(function (scope) {
    "use strict";
    function F(arity, fun, wrapper) {
        wrapper.a = arity;
        wrapper.f = fun;
        return wrapper;
    }
    function F2(fun) {
        return F(2, fun, function (a) { return function (b) { return fun(a, b); }; });
    }
    function F3(fun) {
        return F(3, fun, function (a) {
            return function (b) { return function (c) { return fun(a, b, c); }; };
        });
    }
    function F4(fun) {
        return F(4, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) { return fun(a, b, c, d); };
                };
            };
        });
    }
    function F5(fun) {
        return F(5, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) { return function (e) { return fun(a, b, c, d, e); }; };
                };
            };
        });
    }
    function F6(fun) {
        return F(6, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return fun(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(fun) {
        return F(7, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) { return fun(a, b, c, d, e, f, g); };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(fun) {
        return F(8, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return fun(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(fun) {
        return F(9, fun, function (a) {
            return function (b) {
                return function (c) {
                    return function (d) {
                        return function (e) {
                            return function (f) {
                                return function (g) {
                                    return function (h) {
                                        return function (i) {
                                            return fun(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(fun, a, b) {
        return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
    }
    function A3(fun, a, b, c) {
        return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
    }
    function A4(fun, a, b, c, d) {
        return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
    }
    function A5(fun, a, b, c, d, e) {
        return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
    }
    function A6(fun, a, b, c, d, e, f) {
        return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
    }
    function A7(fun, a, b, c, d, e, f, g) {
        return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
    }
    function A8(fun, a, b, c, d, e, f, g, h) {
        return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
    }
    function A9(fun, a, b, c, d, e, f, g, h, i) {
        return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
    }
    var _JsArray_empty = [];
    function _JsArray_singleton(value) {
        return [value];
    }
    function _JsArray_length(array) {
        return array.length;
    }
    var _JsArray_initialize_fn = function (size, offset, func) {
        var result = new Array(size);
        for (var i = 0; i < size; i++) {
            result[i] = func(offset + i);
        }
        return result;
    }, _JsArray_initialize = F3(_JsArray_initialize_fn);
    var _JsArray_initializeFromList_fn = function (max, ls) {
        var result = new Array(max);
        for (var i = 0; i < max && ls.b; i++) {
            result[i] = ls.a;
            ls = ls.b;
        }
        result.length = i;
        return _Utils_Tuple2(result, ls);
    }, _JsArray_initializeFromList = F2(_JsArray_initializeFromList_fn);
    var _JsArray_unsafeGet_fn = function (index, array) {
        return array[index];
    }, _JsArray_unsafeGet = F2(_JsArray_unsafeGet_fn);
    var _JsArray_unsafeSet_fn = function (index, value, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[index] = value;
        return result;
    }, _JsArray_unsafeSet = F3(_JsArray_unsafeSet_fn);
    var _JsArray_push_fn = function (value, array) {
        var length = array.length;
        var result = new Array(length + 1);
        for (var i = 0; i < length; i++) {
            result[i] = array[i];
        }
        result[length] = value;
        return result;
    }, _JsArray_push = F2(_JsArray_push_fn);
    var _JsArray_foldl_fn = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldl_fn_unwrapped = function (func, acc, array) {
        var length = array.length;
        for (var i = 0; i < length; i++) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldl = F3(_JsArray_foldl_fn);
    var _JsArray_foldr_fn = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = A2(func, array[i], acc);
        }
        return acc;
    }, _JsArray_foldr_fn_unwrapped = function (func, acc, array) {
        for (var i = array.length - 1; i >= 0; i--) {
            acc = func(array[i], acc);
        }
        return acc;
    }, _JsArray_foldr = F3(_JsArray_foldr_fn);
    var _JsArray_map_fn = function (func, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(array[i]);
        }
        return result;
    }, _JsArray_map = F2(_JsArray_map_fn);
    var _JsArray_indexedMap_fn = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = A2(func, offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap_fn_unwrapped = function (func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for (var i = 0; i < length; i++) {
            result[i] = func(offset + i, array[i]);
        }
        return result;
    }, _JsArray_indexedMap = F3(_JsArray_indexedMap_fn);
    var _JsArray_slice_fn = function (from, to, array) {
        return array.slice(from, to);
    }, _JsArray_slice = F3(_JsArray_slice_fn);
    var _JsArray_appendN_fn = function (n, dest, source) {
        var destLen = dest.length;
        var itemsToCopy = n - destLen;
        if (itemsToCopy > source.length) {
            itemsToCopy = source.length;
        }
        var size = destLen + itemsToCopy;
        var result = new Array(size);
        for (var i = 0; i < destLen; i++) {
            result[i] = dest[i];
        }
        for (var i = 0; i < itemsToCopy; i++) {
            result[i + destLen] = source[i];
        }
        return result;
    }, _JsArray_appendN = F3(_JsArray_appendN_fn);
    // LOG
    var _Debug_log_fn = function (tag, value) {
        return value;
    }, _Debug_log = F2(_Debug_log_fn);
    var _Debug_log_UNUSED_fn = function (tag, value) {
        console.log(tag + ": " + _Debug_toString(value));
        return value;
    }, _Debug_log_UNUSED = F2(_Debug_log_UNUSED_fn);
    // TODOS
    function _Debug_todo(moduleName, region) {
        return function (message) {
            _Debug_crash(8, moduleName, region, message);
        };
    }
    function _Debug_todoCase(moduleName, region, value) {
        return function (message) {
            _Debug_crash(9, moduleName, region, value, message);
        };
    }
    // TO STRING
    function _Debug_toString(value) {
        return "<internals>";
    }
    function _Debug_toString_UNUSED(value) {
        return _Debug_toAnsiString(false, value);
    }
    function _Debug_toAnsiString(ansi, value) {
        if (typeof value === "function") {
            return _Debug_internalColor(ansi, "<function>");
        }
        if (typeof value === "boolean") {
            return _Debug_ctorColor(ansi, value ? "True" : "False");
        }
        if (typeof value === "number") {
            return _Debug_numberColor(ansi, value + "");
        }
        if (value instanceof String) {
            return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
        }
        if (typeof value === "string") {
            return _Debug_stringColor(ansi, "\"" + _Debug_addSlashes(value, false) + "\"");
        }
        if (typeof value === "object" && "$" in value) {
            var tag = value.$;
            if (typeof tag === "number") {
                return _Debug_internalColor(ansi, "<internals>");
            }
            if (tag[0] === "#") {
                var output = [];
                for (var k in value) {
                    if (k === "$")
                        continue;
                    output.push(_Debug_toAnsiString(ansi, value[k]));
                }
                return "(" + output.join(",") + ")";
            }
            if (tag === "Set_elm_builtin") {
                return _Debug_ctorColor(ansi, "Set")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
            }
            if (tag === "RBNode_elm_builtin" || tag === "RBEmpty_elm_builtin") {
                return _Debug_ctorColor(ansi, "Dict")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
            }
            if (tag === "Array_elm_builtin") {
                return _Debug_ctorColor(ansi, "Array")
                    + _Debug_fadeColor(ansi, ".fromList") + " "
                    + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
            }
            if (tag === "::" || tag === "[]") {
                var output = "[";
                value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
                for (; value.b; value = value.b) // WHILE_CONS
                 {
                    output += "," + _Debug_toAnsiString(ansi, value.a);
                }
                return output + "]";
            }
            var output = "";
            for (var i in value) {
                if (i === "$")
                    continue;
                var str = _Debug_toAnsiString(ansi, value[i]);
                var c0 = str[0];
                var parenless = c0 === "{" || c0 === "(" || c0 === "[" || c0 === "<" || c0 === "\"" || str.indexOf(" ") < 0;
                output += " " + (parenless ? str : "(" + str + ")");
            }
            return _Debug_ctorColor(ansi, tag) + output;
        }
        if (typeof DataView === "function" && value instanceof DataView) {
            return _Debug_stringColor(ansi, "<" + value.byteLength + " bytes>");
        }
        if (typeof File !== "undefined" && value instanceof File) {
            return _Debug_internalColor(ansi, "<" + value.name + ">");
        }
        if (typeof value === "object") {
            var output = [];
            for (var key in value) {
                var field = key[0] === "_" ? key.slice(1) : key;
                output.push(_Debug_fadeColor(ansi, field) + " = " + _Debug_toAnsiString(ansi, value[key]));
            }
            if (output.length === 0) {
                return "{}";
            }
            return "{ " + output.join(", ") + " }";
        }
        return _Debug_internalColor(ansi, "<internals>");
    }
    function _Debug_addSlashes(str, isChar) {
        var s = str
            .replace(/\\/g, "\\\\")
            .replace(/\n/g, "\\n")
            .replace(/\t/g, "\\t")
            .replace(/\r/g, "\\r")
            .replace(/\v/g, "\\v")
            .replace(/\0/g, "\\0");
        if (isChar) {
            return s.replace(/\'/g, "\\'");
        }
        else {
            return s.replace(/\"/g, "\\\"");
        }
    }
    function _Debug_ctorColor(ansi, string) {
        return ansi ? "\u001B[96m" + string + "\u001B[0m" : string;
    }
    function _Debug_numberColor(ansi, string) {
        return ansi ? "\u001B[95m" + string + "\u001B[0m" : string;
    }
    function _Debug_stringColor(ansi, string) {
        return ansi ? "\u001B[93m" + string + "\u001B[0m" : string;
    }
    function _Debug_charColor(ansi, string) {
        return ansi ? "\u001B[92m" + string + "\u001B[0m" : string;
    }
    function _Debug_fadeColor(ansi, string) {
        return ansi ? "\u001B[37m" + string + "\u001B[0m" : string;
    }
    function _Debug_internalColor(ansi, string) {
        return ansi ? "\u001B[36m" + string + "\u001B[0m" : string;
    }
    function _Debug_toHexDigit(n) {
        return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
    }
    // CRASH
    function _Debug_crash(identifier) {
        throw new Error("https://github.com/elm/core/blob/1.0.0/hints/" + identifier + ".md");
    }
    function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
        switch (identifier) {
            case 0:
                throw new Error("What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById(\"elm-node\")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.");
            case 1:
                throw new Error("Browser.application programs cannot handle URLs like this:\n\n    " + document.location.href + "\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.");
            case 2:
                var jsonErrorString = fact1;
                throw new Error("Problem with the flags given to your Elm program on initialization.\n\n" + jsonErrorString);
            case 3:
                var portName = fact1;
                throw new Error("There can only be one port named `" + portName + "`, but your program has multiple.");
            case 4:
                var portName = fact1;
                var problem = fact2;
                throw new Error("Trying to send an unexpected type of value through port `" + portName + "`:\n" + problem);
            case 5:
                throw new Error("Trying to use `(==)` on functions.\nThere is no way to know if functions are \"the same\" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.");
            case 6:
                var moduleName = fact1;
                throw new Error("Your page is loading multiple Elm scripts with a module named " + moduleName + ". Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!");
            case 8:
                var moduleName = fact1;
                var region = fact2;
                var message = fact3;
                throw new Error("TODO in module `" + moduleName + "` " + _Debug_regionToString(region) + "\n\n" + message);
            case 9:
                var moduleName = fact1;
                var region = fact2;
                var value = fact3;
                var message = fact4;
                throw new Error("TODO in module `" + moduleName + "` from the `case` expression "
                    + _Debug_regionToString(region) + "\n\nIt received the following value:\n\n    "
                    + _Debug_toString(value).replace("\n", "\n    ")
                    + "\n\nBut the branch that handles it says:\n\n    " + message.replace("\n", "\n    "));
            case 10:
                throw new Error("Bug in https://github.com/elm/virtual-dom/issues");
            case 11:
                throw new Error("Cannot perform mod 0. Division by zero error.");
        }
    }
    function _Debug_regionToString(region) {
        if (region.d_.aU === region.c2.aU) {
            return "on line " + region.d_.aU;
        }
        return "on lines " + region.d_.aU + " through " + region.c2.aU;
    }
    // EQUALITY
    function _Utils_eq(x, y) {
        for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) { }
        return isEqual;
    }
    function _Utils_eqHelp(x, y, depth, stack) {
        if (x === y) {
            return true;
        }
        if (typeof x !== "object" || x === null || y === null) {
            typeof x === "function" && _Debug_crash(5);
            return false;
        }
        if (depth > 100) {
            stack.push(_Utils_Tuple2(x, y));
            return true;
        }
        /**_UNUSED/
        if (x.$ === 'Set_elm_builtin')
        {
            x = $elm$core$Set$toList(x);
            y = $elm$core$Set$toList(y);
        }
        if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
        {
            x = $elm$core$Dict$toList(x);
            y = $elm$core$Dict$toList(y);
        }
        //*/
        /**/
        if (x.$ < 0) {
            x = $elm$core$Dict$toList(x);
            y = $elm$core$Dict$toList(y);
        }
        //*/
        for (var key in x) {
            if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
                return false;
            }
        }
        return true;
    }
    var _Utils_equal = F2(_Utils_eq);
    var _Utils_notEqual_fn = function (a, b) { return !_Utils_eq(a, b); }, _Utils_notEqual = F2(_Utils_notEqual_fn);
    // COMPARISONS
    // Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
    // the particular integer values assigned to LT, EQ, and GT.
    function _Utils_cmp(x, y, ord) {
        if (typeof x !== "object") {
            return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
        }
        /**_UNUSED/
        if (x instanceof String)
        {
            var a = x.valueOf();
            var b = y.valueOf();
            return a === b ? 0 : a < b ? -1 : 1;
        }
        //*/
        /**/
        if (typeof x.$ === "undefined") 
        //*/
        /**_UNUSED/
        if (x.$[0] === '#')
        //*/
        {
            return (ord = _Utils_cmp(x.a, y.a))
                ? ord
                : (ord = _Utils_cmp(x.b, y.b))
                    ? ord
                    : _Utils_cmp(x.c, y.c);
        }
        // traverse conses until end of a list or a mismatch
        for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) { } // WHILE_CONSES
        return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
    }
    var _Utils_lt_fn = function (a, b) { return _Utils_cmp(a, b) < 0; }, _Utils_lt = F2(_Utils_lt_fn);
    var _Utils_le_fn = function (a, b) { return _Utils_cmp(a, b) < 1; }, _Utils_le = F2(_Utils_le_fn);
    var _Utils_gt_fn = function (a, b) { return _Utils_cmp(a, b) > 0; }, _Utils_gt = F2(_Utils_gt_fn);
    var _Utils_ge_fn = function (a, b) { return _Utils_cmp(a, b) >= 0; }, _Utils_ge = F2(_Utils_ge_fn);
    var _Utils_compare_fn = function (x, y) {
        var n = _Utils_cmp(x, y);
        return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
    }, _Utils_compare = F2(_Utils_compare_fn);
    // COMMON VALUES
    var _Utils_Tuple0 = 0;
    var _Utils_Tuple0_UNUSED = { $: "#0" };
    function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
    function _Utils_Tuple2_UNUSED(a, b) { return { $: "#2", a: a, b: b }; }
    function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
    function _Utils_Tuple3_UNUSED(a, b, c) { return { $: "#3", a: a, b: b, c: c }; }
    function _Utils_chr(c) { return c; }
    function _Utils_chr_UNUSED(c) { return new String(c); }
    // RECORDS
    function _Utils_update(oldRecord, updatedFields) {
        var newRecord = {};
        for (var key in oldRecord) {
            newRecord[key] = oldRecord[key];
        }
        for (var key in updatedFields) {
            newRecord[key] = updatedFields[key];
        }
        return newRecord;
    }
    // APPEND
    var _Utils_append = F2(_Utils_ap);
    function _Utils_ap(xs, ys) {
        // append Strings
        if (typeof xs === "string") {
            return xs + ys;
        }
        // append Lists
        if (!xs.b) {
            return ys;
        }
        var root = _List_Cons(xs.a, ys);
        xs = xs.b;
        for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
         {
            curr = curr.b = _List_Cons(xs.a, ys);
        }
        return root;
    }
    var _List_Nil = { $: 0, a: null, b: null };
    var _List_Nil_UNUSED = { $: "[]" };
    function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
    function _List_Cons_UNUSED(hd, tl) { return { $: "::", a: hd, b: tl }; }
    var _List_cons = F2(_List_Cons);
    function _List_fromArray(arr) {
        var out = _List_Nil;
        for (var i = arr.length; i--;) {
            out = _List_Cons(arr[i], out);
        }
        return out;
    }
    function _List_toArray(xs) {
        for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
         {
            out.push(xs.a);
        }
        return out;
    }
    var _List_map2_fn = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
         {
            arr.push(A2(f, xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2_fn_unwrapped = function (f, xs, ys) {
        for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
         {
            arr.push(f(xs.a, ys.a));
        }
        return _List_fromArray(arr);
    }, _List_map2 = F3(_List_map2_fn);
    var _List_map3_fn = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(A3(f, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3_fn_unwrapped = function (f, xs, ys, zs) {
        for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(f(xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map3 = F4(_List_map3_fn);
    var _List_map4_fn = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4_fn_unwrapped = function (f, ws, xs, ys, zs) {
        for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(f(ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map4 = F5(_List_map4_fn);
    var _List_map5_fn = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5_fn_unwrapped = function (f, vs, ws, xs, ys, zs) {
        for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
         {
            arr.push(f(vs.a, ws.a, xs.a, ys.a, zs.a));
        }
        return _List_fromArray(arr);
    }, _List_map5 = F6(_List_map5_fn);
    var _List_sortBy_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            return _Utils_cmp(f(a), f(b));
        }));
    }, _List_sortBy = F2(_List_sortBy_fn);
    var _List_sortWith_fn = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = A2(f, a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith_fn_unwrapped = function (f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
            var ord = f(a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    }, _List_sortWith = F2(_List_sortWith_fn);
    // MATH
    var _Basics_add_fn = function (a, b) { return a + b; }, _Basics_add = F2(_Basics_add_fn);
    var _Basics_sub_fn = function (a, b) { return a - b; }, _Basics_sub = F2(_Basics_sub_fn);
    var _Basics_mul_fn = function (a, b) { return a * b; }, _Basics_mul = F2(_Basics_mul_fn);
    var _Basics_fdiv_fn = function (a, b) { return a / b; }, _Basics_fdiv = F2(_Basics_fdiv_fn);
    var _Basics_idiv_fn = function (a, b) { return (a / b) | 0; }, _Basics_idiv = F2(_Basics_idiv_fn);
    var _Basics_pow_fn = Math.pow, _Basics_pow = F2(_Basics_pow_fn);
    var _Basics_remainderBy_fn = function (b, a) { return a % b; }, _Basics_remainderBy = F2(_Basics_remainderBy_fn);
    // https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
    var _Basics_modBy_fn = function (modulus, x) {
        var answer = x % modulus;
        return modulus === 0
            ? _Debug_crash(11)
            :
                ((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
                    ? answer + modulus
                    : answer;
    }, _Basics_modBy = F2(_Basics_modBy_fn);
    // TRIGONOMETRY
    var _Basics_pi = Math.PI;
    var _Basics_e = Math.E;
    var _Basics_cos = Math.cos;
    var _Basics_sin = Math.sin;
    var _Basics_tan = Math.tan;
    var _Basics_acos = Math.acos;
    var _Basics_asin = Math.asin;
    var _Basics_atan = Math.atan;
    var _Basics_atan2_fn = Math.atan2, _Basics_atan2 = F2(_Basics_atan2_fn);
    // MORE MATH
    function _Basics_toFloat(x) { return x; }
    function _Basics_truncate(n) { return n | 0; }
    function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
    var _Basics_ceiling = Math.ceil;
    var _Basics_floor = Math.floor;
    var _Basics_round = Math.round;
    var _Basics_sqrt = Math.sqrt;
    var _Basics_log = Math.log;
    var _Basics_isNaN = isNaN;
    // BOOLEANS
    function _Basics_not(bool) { return !bool; }
    var _Basics_and_fn = function (a, b) { return a && b; }, _Basics_and = F2(_Basics_and_fn);
    var _Basics_or_fn = function (a, b) { return a || b; }, _Basics_or = F2(_Basics_or_fn);
    var _Basics_xor_fn = function (a, b) { return a !== b; }, _Basics_xor = F2(_Basics_xor_fn);
    var _String_cons_fn = function (chr, str) {
        return chr + str;
    }, _String_cons = F2(_String_cons_fn);
    function _String_uncons(string) {
        var word = string.charCodeAt(0);
        return !isNaN(word)
            ? $elm$core$Maybe$Just(55296 <= word && word <= 56319
                ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
                : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1)))
            : $elm$core$Maybe$Nothing;
    }
    var _String_append_fn = function (a, b) {
        return a + b;
    }, _String_append = F2(_String_append_fn);
    function _String_length(str) {
        return str.length;
    }
    var _String_map_fn = function (func, string) {
        var len = string.length;
        var array = new Array(len);
        var i = 0;
        while (i < len) {
            var word = string.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                array[i] = func(_Utils_chr(string[i] + string[i + 1]));
                i += 2;
                continue;
            }
            array[i] = func(_Utils_chr(string[i]));
            i++;
        }
        return array.join("");
    }, _String_map = F2(_String_map_fn);
    var _String_filter_fn = function (isGood, str) {
        var arr = [];
        var len = str.length;
        var i = 0;
        while (i < len) {
            var char = str[i];
            var word = str.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += str[i];
                i++;
            }
            if (isGood(_Utils_chr(char))) {
                arr.push(char);
            }
        }
        return arr.join("");
    }, _String_filter = F2(_String_filter_fn);
    function _String_reverse(str) {
        var len = str.length;
        var arr = new Array(len);
        var i = 0;
        while (i < len) {
            var word = str.charCodeAt(i);
            if (55296 <= word && word <= 56319) {
                arr[len - i] = str[i + 1];
                i++;
                arr[len - i] = str[i - 1];
                i++;
            }
            else {
                arr[len - i] = str[i];
                i++;
            }
        }
        return arr.join("");
    }
    var _String_foldl_fn = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldl_fn_unwrapped = function (func, state, string) {
        var len = string.length;
        var i = 0;
        while (i < len) {
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (55296 <= word && word <= 56319) {
                char += string[i];
                i++;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldl = F3(_String_foldl_fn);
    var _String_foldr_fn = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    }, _String_foldr_fn_unwrapped = function (func, state, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            state = func(_Utils_chr(char), state);
        }
        return state;
    }, _String_foldr = F3(_String_foldr_fn);
    var _String_split_fn = function (sep, str) {
        return str.split(sep);
    }, _String_split = F2(_String_split_fn);
    var _String_join_fn = function (sep, strs) {
        return strs.join(sep);
    }, _String_join = F2(_String_join_fn);
    var _String_slice_fn = function (start, end, str) {
        return str.slice(start, end);
    }, _String_slice = F3(_String_slice_fn);
    function _String_trim(str) {
        return str.trim();
    }
    function _String_trimLeft(str) {
        return str.replace(/^\s+/, "");
    }
    function _String_trimRight(str) {
        return str.replace(/\s+$/, "");
    }
    function _String_words(str) {
        return _List_fromArray(str.trim().split(/\s+/g));
    }
    function _String_lines(str) {
        return _List_fromArray(str.split(/\r\n|\r|\n/g));
    }
    function _String_toUpper(str) {
        return str.toUpperCase();
    }
    function _String_toLower(str) {
        return str.toLowerCase();
    }
    var _String_any_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (isGood(_Utils_chr(char))) {
                return true;
            }
        }
        return false;
    }, _String_any = F2(_String_any_fn);
    var _String_all_fn = function (isGood, string) {
        var i = string.length;
        while (i--) {
            var char = string[i];
            var word = string.charCodeAt(i);
            if (56320 <= word && word <= 57343) {
                i--;
                char = string[i] + char;
            }
            if (!isGood(_Utils_chr(char))) {
                return false;
            }
        }
        return true;
    }, _String_all = F2(_String_all_fn);
    var _String_contains_fn = function (sub, str) {
        return str.indexOf(sub) > -1;
    }, _String_contains = F2(_String_contains_fn);
    var _String_startsWith_fn = function (sub, str) {
        return str.indexOf(sub) === 0;
    }, _String_startsWith = F2(_String_startsWith_fn);
    var _String_endsWith_fn = function (sub, str) {
        return str.length >= sub.length &&
            str.lastIndexOf(sub) === str.length - sub.length;
    }, _String_endsWith = F2(_String_endsWith_fn);
    var _String_indexes_fn = function (sub, str) {
        var subLen = sub.length;
        if (subLen < 1) {
            return _List_Nil;
        }
        var i = 0;
        var is = [];
        while ((i = str.indexOf(sub, i)) > -1) {
            is.push(i);
            i = i + subLen;
        }
        return _List_fromArray(is);
    }, _String_indexes = F2(_String_indexes_fn);
    // TO STRING
    function _String_fromNumber(number) {
        return number + "";
    }
    // INT CONVERSIONS
    function _String_toInt(str) {
        var total = 0;
        var code0 = str.charCodeAt(0);
        var start = code0 == 43 /* + */ || code0 == 45 /* - */ ? 1 : 0;
        for (var i = start; i < str.length; ++i) {
            var code = str.charCodeAt(i);
            if (code < 48 || 57 < code) {
                return $elm$core$Maybe$Nothing;
            }
            total = 10 * total + code - 48;
        }
        return i == start
            ? $elm$core$Maybe$Nothing
            : $elm$core$Maybe$Just(code0 == 45 ? -total : total);
    }
    // FLOAT CONVERSIONS
    function _String_toFloat(s) {
        // check if it is a hex, octal, or binary number
        if (s.length === 0 || /[\sxbo]/.test(s)) {
            return $elm$core$Maybe$Nothing;
        }
        var n = +s;
        // faster isNaN check
        return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
    }
    function _String_fromList(chars) {
        return _List_toArray(chars).join("");
    }
    function _Char_toCode(char) {
        var code = char.charCodeAt(0);
        if (55296 <= code && code <= 56319) {
            return (code - 55296) * 1024 + char.charCodeAt(1) - 56320 + 65536;
        }
        return code;
    }
    function _Char_fromCode(code) {
        return _Utils_chr((code < 0 || 1114111 < code)
            ? "\uFFFD"
            :
                (code <= 65535)
                    ? String.fromCharCode(code)
                    :
                        (code -= 65536,
                            String.fromCharCode(Math.floor(code / 1024) + 55296, code % 1024 + 56320)));
    }
    function _Char_toUpper(char) {
        return _Utils_chr(char.toUpperCase());
    }
    function _Char_toLower(char) {
        return _Utils_chr(char.toLowerCase());
    }
    function _Char_toLocaleUpper(char) {
        return _Utils_chr(char.toLocaleUpperCase());
    }
    function _Char_toLocaleLower(char) {
        return _Utils_chr(char.toLocaleLowerCase());
    }
    /**_UNUSED/
    function _Json_errorToString(error)
    {
        return $elm$json$Json$Decode$errorToString(error);
    }
    //*/
    // CORE DECODERS
    function _Json_succeed(msg) {
        return {
            $: 0,
            a: msg
        };
    }
    function _Json_fail(msg) {
        return {
            $: 1,
            a: msg
        };
    }
    function _Json_decodePrim(decoder) {
        return { $: 2, b: decoder };
    }
    var _Json_decodeInt = _Json_decodePrim(function (value) {
        return (typeof value !== "number")
            ? _Json_expecting("an INT", value)
            :
                (-2147483647 < value && value < 2147483647 && (value | 0) === value)
                    ? $elm$core$Result$Ok(value)
                    :
                        (isFinite(value) && !(value % 1))
                            ? $elm$core$Result$Ok(value)
                            : _Json_expecting("an INT", value);
    });
    var _Json_decodeBool = _Json_decodePrim(function (value) {
        return (typeof value === "boolean")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a BOOL", value);
    });
    var _Json_decodeFloat = _Json_decodePrim(function (value) {
        return (typeof value === "number")
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a FLOAT", value);
    });
    var _Json_decodeValue = _Json_decodePrim(function (value) {
        return $elm$core$Result$Ok(_Json_wrap(value));
    });
    var _Json_decodeString = _Json_decodePrim(function (value) {
        return (typeof value === "string")
            ? $elm$core$Result$Ok(value)
            : (value instanceof String)
                ? $elm$core$Result$Ok(value + "")
                : _Json_expecting("a STRING", value);
    });
    function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
    function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
    function _Json_decodeNull(value) { return { $: 5, c: value }; }
    var _Json_decodeField_fn = function (field, decoder) {
        return {
            $: 6,
            d: field,
            b: decoder
        };
    }, _Json_decodeField = F2(_Json_decodeField_fn);
    var _Json_decodeIndex_fn = function (index, decoder) {
        return {
            $: 7,
            e: index,
            b: decoder
        };
    }, _Json_decodeIndex = F2(_Json_decodeIndex_fn);
    function _Json_decodeKeyValuePairs(decoder) {
        return {
            $: 8,
            b: decoder
        };
    }
    function _Json_mapMany(f, decoders) {
        return {
            $: 9,
            f: f,
            g: decoders
        };
    }
    var _Json_andThen_fn = function (callback, decoder) {
        return {
            $: 10,
            b: decoder,
            h: callback
        };
    }, _Json_andThen = F2(_Json_andThen_fn);
    function _Json_oneOf(decoders) {
        return {
            $: 11,
            g: decoders
        };
    }
    // DECODING OBJECTS
    var _Json_map1_fn = function (f, d1) {
        return _Json_mapMany(f, [d1]);
    }, _Json_map1 = F2(_Json_map1_fn);
    var _Json_map2_fn = function (f, d1, d2) {
        return _Json_mapMany(f, [d1, d2]);
    }, _Json_map2 = F3(_Json_map2_fn);
    var _Json_map3_fn = function (f, d1, d2, d3) {
        return _Json_mapMany(f, [d1, d2, d3]);
    }, _Json_map3 = F4(_Json_map3_fn);
    var _Json_map4_fn = function (f, d1, d2, d3, d4) {
        return _Json_mapMany(f, [d1, d2, d3, d4]);
    }, _Json_map4 = F5(_Json_map4_fn);
    var _Json_map5_fn = function (f, d1, d2, d3, d4, d5) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
    }, _Json_map5 = F6(_Json_map5_fn);
    var _Json_map6_fn = function (f, d1, d2, d3, d4, d5, d6) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
    }, _Json_map6 = F7(_Json_map6_fn);
    var _Json_map7_fn = function (f, d1, d2, d3, d4, d5, d6, d7) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
    }, _Json_map7 = F8(_Json_map7_fn);
    var _Json_map8_fn = function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
        return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
    }, _Json_map8 = F9(_Json_map8_fn);
    // DECODE
    var _Json_runOnString_fn = function (decoder, string) {
        try {
            var value = JSON.parse(string);
            return _Json_runHelp(decoder, value);
        }
        catch (e) {
            return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("This is not valid JSON! " + e.message, _Json_wrap(string)));
        }
    }, _Json_runOnString = F2(_Json_runOnString_fn);
    var _Json_run_fn = function (decoder, value) {
        return _Json_runHelp(decoder, _Json_unwrap(value));
    }, _Json_run = F2(_Json_run_fn);
    function _Json_runHelp(decoder, value) {
        switch (decoder.$) {
            case 2:
                return decoder.b(value);
            case 5:
                return (value === null)
                    ? $elm$core$Result$Ok(decoder.c)
                    : _Json_expecting("null", value);
            case 3:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("a LIST", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
            case 4:
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
            case 6:
                var field = decoder.d;
                if (typeof value !== "object" || value === null || !(field in value)) {
                    return _Json_expecting("an OBJECT with a field named `" + field + "`", value);
                }
                var result = _Json_runHelp(decoder.b, value[field]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(field, result.a));
            case 7:
                var index = decoder.e;
                if (!_Json_isArray(value)) {
                    return _Json_expecting("an ARRAY", value);
                }
                if (index >= value.length) {
                    return _Json_expecting("a LONGER array. Need index " + index + " but only see " + value.length + " entries", value);
                }
                var result = _Json_runHelp(decoder.b, value[index]);
                return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(index, result.a));
            case 8:
                if (typeof value !== "object" || value === null || _Json_isArray(value)) {
                    return _Json_expecting("an OBJECT", value);
                }
                var keyValuePairs = _List_Nil;
                // TODO test perf of Object.keys and switch when support is good enough
                for (var key in value) {
                    if (value.hasOwnProperty(key)) {
                        var result = _Json_runHelp(decoder.b, value[key]);
                        if (!$elm$core$Result$isOk(result)) {
                            return $elm$core$Result$Err($elm$json$Json$Decode$Field_fn(key, result.a));
                        }
                        keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
                    }
                }
                return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
            case 9:
                var answer = decoder.f;
                var decoders = decoder.g;
                for (var i = 0; i < decoders.length; i++) {
                    var result = _Json_runHelp(decoders[i], value);
                    if (!$elm$core$Result$isOk(result)) {
                        return result;
                    }
                    answer = answer(result.a);
                }
                return $elm$core$Result$Ok(answer);
            case 10:
                var result = _Json_runHelp(decoder.b, value);
                return (!$elm$core$Result$isOk(result))
                    ? result
                    : _Json_runHelp(decoder.h(result.a), value);
            case 11:
                var errors = _List_Nil;
                for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
                 {
                    var result = _Json_runHelp(temp.a, value);
                    if ($elm$core$Result$isOk(result)) {
                        return result;
                    }
                    errors = _List_Cons(result.a, errors);
                }
                return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
            case 1:
                return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn(decoder.a, _Json_wrap(value)));
            case 0:
                return $elm$core$Result$Ok(decoder.a);
        }
    }
    function _Json_runArrayDecoder(decoder, value, toElmValue) {
        var len = value.length;
        var array = new Array(len);
        for (var i = 0; i < len; i++) {
            var result = _Json_runHelp(decoder, value[i]);
            if (!$elm$core$Result$isOk(result)) {
                return $elm$core$Result$Err($elm$json$Json$Decode$Index_fn(i, result.a));
            }
            array[i] = result.a;
        }
        return $elm$core$Result$Ok(toElmValue(array));
    }
    function _Json_isArray(value) {
        return Array.isArray(value) || (typeof FileList !== "undefined" && value instanceof FileList);
    }
    function _Json_toElmArray(array) {
        return $elm$core$Array$initialize_fn(array.length, function (i) { return array[i]; });
    }
    function _Json_expecting(type, value) {
        return $elm$core$Result$Err($elm$json$Json$Decode$Failure_fn("Expecting " + type, _Json_wrap(value)));
    }
    // EQUALITY
    function _Json_equality(x, y) {
        if (x === y) {
            return true;
        }
        if (x.$ !== y.$) {
            return false;
        }
        switch (x.$) {
            case 0:
            case 1:
                return x.a === y.a;
            case 2:
                return x.b === y.b;
            case 5:
                return x.c === y.c;
            case 3:
            case 4:
            case 8:
                return _Json_equality(x.b, y.b);
            case 6:
                return x.d === y.d && _Json_equality(x.b, y.b);
            case 7:
                return x.e === y.e && _Json_equality(x.b, y.b);
            case 9:
                return x.f === y.f && _Json_listEquality(x.g, y.g);
            case 10:
                return x.h === y.h && _Json_equality(x.b, y.b);
            case 11:
                return _Json_listEquality(x.g, y.g);
        }
    }
    function _Json_listEquality(aDecoders, bDecoders) {
        var len = aDecoders.length;
        if (len !== bDecoders.length) {
            return false;
        }
        for (var i = 0; i < len; i++) {
            if (!_Json_equality(aDecoders[i], bDecoders[i])) {
                return false;
            }
        }
        return true;
    }
    // ENCODE
    var _Json_encode_fn = function (indentLevel, value) {
        return JSON.stringify(_Json_unwrap(value), null, indentLevel) + "";
    }, _Json_encode = F2(_Json_encode_fn);
    function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
    function _Json_unwrap_UNUSED(value) { return value.a; }
    function _Json_wrap(value) { return value; }
    function _Json_unwrap(value) { return value; }
    function _Json_emptyArray() { return []; }
    function _Json_emptyObject() { return {}; }
    var _Json_addField_fn = function (key, value, object) {
        object[key] = _Json_unwrap(value);
        return object;
    }, _Json_addField = F3(_Json_addField_fn);
    function _Json_addEntry(func) {
        return F2(function (entry, array) {
            array.push(_Json_unwrap(func(entry)));
            return array;
        });
    }
    var _Json_encodeNull = _Json_wrap(null);
    // TASKS
    function _Scheduler_succeed(value) {
        return {
            $: 0,
            a: value
        };
    }
    function _Scheduler_fail(error) {
        return {
            $: 1,
            a: error
        };
    }
    function _Scheduler_binding(callback) {
        return {
            $: 2,
            b: callback,
            c: null
        };
    }
    var _Scheduler_andThen_fn = function (callback, task) {
        return {
            $: 3,
            b: callback,
            d: task
        };
    }, _Scheduler_andThen = F2(_Scheduler_andThen_fn);
    var _Scheduler_onError_fn = function (callback, task) {
        return {
            $: 4,
            b: callback,
            d: task
        };
    }, _Scheduler_onError = F2(_Scheduler_onError_fn);
    function _Scheduler_receive(callback) {
        return {
            $: 5,
            b: callback
        };
    }
    // PROCESSES
    var _Scheduler_guid = 0;
    function _Scheduler_rawSpawn(task) {
        var proc = {
            $: 0,
            e: _Scheduler_guid++,
            f: task,
            g: null,
            h: []
        };
        _Scheduler_enqueue(proc);
        return proc;
    }
    function _Scheduler_spawn(task) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
        });
    }
    function _Scheduler_rawSend(proc, msg) {
        proc.h.push(msg);
        _Scheduler_enqueue(proc);
    }
    var _Scheduler_send_fn = function (proc, msg) {
        return _Scheduler_binding(function (callback) {
            _Scheduler_rawSend(proc, msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Scheduler_send = F2(_Scheduler_send_fn);
    function _Scheduler_kill(proc) {
        return _Scheduler_binding(function (callback) {
            var task = proc.f;
            if (task.$ === 2 && task.c) {
                task.c();
            }
            proc.f = null;
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }
    /* STEP PROCESSES
    
    type alias Process =
      { $ : tag
      , id : unique_id
      , root : Task
      , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
      , mailbox : [msg]
      }
    
    */
    var _Scheduler_working = false;
    var _Scheduler_queue = [];
    function _Scheduler_enqueue(proc) {
        _Scheduler_queue.push(proc);
        if (_Scheduler_working) {
            return;
        }
        _Scheduler_working = true;
        while (proc = _Scheduler_queue.shift()) {
            _Scheduler_step(proc);
        }
        _Scheduler_working = false;
    }
    function _Scheduler_step(proc) {
        while (proc.f) {
            var rootTag = proc.f.$;
            if (rootTag === 0 || rootTag === 1) {
                while (proc.g && proc.g.$ !== rootTag) {
                    proc.g = proc.g.i;
                }
                if (!proc.g) {
                    return;
                }
                proc.f = proc.g.b(proc.f.a);
                proc.g = proc.g.i;
            }
            else if (rootTag === 2) {
                proc.f.c = proc.f.b(function (newRoot) {
                    proc.f = newRoot;
                    _Scheduler_enqueue(proc);
                });
                return;
            }
            else if (rootTag === 5) {
                if (proc.h.length === 0) {
                    return;
                }
                proc.f = proc.f.b(proc.h.shift());
            }
            else // if (rootTag === 3 || rootTag === 4)
             {
                proc.g = {
                    $: rootTag === 3 ? 0 : 1,
                    b: proc.f.b,
                    i: proc.g
                };
                proc.f = proc.f.d;
            }
        }
    }
    function _Process_sleep(time) {
        return _Scheduler_binding(function (callback) {
            var id = setTimeout(function () {
                callback(_Scheduler_succeed(_Utils_Tuple0));
            }, time);
            return function () { clearTimeout(id); };
        });
    }
    // PROGRAMS
    var _Platform_worker_fn = function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.fl, impl.gC, impl.gh, function () { return function () { }; });
    }, _Platform_worker = F4(_Platform_worker_fn);
    // INITIALIZE A PROGRAM
    function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
        var result = _Json_run_fn(flagDecoder, _Json_wrap(args ? args["flags"] : undefined));
        $elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
        var managers = {};
        var initPair = init(result.a);
        var model = initPair.a;
        var stepper = stepperBuilder(sendToApp, model);
        var ports = _Platform_setupEffects(managers, sendToApp);
        function sendToApp(msg, viewMetadata) {
            var pair = A2(update, msg, model);
            stepper(model = pair.a, viewMetadata);
            _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
        }
        _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
        return ports ? { ports: ports } : {};
    }
    // TRACK PRELOADS
    //
    // This is used by code in elm/browser and elm/http
    // to register any HTTP requests that are triggered by init.
    //
    var _Platform_preload;
    function _Platform_registerPreload(url) {
        _Platform_preload.add(url);
    }
    // EFFECT MANAGERS
    var _Platform_effectManagers = {};
    function _Platform_setupEffects(managers, sendToApp) {
        var ports;
        // setup all necessary effect managers
        for (var key in _Platform_effectManagers) {
            var manager = _Platform_effectManagers[key];
            if (manager.a) {
                ports = ports || {};
                ports[key] = manager.a(key, sendToApp);
            }
            managers[key] = _Platform_instantiateManager(manager, sendToApp);
        }
        return ports;
    }
    function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
        return {
            b: init,
            c: onEffects,
            d: onSelfMsg,
            e: cmdMap,
            f: subMap
        };
    }
    function _Platform_instantiateManager(info, sendToApp) {
        var router = {
            g: sendToApp,
            h: undefined
        };
        var onEffects = info.c;
        var onSelfMsg = info.d;
        var cmdMap = info.e;
        var subMap = info.f;
        function loop(state) {
            return _Scheduler_andThen_fn(loop, _Scheduler_receive(function (msg) {
                var value = msg.a;
                if (msg.$ === 0) {
                    return A3(onSelfMsg, router, value, state);
                }
                return cmdMap && subMap
                    ? A4(onEffects, router, value.i, value.j, state)
                    : A3(onEffects, router, cmdMap ? value.i : value.j, state);
            }));
        }
        return router.h = _Scheduler_rawSpawn(_Scheduler_andThen_fn(loop, info.b));
    }
    // ROUTING
    var _Platform_sendToApp_fn = function (router, msg) {
        return _Scheduler_binding(function (callback) {
            router.g(msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }, _Platform_sendToApp = F2(_Platform_sendToApp_fn);
    var _Platform_sendToSelf_fn = function (router, msg) {
        return _Scheduler_send_fn(router.h, {
            $: 0,
            a: msg
        });
    }, _Platform_sendToSelf = F2(_Platform_sendToSelf_fn);
    // BAGS
    function _Platform_leaf(home) {
        return function (value) {
            return {
                $: 1,
                k: home,
                l: value
            };
        };
    }
    function _Platform_batch(list) {
        return {
            $: 2,
            m: list
        };
    }
    var _Platform_map_fn = function (tagger, bag) {
        return {
            $: 3,
            n: tagger,
            o: bag
        };
    }, _Platform_map = F2(_Platform_map_fn);
    // PIPE BAGS INTO EFFECT MANAGERS
    //
    // Effects must be queued!
    //
    // Say your init contains a synchronous command, like Time.now or Time.here
    //
    //   - This will produce a batch of effects (FX_1)
    //   - The synchronous task triggers the subsequent `update` call
    //   - This will produce a batch of effects (FX_2)
    //
    // If we just start dispatching FX_2, subscriptions from FX_2 can be processed
    // before subscriptions from FX_1. No good! Earlier versions of this code had
    // this problem, leading to these reports:
    //
    //   https://github.com/elm/core/issues/980
    //   https://github.com/elm/core/pull/981
    //   https://github.com/elm/compiler/issues/1776
    //
    // The queue is necessary to avoid ordering issues for synchronous commands.
    // Why use true/false here? Why not just check the length of the queue?
    // The goal is to detect "are we currently dispatching effects?" If we
    // are, we need to bail and let the ongoing while loop handle things.
    //
    // Now say the queue has 1 element. When we dequeue the final element,
    // the queue will be empty, but we are still actively dispatching effects.
    // So you could get queue jumping in a really tricky category of cases.
    //
    var _Platform_effectsQueue = [];
    var _Platform_effectsActive = false;
    function _Platform_enqueueEffects(managers, cmdBag, subBag) {
        _Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });
        if (_Platform_effectsActive)
            return;
        _Platform_effectsActive = true;
        for (var fx; fx = _Platform_effectsQueue.shift();) {
            _Platform_dispatchEffects(fx.p, fx.q, fx.r);
        }
        _Platform_effectsActive = false;
    }
    function _Platform_dispatchEffects(managers, cmdBag, subBag) {
        var effectsDict = {};
        _Platform_gatherEffects(true, cmdBag, effectsDict, null);
        _Platform_gatherEffects(false, subBag, effectsDict, null);
        for (var home in managers) {
            _Scheduler_rawSend(managers[home], {
                $: "fx",
                a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
            });
        }
    }
    function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
        switch (bag.$) {
            case 1:
                var home = bag.k;
                var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
                effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
                return;
            case 2:
                for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
                 {
                    _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
                }
                return;
            case 3:
                _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
                    s: bag.n,
                    t: taggers
                });
                return;
        }
    }
    function _Platform_toEffect(isCmd, home, taggers, value) {
        function applyTaggers(x) {
            for (var temp = taggers; temp; temp = temp.t) {
                x = temp.s(x);
            }
            return x;
        }
        var map = isCmd
            ? _Platform_effectManagers[home].e
            : _Platform_effectManagers[home].f;
        return A2(map, applyTaggers, value);
    }
    function _Platform_insert(isCmd, newEffect, effects) {
        effects = effects || { i: _List_Nil, j: _List_Nil };
        isCmd
            ? (effects.i = _List_Cons(newEffect, effects.i))
            : (effects.j = _List_Cons(newEffect, effects.j));
        return effects;
    }
    // PORTS
    function _Platform_checkPortName(name) {
        if (_Platform_effectManagers[name]) {
            _Debug_crash(3, name);
        }
    }
    // OUTGOING PORTS
    function _Platform_outgoingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            e: _Platform_outgoingPortMap,
            u: converter,
            a: _Platform_setupOutgoingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_outgoingPortMap_fn = function (tagger, value) { return value; }, _Platform_outgoingPortMap = F2(_Platform_outgoingPortMap_fn);
    function _Platform_setupOutgoingPort(name) {
        var subs = [];
        var converter = _Platform_effectManagers[name].u;
        // CREATE MANAGER
        var init = _Process_sleep(0);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
            for (; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
             {
                // grab a separate reference to subs in case unsubscribe is called
                var currentSubs = subs;
                var value = _Json_unwrap(converter(cmdList.a));
                for (var i = 0; i < currentSubs.length; i++) {
                    currentSubs[i](value);
                }
            }
            return init;
        });
        // PUBLIC API
        function subscribe(callback) {
            subs.push(callback);
        }
        function unsubscribe(callback) {
            // copy subs into a new array in case unsubscribe is called within a
            // subscribed callback
            subs = subs.slice();
            var index = subs.indexOf(callback);
            if (index >= 0) {
                subs.splice(index, 1);
            }
        }
        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }
    // INCOMING PORTS
    function _Platform_incomingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            f: _Platform_incomingPortMap,
            u: converter,
            a: _Platform_setupIncomingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_incomingPortMap_fn = function (tagger, finalTagger) {
        return function (value) {
            return tagger(finalTagger(value));
        };
    }, _Platform_incomingPortMap = F2(_Platform_incomingPortMap_fn);
    function _Platform_setupIncomingPort(name, sendToApp) {
        var subs = _List_Nil;
        var converter = _Platform_effectManagers[name].u;
        // CREATE MANAGER
        var init = _Scheduler_succeed(null);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function (router, subList, state) {
            subs = subList;
            return init;
        });
        // PUBLIC API
        function send(incomingValue) {
            var result = _Json_run_fn(converter, _Json_wrap(incomingValue));
            $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
            var value = result.a;
            for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
             {
                sendToApp(temp.a(value));
            }
        }
        return { send: send };
    }
    // EXPORT ELM MODULES
    //
    // Have DEBUG and PROD versions so that we can (1) give nicer errors in
    // debug mode and (2) not pay for the bits needed for that in prod mode.
    //
    function _Platform_export(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsProd(scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsProd(obj, exports) {
        for (var name in exports) {
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6)
                    : _Platform_mergeExportsProd(obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    function _Platform_export_UNUSED(exports) {
        scope["Elm"]
            ? _Platform_mergeExportsDebug("Elm", scope["Elm"], exports)
            : scope["Elm"] = exports;
    }
    function _Platform_mergeExportsDebug(moduleName, obj, exports) {
        for (var name in exports) {
            (name in obj)
                ? (name == "init")
                    ? _Debug_crash(6, moduleName)
                    : _Platform_mergeExportsDebug(moduleName + "." + name, obj[name], exports[name])
                : (obj[name] = exports[name]);
        }
    }
    // HELPERS
    var _VirtualDom_divertHrefToApp;
    var _VirtualDom_doc = typeof document !== "undefined" ? document : {};
    function _VirtualDom_appendChild(parent, child) {
        parent.appendChild(child);
    }
    var _VirtualDom_init_fn = function (virtualNode, flagDecoder, debugMetadata, args) {
        // NOTE: this function needs _Platform_export available to work
        /**/
        var node = args["node"];
        //*/
        /**_UNUSED/
        var node = args && args['node'] ? args['node'] : _Debug_crash(0);
        //*/
        node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () { }), node);
        return {};
    }, _VirtualDom_init = F4(_VirtualDom_init_fn);
    // TEXT
    function _VirtualDom_text(string) {
        return {
            $: 0,
            a: string
        };
    }
    // NODE
    var _VirtualDom_nodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
             {
                var kid = kidList.a;
                descendantsCount += (kid.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 1,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_nodeNS = F2(_VirtualDom_nodeNS_fn);
    var _VirtualDom_node_a0 = undefined, _VirtualDom_node = _VirtualDom_nodeNS(_VirtualDom_node_a0);
    // KEYED NODE
    var _VirtualDom_keyedNodeNS_fn = function (namespace, tag) {
        return F2(function (factList, kidList) {
            for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
             {
                var kid = kidList.a;
                descendantsCount += (kid.b.b || 0);
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 2,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    }, _VirtualDom_keyedNodeNS = F2(_VirtualDom_keyedNodeNS_fn);
    var _VirtualDom_keyedNode_a0 = undefined, _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(_VirtualDom_keyedNode_a0);
    // CUSTOM
    function _VirtualDom_custom(factList, model, render, diff) {
        return {
            $: 3,
            d: _VirtualDom_organizeFacts(factList),
            g: model,
            h: render,
            i: diff
        };
    }
    // MAP
    var _VirtualDom_map_fn = function (tagger, node) {
        return {
            $: 4,
            j: tagger,
            k: node,
            b: 1 + (node.b || 0)
        };
    }, _VirtualDom_map = F2(_VirtualDom_map_fn);
    // LAZY
    function _VirtualDom_thunk(refs, thunk) {
        return {
            $: 5,
            l: refs,
            m: thunk,
            k: undefined
        };
    }
    var _VirtualDom_lazy_fn = function (func, a) {
        return _VirtualDom_thunk([func, a], function () {
            return func(a);
        });
    }, _VirtualDom_lazy = F2(_VirtualDom_lazy_fn);
    var _VirtualDom_lazy2_fn = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return A2(func, a, b);
        });
    }, _VirtualDom_lazy2_fn_unwrapped = function (func, a, b) {
        return _VirtualDom_thunk([func, a, b], function () {
            return func(a, b);
        });
    }, _VirtualDom_lazy2 = F3(_VirtualDom_lazy2_fn);
    var _VirtualDom_lazy3_fn = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return A3(func, a, b, c);
        });
    }, _VirtualDom_lazy3_fn_unwrapped = function (func, a, b, c) {
        return _VirtualDom_thunk([func, a, b, c], function () {
            return func(a, b, c);
        });
    }, _VirtualDom_lazy3 = F4(_VirtualDom_lazy3_fn);
    var _VirtualDom_lazy4_fn = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return A4(func, a, b, c, d);
        });
    }, _VirtualDom_lazy4_fn_unwrapped = function (func, a, b, c, d) {
        return _VirtualDom_thunk([func, a, b, c, d], function () {
            return func(a, b, c, d);
        });
    }, _VirtualDom_lazy4 = F5(_VirtualDom_lazy4_fn);
    var _VirtualDom_lazy5_fn = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return A5(func, a, b, c, d, e);
        });
    }, _VirtualDom_lazy5_fn_unwrapped = function (func, a, b, c, d, e) {
        return _VirtualDom_thunk([func, a, b, c, d, e], function () {
            return func(a, b, c, d, e);
        });
    }, _VirtualDom_lazy5 = F6(_VirtualDom_lazy5_fn);
    var _VirtualDom_lazy6_fn = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return A6(func, a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6_fn_unwrapped = function (func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
            return func(a, b, c, d, e, f);
        });
    }, _VirtualDom_lazy6 = F7(_VirtualDom_lazy6_fn);
    var _VirtualDom_lazy7_fn = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return A7(func, a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7_fn_unwrapped = function (func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
            return func(a, b, c, d, e, f, g);
        });
    }, _VirtualDom_lazy7 = F8(_VirtualDom_lazy7_fn);
    var _VirtualDom_lazy8_fn = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return A8(func, a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8_fn_unwrapped = function (func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
            return func(a, b, c, d, e, f, g, h);
        });
    }, _VirtualDom_lazy8 = F9(_VirtualDom_lazy8_fn);
    // FACTS
    var _VirtualDom_on_fn = function (key, handler) {
        return {
            $: "a0",
            n: key,
            o: handler
        };
    }, _VirtualDom_on = F2(_VirtualDom_on_fn);
    var _VirtualDom_style_fn = function (key, value) {
        return {
            $: "a1",
            n: key,
            o: value
        };
    }, _VirtualDom_style = F2(_VirtualDom_style_fn);
    var _VirtualDom_property_fn = function (key, value) {
        return {
            $: "a2",
            n: key,
            o: value
        };
    }, _VirtualDom_property = F2(_VirtualDom_property_fn);
    var _VirtualDom_attribute_fn = function (key, value) {
        return {
            $: "a3",
            n: key,
            o: value
        };
    }, _VirtualDom_attribute = F2(_VirtualDom_attribute_fn);
    var _VirtualDom_attributeNS_fn = function (namespace, key, value) {
        return {
            $: "a4",
            n: key,
            o: { f: namespace, o: value }
        };
    }, _VirtualDom_attributeNS = F3(_VirtualDom_attributeNS_fn);
    // XSS ATTACK VECTOR CHECKS
    function _VirtualDom_noScript(tag) {
        return tag == "script" ? "p" : tag;
    }
    function _VirtualDom_noOnOrFormAction(key) {
        return /^(on|formAction$)/i.test(key) ? "data-" + key : key;
    }
    function _VirtualDom_noInnerHtmlOrFormAction(key) {
        return key == "innerHTML" || key == "formAction" ? "data-" + key : key;
    }
    function _VirtualDom_noJavaScriptUri(value) {
        return /^javascript:/i.test(value.replace(/\s/g, "")) ? "" : value;
    }
    function _VirtualDom_noJavaScriptUri_UNUSED(value) {
        return /^javascript:/i.test(value.replace(/\s/g, ""))
            ? "javascript:alert(\"This is an XSS vector. Please use ports or web components instead.\")"
            : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri(value) {
        return /^\s*(javascript:|data:text\/html)/i.test(value) ? "" : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value) {
        return /^\s*(javascript:|data:text\/html)/i.test(value)
            ? "javascript:alert(\"This is an XSS vector. Please use ports or web components instead.\")"
            : value;
    }
    // MAP FACTS
    var _VirtualDom_mapAttribute_fn = function (func, attr) {
        return (attr.$ === "a0")
            ? _VirtualDom_on_fn(attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
    }, _VirtualDom_mapAttribute = F2(_VirtualDom_mapAttribute_fn);
    function _VirtualDom_mapHandler(func, handler) {
        var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
        // 0 = Normal
        // 1 = MayStopPropagation
        // 2 = MayPreventDefault
        // 3 = Custom
        return {
            $: handler.$,
            a: !tag
                ? _Json_map1_fn(func, handler.a) : _Json_map2_fn(tag < 3
                ? _VirtualDom_mapEventTuple
                : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
        };
    }
    var _VirtualDom_mapEventTuple_fn = function (func, tuple) {
        return _Utils_Tuple2(func(tuple.a), tuple.b);
    }, _VirtualDom_mapEventTuple = F2(_VirtualDom_mapEventTuple_fn);
    var _VirtualDom_mapEventRecord_fn = function (func, record) {
        return {
            an: func(record.an),
            cs: record.cs,
            cj: record.cj
        };
    }, _VirtualDom_mapEventRecord = F2(_VirtualDom_mapEventRecord_fn);
    // ORGANIZE FACTS
    function _VirtualDom_organizeFacts(factList) {
        for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
         {
            var entry = factList.a;
            var tag = entry.$;
            var key = entry.n;
            var value = entry.o;
            if (tag === "a2") {
                (key === "className")
                    ? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
                    : facts[key] = _Json_unwrap(value);
                continue;
            }
            var subFacts = facts[tag] || (facts[tag] = {});
            (tag === "a3" && key === "class")
                ? _VirtualDom_addClass(subFacts, key, value)
                : subFacts[key] = value;
        }
        return facts;
    }
    function _VirtualDom_addClass(object, key, newClass) {
        var classes = object[key];
        object[key] = classes ? classes + " " + newClass : newClass;
    }
    // RENDER
    function _VirtualDom_render(vNode, eventNode) {
        var tag = vNode.$;
        if (tag === 5) {
            return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
        }
        if (tag === 0) {
            return _VirtualDom_doc.createTextNode(vNode.a);
        }
        if (tag === 4) {
            var subNode = vNode.k;
            var tagger = vNode.j;
            while (subNode.$ === 4) {
                typeof tagger !== "object"
                    ? tagger = [tagger, subNode.j]
                    : tagger.push(subNode.j);
                subNode = subNode.k;
            }
            var subEventRoot = { j: tagger, p: eventNode };
            var domNode = _VirtualDom_render(subNode, subEventRoot);
            domNode.elm_event_node_ref = subEventRoot;
            return domNode;
        }
        if (tag === 3) {
            var domNode = vNode.h(vNode.g);
            _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
            return domNode;
        }
        // at this point `tag` must be 1 or 2
        var domNode = vNode.f
            ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
            : _VirtualDom_doc.createElement(vNode.c);
        if (_VirtualDom_divertHrefToApp && vNode.c == "a") {
            domNode.addEventListener("click", _VirtualDom_divertHrefToApp(domNode));
        }
        _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
        for (var kids = vNode.e, i = 0; i < kids.length; i++) {
            _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
        }
        return domNode;
    }
    // APPLY FACTS
    function _VirtualDom_applyFacts(domNode, eventNode, facts) {
        for (var key in facts) {
            var value = facts[key];
            key === "a1"
                ? _VirtualDom_applyStyles(domNode, value)
                :
                    key === "a0"
                        ? _VirtualDom_applyEvents(domNode, eventNode, value)
                        :
                            key === "a3"
                                ? _VirtualDom_applyAttrs(domNode, value)
                                :
                                    key === "a4"
                                        ? _VirtualDom_applyAttrsNS(domNode, value)
                                        :
                                            ((key !== "value" && key !== "checked") || domNode[key] !== value) && (domNode[key] = value);
        }
    }
    // APPLY STYLES
    function _VirtualDom_applyStyles(domNode, styles) {
        var domNodeStyle = domNode.style;
        for (var key in styles) {
            domNodeStyle[key] = styles[key];
        }
    }
    // APPLY ATTRS
    function _VirtualDom_applyAttrs(domNode, attrs) {
        for (var key in attrs) {
            var value = attrs[key];
            typeof value !== "undefined"
                ? domNode.setAttribute(key, value)
                : domNode.removeAttribute(key);
        }
    }
    // APPLY NAMESPACED ATTRS
    function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
        for (var key in nsAttrs) {
            var pair = nsAttrs[key];
            var namespace = pair.f;
            var value = pair.o;
            typeof value !== "undefined"
                ? domNode.setAttributeNS(namespace, key, value)
                : domNode.removeAttributeNS(namespace, key);
        }
    }
    // APPLY EVENTS
    function _VirtualDom_applyEvents(domNode, eventNode, events) {
        var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
        for (var key in events) {
            var newHandler = events[key];
            var oldCallback = allCallbacks[key];
            if (!newHandler) {
                domNode.removeEventListener(key, oldCallback);
                allCallbacks[key] = undefined;
                continue;
            }
            if (oldCallback) {
                var oldHandler = oldCallback.q;
                if (oldHandler.$ === newHandler.$) {
                    oldCallback.q = newHandler;
                    continue;
                }
                domNode.removeEventListener(key, oldCallback);
            }
            oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
            domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported
                && { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 });
            allCallbacks[key] = oldCallback;
        }
    }
    // PASSIVE EVENTS
    var _VirtualDom_passiveSupported;
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function () { _VirtualDom_passiveSupported = true; }
        }));
    }
    catch (e) { }
    // EVENT HANDLERS
    function _VirtualDom_makeCallback(eventNode, initialHandler) {
        function callback(event) {
            var handler = callback.q;
            var result = _Json_runHelp(handler.a, event);
            if (!$elm$core$Result$isOk(result)) {
                return;
            }
            var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
            // 0 = Normal
            // 1 = MayStopPropagation
            // 2 = MayPreventDefault
            // 3 = Custom
            var value = result.a;
            var message = !tag ? value : tag < 3 ? value.a : value.an;
            var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cs;
            var currentEventNode = (stopPropagation && event.stopPropagation(),
                (tag == 2 ? value.b : tag == 3 && value.cj) && event.preventDefault(),
                eventNode);
            var tagger;
            var i;
            while (tagger = currentEventNode.j) {
                if (typeof tagger == "function") {
                    message = tagger(message);
                }
                else {
                    for (var i = tagger.length; i--;) {
                        message = tagger[i](message);
                    }
                }
                currentEventNode = currentEventNode.p;
            }
            currentEventNode(message, stopPropagation); // stopPropagation implies isSync
        }
        callback.q = initialHandler;
        return callback;
    }
    function _VirtualDom_equalEvents(x, y) {
        return x.$ == y.$ && _Json_equality(x.a, y.a);
    }
    // DIFF
    // TODO: Should we do patches like in iOS?
    //
    // type Patch
    //   = At Int Patch
    //   | Batch (List Patch)
    //   | Change ...
    //
    // How could it not be better?
    //
    function _VirtualDom_diff(x, y) {
        var patches = [];
        _VirtualDom_diffHelp(x, y, patches, 0);
        return patches;
    }
    function _VirtualDom_pushPatch(patches, type, index, data) {
        var patch = {
            $: type,
            r: index,
            s: data,
            t: undefined,
            u: undefined
        };
        patches.push(patch);
        return patch;
    }
    function _VirtualDom_diffHelp(x, y, patches, index) {
        if (x === y) {
            return;
        }
        var xType = x.$;
        var yType = y.$;
        // Bail if you run into different types of nodes. Implies that the
        // structure has changed significantly and it's not worth a diff.
        if (xType !== yType) {
            if (xType === 1 && yType === 2) {
                y = _VirtualDom_dekey(y);
                yType = 1;
            }
            else {
                _VirtualDom_pushPatch(patches, 0, index, y);
                return;
            }
        }
        // Now we know that both nodes are the same $.
        switch (yType) {
            case 5:
                var xRefs = x.l;
                var yRefs = y.l;
                var i = xRefs.length;
                var same = i === yRefs.length;
                while (same && i--) {
                    same = xRefs[i] === yRefs[i];
                }
                if (same) {
                    y.k = x.k;
                    return;
                }
                y.k = y.m();
                var subPatches = [];
                _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
                subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
                return;
            case 4:
                // gather nested taggers
                var xTaggers = x.j;
                var yTaggers = y.j;
                var nesting = false;
                var xSubNode = x.k;
                while (xSubNode.$ === 4) {
                    nesting = true;
                    typeof xTaggers !== "object"
                        ? xTaggers = [xTaggers, xSubNode.j]
                        : xTaggers.push(xSubNode.j);
                    xSubNode = xSubNode.k;
                }
                var ySubNode = y.k;
                while (ySubNode.$ === 4) {
                    nesting = true;
                    typeof yTaggers !== "object"
                        ? yTaggers = [yTaggers, ySubNode.j]
                        : yTaggers.push(ySubNode.j);
                    ySubNode = ySubNode.k;
                }
                // Just bail if different numbers of taggers. This implies the
                // structure of the virtual DOM has changed.
                if (nesting && xTaggers.length !== yTaggers.length) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                // check if taggers are "the same"
                if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
                    _VirtualDom_pushPatch(patches, 2, index, yTaggers);
                }
                // diff everything below the taggers
                _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
                return;
            case 0:
                if (x.a !== y.a) {
                    _VirtualDom_pushPatch(patches, 3, index, y.a);
                }
                return;
            case 1:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
                return;
            case 2:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
                return;
            case 3:
                if (x.h !== y.h) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
                factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
                var patch = y.i(x.g, y.g);
                patch && _VirtualDom_pushPatch(patches, 5, index, patch);
                return;
        }
    }
    // assumes the incoming arrays are the same length
    function _VirtualDom_pairwiseRefEqual(as, bs) {
        for (var i = 0; i < as.length; i++) {
            if (as[i] !== bs[i]) {
                return false;
            }
        }
        return true;
    }
    function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
        // Bail if obvious indicators have changed. Implies more serious
        // structural changes such that it's not worth it to diff.
        if (x.c !== y.c || x.f !== y.f) {
            _VirtualDom_pushPatch(patches, 0, index, y);
            return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        diffKids(x, y, patches, index);
    }
    // DIFF FACTS
    // TODO Instead of creating a new diff object, it's possible to just test if
    // there *is* a diff. During the actual patch, do the diff again and make the
    // modifications directly. This way, there's no new allocations. Worth it?
    function _VirtualDom_diffFacts(x, y, category) {
        var diff;
        // look for changes and removals
        for (var xKey in x) {
            if (xKey === "a1" || xKey === "a0" || xKey === "a3" || xKey === "a4") {
                var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
                if (subDiff) {
                    diff = diff || {};
                    diff[xKey] = subDiff;
                }
                continue;
            }
            // remove if not in the new facts
            if (!(xKey in y)) {
                diff = diff || {};
                diff[xKey] =
                    !category
                        ? (typeof x[xKey] === "string" ? "" : null)
                        :
                            (category === "a1")
                                ? ""
                                :
                                    (category === "a0" || category === "a3")
                                        ? undefined
                                        :
                                            { f: x[xKey].f, o: undefined };
                continue;
            }
            var xValue = x[xKey];
            var yValue = y[xKey];
            // reference equal, so don't worry about it
            if (xValue === yValue && xKey !== "value" && xKey !== "checked"
                || category === "a0" && _VirtualDom_equalEvents(xValue, yValue)) {
                continue;
            }
            diff = diff || {};
            diff[xKey] = yValue;
        }
        // add new stuff
        for (var yKey in y) {
            if (!(yKey in x)) {
                diff = diff || {};
                diff[yKey] = y[yKey];
            }
        }
        return diff;
    }
    // DIFF KIDS
    function _VirtualDom_diffKids(xParent, yParent, patches, index) {
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        // FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
        if (xLen > yLen) {
            _VirtualDom_pushPatch(patches, 6, index, {
                v: yLen,
                i: xLen - yLen
            });
        }
        else if (xLen < yLen) {
            _VirtualDom_pushPatch(patches, 7, index, {
                v: xLen,
                e: yKids
            });
        }
        // PAIRWISE DIFF EVERYTHING ELSE
        for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
            var xKid = xKids[i];
            _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
            index += xKid.b || 0;
        }
    }
    // KEYED DIFF
    function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
        var localPatches = [];
        var changes = {}; // Dict String Entry
        var inserts = []; // Array { index : Int, entry : Entry }
        // type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        var xIndex = 0;
        var yIndex = 0;
        var index = rootIndex;
        while (xIndex < xLen && yIndex < yLen) {
            var x = xKids[xIndex];
            var y = yKids[yIndex];
            var xKey = x.a;
            var yKey = y.a;
            var xNode = x.b;
            var yNode = y.b;
            var newMatch = undefined;
            var oldMatch = undefined;
            // check if keys match
            if (xKey === yKey) {
                index++;
                _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
                index += xNode.b || 0;
                xIndex++;
                yIndex++;
                continue;
            }
            // look ahead 1 to detect insertions and removals.
            var xNext = xKids[xIndex + 1];
            var yNext = yKids[yIndex + 1];
            if (xNext) {
                var xNextKey = xNext.a;
                var xNextNode = xNext.b;
                oldMatch = yKey === xNextKey;
            }
            if (yNext) {
                var yNextKey = yNext.a;
                var yNextNode = yNext.b;
                newMatch = xKey === yNextKey;
            }
            // swap x and y
            if (newMatch && oldMatch) {
                index++;
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            // insert y
            if (newMatch) {
                index++;
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                index += xNode.b || 0;
                xIndex += 1;
                yIndex += 2;
                continue;
            }
            // remove x
            if (oldMatch) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 1;
                continue;
            }
            // remove x, insert y
            if (xNext && xNextKey === yNextKey) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            break;
        }
        // eat up any remaining nodes with removeNode and insertNode
        while (xIndex < xLen) {
            index++;
            var x = xKids[xIndex];
            var xNode = x.b;
            _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
            index += xNode.b || 0;
            xIndex++;
        }
        while (yIndex < yLen) {
            var endInserts = endInserts || [];
            var y = yKids[yIndex];
            _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
            yIndex++;
        }
        if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
            _VirtualDom_pushPatch(patches, 8, rootIndex, {
                w: localPatches,
                x: inserts,
                y: endInserts
            });
        }
    }
    // CHANGES FROM KEYED DIFF
    var _VirtualDom_POSTFIX = "_elmW6BL";
    function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
        var entry = changes[key];
        // never seen this key before
        if (!entry) {
            entry = {
                c: 0,
                z: vnode,
                r: yIndex,
                s: undefined
            };
            inserts.push({ r: yIndex, A: entry });
            changes[key] = entry;
            return;
        }
        // this key was removed earlier, a match!
        if (entry.c === 1) {
            inserts.push({ r: yIndex, A: entry });
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
            entry.r = yIndex;
            entry.s.s = {
                w: subPatches,
                A: entry
            };
            return;
        }
        // this key has already been inserted or moved, a duplicate!
        _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
    }
    function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
        var entry = changes[key];
        // never seen this key before
        if (!entry) {
            var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
            changes[key] = {
                c: 1,
                z: vnode,
                r: index,
                s: patch
            };
            return;
        }
        // this key was inserted earlier, a match!
        if (entry.c === 0) {
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
            _VirtualDom_pushPatch(localPatches, 9, index, {
                w: subPatches,
                A: entry
            });
            return;
        }
        // this key has already been removed or moved, a duplicate!
        _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
    }
    // ADD DOM NODES
    //
    // Each DOM node has an "index" assigned in order of traversal. It is important
    // to minimize our crawl over the actual DOM, so these indexes (along with the
    // descendantsCount of virtual nodes) let us skip touching entire subtrees of
    // the DOM if we know there are no patches there.
    function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
        _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
    }
    // assumes `patches` is non-empty and indexes increase monotonically.
    function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
        var patch = patches[i];
        var index = patch.r;
        while (index === low) {
            var patchType = patch.$;
            if (patchType === 1) {
                _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
            }
            else if (patchType === 8) {
                patch.t = domNode;
                patch.u = eventNode;
                var subPatches = patch.s.w;
                if (subPatches.length > 0) {
                    _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                }
            }
            else if (patchType === 9) {
                patch.t = domNode;
                patch.u = eventNode;
                var data = patch.s;
                if (data) {
                    data.A.s = domNode;
                    var subPatches = data.w;
                    if (subPatches.length > 0) {
                        _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                    }
                }
            }
            else {
                patch.t = domNode;
                patch.u = eventNode;
            }
            i++;
            if (!(patch = patches[i]) || (index = patch.r) > high) {
                return i;
            }
        }
        var tag = vNode.$;
        if (tag === 4) {
            var subNode = vNode.k;
            while (subNode.$ === 4) {
                subNode = subNode.k;
            }
            return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
        }
        // tag must be 1 or 2 at this point
        var vKids = vNode.e;
        var childNodes = domNode.childNodes;
        for (var j = 0; j < vKids.length; j++) {
            low++;
            var vKid = tag === 1 ? vKids[j] : vKids[j].b;
            var nextLow = low + (vKid.b || 0);
            if (low <= index && index <= nextLow) {
                i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
                if (!(patch = patches[i]) || (index = patch.r) > high) {
                    return i;
                }
            }
            low = nextLow;
        }
        return i;
    }
    // APPLY PATCHES
    function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
        if (patches.length === 0) {
            return rootDomNode;
        }
        _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
        return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
    }
    function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
        for (var i = 0; i < patches.length; i++) {
            var patch = patches[i];
            var localDomNode = patch.t;
            var newNode = _VirtualDom_applyPatch(localDomNode, patch);
            if (localDomNode === rootDomNode) {
                rootDomNode = newNode;
            }
        }
        return rootDomNode;
    }
    function _VirtualDom_applyPatch(domNode, patch) {
        switch (patch.$) {
            case 0:
                return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
            case 4:
                _VirtualDom_applyFacts(domNode, patch.u, patch.s);
                return domNode;
            case 3:
                domNode.replaceData(0, domNode.length, patch.s);
                return domNode;
            case 1:
                return _VirtualDom_applyPatchesHelp(domNode, patch.s);
            case 2:
                if (domNode.elm_event_node_ref) {
                    domNode.elm_event_node_ref.j = patch.s;
                }
                else {
                    domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
                }
                return domNode;
            case 6:
                var data = patch.s;
                for (var i = 0; i < data.i; i++) {
                    domNode.removeChild(domNode.childNodes[data.v]);
                }
                return domNode;
            case 7:
                var data = patch.s;
                var kids = data.e;
                var i = data.v;
                var theEnd = domNode.childNodes[i];
                for (; i < kids.length; i++) {
                    domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
                }
                return domNode;
            case 9:
                var data = patch.s;
                if (!data) {
                    domNode.parentNode.removeChild(domNode);
                    return domNode;
                }
                var entry = data.A;
                if (typeof entry.r !== "undefined") {
                    domNode.parentNode.removeChild(domNode);
                }
                entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
                return domNode;
            case 8:
                return _VirtualDom_applyPatchReorder(domNode, patch);
            case 5:
                return patch.s(domNode);
            default:
                _Debug_crash(10); // 'Ran into an unknown patch!'
        }
    }
    function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
        var parentNode = domNode.parentNode;
        var newNode = _VirtualDom_render(vNode, eventNode);
        if (!newNode.elm_event_node_ref) {
            newNode.elm_event_node_ref = domNode.elm_event_node_ref;
        }
        if (parentNode && newNode !== domNode) {
            parentNode.replaceChild(newNode, domNode);
        }
        return newNode;
    }
    function _VirtualDom_applyPatchReorder(domNode, patch) {
        var data = patch.s;
        // remove end inserts
        var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
        // removals
        domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
        // inserts
        var inserts = data.x;
        for (var i = 0; i < inserts.length; i++) {
            var insert = inserts[i];
            var entry = insert.A;
            var node = entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u);
            domNode.insertBefore(node, domNode.childNodes[insert.r]);
        }
        // add end inserts
        if (frag) {
            _VirtualDom_appendChild(domNode, frag);
        }
        return domNode;
    }
    function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
        if (!endInserts) {
            return;
        }
        var frag = _VirtualDom_doc.createDocumentFragment();
        for (var i = 0; i < endInserts.length; i++) {
            var insert = endInserts[i];
            var entry = insert.A;
            _VirtualDom_appendChild(frag, entry.c === 2
                ? entry.s
                : _VirtualDom_render(entry.z, patch.u));
        }
        return frag;
    }
    function _VirtualDom_virtualize(node) {
        // TEXT NODES
        if (node.nodeType === 3) {
            return _VirtualDom_text(node.textContent);
        }
        // WEIRD NODES
        if (node.nodeType !== 1) {
            return _VirtualDom_text("");
        }
        // ELEMENT NODES
        var attrList = _List_Nil;
        var attrs = node.attributes;
        for (var i = attrs.length; i--;) {
            var attr = attrs[i];
            var name = attr.name;
            var value = attr.value;
            attrList = _List_Cons(_VirtualDom_attribute_fn(name, value), attrList);
        }
        var tag = node.tagName.toLowerCase();
        var kidList = _List_Nil;
        var kids = node.childNodes;
        for (var i = kids.length; i--;) {
            kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
        }
        return A3(_VirtualDom_node, tag, attrList, kidList);
    }
    function _VirtualDom_dekey(keyedNode) {
        var keyedKids = keyedNode.e;
        var len = keyedKids.length;
        var kids = new Array(len);
        for (var i = 0; i < len; i++) {
            kids[i] = keyedKids[i].b;
        }
        return {
            $: 1,
            c: keyedNode.c,
            d: keyedNode.d,
            e: kids,
            f: keyedNode.f,
            b: keyedNode.b
        };
    }
    // ELEMENT
    var _Debugger_element;
    var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.fl, impl.gC, impl.gh, function (sendToApp, initialModel) {
            var view = impl.gD;
            /**/
            var domNode = args["node"];
            //*/
            /**_UNUSED/
            var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
            //*/
            var currNode = _VirtualDom_virtualize(domNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                var nextNode = view(model);
                var patches = _VirtualDom_diff(currNode, nextNode);
                domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
                currNode = nextNode;
            });
        });
    });
    // DOCUMENT
    var _Debugger_document;
    var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.fl, impl.gC, impl.gh, function (sendToApp, initialModel) {
            var divertHrefToApp = impl.cp && impl.cp(sendToApp);
            var view = impl.gD;
            var title = _VirtualDom_doc.title;
            var bodyNode = _VirtualDom_doc.body;
            var currNode = _VirtualDom_virtualize(bodyNode);
            return _Browser_makeAnimator(initialModel, function (model) {
                _VirtualDom_divertHrefToApp = divertHrefToApp;
                var doc = view(model);
                var nextNode = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "body")(_List_Nil)(doc.bM);
                var patches = _VirtualDom_diff(currNode, nextNode);
                bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
                currNode = nextNode;
                _VirtualDom_divertHrefToApp = 0;
                (title !== doc.bB) && (_VirtualDom_doc.title = title = doc.bB);
            });
        });
    });
    // ANIMATION
    var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== "undefined"
        ? cancelAnimationFrame
        : function (id) { clearTimeout(id); };
    var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== "undefined"
        ? requestAnimationFrame
        : function (callback) { return setTimeout(callback, 1000 / 60); };
    function _Browser_makeAnimator(model, draw) {
        draw(model);
        var state = 0;
        function updateIfNeeded() {
            state = state === 1
                ? 0
                : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
        }
        return function (nextModel, isSync) {
            model = nextModel;
            isSync
                ? (draw(model),
                    state === 2 && (state = 1))
                : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
                    state = 2);
        };
    }
    // APPLICATION
    function _Browser_application(impl) {
        var onUrlChange = impl.fO;
        var onUrlRequest = impl.fP;
        var key = function () { key.a(onUrlChange(_Browser_getUrl())); };
        return _Browser_document({
            cp: function (sendToApp) {
                key.a = sendToApp;
                _Browser_window.addEventListener("popstate", key);
                _Browser_window.navigator.userAgent.indexOf("Trident") < 0 || _Browser_window.addEventListener("hashchange", key);
                return F2(function (domNode, event) {
                    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute("download")) {
                        event.preventDefault();
                        var href = domNode.href;
                        var curr = _Browser_getUrl();
                        var next = $elm$url$Url$fromString(href).a;
                        sendToApp(onUrlRequest((next
                            && curr.fW === next.fW
                            && curr.fe === next.fe
                            && curr.fV.a === next.fV.a)
                            ? $elm$browser$Browser$Internal(next)
                            : $elm$browser$Browser$External(href)));
                    }
                });
            },
            fl: function (flags) {
                return A3(impl.fl, flags, _Browser_getUrl(), key);
            },
            gD: impl.gD,
            gC: impl.gC,
            gh: impl.gh
        });
    }
    function _Browser_getUrl() {
        return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
    }
    var _Browser_go_fn = function (key, n) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            n && history.go(n);
            key();
        }));
    }, _Browser_go = F2(_Browser_go_fn);
    var _Browser_pushUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.pushState({}, "", url);
            key();
        }));
    }, _Browser_pushUrl = F2(_Browser_pushUrl_fn);
    var _Browser_replaceUrl_fn = function (key, url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function () {
            history.replaceState({}, "", url);
            key();
        }));
    }, _Browser_replaceUrl = F2(_Browser_replaceUrl_fn);
    // GLOBAL EVENTS
    var _Browser_fakeNode = { addEventListener: function () { }, removeEventListener: function () { } };
    var _Browser_doc = typeof document !== "undefined" ? document : _Browser_fakeNode;
    var _Browser_window = typeof window !== "undefined" ? window : _Browser_fakeNode;
    var _Browser_on_fn = function (node, eventName, sendToSelf) {
        return _Scheduler_spawn(_Scheduler_binding(function (callback) {
            function handler(event) { _Scheduler_rawSpawn(sendToSelf(event)); }
            node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
            return function () { node.removeEventListener(eventName, handler); };
        }));
    }, _Browser_on = F3(_Browser_on_fn);
    var _Browser_decodeEvent_fn = function (decoder, event) {
        var result = _Json_runHelp(decoder, event);
        return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
    }, _Browser_decodeEvent = F2(_Browser_decodeEvent_fn);
    // PAGE VISIBILITY
    function _Browser_visibilityInfo() {
        return (typeof _VirtualDom_doc.hidden !== "undefined")
            ? { fd: "hidden", eN: "visibilitychange" }
            :
                (typeof _VirtualDom_doc.mozHidden !== "undefined")
                    ? { fd: "mozHidden", eN: "mozvisibilitychange" }
                    :
                        (typeof _VirtualDom_doc.msHidden !== "undefined")
                            ? { fd: "msHidden", eN: "msvisibilitychange" }
                            :
                                (typeof _VirtualDom_doc.webkitHidden !== "undefined")
                                    ? { fd: "webkitHidden", eN: "webkitvisibilitychange" }
                                    : { fd: "hidden", eN: "visibilitychange" };
    }
    // ANIMATION FRAMES
    function _Browser_rAF() {
        return _Scheduler_binding(function (callback) {
            var id = _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(Date.now()));
            });
            return function () {
                _Browser_cancelAnimationFrame(id);
            };
        });
    }
    function _Browser_now() {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(Date.now()));
        });
    }
    // DOM STUFF
    function _Browser_withNode(id, doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                var node = document.getElementById(id);
                callback(node
                    ? _Scheduler_succeed(doStuff(node))
                    : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
            });
        });
    }
    function _Browser_withWindow(doStuff) {
        return _Scheduler_binding(function (callback) {
            _Browser_requestAnimationFrame(function () {
                callback(_Scheduler_succeed(doStuff()));
            });
        });
    }
    // FOCUS and BLUR
    var _Browser_call_fn = function (functionName, id) {
        return _Browser_withNode(id, function (node) {
            node[functionName]();
            return _Utils_Tuple0;
        });
    }, _Browser_call = F2(_Browser_call_fn);
    // WINDOW VIEWPORT
    function _Browser_getViewport() {
        return {
            dT: _Browser_getScene(),
            gE: {
                ef: _Browser_window.pageXOffset,
                eg: _Browser_window.pageYOffset,
                bE: _Browser_doc.documentElement.clientWidth,
                bj: _Browser_doc.documentElement.clientHeight
            }
        };
    }
    function _Browser_getScene() {
        var body = _Browser_doc.body;
        var elem = _Browser_doc.documentElement;
        return {
            bE: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
            bj: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
        };
    }
    var _Browser_setViewport_fn = function (x, y) {
        return _Browser_withWindow(function () {
            _Browser_window.scroll(x, y);
            return _Utils_Tuple0;
        });
    }, _Browser_setViewport = F2(_Browser_setViewport_fn);
    // ELEMENT VIEWPORT
    function _Browser_getViewportOf(id) {
        return _Browser_withNode(id, function (node) {
            return {
                dT: {
                    bE: node.scrollWidth,
                    bj: node.scrollHeight
                },
                gE: {
                    ef: node.scrollLeft,
                    eg: node.scrollTop,
                    bE: node.clientWidth,
                    bj: node.clientHeight
                }
            };
        });
    }
    var _Browser_setViewportOf_fn = function (id, x, y) {
        return _Browser_withNode(id, function (node) {
            node.scrollLeft = x;
            node.scrollTop = y;
            return _Utils_Tuple0;
        });
    }, _Browser_setViewportOf = F3(_Browser_setViewportOf_fn);
    // ELEMENT
    function _Browser_getElement(id) {
        return _Browser_withNode(id, function (node) {
            var rect = node.getBoundingClientRect();
            var x = _Browser_window.pageXOffset;
            var y = _Browser_window.pageYOffset;
            return {
                dT: _Browser_getScene(),
                gE: {
                    ef: x,
                    eg: y,
                    bE: _Browser_doc.documentElement.clientWidth,
                    bj: _Browser_doc.documentElement.clientHeight
                },
                e$: {
                    ef: x + rect.left,
                    eg: y + rect.top,
                    bE: rect.width,
                    bj: rect.height
                }
            };
        });
    }
    // LOAD and RELOAD
    function _Browser_reload(skipCache) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            _VirtualDom_doc.location.reload(skipCache);
        }));
    }
    function _Browser_load(url) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _Scheduler_binding(function (callback) {
            try {
                _Browser_window.location = url;
            }
            catch (err) {
                // Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
                // Other browsers reload the page, so let's be consistent about that.
                _VirtualDom_doc.location.reload(false);
            }
        }));
    }
    var _Bitwise_and_fn = function (a, b) {
        return a & b;
    }, _Bitwise_and = F2(_Bitwise_and_fn);
    var _Bitwise_or_fn = function (a, b) {
        return a | b;
    }, _Bitwise_or = F2(_Bitwise_or_fn);
    var _Bitwise_xor_fn = function (a, b) {
        return a ^ b;
    }, _Bitwise_xor = F2(_Bitwise_xor_fn);
    function _Bitwise_complement(a) {
        return ~a;
    }
    ;
    var _Bitwise_shiftLeftBy_fn = function (offset, a) {
        return a << offset;
    }, _Bitwise_shiftLeftBy = F2(_Bitwise_shiftLeftBy_fn);
    var _Bitwise_shiftRightBy_fn = function (offset, a) {
        return a >> offset;
    }, _Bitwise_shiftRightBy = F2(_Bitwise_shiftRightBy_fn);
    var _Bitwise_shiftRightZfBy_fn = function (offset, a) {
        return a >>> offset;
    }, _Bitwise_shiftRightZfBy = F2(_Bitwise_shiftRightZfBy_fn);
    function _Url_percentEncode(string) {
        return encodeURIComponent(string);
    }
    function _Url_percentDecode(string) {
        try {
            return $elm$core$Maybe$Just(decodeURIComponent(string));
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }
    // SEND REQUEST
    var _Http_toTask_fn = function (router, toTask, request) {
        return _Scheduler_binding(function (callback) {
            function done(response) {
                callback(toTask(request.bV.a(response)));
            }
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("error", function () { done($elm$http$Http$NetworkError_); });
            xhr.addEventListener("timeout", function () { done($elm$http$Http$Timeout_); });
            xhr.addEventListener("load", function () { done(_Http_toResponse(request.bV.b, xhr)); });
            $elm$core$Maybe$isJust(request.d5) && _Http_track(router, xhr, request.d5.a);
            try {
                xhr.open(request.cc, request.cH, true);
            }
            catch (e) {
                return done($elm$http$Http$BadUrl_(request.cH));
            }
            _Http_configureRequest(xhr, request);
            request.bM.a && xhr.setRequestHeader("Content-Type", request.bM.a);
            xhr.send(request.bM.b);
            return function () { xhr.c = true; xhr.abort(); };
        });
    }, _Http_toTask = F3(_Http_toTask_fn);
    // CONFIGURE
    function _Http_configureRequest(xhr, request) {
        for (var headers = request.b$; headers.b; headers = headers.b) // WHILE_CONS
         {
            xhr.setRequestHeader(headers.a.a, headers.a.b);
        }
        xhr.timeout = request.cE.a || 0;
        xhr.responseType = request.bV.d;
        xhr.withCredentials = request.eu;
    }
    // RESPONSES
    function _Http_toResponse(toBody, xhr) {
        return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
    }
    // METADATA
    function _Http_toMetadata(xhr) {
        return {
            cH: xhr.responseURL,
            gc: xhr.status,
            gd: xhr.statusText,
            b$: _Http_parseHeaders(xhr.getAllResponseHeaders())
        };
    }
    // HEADERS
    function _Http_parseHeaders(rawHeaders) {
        if (!rawHeaders) {
            return $elm$core$Dict$empty;
        }
        var headers = $elm$core$Dict$empty;
        var headerPairs = rawHeaders.split("\r\n");
        for (var i = headerPairs.length; i--;) {
            var headerPair = headerPairs[i];
            var index = headerPair.indexOf(": ");
            if (index > 0) {
                var key = headerPair.substring(0, index);
                var value = headerPair.substring(index + 2);
                headers = $elm$core$Dict$update_fn(key, function (oldValue) {
                    return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
                        ? value + ", " + oldValue.a
                        : value);
                }, headers);
            }
        }
        return headers;
    }
    // EXPECT
    var _Http_expect_fn = function (type, toBody, toValue) {
        return {
            $: 0,
            d: type,
            b: toBody,
            a: toValue
        };
    }, _Http_expect = F3(_Http_expect_fn);
    var _Http_mapExpect_fn = function (func, expect) {
        return {
            $: 0,
            d: expect.d,
            b: expect.b,
            a: function (x) { return func(expect.a(x)); }
        };
    }, _Http_mapExpect = F2(_Http_mapExpect_fn);
    function _Http_toDataView(arrayBuffer) {
        return new DataView(arrayBuffer);
    }
    // BODY and PARTS
    var _Http_emptyBody = { $: 0 };
    var _Http_pair_fn = function (a, b) { return { $: 0, a: a, b: b }; }, _Http_pair = F2(_Http_pair_fn);
    function _Http_toFormData(parts) {
        for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
         {
            var part = parts.a;
            formData.append(part.a, part.b);
        }
        return formData;
    }
    var _Http_bytesToBlob_fn = function (mime, bytes) {
        return new Blob([bytes], { type: mime });
    }, _Http_bytesToBlob = F2(_Http_bytesToBlob_fn);
    // PROGRESS
    function _Http_track(router, xhr, tracker) {
        // TODO check out lengthComputable on loadstart event
        xhr.upload.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
                f5: event.loaded,
                cq: event.total
            }))));
        });
        xhr.addEventListener("progress", function (event) {
            if (xhr.c) {
                return;
            }
            _Scheduler_rawSpawn(_Platform_sendToSelf_fn(router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
                fY: event.loaded,
                cq: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
            }))));
        });
    }
    // BYTES
    function _Bytes_width(bytes) {
        return bytes.byteLength;
    }
    var _Bytes_getHostEndianness_fn = function (le, be) {
        return _Scheduler_binding(function (callback) {
            callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
        });
    }, _Bytes_getHostEndianness = F2(_Bytes_getHostEndianness_fn);
    // ENCODERS
    function _Bytes_encode(encoder) {
        var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
        $elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
        return mutableBytes;
    }
    // SIGNED INTEGERS
    var _Bytes_write_i8_fn = function (mb, i, n) { mb.setInt8(i, n); return i + 1; }, _Bytes_write_i8 = F3(_Bytes_write_i8_fn);
    var _Bytes_write_i16_fn = function (mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; }, _Bytes_write_i16 = F4(_Bytes_write_i16_fn);
    var _Bytes_write_i32_fn = function (mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; }, _Bytes_write_i32 = F4(_Bytes_write_i32_fn);
    // UNSIGNED INTEGERS
    var _Bytes_write_u8_fn = function (mb, i, n) { mb.setUint8(i, n); return i + 1; }, _Bytes_write_u8 = F3(_Bytes_write_u8_fn);
    var _Bytes_write_u16_fn = function (mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; }, _Bytes_write_u16 = F4(_Bytes_write_u16_fn);
    var _Bytes_write_u32_fn = function (mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; }, _Bytes_write_u32 = F4(_Bytes_write_u32_fn);
    // FLOATS
    var _Bytes_write_f32_fn = function (mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; }, _Bytes_write_f32 = F4(_Bytes_write_f32_fn);
    var _Bytes_write_f64_fn = function (mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; }, _Bytes_write_f64 = F4(_Bytes_write_f64_fn);
    // BYTES
    var _Bytes_write_bytes_fn = function (mb, offset, bytes) {
        for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4) {
            mb.setUint32(offset + i, bytes.getUint32(i));
        }
        for (; i < len; i++) {
            mb.setUint8(offset + i, bytes.getUint8(i));
        }
        return offset + len;
    }, _Bytes_write_bytes = F3(_Bytes_write_bytes_fn);
    // STRINGS
    function _Bytes_getStringWidth(string) {
        for (var width = 0, i = 0; i < string.length; i++) {
            var code = string.charCodeAt(i);
            width +=
                (code < 128) ? 1 :
                    (code < 2048) ? 2 :
                        (code < 55296 || 56319 < code) ? 3 : (i++, 4);
        }
        return width;
    }
    var _Bytes_write_string_fn = function (mb, offset, string) {
        for (var i = 0; i < string.length; i++) {
            var code = string.charCodeAt(i);
            offset +=
                (code < 128)
                    ? (mb.setUint8(offset, code)
                        , 1)
                    :
                        (code < 2048)
                            ? (mb.setUint16(offset, 49280 /* 0b1100000010000000 */
                                | (code >>> 6 & 31 /* 0b00011111 */) << 8
                                | code & 63 /* 0b00111111 */)
                                , 2)
                            :
                                (code < 55296 || 56319 < code)
                                    ? (mb.setUint16(offset, 57472 /* 0b1110000010000000 */
                                        | (code >>> 12 & 15 /* 0b00001111 */) << 8
                                        | code >>> 6 & 63 /* 0b00111111 */)
                                        , mb.setUint8(offset + 2, 128 /* 0b10000000 */
                                            | code & 63 /* 0b00111111 */)
                                        , 3)
                                    :
                                        (code = (code - 55296) * 1024 + string.charCodeAt(++i) - 56320 + 65536
                                            , mb.setUint32(offset, 4034953344 /* 0b11110000100000001000000010000000 */
                                                | (code >>> 18 & 7 /* 0b00000111 */) << 24
                                                | (code >>> 12 & 63 /* 0b00111111 */) << 16
                                                | (code >>> 6 & 63 /* 0b00111111 */) << 8
                                                | code & 63 /* 0b00111111 */)
                                            , 4);
        }
        return offset;
    }, _Bytes_write_string = F3(_Bytes_write_string_fn);
    // DECODER
    var _Bytes_decode_fn = function (decoder, bytes) {
        try {
            return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Bytes_decode_fn_unwrapped = function (decoder, bytes) {
        try {
            return $elm$core$Maybe$Just(decoder(bytes, 0).b);
        }
        catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Bytes_decode = F2(_Bytes_decode_fn);
    var _Bytes_read_i8_fn = function (bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); }, _Bytes_read_i8 = F2(_Bytes_read_i8_fn);
    var _Bytes_read_i16_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); }, _Bytes_read_i16 = F3(_Bytes_read_i16_fn);
    var _Bytes_read_i32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); }, _Bytes_read_i32 = F3(_Bytes_read_i32_fn);
    var _Bytes_read_u8_fn = function (bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); }, _Bytes_read_u8 = F2(_Bytes_read_u8_fn);
    var _Bytes_read_u16_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); }, _Bytes_read_u16 = F3(_Bytes_read_u16_fn);
    var _Bytes_read_u32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); }, _Bytes_read_u32 = F3(_Bytes_read_u32_fn);
    var _Bytes_read_f32_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); }, _Bytes_read_f32 = F3(_Bytes_read_f32_fn);
    var _Bytes_read_f64_fn = function (isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); }, _Bytes_read_f64 = F3(_Bytes_read_f64_fn);
    var _Bytes_read_bytes_fn = function (len, bytes, offset) {
        return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
    }, _Bytes_read_bytes = F3(_Bytes_read_bytes_fn);
    var _Bytes_read_string_fn = function (len, bytes, offset) {
        var string = "";
        var end = offset + len;
        for (; offset < end;) {
            var byte = bytes.getUint8(offset++);
            string +=
                (byte < 128)
                    ? String.fromCharCode(byte)
                    :
                        ((byte & 224 /* 0b11100000 */) === 192 /* 0b11000000 */)
                            ? String.fromCharCode((byte & 31 /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 63 /* 0b00111111 */)
                            :
                                ((byte & 240 /* 0b11110000 */) === 224 /* 0b11100000 */)
                                    ? String.fromCharCode((byte & 15 /* 0b00001111 */) << 12
                                        | (bytes.getUint8(offset++) & 63 /* 0b00111111 */) << 6
                                        | bytes.getUint8(offset++) & 63 /* 0b00111111 */)
                                    :
                                        (byte =
                                            ((byte & 7 /* 0b00000111 */) << 18
                                                | (bytes.getUint8(offset++) & 63 /* 0b00111111 */) << 12
                                                | (bytes.getUint8(offset++) & 63 /* 0b00111111 */) << 6
                                                | bytes.getUint8(offset++) & 63 /* 0b00111111 */) - 65536
                                            , String.fromCharCode(Math.floor(byte / 1024) + 55296, byte % 1024 + 56320));
        }
        return _Utils_Tuple2(offset, string);
    }, _Bytes_read_string = F3(_Bytes_read_string_fn);
    var _Bytes_decodeFailure_fn = function () { throw 0; }, _Bytes_decodeFailure = F2(_Bytes_decodeFailure_fn);
    // DECODER
    var _File_decoder = _Json_decodePrim(function (value) {
        // NOTE: checks if `File` exists in case this is run on node
        return (typeof File !== "undefined" && value instanceof File)
            ? $elm$core$Result$Ok(value)
            : _Json_expecting("a FILE", value);
    });
    // METADATA
    function _File_name(file) { return file.name; }
    function _File_mime(file) { return file.type; }
    function _File_size(file) { return file.size; }
    function _File_lastModified(file) {
        return $elm$time$Time$millisToPosix(file.lastModified);
    }
    // DOWNLOAD
    var _File_downloadNode;
    function _File_getDownloadNode() {
        return _File_downloadNode || (_File_downloadNode = document.createElement("a"));
    }
    var _File_download_fn = function (name, mime, content) {
        return _Scheduler_binding(function (callback) {
            var blob = new Blob([content], { type: mime });
            // for IE10+
            if (navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(blob, name);
                return;
            }
            // for HTML5
            var node = _File_getDownloadNode();
            var objectUrl = URL.createObjectURL(blob);
            node.href = objectUrl;
            node.download = name;
            _File_click(node);
            URL.revokeObjectURL(objectUrl);
        });
    }, _File_download = F3(_File_download_fn);
    function _File_downloadUrl(href) {
        return _Scheduler_binding(function (callback) {
            var node = _File_getDownloadNode();
            node.href = href;
            node.download = "";
            node.origin === location.origin || (node.target = "_blank");
            _File_click(node);
        });
    }
    // IE COMPATIBILITY
    function _File_makeBytesSafeForInternetExplorer(bytes) {
        // only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
        // all other browsers can just run `new Blob([bytes])` directly with no problem
        //
        return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    }
    function _File_click(node) {
        // only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
        // all other browsers have MouseEvent and do not need this conditional stuff
        //
        if (typeof MouseEvent === "function") {
            node.dispatchEvent(new MouseEvent("click"));
        }
        else {
            var event = document.createEvent("MouseEvents");
            event.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            document.body.appendChild(node);
            node.dispatchEvent(event);
            document.body.removeChild(node);
        }
    }
    // UPLOAD
    var _File_node;
    function _File_uploadOne(mimes) {
        return _Scheduler_binding(function (callback) {
            _File_node = document.createElement("input");
            _File_node.type = "file";
            _File_node.accept = $elm$core$String$join_fn(",", mimes);
            _File_node.addEventListener("change", function (event) {
                callback(_Scheduler_succeed(event.target.files[0]));
            });
            _File_click(_File_node);
        });
    }
    function _File_uploadOneOrMore(mimes) {
        return _Scheduler_binding(function (callback) {
            _File_node = document.createElement("input");
            _File_node.type = "file";
            _File_node.multiple = true;
            _File_node.accept = $elm$core$String$join_fn(",", mimes);
            _File_node.addEventListener("change", function (event) {
                var elmFiles = _List_fromArray(event.target.files);
                callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
            });
            _File_click(_File_node);
        });
    }
    // CONTENT
    function _File_toString(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsText(blob);
            return function () { reader.abort(); };
        });
    }
    function _File_toBytes(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(new DataView(reader.result)));
            });
            reader.readAsArrayBuffer(blob);
            return function () { reader.abort(); };
        });
    }
    function _File_toUrl(blob) {
        return _Scheduler_binding(function (callback) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsDataURL(blob);
            return function () { reader.abort(); };
        });
    }
    // STRINGS
    var _Parser_isSubString_fn = function (smallString, offset, row, col, bigString) {
        var smallLength = smallString.length;
        var isGood = offset + smallLength <= bigString.length;
        for (var i = 0; isGood && i < smallLength;) {
            var code = bigString.charCodeAt(offset);
            isGood =
                smallString[i++] === bigString[offset++]
                    && (code === 10 /* \n */
                        ? (row++, col = 1)
                        : (col++, (code & 63488) === 55296 ? smallString[i++] === bigString[offset++] : 1));
        }
        return _Utils_Tuple3(isGood ? offset : -1, row, col);
    }, _Parser_isSubString = F5(_Parser_isSubString_fn);
    // CHARS
    var _Parser_isSubChar_fn = function (predicate, offset, string) {
        return (string.length <= offset
            ? -1
            :
                (string.charCodeAt(offset) & 63488) === 55296
                    ? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
                    :
                        (predicate(_Utils_chr(string[offset]))
                            ? ((string[offset] === "\n") ? -2 : (offset + 1))
                            : -1));
    }, _Parser_isSubChar = F3(_Parser_isSubChar_fn);
    var _Parser_isAsciiCode_fn = function (code, offset, string) {
        return string.charCodeAt(offset) === code;
    }, _Parser_isAsciiCode = F3(_Parser_isAsciiCode_fn);
    // NUMBERS
    var _Parser_chompBase10_fn = function (offset, string) {
        for (; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (code < 48 || 57 < code) {
                return offset;
            }
        }
        return offset;
    }, _Parser_chompBase10 = F2(_Parser_chompBase10_fn);
    var _Parser_consumeBase_fn = function (base, offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var digit = string.charCodeAt(offset) - 48;
            if (digit < 0 || base <= digit)
                break;
            total = base * total + digit;
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase = F3(_Parser_consumeBase_fn);
    var _Parser_consumeBase16_fn = function (offset, string) {
        for (var total = 0; offset < string.length; offset++) {
            var code = string.charCodeAt(offset);
            if (48 <= code && code <= 57) {
                total = 16 * total + code - 48;
            }
            else if (65 <= code && code <= 70) {
                total = 16 * total + code - 55;
            }
            else if (97 <= code && code <= 102) {
                total = 16 * total + code - 87;
            }
            else {
                break;
            }
        }
        return _Utils_Tuple2(offset, total);
    }, _Parser_consumeBase16 = F2(_Parser_consumeBase16_fn);
    // FIND STRING
    var _Parser_findSubString_fn = function (smallString, offset, row, col, bigString) {
        var newOffset = bigString.indexOf(smallString, offset);
        var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
        while (offset < target) {
            var code = bigString.charCodeAt(offset++);
            code === 10 /* \n */
                ? (col = 1, row++)
                : (col++, (code & 63488) === 55296 && offset++);
        }
        return _Utils_Tuple3(newOffset, row, col);
    }, _Parser_findSubString = F5(_Parser_findSubString_fn);
    // CREATE
    var _Regex_never = /.^/;
    var _Regex_fromStringWith_fn = function (options, string) {
        var flags = "g";
        if (options.fA) {
            flags += "m";
        }
        if (options.eM) {
            flags += "i";
        }
        try {
            return $elm$core$Maybe$Just(new RegExp(string, flags));
        }
        catch (error) {
            return $elm$core$Maybe$Nothing;
        }
    }, _Regex_fromStringWith = F2(_Regex_fromStringWith_fn);
    // USE
    var _Regex_contains_fn = function (re, string) {
        return string.match(re) !== null;
    }, _Regex_contains = F2(_Regex_contains_fn);
    var _Regex_findAtMost_fn = function (n, re, str) {
        var out = [];
        var number = 0;
        var string = str;
        var lastIndex = re.lastIndex;
        var prevLastIndex = -1;
        var result;
        while (number++ < n && (result = re.exec(string))) {
            if (prevLastIndex == re.lastIndex)
                break;
            var i = result.length - 1;
            var subs = new Array(i);
            while (i > 0) {
                var submatch = result[i];
                subs[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            out.push($elm$regex$Regex$Match_fn(result[0], result.index, number, _List_fromArray(subs)));
            prevLastIndex = re.lastIndex;
        }
        re.lastIndex = lastIndex;
        return _List_fromArray(out);
    }, _Regex_findAtMost = F3(_Regex_findAtMost_fn);
    var _Regex_replaceAtMost_fn = function (n, re, replacer, string) {
        var count = 0;
        function jsReplacer(match) {
            if (count++ >= n) {
                return match;
            }
            var i = arguments.length - 3;
            var submatches = new Array(i);
            while (i > 0) {
                var submatch = arguments[i];
                submatches[--i] = submatch
                    ? $elm$core$Maybe$Just(submatch)
                    : $elm$core$Maybe$Nothing;
            }
            return replacer($elm$regex$Regex$Match_fn(match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
        }
        return string.replace(re, jsReplacer);
    }, _Regex_replaceAtMost = F4(_Regex_replaceAtMost_fn);
    var _Regex_splitAtMost_fn = function (n, re, str) {
        var string = str;
        var out = [];
        var start = re.lastIndex;
        var restoreLastIndex = re.lastIndex;
        while (n--) {
            var result = re.exec(string);
            if (!result)
                break;
            out.push(string.slice(start, result.index));
            start = re.lastIndex;
        }
        out.push(string.slice(start));
        re.lastIndex = restoreLastIndex;
        return _List_fromArray(out);
    }, _Regex_splitAtMost = F3(_Regex_splitAtMost_fn);
    var _Regex_infinity = Infinity;
    var $elm$core$List$cons = _List_cons;
    var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
    var $elm$core$Array$foldr_fn = function (func, baseCase, _v0) {
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function (node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return _JsArray_foldr_fn(helper, acc, subTree);
            }
            else {
                var values = node.a;
                return _JsArray_foldr_fn(func, acc, values);
            }
        });
        return _JsArray_foldr_fn(helper, _JsArray_foldr_fn(func, baseCase, tail), tree);
    }, $elm$core$Array$foldr = F3($elm$core$Array$foldr_fn);
    var $elm$core$Array$toList = function (array) {
        return $elm$core$Array$foldr_fn($elm$core$List$cons, _List_Nil, array);
    };
    var $elm$core$Dict$foldr_fn = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldr_fn(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr_fn_unwrapped = function (func, acc, t) {
        foldr: while (true) {
            if (t.$ === -2) {
                return acc;
            }
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldr_fn_unwrapped(func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    }, $elm$core$Dict$foldr = F3($elm$core$Dict$foldr_fn);
    var $elm$core$Dict$toList = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, list) {
            return _List_Cons(_Utils_Tuple2(key, value), list);
        }, _List_Nil, dict);
    };
    var $elm$core$Dict$keys = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, keyList) {
            return _List_Cons(key, keyList);
        }, _List_Nil, dict);
    };
    var $elm$core$Set$toList = function (_v0) {
        var dict = _v0;
        return $elm$core$Dict$keys(dict);
    };
    var $elm$core$Basics$EQ = 1;
    var $elm$core$Basics$GT = 2;
    var $elm$core$Basics$LT = 0;
    var $author$project$UI$Model$Nop = function (a) {
        return { $: 14, a: a };
    };
    var $elm$core$Basics$always_fn = function (a, _v0) {
        return a;
    }, $elm$core$Basics$always = F2($elm$core$Basics$always_fn);
    var $elm$core$Result$Err = function (a) {
        return { $: 1, a: a };
    };
    var $elm$json$Json$Decode$Failure_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$json$Json$Decode$Failure = F2($elm$json$Json$Decode$Failure_fn);
    var $elm$json$Json$Decode$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$json$Json$Decode$Field = F2($elm$json$Json$Decode$Field_fn);
    var $elm$json$Json$Decode$Index_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$json$Json$Decode$Index = F2($elm$json$Json$Decode$Index_fn);
    var $elm$core$Result$Ok = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$OneOf = function (a) {
        return { $: 2, a: a };
    };
    var $elm$core$Basics$False = 1;
    var $elm$core$Basics$add = _Basics_add;
    var $elm$core$Maybe$Just = function (a) { return { $: 0, a: a }; };
    var $elm$core$Maybe$Nothing = { $: 1, a: null };
    var $elm$core$String$all = _String_all;
    var $elm$core$Basics$and = _Basics_and;
    var $elm$core$Basics$append = _Utils_append;
    var $elm$json$Json$Encode$encode = _Json_encode;
    var $elm$core$String$fromInt = _String_fromNumber;
    var $elm$core$String$join_fn = function (sep, chunks) {
        return _String_join_fn(sep, _List_toArray(chunks));
    }, $elm$core$String$join = F2($elm$core$String$join_fn);
    var $elm$core$String$split_fn = function (sep, string) {
        return _List_fromArray(_String_split_fn(sep, string));
    }, $elm$core$String$split = F2($elm$core$String$split_fn);
    var $elm$json$Json$Decode$indent = function (str) {
        return $elm$core$String$join_fn("\n    ", $elm$core$String$split_fn("\n", str));
    };
    var $elm$core$List$foldl_fn = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = A2(func, x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl_fn_unwrapped = function (func, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = func(x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    }, $elm$core$List$foldl = F3($elm$core$List$foldl_fn);
    var $elm$core$List$length = function (xs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, i) {
            return i + 1;
        }, 0, xs);
    };
    var $elm$core$List$map2 = _List_map2;
    var $elm$core$Basics$le = _Utils_le;
    var $elm$core$Basics$sub = _Basics_sub;
    var $elm$core$List$rangeHelp_fn = function (lo, hi, list) {
        rangeHelp: while (true) {
            if (_Utils_cmp(lo, hi) < 1) {
                var $temp$lo = lo, $temp$hi = hi - 1, $temp$list = _List_Cons(hi, list);
                lo = $temp$lo;
                hi = $temp$hi;
                list = $temp$list;
                continue rangeHelp;
            }
            else {
                return list;
            }
        }
    }, $elm$core$List$rangeHelp = F3($elm$core$List$rangeHelp_fn);
    var $elm$core$List$range_fn = function (lo, hi) {
        return $elm$core$List$rangeHelp_fn(lo, hi, _List_Nil);
    }, $elm$core$List$range = F2($elm$core$List$range_fn);
    var $elm$core$List$indexedMap_fn = function (f, xs) {
        return _List_map2_fn(f, $elm$core$List$range_fn(0, $elm$core$List$length(xs) - 1), xs);
    }, $elm$core$List$indexedMap = F2($elm$core$List$indexedMap_fn);
    var $elm$core$Char$toCode = _Char_toCode;
    var $elm$core$Char$isLower = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (97 <= code) && (code <= 122);
    };
    var $elm$core$Char$isUpper = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 90) && (65 <= code);
    };
    var $elm$core$Basics$or = _Basics_or;
    var $elm$core$Char$isAlpha = function (_char) {
        return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
    };
    var $elm$core$Char$isDigit = function (_char) {
        var code = $elm$core$Char$toCode(_char);
        return (code <= 57) && (48 <= code);
    };
    var $elm$core$Char$isAlphaNum = function (_char) {
        return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
    };
    var $elm$core$List$reverse = function (list) {
        return $elm$core$List$foldl_fn($elm$core$List$cons, _List_Nil, list);
    };
    var $elm$core$String$uncons = _String_uncons;
    var $elm$json$Json$Decode$errorOneOf_fn = function (i, error) {
        return "\n\n(" + ($elm$core$String$fromInt(i + 1) + (") " + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
    }, $elm$json$Json$Decode$errorOneOf = F2($elm$json$Json$Decode$errorOneOf_fn);
    var $elm$json$Json$Decode$errorToString = function (error) {
        return $elm$json$Json$Decode$errorToStringHelp_fn(error, _List_Nil);
    };
    var $elm$json$Json$Decode$errorToStringHelp_fn = function (error, context) {
        errorToStringHelp: while (true) {
            switch (error.$) {
                case 0:
                    var f = error.a;
                    var err = error.b;
                    var isSimple = function () {
                        var _v1 = $elm$core$String$uncons(f);
                        if (_v1.$ === 1) {
                            return false;
                        }
                        else {
                            var _v2 = _v1.a;
                            var _char = _v2.a;
                            var rest = _v2.b;
                            return $elm$core$Char$isAlpha(_char) && _String_all_fn($elm$core$Char$isAlphaNum, rest);
                        }
                    }();
                    var fieldName = isSimple ? ("." + f) : ("['" + (f + "']"));
                    var $temp$error = err, $temp$context = _List_Cons(fieldName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 1:
                    var i = error.a;
                    var err = error.b;
                    var indexName = "[" + ($elm$core$String$fromInt(i) + "]");
                    var $temp$error = err, $temp$context = _List_Cons(indexName, context);
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                case 2:
                    var errors = error.a;
                    if (!errors.b) {
                        return "Ran into a Json.Decode.oneOf with no possibilities" + function () {
                            if (!context.b) {
                                return "!";
                            }
                            else {
                                return " at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                            }
                        }();
                    }
                    else {
                        if (!errors.b.b) {
                            var err = errors.a;
                            var $temp$error = err, $temp$context = context;
                            error = $temp$error;
                            context = $temp$context;
                            continue errorToStringHelp;
                        }
                        else {
                            var starter = function () {
                                if (!context.b) {
                                    return "Json.Decode.oneOf";
                                }
                                else {
                                    return "The Json.Decode.oneOf at json" + $elm$core$String$join_fn("", $elm$core$List$reverse(context));
                                }
                            }();
                            var introduction = starter + (" failed in the following " + ($elm$core$String$fromInt($elm$core$List$length(errors)) + " ways:"));
                            return $elm$core$String$join_fn("\n\n", _List_Cons(introduction, $elm$core$List$indexedMap_fn($elm$json$Json$Decode$errorOneOf, errors)));
                        }
                    }
                default:
                    var msg = error.a;
                    var json = error.b;
                    var introduction = function () {
                        if (!context.b) {
                            return "Problem with the given value:\n\n";
                        }
                        else {
                            return "Problem with the value at json" + ($elm$core$String$join_fn("", $elm$core$List$reverse(context)) + ":\n\n    ");
                        }
                    }();
                    return introduction + ($elm$json$Json$Decode$indent(_Json_encode_fn(4, json)) + ("\n\n" + msg));
            }
        }
    }, $elm$json$Json$Decode$errorToStringHelp = F2($elm$json$Json$Decode$errorToStringHelp_fn);
    var $elm$core$Array$branchFactor = 32;
    var $elm$core$Array$Array_elm_builtin_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $elm$core$Array$Array_elm_builtin = F4($elm$core$Array$Array_elm_builtin_fn);
    var $elm$core$Elm$JsArray$empty = _JsArray_empty;
    var $elm$core$Basics$ceiling = _Basics_ceiling;
    var $elm$core$Basics$fdiv = _Basics_fdiv;
    var $elm$core$Basics$logBase_fn = function (base, number) {
        return _Basics_log(number) / _Basics_log(base);
    }, $elm$core$Basics$logBase = F2($elm$core$Basics$logBase_fn);
    var $elm$core$Basics$toFloat = _Basics_toFloat;
    var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling($elm$core$Basics$logBase_fn(2, $elm$core$Array$branchFactor));
    var $elm$core$Array$empty = $elm$core$Array$Array_elm_builtin_fn(0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
    var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
    var $elm$core$Array$Leaf = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Basics$apL_fn = function (f, x) {
        return f(x);
    }, $elm$core$Basics$apL = F2($elm$core$Basics$apL_fn);
    var $elm$core$Basics$apR_fn = function (x, f) {
        return f(x);
    }, $elm$core$Basics$apR = F2($elm$core$Basics$apR_fn);
    var $elm$core$Basics$eq = _Utils_equal;
    var $elm$core$Basics$floor = _Basics_floor;
    var $elm$core$Elm$JsArray$length = _JsArray_length;
    var $elm$core$Basics$gt = _Utils_gt;
    var $elm$core$Basics$max_fn = function (x, y) {
        return (_Utils_cmp(x, y) > 0) ? x : y;
    }, $elm$core$Basics$max = F2($elm$core$Basics$max_fn);
    var $elm$core$Basics$mul = _Basics_mul;
    var $elm$core$Array$SubTree = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
    var $elm$core$Array$compressNodes_fn = function (nodes, acc) {
        compressNodes: while (true) {
            var _v0 = _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodes);
            var node = _v0.a;
            var remainingNodes = _v0.b;
            var newAcc = _List_Cons($elm$core$Array$SubTree(node), acc);
            if (!remainingNodes.b) {
                return $elm$core$List$reverse(newAcc);
            }
            else {
                var $temp$nodes = remainingNodes, $temp$acc = newAcc;
                nodes = $temp$nodes;
                acc = $temp$acc;
                continue compressNodes;
            }
        }
    }, $elm$core$Array$compressNodes = F2($elm$core$Array$compressNodes_fn);
    var $elm$core$Tuple$first = function (_v0) {
        var x = _v0.a;
        return x;
    };
    var $elm$core$Array$treeFromBuilder_fn = function (nodeList, nodeListSize) {
        treeFromBuilder: while (true) {
            var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
            if (newNodeSize === 1) {
                return _JsArray_initializeFromList_fn($elm$core$Array$branchFactor, nodeList).a;
            }
            else {
                var $temp$nodeList = $elm$core$Array$compressNodes_fn(nodeList, _List_Nil), $temp$nodeListSize = newNodeSize;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue treeFromBuilder;
            }
        }
    }, $elm$core$Array$treeFromBuilder = F2($elm$core$Array$treeFromBuilder_fn);
    var $elm$core$Array$builderToArray_fn = function (reverseNodeList, builder) {
        if (!builder.o) {
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.q), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.q);
        }
        else {
            var treeLen = builder.o * $elm$core$Array$branchFactor;
            var depth = $elm$core$Basics$floor($elm$core$Basics$logBase_fn($elm$core$Array$branchFactor, treeLen - 1));
            var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.s) : builder.s;
            var tree = $elm$core$Array$treeFromBuilder_fn(correctNodeList, builder.o);
            return $elm$core$Array$Array_elm_builtin_fn($elm$core$Elm$JsArray$length(builder.q) + treeLen, $elm$core$Basics$max_fn(5, depth * $elm$core$Array$shiftStep), tree, builder.q);
        }
    }, $elm$core$Array$builderToArray = F2($elm$core$Array$builderToArray_fn);
    var $elm$core$Basics$idiv = _Basics_idiv;
    var $elm$core$Basics$lt = _Utils_lt;
    var $elm$core$Array$initializeHelp_fn = function (fn, fromIndex, len, nodeList, tail) {
        initializeHelp: while (true) {
            if (fromIndex < 0) {
                return $elm$core$Array$builderToArray_fn(false, { s: nodeList, o: (len / $elm$core$Array$branchFactor) | 0, q: tail });
            }
            else {
                var leaf = $elm$core$Array$Leaf(_JsArray_initialize_fn($elm$core$Array$branchFactor, fromIndex, fn));
                var $temp$fn = fn, $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor, $temp$len = len, $temp$nodeList = _List_Cons(leaf, nodeList), $temp$tail = tail;
                fn = $temp$fn;
                fromIndex = $temp$fromIndex;
                len = $temp$len;
                nodeList = $temp$nodeList;
                tail = $temp$tail;
                continue initializeHelp;
            }
        }
    }, $elm$core$Array$initializeHelp = F5($elm$core$Array$initializeHelp_fn);
    var $elm$core$Basics$remainderBy = _Basics_remainderBy;
    var $elm$core$Array$initialize_fn = function (len, fn) {
        if (len <= 0) {
            return $elm$core$Array$empty;
        }
        else {
            var tailLen = len % $elm$core$Array$branchFactor;
            var tail = _JsArray_initialize_fn(tailLen, len - tailLen, fn);
            var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
            return $elm$core$Array$initializeHelp_fn(fn, initialFromIndex, len, _List_Nil, tail);
        }
    }, $elm$core$Array$initialize = F2($elm$core$Array$initialize_fn);
    var $elm$core$Basics$True = 0;
    var $elm$core$Result$isOk = function (result) {
        if (!result.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$json$Json$Decode$andThen = _Json_andThen;
    var $elm$json$Json$Decode$map = _Json_map1;
    var $elm$json$Json$Decode$map2 = _Json_map2;
    var $elm$json$Json$Decode$succeed = _Json_succeed;
    var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
        switch (handler.$) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $elm$browser$Browser$External = function (a) {
        return { $: 1, a: a };
    };
    var $elm$browser$Browser$Internal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Basics$identity = function (x) {
        return x;
    };
    var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
    var $elm$url$Url$Http = 0;
    var $elm$url$Url$Https = 1;
    var $elm$url$Url$Url_fn = function (protocol, host, port_, path, query, fragment) {
        return { c7: fragment, fe: host, dC: path, fV: port_, fW: protocol, dH: query };
    }, $elm$url$Url$Url = F6($elm$url$Url$Url_fn);
    var $elm$core$String$contains = _String_contains;
    var $elm$core$String$length = _String_length;
    var $elm$core$String$slice = _String_slice;
    var $elm$core$String$dropLeft_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(n, $elm$core$String$length(string), string);
    }, $elm$core$String$dropLeft = F2($elm$core$String$dropLeft_fn);
    var $elm$core$String$indexes = _String_indexes;
    var $elm$core$String$isEmpty = function (string) {
        return string === "";
    };
    var $elm$core$String$left_fn = function (n, string) {
        return (n < 1) ? "" : _String_slice_fn(0, n, string);
    }, $elm$core$String$left = F2($elm$core$String$left_fn);
    var $elm$core$String$toInt = _String_toInt;
    var $elm$url$Url$chompBeforePath_fn = function (protocol, path, params, frag, str) {
        if ($elm$core$String$isEmpty(str) || _String_contains_fn("@", str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn(":", str);
            if (!_v0.b) {
                return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
            }
            else {
                if (!_v0.b.b) {
                    var i = _v0.a;
                    var _v1 = $elm$core$String$toInt($elm$core$String$dropLeft_fn(i + 1, str));
                    if (_v1.$ === 1) {
                        return $elm$core$Maybe$Nothing;
                    }
                    else {
                        var port_ = _v1;
                        return $elm$core$Maybe$Just($elm$url$Url$Url_fn(protocol, $elm$core$String$left_fn(i, str), port_, path, params, frag));
                    }
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }
    }, $elm$url$Url$chompBeforePath = F5($elm$url$Url$chompBeforePath_fn);
    var $elm$url$Url$chompBeforeQuery_fn = function (protocol, params, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("/", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforePath_fn(protocol, "/", params, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforePath_fn(protocol, $elm$core$String$dropLeft_fn(i, str), params, frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeQuery = F4($elm$url$Url$chompBeforeQuery_fn);
    var $elm$url$Url$chompBeforeFragment_fn = function (protocol, frag, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("?", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Nothing, frag, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeQuery_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), frag, $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompBeforeFragment = F3($elm$url$Url$chompBeforeFragment_fn);
    var $elm$url$Url$chompAfterProtocol_fn = function (protocol, str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v0 = _String_indexes_fn("#", str);
            if (!_v0.b) {
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Nothing, str);
            }
            else {
                var i = _v0.a;
                return $elm$url$Url$chompBeforeFragment_fn(protocol, $elm$core$Maybe$Just($elm$core$String$dropLeft_fn(i + 1, str)), $elm$core$String$left_fn(i, str));
            }
        }
    }, $elm$url$Url$chompAfterProtocol = F2($elm$url$Url$chompAfterProtocol_fn);
    var $elm$core$String$startsWith = _String_startsWith;
    var $elm$url$Url$fromString = function (str) {
        return _String_startsWith_fn("http://", str) ? $elm$url$Url$chompAfterProtocol_fn(0, $elm$core$String$dropLeft_fn(7, str)) : (_String_startsWith_fn("https://", str) ? $elm$url$Url$chompAfterProtocol_fn(1, $elm$core$String$dropLeft_fn(8, str)) : $elm$core$Maybe$Nothing);
    };
    var $elm$core$Basics$never = function (_v0) {
        never: while (true) {
            var nvr = _v0;
            var $temp$_v0 = nvr;
            _v0 = $temp$_v0;
            continue never;
        }
    };
    var $elm$core$Task$Perform = $elm$core$Basics$identity;
    var $elm$core$Task$succeed = _Scheduler_succeed;
    var $elm$core$Task$init = $elm$core$Task$succeed(0);
    var $elm$core$List$foldrHelper_fn = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return A2(fn, a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return A2(fn, a, A2(fn, b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn(fn, acc, ctr + 1, r4);
                        return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper_fn_unwrapped = function (fn, acc, ctr, ls) {
        if (!ls.b) {
            return acc;
        }
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) {
                return fn(a, acc);
            }
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) {
                    return fn(a, fn(b, acc));
                }
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) {
                        return fn(a, fn(b, fn(c, acc)));
                    }
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = (ctr > 500) ? $elm$core$List$foldl_fn_unwrapped(fn, acc, $elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper_fn_unwrapped(fn, acc, ctr + 1, r4);
                        return fn(a, fn(b, fn(c, fn(d, res))));
                    }
                }
            }
        }
    }, $elm$core$List$foldrHelper = F4($elm$core$List$foldrHelper_fn);
    var $elm$core$List$foldr_fn = function (fn, acc, ls) {
        return $elm$core$List$foldrHelper_fn(fn, acc, 0, ls);
    }, $elm$core$List$foldr = F3($elm$core$List$foldr_fn);
    var $elm$core$List$map_fn = function (f, xs) {
        return $elm$core$List$foldr_fn(F2(function (x, acc) {
            return _List_Cons(f(x), acc);
        }), _List_Nil, xs);
    }, $elm$core$List$map = F2($elm$core$List$map_fn);
    var $elm$core$Task$andThen = _Scheduler_andThen;
    var $elm$core$Task$map_fn = function (func, taskA) {
        return _Scheduler_andThen_fn(function (a) {
            return $elm$core$Task$succeed(func(a));
        }, taskA);
    }, $elm$core$Task$map = F2($elm$core$Task$map_fn);
    var $elm$core$Task$map2_fn = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(A2(func, a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2_fn_unwrapped = function (func, taskA, taskB) {
        return _Scheduler_andThen_fn(function (a) {
            return _Scheduler_andThen_fn(function (b) {
                return $elm$core$Task$succeed(func(a, b));
            }, taskB);
        }, taskA);
    }, $elm$core$Task$map2 = F3($elm$core$Task$map2_fn);
    var $elm$core$Task$sequence = function (tasks) {
        return $elm$core$List$foldr_fn($elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
    };
    var $elm$core$Platform$sendToApp = _Platform_sendToApp;
    var $elm$core$Task$spawnCmd_fn = function (router, _v0) {
        var task = _v0;
        return _Scheduler_spawn(_Scheduler_andThen_fn($elm$core$Platform$sendToApp(router), task));
    }, $elm$core$Task$spawnCmd = F2($elm$core$Task$spawnCmd_fn);
    var $elm$core$Task$onEffects_fn = function (router, commands, state) {
        return $elm$core$Task$map_fn(function (_v0) {
            return 0;
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Task$spawnCmd(router), commands)));
    }, $elm$core$Task$onEffects = F3($elm$core$Task$onEffects_fn);
    var $elm$core$Task$onSelfMsg_fn = function (_v0, _v1, _v2) {
        return $elm$core$Task$succeed(0);
    }, $elm$core$Task$onSelfMsg = F3($elm$core$Task$onSelfMsg_fn);
    var $elm$core$Task$cmdMap_fn = function (tagger, _v0) {
        var task = _v0;
        return $elm$core$Task$map_fn(tagger, task);
    }, $elm$core$Task$cmdMap = F2($elm$core$Task$cmdMap_fn);
    _Platform_effectManagers["Task"] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
    var $elm$core$Task$command = _Platform_leaf("Task");
    var $elm$core$Task$perform_fn = function (toMessage, task) {
        return $elm$core$Task$command($elm$core$Task$map_fn(toMessage, task));
    }, $elm$core$Task$perform = F2($elm$core$Task$perform_fn);
    var $elm$browser$Browser$application = _Browser_application;
    var $elm$json$Json$Decode$bool = _Json_decodeBool;
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$Attribute = $elm$core$Basics$identity;
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr = function (a) {
        return function (_v0) {
            return a;
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$Colored_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$Colored = F3($mdgriffith$elm_ui$Internal$Model$Colored_fn);
    var $mdgriffith$elm_ui$Internal$Model$StyleClass_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$StyleClass = F2($mdgriffith$elm_ui$Internal$Model$StyleClass_fn);
    var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
    var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
        return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
    };
    var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
    var $elm$core$Basics$round = _Basics_round;
    var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
        return $elm$core$String$fromInt($elm$core$Basics$round(x * 255));
    };
    var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
        var red = _v0.a;
        var green = _v0.b;
        var blue = _v0.c;
        var alpha = _v0.d;
        return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
    };
    var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bg-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr), "background-color", clr));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Background$color = function (clr) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr($mdgriffith$elm_ui$Element$Background$color(clr));
    };
    var $mdgriffith$elm_ui$Internal$Model$Rgba_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $mdgriffith$elm_ui$Internal$Model$Rgba = F4($mdgriffith$elm_ui$Internal$Model$Rgba_fn);
    var $mdgriffith$elm_ui$Element$rgb_fn = function (r, g, b) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(r, g, b, 1);
    }, $mdgriffith$elm_ui$Element$rgb = F3($mdgriffith$elm_ui$Element$rgb_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$rgb = $mdgriffith$elm_ui$Element$rgb;
    var $mdgriffith$elm_ui$Element$rgb255_fn = function (red, green, blue) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(red / 255, green / 255, blue / 255, 1);
    }, $mdgriffith$elm_ui$Element$rgb255 = F3($mdgriffith$elm_ui$Element$rgb255_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$rgb255 = $mdgriffith$elm_ui$Element$rgb255;
    var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
    var $miniBill$elm_ui_with_context$Element$WithContext$rgba = $mdgriffith$elm_ui$Element$rgba;
    var $author$project$UI$Theme$colors = {
        aQ: $mdgriffith$elm_ui$Element$rgb_fn(0.9, 0.9, 0.9),
        e1: $mdgriffith$elm_ui$Element$rgb_fn(0.9, 0, 0),
        b4: $mdgriffith$elm_ui$Element$rgb_fn(0.1, 0.1, 0.1),
        dh: $mdgriffith$elm_ui$Element$rgb_fn(0.9, 0.9, 0.9),
        fx: $mdgriffith$elm_ui$Internal$Model$Rgba_fn(0.5, 0.5, 0.5, 0.5),
        dU: $mdgriffith$elm_ui$Element$rgb255_fn(255, 215, 0),
        d9: $mdgriffith$elm_ui$Element$rgb_fn(0.8, 0.8, 0.8),
        gF: $mdgriffith$elm_ui$Element$rgb_fn(0.8, 0.8, 0)
    };
    var $elm$json$Json$Decode$field = _Json_decodeField;
    var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
    var $miniBill$elm_ui_with_context$Element$WithContext$fill = $mdgriffith$elm_ui$Element$fill;
    var $author$project$UI$Theme$fontSize = 20;
    var $author$project$Document$CodeRow = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$UI$L10N$En = 0;
    var $author$project$Document$Id = $elm$core$Basics$identity;
    var $author$project$UI$L10N$It = 1;
    var $author$project$API$Google$Missing = { $: 0 };
    var $miniBill$elm_ui_with_context$Element$WithContext$Phone = 0;
    var $author$project$API$Google$Present = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$UI$Model$Resized = function (a) {
        return { $: 5, a: a };
    };
    var $elm$core$Maybe$andThen_fn = function (callback, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return callback(value);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$andThen = F2($elm$core$Maybe$andThen_fn);
    var $elm$core$Basics$composeR_fn = function (f, g, x) {
        return g(f(x));
    }, $elm$core$Basics$composeR = F3($elm$core$Basics$composeR_fn);
    var $elm$core$String$concat = function (strings) {
        return $elm$core$String$join_fn("", strings);
    };
    var $elm$json$Json$Decode$decodeValue = _Json_run;
    var $miniBill$elm_codec$Codec$decoder = function (_v0) {
        var m = _v0;
        return m.eX;
    };
    var $miniBill$elm_codec$Codec$decodeValue = function (codec) {
        return $elm$json$Json$Decode$decodeValue($miniBill$elm_codec$Codec$decoder(codec));
    };
    var $author$project$UI$defaultDocument = _List_fromArray(["{{plotsin, plot(x<y), plot(x\u00B2+y\u00B2=3)},{[zx+iy]plotexp(1/z), plot(x\u00B2+y\u00B2+z\u00B2=3), plot{sinx,x,-sinhx,-x,x\u00B2+y\u00B2=3,cosx,sinhx,-cosx,-sinx,x\u00B2+y\u00B2=4}}, {plot(r=3/(t+1)), plot{sin(3t),cos(5t)}, plot((x\u00B2-y\u00B2+1,2xy)}}", "solve(x+2(x-(x\u00B2-6)+1),x", "plot(sin\u00B2x+sin\u00B2y+sin\u00B2z = pw(z>1,-1,.5sinsqrt(x\u00B2+y\u00B2+z\u00B2", "simplifydet{{a,b,c},{0,1,0},{1,2,3", "plot{z=sin(x\u00B2+y\u00B2),x\u00B2+y\u00B2+(z-2)\u00B2 = 3}", "stepsimplify(sin(pi/2-x))", "[zx+iy]{plot(z\u00B3-1),plotabs(z\u00B3-1),plotarg(z\u00B3-1)}", ""]);
    var $miniBill$elm_codec$Codec$Codec = $elm$core$Basics$identity;
    var $elm$json$Json$Encode$object = function (pairs) {
        return _Json_wrap($elm$core$List$foldl_fn_unwrapped(function (_v0, obj) {
            var k = _v0.a;
            var v = _v0.b;
            return _Json_addField_fn(k, v, obj);
        }, _Json_emptyObject(0), pairs));
    };
    var $miniBill$elm_codec$Codec$buildObject = function (_v0) {
        var om = _v0;
        return {
            eX: om.eX,
            g: function (v) {
                return $elm$json$Json$Encode$object(om.g(v));
            }
        };
    };
    var $miniBill$elm_codec$Codec$ObjectCodec = $elm$core$Basics$identity;
    var $miniBill$elm_codec$Codec$encoder = function (_v0) {
        var m = _v0;
        return m.g;
    };
    var $miniBill$elm_codec$Codec$field_fn = function (name, getter, codec, _v0) {
        var ocodec = _v0;
        return {
            eX: _Json_map2_fn(F2(function (f, x) {
                return f(x);
            }), ocodec.eX, _Json_decodeField_fn(name, $miniBill$elm_codec$Codec$decoder(codec))),
            g: function (v) {
                return _List_Cons(_Utils_Tuple2(name, A2($miniBill$elm_codec$Codec$encoder, codec, getter(v))), ocodec.g(v));
            }
        };
    }, $miniBill$elm_codec$Codec$field = F4($miniBill$elm_codec$Codec$field_fn);
    var $author$project$API$Google$FileId = $elm$core$Basics$identity;
    var $miniBill$elm_codec$Codec$map_fn = function (go, back, codec) {
        return {
            eX: _Json_map1_fn(go, $miniBill$elm_codec$Codec$decoder(codec)),
            g: function (v) {
                return A2($miniBill$elm_codec$Codec$encoder, codec, back(v));
            }
        };
    }, $miniBill$elm_codec$Codec$map = F3($miniBill$elm_codec$Codec$map_fn);
    var $miniBill$elm_codec$Codec$build_fn = function (encoder_, decoder_) {
        return { eX: decoder_, g: encoder_ };
    }, $miniBill$elm_codec$Codec$build = F2($miniBill$elm_codec$Codec$build_fn);
    var $elm$json$Json$Decode$string = _Json_decodeString;
    var $elm$json$Json$Encode$string = _Json_wrap;
    var $miniBill$elm_codec$Codec$string = $miniBill$elm_codec$Codec$build_fn($elm$json$Json$Encode$string, $elm$json$Json$Decode$string);
    var $author$project$API$Google$fileIdCodec = $miniBill$elm_codec$Codec$map_fn($elm$core$Basics$identity, function (_v0) {
        var i = _v0;
        return i;
    }, $miniBill$elm_codec$Codec$string);
    var $elm$json$Json$Decode$oneOf = _Json_oneOf;
    var $elm$json$Json$Decode$maybe = function (decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            _Json_map1_fn($elm$core$Maybe$Just, decoder),
            $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
        ]));
    };
    var $miniBill$elm_codec$Codec$maybeField_fn = function (name, getter, codec, _v0) {
        var ocodec = _v0;
        return {
            eX: _Json_map2_fn(F2(function (f, x) {
                return f(x);
            }), ocodec.eX, $elm$json$Json$Decode$maybe(_Json_decodeField_fn(name, $miniBill$elm_codec$Codec$decoder(codec)))),
            g: function (v) {
                var _v1 = getter(v);
                if (!_v1.$) {
                    var present = _v1.a;
                    return _List_Cons(_Utils_Tuple2(name, A2($miniBill$elm_codec$Codec$encoder, codec, present)), ocodec.g(v));
                }
                else {
                    return ocodec.g(v);
                }
            }
        };
    }, $miniBill$elm_codec$Codec$maybeField = F4($miniBill$elm_codec$Codec$maybeField_fn);
    var $miniBill$elm_codec$Codec$object = function (ctor) {
        return {
            eX: $elm$json$Json$Decode$succeed(ctor),
            g: function (_v0) {
                return _List_Nil;
            }
        };
    };
    var $author$project$Maybe$MyExtra$withDefaultMaybe_fn = function (r, l) {
        if (!l.$) {
            return l;
        }
        else {
            return r;
        }
    }, $author$project$Maybe$MyExtra$withDefaultMaybe = F2($author$project$Maybe$MyExtra$withDefaultMaybe_fn);
    var $author$project$Document$combineMetadataWithErrors_fn = function (l, r) {
        return {
            ac: _Utils_ap(l.ac, r.ac),
            n: $author$project$Maybe$MyExtra$withDefaultMaybe_fn(r.n, l.n)
        };
    }, $author$project$Document$combineMetadataWithErrors = F2($author$project$Document$combineMetadataWithErrors_fn);
    var $author$project$Document$emptyRow = {
        G: $author$project$Document$CodeRow(_List_Nil),
        al: true,
        r: ""
    };
    var $elm$core$Basics$composeL_fn = function (g, f, x) {
        return g(f(x));
    }, $elm$core$Basics$composeL = F3($elm$core$Basics$composeL_fn);
    var $elm$core$List$filter_fn = function (isGood, list) {
        return $elm$core$List$foldr_fn(F2(function (x, xs) {
            return isGood(x) ? _List_Cons(x, xs) : xs;
        }), _List_Nil, list);
    }, $elm$core$List$filter = F2($elm$core$List$filter_fn);
    var $elm$core$Basics$not = _Basics_not;
    var $elm_community$list_extra$List$Extra$filterNot_fn = function (pred, list) {
        return $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred), list);
    }, $elm_community$list_extra$List$Extra$filterNot = F2($elm_community$list_extra$List$Extra$filterNot_fn);
    var $elm$core$Tuple$mapSecond_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(x, func(y));
    }, $elm$core$Tuple$mapSecond = F2($elm$core$Tuple$mapSecond_fn);
    var $author$project$List$MyExtra$Left = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Document$MarkdownRow = { $: 1 };
    var $author$project$List$MyExtra$Right = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$List$MyExtra$categorize = function (f) {
        return A2($elm$core$List$foldr, F2(function (e, _v0) {
            var la = _v0.a;
            var ra = _v0.b;
            var _v1 = f(e);
            if (!_v1.$) {
                var l = _v1.a;
                return _Utils_Tuple2(_List_Cons(l, la), ra);
            }
            else {
                var r = _v1.a;
                return _Utils_Tuple2(la, _List_Cons(r, ra));
            }
        }), _Utils_Tuple2(_List_Nil, _List_Nil));
    };
    var $author$project$List$MyExtra$groupOneWith_fn = function (step, list) {
        return function (_v3) {
            var last = _v3.a;
            var acc = _v3.b;
            if (!last.$) {
                var l = last.a;
                return _List_Cons(l, acc);
            }
            else {
                return acc;
            }
        }($elm$core$List$foldr_fn(F2(function (e, _v0) {
            var last = _v0.a;
            var acc = _v0.b;
            if (last.$ === 1) {
                return _Utils_Tuple2($elm$core$Maybe$Just(e), acc);
            }
            else {
                var lst = last.a;
                var _v2 = A2(step, e, lst);
                if (!_v2.$) {
                    var c = _v2.a;
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Cons(c, acc));
                }
                else {
                    return _Utils_Tuple2($elm$core$Maybe$Just(e), _List_Cons(lst, acc));
                }
            }
        }), _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil), list));
    }, $author$project$List$MyExtra$groupOneWith_fn_unwrapped = function (step, list) {
        return function (_v3) {
            var last = _v3.a;
            var acc = _v3.b;
            if (!last.$) {
                var l = last.a;
                return _List_Cons(l, acc);
            }
            else {
                return acc;
            }
        }($elm$core$List$foldr_fn(F2(function (e, _v0) {
            var last = _v0.a;
            var acc = _v0.b;
            if (last.$ === 1) {
                return _Utils_Tuple2($elm$core$Maybe$Just(e), acc);
            }
            else {
                var lst = last.a;
                var _v2 = step(e, lst);
                if (!_v2.$) {
                    var c = _v2.a;
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Cons(c, acc));
                }
                else {
                    return _Utils_Tuple2($elm$core$Maybe$Just(e), _List_Cons(lst, acc));
                }
            }
        }), _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil), list));
    }, $author$project$List$MyExtra$groupOneWith = F2($author$project$List$MyExtra$groupOneWith_fn);
    var $author$project$Document$MetadataRow = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Document$NormalRow = function (a) {
        return { $: 0, a: a };
    };
    var $elm$core$Basics$negate = function (n) {
        return -n;
    };
    var $elm$core$String$dropRight_fn = function (n, string) {
        return (n < 1) ? string : _String_slice_fn(0, -n, string);
    }, $elm$core$String$dropRight = F2($elm$core$String$dropRight_fn);
    var $author$project$API$Google$googleMetadataKey = "GOOGLE_ID = ";
    var $author$project$API$Google$fileIdFromMetadata = function (metadata) {
        return _String_startsWith_fn($author$project$API$Google$googleMetadataKey, metadata) ? $elm$core$Maybe$Just($elm$core$String$dropLeft_fn($elm$core$String$length($author$project$API$Google$googleMetadataKey), metadata)) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Document$metadataMarker = "[//]: # (NUPLOT INTERNAL DATA -- ";
    var $elm$core$String$trim = _String_trim;
    var $author$project$Document$parseFragment = function (f) {
        if (_String_startsWith_fn(">", f)) {
            return $author$project$Document$NormalRow({
                G: $author$project$Document$CodeRow(_List_Nil),
                al: false,
                r: $elm$core$String$trim($elm$core$String$dropLeft_fn(1, f))
            });
        }
        else {
            if (_String_startsWith_fn($author$project$Document$metadataMarker, f)) {
                var extracted = $elm$core$String$dropRight_fn(1, $elm$core$String$dropLeft_fn($elm$core$String$length($author$project$Document$metadataMarker), f));
                var _v0 = $author$project$API$Google$fileIdFromMetadata(extracted);
                if (!_v0.$) {
                    var gid = _v0.a;
                    return $author$project$Document$MetadataRow({
                        ac: _List_Nil,
                        n: $elm$core$Maybe$Just(gid)
                    });
                }
                else {
                    return $author$project$Document$MetadataRow({
                        ac: _List_fromArray([
                            { e0: "Unrecognized metadata: " + extracted, fs: "Metadati non riconosciuti: " + extracted }
                        ]),
                        n: $elm$core$Maybe$Nothing
                    });
                }
            }
            else {
                return $author$project$Document$NormalRow({ G: $author$project$Document$MarkdownRow, al: false, r: f });
            }
        }
    };
    var $author$project$Document$parseRow = function (row) {
        var combine = F2(function (curr, last) {
            var _v1 = _Utils_Tuple2(curr.G, last.G);
            _v1$2: while (true) {
                if (_v1.a.$ === 1) {
                    if (_v1.b.$ === 1) {
                        var _v2 = _v1.a;
                        var _v3 = _v1.b;
                        return $elm$core$Maybe$Just({ G: $author$project$Document$MarkdownRow, al: false, r: curr.r + ("\n" + last.r) });
                    }
                    else {
                        break _v1$2;
                    }
                }
                else {
                    if (!_v1.b.$) {
                        return $elm$core$Maybe$Just({
                            G: $author$project$Document$CodeRow(_List_Nil),
                            al: false,
                            r: curr.r + ("\n" + last.r)
                        });
                    }
                    else {
                        break _v1$2;
                    }
                }
            }
            return $elm$core$Maybe$Nothing;
        });
        return $elm$core$Tuple$mapSecond_fn($author$project$List$MyExtra$groupOneWith(combine), A2($author$project$List$MyExtra$categorize, function (f) {
            if (f.$ === 1) {
                var m = f.a;
                return $author$project$List$MyExtra$Left(m);
            }
            else {
                var n = f.a;
                return $author$project$List$MyExtra$Right(n);
            }
        }, $elm$core$List$map_fn($author$project$Document$parseFragment, $elm$core$String$split_fn("\n", row))));
    };
    var $author$project$Document$fromFile_fn = function (name, file) {
        return function (_v2) {
            var metadataWithErrorsList = _v2.a;
            var rows = _v2.b;
            var _v3 = $elm$core$List$foldr_fn($author$project$Document$combineMetadataWithErrors, { ac: _List_Nil, n: $elm$core$Maybe$Nothing }, metadataWithErrorsList);
            var errors = _v3.ac;
            var googleId = _v3.n;
            return {
                c0: {
                    n: googleId,
                    dw: $author$project$Maybe$MyExtra$withDefaultMaybe_fn(name, name),
                    M: _Utils_ap(rows, _List_fromArray([$author$project$Document$emptyRow]))
                },
                ac: errors
            };
        }($elm$core$Tuple$mapSecond_fn($elm_community$list_extra$List$Extra$filterNot(A2($elm$core$Basics$composeR, function ($) {
            return $.r;
        }, $elm$core$String$isEmpty)), $elm$core$List$foldr_fn(F2(function (_v0, _v1) {
            var m = _v0.a;
            var r = _v0.b;
            var ma = _v1.a;
            var ra = _v1.b;
            return _Utils_Tuple2(_Utils_ap(m, ma), _Utils_ap(r, ra));
        }), _Utils_Tuple2(_List_Nil, _List_Nil), $elm$core$List$map_fn($author$project$Document$parseRow, $elm$core$String$split_fn("\n\n", file)))));
    }, $author$project$Document$fromFile = F2($author$project$Document$fromFile_fn);
    var $miniBill$elm_codec$Codec$composite_fn = function (enc, dec, _v0) {
        var codec = _v0;
        return {
            eX: dec(codec.eX),
            g: enc(codec.g)
        };
    }, $miniBill$elm_codec$Codec$composite = F3($miniBill$elm_codec$Codec$composite_fn);
    var $elm$json$Json$Decode$list = _Json_decodeList;
    var $elm$json$Json$Encode$list_fn = function (func, entries) {
        return _Json_wrap($elm$core$List$foldl_fn(_Json_addEntry(func), _Json_emptyArray(0), entries));
    }, $elm$json$Json$Encode$list = F2($elm$json$Json$Encode$list_fn);
    var $miniBill$elm_codec$Codec$list_a0 = $elm$json$Json$Encode$list, $miniBill$elm_codec$Codec$list_a1 = $elm$json$Json$Decode$list, $miniBill$elm_codec$Codec$list = A2($miniBill$elm_codec$Codec$composite, $miniBill$elm_codec$Codec$list_a0, $miniBill$elm_codec$Codec$list_a1);
    var $miniBill$elm_codec$Codec$oneOf_fn = function (main, alts) {
        return {
            eX: $elm$json$Json$Decode$oneOf(_List_Cons($miniBill$elm_codec$Codec$decoder(main), $elm$core$List$map_fn($miniBill$elm_codec$Codec$decoder, alts))),
            g: $miniBill$elm_codec$Codec$encoder(main)
        };
    }, $miniBill$elm_codec$Codec$oneOf = F2($miniBill$elm_codec$Codec$oneOf_fn);
    var $author$project$Document$rowCodec = $miniBill$elm_codec$Codec$map_fn(function (i) {
        return _String_startsWith_fn(">", i) ? {
            G: $author$project$Document$CodeRow(_List_Nil),
            al: false,
            r: $elm$core$String$trim($elm$core$String$dropLeft_fn(1, i))
        } : { G: $author$project$Document$MarkdownRow, al: false, r: i };
    }, function (r) {
        var _v0 = r.G;
        if (_v0.$ === 1) {
            return r.r;
        }
        else {
            return "> " + r.r;
        }
    }, $miniBill$elm_codec$Codec$string);
    var $author$project$API$Google$fileIdToMetadata = function (_v0) {
        var fid = _v0;
        return _Utils_ap($author$project$API$Google$googleMetadataKey, fid);
    };
    var $author$project$Document$toFile = function (_v0) {
        var rows = _v0.M;
        var googleId = _v0.n;
        var rowToString = function (_v3) {
            var input = _v3.r;
            var data = _v3.G;
            if (data.$ === 1) {
                return input;
            }
            else {
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn(function (l) {
                    return "> " + l;
                }, $elm$core$String$split_fn("\n", input)));
            }
        };
        return $elm$core$String$join_fn("\n\n", function (l) {
            if (googleId.$ === 1) {
                return l;
            }
            else {
                var gid = googleId.a;
                return _Utils_ap(l, _List_fromArray([
                    $author$project$Document$metadataMarker + ($author$project$API$Google$fileIdToMetadata(gid) + ")")
                ]));
            }
        }($elm$core$List$map_fn(rowToString, $elm_community$list_extra$List$Extra$filterNot_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.r;
        }, $elm$core$String$isEmpty), rows))));
    };
    var $author$project$Document$rowsCodec = function () {
        var v1Codec = $miniBill$elm_codec$Codec$map_fn(A2($elm$core$Basics$composeR, $author$project$Document$fromFile($elm$core$Maybe$Nothing), A2($elm$core$Basics$composeR, function ($) {
            return $.c0;
        }, function ($) {
            return $.M;
        })), function (r) {
            return $author$project$Document$toFile({ n: $elm$core$Maybe$Nothing, dw: $elm$core$Maybe$Nothing, M: r });
        }, $miniBill$elm_codec$Codec$string);
        var v0Codec = $miniBill$elm_codec$Codec$composite_fn($miniBill$elm_codec$Codec$list_a0, $miniBill$elm_codec$Codec$list_a1, $author$project$Document$rowCodec);
        return $miniBill$elm_codec$Codec$oneOf_fn(v1Codec, _List_fromArray([v0Codec]));
    }();
    var $author$project$Document$codec = function () {
        var ctor = F3(function (r, n, gid) {
            return { n: gid, dw: n, M: r };
        });
        return $miniBill$elm_codec$Codec$buildObject($miniBill$elm_codec$Codec$maybeField_fn("googleId", function ($) {
            return $.n;
        }, $author$project$API$Google$fileIdCodec, $miniBill$elm_codec$Codec$maybeField_fn("name", function ($) {
            return $.dw;
        }, $miniBill$elm_codec$Codec$string, $miniBill$elm_codec$Codec$field_fn("rows", function ($) {
            return $.M;
        }, $author$project$Document$rowsCodec, $miniBill$elm_codec$Codec$object(ctor)))));
    }();
    var $author$project$Zipper$Zipper = $elm$core$Basics$identity;
    var $author$project$Zipper$codec = function (inner) {
        return $miniBill$elm_codec$Codec$map_fn($elm$core$Basics$identity, function (_v0) {
            var z = _v0;
            return z;
        }, $miniBill$elm_codec$Codec$buildObject($miniBill$elm_codec$Codec$field_fn("after", function ($) {
            return $.d;
        }, $miniBill$elm_codec$Codec$composite_fn($miniBill$elm_codec$Codec$list_a0, $miniBill$elm_codec$Codec$list_a1, inner), $miniBill$elm_codec$Codec$field_fn("curr", function ($) {
            return $.h;
        }, inner, $miniBill$elm_codec$Codec$field_fn("before", function ($) {
            return $.e;
        }, $miniBill$elm_codec$Codec$composite_fn($miniBill$elm_codec$Codec$list_a0, $miniBill$elm_codec$Codec$list_a1, inner), $miniBill$elm_codec$Codec$object(F3(function (b, c, a) {
            return { d: a, e: b, h: c };
        })))))));
    };
    var $elm$core$List$head = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(x);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$UI$Model$documentsCodec = $miniBill$elm_codec$Codec$map_fn($elm$core$List$head, function (c) {
        if (c.$ === 1) {
            return _List_Nil;
        }
        else {
            var v = c.a;
            return _List_fromArray([v]);
        }
    }, $miniBill$elm_codec$Codec$composite_fn($miniBill$elm_codec$Codec$list_a0, $miniBill$elm_codec$Codec$list_a1, $author$project$Zipper$codec($author$project$Document$codec)));
    var $elm$core$List$maybeCons_fn = function (f, mx, xs) {
        var _v0 = f(mx);
        if (!_v0.$) {
            var x = _v0.a;
            return _List_Cons(x, xs);
        }
        else {
            return xs;
        }
    }, $elm$core$List$maybeCons = F3($elm$core$List$maybeCons_fn);
    var $elm$core$List$filterMap_fn = function (f, xs) {
        return $elm$core$List$foldr_fn($elm$core$List$maybeCons(f), _List_Nil, xs);
    }, $elm$core$List$filterMap = F2($elm$core$List$filterMap_fn);
    var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
    var $elm$url$Url$Parser$State_fn = function (visited, unvisited, params, frag, value) {
        return { av: frag, aB: params, as: unvisited, S: value, aE: visited };
    }, $elm$url$Url$Parser$State = F5($elm$url$Url$Parser$State_fn);
    var $elm$url$Url$Parser$fragment = function (toFrag) {
        return function (_v0) {
            var visited = _v0.aE;
            var unvisited = _v0.as;
            var params = _v0.aB;
            var frag = _v0.av;
            var value = _v0.S;
            return _List_fromArray([
                $elm$url$Url$Parser$State_fn(visited, unvisited, params, frag, value(toFrag(frag)))
            ]);
        };
    };
    var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
    var $elm$core$Maybe$map_fn = function (f, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return $elm$core$Maybe$Just(f(value));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $elm$core$Maybe$map = F2($elm$core$Maybe$map_fn);
    var $author$project$Zipper$map_fn = function (f, _v0) {
        var before = _v0.e;
        var curr = _v0.h;
        var after = _v0.d;
        return {
            d: $elm$core$List$indexedMap_fn(function (i) {
                return f(i + 1);
            }, after),
            e: $elm$core$List$indexedMap_fn(function (i) {
                return f((-i) - 1);
            }, before),
            h: A2(f, 0, curr)
        };
    }, $author$project$Zipper$map = F2($author$project$Zipper$map_fn);
    var $elm$core$List$maximum = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just($elm$core$List$foldl_fn($elm$core$Basics$max, x, xs));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$url$Url$Parser$getFirstMatch = function (states) {
        getFirstMatch: while (true) {
            if (!states.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var state = states.a;
                var rest = states.b;
                var _v1 = state.as;
                if (!_v1.b) {
                    return $elm$core$Maybe$Just(state.S);
                }
                else {
                    if ((_v1.a === "") && (!_v1.b.b)) {
                        return $elm$core$Maybe$Just(state.S);
                    }
                    else {
                        var $temp$states = rest;
                        states = $temp$states;
                        continue getFirstMatch;
                    }
                }
            }
        }
    };
    var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
        if (!segments.b) {
            return _List_Nil;
        }
        else {
            if ((segments.a === "") && (!segments.b.b)) {
                return _List_Nil;
            }
            else {
                var segment = segments.a;
                var rest = segments.b;
                return _List_Cons(segment, $elm$url$Url$Parser$removeFinalEmpty(rest));
            }
        }
    };
    var $elm$url$Url$Parser$preparePath = function (path) {
        var _v0 = $elm$core$String$split_fn("/", path);
        if (_v0.b && (_v0.a === "")) {
            var segments = _v0.b;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
        else {
            var segments = _v0;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
    };
    var $elm$url$Url$Parser$addToParametersHelp_fn = function (value, maybeList) {
        if (maybeList.$ === 1) {
            return $elm$core$Maybe$Just(_List_fromArray([value]));
        }
        else {
            var list = maybeList.a;
            return $elm$core$Maybe$Just(_List_Cons(value, list));
        }
    }, $elm$url$Url$Parser$addToParametersHelp = F2($elm$url$Url$Parser$addToParametersHelp_fn);
    var $elm$url$Url$percentDecode = _Url_percentDecode;
    var $elm$core$Basics$compare = _Utils_compare;
    var $elm$core$Dict$get_fn = function (targetKey, dict) {
        get: while (true) {
            if (dict.$ === -2) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var _v1 = _Utils_compare_fn(targetKey, key);
                switch (_v1) {
                    case 0:
                        var $temp$targetKey = targetKey, $temp$dict = left;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                    case 1:
                        return $elm$core$Maybe$Just(value);
                    default:
                        var $temp$targetKey = targetKey, $temp$dict = right;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                }
            }
        }
    }, $elm$core$Dict$get = F2($elm$core$Dict$get_fn);
    var $elm$core$Dict$Black = 1;
    var $elm$core$Dict$RBNode_elm_builtin_fn = function (a, b, c, d, e) {
        return { $: -1, a: a, b: b, c: c, d: d, e: e };
    }, $elm$core$Dict$RBNode_elm_builtin = F5($elm$core$Dict$RBNode_elm_builtin_fn);
    var $elm$core$Dict$RBEmpty_elm_builtin = { $: -2 };
    var $elm$core$Dict$Red = 0;
    var $elm$core$Dict$balance_fn = function (color, key, value, left, right) {
        if ((right.$ === -1) && (!right.a)) {
            var _v1 = right.a;
            var rK = right.b;
            var rV = right.c;
            var rLeft = right.d;
            var rRight = right.e;
            if ((left.$ === -1) && (!left.a)) {
                var _v3 = left.a;
                var lK = left.b;
                var lV = left.c;
                var lLeft = left.d;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBNode_elm_builtin_fn(1, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rLeft, rRight));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, rK, rV, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, left, rLeft), rRight);
            }
        }
        else {
            if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
                var _v5 = left.a;
                var lK = left.b;
                var lV = left.c;
                var _v6 = left.d;
                var _v7 = _v6.a;
                var llK = _v6.b;
                var llV = _v6.c;
                var llLeft = _v6.d;
                var llRight = _v6.e;
                var lRight = left.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, lRight, right));
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, left, right);
            }
        }
    }, $elm$core$Dict$balance = F5($elm$core$Dict$balance_fn);
    var $elm$core$Dict$insertHelp_fn = function (key, value, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
        }
        else {
            var nColor = dict.a;
            var nKey = dict.b;
            var nValue = dict.c;
            var nLeft = dict.d;
            var nRight = dict.e;
            var _v1 = _Utils_compare_fn(key, nKey);
            switch (_v1) {
                case 0:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$insertHelp_fn(key, value, nLeft), nRight);
                case 1:
                    return $elm$core$Dict$RBNode_elm_builtin_fn(nColor, nKey, value, nLeft, nRight);
                default:
                    return $elm$core$Dict$balance_fn(nColor, nKey, nValue, nLeft, $elm$core$Dict$insertHelp_fn(key, value, nRight));
            }
        }
    }, $elm$core$Dict$insertHelp = F3($elm$core$Dict$insertHelp_fn);
    var $elm$core$Dict$insert_fn = function (key, value, dict) {
        var _v0 = $elm$core$Dict$insertHelp_fn(key, value, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$insert = F3($elm$core$Dict$insert_fn);
    var $elm$core$Dict$getMin = function (dict) {
        getMin: while (true) {
            if ((dict.$ === -1) && (dict.d.$ === -1)) {
                var left = dict.d;
                var $temp$dict = left;
                dict = $temp$dict;
                continue getMin;
            }
            else {
                return dict;
            }
        }
    };
    var $elm$core$Dict$moveRedLeft = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var lLeft = _v1.d;
                var lRight = _v1.e;
                var _v2 = dict.e;
                var rClr = _v2.a;
                var rK = _v2.b;
                var rV = _v2.c;
                var rLeft = _v2.d;
                var _v3 = rLeft.a;
                var rlK = rLeft.b;
                var rlV = rLeft.c;
                var rlL = rLeft.d;
                var rlR = rLeft.e;
                var rRight = _v2.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, rlK, rlV, $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), rlL), $elm$core$Dict$RBNode_elm_builtin_fn(1, rK, rV, rlR, rRight));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v4 = dict.d;
                var lClr = _v4.a;
                var lK = _v4.b;
                var lV = _v4.c;
                var lLeft = _v4.d;
                var lRight = _v4.e;
                var _v5 = dict.e;
                var rClr = _v5.a;
                var rK = _v5.b;
                var rV = _v5.c;
                var rLeft = _v5.d;
                var rRight = _v5.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$moveRedRight = function (dict) {
        if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
            if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var _v2 = _v1.d;
                var _v3 = _v2.a;
                var llK = _v2.b;
                var llV = _v2.c;
                var llLeft = _v2.d;
                var llRight = _v2.e;
                var lRight = _v1.e;
                var _v4 = dict.e;
                var rClr = _v4.a;
                var rK = _v4.b;
                var rV = _v4.c;
                var rLeft = _v4.d;
                var rRight = _v4.e;
                return $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, $elm$core$Dict$RBNode_elm_builtin_fn(1, llK, llV, llLeft, llRight), $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, lRight, $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight)));
            }
            else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v5 = dict.d;
                var lClr = _v5.a;
                var lK = _v5.b;
                var lV = _v5.c;
                var lLeft = _v5.d;
                var lRight = _v5.e;
                var _v6 = dict.e;
                var rClr = _v6.a;
                var rK = _v6.b;
                var rV = _v6.c;
                var rLeft = _v6.d;
                var rRight = _v6.e;
                if (clr === 1) {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, $elm$core$Dict$RBNode_elm_builtin_fn(0, lK, lV, lLeft, lRight), $elm$core$Dict$RBNode_elm_builtin_fn(0, rK, rV, rLeft, rRight));
                }
            }
        }
        else {
            return dict;
        }
    };
    var $elm$core$Dict$removeHelpPrepEQGT_fn = function (targetKey, dict, color, key, value, left, right) {
        if ((left.$ === -1) && (!left.a)) {
            var _v1 = left.a;
            var lK = left.b;
            var lV = left.c;
            var lLeft = left.d;
            var lRight = left.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, lK, lV, lLeft, $elm$core$Dict$RBNode_elm_builtin_fn(0, key, value, lRight, right));
        }
        else {
            _v2$2: while (true) {
                if ((right.$ === -1) && (right.a === 1)) {
                    if (right.d.$ === -1) {
                        if (right.d.a === 1) {
                            var _v3 = right.a;
                            var _v4 = right.d;
                            var _v5 = _v4.a;
                            return $elm$core$Dict$moveRedRight(dict);
                        }
                        else {
                            break _v2$2;
                        }
                    }
                    else {
                        var _v6 = right.a;
                        var _v7 = right.d;
                        return $elm$core$Dict$moveRedRight(dict);
                    }
                }
                else {
                    break _v2$2;
                }
            }
            return dict;
        }
    }, $elm$core$Dict$removeHelpPrepEQGT = F7($elm$core$Dict$removeHelpPrepEQGT_fn);
    var $elm$core$Dict$removeMin = function (dict) {
        if ((dict.$ === -1) && (dict.d.$ === -1)) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var lColor = left.a;
            var lLeft = left.d;
            var right = dict.e;
            if (lColor === 1) {
                if ((lLeft.$ === -1) && (!lLeft.a)) {
                    var _v3 = lLeft.a;
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
                }
                else {
                    var _v4 = $elm$core$Dict$moveRedLeft(dict);
                    if (_v4.$ === -1) {
                        var nColor = _v4.a;
                        var nKey = _v4.b;
                        var nValue = _v4.c;
                        var nLeft = _v4.d;
                        var nRight = _v4.e;
                        return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
                    }
                    else {
                        return $elm$core$Dict$RBEmpty_elm_builtin;
                    }
                }
            }
            else {
                return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeMin(left), right);
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    };
    var $elm$core$Dict$removeHelp_fn = function (targetKey, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_cmp(targetKey, key) < 0) {
                if ((left.$ === -1) && (left.a === 1)) {
                    var _v4 = left.a;
                    var lLeft = left.d;
                    if ((lLeft.$ === -1) && (!lLeft.a)) {
                        var _v6 = lLeft.a;
                        return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                    }
                    else {
                        var _v7 = $elm$core$Dict$moveRedLeft(dict);
                        if (_v7.$ === -1) {
                            var nColor = _v7.a;
                            var nKey = _v7.b;
                            var nValue = _v7.c;
                            var nLeft = _v7.d;
                            var nRight = _v7.e;
                            return $elm$core$Dict$balance_fn(nColor, nKey, nValue, $elm$core$Dict$removeHelp_fn(targetKey, nLeft), nRight);
                        }
                        else {
                            return $elm$core$Dict$RBEmpty_elm_builtin;
                        }
                    }
                }
                else {
                    return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, value, $elm$core$Dict$removeHelp_fn(targetKey, left), right);
                }
            }
            else {
                return $elm$core$Dict$removeHelpEQGT_fn(targetKey, $elm$core$Dict$removeHelpPrepEQGT_fn(targetKey, dict, color, key, value, left, right));
            }
        }
    }, $elm$core$Dict$removeHelp = F2($elm$core$Dict$removeHelp_fn);
    var $elm$core$Dict$removeHelpEQGT_fn = function (targetKey, dict) {
        if (dict.$ === -1) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_eq(targetKey, key)) {
                var _v1 = $elm$core$Dict$getMin(right);
                if (_v1.$ === -1) {
                    var minKey = _v1.b;
                    var minValue = _v1.c;
                    return $elm$core$Dict$balance_fn(color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
                }
                else {
                    return $elm$core$Dict$RBEmpty_elm_builtin;
                }
            }
            else {
                return $elm$core$Dict$balance_fn(color, key, value, left, $elm$core$Dict$removeHelp_fn(targetKey, right));
            }
        }
        else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
    }, $elm$core$Dict$removeHelpEQGT = F2($elm$core$Dict$removeHelpEQGT_fn);
    var $elm$core$Dict$remove_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$removeHelp_fn(key, dict);
        if ((_v0.$ === -1) && (!_v0.a)) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(1, k, v, l, r);
        }
        else {
            var x = _v0;
            return x;
        }
    }, $elm$core$Dict$remove = F2($elm$core$Dict$remove_fn);
    var $elm$core$Dict$update_fn = function (targetKey, alter, dictionary) {
        var _v0 = alter($elm$core$Dict$get_fn(targetKey, dictionary));
        if (!_v0.$) {
            var value = _v0.a;
            return $elm$core$Dict$insert_fn(targetKey, value, dictionary);
        }
        else {
            return $elm$core$Dict$remove_fn(targetKey, dictionary);
        }
    }, $elm$core$Dict$update = F3($elm$core$Dict$update_fn);
    var $elm$url$Url$Parser$addParam_fn = function (segment, dict) {
        var _v0 = $elm$core$String$split_fn("=", segment);
        if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
            var rawKey = _v0.a;
            var _v1 = _v0.b;
            var rawValue = _v1.a;
            var _v2 = $elm$url$Url$percentDecode(rawKey);
            if (_v2.$ === 1) {
                return dict;
            }
            else {
                var key = _v2.a;
                var _v3 = $elm$url$Url$percentDecode(rawValue);
                if (_v3.$ === 1) {
                    return dict;
                }
                else {
                    var value = _v3.a;
                    return $elm$core$Dict$update_fn(key, $elm$url$Url$Parser$addToParametersHelp(value), dict);
                }
            }
        }
        else {
            return dict;
        }
    }, $elm$url$Url$Parser$addParam = F2($elm$url$Url$Parser$addParam_fn);
    var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
    var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
        if (maybeQuery.$ === 1) {
            return $elm$core$Dict$empty;
        }
        else {
            var qry = maybeQuery.a;
            return $elm$core$List$foldr_fn($elm$url$Url$Parser$addParam, $elm$core$Dict$empty, $elm$core$String$split_fn("&", qry));
        }
    };
    var $elm$url$Url$Parser$parse_fn = function (_v0, url) {
        var parser = _v0;
        return $elm$url$Url$Parser$getFirstMatch(parser($elm$url$Url$Parser$State_fn(_List_Nil, $elm$url$Url$Parser$preparePath(url.dC), $elm$url$Url$Parser$prepareQuery(url.dH), url.c7, $elm$core$Basics$identity)));
    }, $elm$url$Url$Parser$parse = F2($elm$url$Url$Parser$parse_fn);
    var $author$project$UI$Ports$saveGoogleAccessTokenAndCloseWindow = _Platform_outgoingPort("saveGoogleAccessTokenAndCloseWindow", $elm$json$Json$Encode$string);
    var $author$project$Zipper$singleton = function (x) {
        return { d: _List_Nil, e: _List_Nil, h: x };
    };
    var $author$project$Zipper$toList = function (_v0) {
        var before = _v0.e;
        var curr = _v0.h;
        var after = _v0.d;
        return _Utils_ap($elm$core$List$reverse(before), _List_Cons(curr, after));
    };
    var $author$project$Document$toUI_fn = function (id, _v0) {
        var name = _v0.dw;
        var rows = _v0.M;
        var googleId = _v0.n;
        return { n: googleId, fh: id, du: _List_Nil, dw: name, M: rows };
    }, $author$project$Document$toUI = F2($author$project$Document$toUI_fn);
    var $elm$core$Maybe$withDefault_fn = function (_default, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return value;
        }
        else {
            return _default;
        }
    }, $elm$core$Maybe$withDefault = F2($elm$core$Maybe$withDefault_fn);
    var $author$project$UI$init_fn = function (flags, url, key) {
        var saved = flags.dS;
        var hasClipboard = flags.bZ;
        var hasFullscreen = flags.b_;
        var languages = flags.dq;
        var rootUrl = $elm$core$String$concat(_List_fromArray([
            function () {
                var _v7 = url.fW;
                if (!_v7) {
                    return "http";
                }
                else {
                    return "https";
                }
            }(),
            "://",
            url.fe,
            function () {
                var _v8 = url.fV;
                if (_v8.$ === 1) {
                    return "";
                }
                else {
                    var p = _v8.a;
                    return ":" + $elm$core$String$fromInt(p);
                }
            }()
        ]));
        var parseLanguage = function (lang) {
            var _v6 = $elm$core$String$split_fn("-", lang);
            _v6$2: while (true) {
                if (_v6.b) {
                    switch (_v6.a) {
                        case "it":
                            return $elm$core$Maybe$Just(1);
                        case "en":
                            return $elm$core$Maybe$Just(0);
                        default:
                            break _v6$2;
                    }
                }
                else {
                    break _v6$2;
                }
            }
            return $elm$core$Maybe$Nothing;
        };
        var measure = $elm$core$Task$map_fn(function (_v5) {
            var viewport = _v5.gE;
            return {
                bj: $elm$core$Basics$floor(viewport.bj),
                bE: $elm$core$Basics$floor(viewport.bE)
            };
        }, $elm$browser$Browser$Dom$getViewport);
        var indexToId = function (index) {
            var id = (index < 0) ? (((-index) * 2) - 1) : (index * 2);
            return id;
        };
        var toUi = F2(function (index, document) {
            return $author$project$Document$toUI_fn(indexToId(index), document);
        });
        var emptyRow = function (x) {
            return {
                G: $author$project$Document$CodeRow(_List_Nil),
                al: false,
                r: x
            };
        };
        var documents = function () {
            var _v4 = A2($miniBill$elm_codec$Codec$decodeValue, $author$project$UI$Model$documentsCodec, saved);
            if (!_v4.$) {
                var docs = _v4.a;
                return $elm$core$Maybe$map_fn($author$project$Zipper$map(toUi), docs);
            }
            else {
                return $elm$core$Maybe$Just($author$project$Zipper$singleton($author$project$Document$toUI_fn(0, {
                    n: $elm$core$Maybe$Nothing,
                    dw: $elm$core$Maybe$Nothing,
                    M: $elm$core$List$map_fn(emptyRow, $author$project$UI$defaultDocument)
                })));
            }
        }();
        var nextId = 1 + $elm$core$Maybe$withDefault_fn(-1, $elm$core$List$maximum($elm$core$List$map_fn(function (d) {
            var _v3 = d.fh;
            var i = _v3;
            return i;
        }, $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($author$project$Zipper$toList, documents)))));
        var defaultSize = { bj: 768, bE: 1024 };
        var accessTokenParser = $elm$url$Url$Parser$fragment($elm$core$Maybe$andThen(A2($elm$core$Basics$composeR, $elm$core$String$split("&"), A2($elm$core$Basics$composeR, $elm$core$List$filterMap(function (p) {
            var _v1 = $elm$core$String$split_fn("=", p);
            if (((_v1.b && (_v1.a === "access_token")) && _v1.b.b) && (!_v1.b.b.b)) {
                var _v2 = _v1.b;
                var v = _v2.a;
                return $elm$core$Maybe$Just(v);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }), $elm$core$List$head))));
        var googleAccessTokenFromUrl = $elm$core$Maybe$andThen_fn($elm$core$Basics$identity, $elm$url$Url$Parser$parse_fn(accessTokenParser, url));
        var googleAccessToken = function (s) {
            return $elm$core$String$isEmpty(s) ? $author$project$API$Google$Missing : $author$project$API$Google$Present(s);
        }($elm$core$Maybe$withDefault_fn(flags.dc, googleAccessTokenFromUrl));
        var google = { aN: googleAccessToken, ac: _List_Nil, O: _List_Nil, T: _List_Nil };
        var model = {
            eU: {
                c$: 0,
                bU: false,
                bZ: hasClipboard,
                b_: hasFullscreen,
                dl: false,
                dp: $elm$core$Maybe$withDefault_fn(0, $elm$core$List$head($elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$List$map_fn(parseLanguage, languages)))),
                ck: true
            },
            l: documents,
            m: google,
            fu: key,
            bo: nextId,
            bp: false,
            cn: rootUrl,
            bx: false,
            cq: defaultSize
        };
        return _Utils_Tuple2(model, function () {
            if (googleAccessTokenFromUrl.$ === 1) {
                return $elm$core$Task$perform_fn($author$project$UI$Model$Resized, measure);
            }
            else {
                var token = googleAccessTokenFromUrl.a;
                return $author$project$UI$Ports$saveGoogleAccessTokenAndCloseWindow(token);
            }
        }());
    }, $author$project$UI$init = F3($author$project$UI$init_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn = function (context, attrs) {
        return $elm$core$List$map_fn(function (_v0) {
            var f = _v0;
            return f(context);
        }, attrs);
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes = F2($miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn);
    var $mdgriffith$elm_ui$Internal$Style$classes = { ej: "a", bF: "atv", em: "ab", en: "cx", eo: "cy", ep: "acb", eq: "accx", er: "accy", es: "acr", cM: "al", cN: "ar", et: "at", bG: "ah", bH: "av", ex: "s", eB: "bh", eC: "b", eD: "w7", eF: "bd", eG: "bdt", a5: "bn", eH: "bs", a7: "cpe", eP: "cp", eQ: "cpx", eR: "cpy", aj: "c", bd: "ctr", be: "cb", bf: "ccx", ak: "ccy", aS: "cl", bg: "cr", eT: "ct", eV: "cptr", eW: "ctxt", e8: "fcs", c6: "focus-within", e9: "fs", fa: "g", bY: "hbh", b1: "hc", dd: "he", b2: "hf", de: "hfp", ff: "hv", fi: "ic", fk: "fr", bk: "lbl", fm: "iml", fn: "imlf", fo: "imlp", fp: "implw", fq: "it", ft: "i", ca: "lnk", aI: "nb", dx: "notxt", fM: "ol", fN: "or", aA: "oq", fS: "oh", dB: "pg", ch: "p", fT: "ppe", dP: "ui", f$: "r", f1: "sb", f2: "sbx", f3: "sby", f4: "sbt", f7: "e", f8: "cap", f9: "sev", gg: "sk", gk: "t", gl: "tc", gm: "w8", gn: "w2", go: "w9", gp: "tj", bA: "tja", gq: "tl", gr: "w3", gs: "w5", gt: "w4", gu: "tr", gv: "w6", gw: "w1", gx: "tun", d7: "ts", aD: "clr", gB: "u", cI: "wc", ed: "we", cJ: "wf", ee: "wfp", cK: "wrp" };
    var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
        return { $: 1, a: a };
    };
    var $elm$html$Html$Attributes$stringProperty_fn = function (key, string) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$string(string));
    }, $elm$html$Html$Attributes$stringProperty = F2($elm$html$Html$Attributes$stringProperty_fn);
    var $elm$html$Html$Attributes$class_a0 = "className", $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$class_a0);
    var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
        return $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, cls));
    };
    var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2($mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn);
    var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2($mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic_fn);
    var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
    var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
    var $mdgriffith$elm_ui$Internal$Model$Generic = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
    var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.aj);
    var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.fa);
    var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.dB);
    var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.ch);
    var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.f$);
    var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.f7);
    var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
        switch (context) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$rowClass;
            case 1:
                return $mdgriffith$elm_ui$Internal$Model$columnClass;
            case 2:
                return $mdgriffith$elm_ui$Internal$Model$singleClass;
            case 3:
                return $mdgriffith$elm_ui$Internal$Model$gridClass;
            case 4:
                return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
            default:
                return $mdgriffith$elm_ui$Internal$Model$pageClass;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$addChildren_fn = function (existing, nearbyChildren) {
        switch (nearbyChildren.$) {
            case 0:
                return existing;
            case 1:
                var behind = nearbyChildren.a;
                return _Utils_ap(behind, existing);
            case 2:
                var inFront = nearbyChildren.a;
                return _Utils_ap(existing, inFront);
            default:
                var behind = nearbyChildren.a;
                var inFront = nearbyChildren.b;
                return _Utils_ap(behind, _Utils_ap(existing, inFront));
        }
    }, $mdgriffith$elm_ui$Internal$Model$addChildren = F2($mdgriffith$elm_ui$Internal$Model$addChildren_fn);
    var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn = function (key, existing, nearbyChildren) {
        switch (nearbyChildren.$) {
            case 0:
                return existing;
            case 1:
                var behind = nearbyChildren.a;
                return _Utils_ap($elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, behind), existing);
            case 2:
                var inFront = nearbyChildren.a;
                return _Utils_ap(existing, $elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, inFront));
            default:
                var behind = nearbyChildren.a;
                var inFront = nearbyChildren.b;
                return _Utils_ap($elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, behind), _Utils_ap(existing, $elm$core$List$map_fn(function (x) {
                    return _Utils_Tuple2(key, x);
                }, inFront)));
        }
    }, $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn);
    var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
    var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
    var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
    var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
    var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
    var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
    var $elm$html$Html$div = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "div"), $elm$html$Html$div_fn = $elm$html$Html$div.f;
    var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
    var $elm$core$Set$empty = $elm$core$Dict$empty;
    var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
        switch (x.$) {
            case 0:
                var px = x.a;
                return $elm$core$String$fromInt(px) + "px";
            case 1:
                return "auto";
            case 2:
                var i = x.a;
                return $elm$core$String$fromInt(i) + "fr";
            case 3:
                var min = x.a;
                var len = x.b;
                return "min" + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
            default:
                var max = x.a;
                var len = x.b;
                return "max" + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
        }
    };
    var $elm$core$Tuple$second = function (_v0) {
        var y = _v0.b;
        return y;
    };
    var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
        switch (transform.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v1 = transform.a;
                var x = _v1.a;
                var y = _v1.b;
                var z = _v1.c;
                return $elm$core$Maybe$Just("mv-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
            default:
                var _v2 = transform.a;
                var tx = _v2.a;
                var ty = _v2.b;
                var tz = _v2.c;
                var _v3 = transform.b;
                var sx = _v3.a;
                var sy = _v3.b;
                var sz = _v3.c;
                var _v4 = transform.c;
                var ox = _v4.a;
                var oy = _v4.b;
                var oz = _v4.c;
                var angle = transform.d;
                return $elm$core$Maybe$Just("tfrm-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
        switch (style.$) {
            case 13:
                var name = style.a;
                return name;
            case 12:
                var name = style.a;
                var o = style.b;
                return name;
            case 0:
                var _class = style.a;
                return _class;
            case 1:
                var name = style.a;
                return name;
            case 2:
                var i = style.a;
                return "font-size-" + $elm$core$String$fromInt(i);
            case 3:
                var _class = style.a;
                return _class;
            case 4:
                var _class = style.a;
                return _class;
            case 5:
                var cls = style.a;
                var x = style.b;
                var y = style.c;
                return cls;
            case 7:
                var cls = style.a;
                var top = style.b;
                var right = style.c;
                var bottom = style.d;
                var left = style.e;
                return cls;
            case 6:
                var cls = style.a;
                var top = style.b;
                var right = style.c;
                var bottom = style.d;
                var left = style.e;
                return cls;
            case 8:
                var template = style.a;
                return "grid-rows-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.M)) + ("-cols-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.eS)) + ("-space-x-" + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.ga.a) + ("-space-y-" + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.ga.b)))))));
            case 9:
                var pos = style.a;
                return "gp grid-pos-" + ($elm$core$String$fromInt(pos.f$) + ("-" + ($elm$core$String$fromInt(pos.aG) + ("-" + ($elm$core$String$fromInt(pos.bE) + ("-" + $elm$core$String$fromInt(pos.bj)))))));
            case 11:
                var selector = style.a;
                var subStyle = style.b;
                var name = function () {
                    switch (selector) {
                        case 0:
                            return "fs";
                        case 1:
                            return "hv";
                        default:
                            return "act";
                    }
                }();
                return $elm$core$String$join_fn(" ", $elm$core$List$map_fn(function (sty) {
                    var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
                    if (_v1 === "") {
                        return "";
                    }
                    else {
                        var styleName = _v1;
                        return styleName + ("-" + name);
                    }
                }, subStyle));
            default:
                var x = style.a;
                return $elm$core$Maybe$withDefault_fn("", $mdgriffith$elm_ui$Internal$Model$transformClass(x));
        }
    };
    var $elm$core$Set$insert_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$insert_fn(key, 0, dict);
    }, $elm$core$Set$insert = F2($elm$core$Set$insert_fn);
    var $elm$core$Dict$member_fn = function (key, dict) {
        var _v0 = $elm$core$Dict$get_fn(key, dict);
        if (!_v0.$) {
            return true;
        }
        else {
            return false;
        }
    }, $elm$core$Dict$member = F2($elm$core$Dict$member_fn);
    var $elm$core$Set$member_fn = function (key, _v0) {
        var dict = _v0;
        return $elm$core$Dict$member_fn(key, dict);
    }, $elm$core$Set$member = F2($elm$core$Set$member_fn);
    var $mdgriffith$elm_ui$Internal$Model$reduceStyles_fn = function (style, nevermind) {
        var cache = nevermind.a;
        var existing = nevermind.b;
        var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
        return $elm$core$Set$member_fn(styleName, cache) ? nevermind : _Utils_Tuple2($elm$core$Set$insert_fn(styleName, cache), _List_Cons(style, existing));
    }, $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2($mdgriffith$elm_ui$Internal$Model$reduceStyles_fn);
    var $mdgriffith$elm_ui$Internal$Model$Property_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Property = F2($mdgriffith$elm_ui$Internal$Model$Property_fn);
    var $mdgriffith$elm_ui$Internal$Model$Style_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Style = F2($mdgriffith$elm_ui$Internal$Model$Style_fn);
    var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
        return "." + c;
    };
    var $elm$core$String$fromFloat = _String_fromNumber;
    var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
        var red = _v0.a;
        var green = _v0.b;
        var blue = _v0.c;
        var alpha = _v0.d;
        return "rgba(" + ($elm$core$String$fromInt($elm$core$Basics$round(red * 255)) + (("," + $elm$core$String$fromInt($elm$core$Basics$round(green * 255))) + (("," + $elm$core$String$fromInt($elm$core$Basics$round(blue * 255))) + ("," + ($elm$core$String$fromFloat(alpha) + ")")))));
    };
    var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
        return $elm$core$String$join_fn(" ", $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
            shadow.dj ? $elm$core$Maybe$Just("inset") : $elm$core$Maybe$Nothing,
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.a.a) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.a.b) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.aF) + "px"),
            $elm$core$Maybe$Just($elm$core$String$fromFloat(shadow.cq) + "px"),
            $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$formatColor(shadow.bc))
        ])));
    };
    var $elm$core$Tuple$mapFirst_fn = function (func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(func(x), y);
    }, $elm$core$Tuple$mapFirst = F2($elm$core$Tuple$mapFirst_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$Style_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c6) + ":focus-within", $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("border-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.eE),
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("background-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ez),
                $elm$core$Maybe$map_fn(function (shadow) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", $mdgriffith$elm_ui$Internal$Model$formatBoxShadow({
                        aF: shadow.aF,
                        bc: shadow.bc,
                        dj: false,
                        a: $elm$core$Tuple$mapSecond_fn($elm$core$Basics$toFloat, $elm$core$Tuple$mapFirst_fn($elm$core$Basics$toFloat, shadow.a)),
                        cq: shadow.cq
                    }));
                }, focus.f6),
                $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Property_fn("outline", "none"))
            ]))),
            $mdgriffith$elm_ui$Internal$Model$Style_fn(($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ":focus .focusable, ") + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ".focusable:focus, ") + (".ui-slide-bar:focus + " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + " .focusable-thumb"))), $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("border-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.eE),
                $elm$core$Maybe$map_fn(function (color) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("background-color", $mdgriffith$elm_ui$Internal$Model$formatColor(color));
                }, focus.ez),
                $elm$core$Maybe$map_fn(function (shadow) {
                    return $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", $mdgriffith$elm_ui$Internal$Model$formatBoxShadow({
                        aF: shadow.aF,
                        bc: shadow.bc,
                        dj: false,
                        a: $elm$core$Tuple$mapSecond_fn($elm$core$Basics$toFloat, $elm$core$Tuple$mapFirst_fn($elm$core$Basics$toFloat, shadow.a)),
                        cq: shadow.cq
                    }));
                }, focus.f6),
                $elm$core$Maybe$Just($mdgriffith$elm_ui$Internal$Model$Property_fn("outline", "none"))
            ])))
        ]);
    };
    var $elm$virtual_dom$VirtualDom$node = function (tag) {
        return _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, _VirtualDom_noScript(tag));
    };
    var $elm$virtual_dom$VirtualDom$property_fn = function (key, value) {
        return _VirtualDom_property_fn(_VirtualDom_noInnerHtmlOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    }, $elm$virtual_dom$VirtualDom$property = F2($elm$virtual_dom$VirtualDom$property_fn);
    var $mdgriffith$elm_ui$Internal$Style$AllChildren_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$AllChildren = F2($mdgriffith$elm_ui$Internal$Style$AllChildren_fn);
    var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
        return { $: 6, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Style$Child_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Child = F2($mdgriffith$elm_ui$Internal$Style$Child_fn);
    var $mdgriffith$elm_ui$Internal$Style$Class_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Class = F2($mdgriffith$elm_ui$Internal$Style$Class_fn);
    var $mdgriffith$elm_ui$Internal$Style$Descriptor_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Descriptor = F2($mdgriffith$elm_ui$Internal$Style$Descriptor_fn);
    var $mdgriffith$elm_ui$Internal$Style$Left = 3;
    var $mdgriffith$elm_ui$Internal$Style$Prop_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Prop = F2($mdgriffith$elm_ui$Internal$Style$Prop_fn);
    var $mdgriffith$elm_ui$Internal$Style$Right = 2;
    var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$Supports_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Style$Supports = F2($mdgriffith$elm_ui$Internal$Style$Supports_fn);
    var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
    var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
    var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
    var $mdgriffith$elm_ui$Internal$Style$Top = 0;
    var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray([0, 1, 2, 3, 4, 5]);
    var $elm$core$List$append_fn = function (xs, ys) {
        if (!ys.b) {
            return xs;
        }
        else {
            return $elm$core$List$foldr_fn($elm$core$List$cons, ys, xs);
        }
    }, $elm$core$List$append = F2($elm$core$List$append_fn);
    var $elm$core$List$concat = function (lists) {
        return $elm$core$List$foldr_fn($elm$core$List$append, _List_Nil, lists);
    };
    var $elm$core$List$concatMap_fn = function (f, list) {
        return $elm$core$List$concat($elm$core$List$map_fn(f, list));
    }, $elm$core$List$concatMap = F2($elm$core$List$concatMap_fn);
    var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
        switch (desc) {
            case 0:
                var _v1 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eT);
            case 1:
                var _v2 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.be);
            case 2:
                var _v3 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bg);
            case 3:
                var _v4 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aS);
            case 4:
                var _v5 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bf);
            default:
                var _v6 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ak);
        }
    };
    var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
        switch (desc) {
            case 0:
                var _v1 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.et);
            case 1:
                var _v2 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.em);
            case 2:
                var _v3 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cN);
            case 3:
                var _v4 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cM);
            case 4:
                var _v5 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.en);
            default:
                var _v6 = desc;
                return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo);
        }
    };
    var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
        var createDescription = function (alignment) {
            var _v0 = values(alignment);
            var content = _v0.a;
            var indiv = _v0.b;
            return _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$contentName(alignment), content),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$selfName(alignment), indiv)
                ]))
            ]);
        };
        return $mdgriffith$elm_ui$Internal$Style$Batch($elm$core$List$concatMap_fn(createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
    };
    var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray([
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "column"),
        $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre"),
        $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bY), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eB), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "-1")
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f4), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gk), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "auto !important")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b1), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ee), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cI), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
        ])),
        $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
            switch (alignment) {
                case 0:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "0 !important")
                    ]));
                case 1:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "0 !important")
                    ]));
                case 2:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                    ]));
                case 3:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                    ]));
                case 4:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                    ]));
                default:
                    return _Utils_Tuple2(_List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto")
                        ]))
                    ]), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]));
            }
        })
    ]);
    var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
        var createDescription = function (alignment) {
            return _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$selfName(alignment), values(alignment))
                ]))
            ]);
        };
        return $mdgriffith$elm_ui$Internal$Style$Batch($elm$core$List$concatMap_fn(createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
    };
    var $mdgriffith$elm_ui$Internal$Style$Above = 0;
    var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
    var $mdgriffith$elm_ui$Internal$Style$Below = 1;
    var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
    var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
    var $mdgriffith$elm_ui$Internal$Style$Within = 4;
    var $mdgriffith$elm_ui$Internal$Style$locations = function () {
        var loc = 0;
        var _v0 = function () {
            switch (loc) {
                case 0:
                    return 0;
                case 1:
                    return 0;
                case 2:
                    return 0;
                case 3:
                    return 0;
                case 4:
                    return 0;
                default:
                    return 0;
            }
        }();
        return _List_fromArray([0, 1, 2, 3, 4, 5]);
    }();
    var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray([
        $mdgriffith$elm_ui$Internal$Style$Class_fn("html,body", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fi))), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn("img", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("max-height", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("object-fit", "cover")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Child_fn("img", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("max-width", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("object-fit", "cover")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ":focus", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("outline", "none")
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dP), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("min-height", "100%"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2)), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fk), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aI), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "fixed"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20")
                ]))
            ]))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aI), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "relative"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), $mdgriffith$elm_ui$Internal$Style$elDescription),
            $mdgriffith$elm_ui$Internal$Style$Batch(function (fn) {
                return $elm$core$List$map_fn(fn, $mdgriffith$elm_ui$Internal$Style$locations);
            }(function (loc) {
                switch (loc) {
                    case 0:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ej), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("bottom", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 1:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eC), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("bottom", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ])),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "auto")
                            ]))
                        ]));
                    case 2:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 3:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("right", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "20"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    case 4:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fk), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                    default:
                        return $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eB), _List_fromArray([
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "absolute"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
                            $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none"),
                            $mdgriffith$elm_ui$Internal$Style$Child_fn("*", _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto")
                            ]))
                        ]));
                }
            }))
        ])),
        $mdgriffith$elm_ui$Internal$Style$Class_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "relative"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("resize", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("box-sizing", "border-box"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", "0"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "solid"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-size", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("color", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-family", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("line-height", "1"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "none"),
            $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "inherit"),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cK), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-wrap", "wrap")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dx), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-moz-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-webkit-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("-ms-user-select", "none"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("user-select", "none")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eV), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "pointer")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eW), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "text")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none !important")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a7), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "auto !important")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aD), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aA), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.ff, $mdgriffith$elm_ui$Internal$Style$classes.aD)) + ":hover", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.ff, $mdgriffith$elm_ui$Internal$Style$classes.aA)) + ":hover", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.e8, $mdgriffith$elm_ui$Internal$Style$classes.aD)) + ":focus", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.e8, $mdgriffith$elm_ui$Internal$Style$classes.aA)) + ":focus", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.bF, $mdgriffith$elm_ui$Internal$Style$classes.aD)) + ":active", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot(_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.bF, $mdgriffith$elm_ui$Internal$Style$classes.aA)) + ":active", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("opacity", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d7), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("transition", $elm$core$String$join_fn(", ", $elm$core$List$map_fn(function (x) {
                    return x + " 160ms";
                }, _List_fromArray(["transform", "opacity", "filter", "background-color", "color", "font-size"]))))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f1), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f2), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-x", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-y", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aj), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-shrink", "1")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eP), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eQ), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-x", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eR), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-y", "hidden")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cI), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "auto")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a5), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", "0")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eF), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "dashed")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eG), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "dotted")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eH), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-style", "solid")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gk), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-block")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fq), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("line-height", "1.05"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("background", "transparent"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "inherit")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), $mdgriffith$elm_ui$Internal$Style$elDescription),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "row"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "0%"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ed), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ca), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bd), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.es, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.eq, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.en), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-left", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.eq, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.en), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-right", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:only-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.eq, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.eq + " ~ u"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.es + (" ~ s." + $mdgriffith$elm_ui$Internal$Style$classes.eq)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                            ]));
                        case 1:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                            ]));
                        case 2:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]), _List_Nil);
                        case 3:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]), _List_Nil);
                        case 4:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]), _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                            ]));
                    }
                }),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f9), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "space-between")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bk), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "baseline")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aj), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-direction", "column"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "0px"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("min-height", "min-content"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dd), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.b2), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "100000")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cJ), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ee), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cI), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.ep, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:first-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.er, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "0 !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.er, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "0 !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:only-of-type." + $mdgriffith$elm_ui$Internal$Style$classes.er, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "1"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto !important"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto !important")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("s:last-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.er + " ~ u"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn("u:first-of-type." + ($mdgriffith$elm_ui$Internal$Style$classes.ep + (" ~ s." + $mdgriffith$elm_ui$Internal$Style$classes.er)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-bottom", "auto")
                            ]));
                        case 1:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin-top", "auto")
                            ]));
                        case 2:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-end")
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "flex-start")
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]), _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "center")
                            ]));
                        default:
                            return _Utils_Tuple2(_List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]), _List_Nil);
                    }
                }),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bd), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-grow", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-self", "stretch !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f9), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "space-between")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fa), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "-ms-grid"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn(".gp", _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Supports_fn(_Utils_Tuple2("display", "grid"), _List_fromArray([
                    _Utils_Tuple2("display", "grid")
                ])),
                $mdgriffith$elm_ui$Internal$Style$gridAlignments(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-start")
                            ]);
                        case 1:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "flex-end")
                            ]);
                        case 2:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-end")
                            ]);
                        case 3:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "flex-start")
                            ]);
                        case 4:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("align-items", "center")
                            ]);
                        default:
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("justify-content", "center")
                            ]);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dB), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex + ":first-child"), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (":first-child + ." + $mdgriffith$elm_ui$Internal$Style$classes.ex))), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (":first-child + ." + $mdgriffith$elm_ui$Internal$Style$classes.ex))), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("margin", "0 !important")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 1:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 2:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "right"),
                                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "\"\""),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "table"),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("clear", "both")
                                ]))
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "left"),
                                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "\"\""),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "table"),
                                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("clear", "both")
                                ]))
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fm), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("background-color", "transparent")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fp), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("flex-basis", "auto")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fo), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("cursor", "text"),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fn), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "pre-wrap !important"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("color", "transparent")
                ]))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ch), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "block"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("overflow-wrap", "break-word"),
                $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bY), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "0"),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eB), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("z-index", "-1")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gk), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal")
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ch), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::after", _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "none")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn("::before", _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("content", "none")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$AllChildren_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal"),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ed), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-block")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fk), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eB), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ej), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eC), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "flex")
                    ])),
                    $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gk), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline"),
                        $mdgriffith$elm_ui$Internal$Style$Prop_fn("white-space", "normal")
                    ]))
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aj), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-flex")
                ])),
                $mdgriffith$elm_ui$Internal$Style$Child_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fa), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "inline-grid")
                ])),
                $mdgriffith$elm_ui$Internal$Style$describeAlignment(function (alignment) {
                    switch (alignment) {
                        case 0:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 1:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        case 2:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "right")
                            ]));
                        case 3:
                            return _Utils_Tuple2(_List_Nil, _List_fromArray([
                                $mdgriffith$elm_ui$Internal$Style$Prop_fn("float", "left")
                            ]));
                        case 4:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                        default:
                            return _Utils_Tuple2(_List_Nil, _List_Nil);
                    }
                })
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(".hidden", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("display", "none")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gw), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "100")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gn), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "200")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gr), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "300")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gt), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "400")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gs), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "500")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gv), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "600")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eD), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "700")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gm), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "800")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.go), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-weight", "900")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "italic")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gg), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "line-through")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gB), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "underline"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip-ink", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip", "ink")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(_Utils_ap($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gB), $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gg)), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration", "line-through underline"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip-ink", "auto"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-decoration-skip", "ink")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gx), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-style", "normal")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gp), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "justify")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bA), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "justify-all")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gl), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "center")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gu), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "right")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gq), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("text-align", "left")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Descriptor_fn(".modal", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("position", "fixed"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("left", "0"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("top", "0"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("width", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("height", "100%"),
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("pointer-events", "none")
            ]))
        ]))
    ]);
    var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-" + _var, _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "\"" + (_var + "\""))
            ])),
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-" + (_var + "-off"), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-feature-settings", "\"" + (_var + "\" 0"))
            ]))
        ]);
    };
    var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(_List_fromArray([
        $elm$core$List$map_fn(function (x) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".border-" + $elm$core$String$fromInt(x), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("border-width", $elm$core$String$fromInt(x) + "px")
            ]));
        }, $elm$core$List$range_fn(0, 6)),
        $elm$core$List$map_fn(function (i) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".font-size-" + $elm$core$String$fromInt(i), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-size", $elm$core$String$fromInt(i) + "px")
            ]));
        }, $elm$core$List$range_fn(8, 32)),
        $elm$core$List$map_fn(function (i) {
            return $mdgriffith$elm_ui$Internal$Style$Class_fn(".p-" + $elm$core$String$fromInt(i), _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("padding", $elm$core$String$fromInt(i) + "px")
            ]));
        }, $elm$core$List$range_fn(0, 24)),
        _List_fromArray([
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-smcp", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-variant", "small-caps")
            ])),
            $mdgriffith$elm_ui$Internal$Style$Class_fn(".v-smcp-off", _List_fromArray([
                $mdgriffith$elm_ui$Internal$Style$Prop_fn("font-variant", "normal")
            ]))
        ]),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("zero"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("onum"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("liga"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("dlig"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("ordn"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("tnum"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("afrc"),
        $mdgriffith$elm_ui$Internal$Style$fontVariant("frac")
    ]));
    var $mdgriffith$elm_ui$Internal$Style$explainer = "\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > ." + ($mdgriffith$elm_ui$Internal$Style$classes.ex + (" {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > ." + ($mdgriffith$elm_ui$Internal$Style$classes.ex + " {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n")));
    var $mdgriffith$elm_ui$Internal$Style$inputTextReset = "\ninput[type=\"search\"],\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$sliderReset = "\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$thumbReset = "\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$trackReset = "\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n";
    var $mdgriffith$elm_ui$Internal$Style$overrides = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {" + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$) + (" > " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + (" { flex-basis: auto !important; } " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$) + (" > " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bd) + (" { flex-basis: auto !important; }}" + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
    var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn = function (selector, closing) {
        return { bb: closing, w: _List_Nil, ar: _List_Nil, Z: selector };
    }, $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn);
    var $mdgriffith$elm_ui$Internal$Style$renderRules_fn = function (_v0, rulesToRender) {
        var parent = _v0;
        var generateIntermediates = F2(function (rule, rendered) {
            switch (rule.$) {
                case 0:
                    var name = rule.a;
                    var val = rule.b;
                    return _Utils_update(rendered, {
                        ar: _List_Cons(_Utils_Tuple2(name, val), rendered.ar)
                    });
                case 3:
                    var _v2 = rule.a;
                    var prop = _v2.a;
                    var value = _v2.b;
                    var props = rule.b;
                    return _Utils_update(rendered, {
                        w: _List_Cons({ bb: "\n}", w: _List_Nil, ar: props, Z: "@supports (" + (prop + (":" + (value + (") {" + parent.Z)))) }, rendered.w)
                    });
                case 5:
                    var selector = rule.a;
                    var adjRules = rule.b;
                    return _Utils_update(rendered, {
                        w: _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.Z + (" + " + selector), ""), adjRules), rendered.w)
                    });
                case 1:
                    var child = rule.a;
                    var childRules = rule.b;
                    return _Utils_update(rendered, {
                        w: _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.Z + (" > " + child), ""), childRules), rendered.w)
                    });
                case 2:
                    var child = rule.a;
                    var childRules = rule.b;
                    return _Utils_update(rendered, {
                        w: _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.Z + (" " + child), ""), childRules), rendered.w)
                    });
                case 4:
                    var descriptor = rule.a;
                    var descriptorRules = rule.b;
                    return _Utils_update(rendered, {
                        w: _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(_Utils_ap(parent.Z, descriptor), ""), descriptorRules), rendered.w)
                    });
                default:
                    var batched = rule.a;
                    return _Utils_update(rendered, {
                        w: _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(parent.Z, ""), batched), rendered.w)
                    });
            }
        });
        return $elm$core$List$foldr_fn(generateIntermediates, parent, rulesToRender);
    }, $mdgriffith$elm_ui$Internal$Style$renderRules = F2($mdgriffith$elm_ui$Internal$Style$renderRules_fn);
    var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
        var renderValues = function (values) {
            return $elm$core$String$concat($elm$core$List$map_fn(function (_v3) {
                var x = _v3.a;
                var y = _v3.b;
                return x + (":" + (y + ";"));
            }, values));
        };
        var renderClass = function (rule) {
            var _v2 = rule.ar;
            if (!_v2.b) {
                return "";
            }
            else {
                return rule.Z + ("{" + (renderValues(rule.ar) + (rule.bb + "}")));
            }
        };
        var renderIntermediate = function (_v0) {
            var rule = _v0;
            return _Utils_ap(renderClass(rule), $elm$core$String$concat($elm$core$List$map_fn(renderIntermediate, rule.w)));
        };
        return $elm$core$String$concat($elm$core$List$map_fn(renderIntermediate, $elm$core$List$foldr_fn(F2(function (_v1, existing) {
            var name = _v1.a;
            var styleRules = _v1.b;
            return _List_Cons($mdgriffith$elm_ui$Internal$Style$renderRules_fn($mdgriffith$elm_ui$Internal$Style$emptyIntermediate_fn(name, ""), styleRules), existing);
        }), _List_Nil, styleClasses)));
    };
    var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap($mdgriffith$elm_ui$Internal$Style$overrides, $mdgriffith$elm_ui$Internal$Style$renderCompact(_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
    var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
    var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
        var _v0 = opts.fy;
        switch (_v0) {
            case 0:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
                    ]))
                ]));
            case 1:
                return $elm$virtual_dom$VirtualDom$text("");
            default:
                return A3($elm$virtual_dom$VirtualDom$node, "elm-ui-static-rules", _List_fromArray([
                    $elm$virtual_dom$VirtualDom$property_fn("rules", $elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
                ]), _List_Nil);
        }
    };
    var $elm$core$List$any_fn = function (isOkay, list) {
        any: while (true) {
            if (!list.b) {
                return false;
            }
            else {
                var x = list.a;
                var xs = list.b;
                if (isOkay(x)) {
                    return true;
                }
                else {
                    var $temp$isOkay = isOkay, $temp$list = xs;
                    isOkay = $temp$isOkay;
                    list = $temp$list;
                    continue any;
                }
            }
        }
    }, $elm$core$List$any = F2($elm$core$List$any_fn);
    var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
        switch (font.$) {
            case 0:
                return "serif";
            case 1:
                return "sans-serif";
            case 2:
                return "monospace";
            case 3:
                var name = font.a;
                return "\"" + (name + "\"");
            case 4:
                var name = font.a;
                var url = font.b;
                return "\"" + (name + "\"");
            default:
                var name = font.a.dw;
                return "\"" + (name + "\"");
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
        switch (_var.$) {
            case 0:
                var name = _var.a;
                return name === "smcp";
            case 1:
                var name = _var.a;
                return false;
            default:
                var name = _var.a;
                var index = _var.b;
                return (name === "smcp") && (index === 1);
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
        if (typeface.$ === 5) {
            var font = typeface.a;
            return $elm$core$List$any_fn($mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.eb);
        }
        else {
            return false;
        }
    };
    var $elm$core$Basics$min_fn = function (x, y) {
        return (_Utils_cmp(x, y) < 0) ? x : y;
    }, $elm$core$Basics$min = F2($elm$core$Basics$min_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderProps_fn = function (force, _v0, existing) {
        var key = _v0.a;
        var val = _v0.b;
        return force ? (existing + ("\n  " + (key + (": " + (val + " !important;"))))) : (existing + ("\n  " + (key + (": " + (val + ";")))));
    }, $mdgriffith$elm_ui$Internal$Model$renderProps = F3($mdgriffith$elm_ui$Internal$Model$renderProps_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderStyle_fn = function (options, maybePseudo, selector, props) {
        if (maybePseudo.$ === 1) {
            return _List_fromArray([
                selector + ("{" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
            ]);
        }
        else {
            var pseudo = maybePseudo.a;
            switch (pseudo) {
                case 1:
                    var _v2 = options.ff;
                    switch (_v2) {
                        case 0:
                            return _List_Nil;
                        case 2:
                            return _List_fromArray([
                                selector + ("-hv {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(true), "", props) + "\n}"))
                            ]);
                        default:
                            return _List_fromArray([
                                selector + ("-hv:hover {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
                            ]);
                    }
                case 0:
                    var renderedProps = $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props);
                    return _List_fromArray([
                        selector + ("-fs:focus {" + (renderedProps + "\n}")),
                        ("." + ($mdgriffith$elm_ui$Internal$Style$classes.ex + (":focus " + (selector + "-fs  {")))) + (renderedProps + "\n}"),
                        (selector + "-fs:focus-within {") + (renderedProps + "\n}"),
                        (".ui-slide-bar:focus + " + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ex) + (" .focusable-thumb" + (selector + "-fs {")))) + (renderedProps + "\n}")
                    ]);
                default:
                    return _List_fromArray([
                        selector + ("-act:active {" + ($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderProps(false), "", props) + "\n}"))
                    ]);
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$renderStyle = F4($mdgriffith$elm_ui$Internal$Model$renderStyle_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
        switch (_var.$) {
            case 0:
                var name = _var.a;
                return "\"" + (name + "\"");
            case 1:
                var name = _var.a;
                return "\"" + (name + "\" 0");
            default:
                var name = _var.a;
                var index = _var.b;
                return "\"" + (name + ("\" " + $elm$core$String$fromInt(index)));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
        if (typeface.$ === 5) {
            var font = typeface.a;
            return $elm$core$Maybe$Just($elm$core$String$join_fn(", ", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$renderVariant, font.eb)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
        switch (transform.$) {
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v1 = transform.a;
                var x = _v1.a;
                var y = _v1.b;
                var z = _v1.c;
                return $elm$core$Maybe$Just("translate3d(" + ($elm$core$String$fromFloat(x) + ("px, " + ($elm$core$String$fromFloat(y) + ("px, " + ($elm$core$String$fromFloat(z) + "px)"))))));
            default:
                var _v2 = transform.a;
                var tx = _v2.a;
                var ty = _v2.b;
                var tz = _v2.c;
                var _v3 = transform.b;
                var sx = _v3.a;
                var sy = _v3.b;
                var sz = _v3.c;
                var _v4 = transform.c;
                var ox = _v4.a;
                var oy = _v4.b;
                var oz = _v4.c;
                var angle = transform.d;
                var translate = "translate3d(" + ($elm$core$String$fromFloat(tx) + ("px, " + ($elm$core$String$fromFloat(ty) + ("px, " + ($elm$core$String$fromFloat(tz) + "px)")))));
                var scale = "scale3d(" + ($elm$core$String$fromFloat(sx) + (", " + ($elm$core$String$fromFloat(sy) + (", " + ($elm$core$String$fromFloat(sz) + ")")))));
                var rotate = "rotate3d(" + ($elm$core$String$fromFloat(ox) + (", " + ($elm$core$String$fromFloat(oy) + (", " + ($elm$core$String$fromFloat(oz) + (", " + ($elm$core$String$fromFloat(angle) + "rad)")))))));
                return $elm$core$Maybe$Just(translate + (" " + (scale + (" " + rotate))));
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn = function (options, rule, maybePseudo) {
        switch (rule.$) {
            case 0:
                var selector = rule.a;
                var props = rule.b;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, selector, props);
            case 13:
                var name = rule.a;
                var prop = rule.b;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("box-shadow", prop)
                ]));
            case 12:
                var name = rule.a;
                var transparency = rule.b;
                var opacity = $elm$core$Basics$max_fn(0, $elm$core$Basics$min_fn(1, 1 - transparency));
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("opacity", $elm$core$String$fromFloat(opacity))
                ]));
            case 2:
                var i = rule.a;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, ".font-size-" + $elm$core$String$fromInt(i), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-size", $elm$core$String$fromInt(i) + "px")
                ]));
            case 1:
                var name = rule.a;
                var typefaces = rule.b;
                var features = $elm$core$String$join_fn(", ", $elm$core$List$filterMap_fn($mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
                var families = _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-family", $elm$core$String$join_fn(", ", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-feature-settings", features),
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("font-variant", $elm$core$List$any_fn($mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? "small-caps" : "normal")
                ]);
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + name, families);
            case 3:
                var _class = rule.a;
                var prop = rule.b;
                var val = rule.c;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn(prop, val)
                ]));
            case 4:
                var _class = rule.a;
                var prop = rule.b;
                var color = rule.c;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn(prop, $mdgriffith$elm_ui$Internal$Model$formatColor(color))
                ]));
            case 5:
                var cls = rule.a;
                var x = rule.b;
                var y = rule.c;
                var yPx = $elm$core$String$fromInt(y) + "px";
                var xPx = $elm$core$String$fromInt(x) + "px";
                var single = "." + $mdgriffith$elm_ui$Internal$Style$classes.f7;
                var row = "." + $mdgriffith$elm_ui$Internal$Style$classes.f$;
                var wrappedRow = "." + ($mdgriffith$elm_ui$Internal$Style$classes.cK + row);
                var right = "." + $mdgriffith$elm_ui$Internal$Style$classes.cN;
                var paragraph = "." + $mdgriffith$elm_ui$Internal$Style$classes.ch;
                var page = "." + $mdgriffith$elm_ui$Internal$Style$classes.dB;
                var left = "." + $mdgriffith$elm_ui$Internal$Style$classes.cM;
                var halfY = $elm$core$String$fromFloat(y / 2) + "px";
                var halfX = $elm$core$String$fromFloat(x / 2) + "px";
                var column = "." + $mdgriffith$elm_ui$Internal$Style$classes.aj;
                var _class = "." + cls;
                var any = "." + $mdgriffith$elm_ui$Internal$Style$classes.ex;
                return $elm$core$List$concat(_List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (row + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (wrappedRow + (" > " + any)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin", halfY + (" " + halfX))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (column + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", yPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + (any + (" + " + any)))), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", yPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + left)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-right", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (page + (" > " + right)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _Utils_ap(_class, paragraph), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("line-height", "calc(1em + " + ($elm$core$String$fromInt(y) + "px)"))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "textarea" + (any + _class), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("line-height", "calc(1em + " + ($elm$core$String$fromInt(y) + "px)")),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "calc(100% + " + ($elm$core$String$fromInt(y) + "px)"))
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + (" > " + left)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-right", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + (" > " + right)), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-left", xPx)
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + "::after"), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("content", "''"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("display", "block"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("width", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-top", $elm$core$String$fromInt((-1) * ((y / 2) | 0)) + "px")
                    ])),
                    $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class + (paragraph + "::before"), _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("content", "''"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("display", "block"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("height", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("width", "0"),
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("margin-bottom", $elm$core$String$fromInt((-1) * ((y / 2) | 0)) + "px")
                    ]))
                ]));
            case 7:
                var cls = rule.a;
                var top = rule.b;
                var right = rule.c;
                var bottom = rule.d;
                var left = rule.e;
                var _class = "." + cls;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("padding", $elm$core$String$fromFloat(top) + ("px " + ($elm$core$String$fromFloat(right) + ("px " + ($elm$core$String$fromFloat(bottom) + ("px " + ($elm$core$String$fromFloat(left) + "px")))))))
                ]));
            case 6:
                var cls = rule.a;
                var top = rule.b;
                var right = rule.c;
                var bottom = rule.d;
                var left = rule.e;
                var _class = "." + cls;
                return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, _class, _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Property_fn("border-width", $elm$core$String$fromInt(top) + ("px " + ($elm$core$String$fromInt(right) + ("px " + ($elm$core$String$fromInt(bottom) + ("px " + ($elm$core$String$fromInt(left) + "px")))))))
                ]));
            case 8:
                var template = rule.a;
                var toGridLengthHelper = F3(function (minimum, maximum, x) {
                    toGridLengthHelper: while (true) {
                        switch (x.$) {
                            case 0:
                                var px = x.a;
                                return $elm$core$String$fromInt(px) + "px";
                            case 1:
                                var _v2 = _Utils_Tuple2(minimum, maximum);
                                if (_v2.a.$ === 1) {
                                    if (_v2.b.$ === 1) {
                                        var _v3 = _v2.a;
                                        var _v4 = _v2.b;
                                        return "max-content";
                                    }
                                    else {
                                        var _v6 = _v2.a;
                                        var maxSize = _v2.b.a;
                                        return "minmax(max-content, " + ($elm$core$String$fromInt(maxSize) + "px)");
                                    }
                                }
                                else {
                                    if (_v2.b.$ === 1) {
                                        var minSize = _v2.a.a;
                                        var _v5 = _v2.b;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + "max-content)"));
                                    }
                                    else {
                                        var minSize = _v2.a.a;
                                        var maxSize = _v2.b.a;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(maxSize) + "px)")));
                                    }
                                }
                            case 2:
                                var i = x.a;
                                var _v7 = _Utils_Tuple2(minimum, maximum);
                                if (_v7.a.$ === 1) {
                                    if (_v7.b.$ === 1) {
                                        var _v8 = _v7.a;
                                        var _v9 = _v7.b;
                                        return $elm$core$String$fromInt(i) + "fr";
                                    }
                                    else {
                                        var _v11 = _v7.a;
                                        var maxSize = _v7.b.a;
                                        return "minmax(max-content, " + ($elm$core$String$fromInt(maxSize) + "px)");
                                    }
                                }
                                else {
                                    if (_v7.b.$ === 1) {
                                        var minSize = _v7.a.a;
                                        var _v10 = _v7.b;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(i) + ("fr" + "fr)"))));
                                    }
                                    else {
                                        var minSize = _v7.a.a;
                                        var maxSize = _v7.b.a;
                                        return "minmax(" + ($elm$core$String$fromInt(minSize) + ("px, " + ($elm$core$String$fromInt(maxSize) + "px)")));
                                    }
                                }
                            case 3:
                                var m = x.a;
                                var len = x.b;
                                var $temp$minimum = $elm$core$Maybe$Just(m), $temp$maximum = maximum, $temp$x = len;
                                minimum = $temp$minimum;
                                maximum = $temp$maximum;
                                x = $temp$x;
                                continue toGridLengthHelper;
                            default:
                                var m = x.a;
                                var len = x.b;
                                var $temp$minimum = minimum, $temp$maximum = $elm$core$Maybe$Just(m), $temp$x = len;
                                minimum = $temp$minimum;
                                maximum = $temp$maximum;
                                x = $temp$x;
                                continue toGridLengthHelper;
                        }
                    }
                });
                var toGridLength = function (x) {
                    return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
                };
                var xSpacing = toGridLength(template.ga.a);
                var ySpacing = toGridLength(template.ga.b);
                var rows = function (x) {
                    return "grid-template-rows: " + (x + ";");
                }($elm$core$String$join_fn(" ", $elm$core$List$map_fn(toGridLength, template.M)));
                var msRows = function (x) {
                    return "-ms-grid-rows: " + (x + ";");
                }($elm$core$String$join_fn(ySpacing, $elm$core$List$map_fn(toGridLength, template.eS)));
                var msColumns = function (x) {
                    return "-ms-grid-columns: " + (x + ";");
                }($elm$core$String$join_fn(ySpacing, $elm$core$List$map_fn(toGridLength, template.eS)));
                var gapY = "grid-row-gap:" + (toGridLength(template.ga.b) + ";");
                var gapX = "grid-column-gap:" + (toGridLength(template.ga.a) + ";");
                var columns = function (x) {
                    return "grid-template-columns: " + (x + ";");
                }($elm$core$String$join_fn(" ", $elm$core$List$map_fn(toGridLength, template.eS)));
                var _class = ".grid-rows-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.M)) + ("-cols-" + ($elm$core$String$join_fn("-", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$lengthClassName, template.eS)) + ("-space-x-" + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.ga.a) + ("-space-y-" + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.ga.b)))))));
                var modernGrid = _class + ("{" + (columns + (rows + (gapX + (gapY + "}")))));
                var supports = "@supports (display:grid) {" + (modernGrid + "}");
                var base = _class + ("{" + (msColumns + (msRows + "}")));
                return _List_fromArray([base, supports]);
            case 9:
                var position = rule.a;
                var msPosition = $elm$core$String$join_fn(" ", _List_fromArray([
                    "-ms-grid-row: " + ($elm$core$String$fromInt(position.f$) + ";"),
                    "-ms-grid-row-span: " + ($elm$core$String$fromInt(position.bj) + ";"),
                    "-ms-grid-column: " + ($elm$core$String$fromInt(position.aG) + ";"),
                    "-ms-grid-column-span: " + ($elm$core$String$fromInt(position.bE) + ";")
                ]));
                var modernPosition = $elm$core$String$join_fn(" ", _List_fromArray([
                    "grid-row: " + ($elm$core$String$fromInt(position.f$) + (" / " + ($elm$core$String$fromInt(position.f$ + position.bj) + ";"))),
                    "grid-column: " + ($elm$core$String$fromInt(position.aG) + (" / " + ($elm$core$String$fromInt(position.aG + position.bE) + ";")))
                ]));
                var _class = ".grid-pos-" + ($elm$core$String$fromInt(position.f$) + ("-" + ($elm$core$String$fromInt(position.aG) + ("-" + ($elm$core$String$fromInt(position.bE) + ("-" + $elm$core$String$fromInt(position.bj)))))));
                var modernGrid = _class + ("{" + (modernPosition + "}"));
                var supports = "@supports (display:grid) {" + (modernGrid + "}");
                var base = _class + ("{" + (msPosition + "}"));
                return _List_fromArray([base, supports]);
            case 11:
                var _class = rule.a;
                var styles = rule.b;
                var renderPseudoRule = function (style) {
                    return $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Just(_class));
                };
                return $elm$core$List$concatMap_fn(renderPseudoRule, styles);
            default:
                var transform = rule.a;
                var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
                var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
                var _v12 = _Utils_Tuple2(_class, val);
                if ((!_v12.a.$) && (!_v12.b.$)) {
                    var cls = _v12.a.a;
                    var v = _v12.b.a;
                    return $mdgriffith$elm_ui$Internal$Model$renderStyle_fn(options, maybePseudo, "." + cls, _List_fromArray([
                        $mdgriffith$elm_ui$Internal$Model$Property_fn("transform", v)
                    ]));
                }
                else {
                    return _List_Nil;
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3($mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$encodeStyles_fn = function (options, stylesheet) {
        return $elm$json$Json$Encode$object($elm$core$List$map_fn(function (style) {
            var styled = $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Nothing);
            return _Utils_Tuple2($mdgriffith$elm_ui$Internal$Model$getStyleName(style), $elm$json$Json$Encode$list_fn($elm$json$Json$Encode$string, styled));
        }, stylesheet));
    }, $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2($mdgriffith$elm_ui$Internal$Model$encodeStyles_fn);
    var $mdgriffith$elm_ui$Internal$Model$bracket_fn = function (selector, rules) {
        var renderPair = function (_v0) {
            var name = _v0.a;
            var val = _v0.b;
            return name + (": " + (val + ";"));
        };
        return selector + (" {" + ($elm$core$String$join_fn("", $elm$core$List$map_fn(renderPair, rules)) + "}"));
    }, $mdgriffith$elm_ui$Internal$Model$bracket = F2($mdgriffith$elm_ui$Internal$Model$bracket_fn);
    var $mdgriffith$elm_ui$Internal$Model$fontRule_fn = function (name, modifier, _v0) {
        var parentAdj = _v0.a;
        var textAdjustment = _v0.b;
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + (modifier + (", " + ("." + (name + (" ." + modifier))))))), parentAdj),
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + (modifier + ("> ." + ($mdgriffith$elm_ui$Internal$Style$classes.gk + (", ." + (name + (" ." + (modifier + (" > ." + $mdgriffith$elm_ui$Internal$Style$classes.gk)))))))))), textAdjustment)
        ]);
    }, $mdgriffith$elm_ui$Internal$Model$fontRule = F3($mdgriffith$elm_ui$Internal$Model$fontRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule_fn = function (fontToAdjust, _v0, otherFontName) {
        var full = _v0.a;
        var capital = _v0.b;
        var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (" ." + fontToAdjust));
        return $elm$core$String$join_fn(" ", _Utils_ap($mdgriffith$elm_ui$Internal$Model$fontRule_fn(name, $mdgriffith$elm_ui$Internal$Style$classes.f8, capital), $mdgriffith$elm_ui$Internal$Model$fontRule_fn(name, $mdgriffith$elm_ui$Internal$Style$classes.e9, full)));
    }, $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule_fn = function (fontToAdjust, otherFontName) {
        var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (" ." + fontToAdjust));
        return $elm$core$String$join_fn(" ", _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.f8 + (", " + ("." + (name + (" ." + $mdgriffith$elm_ui$Internal$Style$classes.f8))))))), _List_fromArray([
                _Utils_Tuple2("line-height", "1")
            ])),
            $mdgriffith$elm_ui$Internal$Model$bracket_fn("." + (name + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.f8 + ("> ." + ($mdgriffith$elm_ui$Internal$Style$classes.gk + (", ." + (name + (" ." + ($mdgriffith$elm_ui$Internal$Style$classes.f8 + (" > ." + $mdgriffith$elm_ui$Internal$Style$classes.gk)))))))))), _List_fromArray([
                _Utils_Tuple2("vertical-align", "0"),
                _Utils_Tuple2("line-height", "1")
            ]))
        ]));
    }, $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2($mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule_fn);
    var $mdgriffith$elm_ui$Internal$Model$adjust_fn = function (size, height, vertical) {
        return { bj: height / size, cq: size, ec: vertical };
    }, $mdgriffith$elm_ui$Internal$Model$adjust = F3($mdgriffith$elm_ui$Internal$Model$adjust_fn);
    var $elm$core$List$minimum = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just($elm$core$List$foldl_fn($elm$core$Basics$min, x, xs));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$Basics$neq = _Utils_notEqual;
    var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
        var lines = _List_fromArray([adjustment.eL, adjustment.eA, adjustment.eY, adjustment.fv]);
        var lineHeight = 1.5;
        var normalDescender = (lineHeight - 1) / 2;
        var oldMiddle = lineHeight / 2;
        var descender = $elm$core$Maybe$withDefault_fn(adjustment.eY, $elm$core$List$minimum(lines));
        var newBaseline = $elm$core$Maybe$withDefault_fn(adjustment.eA, $elm$core$List$minimum($elm$core$List$filter_fn(function (x) {
            return !_Utils_eq(x, descender);
        }, lines)));
        var base = lineHeight;
        var ascender = $elm$core$Maybe$withDefault_fn(adjustment.eL, $elm$core$List$maximum(lines));
        var capitalSize = 1 / (ascender - newBaseline);
        var capitalVertical = 1 - ascender;
        var fullSize = 1 / (ascender - descender);
        var fullVertical = 1 - ascender;
        var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
        var newFullMiddle = ((ascender - descender) / 2) + descender;
        return {
            eL: $mdgriffith$elm_ui$Internal$Model$adjust_fn(capitalSize, ascender - newBaseline, capitalVertical),
            c8: $mdgriffith$elm_ui$Internal$Model$adjust_fn(fullSize, ascender - descender, fullVertical)
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
        return _Utils_Tuple2(_List_fromArray([
            _Utils_Tuple2("display", "block")
        ]), _List_fromArray([
            _Utils_Tuple2("display", "inline-block"),
            _Utils_Tuple2("line-height", $elm$core$String$fromFloat(converted.bj)),
            _Utils_Tuple2("vertical-align", $elm$core$String$fromFloat(converted.ec) + "em"),
            _Utils_Tuple2("font-size", $elm$core$String$fromFloat(converted.cq) + "em")
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
        return $elm$core$List$foldl_fn_unwrapped(function (face, found) {
            if (found.$ === 1) {
                if (face.$ === 5) {
                    var _with = face.a;
                    var _v2 = _with.el;
                    if (_v2.$ === 1) {
                        return found;
                    }
                    else {
                        var adjustment = _v2.a;
                        return $elm$core$Maybe$Just(_Utils_Tuple2($mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(function ($) {
                            return $.c8;
                        }($mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))), $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(function ($) {
                            return $.eL;
                        }($mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
                    }
                }
                else {
                    return found;
                }
            }
            else {
                return found;
            }
        }, $elm$core$Maybe$Nothing, typefaces);
    };
    var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
        var withImport = function (font) {
            if (font.$ === 4) {
                var url = font.b;
                return $elm$core$Maybe$Just("@import url('" + (url + "');"));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        };
        var fontImports = function (_v2) {
            var name = _v2.a;
            var typefaces = _v2.b;
            var imports = $elm$core$String$join_fn("\n", $elm$core$List$filterMap_fn(withImport, typefaces));
            return imports;
        };
        var allNames = $elm$core$List$map_fn($elm$core$Tuple$first, rules);
        var fontAdjustments = function (_v1) {
            var name = _v1.a;
            var typefaces = _v1.b;
            var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
            if (_v0.$ === 1) {
                return $elm$core$String$join_fn("", $elm$core$List$map_fn($mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name), allNames));
            }
            else {
                var adjustment = _v0.a;
                return $elm$core$String$join_fn("", $elm$core$List$map_fn(A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment), allNames));
            }
        };
        return _Utils_ap($elm$core$String$join_fn("\n", $elm$core$List$map_fn(fontImports, rules)), $elm$core$String$join_fn("\n", $elm$core$List$map_fn(fontAdjustments, rules)));
    };
    var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
        if (rule.$ === 1) {
            var name = rule.a;
            var typefaces = rule.b;
            return $elm$core$Maybe$Just(_Utils_Tuple2(name, typefaces));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn = function (options, stylesheet) {
        var combine = F2(function (style, rendered) {
            return {
                bu: _Utils_ap(rendered.bu, $mdgriffith$elm_ui$Internal$Model$renderStyleRule_fn(options, style, $elm$core$Maybe$Nothing)),
                a0: function () {
                    var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
                    if (_v1.$ === 1) {
                        return rendered.a0;
                    }
                    else {
                        var topLevel = _v1.a;
                        return _List_Cons(topLevel, rendered.a0);
                    }
                }()
            };
        });
        var _v0 = $elm$core$List$foldl_fn(combine, { bu: _List_Nil, a0: _List_Nil }, stylesheet);
        var topLevel = _v0.a0;
        var rules = _v0.bu;
        return _Utils_ap($mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel), $elm$core$String$concat(rules));
    }, $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn);
    var $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn = function (options, styleSheet) {
        var _v0 = options.fy;
        switch (_v0) {
            case 0:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn(options, styleSheet))
                    ]))
                ]));
            case 1:
                return A3($elm$virtual_dom$VirtualDom$node, "div", _List_Nil, _List_fromArray([
                    A3($elm$virtual_dom$VirtualDom$node, "style", _List_Nil, _List_fromArray([
                        $elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Model$toStyleSheetString_fn(options, styleSheet))
                    ]))
                ]));
            default:
                return A3($elm$virtual_dom$VirtualDom$node, "elm-ui-rules", _List_fromArray([
                    $elm$virtual_dom$VirtualDom$property_fn("rules", $mdgriffith$elm_ui$Internal$Model$encodeStyles_fn(options, styleSheet))
                ]), _List_Nil);
        }
    }, $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2($mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn);
    var $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn = function (_static, opts, styles, children) {
        var dynamicStyleSheet = $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn(opts, $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$reduceStyles, _Utils_Tuple2($elm$core$Set$empty, $mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.e8)), styles).b);
        return _static ? _List_Cons(_Utils_Tuple2("static-stylesheet", $mdgriffith$elm_ui$Internal$Model$staticRoot(opts)), _List_Cons(_Utils_Tuple2("dynamic-stylesheet", dynamicStyleSheet), children)) : _List_Cons(_Utils_Tuple2("dynamic-stylesheet", dynamicStyleSheet), children);
    }, $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4($mdgriffith$elm_ui$Internal$Model$embedKeyed_fn);
    var $mdgriffith$elm_ui$Internal$Model$embedWith_fn = function (_static, opts, styles, children) {
        var dynamicStyleSheet = $mdgriffith$elm_ui$Internal$Model$toStyleSheet_fn(opts, $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$reduceStyles, _Utils_Tuple2($elm$core$Set$empty, $mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.e8)), styles).b);
        return _static ? _List_Cons($mdgriffith$elm_ui$Internal$Model$staticRoot(opts), _List_Cons(dynamicStyleSheet, children)) : _List_Cons(dynamicStyleSheet, children);
    }, $mdgriffith$elm_ui$Internal$Model$embedWith = F4($mdgriffith$elm_ui$Internal$Model$embedWith_fn);
    var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
    var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
    var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
        return _VirtualDom_keyedNodeNS_fn(_VirtualDom_keyedNode_a0, _VirtualDom_noScript(tag));
    };
    var $elm$html$Html$p = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "p"), $elm$html$Html$p_fn = $elm$html$Html$p.f;
    var $elm$core$Bitwise$and = _Bitwise_and;
    var $mdgriffith$elm_ui$Internal$Flag$present_fn = function (myFlag, _v0) {
        var fieldOne = _v0.a;
        var fieldTwo = _v0.b;
        if (!myFlag.$) {
            var first = myFlag.a;
            return _Utils_eq(first & fieldOne, first);
        }
        else {
            var second = myFlag.a;
            return _Utils_eq(second & fieldTwo, second);
        }
    }, $mdgriffith$elm_ui$Internal$Flag$present = F2($mdgriffith$elm_ui$Internal$Flag$present_fn);
    var $elm$html$Html$s = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "s"), $elm$html$Html$s_fn = $elm$html$Html$s.f;
    var $elm$html$Html$u = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "u"), $elm$html$Html$u_fn = $elm$html$Html$u.f;
    var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
    var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
    var $mdgriffith$elm_ui$Internal$Model$finalizeNode_fn = function (has, node, attributes, children, embedMode, parentContext) {
        var createNode = F2(function (nodeName, attrs) {
            if (children.$ === 1) {
                var keyed = children.a;
                return A3($elm$virtual_dom$VirtualDom$keyedNode, nodeName, attrs, function () {
                    switch (embedMode.$) {
                        case 0:
                            return keyed;
                        case 2:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn(false, opts, styles, keyed);
                        default:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedKeyed_fn(true, opts, styles, keyed);
                    }
                }());
            }
            else {
                var unkeyed = children.a;
                return A2(function () {
                    switch (nodeName) {
                        case "div":
                            return $elm$html$Html$div;
                        case "p":
                            return $elm$html$Html$p;
                        default:
                            return $elm$virtual_dom$VirtualDom$node(nodeName);
                    }
                }(), attrs, function () {
                    switch (embedMode.$) {
                        case 0:
                            return unkeyed;
                        case 2:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedWith_fn(false, opts, styles, unkeyed);
                        default:
                            var opts = embedMode.a;
                            var styles = embedMode.b;
                            return $mdgriffith$elm_ui$Internal$Model$embedWith_fn(true, opts, styles, unkeyed);
                    }
                }());
            }
        });
        var html = function () {
            switch (node.$) {
                case 0:
                    return A2(createNode, "div", attributes);
                case 1:
                    var nodeName = node.a;
                    return A2(createNode, nodeName, attributes);
                default:
                    var nodeName = node.a;
                    var internal = node.b;
                    return A3($elm$virtual_dom$VirtualDom$node, nodeName, attributes, _List_fromArray([
                        A2(createNode, internal, _List_fromArray([
                            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + $mdgriffith$elm_ui$Internal$Style$classes.f7))
                        ]))
                    ]));
            }
        }();
        switch (parentContext) {
            case 0:
                return ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!$mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? $elm$html$Html$u_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.ex, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.bd, $mdgriffith$elm_ui$Internal$Style$classes.ak, $mdgriffith$elm_ui$Internal$Style$classes.es])))
                ]), _List_fromArray([html])) : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$centerX, has) ? $elm$html$Html$s_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.ex, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.bd, $mdgriffith$elm_ui$Internal$Style$classes.ak, $mdgriffith$elm_ui$Internal$Style$classes.eq])))
                ]), _List_fromArray([html])) : html));
            case 1:
                return ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!$mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$centerY, has) ? $elm$html$Html$s_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.ex, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.bd, $mdgriffith$elm_ui$Internal$Style$classes.er])))
                ]), _List_fromArray([html])) : ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? $elm$html$Html$u_fn(_List_fromArray([
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.ex, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.bd, $mdgriffith$elm_ui$Internal$Style$classes.ep])))
                ]), _List_fromArray([html])) : html));
            default:
                return html;
        }
    }, $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6($mdgriffith$elm_ui$Internal$Model$finalizeNode_fn);
    var $elm$core$List$isEmpty = function (xs) {
        if (!xs.b) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
    var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.gk + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.cI + (" " + $mdgriffith$elm_ui$Internal$Style$classes.b1)))));
    var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Model$textElementClasses)
        ]), _List_fromArray([
            $elm$html$Html$text(str)
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.ex + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.gk + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.cJ + (" " + $mdgriffith$elm_ui$Internal$Style$classes.b2)))));
    var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
        ]), _List_fromArray([
            $elm$html$Html$text(str)
        ]));
    };
    var $mdgriffith$elm_ui$Internal$Model$createElement_fn = function (context, children, rendered) {
        var gatherKeyed = F2(function (_v8, _v9) {
            var key = _v8.a;
            var child = _v8.b;
            var htmls = _v9.a;
            var existingStyles = _v9.b;
            switch (child.$) {
                case 0:
                    var html = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, html(context)), htmls), existingStyles) : _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, html(context)), htmls), existingStyles);
                case 1:
                    var styled = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, A2(styled.b3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.d0 : _Utils_ap(styled.d0, existingStyles)) : _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, A2(styled.b3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.d0 : _Utils_ap(styled.d0, existingStyles));
                case 2:
                    var str = child.a;
                    return _Utils_Tuple2(_List_Cons(_Utils_Tuple2(key, _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)), htmls), existingStyles);
                default:
                    return _Utils_Tuple2(htmls, existingStyles);
            }
        });
        var gather = F2(function (child, _v6) {
            var htmls = _v6.a;
            var existingStyles = _v6.b;
            switch (child.$) {
                case 0:
                    var html = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(html(context), htmls), existingStyles) : _Utils_Tuple2(_List_Cons(html(context), htmls), existingStyles);
                case 1:
                    var styled = child.a;
                    return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(_List_Cons(A2(styled.b3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.d0 : _Utils_ap(styled.d0, existingStyles)) : _Utils_Tuple2(_List_Cons(A2(styled.b3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context), htmls), $elm$core$List$isEmpty(existingStyles) ? styled.d0 : _Utils_ap(styled.d0, existingStyles));
                case 2:
                    var str = child.a;
                    return _Utils_Tuple2(_List_Cons(_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str), htmls), existingStyles);
                default:
                    return _Utils_Tuple2(htmls, existingStyles);
            }
        });
        if (children.$ === 1) {
            var keyedChildren = children.a;
            var _v1 = $elm$core$List$foldr_fn(gatherKeyed, _Utils_Tuple2(_List_Nil, _List_Nil), keyedChildren);
            var keyed = _v1.a;
            var styles = _v1.b;
            var newStyles = $elm$core$List$isEmpty(styles) ? rendered.d0 : _Utils_ap(rendered.d0, styles);
            if (!newStyles.b) {
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A5($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.ax, rendered.dy, rendered.au, $mdgriffith$elm_ui$Internal$Model$Keyed($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn("nearby-element-pls", keyed, rendered.P)), $mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
            }
            else {
                var allStyles = newStyles;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    b3: A4($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.ax, rendered.dy, rendered.au, $mdgriffith$elm_ui$Internal$Model$Keyed($mdgriffith$elm_ui$Internal$Model$addKeyedChildren_fn("nearby-element-pls", keyed, rendered.P))),
                    d0: allStyles
                });
            }
        }
        else {
            var unkeyedChildren = children.a;
            var _v3 = $elm$core$List$foldr_fn(gather, _Utils_Tuple2(_List_Nil, _List_Nil), unkeyedChildren);
            var unkeyed = _v3.a;
            var styles = _v3.b;
            var newStyles = $elm$core$List$isEmpty(styles) ? rendered.d0 : _Utils_ap(rendered.d0, styles);
            if (!newStyles.b) {
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A5($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.ax, rendered.dy, rendered.au, $mdgriffith$elm_ui$Internal$Model$Unkeyed($mdgriffith$elm_ui$Internal$Model$addChildren_fn(unkeyed, rendered.P)), $mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
            }
            else {
                var allStyles = newStyles;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    b3: A4($mdgriffith$elm_ui$Internal$Model$finalizeNode, rendered.ax, rendered.dy, rendered.au, $mdgriffith$elm_ui$Internal$Model$Unkeyed($mdgriffith$elm_ui$Internal$Model$addChildren_fn(unkeyed, rendered.P))),
                    d0: allStyles
                });
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$createElement = F3($mdgriffith$elm_ui$Internal$Model$createElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$Single_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$Single = F3($mdgriffith$elm_ui$Internal$Model$Single_fn);
    var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
        return { $: 10, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$Field_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Flag$Field = F2($mdgriffith$elm_ui$Internal$Flag$Field_fn);
    var $elm$core$Bitwise$or = _Bitwise_or;
    var $mdgriffith$elm_ui$Internal$Flag$add_fn = function (myFlag, _v0) {
        var one = _v0.a;
        var two = _v0.b;
        if (!myFlag.$) {
            var first = myFlag.a;
            return $mdgriffith$elm_ui$Internal$Flag$Field_fn(first | one, two);
        }
        else {
            var second = myFlag.a;
            return $mdgriffith$elm_ui$Internal$Flag$Field_fn(one, second | two);
        }
    }, $mdgriffith$elm_ui$Internal$Flag$add = F2($mdgriffith$elm_ui$Internal$Flag$add_fn);
    var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2($mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn);
    var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$nearbyElement_fn = function (location, elem) {
        return $elm$html$Html$div_fn(_List_fromArray([
            $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, function () {
                switch (location) {
                    case 0:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.ej]));
                    case 1:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.eC]));
                    case 2:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.fN]));
                    case 3:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.fM]));
                    case 4:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.fk]));
                    default:
                        return $elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.aI, $mdgriffith$elm_ui$Internal$Style$classes.f7, $mdgriffith$elm_ui$Internal$Style$classes.eB]));
                }
            }())
        ]), _List_fromArray([
            function () {
                switch (elem.$) {
                    case 3:
                        return $elm$virtual_dom$VirtualDom$text("");
                    case 2:
                        var str = elem.a;
                        return $mdgriffith$elm_ui$Internal$Model$textElement(str);
                    case 0:
                        var html = elem.a;
                        return html($mdgriffith$elm_ui$Internal$Model$asEl);
                    default:
                        var styled = elem.a;
                        return A2(styled.b3, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
                }
            }()
        ]));
    }, $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2($mdgriffith$elm_ui$Internal$Model$nearbyElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn = function (location, elem, existing) {
        var nearby = $mdgriffith$elm_ui$Internal$Model$nearbyElement_fn(location, elem);
        switch (existing.$) {
            case 0:
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(_List_fromArray([nearby]));
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(_List_fromArray([nearby]));
                }
            case 1:
                var existingBehind = existing.a;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(_List_Cons(nearby, existingBehind));
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(existingBehind, _List_fromArray([nearby]));
                }
            case 2:
                var existingInFront = existing.a;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(_List_fromArray([nearby]), existingInFront);
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(_List_Cons(nearby, existingInFront));
                }
            default:
                var existingBehind = existing.a;
                var existingInFront = existing.b;
                if (location === 5) {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(_List_Cons(nearby, existingBehind), existingInFront);
                }
                else {
                    return $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront_fn(existingBehind, _List_Cons(nearby, existingInFront));
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3($mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn);
    var $mdgriffith$elm_ui$Internal$Model$Embedded_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Embedded = F2($mdgriffith$elm_ui$Internal$Model$Embedded_fn);
    var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$addNodeName_fn = function (newNode, old) {
        switch (old.$) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
            case 1:
                var name = old.a;
                return $mdgriffith$elm_ui$Internal$Model$Embedded_fn(name, newNode);
            default:
                var x = old.a;
                var y = old.b;
                return $mdgriffith$elm_ui$Internal$Model$Embedded_fn(x, y);
        }
    }, $mdgriffith$elm_ui$Internal$Model$addNodeName = F2($mdgriffith$elm_ui$Internal$Model$addNodeName_fn);
    var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
        switch (align) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Style$classes.bG + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cM);
            case 2:
                return $mdgriffith$elm_ui$Internal$Style$classes.bG + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cN);
            default:
                return $mdgriffith$elm_ui$Internal$Style$classes.bG + (" " + $mdgriffith$elm_ui$Internal$Style$classes.en);
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
        switch (align) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Style$classes.bH + (" " + $mdgriffith$elm_ui$Internal$Style$classes.et);
            case 2:
                return $mdgriffith$elm_ui$Internal$Style$classes.bH + (" " + $mdgriffith$elm_ui$Internal$Style$classes.em);
            default:
                return $mdgriffith$elm_ui$Internal$Style$classes.bH + (" " + $mdgriffith$elm_ui$Internal$Style$classes.eo);
        }
    };
    var $elm$virtual_dom$VirtualDom$attribute_fn = function (key, value) {
        return _VirtualDom_attribute_fn(_VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    }, $elm$virtual_dom$VirtualDom$attribute = F2($elm$virtual_dom$VirtualDom$attribute_fn);
    var $mdgriffith$elm_ui$Internal$Model$FullTransform_fn = function (a, b, c, d) {
        return { $: 2, a: a, b: b, c: c, d: d };
    }, $mdgriffith$elm_ui$Internal$Model$FullTransform = F4($mdgriffith$elm_ui$Internal$Model$FullTransform_fn);
    var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn = function (transform, component) {
        switch (transform.$) {
            case 0:
                switch (component.$) {
                    case 0:
                        var x = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, 0, 0));
                    case 1:
                        var y = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(0, y, 0));
                    case 2:
                        var z = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(0, 0, z));
                    case 3:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
                    case 4:
                        var xyz = component.a;
                        var angle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(0, 0, 0), _Utils_Tuple3(1, 1, 1), xyz, angle);
                    default:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(0, 0, 0), xyz, _Utils_Tuple3(0, 0, 1), 0);
                }
            case 1:
                var moved = transform.a;
                var x = moved.a;
                var y = moved.b;
                var z = moved.c;
                switch (component.$) {
                    case 0:
                        var newX = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(newX, y, z));
                    case 1:
                        var newY = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, newY, z));
                    case 2:
                        var newZ = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(_Utils_Tuple3(x, y, newZ));
                    case 3:
                        var xyz = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
                    case 4:
                        var xyz = component.a;
                        var angle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, _Utils_Tuple3(1, 1, 1), xyz, angle);
                    default:
                        var scale = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, scale, _Utils_Tuple3(0, 0, 1), 0);
                }
            default:
                var moved = transform.a;
                var x = moved.a;
                var y = moved.b;
                var z = moved.c;
                var scaled = transform.b;
                var origin = transform.c;
                var angle = transform.d;
                switch (component.$) {
                    case 0:
                        var newX = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(newX, y, z), scaled, origin, angle);
                    case 1:
                        var newY = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(x, newY, z), scaled, origin, angle);
                    case 2:
                        var newZ = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(_Utils_Tuple3(x, y, newZ), scaled, origin, angle);
                    case 3:
                        var newMove = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(newMove, scaled, origin, angle);
                    case 4:
                        var newOrigin = component.a;
                        var newAngle = component.b;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, scaled, newOrigin, newAngle);
                    default:
                        var newScale = component.a;
                        return $mdgriffith$elm_ui$Internal$Model$FullTransform_fn(moved, newScale, origin, angle);
                }
        }
    }, $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2($mdgriffith$elm_ui$Internal$Model$composeTransformation_fn);
    var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
    var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
    var $mdgriffith$elm_ui$Internal$Flag$merge_fn = function (_v0, _v1) {
        var one = _v0.a;
        var two = _v0.b;
        var three = _v1.a;
        var four = _v1.b;
        return $mdgriffith$elm_ui$Internal$Flag$Field_fn(one | three, two | four);
    }, $mdgriffith$elm_ui$Internal$Flag$merge = F2($mdgriffith$elm_ui$Internal$Flag$merge_fn);
    var $mdgriffith$elm_ui$Internal$Flag$none = $mdgriffith$elm_ui$Internal$Flag$Field_fn(0, 0);
    var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
        switch (h.$) {
            case 0:
                var px = h.a;
                var val = $elm$core$String$fromInt(px);
                var name = "height-px-" + val;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Style$classes.dd + (" " + name), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn(name, "height", val + "px")
                ]));
            case 1:
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.b1, _List_Nil);
            case 2:
                var portion = h.a;
                return (portion === 1) ? _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.b2, _List_Nil) : _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.de + (" height-fill-" + $elm$core$String$fromInt(portion)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.ex + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.aj + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("height-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000))
                ]));
            case 3:
                var minSize = h.a;
                var len = h.b;
                var cls = "min-height-" + $elm$core$String$fromInt(minSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "min-height", $elm$core$String$fromInt(minSize) + "px !important");
                var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
                var newFlag = _v1.a;
                var newAttrs = _v1.b;
                var newStyle = _v1.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
            default:
                var maxSize = h.a;
                var len = h.b;
                var cls = "max-height-" + $elm$core$String$fromInt(maxSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "max-height", $elm$core$String$fromInt(maxSize) + "px");
                var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
                var newFlag = _v2.a;
                var newAttrs = _v2.b;
                var newStyle = _v2.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
        }
    };
    var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
    var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
        switch (w.$) {
            case 0:
                var px = w.a;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Style$classes.ed + (" width-px-" + $elm$core$String$fromInt(px)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn("width-px-" + $elm$core$String$fromInt(px), "width", $elm$core$String$fromInt(px) + "px")
                ]));
            case 1:
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.cI, _List_Nil);
            case 2:
                var portion = w.a;
                return (portion === 1) ? _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.cJ, _List_Nil) : _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none), $mdgriffith$elm_ui$Internal$Style$classes.ee + (" width-fill-" + $elm$core$String$fromInt(portion)), _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.ex + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.f$ + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("width-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000))
                ]));
            case 3:
                var minSize = w.a;
                var len = w.b;
                var cls = "min-width-" + $elm$core$String$fromInt(minSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "min-width", $elm$core$String$fromInt(minSize) + "px");
                var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
                var newFlag = _v1.a;
                var newAttrs = _v1.b;
                var newStyle = _v1.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
            default:
                var maxSize = w.a;
                var len = w.b;
                var cls = "max-width-" + $elm$core$String$fromInt(maxSize);
                var style = $mdgriffith$elm_ui$Internal$Model$Single_fn(cls, "max-width", $elm$core$String$fromInt(maxSize) + "px");
                var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
                var newFlag = _v2.a;
                var newAttrs = _v2.b;
                var newStyle = _v2.c;
                return _Utils_Tuple3($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag), cls + (" " + newAttrs), _List_Cons(style, newStyle));
        }
    };
    var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
    var $elm$core$Basics$ge = _Utils_ge;
    var $mdgriffith$elm_ui$Internal$Model$skippable_fn = function (flag, style) {
        if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
            if (style.$ === 3) {
                var val = style.c;
                switch (val) {
                    case "0px":
                        return true;
                    case "1px":
                        return true;
                    case "2px":
                        return true;
                    case "3px":
                        return true;
                    case "4px":
                        return true;
                    case "5px":
                        return true;
                    case "6px":
                        return true;
                    default:
                        return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            switch (style.$) {
                case 2:
                    var i = style.a;
                    return (i >= 8) && (i <= 32);
                case 7:
                    var name = style.a;
                    var t = style.b;
                    var r = style.c;
                    var b = style.d;
                    var l = style.e;
                    return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
                default:
                    return false;
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$skippable = F2($mdgriffith$elm_ui$Internal$Model$skippable_fn);
    var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
    var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
    var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
    var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn = function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
        gatherAttrRecursive: while (true) {
            if (!elementAttrs.b) {
                var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
                if (_v1.$ === 1) {
                    return {
                        au: _List_Cons($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, classes), attrs),
                        P: children,
                        ax: has,
                        dy: node,
                        d0: styles
                    };
                }
                else {
                    var _class = _v1.a;
                    return {
                        au: _List_Cons($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, classes + (" " + _class)), attrs),
                        P: children,
                        ax: has,
                        dy: node,
                        d0: _List_Cons($mdgriffith$elm_ui$Internal$Model$Transform(transform), styles)
                    };
                }
            }
            else {
                var attribute = elementAttrs.a;
                var remaining = elementAttrs.b;
                switch (attribute.$) {
                    case 0:
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 3:
                        var flag = attribute.a;
                        var exactClassName = attribute.b;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn(flag, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = exactClassName + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                    case 1:
                        var actualAttribute = attribute.a;
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons(actualAttribute, attrs), $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 4:
                        var flag = attribute.a;
                        var style = attribute.b;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn(flag, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            if ($mdgriffith$elm_ui$Internal$Model$skippable_fn(flag, style)) {
                                var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            }
                            else {
                                var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = transform, $temp$styles = _List_Cons(style, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            }
                        }
                    case 10:
                        var flag = attribute.a;
                        var component = attribute.b;
                        var $temp$classes = classes, $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn(flag, has), $temp$transform = $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn(transform, component), $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 7:
                        var width = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$width, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            switch (width.$) {
                                case 0:
                                    var px = width.a;
                                    var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.ed + (" width-px-" + $elm$core$String$fromInt(px))) + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn("width-px-" + $elm$core$String$fromInt(px), "width", $elm$core$String$fromInt(px) + "px"), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 1:
                                    var $temp$classes = classes + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cI), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 2:
                                    var portion = width.a;
                                    if (portion === 1) {
                                        var $temp$classes = classes + (" " + $mdgriffith$elm_ui$Internal$Style$classes.cJ), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.ee + (" width-fill-" + $elm$core$String$fromInt(portion)))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.ex + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.f$ + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("width-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000)), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                default:
                                    var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
                                    var addToFlags = _v4.a;
                                    var newClass = _v4.b;
                                    var newStyles = _v4.c;
                                    var $temp$classes = classes + (" " + newClass), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$merge_fn(addToFlags, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$width, has)), $temp$transform = transform, $temp$styles = _Utils_ap(newStyles, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                            }
                        }
                    case 8:
                        var height = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$height, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            switch (height.$) {
                                case 0:
                                    var px = height.a;
                                    var val = $elm$core$String$fromInt(px) + "px";
                                    var name = "height-px-" + val;
                                    var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.dd + (" " + (name + (" " + classes))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn(name, "height ", val), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 1:
                                    var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.b1 + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                case 2:
                                    var portion = height.a;
                                    if (portion === 1) {
                                        var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.b2 + (" " + classes), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.de + (" height-fill-" + $elm$core$String$fromInt(portion)))), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = _List_Cons($mdgriffith$elm_ui$Internal$Model$Single_fn($mdgriffith$elm_ui$Internal$Style$classes.ex + ("." + ($mdgriffith$elm_ui$Internal$Style$classes.aj + (" > " + $mdgriffith$elm_ui$Internal$Style$dot("height-fill-" + $elm$core$String$fromInt(portion))))), "flex-grow", $elm$core$String$fromInt(portion * 100000)), styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                default:
                                    var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
                                    var addToFlags = _v6.a;
                                    var newClass = _v6.b;
                                    var newStyles = _v6.c;
                                    var $temp$classes = classes + (" " + newClass), $temp$node = node, $temp$has = $mdgriffith$elm_ui$Internal$Flag$merge_fn(addToFlags, $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$height, has)), $temp$transform = transform, $temp$styles = _Utils_ap(newStyles, styles), $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                            }
                        }
                    case 2:
                        var description = attribute.a;
                        switch (description.$) {
                            case 0:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("main", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 1:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("nav", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 2:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("footer", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 3:
                                var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("aside", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 4:
                                var i = description.a;
                                if (i <= 1) {
                                    var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h1", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                    classes = $temp$classes;
                                    node = $temp$node;
                                    has = $temp$has;
                                    transform = $temp$transform;
                                    styles = $temp$styles;
                                    attrs = $temp$attrs;
                                    children = $temp$children;
                                    elementAttrs = $temp$elementAttrs;
                                    continue gatherAttrRecursive;
                                }
                                else {
                                    if (i < 7) {
                                        var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h" + $elm$core$String$fromInt(i), node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                    else {
                                        var $temp$classes = classes, $temp$node = $mdgriffith$elm_ui$Internal$Model$addNodeName_fn("h6", node), $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                        classes = $temp$classes;
                                        node = $temp$node;
                                        has = $temp$has;
                                        transform = $temp$transform;
                                        styles = $temp$styles;
                                        attrs = $temp$attrs;
                                        children = $temp$children;
                                        elementAttrs = $temp$elementAttrs;
                                        continue gatherAttrRecursive;
                                    }
                                }
                            case 9:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 8:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("role", "button"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 5:
                                var label = description.a;
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-label", label), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            case 6:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-live", "polite"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                            default:
                                var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = _List_Cons($elm$virtual_dom$VirtualDom$attribute_fn("aria-live", "assertive"), attrs), $temp$children = children, $temp$elementAttrs = remaining;
                                classes = $temp$classes;
                                node = $temp$node;
                                has = $temp$has;
                                transform = $temp$transform;
                                styles = $temp$styles;
                                attrs = $temp$attrs;
                                children = $temp$children;
                                elementAttrs = $temp$elementAttrs;
                                continue gatherAttrRecursive;
                        }
                    case 9:
                        var location = attribute.a;
                        var elem = attribute.b;
                        var newStyles = function () {
                            switch (elem.$) {
                                case 3:
                                    return styles;
                                case 2:
                                    var str = elem.a;
                                    return styles;
                                case 0:
                                    var html = elem.a;
                                    return styles;
                                default:
                                    var styled = elem.a;
                                    return _Utils_ap(styles, styled.d0);
                            }
                        }();
                        var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = newStyles, $temp$attrs = attrs, $temp$children = $mdgriffith$elm_ui$Internal$Model$addNearbyElement_fn(location, elem, children), $temp$elementAttrs = remaining;
                        classes = $temp$classes;
                        node = $temp$node;
                        has = $temp$has;
                        transform = $temp$transform;
                        styles = $temp$styles;
                        attrs = $temp$attrs;
                        children = $temp$children;
                        elementAttrs = $temp$elementAttrs;
                        continue gatherAttrRecursive;
                    case 6:
                        var x = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (" " + classes), $temp$node = node, $temp$has = function (flags) {
                                switch (x) {
                                    case 1:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$centerX, flags);
                                    case 2:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
                                    default:
                                        return flags;
                                }
                            }($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$xAlign, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                    default:
                        var y = attribute.a;
                        if ($mdgriffith$elm_ui$Internal$Flag$present_fn($mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
                            var $temp$classes = classes, $temp$node = node, $temp$has = has, $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                        else {
                            var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (" " + classes), $temp$node = node, $temp$has = function (flags) {
                                switch (y) {
                                    case 1:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$centerY, flags);
                                    case 2:
                                        return $mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
                                    default:
                                        return flags;
                                }
                            }($mdgriffith$elm_ui$Internal$Flag$add_fn($mdgriffith$elm_ui$Internal$Flag$yAlign, has)), $temp$transform = transform, $temp$styles = styles, $temp$attrs = attrs, $temp$children = children, $temp$elementAttrs = remaining;
                            classes = $temp$classes;
                            node = $temp$node;
                            has = $temp$has;
                            transform = $temp$transform;
                            styles = $temp$styles;
                            attrs = $temp$attrs;
                            children = $temp$children;
                            elementAttrs = $temp$elementAttrs;
                            continue gatherAttrRecursive;
                        }
                }
            }
        }
    }, $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8($mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn);
    var $mdgriffith$elm_ui$Internal$Model$Untransformed = { $: 0 };
    var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
    var $mdgriffith$elm_ui$Internal$Model$element_fn = function (context, node, attributes, children) {
        return $mdgriffith$elm_ui$Internal$Model$createElement_fn(context, children, $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive_fn($mdgriffith$elm_ui$Internal$Model$contextClasses(context), node, $mdgriffith$elm_ui$Internal$Flag$none, $mdgriffith$elm_ui$Internal$Model$untransformed, _List_Nil, _List_Nil, $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren, $elm$core$List$reverse(attributes)));
    }, $mdgriffith$elm_ui$Internal$Model$element = F4($mdgriffith$elm_ui$Internal$Model$element_fn);
    var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
    var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
    var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
        ez: $elm$core$Maybe$Nothing,
        eE: $elm$core$Maybe$Nothing,
        f6: $elm$core$Maybe$Just({
            aF: 0,
            bc: $mdgriffith$elm_ui$Internal$Model$Rgba_fn(155 / 255, 203 / 255, 1, 1),
            a: _Utils_Tuple2(0, 0),
            cq: 3
        })
    };
    var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
        var combine = F2(function (opt, record) {
            switch (opt.$) {
                case 0:
                    var hoverable = opt.a;
                    var _v4 = record.ff;
                    if (_v4.$ === 1) {
                        return _Utils_update(record, {
                            ff: $elm$core$Maybe$Just(hoverable)
                        });
                    }
                    else {
                        return record;
                    }
                case 1:
                    var focusStyle = opt.a;
                    var _v5 = record.e8;
                    if (_v5.$ === 1) {
                        return _Utils_update(record, {
                            e8: $elm$core$Maybe$Just(focusStyle)
                        });
                    }
                    else {
                        return record;
                    }
                default:
                    var renderMode = opt.a;
                    var _v6 = record.fy;
                    if (_v6.$ === 1) {
                        return _Utils_update(record, {
                            fy: $elm$core$Maybe$Just(renderMode)
                        });
                    }
                    else {
                        return record;
                    }
            }
        });
        var andFinally = function (record) {
            return {
                e8: function () {
                    var _v0 = record.e8;
                    if (_v0.$ === 1) {
                        return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
                    }
                    else {
                        var focusable = _v0.a;
                        return focusable;
                    }
                }(),
                ff: function () {
                    var _v1 = record.ff;
                    if (_v1.$ === 1) {
                        return 1;
                    }
                    else {
                        var hoverable = _v1.a;
                        return hoverable;
                    }
                }(),
                fy: function () {
                    var _v2 = record.fy;
                    if (_v2.$ === 1) {
                        return 0;
                    }
                    else {
                        var actualMode = _v2.a;
                        return actualMode;
                    }
                }()
            };
        };
        return andFinally($elm$core$List$foldr_fn(combine, { e8: $elm$core$Maybe$Nothing, ff: $elm$core$Maybe$Nothing, fy: $elm$core$Maybe$Nothing }, options));
    };
    var $mdgriffith$elm_ui$Internal$Model$toHtml_fn = function (mode, el) {
        switch (el.$) {
            case 0:
                var html = el.a;
                return html($mdgriffith$elm_ui$Internal$Model$asEl);
            case 1:
                var styles = el.a.d0;
                var html = el.a.b3;
                return A2(html, mode(styles), $mdgriffith$elm_ui$Internal$Model$asEl);
            case 2:
                var text = el.a;
                return $mdgriffith$elm_ui$Internal$Model$textElement(text);
            default:
                return $mdgriffith$elm_ui$Internal$Model$textElement("");
        }
    }, $mdgriffith$elm_ui$Internal$Model$toHtml = F2($mdgriffith$elm_ui$Internal$Model$toHtml_fn);
    var $mdgriffith$elm_ui$Internal$Model$renderRoot_fn = function (optionList, attributes, child) {
        var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
        var embedStyle = function () {
            var _v0 = options.fy;
            if (_v0 === 1) {
                return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
            }
            else {
                return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
            }
        }();
        return $mdgriffith$elm_ui$Internal$Model$toHtml_fn(embedStyle, $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, attributes, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([child]))));
    }, $mdgriffith$elm_ui$Internal$Model$renderRoot = F3($mdgriffith$elm_ui$Internal$Model$renderRoot_fn);
    var $mdgriffith$elm_ui$Internal$Model$FontFamily_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$FontFamily = F2($mdgriffith$elm_ui$Internal$Model$FontFamily_fn);
    var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
        return { $: 2, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$SansSerif = { $: 1 };
    var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
        return { $: 3, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
    var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
    var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
    var $elm$core$String$toLower = _String_toLower;
    var $elm$core$String$words = _String_words;
    var $mdgriffith$elm_ui$Internal$Model$renderFontClassName_fn = function (font, current) {
        return _Utils_ap(current, function () {
            switch (font.$) {
                case 0:
                    return "serif";
                case 1:
                    return "sans-serif";
                case 2:
                    return "monospace";
                case 3:
                    var name = font.a;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
                case 4:
                    var name = font.a;
                    var url = font.b;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
                default:
                    var name = font.a.dw;
                    return $elm$core$String$join_fn("-", $elm$core$String$words($elm$core$String$toLower(name)));
            }
        }());
    }, $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2($mdgriffith$elm_ui$Internal$Model$renderFontClassName_fn);
    var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
        var families = _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$Typeface("Open Sans"),
            $mdgriffith$elm_ui$Internal$Model$Typeface("Helvetica"),
            $mdgriffith$elm_ui$Internal$Model$Typeface("Verdana"),
            $mdgriffith$elm_ui$Internal$Model$SansSerif
        ]);
        return _List_fromArray([
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$bgColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bg-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass($mdgriffith$elm_ui$Internal$Model$Rgba_fn(1, 1, 1, 0)), "background-color", $mdgriffith$elm_ui$Internal$Model$Rgba_fn(1, 1, 1, 0))),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("fc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 1)), "color", $mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 1))),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontSize, $mdgriffith$elm_ui$Internal$Model$FontSize(20)),
            $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontFamily, $mdgriffith$elm_ui$Internal$Model$FontFamily_fn($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderFontClassName, "font-", families), families))
        ]);
    }();
    var $mdgriffith$elm_ui$Element$layoutWith_fn = function (_v0, attrs, child) {
        var options = _v0.fR;
        return $mdgriffith$elm_ui$Internal$Model$renderRoot_fn(options, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($elm$core$String$join_fn(" ", _List_fromArray([$mdgriffith$elm_ui$Internal$Style$classes.dP, $mdgriffith$elm_ui$Internal$Style$classes.ex, $mdgriffith$elm_ui$Internal$Style$classes.f7]))), _Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)), child);
    }, $mdgriffith$elm_ui$Element$layoutWith = F3($mdgriffith$elm_ui$Element$layoutWith_fn);
    var $mdgriffith$elm_ui$Element$layout_a0 = { fR: _List_Nil }, $mdgriffith$elm_ui$Element$layout = $mdgriffith$elm_ui$Element$layoutWith($mdgriffith$elm_ui$Element$layout_a0);
    var $miniBill$elm_ui_with_context$Element$WithContext$layout_fn = function (context, attrs, _v0) {
        var f = _v0;
        return $mdgriffith$elm_ui$Element$layoutWith_fn($mdgriffith$elm_ui$Element$layout_a0, $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), f(context));
    }, $miniBill$elm_ui_with_context$Element$WithContext$layout = F3($miniBill$elm_ui_with_context$Element$WithContext$layout_fn);
    var $mdgriffith$elm_ui$Element$Font$size = function (i) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontSize, $mdgriffith$elm_ui$Internal$Model$FontSize(i));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Font$size = function (i) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr($mdgriffith$elm_ui$Element$Font$size(i));
    };
    var $author$project$UI$Model$GoogleGotAccessToken = function (a) {
        return { $: 12, a: a };
    };
    var $author$project$UI$Model$IsFullscreen = function (a) {
        return { $: 13, a: a };
    };
    var $elm$core$Platform$Sub$batch = _Platform_batch;
    var $author$project$UI$Ports$gotGoogleAccessToken = _Platform_incomingPort("gotGoogleAccessToken", $elm$json$Json$Decode$string);
    var $author$project$UI$Ports$isFullscreen = _Platform_incomingPort("isFullscreen", $elm$json$Json$Decode$bool);
    var $elm$browser$Browser$Events$Window = 1;
    var $elm$json$Json$Decode$int = _Json_decodeInt;
    var $elm$browser$Browser$Events$MySub_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $elm$browser$Browser$Events$MySub = F3($elm$browser$Browser$Events$MySub_fn);
    var $elm$browser$Browser$Events$State_fn = function (subs, pids) {
        return { dD: pids, d1: subs };
    }, $elm$browser$Browser$Events$State = F2($elm$browser$Browser$Events$State_fn);
    var $elm$browser$Browser$Events$init = $elm$core$Task$succeed($elm$browser$Browser$Events$State_fn(_List_Nil, $elm$core$Dict$empty));
    var $elm$browser$Browser$Events$nodeToKey = function (node) {
        if (!node) {
            return "d_";
        }
        else {
            return "w_";
        }
    };
    var $elm$browser$Browser$Events$addKey = function (sub) {
        var node = sub.a;
        var name = sub.b;
        return _Utils_Tuple2(_Utils_ap($elm$browser$Browser$Events$nodeToKey(node), name), sub);
    };
    var $elm$core$Dict$fromList = function (assocs) {
        return $elm$core$List$foldl_fn_unwrapped(function (_v0, dict) {
            var key = _v0.a;
            var value = _v0.b;
            return $elm$core$Dict$insert_fn(key, value, dict);
        }, $elm$core$Dict$empty, assocs);
    };
    var $elm$core$Process$kill = _Scheduler_kill;
    var $elm$core$Dict$foldl_fn = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, $elm$core$Dict$foldl_fn(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl_fn_unwrapped = function (func, acc, dict) {
        foldl: while (true) {
            if (dict.$ === -2) {
                return acc;
            }
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = func(key, value, $elm$core$Dict$foldl_fn_unwrapped(func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    }, $elm$core$Dict$foldl = F3($elm$core$Dict$foldl_fn);
    var $elm$core$Dict$merge_fn = function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
        var stepState = F3(function (rKey, rValue, _v0) {
            stepState: while (true) {
                var list = _v0.a;
                var result = _v0.b;
                if (!list.b) {
                    return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                }
                else {
                    var _v2 = list.a;
                    var lKey = _v2.a;
                    var lValue = _v2.b;
                    var rest = list.b;
                    if (_Utils_cmp(lKey, rKey) < 0) {
                        var $temp$rKey = rKey, $temp$rValue = rValue, $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));
                        rKey = $temp$rKey;
                        rValue = $temp$rValue;
                        _v0 = $temp$_v0;
                        continue stepState;
                    }
                    else {
                        if (_Utils_cmp(lKey, rKey) > 0) {
                            return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                        }
                        else {
                            return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
                        }
                    }
                }
            }
        });
        var _v3 = $elm$core$Dict$foldl_fn(stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);
        var leftovers = _v3.a;
        var intermediateResult = _v3.b;
        return $elm$core$List$foldl_fn_unwrapped(function (_v4, result) {
            var k = _v4.a;
            var v = _v4.b;
            return A3(leftStep, k, v, result);
        }, intermediateResult, leftovers);
    }, $elm$core$Dict$merge = F6($elm$core$Dict$merge_fn);
    var $elm$browser$Browser$Events$Event_fn = function (key, event) {
        return { c3: event, fu: key };
    }, $elm$browser$Browser$Events$Event = F2($elm$browser$Browser$Events$Event_fn);
    var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
    var $elm$browser$Browser$Events$spawn_fn = function (router, key, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var actualNode = function () {
            if (!node) {
                return _Browser_doc;
            }
            else {
                return _Browser_window;
            }
        }();
        return $elm$core$Task$map_fn(function (value) {
            return _Utils_Tuple2(key, value);
        }, _Browser_on_fn(actualNode, name, function (event) {
            return _Platform_sendToSelf_fn(router, $elm$browser$Browser$Events$Event_fn(key, event));
        }));
    }, $elm$browser$Browser$Events$spawn = F3($elm$browser$Browser$Events$spawn_fn);
    var $elm$core$Dict$union_fn = function (t1, t2) {
        return $elm$core$Dict$foldl_fn($elm$core$Dict$insert, t2, t1);
    }, $elm$core$Dict$union = F2($elm$core$Dict$union_fn);
    var $elm$browser$Browser$Events$onEffects_fn = function (router, subs, state) {
        var stepRight = F3(function (key, sub, _v6) {
            var deads = _v6.a;
            var lives = _v6.b;
            var news = _v6.c;
            return _Utils_Tuple3(deads, lives, _List_Cons($elm$browser$Browser$Events$spawn_fn(router, key, sub), news));
        });
        var stepLeft = F3(function (_v4, pid, _v5) {
            var deads = _v5.a;
            var lives = _v5.b;
            var news = _v5.c;
            return _Utils_Tuple3(_List_Cons(pid, deads), lives, news);
        });
        var stepBoth = F4(function (key, pid, _v2, _v3) {
            var deads = _v3.a;
            var lives = _v3.b;
            var news = _v3.c;
            return _Utils_Tuple3(deads, $elm$core$Dict$insert_fn(key, pid, lives), news);
        });
        var newSubs = $elm$core$List$map_fn($elm$browser$Browser$Events$addKey, subs);
        var _v0 = $elm$core$Dict$merge_fn(stepLeft, stepBoth, stepRight, state.dD, $elm$core$Dict$fromList(newSubs), _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
        var deadPids = _v0.a;
        var livePids = _v0.b;
        var makeNewPids = _v0.c;
        return _Scheduler_andThen_fn(function (pids) {
            return $elm$core$Task$succeed($elm$browser$Browser$Events$State_fn(newSubs, $elm$core$Dict$union_fn(livePids, $elm$core$Dict$fromList(pids))));
        }, _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$sequence(makeNewPids);
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Process$kill, deadPids))));
    }, $elm$browser$Browser$Events$onEffects = F3($elm$browser$Browser$Events$onEffects_fn);
    var $elm$browser$Browser$Events$onSelfMsg_fn = function (router, _v0, state) {
        var key = _v0.fu;
        var event = _v0.c3;
        var toMessage = function (_v2) {
            var subKey = _v2.a;
            var _v3 = _v2.b;
            var node = _v3.a;
            var name = _v3.b;
            var decoder = _v3.c;
            return _Utils_eq(subKey, key) ? _Browser_decodeEvent_fn(decoder, event) : $elm$core$Maybe$Nothing;
        };
        var messages = $elm$core$List$filterMap_fn(toMessage, state.d1);
        return _Scheduler_andThen_fn(function (_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence($elm$core$List$map_fn($elm$core$Platform$sendToApp(router), messages)));
    }, $elm$browser$Browser$Events$onSelfMsg = F3($elm$browser$Browser$Events$onSelfMsg_fn);
    var $elm$browser$Browser$Events$subMap_fn = function (func, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var decoder = _v0.c;
        return $elm$browser$Browser$Events$MySub_fn(node, name, _Json_map1_fn(func, decoder));
    }, $elm$browser$Browser$Events$subMap = F2($elm$browser$Browser$Events$subMap_fn);
    _Platform_effectManagers["Browser.Events"] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
    var $elm$browser$Browser$Events$subscription = _Platform_leaf("Browser.Events");
    var $elm$browser$Browser$Events$on_fn = function (node, name, decoder) {
        return $elm$browser$Browser$Events$subscription($elm$browser$Browser$Events$MySub_fn(node, name, decoder));
    }, $elm$browser$Browser$Events$on = F3($elm$browser$Browser$Events$on_fn);
    var $elm$browser$Browser$Events$onResize = function (func) {
        return $elm$browser$Browser$Events$on_fn(1, "resize", _Json_decodeField_fn("target", _Json_map2_fn(func, _Json_decodeField_fn("innerWidth", $elm$json$Json$Decode$int), _Json_decodeField_fn("innerHeight", $elm$json$Json$Decode$int))));
    };
    var $author$project$UI$subscriptions = function (_v0) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$browser$Browser$Events$onResize(F2(function (w, h) {
                return $author$project$UI$Model$Resized({ bj: h, bE: w });
            })),
            $author$project$UI$Ports$gotGoogleAccessToken($author$project$UI$Model$GoogleGotAccessToken),
            $author$project$UI$Ports$isFullscreen($author$project$UI$Model$IsFullscreen)
        ]));
    };
    var $author$project$UI$Model$DocumentGoogleId = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$UI$Model$DocumentGoogleSaveResult = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$UI$Model$DocumentMsg_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$UI$Model$DocumentMsg = F2($author$project$UI$Model$DocumentMsg_fn);
    var $author$project$UI$Model$DocumentOpenContent = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$UI$Model$DocumentOpenSelected = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$API$Google$Errored = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$API$Google$Expired = { $: 2 };
    var $author$project$Document$ModalClose = { $: 0 };
    var $author$project$API$Google$Running = { $: 1 };
    var $author$project$API$Google$Succeded = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$API$Google$Unauthorized = { $: 1 };
    var $author$project$API$Google$WaitingAccessToken = { $: 0 };
    var $author$project$Zipper$allRight = function (orig) {
        var before = orig.e;
        var curr = orig.h;
        var after = orig.d;
        var _v0 = $elm$core$List$reverse(after);
        if (!_v0.b) {
            return orig;
        }
        else {
            var end = _v0.a;
            var tail = _v0.b;
            return {
                d: _List_Nil,
                e: _Utils_ap(tail, _List_Cons(curr, before)),
                h: end
            };
        }
    };
    var $author$project$Zipper$append_fn = function (x, _v0) {
        var z = _v0;
        return _Utils_update(z, {
            d: _Utils_ap(z.d, _List_fromArray([x]))
        });
    }, $author$project$Zipper$append = F2($author$project$Zipper$append_fn);
    var $miniBill$elm_codec$Codec$encodeToValue = function (codec) {
        return $miniBill$elm_codec$Codec$encoder(codec);
    };
    var $author$project$UI$Ports$persist = _Platform_outgoingPort("persist", $elm$core$Basics$identity);
    var $author$project$Document$toStored = function (_v0) {
        var name = _v0.dw;
        var rows = _v0.M;
        var googleId = _v0.n;
        return { n: googleId, dw: name, M: rows };
    };
    var $author$project$UI$persist = function (model) {
        return _Utils_Tuple2(model, $author$project$UI$Ports$persist(A2($miniBill$elm_codec$Codec$encodeToValue, $author$project$UI$Model$documentsCodec, $elm$core$Maybe$map_fn($author$project$Zipper$map(function (_v0) {
            return $author$project$Document$toStored;
        }), model.l))));
    };
    var $author$project$UI$addDocument_fn = function (model, _v0) {
        var name = _v0.dw;
        var rows = _v0.M;
        var googleId = _v0.n;
        var toAppend = { n: googleId, fh: model.bo, du: _List_Nil, dw: name, M: rows };
        var documents = $elm$core$Maybe$Just(function () {
            var _v1 = model.l;
            if (_v1.$ === 1) {
                return $author$project$Zipper$singleton(toAppend);
            }
            else {
                var docs = _v1.a;
                return $author$project$Zipper$allRight($author$project$Zipper$append_fn(toAppend, docs));
            }
        }());
        return $author$project$UI$persist(_Utils_update(model, { l: documents, bo: model.bo + 1 }));
    }, $author$project$UI$addDocument = F2($author$project$UI$addDocument_fn);
    var $elm$core$Task$onError = _Scheduler_onError;
    var $elm$core$Task$attempt_fn = function (resultToMessage, task) {
        return $elm$core$Task$command(_Scheduler_onError_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), _Scheduler_andThen_fn(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
    }, $elm$core$Task$attempt = F2($elm$core$Task$attempt_fn);
    var $author$project$API$Google$clientId = "696268500736-k646rm6l6qcucv2t1qufdg31ngsfgmhu.apps.googleusercontent.com";
    var $elm$url$Url$Builder$toQueryPair = function (_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return key + ("=" + value);
    };
    var $elm$url$Url$Builder$toQuery = function (parameters) {
        if (!parameters.b) {
            return "";
        }
        else {
            return "?" + $elm$core$String$join_fn("&", $elm$core$List$map_fn($elm$url$Url$Builder$toQueryPair, parameters));
        }
    };
    var $elm$url$Url$Builder$crossOrigin_fn = function (prePath, pathSegments, parameters) {
        return prePath + ("/" + ($elm$core$String$join_fn("/", pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
    }, $elm$url$Url$Builder$crossOrigin = F3($elm$url$Url$Builder$crossOrigin_fn);
    var $author$project$API$Google$scope = "https://www.googleapis.com/auth/drive.file";
    var $elm$url$Url$Builder$QueryParameter_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$url$Url$Builder$QueryParameter = F2($elm$url$Url$Builder$QueryParameter_fn);
    var $elm$url$Url$percentEncode = _Url_percentEncode;
    var $elm$url$Url$Builder$string_fn = function (key, value) {
        return $elm$url$Url$Builder$QueryParameter_fn($elm$url$Url$percentEncode(key), $elm$url$Url$percentEncode(value));
    }, $elm$url$Url$Builder$string = F2($elm$url$Url$Builder$string_fn);
    var $author$project$API$Google$authenticationFlowUrl = function (redirectUri) {
        return $elm$url$Url$Builder$crossOrigin_fn("https://accounts.google.com", _List_fromArray(["o", "oauth2", "v2", "auth"]), _List_fromArray([
            $elm$url$Url$Builder$string_fn("scope", $author$project$API$Google$scope),
            $elm$url$Url$Builder$string_fn("response_type", "token"),
            $elm$url$Url$Builder$string_fn("client_id", $author$project$API$Google$clientId),
            $elm$url$Url$Builder$string_fn("redirect_uri", redirectUri)
        ]));
    };
    var $elm$core$Platform$Cmd$batch = _Platform_batch;
    var $miniBill$elm_ui_with_context$Element$WithContext$BigDesktop = 3;
    var $miniBill$elm_ui_with_context$Element$WithContext$Desktop = 2;
    var $miniBill$elm_ui_with_context$Element$WithContext$Landscape = 1;
    var $miniBill$elm_ui_with_context$Element$WithContext$Portrait = 0;
    var $miniBill$elm_ui_with_context$Element$WithContext$Tablet = 1;
    var $mdgriffith$elm_ui$Element$BigDesktop = 3;
    var $mdgriffith$elm_ui$Element$Desktop = 2;
    var $mdgriffith$elm_ui$Element$Landscape = 1;
    var $mdgriffith$elm_ui$Element$Phone = 0;
    var $mdgriffith$elm_ui$Element$Portrait = 0;
    var $mdgriffith$elm_ui$Element$Tablet = 1;
    var $mdgriffith$elm_ui$Element$classifyDevice = function (window) {
        return {
            eO: function () {
                var shortSide = $elm$core$Basics$min_fn(window.bE, window.bj);
                var longSide = $elm$core$Basics$max_fn(window.bE, window.bj);
                return (shortSide < 600) ? 0 : ((longSide <= 1200) ? 1 : (((longSide > 1200) && (longSide <= 1920)) ? 2 : 3));
            }(),
            dA: (_Utils_cmp(window.bE, window.bj) < 0) ? 0 : 1
        };
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$classifyDevice = function (size) {
        var _v0 = $mdgriffith$elm_ui$Element$classifyDevice(size);
        var _class = _v0.eO;
        var orientation = _v0.dA;
        return {
            eO: function () {
                switch (_class) {
                    case 0:
                        return 0;
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    default:
                        return 3;
                }
            }(),
            dA: function () {
                if (!orientation) {
                    return 0;
                }
                else {
                    return 1;
                }
            }()
        };
    };
    var $author$project$UI$Ports$copy = _Platform_outgoingPort("copy", $elm$json$Json$Encode$string);
    var $author$project$UI$Ports$copyCanvas = function (_v0) {
        var id = _v0;
        return $author$project$UI$Ports$copy(id);
    };
    var $elm_community$list_extra$List$Extra$find_fn = function (predicate, list) {
        find: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var first = list.a;
                var rest = list.b;
                if (predicate(first)) {
                    return $elm$core$Maybe$Just(first);
                }
                else {
                    var $temp$predicate = predicate, $temp$list = rest;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue find;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$find = F2($elm_community$list_extra$List$Extra$find_fn);
    var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
    var $author$project$UI$Ports$saveGoogleAccessToken = _Platform_outgoingPort("saveGoogleAccessToken", $elm$json$Json$Encode$string);
    var $author$project$API$Google$FileNotFound = { $: 4 };
    var $elm$http$Http$BadStatus__fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $elm$http$Http$BadStatus_ = F2($elm$http$Http$BadStatus__fn);
    var $elm$http$Http$BadUrl_ = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$GoodStatus__fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $elm$http$Http$GoodStatus_ = F2($elm$http$Http$GoodStatus__fn);
    var $elm$http$Http$NetworkError_ = { $: 2 };
    var $elm$http$Http$Receiving = function (a) {
        return { $: 1, a: a };
    };
    var $elm$http$Http$Sending = function (a) {
        return { $: 0, a: a };
    };
    var $elm$http$Http$Timeout_ = { $: 1 };
    var $elm$core$Maybe$isJust = function (maybe) {
        if (!maybe.$) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$http$Http$bytesPart_fn = function (key, mime, bytes) {
        return _Http_pair_fn(key, _Http_bytesToBlob_fn(mime, bytes));
    }, $elm$http$Http$bytesPart = F3($elm$http$Http$bytesPart_fn);
    var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
        switch (builder.$) {
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 4;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 4;
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
                var w = builder.a;
                return w;
            case 9:
                var w = builder.a;
                return w;
            default:
                var bs = builder.a;
                return _Bytes_width(bs);
        }
    };
    var $elm$bytes$Bytes$LE = 0;
    var $elm$bytes$Bytes$Encode$write_fn = function (builder, mb, offset) {
        switch (builder.$) {
            case 0:
                var n = builder.a;
                return _Bytes_write_i8_fn(mb, offset, n);
            case 1:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_i16_fn(mb, offset, n, !e);
            case 2:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_i32_fn(mb, offset, n, !e);
            case 3:
                var n = builder.a;
                return _Bytes_write_u8_fn(mb, offset, n);
            case 4:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_u16_fn(mb, offset, n, !e);
            case 5:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_u32_fn(mb, offset, n, !e);
            case 6:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_f32_fn(mb, offset, n, !e);
            case 7:
                var e = builder.a;
                var n = builder.b;
                return _Bytes_write_f64_fn(mb, offset, n, !e);
            case 8:
                var bs = builder.b;
                return $elm$bytes$Bytes$Encode$writeSequence_fn(bs, mb, offset);
            case 9:
                var s = builder.b;
                return _Bytes_write_string_fn(mb, offset, s);
            default:
                var bs = builder.a;
                return _Bytes_write_bytes_fn(mb, offset, bs);
        }
    }, $elm$bytes$Bytes$Encode$write = F3($elm$bytes$Bytes$Encode$write_fn);
    var $elm$bytes$Bytes$Encode$writeSequence_fn = function (builders, mb, offset) {
        writeSequence: while (true) {
            if (!builders.b) {
                return offset;
            }
            else {
                var b = builders.a;
                var bs = builders.b;
                var $temp$builders = bs, $temp$mb = mb, $temp$offset = $elm$bytes$Bytes$Encode$write_fn(b, mb, offset);
                builders = $temp$builders;
                mb = $temp$mb;
                offset = $temp$offset;
                continue writeSequence;
            }
        }
    }, $elm$bytes$Bytes$Encode$writeSequence = F3($elm$bytes$Bytes$Encode$writeSequence_fn);
    var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
    var $elm$core$Task$fail = _Scheduler_fail;
    var $elm$http$Http$Header_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$http$Http$Header = F2($elm$http$Http$Header_fn);
    var $elm$http$Http$header = $elm$http$Http$Header;
    var $author$project$API$Google$CodeBug = { $: 2 };
    var $author$project$API$Google$NetworkError = { $: 3 };
    var $author$project$API$Google$UnexpectedResponse = function (a) {
        return { $: 0, a: a };
    };
    var $elm$json$Json$Decode$decodeString = _Json_runOnString;
    var $elm$core$Result$mapError_fn = function (f, result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            var e = result.a;
            return $elm$core$Result$Err(f(e));
        }
    }, $elm$core$Result$mapError = F2($elm$core$Result$mapError_fn);
    var $elm$http$Http$stringResolver_a0 = "", $elm$http$Http$stringResolver_a1 = $elm$core$Basics$identity, $elm$http$Http$stringResolver = A2(_Http_expect, $elm$http$Http$stringResolver_a0, $elm$http$Http$stringResolver_a1);
    var $author$project$API$Google$jsonResolver = function (decoder) {
        return _Http_expect_fn($elm$http$Http$stringResolver_a0, $elm$http$Http$stringResolver_a1, function (response) {
            switch (response.$) {
                case 0:
                    return $elm$core$Result$Err($author$project$API$Google$CodeBug);
                case 1:
                    return $elm$core$Result$Err($author$project$API$Google$NetworkError);
                case 2:
                    return $elm$core$Result$Err($author$project$API$Google$NetworkError);
                case 3:
                    var statusCode = response.a.gc;
                    var body = response.b;
                    switch (statusCode) {
                        case 401:
                            return $elm$core$Result$Err($author$project$API$Google$Unauthorized);
                        case 404:
                            return $elm$core$Result$Err($author$project$API$Google$FileNotFound);
                        default:
                            return $elm$core$Result$Err($author$project$API$Google$UnexpectedResponse("BadStatus " + ($elm$core$String$fromInt(statusCode) + (", body: " + body))));
                    }
                default:
                    var body = response.b;
                    return $elm$core$Result$mapError_fn(function (e) {
                        return $author$project$API$Google$UnexpectedResponse($elm$json$Json$Decode$errorToString(e));
                    }, _Json_runOnString_fn(decoder, body));
            }
        });
    };
    var $elm$http$Http$multipartBody = function (parts) {
        return _Http_pair_fn("", _Http_toFormData(parts));
    };
    var $elm$bytes$Bytes$Encode$Utf8_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $elm$bytes$Bytes$Encode$Utf8 = F2($elm$bytes$Bytes$Encode$Utf8_fn);
    var $elm$bytes$Bytes$Encode$string = function (str) {
        return $elm$bytes$Bytes$Encode$Utf8_fn(_Bytes_getStringWidth(str), str);
    };
    var $elm$http$Http$stringPart = _Http_pair;
    var $elm$http$Http$resultToTask = function (result) {
        if (!result.$) {
            var a = result.a;
            return $elm$core$Task$succeed(a);
        }
        else {
            var x = result.a;
            return $elm$core$Task$fail(x);
        }
    };
    var $elm$http$Http$task = function (r) {
        return _Http_toTask_fn(0, $elm$http$Http$resultToTask, { eu: false, bM: r.bM, bV: r.cm, b$: r.b$, cc: r.cc, cE: r.cE, d5: $elm$core$Maybe$Nothing, cH: r.cH });
    };
    var $author$project$API$Google$uploadFile = function (params) {
        var updateMetadataEncoder = $elm$bytes$Bytes$Encode$string(_Json_encode_fn(0, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("mimeType", $elm$json$Json$Encode$string("text/markdown")),
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(params.dw))
        ]))));
        var insertUrl = $elm$url$Url$Builder$crossOrigin_fn("https://www.googleapis.com", _List_fromArray(["upload", "drive", "v3", "files"]), _List_fromArray([
            $elm$url$Url$Builder$string_fn("uploadType", "multipart")
        ]));
        var _v0 = params.fh;
        var id = _v0;
        var insertMetadataEncoder = $elm$bytes$Bytes$Encode$string(_Json_encode_fn(0, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2("id", $elm$json$Json$Encode$string(id)),
            _Utils_Tuple2("mimeType", $elm$json$Json$Encode$string("text/markdown")),
            _Utils_Tuple2("name", $elm$json$Json$Encode$string(params.dw))
        ]))));
        var insertTask = $elm$http$Http$task({
            bM: $elm$http$Http$multipartBody(_List_fromArray([
                $elm$http$Http$bytesPart_fn("metadata", "application/json; charset=UTF-8", $elm$bytes$Bytes$Encode$encode(insertMetadataEncoder)),
                _Http_pair_fn("content", params.cX)
            ])),
            b$: _List_fromArray([
                $elm$http$Http$Header_fn("Authorization", "Bearer " + params.aN)
            ]),
            cc: "POST",
            cm: $author$project$API$Google$jsonResolver($elm$json$Json$Decode$succeed(0)),
            cE: $elm$core$Maybe$Nothing,
            cH: insertUrl
        });
        var updateUrl = $elm$url$Url$Builder$crossOrigin_fn("https://www.googleapis.com", _List_fromArray(["upload", "drive", "v3", "files", id]), _List_fromArray([
            $elm$url$Url$Builder$string_fn("uploadType", "multipart")
        ]));
        var updateTask = $elm$http$Http$task({
            bM: $elm$http$Http$multipartBody(_List_fromArray([
                $elm$http$Http$bytesPart_fn("metadata", "application/json; charset=UTF-8", $elm$bytes$Bytes$Encode$encode(updateMetadataEncoder)),
                _Http_pair_fn("content", params.cX)
            ])),
            b$: _List_fromArray([
                $elm$http$Http$Header_fn("Authorization", "Bearer " + params.aN)
            ]),
            cc: "PATCH",
            cm: $author$project$API$Google$jsonResolver($elm$json$Json$Decode$succeed(0)),
            cE: $elm$core$Maybe$Nothing,
            cH: updateUrl
        });
        return _Scheduler_onError_fn(function (e) {
            return _Utils_eq(e, $author$project$API$Google$FileNotFound) ? insertTask : $elm$core$Task$fail(e);
        }, updateTask);
    };
    var $author$project$UI$withCommand_fn = function (cmd, _v0) {
        var model = _v0.a;
        var cmds = _v0.b;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, cmds])));
    }, $author$project$UI$withCommand = F2($author$project$UI$withCommand_fn);
    var $author$project$UI$documentGoogleId_fn = function (docId, res, model) {
        if (!res.$) {
            var googleId = res.a;
            var maybeDoc = $elm_community$list_extra$List$Extra$find_fn(function (_v6) {
                var id = _v6.fh;
                return _Utils_eq(id, docId);
            }, model.m.O);
            var google = model.m;
            var google_ = F2(function (_v5, request) {
                var name = _v5.dw;
                var content = _v5.cX;
                return _Utils_update(google, {
                    O: $elm$core$List$filter_fn(function (_v4) {
                        var id = _v4.fh;
                        return !_Utils_eq(id, docId);
                    }, google.O),
                    T: _List_Cons({ cX: content, n: googleId, fh: docId, dw: name, Y: request }, google.T)
                });
            });
            var documents_ = $elm$core$Maybe$map_fn($author$project$Zipper$map(F2(function (_v3, document) {
                var id = document.fh;
                return _Utils_eq(id, docId) ? _Utils_update(document, {
                    n: $elm$core$Maybe$Just(googleId)
                }) : document;
            })), model.l);
            if (maybeDoc.$ === 1) {
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            }
            else {
                var data = maybeDoc.a;
                var _v2 = google.aN;
                switch (_v2.$) {
                    case 0:
                        return $author$project$UI$persist(_Utils_update(model, {
                            l: documents_,
                            m: A2(google_, data, $author$project$API$Google$WaitingAccessToken)
                        }));
                    case 2:
                        return $author$project$UI$persist(_Utils_update(model, {
                            l: documents_,
                            m: A2(google_, data, $author$project$API$Google$WaitingAccessToken)
                        }));
                    default:
                        var token = _v2.a;
                        return $author$project$UI$withCommand_fn($elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentMsg(docId), $author$project$UI$Model$DocumentGoogleSaveResult), $author$project$API$Google$uploadFile({ aN: token, cX: data.cX, fh: googleId, dw: data.dw })), $author$project$UI$persist(_Utils_update(model, {
                            l: documents_,
                            m: A2(google_, data, $author$project$API$Google$Running)
                        })));
                }
            }
        }
        else {
            var e = res.a;
            var google = model.m;
            var google_ = _Utils_update(google, {
                O: $elm$core$List$map_fn(function (data) {
                    var id = data.fh;
                    return _Utils_eq(id, docId) ? _Utils_update(data, {
                        Y: $author$project$API$Google$Errored(e)
                    }) : data;
                }, google.O)
            });
            return _Utils_eq(e, $author$project$API$Google$Unauthorized) ? _Utils_Tuple2(_Utils_update(model, {
                m: _Utils_update(google_, { aN: $author$project$API$Google$Expired })
            }), $author$project$UI$Ports$saveGoogleAccessToken("")) : _Utils_Tuple2(_Utils_update(model, { m: google_ }), $elm$core$Platform$Cmd$none);
        }
    }, $author$project$UI$documentGoogleId = F3($author$project$UI$documentGoogleId_fn);
    var $elm$core$List$drop_fn = function (n, list) {
        drop: while (true) {
            if (n <= 0) {
                return list;
            }
            else {
                if (!list.b) {
                    return list;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs;
                    n = $temp$n;
                    list = $temp$list;
                    continue drop;
                }
            }
        }
    }, $elm$core$List$drop = F2($elm$core$List$drop_fn);
    var $elm$core$String$endsWith = _String_endsWith;
    var $author$project$UI$Ports$exitFullscreen = _Platform_outgoingPort("exitFullscreen", $elm$json$Json$Encode$string);
    var $author$project$UI$Ports$exitFullscreenCanvas = function (_v0) {
        var id = _v0;
        return $author$project$UI$Ports$exitFullscreen(id);
    };
    var $elm$time$Time$Posix = $elm$core$Basics$identity;
    var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
    var $elm$file$File$Select$file_fn = function (mimes, toMsg) {
        return $elm$core$Task$perform_fn(toMsg, _File_uploadOne(mimes));
    }, $elm$file$File$Select$file = F2($elm$file$File$Select$file_fn);
    var $author$project$Zipper$filter_fn = function (f, _v0) {
        var before = _v0.e;
        var curr = _v0.h;
        var after = _v0.d;
        var before_ = $elm$core$List$filter_fn(f, before);
        var after_ = $elm$core$List$filter_fn(f, after);
        if (f(curr)) {
            return $elm$core$Maybe$Just({ d: after_, e: before_, h: curr });
        }
        else {
            var _v1 = _Utils_Tuple2(before_, after_);
            if (_v1.b.b) {
                var _v2 = _v1.b;
                var a = _v2.a;
                var atail = _v2.b;
                return $elm$core$Maybe$Just({ d: atail, e: before_, h: a });
            }
            else {
                if (!_v1.a.b) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var _v3 = _v1.a;
                    var b = _v3.a;
                    var btail = _v3.b;
                    return $elm$core$Maybe$Just({ d: _List_Nil, e: btail, h: b });
                }
            }
        }
    }, $author$project$Zipper$filter = F2($author$project$Zipper$filter_fn);
    var $author$project$Zipper$find_fn = function (f, zip) {
        return $elm_community$list_extra$List$Extra$find_fn(f, $author$project$Zipper$toList(zip));
    }, $author$project$Zipper$find = F2($author$project$Zipper$find_fn);
    var $elm_community$list_extra$List$Extra$findIndexHelp_fn = function (index, predicate, list) {
        findIndexHelp: while (true) {
            if (!list.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var x = list.a;
                var xs = list.b;
                if (predicate(x)) {
                    return $elm$core$Maybe$Just(index);
                }
                else {
                    var $temp$index = index + 1, $temp$predicate = predicate, $temp$list = xs;
                    index = $temp$index;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue findIndexHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$findIndexHelp = F3($elm_community$list_extra$List$Extra$findIndexHelp_fn);
    var $elm_community$list_extra$List$Extra$findIndex_a0 = 0, $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp($elm_community$list_extra$List$Extra$findIndex_a0);
    var $author$project$Zipper$left_fn = function (i, orig) {
        left: while (true) {
            var before = orig.e;
            var curr = orig.h;
            var after = orig.d;
            if (!i) {
                return orig;
            }
            else {
                if (i < 0) {
                    return $author$project$Zipper$right_fn(-i, orig);
                }
                else {
                    if (!before.b) {
                        return orig;
                    }
                    else {
                        var h = before.a;
                        var t = before.b;
                        var $temp$i = i - 1, $temp$orig = {
                            d: _List_Cons(curr, after),
                            e: t,
                            h: h
                        };
                        i = $temp$i;
                        orig = $temp$orig;
                        continue left;
                    }
                }
            }
        }
    }, $author$project$Zipper$left = F2($author$project$Zipper$left_fn);
    var $author$project$Zipper$right_fn = function (i, orig) {
        right: while (true) {
            var before = orig.e;
            var curr = orig.h;
            var after = orig.d;
            if (!i) {
                return orig;
            }
            else {
                if (i < 0) {
                    return $author$project$Zipper$left_fn(-i, orig);
                }
                else {
                    if (!after.b) {
                        return orig;
                    }
                    else {
                        var h = after.a;
                        var t = after.b;
                        var $temp$i = i - 1, $temp$orig = {
                            d: t,
                            e: _List_Cons(curr, before),
                            h: h
                        };
                        i = $temp$i;
                        orig = $temp$orig;
                        continue right;
                    }
                }
            }
        }
    }, $author$project$Zipper$right = F2($author$project$Zipper$right_fn);
    var $author$project$Zipper$focusFind_fn = function (cond, orig) {
        var before = orig.e;
        var curr = orig.h;
        var after = orig.d;
        var _v0 = $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, cond, $elm$core$List$reverse(before));
        if (!_v0.$) {
            var i = _v0.a;
            return $author$project$Zipper$left_fn($elm$core$List$length(before) - i, orig);
        }
        else {
            if (cond(curr)) {
                return orig;
            }
            else {
                var _v1 = $elm_community$list_extra$List$Extra$findIndexHelp_fn($elm_community$list_extra$List$Extra$findIndex_a0, cond, after);
                if (_v1.$ === 1) {
                    return orig;
                }
                else {
                    var i = _v1.a;
                    return $author$project$Zipper$right_fn(i + 1, orig);
                }
            }
        }
    }, $author$project$Zipper$focusFind = F2($author$project$Zipper$focusFind_fn);
    var $author$project$UI$Ports$fullscreen = _Platform_outgoingPort("fullscreen", $elm$json$Json$Encode$string);
    var $author$project$UI$Ports$fullscreenCanvas = function (_v0) {
        var id = _v0;
        return $author$project$UI$Ports$fullscreen(id);
    };
    var $elm$http$Http$emptyBody = _Http_emptyBody;
    var $elm$url$Url$Builder$int_fn = function (key, value) {
        return $elm$url$Url$Builder$QueryParameter_fn($elm$url$Url$percentEncode(key), $elm$core$String$fromInt(value));
    }, $elm$url$Url$Builder$int = F2($elm$url$Url$Builder$int_fn);
    var $author$project$API$Google$generateIds = function (_v0) {
        var count = _v0.cY;
        var accessToken = _v0.aN;
        var url = $elm$url$Url$Builder$crossOrigin_fn("https://www.googleapis.com", _List_fromArray(["drive", "v3", "files", "generateIds"]), _List_fromArray([
            $elm$url$Url$Builder$int_fn("count", count)
        ]));
        return $elm$http$Http$task({
            bM: $elm$http$Http$emptyBody,
            b$: _List_fromArray([
                $elm$http$Http$Header_fn("Authorization", "Bearer " + accessToken)
            ]),
            cc: "GET",
            cm: $author$project$API$Google$jsonResolver(_Json_decodeField_fn("ids", $elm$json$Json$Decode$list(_Json_map1_fn($elm$core$Basics$identity, $elm$json$Json$Decode$string)))),
            cE: $elm$core$Maybe$Nothing,
            cH: url
        });
    };
    var $author$project$API$Google$generateId = function (_v0) {
        var accessToken = _v0.aN;
        return _Scheduler_andThen_fn(function (l) {
            var _v1 = $elm$core$List$head(l);
            if (!_v1.$) {
                var h = _v1.a;
                return $elm$core$Task$succeed(h);
            }
            else {
                return $elm$core$Task$fail($author$project$API$Google$UnexpectedResponse("Empty list when retrieving a new ID"));
            }
        }, $author$project$API$Google$generateIds({ aN: accessToken, cY: 1 }));
    };
    var $author$project$API$Google$mapRequest_fn = function (f, req) {
        switch (req.$) {
            case 0:
                return $author$project$API$Google$WaitingAccessToken;
            case 1:
                return $author$project$API$Google$Running;
            case 2:
                var e = req.a;
                return $author$project$API$Google$Errored(e);
            default:
                var x = req.a;
                return $author$project$API$Google$Succeded(f(x));
        }
    }, $author$project$API$Google$mapRequest = F2($author$project$API$Google$mapRequest_fn);
    var $author$project$UI$googleSave_fn = function (model, document) {
        var name = $elm$core$Maybe$withDefault_fn("Untitled", document.dw);
        var google = model.m;
        var content = $author$project$Document$toFile(document);
        var data = function (request) {
            return { cX: content, fh: document.fh, dw: name, Y: request };
        };
        var google_ = function (request) {
            var _v2 = document.n;
            if (_v2.$ === 1) {
                return _Utils_update(google, {
                    O: _List_Cons(data(request), google.O)
                });
            }
            else {
                var googleId = _v2.a;
                return _Utils_update(google, {
                    T: _List_Cons({
                        cX: content,
                        n: googleId,
                        fh: document.fh,
                        dw: name,
                        Y: $author$project$API$Google$mapRequest_fn(function (_v3) {
                            return 0;
                        }, request)
                    }, google.T)
                });
            }
        };
        var _v0 = google.aN;
        switch (_v0.$) {
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    m: google_($author$project$API$Google$WaitingAccessToken)
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, {
                    m: google_($author$project$API$Google$WaitingAccessToken)
                }), $elm$core$Platform$Cmd$none);
            default:
                var token = _v0.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    m: google_($author$project$API$Google$Running)
                }), function () {
                    var _v1 = document.n;
                    if (_v1.$ === 1) {
                        return $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentMsg(document.fh), $author$project$UI$Model$DocumentGoogleId), $author$project$API$Google$generateId({ aN: token }));
                    }
                    else {
                        var googleId = _v1.a;
                        return $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentMsg(document.fh), $author$project$UI$Model$DocumentGoogleSaveResult), $author$project$API$Google$uploadFile({ aN: token, cX: content, fh: googleId, dw: name }));
                    }
                }());
        }
    }, $author$project$UI$googleSave = F2($author$project$UI$googleSave_fn);
    var $elm$file$File$name = _File_name;
    var $author$project$UI$Ports$openWindow = _Platform_outgoingPort("openWindow", $elm$json$Json$Encode$string);
    var $author$project$Document$ParseError = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Document$Parsed = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$Parser$Unexpected = { $: 1 };
    var $elm$core$List$all_fn = function (isOkay, list) {
        return !$elm$core$List$any_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay), list);
    }, $elm$core$List$all = F2($elm$core$List$all_fn);
    var $author$project$UI$L10N$map_fn = function (f, _v0) {
        var en = _v0.e0;
        var it = _v0.fs;
        return {
            e0: f(en),
            fs: f(it)
        };
    }, $author$project$UI$L10N$map = F2($author$project$UI$L10N$map_fn);
    var $author$project$UI$L10N$traverse = function (f) {
        return A2($elm$core$List$foldr, F2(function (e, _v0) {
            var en = _v0.e0;
            var it = _v0.fs;
            var fe = f(e);
            return {
                e0: _List_Cons(fe.e0, en),
                fs: _List_Cons(fe.fs, it)
            };
        }), { e0: _List_Nil, fs: _List_Nil });
    };
    var $author$project$UI$L10N$sequence = $author$project$UI$L10N$traverse($elm$core$Basics$identity);
    var $author$project$UI$L10N$concat_a0 = $author$project$UI$L10N$sequence, $author$project$UI$L10N$concat_a1 = $author$project$UI$L10N$map($elm$core$String$concat), $author$project$UI$L10N$concat = A2($elm$core$Basics$composeR, $author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1);
    var $author$project$Expression$Parser$contextToString = function (ctx) {
        switch (ctx) {
            case 0:
                return { e0: "an addition or subtraction", fs: "un addizione o una sottrazione" };
            case 1:
                return { e0: "an atomic expression", fs: "un espressione atomica" };
            case 2:
                return { e0: "an expression", fs: "un espressione" };
            case 3:
                return { e0: "a list", fs: "una lista" };
            case 4:
                return { e0: "a multiplication or a division", fs: "una moltiplicazione o una divisione" };
            case 5:
                return { e0: "a number", fs: "un numero" };
            case 6:
                return { e0: "an exponentiation", fs: "un elevamento a potenza" };
            case 7:
                return { e0: "a replacement", fs: "una sostituzione" };
            case 8:
                return { e0: "a replacement list", fs: "una lista di sostituzioni" };
            case 9:
                return { e0: "a variable", fs: "una variabile" };
            default:
                return { e0: "a vector", fs: "un vettore" };
        }
    };
    var $elm$core$List$partition_fn = function (pred, list) {
        var step = F2(function (x, _v0) {
            var trues = _v0.a;
            var falses = _v0.b;
            return pred(x) ? _Utils_Tuple2(_List_Cons(x, trues), falses) : _Utils_Tuple2(trues, _List_Cons(x, falses));
        });
        return $elm$core$List$foldr_fn(step, _Utils_Tuple2(_List_Nil, _List_Nil), list);
    }, $elm$core$List$partition = F2($elm$core$List$partition_fn);
    var $elm_community$list_extra$List$Extra$gatherWith_fn = function (testFn, list) {
        var helper = F2(function (scattered, gathered) {
            if (!scattered.b) {
                return $elm$core$List$reverse(gathered);
            }
            else {
                var toGather = scattered.a;
                var population = scattered.b;
                var _v1 = $elm$core$List$partition_fn(testFn(toGather), population);
                var gathering = _v1.a;
                var remaining = _v1.b;
                return A2(helper, remaining, _List_Cons(_Utils_Tuple2(toGather, gathering), gathered));
            }
        });
        return A2(helper, list, _List_Nil);
    }, $elm_community$list_extra$List$Extra$gatherWith = F2($elm_community$list_extra$List$Extra$gatherWith_fn);
    var $elm_community$list_extra$List$Extra$gatherEqualsBy_fn = function (extract, list) {
        return $elm_community$list_extra$List$Extra$gatherWith_fn(F2(function (a, b) {
            return _Utils_eq(extract(a), extract(b));
        }), list);
    }, $elm_community$list_extra$List$Extra$gatherEqualsBy = F2($elm_community$list_extra$List$Extra$gatherEqualsBy_fn);
    var $author$project$UI$L10N$invariant = function (content) {
        return { e0: content, fs: content };
    };
    var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
    var $elm$core$String$repeatHelp_fn = function (n, chunk, result) {
        return (n <= 0) ? result : $elm$core$String$repeatHelp_fn(n >> 1, _Utils_ap(chunk, chunk), (!(n & 1)) ? result : _Utils_ap(result, chunk));
    }, $elm$core$String$repeatHelp = F3($elm$core$String$repeatHelp_fn);
    var $elm$core$String$repeat_fn = function (n, chunk) {
        return $elm$core$String$repeatHelp_fn(n, chunk, "");
    }, $elm$core$String$repeat = F2($elm$core$String$repeat_fn);
    var $author$project$Expression$Parser$errorsToString_fn = function (input, err) {
        var problemGroupToString = function (_v4) {
            var col = _v4.a.aG;
            var contextStack = _v4.a.bR;
            var problem = _v4.a.dE;
            var problems = _v4.b;
            var prefix = function () {
                if (!contextStack.b) {
                    return $author$project$UI$L10N$invariant($elm$core$String$repeat_fn(col + 1, " ") + "^ ");
                }
                else {
                    var frame = contextStack.a;
                    var pprefix = _Utils_eq(col, frame.aG) ? $elm$core$String$repeat_fn(col + 1, " ") : ($elm$core$String$repeat_fn(frame.aG + 1, " ") + ("|" + $elm$core$String$repeat_fn((col - frame.aG) - 1, "-")));
                    var ctxString = $author$project$Expression$Parser$contextToString(frame.eU);
                    return { e0: pprefix + ("^ While trying to parse " + (ctxString.e0 + ". ")), fs: pprefix + ("^ Durante il parsing di " + (ctxString.fs + ". ")) };
                }
            }();
            var allProblems = _List_Cons(problem, $elm$core$List$map_fn(function ($) {
                return $.dE;
            }, problems));
            return $elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([
                prefix,
                $elm$core$List$any_fn($elm$core$Basics$eq($author$project$Expression$Parser$Unexpected), allProblems) ? ($elm$core$List$all_fn($elm$core$Basics$eq($author$project$Expression$Parser$Unexpected), allProblems) ? { e0: "Unexpected", fs: "Inatteso" } : { e0: "Unexpected, expected ", fs: "Inatteso, atteso " }) : { e0: "Expected ", fs: "Atteso " },
                function (expecteds) {
                    var _v2 = $elm$core$List$reverse(expecteds);
                    if (!_v2.b) {
                        return $author$project$UI$L10N$invariant("");
                    }
                    else {
                        if (!_v2.b.b) {
                            var single = _v2.a;
                            return single;
                        }
                        else {
                            var last = _v2.a;
                            var init = _v2.b;
                            return $elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([
                                $author$project$UI$L10N$map_fn($elm$core$String$join(", "), $author$project$UI$L10N$sequence($elm$core$List$reverse(init))),
                                { e0: " or ", fs: " o " },
                                last
                            ]));
                        }
                    }
                }($elm$core$List$filterMap_fn(function (p) {
                    if (p.$ === 1) {
                        return $elm$core$Maybe$Nothing;
                    }
                    else {
                        var e = p.a;
                        return $elm$core$Maybe$Just(e);
                    }
                }, allProblems))
            ]));
        };
        var errsString = $elm$core$List$map_fn(problemGroupToString, $elm_community$list_extra$List$Extra$gatherEqualsBy_fn(function (_v0) {
            var col = _v0.aG;
            var contextStack = _v0.bR;
            return { aG: col, bR: contextStack };
        }, err));
        return $author$project$UI$L10N$map_fn($elm$core$String$join("\n"), $author$project$UI$L10N$sequence(_Utils_ap(_List_fromArray([
            { e0: "Error parsing expression:", fs: "Errore nel parsing dell'espressione:" },
            $author$project$UI$L10N$invariant("  " + input)
        ]), $elm$core$List$isEmpty(err) ? _List_fromArray([
            { e0: "No valid parse?", fs: "Nessuna interpretazione possibile?" }
        ]) : errsString)));
    }, $author$project$Expression$Parser$errorsToString = F2($author$project$Expression$Parser$errorsToString_fn);
    var $author$project$Expression$Cleaner$cuts = _List_fromArray([
        _Utils_Tuple2("\u2265", ">="),
        _Utils_Tuple2("\u2A7E", ">="),
        _Utils_Tuple2("\u21D2", "=>"),
        _Utils_Tuple2("\u2264", "<="),
        _Utils_Tuple2("\u2A7D", "<="),
        _Utils_Tuple2("\u2260", "<>"),
        _Utils_Tuple2("**", "^"),
        _Utils_Tuple2("^-1", "^(-1)"),
        _Utils_Tuple2("\u00B2", "^(2)"),
        _Utils_Tuple2("\u00B3", "^(3)"),
        _Utils_Tuple2("'", "")
    ]);
    var $elm$core$String$replace_fn = function (before, after, string) {
        return $elm$core$String$join_fn(after, $elm$core$String$split_fn(before, string));
    }, $elm$core$String$replace = F3($elm$core$String$replace_fn);
    var $author$project$Expression$Cleaner$cleanInput = function (string) {
        var cut = F3(function (f, t, s) {
            cut: while (true) {
                var replaced = $elm$core$String$replace_fn(f, t, s);
                if (_Utils_eq(s, replaced)) {
                    return s;
                }
                else {
                    var $temp$f = f, $temp$t = t, $temp$s = replaced;
                    f = $temp$f;
                    t = $temp$t;
                    s = $temp$s;
                    continue cut;
                }
            }
        });
        return $elm$core$List$foldl_fn(function (_v0) {
            var ef = _v0.a;
            var et = _v0.b;
            return A2(cut, ef, et);
        }, string, $author$project$Expression$Cleaner$cuts);
    };
    var $author$project$Expression$Declared = 0;
    var $author$project$Expression$KnownFunction = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Atan2 = { $: 6 };
    var $author$project$Expression$Dd = { $: 21 };
    var $author$project$Expression$Mbrot = { $: 35 };
    var $author$project$Expression$Mod = { $: 34 };
    var $author$project$Expression$Solve = { $: 33 };
    var $author$project$Expression$binaryFunctions = _List_fromArray([
        _Utils_Tuple2("atan2", $author$project$Expression$Atan2),
        _Utils_Tuple2("dd", $author$project$Expression$Dd),
        _Utils_Tuple2("solve", $author$project$Expression$Solve),
        _Utils_Tuple2("mod", $author$project$Expression$Mod),
        _Utils_Tuple2("mbrot", $author$project$Expression$Mbrot)
    ]);
    var $elm$core$String$cons = _String_cons;
    var $elm$core$String$fromChar = function (_char) {
        return _String_cons_fn(_char, "");
    };
    var $elm$core$Char$fromCode = _Char_fromCode;
    var $author$project$Trie$Trie = $elm$core$Basics$identity;
    var $author$project$Trie$empty = { P: $elm$core$Dict$empty, S: $elm$core$Maybe$Nothing };
    var $elm$core$String$foldr = _String_foldr;
    var $elm$core$String$toList = function (string) {
        return _String_foldr_fn($elm$core$List$cons, _List_Nil, string);
    };
    var $author$project$Trie$insert_fn = function (s, v) {
        var go = F2(function (ss, orig) {
            var trie = orig;
            if (!ss.b) {
                return _Utils_eq(trie.S, $elm$core$Maybe$Nothing) ? _Utils_update(trie, {
                    S: $elm$core$Maybe$Just(v)
                }) : orig;
            }
            else {
                var c = ss.a;
                var cs = ss.b;
                var node = A2(go, cs, $elm$core$Maybe$withDefault_fn($author$project$Trie$empty, $elm$core$Dict$get_fn(c, trie.P)));
                return _Utils_update(trie, {
                    P: $elm$core$Dict$insert_fn(c, node, trie.P)
                });
            }
        });
        return go($elm$core$String$toList(s));
    }, $author$project$Trie$insert = F2($author$project$Trie$insert_fn);
    var $author$project$Trie$fromList_a0 = function (_v0) {
        var k = _v0.a;
        var v = _v0.b;
        return $author$project$Trie$insert_fn(k, v);
    }, $author$project$Trie$fromList_a1 = $author$project$Trie$empty, $author$project$Trie$fromList = A2($elm$core$List$foldl, $author$project$Trie$fromList_a0, $author$project$Trie$fromList_a1);
    var $author$project$Expression$greeks = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("alpha", "\u03B1"),
        _Utils_Tuple2("beta", "\u03B2"),
        _Utils_Tuple2("delta", "\u03B4"),
        _Utils_Tuple2("Delta", "\u0394"),
        _Utils_Tuple2("epsilon", "\u025B"),
        _Utils_Tuple2("eta", "\u03B7"),
        _Utils_Tuple2("gamma", "\u03B3"),
        _Utils_Tuple2("Gamma", "\u0393"),
        _Utils_Tuple2("iota", "\u03B9"),
        _Utils_Tuple2("kappa", "\u03BA"),
        _Utils_Tuple2("lambda", "\u03BB"),
        _Utils_Tuple2("Lambda", "\u039B"),
        _Utils_Tuple2("mu", "\u03BC"),
        _Utils_Tuple2("nu", "\u03BD"),
        _Utils_Tuple2("omega", "\u03C9"),
        _Utils_Tuple2("Omega", "\u03A9"),
        _Utils_Tuple2("phi", "\u03C6"),
        _Utils_Tuple2("Phi", "\u03A6"),
        _Utils_Tuple2("pi", "\u03C0"),
        _Utils_Tuple2("Pi", "\u03A0"),
        _Utils_Tuple2("psi", "\u03C8"),
        _Utils_Tuple2("Psi", "\u03A8"),
        _Utils_Tuple2("rho", "\u03C1"),
        _Utils_Tuple2("sigma", "\u03C3"),
        _Utils_Tuple2("Sigma", "\u03A3"),
        _Utils_Tuple2("tau", "\u03C4"),
        _Utils_Tuple2("theta", "\u03D1"),
        _Utils_Tuple2("Theta", "\u0398"),
        _Utils_Tuple2("upsilon", "\u03C5"),
        _Utils_Tuple2("xi", "\u03BE"),
        _Utils_Tuple2("Xi", "\u039E"),
        _Utils_Tuple2("zeta", "\u03B6")
    ]));
    var $author$project$Expression$Ii = { $: 22 };
    var $author$project$Expression$quaternaryFunctions = _List_fromArray([
        _Utils_Tuple2("ii", $author$project$Expression$Ii)
    ]);
    var $author$project$Expression$Pw = { $: 28 };
    var $author$project$Expression$ternaryFunctions = _List_fromArray([
        _Utils_Tuple2("pw", $author$project$Expression$Pw)
    ]);
    var $author$project$Expression$APlot = { $: 30 };
    var $author$project$Expression$Abs = { $: 10 };
    var $author$project$Expression$Acos = { $: 4 };
    var $author$project$Expression$Arg = { $: 18 };
    var $author$project$Expression$Asin = { $: 3 };
    var $author$project$Expression$Atan = { $: 5 };
    var $author$project$Expression$Ceiling = { $: 27 };
    var $author$project$Expression$Cos = { $: 1 };
    var $author$project$Expression$Cosh = { $: 8 };
    var $author$project$Expression$Det = { $: 20 };
    var $author$project$Expression$Exp = { $: 14 };
    var $author$project$Expression$Floor = { $: 26 };
    var $author$project$Expression$Gra = { $: 19 };
    var $author$project$Expression$Im = { $: 17 };
    var $author$project$Expression$Ln = { $: 12 };
    var $author$project$Expression$Log10 = { $: 13 };
    var $author$project$Expression$Plot = { $: 29 };
    var $author$project$Expression$Re = { $: 16 };
    var $author$project$Expression$Root = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Expression$Round = { $: 25 };
    var $author$project$Expression$Sign = { $: 15 };
    var $author$project$Expression$Simplify = { $: 31 };
    var $author$project$Expression$Sin = { $: 0 };
    var $author$project$Expression$Sinh = { $: 7 };
    var $author$project$Expression$StepSimplify = { $: 32 };
    var $author$project$Expression$Tan = { $: 2 };
    var $author$project$Expression$Tanh = { $: 9 };
    var $author$project$Expression$unaryFunctions = function () {
        var trig = _List_fromArray([
            _Utils_Tuple2("sin", $author$project$Expression$Sin),
            _Utils_Tuple2("cos", $author$project$Expression$Cos),
            _Utils_Tuple2("tan", $author$project$Expression$Tan),
            _Utils_Tuple2("asin", $author$project$Expression$Asin),
            _Utils_Tuple2("acos", $author$project$Expression$Acos),
            _Utils_Tuple2("atan", $author$project$Expression$Atan),
            _Utils_Tuple2("sinh", $author$project$Expression$Sinh),
            _Utils_Tuple2("cosh", $author$project$Expression$Cosh),
            _Utils_Tuple2("tanh", $author$project$Expression$Tanh)
        ]);
        var power = _List_fromArray([
            _Utils_Tuple2("abs", $author$project$Expression$Abs),
            _Utils_Tuple2("sign", $author$project$Expression$Sign),
            _Utils_Tuple2("sqrt", $author$project$Expression$Root(2)),
            _Utils_Tuple2("cbrt", $author$project$Expression$Root(3)),
            _Utils_Tuple2("ln", $author$project$Expression$Ln),
            _Utils_Tuple2("log10", $author$project$Expression$Log10),
            _Utils_Tuple2("exp", $author$project$Expression$Exp)
        ]);
        var other = _List_fromArray([
            _Utils_Tuple2("plot", $author$project$Expression$Plot),
            _Utils_Tuple2("aplot", $author$project$Expression$APlot),
            _Utils_Tuple2("simplify", $author$project$Expression$Simplify),
            _Utils_Tuple2("stepsimplify", $author$project$Expression$StepSimplify),
            _Utils_Tuple2("floor", $author$project$Expression$Floor),
            _Utils_Tuple2("ceil", $author$project$Expression$Ceiling),
            _Utils_Tuple2("ceiling", $author$project$Expression$Ceiling),
            _Utils_Tuple2("round", $author$project$Expression$Round)
        ]);
        var matrix = _List_fromArray([
            _Utils_Tuple2("gra", $author$project$Expression$Gra),
            _Utils_Tuple2("det", $author$project$Expression$Det)
        ]);
        var complex = _List_fromArray([
            _Utils_Tuple2("re", $author$project$Expression$Re),
            _Utils_Tuple2("im", $author$project$Expression$Im),
            _Utils_Tuple2("arg", $author$project$Expression$Arg)
        ]);
        return $elm$core$List$concat(_List_fromArray([power, trig, complex, matrix, other]));
    }();
    var $author$project$Expression$For = { $: 36 };
    var $author$project$Expression$Max = { $: 24 };
    var $author$project$Expression$Min = { $: 23 };
    var $author$project$Expression$variadicFunctions = _List_fromArray([
        _Utils_Tuple2("min", $author$project$Expression$Min),
        _Utils_Tuple2("max", $author$project$Expression$Max),
        _Utils_Tuple2("for", $author$project$Expression$For)
    ]);
    var $author$project$Expression$defaultContext = function () {
        var map = function (i) {
            return $elm$core$List$map(function (_v0) {
                var f = _v0.a;
                var n = _v0.b;
                return _Utils_Tuple2(f, _Utils_Tuple2($author$project$Expression$KnownFunction(n), i));
            });
        };
        var letters = $elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar), $elm$core$List$range_fn($elm$core$Char$toCode("a"), $elm$core$Char$toCode("z")));
        return {
            c9: $elm$core$List$foldl_fn($author$project$Trie$fromList_a0, $author$project$Trie$fromList_a1, $elm$core$List$concat(_List_fromArray([
                A2(map, $elm$core$Maybe$Just(1), $author$project$Expression$unaryFunctions),
                A2(map, $elm$core$Maybe$Just(2), $author$project$Expression$binaryFunctions),
                A2(map, $elm$core$Maybe$Just(3), $author$project$Expression$ternaryFunctions),
                A2(map, $elm$core$Maybe$Just(4), $author$project$Expression$quaternaryFunctions),
                A2(map, $elm$core$Maybe$Nothing, $author$project$Expression$variadicFunctions)
            ]))),
            ea: $elm$core$List$foldl_fn($author$project$Trie$fromList_a0, $author$project$Trie$fromList_a1, $elm$core$List$map_fn(function (v) {
                return _Utils_Tuple2(v, 0);
            }, _Utils_ap(letters, $elm$core$Dict$keys($author$project$Expression$greeks))))
        };
    }();
    var $elm$parser$Parser$Advanced$Bad_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Bad = F2($elm$parser$Parser$Advanced$Bad_fn);
    var $elm$parser$Parser$Advanced$Good_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $elm$parser$Parser$Advanced$Good = F3($elm$parser$Parser$Advanced$Good_fn);
    var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
    var $elm$parser$Parser$Advanced$AddRight_fn = function (a, b) {
        return { $: 1, a: a, b: b };
    }, $elm$parser$Parser$Advanced$AddRight = F2($elm$parser$Parser$Advanced$AddRight_fn);
    var $elm$parser$Parser$Advanced$DeadEnd_fn = function (row, col, problem, contextStack) {
        return { aG: col, bR: contextStack, dE: problem, f$: row };
    }, $elm$parser$Parser$Advanced$DeadEnd = F4($elm$parser$Parser$Advanced$DeadEnd_fn);
    var $elm$parser$Parser$Advanced$Empty = { $: 0 };
    var $elm$parser$Parser$Advanced$fromState_fn = function (s, x) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(s.f$, s.aG, x, s.eU));
    }, $elm$parser$Parser$Advanced$fromState = F2($elm$parser$Parser$Advanced$fromState_fn);
    var $elm$parser$Parser$Advanced$end = function (x) {
        return function (s) {
            return _Utils_eq($elm$core$String$length(s.cr), s.a) ? $elm$parser$Parser$Advanced$Good_fn(false, 0, s) : $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$Advanced$map2_fn = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, A2(func, a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2_fn_unwrapped = function (func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function (s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, func(a, b), s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$map2 = F3($elm$parser$Parser$Advanced$map2_fn);
    var $elm$parser$Parser$Advanced$ignorer_fn = function (keepParser, ignoreParser) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$always, keepParser, ignoreParser);
    }, $elm$parser$Parser$Advanced$ignorer = F2($elm$parser$Parser$Advanced$ignorer_fn);
    var $elm$parser$Parser$Advanced$keeper_fn = function (parseFunc, parseArg) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$core$Basics$apL, parseFunc, parseArg);
    }, $elm$parser$Parser$Advanced$keeper = F2($elm$parser$Parser$Advanced$keeper_fn);
    var $author$project$Expression$Parser$AddSubtractionContext = 0;
    var $author$project$Expression$Apply_fn = function (a, b) {
        return { $: 8, a: a, b: b };
    }, $author$project$Expression$Apply = F2($author$project$Expression$Apply_fn);
    var $author$project$Expression$Parser$AtomContext = 1;
    var $elm$parser$Parser$Advanced$Done = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$Equals = 2;
    var $author$project$Expression$Parser$Expected = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Parser$ExpressionContext = 2;
    var $elm$parser$Parser$Advanced$Forbidden = 0;
    var $author$project$Expression$GreaterThan = 4;
    var $author$project$Expression$GreaterThanOrEquals = 3;
    var $author$project$Expression$Lambda_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Expression$Lambda = F2($author$project$Expression$Lambda_fn);
    var $author$project$Expression$LessThan = 0;
    var $author$project$Expression$LessThanOrEquals = 1;
    var $author$project$Expression$List = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$Expression$Parser$ListContext = 3;
    var $elm$parser$Parser$Advanced$Loop = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Parser$MultiDivisionContext = 4;
    var $author$project$Expression$Parser$NumberContext = 5;
    var $elm$parser$Parser$Advanced$Optional = 1;
    var $author$project$Expression$Parser$PowerContext = 6;
    var $author$project$Expression$RelationOperation_fn = function (a, b, c) {
        return { $: 6, a: a, b: b, c: c };
    }, $author$project$Expression$RelationOperation = F3($author$project$Expression$RelationOperation_fn);
    var $author$project$Expression$Replace_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Expression$Replace = F2($author$project$Expression$Replace_fn);
    var $author$project$Expression$Parser$ReplacementContext = 7;
    var $author$project$Expression$Parser$ReplacementListContext = 8;
    var $author$project$Expression$Variable = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Expression$Parser$VariableContext = 9;
    var $author$project$Expression$Parser$VectorContext = 10;
    var $elm$parser$Parser$Advanced$andThen_fn = function (callback, _v0) {
        var parseA = _v0;
        return function (s0) {
            var _v1 = parseA(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p1 = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                var _v2 = callback(a);
                var parseB = _v2;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return $elm$parser$Parser$Advanced$Bad_fn(p1 || p2, x);
                }
                else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return $elm$parser$Parser$Advanced$Good_fn(p1 || p2, b, s2);
                }
            }
        };
    }, $elm$parser$Parser$Advanced$andThen = F2($elm$parser$Parser$Advanced$andThen_fn);
    var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(false, x);
            }
            else {
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(false, a, s1);
            }
        };
    };
    var $author$project$Expression$Multiplication = 1;
    var $author$project$Expression$AssociativeOperation_fn = function (a, b, c, d) {
        return { $: 7, a: a, b: b, c: c, d: d };
    }, $author$project$Expression$AssociativeOperation = F4($author$project$Expression$AssociativeOperation_fn);
    var $author$project$Expression$Utils$associativeOperation_fn = function (op, _default, xs) {
        if (!xs.b) {
            return _default;
        }
        else {
            if (!xs.b.b) {
                var single = xs.a;
                return single;
            }
            else {
                var y_ = xs.a;
                var _v1 = xs.b;
                var z_ = _v1.a;
                var zs = _v1.b;
                return $author$project$Expression$AssociativeOperation_fn(op, y_, z_, zs);
            }
        }
    }, $author$project$Expression$Utils$associativeOperation = F3($author$project$Expression$Utils$associativeOperation_fn);
    var $author$project$Expression$Integer = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Utils$one = $author$project$Expression$Integer(1);
    var $author$project$Expression$Utils$by_a0 = 1, $author$project$Expression$Utils$by_a1 = $author$project$Expression$Utils$one, $author$project$Expression$Utils$by = A2($author$project$Expression$Utils$associativeOperation, $author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1);
    var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
    var $elm$parser$Parser$Advanced$chompIf_fn = function (isGood, expecting) {
        return function (s) {
            var newOffset = _Parser_isSubChar_fn(isGood, s.a, s.cr);
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : (newOffset === -2 ? $elm$parser$Parser$Advanced$Good_fn(true, 0, { aG: 1, eU: s.eU, f: s.f, a: s.a + 1, f$: s.f$ + 1, cr: s.cr }) : $elm$parser$Parser$Advanced$Good_fn(true, 0, { aG: s.aG + 1, eU: s.eU, f: s.f, a: newOffset, f$: s.f$, cr: s.cr }));
        };
    }, $elm$parser$Parser$Advanced$chompIf = F2($elm$parser$Parser$Advanced$chompIf_fn);
    var $elm$parser$Parser$Advanced$chompWhileHelp_fn = function (isGood, offset, row, col, s0) {
        chompWhileHelp: while (true) {
            var newOffset = _Parser_isSubChar_fn(isGood, offset, s0.cr);
            if (newOffset === -1) {
                return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s0.a, offset) < 0, 0, { aG: col, eU: s0.eU, f: s0.f, a: offset, f$: row, cr: s0.cr });
            }
            else {
                if (newOffset === -2) {
                    var $temp$isGood = isGood, $temp$offset = offset + 1, $temp$row = row + 1, $temp$col = 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
                else {
                    var $temp$isGood = isGood, $temp$offset = newOffset, $temp$row = row, $temp$col = col + 1, $temp$s0 = s0;
                    isGood = $temp$isGood;
                    offset = $temp$offset;
                    row = $temp$row;
                    col = $temp$col;
                    s0 = $temp$s0;
                    continue chompWhileHelp;
                }
            }
        }
    }, $elm$parser$Parser$Advanced$chompWhileHelp = F5($elm$parser$Parser$Advanced$chompWhileHelp_fn);
    var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
        return function (s) {
            return $elm$parser$Parser$Advanced$chompWhileHelp_fn(isGood, s.a, s.f$, s.aG, s);
        };
    };
    var $author$project$Trie$union_fn = function (_v0, _v1) {
        var l = _v0;
        var r = _v1;
        var value = function () {
            var _v4 = l.S;
            if (_v4.$ === 1) {
                return r.S;
            }
            else {
                return l.S;
            }
        }();
        var go = F2(function (x, y) {
            if (!x.b) {
                return y;
            }
            else {
                var xh = x.a;
                var xc = xh.a;
                var xn = xh.b;
                var xt = x.b;
                if (!y.b) {
                    return x;
                }
                else {
                    var yh = y.a;
                    var yc = yh.a;
                    var yn = yh.b;
                    var yt = y.b;
                    return _Utils_eq(xc, yc) ? _List_Cons(_Utils_Tuple2(xc, $author$project$Trie$union_fn(xn, yn)), A2(go, xt, yt)) : ((_Utils_cmp(xc, yc) < 0) ? _List_Cons(xh, A2(go, xt, y)) : _List_Cons(yh, A2(go, x, yt)));
                }
            }
        });
        return {
            P: $elm$core$Dict$fromList(A2(go, $elm$core$Dict$toList(l.P), $elm$core$Dict$toList(r.P))),
            S: value
        };
    }, $author$project$Trie$union = F2($author$project$Trie$union_fn);
    var $author$project$Expression$Parser$combineContext_fn = function (old, _new) {
        return {
            c9: $author$project$Trie$union_fn(old.c9, _new.c9),
            ea: $author$project$Trie$union_fn(old.ea, _new.ea)
        };
    }, $author$project$Expression$Parser$combineContext = F2($author$project$Expression$Parser$combineContext_fn);
    var $elm$parser$Parser$Advanced$commit = function (a) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Good_fn(true, a, s);
        };
    };
    var $author$project$Expression$BinaryOperation_fn = function (a, b, c) {
        return { $: 5, a: a, b: b, c: c };
    }, $author$project$Expression$BinaryOperation = F3($author$project$Expression$BinaryOperation_fn);
    var $author$project$Expression$Division = 0;
    var $author$project$Expression$Utils$div_a0 = 0, $author$project$Expression$Utils$div = $author$project$Expression$BinaryOperation($author$project$Expression$Utils$div_a0);
    var $author$project$Expression$Parser$expectedALetter = $author$project$Expression$Parser$Expected({ e0: "a letter", fs: "una lettera" });
    var $elm$parser$Parser$Advanced$mapChompedString_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, A2(func, _String_slice_fn(s0.a, s1.a, s0.cr), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
            else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(_String_slice_fn(s0.a, s1.a, s0.cr), a), s1);
            }
        };
    }, $elm$parser$Parser$Advanced$mapChompedString = F2($elm$parser$Parser$Advanced$mapChompedString_fn);
    var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
        return $elm$parser$Parser$Advanced$mapChompedString_fn($elm$core$Basics$always, parser);
    };
    var $author$project$Expression$Defined = 1;
    var $author$project$Trie$get = function (key) {
        var go = F2(function (k, _v0) {
            var value = _v0.S;
            var children = _v0.P;
            if (!k.b) {
                return value;
            }
            else {
                var h = k.a;
                var t = k.b;
                return $elm$core$Maybe$andThen_fn(go(t), $elm$core$Dict$get_fn(h, children));
            }
        });
        return go($elm$core$String$toList(key));
    };
    var $author$project$Expression$Parser$getFirstFree = function (trie) {
        var alphabeth = $elm$core$List$map_fn(A2($elm$core$Basics$composeL, $elm$core$String$fromChar, $elm$core$Char$fromCode), $elm$core$List$range_fn($elm$core$Char$toCode("a"), $elm$core$Char$toCode("z")));
        var go = function (lst) {
            go: while (true) {
                var _v0 = $elm_community$list_extra$List$Extra$find_fn(function (p) {
                    return !_Utils_eq(A2($author$project$Trie$get, p, trie), $elm$core$Maybe$Just(1));
                }, lst);
                if (!_v0.$) {
                    var p = _v0.a;
                    return p;
                }
                else {
                    var $temp$lst = $elm$core$List$concatMap_fn(function (l) {
                        return $elm$core$List$map_fn(function (r) {
                            return _Utils_ap(l, r);
                        }, alphabeth);
                    }, lst);
                    lst = $temp$lst;
                    continue go;
                }
            }
        };
        return go(alphabeth);
    };
    var $elm$core$String$fromList = _String_fromList;
    var $author$project$Trie$getLongestPrefix = function (s) {
        var tryClose = F2(function (acc, value) {
            return $elm$core$Maybe$map_fn(function (v) {
                return _Utils_Tuple2($elm$core$String$fromList($elm$core$List$reverse(acc)), v);
            }, value);
        });
        var go = F3(function (cs, acc, _v0) {
            var value = _v0.S;
            var children = _v0.P;
            if (!cs.b) {
                return A2(tryClose, acc, value);
            }
            else {
                var h = cs.a;
                var t = cs.b;
                var _v2 = $elm$core$Dict$get_fn(h, children);
                if (_v2.$ === 1) {
                    return A2(tryClose, acc, value);
                }
                else {
                    var child = _v2.a;
                    var _v3 = A3(go, t, _List_Cons(h, acc), child);
                    if (!_v3.$) {
                        var r = _v3.a;
                        return $elm$core$Maybe$Just(r);
                    }
                    else {
                        return A2(tryClose, acc, value);
                    }
                }
            }
        });
        return A2(go, $elm$core$String$toList(s), _List_Nil);
    };
    var $elm$parser$Parser$Advanced$getOffset = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.a, s);
    };
    var $elm$parser$Parser$Advanced$getSource = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.cr, s);
    };
    var $elm$parser$Parser$Advanced$Located_fn = function (row, col, context) {
        return { aG: col, eU: context, f$: row };
    }, $elm$parser$Parser$Advanced$Located = F3($elm$parser$Parser$Advanced$Located_fn);
    var $elm$parser$Parser$Advanced$changeContext_fn = function (newContext, s) {
        return { aG: s.aG, eU: newContext, f: s.f, a: s.a, f$: s.f$, cr: s.cr };
    }, $elm$parser$Parser$Advanced$changeContext = F2($elm$parser$Parser$Advanced$changeContext_fn);
    var $elm$parser$Parser$Advanced$inContext_fn = function (context, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse($elm$parser$Parser$Advanced$changeContext_fn(_List_Cons($elm$parser$Parser$Advanced$Located_fn(s0.f$, s0.aG, context), s0.eU), s0));
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, a, $elm$parser$Parser$Advanced$changeContext_fn(s0.eU, s1));
            }
            else {
                var step = _v1;
                return step;
            }
        };
    }, $elm$parser$Parser$Advanced$inContext = F2($elm$parser$Parser$Advanced$inContext_fn);
    var $elm$core$Basics$modBy = _Basics_modBy;
    var $miniBill$elm_unicode$Unicode$isAlpha = function (c) {
        var code = $elm$core$Char$toCode(c);
        return (code < 256) ? (((code >= 65) && (code <= 90)) || (((code >= 97) && (code <= 122)) || ((code === 170) || ((code === 181) || ((code === 186) || (((code >= 192) && (code <= 214)) || (((code >= 216) && (code <= 246)) || ((code >= 248) && (code <= 255))))))))) : ((code < 42191) ? ((code < 4196) ? ((code < 2523) ? ((code < 1790) ? ((code < 1328) ? (((code >= 256) && (code <= 705)) || (((code >= 710) && (code <= 721)) || (((code >= 736) && (code <= 740)) || (((code >= 880) && (code <= 884)) || (((code >= 886) && (code <= 887)) || (((code >= 890) && (code <= 893)) || ((code === 895) || ((code === 902) || (((code >= 904) && (code <= 1013)) || (((code >= 1015) && (code <= 1153)) || (((code >= 1162) && (code <= 1327)) || ((!_Basics_modBy_fn(2, code)) && ((code >= 748) && (code <= 750)))))))))))))) : (((code >= 1329) && (code <= 1366)) || ((code === 1369) || (((code >= 1376) && (code <= 1416)) || (((code >= 1488) && (code <= 1522)) || (((code >= 1568) && (code <= 1610)) || (((code >= 1646) && (code <= 1647)) || (((code >= 1649) && (code <= 1747)) || ((code === 1749) || (((code >= 1765) && (code <= 1766)) || (((code >= 1774) && (code <= 1775)) || ((code >= 1786) && (code <= 1788))))))))))))) : ((code < 2087) ? ((code === 1791) || ((code === 1808) || (((code >= 1810) && (code <= 1839)) || (((code >= 1869) && (code <= 1957)) || ((code === 1969) || (((code >= 1994) && (code <= 2026)) || (((code >= 2036) && (code <= 2037)) || ((code === 2042) || (((code >= 2048) && (code <= 2069)) || ((code === 2074) || (code === 2084))))))))))) : ((code === 2088) || (((code >= 2112) && (code <= 2136)) || (((code >= 2144) && (code <= 2247)) || (((code >= 2308) && (code <= 2361)) || ((code === 2365) || ((code === 2384) || (((code >= 2392) && (code <= 2401)) || (((code >= 2417) && (code <= 2432)) || (((code >= 2437) && (code <= 2489)) || ((code === 2493) || (code === 2510))))))))))))) : ((code < 3312) ? ((code < 2876) ? (((code >= 2524) && (code <= 2529)) || (((code >= 2544) && (code <= 2545)) || ((code === 2556) || (((code >= 2565) && (code <= 2617)) || (((code >= 2649) && (code <= 2654)) || (((code >= 2674) && (code <= 2676)) || (((code >= 2693) && (code <= 2745)) || ((code === 2749) || (((code >= 2768) && (code <= 2785)) || ((code === 2809) || ((code >= 2821) && (code <= 2873)))))))))))) : ((code === 2877) || (((code >= 2908) && (code <= 2913)) || ((code === 2929) || (((code >= 2947) && (code <= 3001)) || ((code === 3024) || (((code >= 3077) && (code <= 3133)) || (((code >= 3160) && (code <= 3169)) || ((code === 3200) || (((code >= 3205) && (code <= 3257)) || ((code === 3261) || ((code >= 3294) && (code <= 3297))))))))))))) : ((code < 3712) ? (((code >= 3313) && (code <= 3314)) || (((code >= 3332) && (code <= 3386)) || ((code === 3389) || ((code === 3406) || (((code >= 3412) && (code <= 3414)) || (((code >= 3423) && (code <= 3425)) || (((code >= 3450) && (code <= 3455)) || (((code >= 3461) && (code <= 3526)) || (((code >= 3585) && (code <= 3632)) || (((code >= 3634) && (code <= 3635)) || ((code >= 3648) && (code <= 3654)))))))))))) : (((code >= 3713) && (code <= 3760)) || (((code >= 3762) && (code <= 3763)) || (((code >= 3773) && (code <= 3780)) || ((code === 3782) || (((code >= 3804) && (code <= 3840)) || (((code >= 3904) && (code <= 3948)) || (((code >= 3976) && (code <= 3980)) || (((code >= 4096) && (code <= 4138)) || ((code === 4159) || (((code >= 4176) && (code <= 4181)) || (((code >= 4186) && (code <= 4189)) || (code === 4193))))))))))))))) : ((code < 7959) ? ((code < 6278) ? ((code < 5742) ? (((code >= 4197) && (code <= 4198)) || (((code >= 4206) && (code <= 4208)) || (((code >= 4213) && (code <= 4225)) || ((code === 4238) || (((code >= 4256) && (code <= 4301)) || (((code >= 4304) && (code <= 4346)) || (((code >= 4348) && (code <= 4954)) || (((code >= 4992) && (code <= 5007)) || (((code >= 5024) && (code <= 5109)) || (((code >= 5112) && (code <= 5117)) || ((code >= 5121) && (code <= 5740)))))))))))) : (((code >= 5743) && (code <= 5759)) || (((code >= 5761) && (code <= 5786)) || (((code >= 5792) && (code <= 5866)) || (((code >= 5873) && (code <= 5905)) || (((code >= 5920) && (code <= 5937)) || (((code >= 5952) && (code <= 5969)) || (((code >= 5984) && (code <= 6000)) || (((code >= 6016) && (code <= 6067)) || ((code === 6103) || ((code === 6108) || ((code >= 6176) && (code <= 6276))))))))))))) : ((code < 7167) ? (((code >= 6279) && (code <= 6312)) || (((code >= 6314) && (code <= 6430)) || (((code >= 6480) && (code <= 6601)) || (((code >= 6656) && (code <= 6678)) || (((code >= 6688) && (code <= 6740)) || ((code === 6823) || (((code >= 6917) && (code <= 6963)) || (((code >= 6981) && (code <= 6987)) || (((code >= 7043) && (code <= 7072)) || (((code >= 7086) && (code <= 7087)) || ((code >= 7098) && (code <= 7141)))))))))))) : (((code >= 7168) && (code <= 7203)) || (((code >= 7245) && (code <= 7247)) || (((code >= 7258) && (code <= 7293)) || (((code >= 7296) && (code <= 7304)) || (((code >= 7312) && (code <= 7359)) || (((code >= 7401) && (code <= 7404)) || (((code >= 7406) && (code <= 7411)) || (((code >= 7413) && (code <= 7414)) || ((code === 7418) || (((code >= 7424) && (code <= 7615)) || ((code >= 7680) && (code <= 7957)))))))))))))) : ((code < 8525) ? ((code < 8318) ? (((code >= 7960) && (code <= 7965)) || (((code >= 7968) && (code <= 8005)) || (((code >= 8008) && (code <= 8013)) || (((code >= 8016) && (code <= 8023)) || (((code >= 8025) && (code <= 8124)) || ((code === 8126) || (((code >= 8130) && (code <= 8140)) || (((code >= 8144) && (code <= 8155)) || (((code >= 8160) && (code <= 8172)) || (((code >= 8178) && (code <= 8188)) || (code === 8305))))))))))) : ((code === 8319) || (((code >= 8336) && (code <= 8348)) || ((code === 8450) || ((code === 8455) || (((code >= 8458) && (code <= 8467)) || ((code === 8469) || (((code >= 8473) && (code <= 8477)) || (((code >= 8490) && (code <= 8493)) || (((code >= 8495) && (code <= 8505)) || (((code >= 8508) && (code <= 8511)) || (((code >= 8517) && (code <= 8521)) || ((!_Basics_modBy_fn(2, code)) && ((code >= 8484) && (code <= 8488))))))))))))))) : ((code < 11822) ? ((code === 8526) || (((code >= 8579) && (code <= 8580)) || (((code >= 11264) && (code <= 11310)) || (((code >= 11312) && (code <= 11358)) || (((code >= 11360) && (code <= 11492)) || (((code >= 11499) && (code <= 11502)) || (((code >= 11506) && (code <= 11507)) || (((code >= 11520) && (code <= 11565)) || (((code >= 11568) && (code <= 11623)) || ((code === 11631) || ((code >= 11648) && (code <= 11742)))))))))))) : ((code === 11823) || (((code >= 12293) && (code <= 12294)) || (((code >= 12337) && (code <= 12341)) || (((code >= 12347) && (code <= 12348)) || (((code >= 12353) && (code <= 12438)) || (((code >= 12445) && (code <= 12447)) || (((code >= 12449) && (code <= 12538)) || (((code >= 12540) && (code <= 12686)) || (((code >= 12704) && (code <= 12735)) || (((code >= 12784) && (code <= 12799)) || (((code >= 13312) && (code <= 19903)) || ((code >= 19968) && (code <= 42124))))))))))))))))) : ((code < 68863) ? ((code < 44031) ? ((code < 43359) ? ((code < 42996) ? (((code >= 42192) && (code <= 42237)) || (((code >= 42240) && (code <= 42508)) || (((code >= 42512) && (code <= 42527)) || (((code >= 42538) && (code <= 42539)) || (((code >= 42560) && (code <= 42606)) || (((code >= 42623) && (code <= 42653)) || (((code >= 42656) && (code <= 42725)) || (((code >= 42775) && (code <= 42783)) || (((code >= 42786) && (code <= 42888)) || (((code >= 42891) && (code <= 42943)) || ((code >= 42946) && (code <= 42954)))))))))))) : (((code >= 42997) && (code <= 43009)) || (((code >= 43011) && (code <= 43013)) || (((code >= 43015) && (code <= 43018)) || (((code >= 43020) && (code <= 43042)) || (((code >= 43072) && (code <= 43123)) || (((code >= 43138) && (code <= 43187)) || (((code >= 43250) && (code <= 43255)) || ((code === 43259) || (((code >= 43261) && (code <= 43262)) || (((code >= 43274) && (code <= 43301)) || ((code >= 43312) && (code <= 43334))))))))))))) : ((code < 43696) ? (((code >= 43360) && (code <= 43388)) || (((code >= 43396) && (code <= 43442)) || ((code === 43471) || (((code >= 43488) && (code <= 43492)) || (((code >= 43494) && (code <= 43503)) || (((code >= 43514) && (code <= 43560)) || (((code >= 43584) && (code <= 43586)) || (((code >= 43588) && (code <= 43595)) || (((code >= 43616) && (code <= 43638)) || ((code === 43642) || ((code >= 43646) && (code <= 43695)))))))))))) : ((code === 43697) || (((code >= 43701) && (code <= 43702)) || (((code >= 43705) && (code <= 43709)) || ((code === 43712) || (((code >= 43714) && (code <= 43741)) || (((code >= 43744) && (code <= 43754)) || (((code >= 43762) && (code <= 43764)) || (((code >= 43777) && (code <= 43822)) || (((code >= 43824) && (code <= 43866)) || (((code >= 43868) && (code <= 43881)) || ((code >= 43888) && (code <= 44002)))))))))))))) : ((code < 66775) ? ((code < 65381) ? (((code >= 44032) && (code <= 55291)) || (((code >= 63744) && (code <= 64217)) || (((code >= 64256) && (code <= 64279)) || ((code === 64285) || (((code >= 64287) && (code <= 64296)) || (((code >= 64298) && (code <= 64433)) || (((code >= 64467) && (code <= 64829)) || (((code >= 64848) && (code <= 65019)) || (((code >= 65136) && (code <= 65276)) || (((code >= 65313) && (code <= 65338)) || ((code >= 65345) && (code <= 65370)))))))))))) : (((code >= 65382) && (code <= 65500)) || (((code >= 65536) && (code <= 65786)) || (((code >= 66176) && (code <= 66256)) || (((code >= 66304) && (code <= 66335)) || (((code >= 66349) && (code <= 66368)) || (((code >= 66370) && (code <= 66377)) || (((code >= 66384) && (code <= 66421)) || (((code >= 66432) && (code <= 66461)) || (((code >= 66464) && (code <= 66511)) || (((code >= 66560) && (code <= 66717)) || ((code >= 66736) && (code <= 66771))))))))))))) : ((code < 68111) ? (((code >= 66776) && (code <= 66811)) || (((code >= 66816) && (code <= 66915)) || (((code >= 67072) && (code <= 67669)) || (((code >= 67680) && (code <= 67702)) || (((code >= 67712) && (code <= 67742)) || (((code >= 67808) && (code <= 67829)) || (((code >= 67840) && (code <= 67861)) || (((code >= 67872) && (code <= 67897)) || (((code >= 67968) && (code <= 68023)) || (((code >= 68030) && (code <= 68031)) || (code === 68096))))))))))) : (((code >= 68112) && (code <= 68149)) || (((code >= 68192) && (code <= 68220)) || (((code >= 68224) && (code <= 68252)) || (((code >= 68288) && (code <= 68295)) || (((code >= 68297) && (code <= 68324)) || (((code >= 68352) && (code <= 68405)) || (((code >= 68416) && (code <= 68437)) || (((code >= 68448) && (code <= 68466)) || (((code >= 68480) && (code <= 68497)) || (((code >= 68608) && (code <= 68680)) || (((code >= 68736) && (code <= 68786)) || ((code >= 68800) && (code <= 68850)))))))))))))))) : ((code < 72383) ? ((code < 70655) ? ((code < 69958) ? (((code >= 68864) && (code <= 68899)) || (((code >= 69248) && (code <= 69289)) || (((code >= 69296) && (code <= 69404)) || (((code >= 69415) && (code <= 69445)) || (((code >= 69552) && (code <= 69572)) || (((code >= 69600) && (code <= 69622)) || (((code >= 69635) && (code <= 69687)) || (((code >= 69763) && (code <= 69807)) || (((code >= 69840) && (code <= 69864)) || (((code >= 69891) && (code <= 69926)) || (code === 69956))))))))))) : (((code >= 69959) && (code <= 70002)) || ((code === 70006) || (((code >= 70019) && (code <= 70066)) || (((code >= 70081) && (code <= 70084)) || (((code >= 70144) && (code <= 70187)) || (((code >= 70272) && (code <= 70312)) || (((code >= 70320) && (code <= 70366)) || (((code >= 70405) && (code <= 70457)) || ((code === 70461) || ((code === 70480) || (((code >= 70493) && (code <= 70497)) || ((!_Basics_modBy_fn(2, code)) && ((code >= 70106) && (code <= 70108))))))))))))))) : ((code < 71423) ? (((code >= 70656) && (code <= 70708)) || (((code >= 70727) && (code <= 70730)) || (((code >= 70751) && (code <= 70831)) || (((code >= 70852) && (code <= 70853)) || ((code === 70855) || (((code >= 71040) && (code <= 71086)) || (((code >= 71128) && (code <= 71131)) || (((code >= 71168) && (code <= 71215)) || ((code === 71236) || (((code >= 71296) && (code <= 71338)) || (code === 71352))))))))))) : (((code >= 71424) && (code <= 71450)) || (((code >= 71680) && (code <= 71723)) || (((code >= 71840) && (code <= 71903)) || (((code >= 71935) && (code <= 71983)) || (((code >= 72096) && (code <= 72144)) || ((code === 72192) || (((code >= 72203) && (code <= 72242)) || ((code === 72250) || ((code === 72272) || (((code >= 72284) && (code <= 72329)) || ((code === 72349) || ((_Basics_modBy_fn(2, code) === 1) && (((code >= 71999) && (code <= 72001)) || ((code >= 72161) && (code <= 72163))))))))))))))))) : ((code < 119807) ? ((code < 82943) ? (((code >= 72384) && (code <= 72750)) || ((code === 72768) || (((code >= 72818) && (code <= 72847)) || (((code >= 72960) && (code <= 73008)) || ((code === 73030) || (((code >= 73056) && (code <= 73097)) || ((code === 73112) || (((code >= 73440) && (code <= 73458)) || ((code === 73648) || (((code >= 73728) && (code <= 74649)) || ((code >= 74880) && (code <= 78894)))))))))))) : (((code >= 82944) && (code <= 92766)) || (((code >= 92880) && (code <= 92909)) || (((code >= 92928) && (code <= 92975)) || (((code >= 92992) && (code <= 92995)) || (((code >= 93027) && (code <= 93071)) || (((code >= 93760) && (code <= 93823)) || (((code >= 93952) && (code <= 94026)) || ((code === 94032) || (((code >= 94099) && (code <= 94177)) || ((code === 94179) || ((code >= 94208) && (code <= 113817))))))))))))) : ((code < 120713) ? (((code >= 119808) && (code <= 120092)) || (((code >= 120094) && (code <= 120144)) || (((code >= 120146) && (code <= 120485)) || (((code >= 120488) && (code <= 120512)) || (((code >= 120514) && (code <= 120538)) || (((code >= 120540) && (code <= 120570)) || (((code >= 120572) && (code <= 120596)) || (((code >= 120598) && (code <= 120628)) || (((code >= 120630) && (code <= 120654)) || (((code >= 120656) && (code <= 120686)) || ((code >= 120688) && (code <= 120712)))))))))))) : (((code >= 120714) && (code <= 120744)) || (((code >= 120746) && (code <= 120770)) || (((code >= 120772) && (code <= 120779)) || (((code >= 123136) && (code <= 123180)) || (((code >= 123191) && (code <= 123197)) || ((code === 123214) || (((code >= 123584) && (code <= 123627)) || (((code >= 124928) && (code <= 125124)) || (((code >= 125184) && (code <= 125251)) || ((code === 125259) || (((code >= 126464) && (code <= 126651)) || ((code >= 131072) && (code <= 201546))))))))))))))))));
    };
    var $author$project$Expression$Parser$isVariableLetter = $miniBill$elm_unicode$Unicode$isAlpha;
    var $elm$parser$Parser$Advanced$lazy = function (thunk) {
        return function (s) {
            var _v0 = thunk(0);
            var parse = _v0;
            return parse(s);
        };
    };
    var $elm$parser$Parser$Advanced$loopHelp_fn = function (p, state, callback, s0) {
        loopHelp: while (true) {
            var _v0 = callback(state);
            var parse = _v0;
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p1 = _v1.a;
                var step = _v1.b;
                var s1 = _v1.c;
                if (!step.$) {
                    var newState = step.a;
                    var $temp$p = p || p1, $temp$state = newState, $temp$callback = callback, $temp$s0 = s1;
                    p = $temp$p;
                    state = $temp$state;
                    callback = $temp$callback;
                    s0 = $temp$s0;
                    continue loopHelp;
                }
                else {
                    var result = step.a;
                    return $elm$parser$Parser$Advanced$Good_fn(p || p1, result, s1);
                }
            }
            else {
                var p1 = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p || p1, x);
            }
        }
    }, $elm$parser$Parser$Advanced$loopHelp = F4($elm$parser$Parser$Advanced$loopHelp_fn);
    var $elm$parser$Parser$Advanced$loop_fn = function (state, callback) {
        return function (s) {
            return $elm$parser$Parser$Advanced$loopHelp_fn(false, state, callback, s);
        };
    }, $elm$parser$Parser$Advanced$loop = F2($elm$parser$Parser$Advanced$loop_fn);
    var $elm$parser$Parser$Advanced$map_fn = function (func, _v0) {
        var parse = _v0;
        return function (s0) {
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return $elm$parser$Parser$Advanced$Good_fn(p, func(a), s1);
            }
            else {
                var p = _v1.a;
                var x = _v1.b;
                return $elm$parser$Parser$Advanced$Bad_fn(p, x);
            }
        };
    }, $elm$parser$Parser$Advanced$map = F2($elm$parser$Parser$Advanced$map_fn);
    var $author$project$Expression$Negate = 0;
    var $author$project$Expression$UnaryOperation_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Expression$UnaryOperation = F2($author$project$Expression$UnaryOperation_fn);
    var $author$project$Expression$Utils$negate__a0 = 0, $author$project$Expression$Utils$negate_ = $author$project$Expression$UnaryOperation($author$project$Expression$Utils$negate__a0);
    var $author$project$Expression$Addition = 0;
    var $author$project$Expression$Utils$zero = $author$project$Expression$Integer(0);
    var $author$project$Expression$Utils$plus_a0 = 0, $author$project$Expression$Utils$plus_a1 = $author$project$Expression$Utils$zero, $author$project$Expression$Utils$plus = A2($author$project$Expression$Utils$associativeOperation, $author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1);
    var $author$project$Expression$Utils$minus_fn = function (x_, y_) {
        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
            x_,
            $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, y_)
        ]));
    }, $author$project$Expression$Utils$minus = F2($author$project$Expression$Utils$minus_fn);
    var $elm$parser$Parser$Advanced$Append_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Append = F2($elm$parser$Parser$Advanced$Append_fn);
    var $elm$parser$Parser$Advanced$oneOfHelp_fn = function (s0, bag, parsers) {
        oneOfHelp: while (true) {
            if (!parsers.b) {
                return $elm$parser$Parser$Advanced$Bad_fn(false, bag);
            }
            else {
                var parse = parsers.a;
                var remainingParsers = parsers.b;
                var _v1 = parse(s0);
                if (!_v1.$) {
                    var step = _v1;
                    return step;
                }
                else {
                    var step = _v1;
                    var p = step.a;
                    var x = step.b;
                    if (p) {
                        return step;
                    }
                    else {
                        var $temp$s0 = s0, $temp$bag = $elm$parser$Parser$Advanced$Append_fn(bag, x), $temp$parsers = remainingParsers;
                        s0 = $temp$s0;
                        bag = $temp$bag;
                        parsers = $temp$parsers;
                        continue oneOfHelp;
                    }
                }
            }
        }
    }, $elm$parser$Parser$Advanced$oneOfHelp = F3($elm$parser$Parser$Advanced$oneOfHelp_fn);
    var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
        return function (s) {
            return $elm$parser$Parser$Advanced$oneOfHelp_fn(s, $elm$parser$Parser$Advanced$Empty, parsers);
        };
    };
    var $elm$parser$Parser$Advanced$succeed = function (a) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Good_fn(false, a, s);
        };
    };
    var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
    var $elm$parser$Parser$Advanced$token = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(str);
        return function (s) {
            var _v1 = _Parser_isSubString_fn(str, s.a, s.f$, s.aG, s.cr);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, expecting)) : $elm$parser$Parser$Advanced$Good_fn(progress, 0, { aG: newCol, eU: s.eU, f: s.f, a: newOffset, f$: newRow, cr: s.cr });
        };
    };
    var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
    var $elm$parser$Parser$Advanced$Token_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $elm$parser$Parser$Advanced$Token = F2($elm$parser$Parser$Advanced$Token_fn);
    var $author$project$Expression$Parser$token = function (x) {
        return $elm$parser$Parser$Advanced$Token_fn(x, $author$project$Expression$Parser$Expected({ e0: "a '" + (x + "'"), fs: "un '" + (x + "'") }));
    };
    var $author$project$Expression$Parser$whitespace = $elm$parser$Parser$Advanced$chompWhile(function (c) {
        return (c === " ") || (c === "\n");
    });
    var $author$project$Expression$Parser$multiSequenceHelp_fn = function (_v0, acc, context) {
        var allowNegation = _v0.a4;
        var separators = _v0.bw;
        var item = _v0.ay;
        var separated = function (p) {
            return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $author$project$Expression$Parser$whitespace), p);
        }($elm$parser$Parser$Advanced$oneOf($elm$core$List$map_fn(function (_v1) {
            var f = _v1.a;
            var parser = _v1.b;
            return $elm$parser$Parser$Advanced$andThen_fn(function (chomped) {
                return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (mn, e) {
                    return $elm$parser$Parser$Advanced$Loop(A2(f, acc, mn(e)));
                })), $elm$parser$Parser$Advanced$ignorer_fn((allowNegation && (!$elm$core$String$isEmpty($elm$core$String$trim(chomped)))) ? $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($author$project$Expression$Utils$negate_), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("-"))),
                    $elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity)
                ])) : $elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $author$project$Expression$Parser$whitespace)), item(context));
            }, $elm$parser$Parser$Advanced$getChompedString(parser(context)));
        }, separators)));
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            separated,
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(acc))
        ]));
    }, $author$project$Expression$Parser$multiSequenceHelp = F3($author$project$Expression$Parser$multiSequenceHelp_fn);
    var $author$project$Expression$Parser$multiSequence_fn = function (data, context) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (first) {
            return $elm$parser$Parser$Advanced$loop_fn(first, function (expr) {
                return $author$project$Expression$Parser$multiSequenceHelp_fn(data, expr, context);
            });
        }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), data.ay(context)));
    }, $author$project$Expression$Parser$multiSequence = F2($author$project$Expression$Parser$multiSequence_fn);
    var $author$project$Expression$Parser$optional = function (p) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            p,
            $elm$parser$Parser$Advanced$succeed(0)
        ]));
    };
    var $author$project$Expression$Power = 1;
    var $author$project$Expression$Utils$pow_a0 = 1, $author$project$Expression$Utils$pow = $author$project$Expression$BinaryOperation($author$project$Expression$Utils$pow_a0);
    var $elm$parser$Parser$Advanced$problem = function (x) {
        return function (s) {
            return $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromState_fn(s, x));
        };
    };
    var $elm$parser$Parser$Advanced$revAlways_fn = function (_v0, b) {
        return b;
    }, $elm$parser$Parser$Advanced$revAlways = F2($elm$parser$Parser$Advanced$revAlways_fn);
    var $elm$parser$Parser$Advanced$skip_fn = function (iParser, kParser) {
        return $elm$parser$Parser$Advanced$map2_fn($elm$parser$Parser$Advanced$revAlways, iParser, kParser);
    }, $elm$parser$Parser$Advanced$skip = F2($elm$parser$Parser$Advanced$skip_fn);
    var $elm$parser$Parser$Advanced$sequenceEndForbidden_fn = function (ender, ws, parseItem, sep, revItems) {
        var chompRest = function (item) {
            return $elm$parser$Parser$Advanced$sequenceEndForbidden_fn(ender, ws, parseItem, sep, _List_Cons(item, revItems));
        };
        return $elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$skip_fn(sep, $elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$map_fn(function (item) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(item, revItems));
            }, parseItem))),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(revItems));
            }, ender)
        ])));
    }, $elm$parser$Parser$Advanced$sequenceEndForbidden = F5($elm$parser$Parser$Advanced$sequenceEndForbidden_fn);
    var $elm$parser$Parser$Advanced$sequenceEndMandatory_fn = function (ws, parseItem, sep, revItems) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (item) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(item, revItems));
            }, $elm$parser$Parser$Advanced$ignorer_fn(parseItem, $elm$parser$Parser$Advanced$ignorer_fn(ws, $elm$parser$Parser$Advanced$ignorer_fn(sep, ws)))),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(revItems));
            }, $elm$parser$Parser$Advanced$succeed(0))
        ]));
    }, $elm$parser$Parser$Advanced$sequenceEndMandatory = F4($elm$parser$Parser$Advanced$sequenceEndMandatory_fn);
    var $elm$parser$Parser$Advanced$sequenceEndOptional_fn = function (ender, ws, parseItem, sep, revItems) {
        var parseEnd = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(revItems));
        }, ender);
        return $elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$skip_fn(sep, $elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (item) {
                    return $elm$parser$Parser$Advanced$Loop(_List_Cons(item, revItems));
                }, parseItem),
                parseEnd
            ])))),
            parseEnd
        ])));
    }, $elm$parser$Parser$Advanced$sequenceEndOptional = F5($elm$parser$Parser$Advanced$sequenceEndOptional_fn);
    var $elm$parser$Parser$Advanced$sequenceEnd_fn = function (ender, ws, parseItem, sep, trailing) {
        var chompRest = function (item) {
            switch (trailing) {
                case 0:
                    return $elm$parser$Parser$Advanced$loop_fn(_List_fromArray([item]), A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
                case 1:
                    return $elm$parser$Parser$Advanced$loop_fn(_List_fromArray([item]), A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
                default:
                    return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$skip_fn(sep, $elm$parser$Parser$Advanced$skip_fn(ws, $elm$parser$Parser$Advanced$loop_fn(_List_fromArray([item]), A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))), ender);
            }
        };
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$andThen_fn(chompRest, parseItem),
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return _List_Nil;
            }, ender)
        ]));
    }, $elm$parser$Parser$Advanced$sequenceEnd = F5($elm$parser$Parser$Advanced$sequenceEnd_fn);
    var $elm$parser$Parser$Advanced$sequence = function (i) {
        return $elm$parser$Parser$Advanced$skip_fn($elm$parser$Parser$Advanced$token(i.d_), $elm$parser$Parser$Advanced$skip_fn(i.dY, $elm$parser$Parser$Advanced$sequenceEnd_fn($elm$parser$Parser$Advanced$token(i.c2), i.dY, i.ay, $elm$parser$Parser$Advanced$token(i.dV), i.d6)));
    };
    var $author$project$Expression$Parser$toContext = function (d) {
        return {
            c9: $author$project$Trie$empty,
            ea: $elm$core$List$foldl_fn($author$project$Trie$fromList_a0, $author$project$Trie$fromList_a1, $elm$core$List$map_fn(function (v) {
                return _Utils_Tuple2(v, 1);
            }, $elm$core$Dict$keys(d)))
        };
    };
    var $author$project$Expression$Float = function (a) {
        return { $: 1, a: a };
    };
    var $elm$core$String$toFloat = _String_toFloat;
    var $author$project$Expression$Parser$tryParseNumber = function (n) {
        var _v0 = $elm$core$String$toInt(n);
        if (!_v0.$) {
            var i = _v0.a;
            return $elm$parser$Parser$Advanced$succeed($author$project$Expression$Integer(i));
        }
        else {
            var _v1 = $elm$core$String$toFloat(n);
            if (!_v1.$) {
                var f = _v1.a;
                return $elm$parser$Parser$Advanced$succeed($author$project$Expression$Float(f));
            }
            else {
                return $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$Expected({ e0: "a number", fs: "un numero" }));
            }
        }
    };
    var $author$project$Expression$Utils$vector_a0 = $author$project$Expression$List, $author$project$Expression$Utils$vector_a1 = $elm$core$List$map(function (el) {
        return $author$project$Expression$List(_List_fromArray([el]));
    }), $author$project$Expression$Utils$vector = A2($elm$core$Basics$composeL, $author$project$Expression$Utils$vector_a0, $author$project$Expression$Utils$vector_a1);
    var $author$project$Expression$Parser$addsubtractionParser = function (context) {
        return $elm$parser$Parser$Advanced$inContext_fn(0, $author$project$Expression$Parser$multiSequence_fn({
            a4: false,
            ay: $author$project$Expression$Parser$multidivisionParser,
            bw: _List_fromArray([
                _Utils_Tuple2(F2(function (l, r) {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([l, r]));
                }), function (_v24) {
                    return $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("+"));
                }),
                _Utils_Tuple2(F2(function (l, r) {
                    return $author$project$Expression$Utils$minus_fn(l, r);
                }), function (_v25) {
                    return $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("-"));
                })
            ])
        }, context));
    };
    var $author$project$Expression$Parser$atomParser = function (context) {
        return $elm$parser$Parser$Advanced$inContext_fn(1, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$inContext_fn(10, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(function (es) {
                if (es.b && (!es.b.b)) {
                    var x = es.a;
                    return x;
                }
                else {
                    return $elm$core$Basics$composeL_fn($author$project$Expression$Utils$vector_a0, $author$project$Expression$Utils$vector_a1, es);
                }
            }), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$sequence({
                c2: $author$project$Expression$Parser$token(""),
                ay: $elm$parser$Parser$Advanced$lazy(function (_v23) {
                    return $author$project$Expression$Parser$cyclic$mainParser()(context);
                }),
                dV: $author$project$Expression$Parser$token(","),
                dY: $author$project$Expression$Parser$whitespace,
                d_: $author$project$Expression$Parser$token("("),
                d6: 0
            }), $author$project$Expression$Parser$whitespace), $author$project$Expression$Parser$optional($elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(")")))))),
            $author$project$Expression$Parser$replacementParser(context),
            $author$project$Expression$Parser$listParser(context),
            $elm$parser$Parser$Advanced$inContext_fn(9, $author$project$Expression$Parser$variableParser(context)),
            $elm$parser$Parser$Advanced$inContext_fn(5, $elm$parser$Parser$Advanced$andThen_fn($author$project$Expression$Parser$tryParseNumber, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $elm$parser$Parser$Advanced$chompIf_fn(function (c) {
                return (c === ".") || $elm$core$Char$isDigit(c);
            }, $author$project$Expression$Parser$Expected({ e0: "a digit, or a dot", fs: "una cifra, o un punto" }))), $elm$parser$Parser$Advanced$chompWhile(function (c) {
                return (c === ".") || $elm$core$Char$isDigit(c);
            })))))
        ])));
    };
    var $author$project$Expression$Parser$listParser = function (context) {
        var step = function (acc) {
            return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(","))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$map_fn(function (e) {
                        return $elm$parser$Parser$Advanced$Loop(_List_Cons(e, acc));
                    }, $elm$parser$Parser$Advanced$lazy(function (_v21) {
                        return $author$project$Expression$Parser$cyclic$mainParser()(context);
                    })),
                    $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(acc))
                ]))),
                $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(acc))
            ]));
        };
        var restParser = $elm$parser$Parser$Advanced$map_fn($elm$core$List$reverse, $elm$parser$Parser$Advanced$loop_fn(_List_Nil, step));
        return $elm$parser$Parser$Advanced$inContext_fn(3, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (h, t) {
            return $author$project$Expression$List(_List_Cons(h, t));
        })), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("{"))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$lazy(function (_v20) {
            return $author$project$Expression$Parser$cyclic$mainParser()(context);
        }), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$ignorer_fn(restParser, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("}")),
            $elm$parser$Parser$Advanced$succeed(0)
        ])))));
    };
    var $author$project$Expression$Parser$multidivisionParser = function (context) {
        var signLoopStep = function (b) {
            return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Loop(!b)), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("-"))),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Loop(b)), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("+"))),
                $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(b ? $author$project$Expression$Utils$negate_ : $elm$core$Basics$identity))
            ]));
        };
        return $elm$parser$Parser$Advanced$inContext_fn(4, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (maybeNegate, md) {
            return maybeNegate(md);
        })), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$loop_fn(false, signLoopStep), $author$project$Expression$Parser$whitespace)), $author$project$Expression$Parser$multiSequence_fn({
            a4: true,
            ay: $author$project$Expression$Parser$powerParser,
            bw: _List_fromArray([
                _Utils_Tuple2(F2(function (l, r) {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, r]));
                }), function (_v17) {
                    return $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("*"));
                }),
                _Utils_Tuple2(F2(function (l, r) {
                    return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, l, r);
                }), function (_v18) {
                    return $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("/"));
                }),
                _Utils_Tuple2(F2(function (l, r) {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, r]));
                }), function (_v19) {
                    return $elm$parser$Parser$Advanced$succeed(0);
                })
            ])
        }, context)));
    };
    var $author$project$Expression$Parser$parseArgs_fn = function (count, greedy, context) {
        if (!count.$) {
            switch (count.a) {
                case 0:
                    return $elm$parser$Parser$Advanced$succeed(_List_Nil);
                case 1:
                    return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(function (e) {
                        return _List_fromArray([e]);
                    }), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$lazy(function (_v12) {
                        return greedy ? $author$project$Expression$Parser$cyclic$mainParser()(context) : $author$project$Expression$Parser$powerParser(context);
                    }), $author$project$Expression$Parser$whitespace));
                default:
                    var c = count.a;
                    return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($elm$core$List$cons), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$lazy(function (_v13) {
                        return $author$project$Expression$Parser$cyclic$mainParser()(context);
                    }), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(","))), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$ignorer_fn($author$project$Expression$Parser$parseArgs_fn($elm$core$Maybe$Just(c - 1), greedy, context), $author$project$Expression$Parser$whitespace));
            }
        }
        else {
            return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($elm$core$List$cons), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$lazy(function (_v14) {
                    return $author$project$Expression$Parser$cyclic$mainParser()(context);
                })), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(","))), $elm$parser$Parser$Advanced$commit(0)), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$lazy(function (_v15) {
                    return $author$project$Expression$Parser$parseArgs_fn($elm$core$Maybe$Nothing, greedy, context);
                }), $author$project$Expression$Parser$whitespace)),
                $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(function (e) {
                    return _List_fromArray([e]);
                }), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$lazy(function (_v16) {
                    return greedy ? $author$project$Expression$Parser$cyclic$mainParser()(context) : $author$project$Expression$Parser$powerParser(context);
                }), $author$project$Expression$Parser$whitespace))
            ]));
        }
    }, $author$project$Expression$Parser$parseArgs = F3($author$project$Expression$Parser$parseArgs_fn);
    var $author$project$Expression$Parser$powerParser = function (context) {
        return $elm$parser$Parser$Advanced$inContext_fn(6, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (atom, maybePow) {
            return maybePow(atom);
        })), $elm$parser$Parser$Advanced$ignorer_fn($author$project$Expression$Parser$atomParser(context), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (e, b) {
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, b, e);
            })), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("^"))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$lazy(function (_v10) {
                return $author$project$Expression$Parser$powerParser(context);
            })),
            $elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity)
        ]))));
    };
    var $author$project$Expression$Parser$relationParser = function (context) {
        var inner = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (a, f) {
            return f(a);
        })), $elm$parser$Parser$Advanced$ignorer_fn($author$project$Expression$Parser$addsubtractionParser(context), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (r, l) {
                if (l.$ === 2) {
                    var v = l.a;
                    return $elm$parser$Parser$Advanced$succeed($author$project$Expression$Lambda_fn(v, r));
                }
                else {
                    return $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$Expected({ e0: "left side of lambda", fs: "la parte sinistra di una lambda" }));
                }
            })), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("=>"))), $author$project$Expression$Parser$whitespace), $author$project$Expression$Parser$addsubtractionParser(context)),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F3(function (o, r, l) {
                return $elm$parser$Parser$Advanced$succeed($author$project$Expression$RelationOperation_fn(o, l, r));
            })), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("<="))),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(3), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(">="))),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("<"))),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(2), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("="))),
                $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(4), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(">")))
            ])), $author$project$Expression$Parser$whitespace)), $author$project$Expression$Parser$addsubtractionParser(context)),
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$succeed)
        ])));
        return $elm$parser$Parser$Advanced$inContext_fn(2, $elm$parser$Parser$Advanced$andThen_fn($elm$core$Basics$identity, inner));
    };
    var $author$project$Expression$Parser$replacementListParser = function (context) {
        var shortVariable = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (p, e) {
            return _Utils_Tuple2(p, $elm$core$Maybe$Just(e));
        })), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompIf_fn($author$project$Expression$Parser$isVariableLetter, $author$project$Expression$Parser$expectedALetter)), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$andThen_fn(function (s) {
            return ($elm$core$String$length(s) > 1) ? $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$Expected({ e0: "0 or 1 '='", fs: "0 o 1 '='" })) : $elm$parser$Parser$Advanced$succeed(0);
        }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile($elm$core$Basics$eq("="))))), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$lazy(function (_v8) {
            return $author$project$Expression$Parser$cyclic$mainParser()(context);
        }));
        var longVariable = $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F2(function (v, e) {
            return _Utils_Tuple2(v, $elm$core$Maybe$Just(e));
        })), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn(function (s) {
            return $elm$core$String$isEmpty(s) ? $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$expectedALetter) : $elm$parser$Parser$Advanced$succeed(s);
        }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile($author$project$Expression$Parser$isVariableLetter))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("="))), $author$project$Expression$Parser$whitespace)), $elm$parser$Parser$Advanced$lazy(function (_v7) {
            return $author$project$Expression$Parser$cyclic$mainParser()(context);
        })));
        var declaration = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(function (v) {
            return _Utils_Tuple2(v, $elm$core$Maybe$Nothing);
        }), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("!"))), $elm$parser$Parser$Advanced$andThen_fn(function (s) {
            return $elm$core$String$isEmpty(s) ? $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$expectedALetter) : $elm$parser$Parser$Advanced$succeed(s);
        }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile($author$project$Expression$Parser$isVariableLetter))));
        return $elm$parser$Parser$Advanced$inContext_fn(8, $elm$parser$Parser$Advanced$map_fn($elm$core$Dict$fromList, $elm$parser$Parser$Advanced$sequence({
            c2: $author$project$Expression$Parser$token("]"),
            ay: $elm$parser$Parser$Advanced$oneOf(_List_fromArray([declaration, longVariable, shortVariable])),
            dV: $author$project$Expression$Parser$token(";"),
            dY: $author$project$Expression$Parser$whitespace,
            d_: $author$project$Expression$Parser$token("["),
            d6: 1
        })));
    };
    var $author$project$Expression$Parser$replacementParser = function (context) {
        return $elm$parser$Parser$Advanced$inContext_fn(7, $elm$parser$Parser$Advanced$andThen_fn(function (list) {
            return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($author$project$Expression$Replace(list)), $author$project$Expression$Parser$whitespace), $author$project$Expression$Parser$cyclic$mainParser()($author$project$Expression$Parser$combineContext_fn(context, $author$project$Expression$Parser$toContext(list))));
        }, $author$project$Expression$Parser$replacementListParser(context)));
    };
    var $author$project$Expression$Parser$variableParser = function (context) {
        var chomp = function (i) {
            return (i <= 0) ? $elm$parser$Parser$Advanced$succeed(0) : $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$chompIf_fn(function (_v0) {
                return true;
            }, $author$project$Expression$Parser$Unexpected)), chomp(i - 1));
        };
        return $elm$parser$Parser$Advanced$andThen_fn(function (rest) {
            var _v1 = A2($author$project$Trie$getLongestPrefix, rest, context.c9);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var nameString = _v2.a;
                var _v3 = _v2.b;
                var name = _v3.a;
                var arity = _v3.b;
                return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Expression$Apply(name)), $elm$core$Maybe$withDefault(function () {
                    var free = $author$project$Expression$Parser$getFirstFree(context.ea);
                    return $author$project$Expression$Lambda_fn(free, $author$project$Expression$Apply_fn(name, _List_fromArray([
                        $author$project$Expression$Variable(free)
                    ])));
                }()))), chomp($elm$core$String$length(nameString))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just), $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token("("))), $author$project$Expression$Parser$whitespace), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($author$project$Expression$Parser$parseArgs_fn($elm$core$Maybe$Nothing, true, context), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                        $elm$parser$Parser$Advanced$symbol($author$project$Expression$Parser$token(")")),
                        $elm$parser$Parser$Advanced$succeed(0)
                    ]))), $author$project$Expression$Parser$whitespace)),
                    $elm$parser$Parser$Advanced$map_fn($elm$core$Maybe$Just, $author$project$Expression$Parser$parseArgs_fn(arity, false, context)),
                    $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing), $author$project$Expression$Parser$whitespace)
                ])));
            }
            else {
                var _v4 = A2($author$project$Trie$getLongestPrefix, rest, context.ea);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var name = _v5.a;
                    return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($author$project$Expression$Variable(name)), chomp($elm$core$String$length(name)));
                }
                else {
                    var l = $elm$core$String$left_fn(1, rest);
                    var _v6 = $elm$core$String$toList(l);
                    if (_v6.b && (!_v6.b.b)) {
                        var v = _v6.a;
                        return $author$project$Expression$Parser$isVariableLetter(v) ? $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($author$project$Expression$Variable(l)), chomp(1)) : $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$expectedALetter);
                    }
                    else {
                        return $elm$parser$Parser$Advanced$problem($author$project$Expression$Parser$expectedALetter);
                    }
                }
            }
        }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($elm$core$String$dropLeft), $elm$parser$Parser$Advanced$getOffset), $elm$parser$Parser$Advanced$getSource));
    };
    function $author$project$Expression$Parser$cyclic$mainParser() {
        return $author$project$Expression$Parser$relationParser;
    }
    var $author$project$Expression$Parser$mainParser = $author$project$Expression$Parser$cyclic$mainParser();
    $author$project$Expression$Parser$cyclic$mainParser = function () {
        return $author$project$Expression$Parser$mainParser;
    };
    var $elm$core$Result$map_fn = function (func, ra) {
        if (!ra.$) {
            var a = ra.a;
            return $elm$core$Result$Ok(func(a));
        }
        else {
            var e = ra.a;
            return $elm$core$Result$Err(e);
        }
    }, $elm$core$Result$map = F2($elm$core$Result$map_fn);
    var $elm$parser$Parser$Advanced$bagToList_fn = function (bag, list) {
        bagToList: while (true) {
            switch (bag.$) {
                case 0:
                    return list;
                case 1:
                    var bag1 = bag.a;
                    var x = bag.b;
                    var $temp$bag = bag1, $temp$list = _List_Cons(x, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
                default:
                    var bag1 = bag.a;
                    var bag2 = bag.b;
                    var $temp$bag = bag1, $temp$list = $elm$parser$Parser$Advanced$bagToList_fn(bag2, list);
                    bag = $temp$bag;
                    list = $temp$list;
                    continue bagToList;
            }
        }
    }, $elm$parser$Parser$Advanced$bagToList = F2($elm$parser$Parser$Advanced$bagToList_fn);
    var $elm$parser$Parser$Advanced$run_fn = function (_v0, src) {
        var parse = _v0;
        var _v1 = parse({ aG: 1, eU: _List_Nil, f: 1, a: 0, f$: 1, cr: src });
        if (!_v1.$) {
            var value = _v1.b;
            return $elm$core$Result$Ok(value);
        }
        else {
            var bag = _v1.b;
            return $elm$core$Result$Err($elm$parser$Parser$Advanced$bagToList_fn(bag, _List_Nil));
        }
    }, $elm$parser$Parser$Advanced$run = F2($elm$parser$Parser$Advanced$run_fn);
    var $elm$core$Dict$map_fn = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, A2(func, key, value), $elm$core$Dict$map_fn(func, left), $elm$core$Dict$map_fn(func, right));
        }
    }, $elm$core$Dict$map_fn_unwrapped = function (func, dict) {
        if (dict.$ === -2) {
            return $elm$core$Dict$RBEmpty_elm_builtin;
        }
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return $elm$core$Dict$RBNode_elm_builtin_fn(color, key, func(key, value), $elm$core$Dict$map_fn_unwrapped(func, left), $elm$core$Dict$map_fn_unwrapped(func, right));
        }
    }, $elm$core$Dict$map = F2($elm$core$Dict$map_fn);
    var $author$project$Expression$visit_fn = function (f, expr) {
        var _v0 = f(expr);
        if (!_v0.$) {
            var r = _v0.a;
            return r;
        }
        else {
            switch (expr.$) {
                case 0:
                    var i = expr.a;
                    return $author$project$Expression$Integer(i);
                case 4:
                    var uop = expr.a;
                    var c = expr.b;
                    return $author$project$Expression$UnaryOperation_fn(uop, $author$project$Expression$visit_fn(f, c));
                case 5:
                    var bop = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return $author$project$Expression$BinaryOperation_fn(bop, $author$project$Expression$visit_fn(f, l), $author$project$Expression$visit_fn(f, r));
                case 6:
                    var rop = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return $author$project$Expression$RelationOperation_fn(rop, $author$project$Expression$visit_fn(f, l), $author$project$Expression$visit_fn(f, r));
                case 7:
                    var aop = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var o = expr.d;
                    return $author$project$Expression$AssociativeOperation_fn(aop, $author$project$Expression$visit_fn(f, l), $author$project$Expression$visit_fn(f, r), $elm$core$List$map_fn($author$project$Expression$visit(f), o));
                case 8:
                    var func = expr.a;
                    var args = expr.b;
                    return $author$project$Expression$Apply_fn(func, $elm$core$List$map_fn($author$project$Expression$visit(f), args));
                case 2:
                    var v = expr.a;
                    return $author$project$Expression$Variable(v);
                case 3:
                    var x = expr.a;
                    var c = expr.b;
                    return $author$project$Expression$Lambda_fn(x, $author$project$Expression$visit_fn(f, c));
                case 1:
                    var fl = expr.a;
                    return $author$project$Expression$Float(fl);
                case 9:
                    var vars = expr.a;
                    var c = expr.b;
                    return $author$project$Expression$Replace_fn($elm$core$Dict$map_fn(function (_v2) {
                        return $elm$core$Maybe$map($author$project$Expression$visit(f));
                    }, vars), $author$project$Expression$visit_fn(f, c));
                default:
                    var es = expr.a;
                    return $author$project$Expression$List($elm$core$List$map_fn($author$project$Expression$visit(f), es));
            }
        }
    }, $author$project$Expression$visit = F2($author$project$Expression$visit_fn);
    function $author$project$Expression$Utils$cyclic$squash() {
        return $author$project$Expression$visit(function (expr) {
            if (expr.$ === 7) {
                if (!expr.a) {
                    var _v1 = expr.a;
                    var ol = expr.b;
                    var or = expr.c;
                    var oo = expr.d;
                    var extract = function (el) {
                        var _v2 = $author$project$Expression$Utils$cyclic$squash()(el);
                        if ((_v2.$ === 7) && (!_v2.a)) {
                            var _v3 = _v2.a;
                            var il = _v2.b;
                            var ir = _v2.c;
                            var io = _v2.d;
                            return $elm$core$List$concatMap_fn(extract, _List_Cons(il, _List_Cons(ir, io)));
                        }
                        else {
                            var ex = _v2;
                            return _List_fromArray([ex]);
                        }
                    };
                    return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$concatMap_fn(extract, _List_Cons(ol, _List_Cons(or, oo)))));
                }
                else {
                    var _v4 = expr.a;
                    var ol = expr.b;
                    var or = expr.c;
                    var oo = expr.d;
                    var extract = function (el) {
                        var _v5 = $author$project$Expression$Utils$cyclic$squash()(el);
                        if ((_v5.$ === 7) && (_v5.a === 1)) {
                            var _v6 = _v5.a;
                            var il = _v5.b;
                            var ir = _v5.c;
                            var io = _v5.d;
                            return $elm$core$List$concatMap_fn(extract, _List_Cons(il, _List_Cons(ir, io)));
                        }
                        else {
                            var ex = _v5;
                            return _List_fromArray([ex]);
                        }
                    };
                    return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, $elm$core$List$concatMap_fn(extract, _List_Cons(ol, _List_Cons(or, oo)))));
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        });
    }
    var $author$project$Expression$Utils$squash = $author$project$Expression$Utils$cyclic$squash();
    $author$project$Expression$Utils$cyclic$squash = function () {
        return $author$project$Expression$Utils$squash;
    };
    var $author$project$Expression$Parser$parse = function (input) {
        return $elm$core$Result$map_fn($author$project$Expression$Utils$squash, $elm$parser$Parser$Advanced$run_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$ignorer_fn($author$project$Expression$Parser$mainParser($author$project$Expression$defaultContext), $elm$parser$Parser$Advanced$end($author$project$Expression$Parser$Unexpected))), $author$project$Expression$Cleaner$cleanInput($elm$core$String$trim(input))));
    };
    var $author$project$UI$parseOrError = function (input) {
        return $elm$core$String$isEmpty(input) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(function () {
            var _v0 = $author$project$Expression$Parser$parse(input);
            if (!_v0.$) {
                var e = _v0.a;
                return $author$project$Document$Parsed(e);
            }
            else {
                var e = _v0.a;
                return $author$project$Document$ParseError($author$project$Expression$Parser$errorsToString_fn(input, e));
            }
        }());
    };
    var $author$project$UI$Ports$resetZoom = _Platform_outgoingPort("resetZoom", $elm$json$Json$Encode$string);
    var $author$project$UI$Ports$resetZoomCanvas = function (_v0) {
        var id = _v0;
        return $author$project$UI$Ports$resetZoom(id);
    };
    var $author$project$UI$Ports$save = _Platform_outgoingPort("save", $elm$json$Json$Encode$string);
    var $author$project$UI$Ports$saveCanvas = function (_v0) {
        var id = _v0;
        return $author$project$UI$Ports$save(id);
    };
    var $elm$file$File$Download$string_fn = function (name, mime, content) {
        return $elm$core$Task$perform_fn($elm$core$Basics$never, _File_download_fn(name, mime, content));
    }, $elm$file$File$Download$string = F3($elm$file$File$Download$string_fn);
    var $elm$file$File$toString = _File_toString;
    var $elm$core$List$takeReverse_fn = function (n, list, kept) {
        takeReverse: while (true) {
            if (n <= 0) {
                return kept;
            }
            else {
                if (!list.b) {
                    return kept;
                }
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs, $temp$kept = _List_Cons(x, kept);
                    n = $temp$n;
                    list = $temp$list;
                    kept = $temp$kept;
                    continue takeReverse;
                }
            }
        }
    }, $elm$core$List$takeReverse = F3($elm$core$List$takeReverse_fn);
    var $elm$core$List$takeTailRec_fn = function (n, list) {
        return $elm$core$List$reverse($elm$core$List$takeReverse_fn(n, list, _List_Nil));
    }, $elm$core$List$takeTailRec = F2($elm$core$List$takeTailRec_fn);
    var $elm$core$List$takeFast_fn = function (ctr, n, list) {
        if (n <= 0) {
            return _List_Nil;
        }
        else {
            var _v0 = _Utils_Tuple2(n, list);
            _v0$1: while (true) {
                _v0$5: while (true) {
                    if (!_v0.b.b) {
                        return list;
                    }
                    else {
                        if (_v0.b.b.b) {
                            switch (_v0.a) {
                                case 1:
                                    break _v0$1;
                                case 2:
                                    var _v2 = _v0.b;
                                    var x = _v2.a;
                                    var _v3 = _v2.b;
                                    var y = _v3.a;
                                    return _List_fromArray([x, y]);
                                case 3:
                                    if (_v0.b.b.b.b) {
                                        var _v4 = _v0.b;
                                        var x = _v4.a;
                                        var _v5 = _v4.b;
                                        var y = _v5.a;
                                        var _v6 = _v5.b;
                                        var z = _v6.a;
                                        return _List_fromArray([x, y, z]);
                                    }
                                    else {
                                        break _v0$5;
                                    }
                                default:
                                    if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                                        var _v7 = _v0.b;
                                        var x = _v7.a;
                                        var _v8 = _v7.b;
                                        var y = _v8.a;
                                        var _v9 = _v8.b;
                                        var z = _v9.a;
                                        var _v10 = _v9.b;
                                        var w = _v10.a;
                                        var tl = _v10.b;
                                        return (ctr > 1000) ? _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeTailRec_fn(n - 4, tl))))) : _List_Cons(x, _List_Cons(y, _List_Cons(z, _List_Cons(w, $elm$core$List$takeFast_fn(ctr + 1, n - 4, tl)))));
                                    }
                                    else {
                                        break _v0$5;
                                    }
                            }
                        }
                        else {
                            if (_v0.a === 1) {
                                break _v0$1;
                            }
                            else {
                                break _v0$5;
                            }
                        }
                    }
                }
                return list;
            }
            var _v1 = _v0.b;
            var x = _v1.a;
            return _List_fromArray([x]);
        }
    }, $elm$core$List$takeFast = F3($elm$core$List$takeFast_fn);
    var $elm$core$List$take_fn = function (n, list) {
        return $elm$core$List$takeFast_fn(0, n, list);
    }, $elm$core$List$take = F2($elm$core$List$take_fn);
    var $elm_community$list_extra$List$Extra$updateAt_fn = function (index, fn, list) {
        if (index < 0) {
            return list;
        }
        else {
            var tail = $elm$core$List$drop_fn(index, list);
            var head = $elm$core$List$take_fn(index, list);
            if (tail.b) {
                var x = tail.a;
                var xs = tail.b;
                return _Utils_ap(head, _List_Cons(fn(x), xs));
            }
            else {
                return list;
            }
        }
    }, $elm_community$list_extra$List$Extra$updateAt = F3($elm_community$list_extra$List$Extra$updateAt_fn);
    var $author$project$UI$updateByDocId_fn = function (docId, f, model) {
        var _v0 = model.l;
        if (_v0.$ === 1) {
            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
        else {
            var docs = _v0.a;
            var documents = $author$project$Zipper$map_fn(F2(function (_v1, doc) {
                var id = doc.fh;
                return _Utils_eq(id, docId) ? f(doc) : doc;
            }), docs);
            return $author$project$UI$persist(_Utils_update(model, {
                l: $elm$core$Maybe$Just(documents)
            }));
        }
    }, $author$project$UI$updateByDocId = F3($author$project$UI$updateByDocId_fn);
    var $author$project$UI$update = function (msg) {
        var filterEmpty = A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$filterNot(A2($elm$core$Basics$composeR, function ($) {
            return $.r;
        }, $elm$core$String$isEmpty)), function (rs) {
            return _Utils_ap(rs, _List_fromArray([$author$project$Document$emptyRow]));
        });
        var calculateRow = function (r) {
            var _v21 = r.G;
            if (!_v21.$) {
                return _Utils_update(r, {
                    G: $author$project$Document$CodeRow($elm$core$List$filterMap_fn($author$project$UI$parseOrError, $elm$core$String$split_fn("\n", $elm$core$String$replace_fn("\\\n", "", r.r)))),
                    al: false
                });
            }
            else {
                return _Utils_update(r, { al: false });
            }
        };
        var inner = function (model) {
            switch (msg.$) {
                case 0:
                    return $author$project$UI$addDocument_fn(model, {
                        n: $elm$core$Maybe$Nothing,
                        dw: $elm$core$Maybe$Nothing,
                        M: _List_fromArray([$author$project$Document$emptyRow])
                    });
                case 5:
                    var size = msg.a;
                    var context_ = model.eU;
                    return _Utils_Tuple2(_Utils_update(model, {
                        eU: _Utils_update(context_, {
                            c$: $miniBill$elm_ui_with_context$Element$WithContext$classifyDevice(size).eO
                        }),
                        cq: size
                    }), $elm$core$Platform$Cmd$none);
                case 6:
                    var openMenu = msg.a;
                    return _Utils_Tuple2(_Utils_update(model, { bp: openMenu }), $elm$core$Platform$Cmd$none);
                case 7:
                    var showPendingActions = msg.a;
                    return _Utils_Tuple2(_Utils_update(model, { bx: showPendingActions }), $elm$core$Platform$Cmd$none);
                case 1:
                    return _Utils_Tuple2(model, $elm$file$File$Select$file_fn(_List_fromArray(["text/plain", ".txt"]), $author$project$UI$Model$DocumentOpenSelected));
                case 2:
                    var file = msg.a;
                    return _Utils_Tuple2(model, $elm$core$Task$perform_fn(function (content) {
                        return $author$project$UI$Model$DocumentOpenContent({
                            cX: content,
                            dw: $elm$file$File$name(file)
                        });
                    }, $elm$file$File$toString(file)));
                case 3:
                    var name = msg.a.dw;
                    var content = msg.a.cX;
                    var _v12 = $author$project$Document$fromFile_fn($elm$core$Maybe$Just(_String_endsWith_fn(".txt", name) ? $elm$core$String$dropRight_fn(4, name) : name), content);
                    var errors = _v12.ac;
                    var document = _v12.c0;
                    return $author$project$UI$addDocument_fn(model, document);
                case 10:
                    var language = msg.a;
                    var context = model.eU;
                    return _Utils_Tuple2(_Utils_update(model, {
                        eU: _Utils_update(context, { dp: language })
                    }), $elm$core$Platform$Cmd$none);
                case 8:
                    var expandIntervals = msg.a;
                    var context = model.eU;
                    return _Utils_Tuple2(_Utils_update(model, {
                        eU: _Utils_update(context, { bU: expandIntervals })
                    }), $elm$core$Platform$Cmd$none);
                case 9:
                    var rayDifferentials = msg.a;
                    var context = model.eU;
                    return _Utils_Tuple2(_Utils_update(model, {
                        eU: _Utils_update(context, { ck: rayDifferentials })
                    }), $elm$core$Platform$Cmd$none);
                case 11:
                    return _Utils_Tuple2(model, $author$project$UI$Ports$openWindow($author$project$API$Google$authenticationFlowUrl(model.cn)));
                case 4:
                    switch (msg.b.$) {
                        case 7:
                            var docId = msg.a;
                            var data = msg.b.a;
                            var updateRow = function (rowF) {
                                return $author$project$UI$updateByDocId_fn(docId, function (curr) {
                                    return _Utils_update(curr, {
                                        M: filterEmpty($elm_community$list_extra$List$Extra$updateAt_fn(data.b7, rowF, curr.M))
                                    });
                                }, model);
                            };
                            var _v1 = data.fz;
                            switch (_v1.$) {
                                case 11:
                                    var canvasId = _v1.a;
                                    return _Utils_Tuple2(model, $author$project$UI$Ports$copyCanvas(canvasId));
                                case 8:
                                    var canvasId = _v1.a;
                                    return _Utils_Tuple2(model, $author$project$UI$Ports$saveCanvas(canvasId));
                                case 9:
                                    var canvasId = _v1.a;
                                    return _Utils_Tuple2(model, $author$project$UI$Ports$fullscreenCanvas(canvasId));
                                case 6:
                                    var input = _v1.a;
                                    return updateRow(function (r) {
                                        return _Utils_update(r, { r: input });
                                    });
                                case 5:
                                    return updateRow(calculateRow);
                                case 4:
                                    return updateRow(function (r) {
                                        return _Utils_update(r, { al: true });
                                    });
                                case 0:
                                    return updateRow(function (r) {
                                        return _Utils_update(r, { al: false });
                                    });
                                case 1:
                                    return updateRow(function (r) {
                                        return _Utils_update(r, {
                                            G: $author$project$Document$CodeRow(_List_Nil)
                                        });
                                    });
                                case 2:
                                    return updateRow(function (r) {
                                        return _Utils_update(r, { G: $author$project$Document$MarkdownRow });
                                    });
                                case 3:
                                    return updateRow(function (r) {
                                        return _Utils_update(r, {
                                            G: $author$project$Document$CodeRow(_List_Nil)
                                        });
                                    });
                                case 10:
                                    var canvasId = _v1.a;
                                    return _Utils_Tuple2(model, $author$project$UI$Ports$exitFullscreenCanvas(canvasId));
                                default:
                                    var canvasId = _v1.a;
                                    return _Utils_Tuple2(model, $author$project$UI$Ports$resetZoomCanvas(canvasId));
                            }
                        case 0:
                            var docId = msg.a;
                            var _v2 = msg.b;
                            var documents = $elm$core$Maybe$map_fn($author$project$Zipper$focusFind(function (_v3) {
                                var id = _v3.fh;
                                return _Utils_eq(id, docId);
                            }), model.l);
                            return $author$project$UI$persist(_Utils_update(model, { l: documents }));
                        case 2:
                            var docId = msg.a;
                            var ask = msg.b.a.bJ;
                            if (ask) {
                                return $author$project$UI$updateByDocId_fn(docId, function (document) {
                                    return _Utils_update(document, {
                                        du: _List_Cons($author$project$Document$ModalClose, document.du)
                                    });
                                }, model);
                            }
                            else {
                                var documents = $elm$core$Maybe$andThen_fn($author$project$Zipper$filter(function (_v4) {
                                    var id = _v4.fh;
                                    return !_Utils_eq(id, docId);
                                }), model.l);
                                return $author$project$UI$persist(_Utils_update(model, { l: documents }));
                            }
                        case 11:
                            var docId = msg.a;
                            var _v5 = msg.b;
                            return $author$project$UI$updateByDocId_fn(docId, function (doc) {
                                return _Utils_update(doc, {
                                    M: $elm$core$List$map_fn(calculateRow, doc.M)
                                });
                            }, model);
                        case 12:
                            var docId = msg.a;
                            var _v6 = msg.b;
                            return $author$project$UI$updateByDocId_fn(docId, function (doc) {
                                return _Utils_update(doc, {
                                    M: $elm$core$List$map_fn(function (row) {
                                        var _v7 = row.G;
                                        if (!_v7.$) {
                                            return _Utils_update(row, {
                                                G: $author$project$Document$CodeRow(_List_Nil)
                                            });
                                        }
                                        else {
                                            return row;
                                        }
                                    }, doc.M)
                                });
                            }, model);
                        case 1:
                            var docId = msg.a;
                            var name = msg.b.a;
                            return $author$project$UI$updateByDocId_fn(docId, function (doc) {
                                return _Utils_update(doc, {
                                    du: $elm$core$List$drop_fn(1, doc.du),
                                    dw: $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(name)
                                });
                            }, model);
                        case 8:
                            var docId = msg.a;
                            var modal = msg.b.a;
                            return $author$project$UI$updateByDocId_fn(docId, function (document) {
                                return _Utils_update(document, {
                                    du: _List_Cons(modal, document.du)
                                });
                            }, model);
                        case 10:
                            var docId = msg.a;
                            var _v8 = msg.b;
                            return $author$project$UI$updateByDocId_fn(docId, function (document) {
                                return _Utils_update(document, {
                                    du: $elm$core$List$drop_fn(1, document.du)
                                });
                            }, model);
                        case 9:
                            var docId = msg.a;
                            var modal = msg.b.a;
                            return $author$project$UI$updateByDocId_fn(docId, function (document) {
                                return _Utils_update(document, {
                                    du: _List_Cons(modal, $elm$core$List$drop_fn(1, document.du))
                                });
                            }, model);
                        case 3:
                            var docId = msg.a;
                            var _v9 = msg.b;
                            var _v10 = $elm_community$list_extra$List$Extra$find_fn(function (_v11) {
                                var id = _v11.fh;
                                return _Utils_eq(id, docId);
                            }, $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($author$project$Zipper$toList, model.l)));
                            if (_v10.$ === 1) {
                                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                            }
                            else {
                                var document = _v10.a;
                                return _Utils_Tuple2(model, $elm$file$File$Download$string_fn($elm$core$Maybe$withDefault_fn("Untitled", document.dw) + ".txt", "text/plain", $author$project$Document$toFile(document)));
                            }
                        case 4:
                            var docId = msg.a;
                            var _v13 = msg.b;
                            var _v14 = $elm$core$Maybe$andThen_fn($author$project$Zipper$find(function (_v15) {
                                var id = _v15.fh;
                                return _Utils_eq(id, docId);
                            }), model.l);
                            if (!_v14.$) {
                                var document = _v14.a;
                                return $author$project$UI$googleSave_fn(model, document);
                            }
                            else {
                                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                            }
                        case 6:
                            var docId = msg.a;
                            var res = msg.b.a;
                            return $author$project$UI$documentGoogleId_fn(docId, res, model);
                        default:
                            var docId = msg.a;
                            var res = msg.b.a;
                            var google = model.m;
                            var google_ = _Utils_update(google, {
                                T: $elm$core$List$map_fn(function (data) {
                                    var id = data.fh;
                                    return _Utils_eq(id, docId) ? _Utils_update(data, {
                                        Y: function () {
                                            if (!res.$) {
                                                return $author$project$API$Google$Succeded(0);
                                            }
                                            else {
                                                var e = res.a;
                                                return $author$project$API$Google$Errored(e);
                                            }
                                        }()
                                    }) : data;
                                }, google.T)
                            });
                            return _Utils_eq(res, $elm$core$Result$Err($author$project$API$Google$Unauthorized)) ? _Utils_Tuple2(_Utils_update(model, {
                                m: _Utils_update(google_, { aN: $author$project$API$Google$Expired })
                            }), $author$project$UI$Ports$saveGoogleAccessToken("")) : _Utils_Tuple2(_Utils_update(model, { m: google_ }), $elm$core$Platform$Cmd$none);
                    }
                case 13:
                    var isFullscreen = msg.a;
                    var context = model.eU;
                    return _Utils_Tuple2(_Utils_update(model, {
                        eU: _Utils_update(context, { dl: isFullscreen })
                    }), $elm$core$Platform$Cmd$none);
                case 12:
                    var token = msg.a;
                    var google = model.m;
                    var idRequests = $elm$core$List$map_fn(function (_v20) {
                        var id = _v20.fh;
                        return $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentMsg(id), $author$project$UI$Model$DocumentGoogleId), $author$project$API$Google$generateId({ aN: token }));
                    }, $elm$core$List$filter_fn(function (_v19) {
                        var request = _v19.Y;
                        return _Utils_eq(request, $author$project$API$Google$WaitingAccessToken);
                    }, google.O));
                    var saveRequests = $elm$core$List$map_fn(function (_v18) {
                        var id = _v18.fh;
                        var googleId = _v18.n;
                        var name = _v18.dw;
                        var content = _v18.cX;
                        return $elm$core$Task$attempt_fn(A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentMsg(id), $author$project$UI$Model$DocumentGoogleSaveResult), $author$project$API$Google$uploadFile({ aN: token, cX: content, fh: googleId, dw: name }));
                    }, $elm$core$List$filter_fn(function (_v17) {
                        var request = _v17.Y;
                        return _Utils_eq(request, $author$project$API$Google$WaitingAccessToken);
                    }, google.T));
                    var _do = function (data) {
                        var request = data.Y;
                        return _Utils_eq(request, $author$project$API$Google$WaitingAccessToken) ? _Utils_update(data, { Y: $author$project$API$Google$Running }) : data;
                    };
                    var google_ = _Utils_update(google, {
                        aN: $author$project$API$Google$Present(token),
                        O: $elm$core$List$map_fn(_do, google.O),
                        T: $elm$core$List$map_fn(_do, google.T)
                    });
                    var model_ = _Utils_update(model, { m: google_ });
                    return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$batch(_Utils_ap(idRequests, saveRequests)));
                default:
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            }
        };
        return function (model) {
            return inner(_Utils_update(model, { bp: false, bx: false }));
        };
    };
    var $elm$json$Json$Decode$value = _Json_decodeValue;
    var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
    var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
    var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
        return { $: 8, a: a };
    };
    var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
    var $mdgriffith$elm_ui$Internal$Model$Content = { $: 1 };
    var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
    var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
        return { $: 7, a: a };
    };
    var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
    var $mdgriffith$elm_ui$Element$column_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eT + (" " + $mdgriffith$elm_ui$Internal$Style$classes.aS)), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$column = F2($mdgriffith$elm_ui$Element$column_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$Element = $elm$core$Basics$identity;
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn = function (context, _v0) {
        var f = _v0;
        return f(context);
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$run = F2($miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn = function (container, attrs, children) {
        return function (context) {
            return A2(container, $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), $elm$core$List$map_fn($miniBill$elm_ui_with_context$Element$WithContext$Internal$run(context), children));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn_unwrapped = function (container, attrs, children) {
        return function (context) {
            return container($miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), $elm$core$List$map_fn($miniBill$elm_ui_with_context$Element$WithContext$Internal$run(context), children));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer = F3($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$column_a0 = $mdgriffith$elm_ui$Element$column, $miniBill$elm_ui_with_context$Element$WithContext$column = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($miniBill$elm_ui_with_context$Element$WithContext$column_a0);
    var $author$project$UI$Model$DocumentClose = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$UI$Model$DocumentNew = { $: 0 };
    var $author$project$UI$Model$DocumentPushModal = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$UI$Model$DocumentSelect = { $: 0 };
    var $author$project$Document$ModalRename = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
        return { $: 5, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
    var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute = function (a) {
        return function (_v0) {
            return a;
        };
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$alignBottom = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$alignBottom);
    var $mdgriffith$elm_ui$Internal$Model$Button = { $: 8 };
    var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
        return { $: 2, a: a };
    };
    var $elm$json$Json$Encode$bool = _Json_wrap;
    var $elm$html$Html$Attributes$boolProperty_fn = function (key, bool) {
        return _VirtualDom_property_fn(key, $elm$json$Json$Encode$bool(bool));
    }, $elm$html$Html$Attributes$boolProperty = F2($elm$html$Html$Attributes$boolProperty_fn);
    var $elm$html$Html$Attributes$disabled_a0 = "disabled", $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$disabled_a0);
    var $mdgriffith$elm_ui$Element$Input$enter = "Enter";
    var $mdgriffith$elm_ui$Internal$Model$NoAttribute = { $: 0 };
    var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
        if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
            var _v1 = attr.b;
            var _v2 = _v1.a;
            return true;
        }
        else {
            return false;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
        return $elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass("focusable");
    };
    var $elm$virtual_dom$VirtualDom$Normal = function (a) {
        return { $: 0, a: a };
    };
    var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
    var $elm$html$Html$Events$on_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$Normal(decoder));
    }, $elm$html$Html$Events$on = F2($elm$html$Html$Events$on_fn);
    var $elm$html$Html$Events$onClick = function (msg) {
        return $elm$html$Html$Events$on_fn("click", $elm$json$Json$Decode$succeed(msg));
    };
    var $mdgriffith$elm_ui$Element$Events$onClick_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Events$onClick_a1 = $elm$html$Html$Events$onClick, $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1);
    var $elm$json$Json$Decode$fail = _Json_fail;
    var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
        return { $: 2, a: a };
    };
    var $elm$html$Html$Events$preventDefaultOn_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
    }, $elm$html$Html$Events$preventDefaultOn = F2($elm$html$Html$Events$preventDefaultOn_fn);
    var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
        var decode = function (code) {
            var _v0 = lookup(code);
            if (_v0.$ === 1) {
                return $elm$json$Json$Decode$fail("No key matched");
            }
            else {
                var msg = _v0.a;
                return $elm$json$Json$Decode$succeed(msg);
            }
        };
        var isKey = _Json_andThen_fn(decode, _Json_decodeField_fn("key", $elm$json$Json$Decode$string));
        return $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$preventDefaultOn_fn("keydown", _Json_map1_fn(function (fired) {
            return _Utils_Tuple2(fired, true);
        }, isKey)));
    };
    var $mdgriffith$elm_ui$Internal$Model$Class_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Class = F2($mdgriffith$elm_ui$Internal$Model$Class_fn);
    var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
    var $mdgriffith$elm_ui$Element$pointer = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.eV);
    var $mdgriffith$elm_ui$Element$Input$space = " ";
    var $elm$html$Html$Attributes$tabindex = function (n) {
        return _VirtualDom_attribute_fn("tabIndex", $elm$core$String$fromInt(n));
    };
    var $mdgriffith$elm_ui$Element$Input$button_fn = function (attrs, _v0) {
        var onPress = _v0.W;
        var label = _v0.R;
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bf + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.ak + (" " + ($mdgriffith$elm_ui$Internal$Style$classes.f4 + (" " + $mdgriffith$elm_ui$Internal$Style$classes.dx)))))), _List_Cons($mdgriffith$elm_ui$Element$pointer, _List_Cons($mdgriffith$elm_ui$Element$Input$focusDefault(attrs), _List_Cons($mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button), _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$tabindex(0)), function () {
            if (onPress.$ === 1) {
                return _List_Cons($mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true)), attrs);
            }
            else {
                var msg = onPress.a;
                return _List_Cons($elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Events$onClick_a0, $mdgriffith$elm_ui$Element$Events$onClick_a1, msg), _List_Cons($mdgriffith$elm_ui$Element$Input$onKeyLookup(function (code) {
                    return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
                }), attrs));
            }
        }()))))))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([label])));
    }, $mdgriffith$elm_ui$Element$Input$button = F2($mdgriffith$elm_ui$Element$Input$button_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn = function (ctor, f, attrs, child) {
        return function (context) {
            return A2(ctor, $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), A2(f, context, child));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs = F4($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0 = $mdgriffith$elm_ui$Element$Input$button, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1 = F2(function (context, _v0) {
        var onPress = _v0.W;
        var label = _v0.R;
        return {
            R: $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, label),
            W: onPress
        };
    }), $miniBill$elm_ui_with_context$Element$WithContext$Input$button = A2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1);
    var $elm$svg$Svg$Attributes$d_a0 = "d", $elm$svg$Svg$Attributes$d = _VirtualDom_attribute($elm$svg$Svg$Attributes$d_a0);
    var $elm$svg$Svg$trustedNode_a0 = "http://www.w3.org/2000/svg", $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS($elm$svg$Svg$trustedNode_a0);
    var $elm$svg$Svg$path = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "path"), $elm$svg$Svg$path_fn = $elm$svg$Svg$path.f;
    var $elm$svg$Svg$svg = _VirtualDom_nodeNS_fn($elm$svg$Svg$trustedNode_a0, "svg"), $elm$svg$Svg$svg_fn = $elm$svg$Svg$svg.f;
    var $elm$svg$Svg$Attributes$viewBox_a0 = "viewBox", $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute($elm$svg$Svg$Attributes$viewBox_a0);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$CloseOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$closeOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$CloseOutlined$viewWithAttributes;
    var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("fc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor), "color", fontColor));
    };
    var $mdgriffith$elm_ui$Element$el_fn = function (attrs, child) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([child])));
    }, $mdgriffith$elm_ui$Element$el = F2($mdgriffith$elm_ui$Element$el_fn);
    var $elm$svg$Svg$Attributes$fill_a0 = "fill", $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute($elm$svg$Svg$Attributes$fill_a0);
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$defaultProps = { bh: $elm$core$Maybe$Nothing, bj: $elm$core$Maybe$Nothing, bt: $elm$core$Maybe$Nothing, by: false, cu: _List_Nil, cF: $elm$core$Maybe$Nothing, bE: $elm$core$Maybe$Nothing };
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$fromAttributes = function () {
        var f = F2(function (act, acc) {
            switch (act.$) {
                case 0:
                    return _Utils_update(acc, { by: true });
                case 1:
                    var x = act.a;
                    return _Utils_update(acc, {
                        bt: $elm$core$Maybe$Just(x)
                    });
                case 2:
                    var x = act.a;
                    return _Utils_update(acc, {
                        bE: $elm$core$Maybe$Just(x)
                    });
                case 3:
                    var x = act.a;
                    return _Utils_update(acc, {
                        bj: $elm$core$Maybe$Just(x)
                    });
                case 4:
                    var x = act.a;
                    return _Utils_update(acc, {
                        bh: $elm$core$Maybe$Just(x)
                    });
                case 5:
                    var x = act.a;
                    return _Utils_update(acc, { cu: x });
                default:
                    var x = act.a;
                    return _Utils_update(acc, {
                        cF: $elm$core$Maybe$Just(x)
                    });
            }
        });
        return A2($elm$core$List$foldl, f, $lemol$ant_design_icons_elm_ui$Ant$Icon$defaultProps);
    }();
    var $elm$svg$Svg$Attributes$height_a0 = "height", $elm$svg$Svg$Attributes$height = _VirtualDom_attribute($elm$svg$Svg$Attributes$height_a0);
    var $mdgriffith$elm_ui$Internal$Model$unstyled_a0 = $mdgriffith$elm_ui$Internal$Model$Unstyled, $mdgriffith$elm_ui$Internal$Model$unstyled_a1 = $elm$core$Basics$always, $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$unstyled_a0, $mdgriffith$elm_ui$Internal$Model$unstyled_a1);
    var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
    var $mdgriffith$elm_ui$Internal$Model$Rotate_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Rotate = F2($mdgriffith$elm_ui$Internal$Model$Rotate_fn);
    var $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn = function (a, b) {
        return { $: 10, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2($mdgriffith$elm_ui$Internal$Model$TransformComponent_fn);
    var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
    var $mdgriffith$elm_ui$Element$rotate = function (angle) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$rotate, $mdgriffith$elm_ui$Internal$Model$Rotate_fn(_Utils_Tuple3(0, 0, 1), angle));
    };
    var $elm$core$List$singleton = function (value) {
        return _List_fromArray([value]);
    };
    var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
    var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
    var $elm$svg$Svg$Attributes$width_a0 = "width", $elm$svg$Svg$Attributes$width = _VirtualDom_attribute($elm$svg$Svg$Attributes$width_a0);
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn = function (theme, attrs, svgIcon) {
        var props = $lemol$ant_design_icons_elm_ui$Ant$Icon$fromAttributes(attrs);
        var rotate_ = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$rotate, props.bt)));
        var spin_ = props.by ? _List_fromArray([
            _VirtualDom_style_fn("animation", "loadingCircle 1s infinite linear")
        ]) : _List_Nil;
        var svgAttributes = _Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$width_a0, "1em"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$height_a0, "1em"),
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "currentColor")
        ]), spin_);
        var width_ = $elm$core$Maybe$withDefault_fn(1 * 14, props.bE);
        var height_ = $elm$core$Maybe$withDefault_fn(1 * 14, props.bE);
        var fill_ = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Font$color, props.bh)));
        var elAttributes = _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$size($elm$core$Basics$max_fn(width_, height_))
        ]), _Utils_ap(rotate_, fill_));
        return $mdgriffith$elm_ui$Element$el_fn(elAttributes, $mdgriffith$elm_ui$Element$html(svgIcon(svgAttributes)));
    }, $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase = F3($lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn);
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0 = {}, $lemol$ant_design_icons_elm_ui$Ant$Icon$icon = $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0);
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$closeOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$closeOutlined);
    };
    var $avh4$elm_color$Color$RgbaSpace_fn = function (a, b, c, d) {
        return { $: 0, a: a, b: b, c: c, d: d };
    }, $avh4$elm_color$Color$RgbaSpace = F4($avh4$elm_color$Color$RgbaSpace_fn);
    var $avh4$elm_color$Color$hsla_fn = function (hue, sat, light, alpha) {
        var _v0 = _Utils_Tuple3(hue, sat, light);
        var h = _v0.a;
        var s = _v0.b;
        var l = _v0.c;
        var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
        var m1 = (l * 2) - m2;
        var hueToRgb = function (h__) {
            var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
            return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
        };
        var b = hueToRgb(h - (1 / 3));
        var g = hueToRgb(h);
        var r = hueToRgb(h + (1 / 3));
        return $avh4$elm_color$Color$RgbaSpace_fn(r, g, b, alpha);
    }, $avh4$elm_color$Color$hsla = F4($avh4$elm_color$Color$hsla_fn);
    var $avh4$elm_color$Color$fromHsla = function (_v0) {
        var hue = _v0.fg;
        var saturation = _v0.f0;
        var lightness = _v0.b9;
        var alpha = _v0.ev;
        return $avh4$elm_color$Color$hsla_fn(hue, saturation, lightness, alpha);
    };
    var $mdgriffith$elm_ui$Element$fromRgb = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$Rgba_fn(clr.cl, clr.bW, clr.bL, clr.ev);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$fromRgb = $mdgriffith$elm_ui$Element$fromRgb;
    var $avh4$elm_color$Color$fromRgba = function (components) {
        return $avh4$elm_color$Color$RgbaSpace_fn(components.cl, components.bW, components.bL, components.ev);
    };
    var $elm$core$Basics$isNaN = _Basics_isNaN;
    var $avh4$elm_color$Color$toHsla = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        var minColor = $elm$core$Basics$min_fn(r, $elm$core$Basics$min_fn(g, b));
        var maxColor = $elm$core$Basics$max_fn(r, $elm$core$Basics$max_fn(g, b));
        var l = (minColor + maxColor) / 2;
        var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
        var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
        var h2 = h1 * (1 / 6);
        var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
        return { ev: a, fg: h3, b9: l, f0: s };
    };
    var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        return { ev: a, bL: b, bW: g, cl: r };
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$toRgb = $mdgriffith$elm_ui$Element$toRgb;
    var $avh4$elm_color$Color$toRgba = function (_v0) {
        var r = _v0.a;
        var g = _v0.b;
        var b = _v0.c;
        var a = _v0.d;
        return { ev: a, bL: b, bW: g, cl: r };
    };
    var $author$project$UI$Theme$mapHsl = function (f) {
        return A2($elm$core$Basics$composeR, $miniBill$elm_ui_with_context$Element$WithContext$toRgb, A2($elm$core$Basics$composeR, $avh4$elm_color$Color$fromRgba, A2($elm$core$Basics$composeR, $avh4$elm_color$Color$toHsla, A2($elm$core$Basics$composeR, f, A2($elm$core$Basics$composeR, $avh4$elm_color$Color$fromHsla, A2($elm$core$Basics$composeR, $avh4$elm_color$Color$toRgba, $miniBill$elm_ui_with_context$Element$WithContext$fromRgb))))));
    };
    var $author$project$UI$Theme$darken = $author$project$UI$Theme$mapHsl(function (c) {
        return _Utils_update(c, { b9: 0.8 * c.b9 });
    });
    var $miniBill$elm_ui_with_context$Element$WithContext$el_a0 = $mdgriffith$elm_ui$Element$el, $miniBill$elm_ui_with_context$Element$WithContext$el_a1 = $miniBill$elm_ui_with_context$Element$WithContext$Internal$run, $miniBill$elm_ui_with_context$Element$WithContext$el = A2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1);
    var $miniBill$elm_ui_with_context$Element$WithContext$element = function (elem) {
        return function (_v0) {
            return elem;
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$Focus = 0;
    var $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn = function (a, b) {
        return { $: 11, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2($mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn);
    var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
    var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
        return { $: 6, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Nearby_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Nearby = F2($mdgriffith$elm_ui$Internal$Model$Nearby_fn);
    var $mdgriffith$elm_ui$Internal$Model$Empty = { $: 3 };
    var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
        return { $: 2, a: a };
    };
    var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
    var $mdgriffith$elm_ui$Internal$Model$map_fn = function (fn, el) {
        switch (el.$) {
            case 1:
                var styled = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Styled({
                    b3: F2(function (add, context) {
                        return _VirtualDom_map_fn(fn, A2(styled.b3, add, context));
                    }),
                    d0: styled.d0
                });
            case 0:
                var html = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Unstyled(A2($elm$core$Basics$composeL, $elm$virtual_dom$VirtualDom$map(fn), html));
            case 2:
                var str = el.a;
                return $mdgriffith$elm_ui$Internal$Model$Text(str);
            default:
                return $mdgriffith$elm_ui$Internal$Model$Empty;
        }
    }, $mdgriffith$elm_ui$Internal$Model$map = F2($mdgriffith$elm_ui$Internal$Model$map_fn);
    var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
    var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn = function (fn, attr) {
        switch (attr.$) {
            case 0:
                return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
            case 2:
                var description = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Describe(description);
            case 6:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
            case 5:
                var y = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
            case 7:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Width(x);
            case 8:
                var x = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Height(x);
            case 3:
                var x = attr.a;
                var y = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$Class_fn(x, y);
            case 4:
                var flag = attr.a;
                var style = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn(flag, style);
            case 9:
                var location = attr.a;
                var elem = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$Nearby_fn(location, $mdgriffith$elm_ui$Internal$Model$map_fn(fn, elem));
            case 1:
                var htmlAttr = attr.a;
                return $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_mapAttribute_fn(fn, htmlAttr));
            default:
                var fl = attr.a;
                var trans = attr.b;
                return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn(fl, trans);
        }
    }, $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn);
    var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
        return $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle_fn($elm$core$Basics$never, style);
    };
    var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper_fn = function (attr, _v0) {
        var styles = _v0.a;
        var trans = _v0.b;
        var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
        switch (_v1.$) {
            case 4:
                var style = _v1.b;
                return _Utils_Tuple2(_List_Cons(style, styles), trans);
            case 10:
                var flag = _v1.a;
                var component = _v1.b;
                return _Utils_Tuple2(styles, $mdgriffith$elm_ui$Internal$Model$composeTransformation_fn(trans, component));
            default:
                return _Utils_Tuple2(styles, trans);
        }
    }, $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2($mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper_fn);
    var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
        var _v0 = $elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper, _Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed), attrs);
        var styles = _v0.a;
        var transform = _v0.b;
        return _List_Cons($mdgriffith$elm_ui$Internal$Model$Transform(transform), styles);
    };
    var $mdgriffith$elm_ui$Element$focused = function (decs) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$focus, $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn(0, $mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$focused = function (decs) {
        return function (context) {
            return $mdgriffith$elm_ui$Element$focused($elm$core$List$map_fn(function (_v0) {
                var f = _v0;
                return f(context);
            }, decs));
        };
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$height = function (l) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$height(l));
    };
    var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
    var $miniBill$elm_ui_with_context$Element$WithContext$none = $miniBill$elm_ui_with_context$Element$WithContext$element($mdgriffith$elm_ui$Element$none);
    var $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn = function (a, b, c, d, e) {
        return { $: 7, a: a, b: b, c: c, d: d, e: e };
    }, $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5($mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn);
    var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
    var $mdgriffith$elm_ui$Element$padding = function (x) {
        var f = x;
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(x), f, f, f, f));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$padding = function (x) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$padding(x));
    };
    var $mdgriffith$elm_ui$Internal$Model$paddingName_fn = function (top, right, bottom, left) {
        return "pad-" + ($elm$core$String$fromInt(top) + ("-" + ($elm$core$String$fromInt(right) + ("-" + ($elm$core$String$fromInt(bottom) + ("-" + $elm$core$String$fromInt(left)))))));
    }, $mdgriffith$elm_ui$Internal$Model$paddingName = F4($mdgriffith$elm_ui$Internal$Model$paddingName_fn);
    var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
        var top = _v0.d4;
        var right = _v0.dO;
        var bottom = _v0.cS;
        var left = _v0.dr;
        if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
            var topFloat = top;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(top), topFloat, topFloat, topFloat, topFloat));
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn($mdgriffith$elm_ui$Internal$Model$paddingName_fn(top, right, bottom, left), top, right, bottom, left));
        }
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$paddingEach = function (paddings) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$paddingEach(paddings));
    };
    var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
    var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
        var topLeft = _v0.gz;
        var topRight = _v0.gA;
        var bottomLeft = _v0.eI;
        var bottomRight = _v0.eJ;
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderRound, $mdgriffith$elm_ui$Internal$Model$Single_fn("br-" + ($elm$core$String$fromInt(topLeft) + ("-" + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ("-" + $elm$core$String$fromInt(bottomRight)))))), "border-radius", $elm$core$String$fromInt(topLeft) + ("px " + ($elm$core$String$fromInt(topRight) + ("px " + ($elm$core$String$fromInt(bottomRight) + ("px " + ($elm$core$String$fromInt(bottomLeft) + "px"))))))));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Border$roundEach = function (edges) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$roundEach(edges));
    };
    var $author$project$UI$Theme$roundness = 3;
    var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
    var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
    var $mdgriffith$elm_ui$Element$row_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.aS + (" " + $mdgriffith$elm_ui$Internal$Style$classes.ak)), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$row = F2($mdgriffith$elm_ui$Element$row_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$row_a0 = $mdgriffith$elm_ui$Element$row, $miniBill$elm_ui_with_context$Element$WithContext$row = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($miniBill$elm_ui_with_context$Element$WithContext$row_a0);
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$Fill = function (a) {
        return { $: 4, a: a };
    };
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$fill = $lemol$ant_design_icons_elm_ui$Ant$Icon$Fill;
    var $author$project$UI$Theme$iconSize = { c1: ((20 * 3) / 4) | 0, dZ: 20 };
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$Width = function (a) {
        return { $: 2, a: a };
    };
    var $lemol$ant_design_icons_elm_ui$Ant$Icon$width = $lemol$ant_design_icons_elm_ui$Ant$Icon$Width;
    var $author$project$UI$Theme$smallDarkIconAttrs = _List_fromArray([
        $lemol$ant_design_icons_elm_ui$Ant$Icon$width($author$project$UI$Theme$iconSize.c1),
        $lemol$ant_design_icons_elm_ui$Ant$Icon$fill($author$project$UI$Theme$colors.b4)
    ]);
    var $author$project$UI$Theme$spacing = 10;
    var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
    var $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute = function (child) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$htmlAttribute(child));
    };
    var $author$project$UI$L10N$localize_fn = function (_v0, _v1) {
        var en = _v0.e0;
        var it = _v0.fs;
        var language = _v1.dp;
        if (!language) {
            return en;
        }
        else {
            return it;
        }
    }, $author$project$UI$L10N$localize = F2($author$project$UI$L10N$localize_fn);
    var $elm$html$Html$Attributes$title_a0 = "title", $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$title_a0);
    var $miniBill$elm_ui_with_context$Element$WithContext$Internal$runAttribute_fn = function (context, _v0) {
        var f = _v0;
        return f(context);
    }, $miniBill$elm_ui_with_context$Element$WithContext$Internal$runAttribute = F2($miniBill$elm_ui_with_context$Element$WithContext$Internal$runAttribute_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$withAttribute_fn = function (selector, f) {
        return function (context) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$runAttribute_fn(context, f(selector(context)));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$withAttribute = F2($miniBill$elm_ui_with_context$Element$WithContext$withAttribute_fn);
    var $author$project$UI$L10N$title = function (l10n) {
        return $miniBill$elm_ui_with_context$Element$WithContext$withAttribute_fn($author$project$UI$L10N$localize(l10n), A2($elm$core$Basics$composeL, $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute, $elm$html$Html$Attributes$title));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$width = function (l) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$width(l));
    };
    var $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn = function (a, b, c, d, e) {
        return { $: 6, a: a, b: b, c: c, d: d, e: e };
    }, $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5($mdgriffith$elm_ui$Internal$Model$BorderWidth_fn);
    var $mdgriffith$elm_ui$Element$Border$width = function (v) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + $elm$core$String$fromInt(v), v, v, v, v));
    };
    var $mdgriffith$elm_ui$Element$Border$widthXY_fn = function (x, y) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y))), y, x, y, x));
    }, $mdgriffith$elm_ui$Element$Border$widthXY = F2($mdgriffith$elm_ui$Element$Border$widthXY_fn);
    var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
        var bottom = _v0.cS;
        var top = _v0.d4;
        var left = _v0.dr;
        var right = _v0.dO;
        return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : $mdgriffith$elm_ui$Element$Border$widthXY_fn(left, top)) : $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderWidth, $mdgriffith$elm_ui$Internal$Model$BorderWidth_fn("b-" + ($elm$core$String$fromInt(top) + ("-" + ($elm$core$String$fromInt(right) + ("-" + ($elm$core$String$fromInt(bottom) + ("-" + $elm$core$String$fromInt(left))))))), top, right, bottom, left));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach = function (edges) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$widthEach(edges));
    };
    var $author$project$UI$documentTabButton = function (_v0) {
        var selected = _v0.co;
        var onPress = _v0.W;
        var closeMsg = _v0.bO;
        var label = _v0.R;
        var title = _v0.bB;
        var focusStyleChild = $miniBill$elm_ui_with_context$Element$WithContext$focused(_List_Nil);
        var focusStyle = $miniBill$elm_ui_with_context$Element$WithContext$focused(_List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$darken(selected ? $author$project$UI$Theme$colors.dU : $author$project$UI$Theme$colors.d9))
        ]));
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Border$roundEach({ eI: 0, eJ: 0, gz: $author$project$UI$Theme$roundness, gA: $author$project$UI$Theme$roundness }),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach({ cS: 0, dr: 1, dO: 1, d4: 1 }),
            $miniBill$elm_ui_with_context$Element$WithContext$Background$color(selected ? $author$project$UI$Theme$colors.dU : $author$project$UI$Theme$colors.d9),
            $author$project$UI$L10N$title(title),
            $miniBill$elm_ui_with_context$Element$WithContext$alignBottom,
            focusStyle
        ]), _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
                focusStyleChild
            ]), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                    function () {
                        if (closeMsg.$ === 1) {
                            return $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing);
                        }
                        else {
                            return $miniBill$elm_ui_with_context$Element$WithContext$paddingEach({ cS: $author$project$UI$Theme$spacing, dr: $author$project$UI$Theme$spacing, dO: ($author$project$UI$Theme$spacing / 2) | 0, d4: $author$project$UI$Theme$spacing });
                        }
                    }()
                ]), label),
                W: $elm$core$Maybe$Just(onPress)
            }),
            function () {
                if (closeMsg.$ === 1) {
                    return $miniBill$elm_ui_with_context$Element$WithContext$none;
                }
                else {
                    return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$paddingEach({ cS: $author$project$UI$Theme$spacing, dr: ($author$project$UI$Theme$spacing / 2) | 0, dO: $author$project$UI$Theme$spacing, d4: $author$project$UI$Theme$spacing }),
                        focusStyleChild,
                        $author$project$UI$L10N$title({ e0: "Close", fs: "Chiudi" })
                    ]), {
                        R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$closeOutlined($author$project$UI$Theme$smallDarkIconAttrs)),
                        W: closeMsg
                    });
                }
            }()
        ]));
    };
    var $author$project$UI$ellipsize = function (s) {
        var maxLen = 15;
        return (_Utils_cmp($elm$core$String$length(s), maxLen) < 0) ? s : ($elm$core$String$left_fn(maxLen, s) + "...");
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$FileAddTwoTone$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "#E6E6E6")
            ]), _List_Nil),
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "#333")
            ]), _List_Nil),
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"),
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$fill_a0, "#333")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$fileAddTwoTone = $lemol$ant_design_icons_elm$Ant$Icons$Svg$FileAddTwoTone$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$fileAddTwoTone = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$fileAddTwoTone);
    };
    var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
    var $miniBill$elm_ui_with_context$Element$WithContext$map_fn = function (f, _v0) {
        var g = _v0;
        return A2($elm$core$Basics$composeR, g, $mdgriffith$elm_ui$Element$map(f));
    }, $miniBill$elm_ui_with_context$Element$WithContext$map = F2($miniBill$elm_ui_with_context$Element$WithContext$map_fn);
    var $author$project$UI$rowToTitle = function (_v0) {
        var input = _v0.r;
        return $author$project$UI$ellipsize(input);
    };
    var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
    var $mdgriffith$elm_ui$Element$scrollbarX = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.f2);
    var $miniBill$elm_ui_with_context$Element$WithContext$scrollbarX = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$scrollbarX);
    var $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn = function (a, b, c) {
        return { $: 5, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3($mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn);
    var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
    var $mdgriffith$elm_ui$Internal$Model$spacingName_fn = function (x, y) {
        return "spacing-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y)));
    }, $mdgriffith$elm_ui$Internal$Model$spacingName = F2($mdgriffith$elm_ui$Internal$Model$spacingName_fn);
    var $mdgriffith$elm_ui$Element$spacing = function (x) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Model$SpacingStyle_fn($mdgriffith$elm_ui$Internal$Model$spacingName_fn(x, x), x, x));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$spacing = function (x) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$spacing(x));
    };
    var $mdgriffith$elm_ui$Element$text = function (content) {
        return $mdgriffith$elm_ui$Internal$Model$Text(content);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$text = function (content) {
        return $miniBill$elm_ui_with_context$Element$WithContext$element($mdgriffith$elm_ui$Element$text(content));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$with_fn = function (selector, f) {
        return function (context) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, f(selector(context)));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$with = F2($miniBill$elm_ui_with_context$Element$WithContext$with_fn);
    var $author$project$UI$L10N$text = function (l10n) {
        return $miniBill$elm_ui_with_context$Element$WithContext$with_fn($author$project$UI$L10N$localize(l10n), $miniBill$elm_ui_with_context$Element$WithContext$text);
    };
    var $author$project$UI$Model$DocumentCalculateAll = { $: 11 };
    var $author$project$UI$Model$DocumentClearAll = { $: 12 };
    var $author$project$UI$Model$ToggleMenu = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$UI$Model$ToggleShowPendingActions = function (a) {
        return { $: 7, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$Right = 2;
    var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
    var $miniBill$elm_ui_with_context$Element$WithContext$alignRight = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$alignRight);
    var $mdgriffith$elm_ui$Internal$Model$Below = 1;
    var $mdgriffith$elm_ui$Element$createNearby_fn = function (loc, element) {
        if (element.$ === 3) {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$Nearby_fn(loc, element);
        }
    }, $mdgriffith$elm_ui$Element$createNearby = F2($mdgriffith$elm_ui$Element$createNearby_fn);
    var $mdgriffith$elm_ui$Element$below = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(1, element);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn = function (toAttr, _v0) {
        var f = _v0;
        return A2($elm$core$Basics$composeR, f, toAttr);
    }, $miniBill$elm_ui_with_context$Element$WithContext$createNearby = F2($miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$below_a0 = $mdgriffith$elm_ui$Element$below, $miniBill$elm_ui_with_context$Element$WithContext$below = $miniBill$elm_ui_with_context$Element$WithContext$createNearby($miniBill$elm_ui_with_context$Element$WithContext$below_a0);
    var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
    var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
    var $miniBill$elm_ui_with_context$Element$WithContext$centerY = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$centerY);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$CloudSyncOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z")
            ]), _List_Nil),
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 003 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 00-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$cloudSyncOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$CloudSyncOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$cloudSyncOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$cloudSyncOutlined);
    };
    var $author$project$UI$Theme$darkIconAttrs = _List_fromArray([
        $lemol$ant_design_icons_elm_ui$Ant$Icon$width($author$project$UI$Theme$iconSize.dZ),
        $lemol$ant_design_icons_elm_ui$Ant$Icon$fill($author$project$UI$Theme$colors.b4)
    ]);
    var $author$project$UI$Model$DocumentDownload = { $: 3 };
    var $author$project$UI$Model$DocumentOpen = { $: 1 };
    var $author$project$UI$Model$Language = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$UI$Model$ToggleExpandIntervals = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$UI$Model$ToggleRayDifferentials = function (a) {
        return { $: 9, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
    var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
    var $miniBill$elm_ui_with_context$Element$WithContext$centerX = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$centerX);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$FolderOpenOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$folderOpenOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$FolderOpenOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$folderOpenOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$folderOpenOutlined);
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$FunnelPlotOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$funnelPlotOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$FunnelPlotOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$funnelPlotOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$funnelPlotOutlined);
    };
    var $author$project$UI$Theme$hr = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
        $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
        $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach({ cS: 0, dr: 0, dO: 0, d4: 1 })
    ]), $miniBill$elm_ui_with_context$Element$WithContext$none);
    var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
    var $mdgriffith$elm_ui$Element$inFront = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(4, element);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$inFront_a0 = $mdgriffith$elm_ui$Element$inFront, $miniBill$elm_ui_with_context$Element$WithContext$inFront = $miniBill$elm_ui_with_context$Element$WithContext$createNearby($miniBill$elm_ui_with_context$Element$WithContext$inFront_a0);
    var $elm$core$List$intersperse_fn = function (sep, xs) {
        if (!xs.b) {
            return _List_Nil;
        }
        else {
            var hd = xs.a;
            var tl = xs.b;
            var step = F2(function (x, rest) {
                return _List_Cons(sep, _List_Cons(x, rest));
            });
            var spersed = $elm$core$List$foldr_fn(step, _List_Nil, tl);
            return _List_Cons(hd, spersed);
        }
    }, $elm$core$List$intersperse = F2($elm$core$List$intersperse_fn);
    var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
    var $mdgriffith$elm_ui$Element$moveLeft = function (x) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveX, $mdgriffith$elm_ui$Internal$Model$MoveX(-x));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$moveLeft = function (x) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr($mdgriffith$elm_ui$Element$moveLeft(x));
    };
    var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
    var $mdgriffith$elm_ui$Element$moveUp = function (y) {
        return $mdgriffith$elm_ui$Internal$Model$TransformComponent_fn($mdgriffith$elm_ui$Internal$Flag$moveY, $mdgriffith$elm_ui$Internal$Model$MoveY(-y));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$moveUp = function (y) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr($mdgriffith$elm_ui$Element$moveUp(y));
    };
    var $author$project$UI$Theme$row = function (attrs) {
        return $miniBill$elm_ui_with_context$Element$WithContext$row(_List_Cons($miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing), attrs));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$SaveOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$saveOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$SaveOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$saveOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$saveOutlined);
    };
    var $author$project$Zipper$selected = function (_v0) {
        var curr = _v0.h;
        return curr;
    };
    var $author$project$UI$selectedDocumentId = function (_v0) {
        var documents = _v0.l;
        return $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Zipper$selected, function ($) {
            return $.fh;
        }), documents);
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$StopOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$stopOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$StopOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$stopOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$stopOutlined);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Border$width = function (v) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$width(v));
    };
    var $author$project$UI$dropdown = function (model) {
        var vr = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach({ cS: 0, dr: 0, dO: 1, d4: 0 })
        ]), $miniBill$elm_ui_with_context$Element$WithContext$none);
        var btn = F3(function (msg, icon, lbl) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing),
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
            ]), {
                R: A2($author$project$UI$Theme$row, _List_Nil, _List_fromArray([
                    function () {
                        if (!icon.b) {
                            return $miniBill$elm_ui_with_context$Element$WithContext$none;
                        }
                        else {
                            var mainIcon = icon.a;
                            var layers = icon.b;
                            return $elm$core$List$foldl_fn(function (e) {
                                return $miniBill$elm_ui_with_context$Element$WithContext$el(_List_fromArray([
                                    $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$inFront_a0, e)
                                ]));
                            }, mainIcon, layers);
                        }
                    }(),
                    $author$project$UI$L10N$text(lbl)
                ])),
                W: $elm$core$Maybe$Just(msg)
            });
        });
        var languageButton = F2(function (lang, flag) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
            ]), $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$centerX]), A3(btn, $author$project$UI$Model$Language(lang), _List_Nil, $author$project$UI$L10N$invariant(flag))));
        });
        var languagesRow = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
        ]), _List_fromArray([
            A2(languageButton, 0, "\uD83C\uDDEC\uD83C\uDDE7"),
            vr,
            A2(languageButton, 1, "\uD83C\uDDEE\uD83C\uDDF9")
        ]));
        var simpleBtn = F3(function (msg, icon, lbl) {
            return A3(btn, msg, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$element(icon($author$project$UI$Theme$darkIconAttrs))
            ]), lbl);
        });
        var bigStop = function () {
            var delta = $author$project$UI$Theme$iconSize.dZ / 6;
            var bigWidth = (($author$project$UI$Theme$iconSize.dZ * 4) / 3) | 0;
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$moveUp(delta),
                $miniBill$elm_ui_with_context$Element$WithContext$moveLeft(delta)
            ]), $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$stopOutlined(_Utils_ap($author$project$UI$Theme$darkIconAttrs, _List_fromArray([
                $lemol$ant_design_icons_elm_ui$Ant$Icon$width(bigWidth)
            ])))));
        }();
        var expandIntervalsButton = function (expandIntervals) {
            return expandIntervals ? A3(btn, $author$project$UI$Model$ToggleExpandIntervals(false), _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$funnelPlotOutlined($author$project$UI$Theme$darkIconAttrs)),
                bigStop
            ]), { e0: "Do not apply noise reduction", fs: "Non applicare riduzione rumore" }) : A3(simpleBtn, $author$project$UI$Model$ToggleExpandIntervals(true), $lemol$ant_design_icons_elm_ui$Ant$Icons$funnelPlotOutlined, { e0: "Apply noise reduction", fs: "Applica riduzione rumore" });
        };
        var rayDifferentialsButton = function (rayDifferentials) {
            return rayDifferentials ? A3(btn, $author$project$UI$Model$ToggleRayDifferentials(false), _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$funnelPlotOutlined($author$project$UI$Theme$darkIconAttrs)),
                bigStop
            ]), { e0: "Do not apply ray differentials", fs: "Non applicare differenziali raggi" }) : A3(simpleBtn, $author$project$UI$Model$ToggleRayDifferentials(true), $lemol$ant_design_icons_elm_ui$Ant$Icons$funnelPlotOutlined, { e0: "Apply ray differentials", fs: "Applica differenziali raggi" });
        };
        var buttons = function () {
            var sid = $author$project$UI$selectedDocumentId(model);
            return _List_fromArray([
                $elm$core$Maybe$Just(A3(simpleBtn, $author$project$UI$Model$DocumentOpen, $lemol$ant_design_icons_elm_ui$Ant$Icons$folderOpenOutlined, { e0: "Open", fs: "Apri" })),
                $elm$core$Maybe$map_fn(function (id) {
                    return A3(simpleBtn, $author$project$UI$Model$DocumentMsg_fn(id, $author$project$UI$Model$DocumentDownload), $lemol$ant_design_icons_elm_ui$Ant$Icons$saveOutlined, { e0: "Save", fs: "Salva" });
                }, sid),
                $elm$core$Maybe$Just($miniBill$elm_ui_with_context$Element$WithContext$with_fn(function ($) {
                    return $.bU;
                }, expandIntervalsButton)),
                $elm$core$Maybe$Just($miniBill$elm_ui_with_context$Element$WithContext$with_fn(function ($) {
                    return $.ck;
                }, rayDifferentialsButton)),
                $elm$core$Maybe$Just(languagesRow)
            ]);
        }();
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
            $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.aQ),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$width(1)
        ]), $elm$core$List$intersperse_fn($author$project$UI$Theme$hr, $elm$core$List$filterMap_fn($elm$core$Basics$identity, buttons)));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$MoreOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$moreOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$MoreOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$moreOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$moreOutlined);
    };
    var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
    var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
    var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$hover, $mdgriffith$elm_ui$Internal$Model$PseudoSelector_fn(1, $mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$mouseOver = function (decs) {
        return function (context) {
            return $mdgriffith$elm_ui$Element$mouseOver($elm$core$List$map_fn(function (_v0) {
                var f = _v0;
                return f(context);
            }, decs));
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$Paragraph = { $: 9 };
    var $mdgriffith$elm_ui$Element$paragraph_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asParagraph, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph), _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$spacing(5), attrs))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$paragraph = F2($mdgriffith$elm_ui$Element$paragraph_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$paragraph_a0 = $mdgriffith$elm_ui$Element$paragraph, $miniBill$elm_ui_with_context$Element$WithContext$paragraph = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($miniBill$elm_ui_with_context$Element$WithContext$paragraph_a0);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$PlaySquareOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z")
            ]), _List_Nil),
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$playSquareOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$PlaySquareOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$playSquareOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$playSquareOutlined);
    };
    var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderRound, $mdgriffith$elm_ui$Internal$Model$Single_fn("br-" + $elm$core$String$fromInt(radius), "border-radius", $elm$core$String$fromInt(radius) + "px"));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Border$rounded = function (radius) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$rounded(radius));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$shrink = $mdgriffith$elm_ui$Element$shrink;
    var $author$project$UI$viewPendingActions = function (actions) {
        var viewPendingAction = function (_v1) {
            var label = _v1.a;
            var msg = _v1.b;
            if (msg.$ === 1) {
                return label;
            }
            else {
                var m = msg.a;
                return A2($author$project$UI$Theme$row, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                ]), _List_fromArray([
                    label,
                    $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                        $author$project$UI$L10N$title({ e0: "Run", fs: "Esegui" })
                    ]), {
                        R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$playSquareOutlined($author$project$UI$Theme$darkIconAttrs)),
                        W: $elm$core$Maybe$Just(m)
                    })
                ]));
            }
        };
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
            $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.aQ),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$width(1),
            $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing)
        ]), $elm$core$List$intersperse_fn($author$project$UI$Theme$hr, $elm$core$List$map_fn(viewPendingAction, actions)));
    };
    var $author$project$UI$toolbar = function (model) {
        var google = model.m;
        var openMenu = model.bp;
        var showPendingActions = model.bx;
        var toolbarButton = F4(function (buttonAttrs, msg, icon, label) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _Utils_ap(_List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                $miniBill$elm_ui_with_context$Element$WithContext$centerY,
                $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing),
                $miniBill$elm_ui_with_context$Element$WithContext$Border$rounded(999),
                $miniBill$elm_ui_with_context$Element$WithContext$mouseOver(_List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$darken($author$project$UI$Theme$colors.aQ))
                ])),
                $author$project$UI$L10N$title(label)
            ]), buttonAttrs), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$element(icon($author$project$UI$Theme$darkIconAttrs)),
                W: $elm$core$Maybe$Just(msg)
            });
        });
        var simpleToolbarButton = toolbarButton(_List_Nil);
        var runButton = $elm$core$Maybe$map_fn(function (id) {
            return A3(simpleToolbarButton, $author$project$UI$Model$DocumentMsg_fn(id, $author$project$UI$Model$DocumentCalculateAll), $lemol$ant_design_icons_elm_ui$Ant$Icons$playSquareOutlined, { e0: "Run document", fs: "Esegui documento" });
        }, $author$project$UI$selectedDocumentId(model));
        var pendingActions = function () {
            var waitingAccessTokenLabel = { e0: "Waiting for user to authenticate with Google", fs: "In attesa che l'utente si autentichi con Google" };
            var viewGoogleAction = F2(function (_v4, _v5) {
                var en = _v4.e0;
                var it = _v4.fs;
                var name = _v5.dw;
                var request = _v5.Y;
                switch (request.$) {
                    case 0:
                        return _Utils_Tuple2($author$project$UI$L10N$text({ e0: name + (": " + waitingAccessTokenLabel.e0), fs: name + (": " + waitingAccessTokenLabel.fs) }), $elm$core$Maybe$Nothing);
                    case 1:
                        return _Utils_Tuple2($author$project$UI$L10N$text({ e0: name + (": " + en), fs: name + (": " + it) }), $elm$core$Maybe$Nothing);
                    case 2:
                        var error = request.a;
                        return _Utils_Tuple2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$paragraph_a0, _List_Nil, _List_fromArray([
                            $author$project$UI$L10N$text({
                                e0: name + (": " + function () {
                                    if (!error.$) {
                                        var r = error.a;
                                        return "unexpected response " + r;
                                    }
                                    else {
                                        return "Unexpected error";
                                    }
                                }()),
                                fs: name + (": " + function () {
                                    if (!error.$) {
                                        var r = error.a;
                                        return "risposta inattesa " + r;
                                    }
                                    else {
                                        return "Unexpected error";
                                    }
                                }())
                            })
                        ])), $elm$core$Maybe$Nothing);
                    default:
                        return _Utils_Tuple2($author$project$UI$L10N$text({ e0: name + ": done", fs: name + ": fatto" }), $elm$core$Maybe$Nothing);
                }
            });
            return _Utils_ap($elm$core$List$map_fn(viewGoogleAction({ e0: "Waiting for an id", fs: "In attesa di id" }), google.O), $elm$core$List$map_fn(viewGoogleAction({ e0: "Waiting for save", fs: "In attesa di salvataggio" }), google.T));
        }();
        var pendingButton = $elm$core$List$isEmpty(pendingActions) ? $miniBill$elm_ui_with_context$Element$WithContext$none : ($elm$core$List$any_fn(function (_v0) {
            var msg = _v0.b;
            return !_Utils_eq(msg, $elm$core$Maybe$Nothing);
        }, pendingActions) ? A4(toolbarButton, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.gF),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$width(1)
        ]), $author$project$UI$Model$ToggleShowPendingActions(!showPendingActions), $lemol$ant_design_icons_elm_ui$Ant$Icons$cloudSyncOutlined, { e0: "Pending actions", fs: "Azioni in coda" }) : A3(simpleToolbarButton, $author$project$UI$Model$ToggleShowPendingActions(!showPendingActions), $lemol$ant_design_icons_elm_ui$Ant$Icons$cloudSyncOutlined, { e0: "Pending actions", fs: "Azioni in coda" }));
        var moreButton = A3(simpleToolbarButton, $author$project$UI$Model$ToggleMenu(!openMenu), $lemol$ant_design_icons_elm_ui$Ant$Icons$moreOutlined, { e0: "Menu", fs: "Men\u00F9" });
        var clearButton = $elm$core$Maybe$map_fn(function (id) {
            return A3(simpleToolbarButton, $author$project$UI$Model$DocumentMsg_fn(id, $author$project$UI$Model$DocumentClearAll), $lemol$ant_design_icons_elm_ui$Ant$Icons$stopOutlined, { e0: "Clear document", fs: "Pulisci documento" });
        }, $author$project$UI$selectedDocumentId(model));
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$padding(($author$project$UI$Theme$spacing / 4) | 0),
            openMenu ? $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$below_a0, $author$project$UI$dropdown(model)) : $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$shrink),
            showPendingActions ? $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$below_a0, $author$project$UI$viewPendingActions(pendingActions)) : $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$shrink)
        ]), $elm$core$List$filterMap_fn($elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just(pendingButton),
            runButton,
            clearButton,
            $elm$core$Maybe$Just(moreButton)
        ])));
    };
    var $author$project$UI$documentPicker = function (model) {
        var documents = model.l;
        var toDocumentTabButton = F2(function (index, document) {
            var selected = !index;
            var name = $elm$core$Maybe$withDefault_fn({ e0: "Untitled", fs: "Senza Titolo" }, $elm$core$Maybe$map_fn($author$project$UI$L10N$invariant, $author$project$Maybe$MyExtra$withDefaultMaybe_fn($elm$core$Maybe$andThen_fn(function (s) {
                return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
            }, $elm$core$Maybe$map_fn($author$project$UI$rowToTitle, $elm$core$List$head(document.M))), document.dw)));
            var label = $author$project$UI$L10N$text($author$project$UI$L10N$map_fn($author$project$UI$ellipsize, name));
            return $miniBill$elm_ui_with_context$Element$WithContext$map_fn($author$project$UI$Model$DocumentMsg(document.fh), $author$project$UI$documentTabButton({
                bO: $elm$core$Maybe$Just($author$project$UI$Model$DocumentClose({ bJ: true })),
                b7: index,
                R: label,
                W: selected ? $author$project$UI$Model$DocumentPushModal($author$project$Document$ModalRename($elm$core$Maybe$withDefault_fn("", document.dw))) : $author$project$UI$Model$DocumentSelect,
                co: selected,
                bB: name
            }));
        });
        var buttons = _Utils_ap($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeL, $author$project$Zipper$toList, $author$project$Zipper$map(toDocumentTabButton)), documents)), _List_fromArray([
            $author$project$UI$documentTabButton({
                bO: $elm$core$Maybe$Nothing,
                b7: -1,
                R: $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_Nil, _List_fromArray([
                    $author$project$UI$L10N$text($author$project$UI$L10N$invariant("\u200B")),
                    $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$fileAddTwoTone($author$project$UI$Theme$smallDarkIconAttrs))
                ])),
                W: $author$project$UI$Model$DocumentNew,
                co: false,
                bB: { e0: "New document", fs: "Nuovo documento" }
            })
        ]));
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$paddingEach({ cS: 0, dr: $author$project$UI$Theme$spacing, dO: $author$project$UI$Theme$spacing, d4: $author$project$UI$Theme$spacing }),
            $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach({ cS: 1, dr: 0, dO: 0, d4: 0 }),
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$spacing(($author$project$UI$Theme$spacing / 2) | 0)
        ]), _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignBottom,
                $miniBill$elm_ui_with_context$Element$WithContext$spacing(($author$project$UI$Theme$spacing / 2) | 0),
                $miniBill$elm_ui_with_context$Element$WithContext$scrollbarX,
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
            ]), buttons),
            $author$project$UI$toolbar(model)
        ]));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$html = function (child) {
        return $miniBill$elm_ui_with_context$Element$WithContext$element($mdgriffith$elm_ui$Element$html(child));
    };
    var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
    var $miniBill$elm_ui_with_context$Element$WithContext$Lazy$apply3_fn = function (context, fn, a, b, c) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, A3(fn, a, b, c));
    }, $miniBill$elm_ui_with_context$Element$WithContext$Lazy$apply3_fn_unwrapped = function (context, fn, a, b, c) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, fn(a, b, c));
    }, $miniBill$elm_ui_with_context$Element$WithContext$Lazy$apply3 = F5($miniBill$elm_ui_with_context$Element$WithContext$Lazy$apply3_fn);
    var $mdgriffith$elm_ui$Element$Lazy$embed = function (x) {
        switch (x.$) {
            case 0:
                var html = x.a;
                return html;
            case 1:
                var styled = x.a;
                return styled.b3($mdgriffith$elm_ui$Internal$Model$OnlyDynamic_fn({
                    e8: { ez: $elm$core$Maybe$Nothing, eE: $elm$core$Maybe$Nothing, f6: $elm$core$Maybe$Nothing },
                    ff: 1,
                    fy: 0
                }, styled.d0));
            case 2:
                var text = x.a;
                return $elm$core$Basics$always($elm$virtual_dom$VirtualDom$text(text));
            default:
                return $elm$core$Basics$always($elm$virtual_dom$VirtualDom$text(""));
        }
    };
    var $mdgriffith$elm_ui$Element$Lazy$apply5_fn = function (fn, a, b, c, d, e) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(A5(fn, a, b, c, d, e));
    }, $mdgriffith$elm_ui$Element$Lazy$apply5_fn_unwrapped = function (fn, a, b, c, d, e) {
        return $mdgriffith$elm_ui$Element$Lazy$embed(fn(a, b, c, d, e));
    }, $mdgriffith$elm_ui$Element$Lazy$apply5 = F6($mdgriffith$elm_ui$Element$Lazy$apply5_fn);
    var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
    var $mdgriffith$elm_ui$Element$Lazy$lazy5_fn = function (fn, a, b, c, d, e) {
        return $mdgriffith$elm_ui$Internal$Model$Unstyled(A7($elm$virtual_dom$VirtualDom$lazy7, $mdgriffith$elm_ui$Element$Lazy$apply5, fn, a, b, c, d, e));
    }, $mdgriffith$elm_ui$Element$Lazy$lazy5 = F6($mdgriffith$elm_ui$Element$Lazy$lazy5_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Lazy$lazy3_fn = function (fn, a, b, c) {
        return function (context) {
            return $mdgriffith$elm_ui$Element$Lazy$lazy5_fn($miniBill$elm_ui_with_context$Element$WithContext$Lazy$apply3, context, fn, a, b, c);
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Lazy$lazy3 = F4($miniBill$elm_ui_with_context$Element$WithContext$Lazy$lazy3_fn);
    var $mdgriffith$elm_ui$Element$scrollbarY = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.f3);
    var $miniBill$elm_ui_with_context$Element$WithContext$scrollbarY = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$scrollbarY);
    var $author$project$UI$Model$DocumentCellMsg = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$UI$Model$EndEditing = { $: 0 };
    var $author$project$UI$Model$ToCode = { $: 1 };
    var $mdgriffith$elm_ui$Internal$Model$Top = 0;
    var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
    var $miniBill$elm_ui_with_context$Element$WithContext$alignTop = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$alignTop);
    var $author$project$UI$Model$Calculate = { $: 5 };
    var $author$project$UI$Model$Clear = { $: 3 };
    var $author$project$UI$Model$ToMarkdown = { $: 2 };
    var $author$project$UI$Theme$column = function (attrs) {
        return $miniBill$elm_ui_with_context$Element$WithContext$column(_List_Cons($miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing), attrs));
    };
    var $author$project$UI$Model$Input = function (a) {
        return { $: 6, a: a };
    };
    var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$Label = $elm$core$Basics$identity;
    var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$labelHidden = function (content) {
        return function (_v0) {
            return $mdgriffith$elm_ui$Element$Input$labelHidden(content);
        };
    };
    var $mdgriffith$elm_ui$Internal$Model$Max_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Max = F2($mdgriffith$elm_ui$Internal$Model$Max_fn);
    var $mdgriffith$elm_ui$Element$maximum_fn = function (i, l) {
        return $mdgriffith$elm_ui$Internal$Model$Max_fn(i, l);
    }, $mdgriffith$elm_ui$Element$maximum = F2($mdgriffith$elm_ui$Element$maximum_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$maximum = $mdgriffith$elm_ui$Element$maximum;
    var $mdgriffith$elm_ui$Element$Input$TextArea = { $: 1 };
    var $mdgriffith$elm_ui$Internal$Model$LivePolite = { $: 6 };
    var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
    var $mdgriffith$elm_ui$Element$Input$applyLabel_fn = function (attrs, label, input) {
        if (label.$ === 1) {
            var labelText = label.a;
            return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), attrs, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input])));
        }
        else {
            var position = label.a;
            var labelAttrs = label.b;
            var labelChild = label.c;
            var labelElement = $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, labelAttrs, $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelChild])));
            switch (position) {
                case 2:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bk), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelElement, input])));
                case 3:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asColumn, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bk), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input, labelElement])));
                case 0:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bk), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([input, labelElement])));
                default:
                    return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asRow, $mdgriffith$elm_ui$Internal$Model$NodeName("label"), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bk), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([labelElement, input])));
            }
        }
    }, $mdgriffith$elm_ui$Element$Input$applyLabel = F3($mdgriffith$elm_ui$Element$Input$applyLabel_fn);
    var $mdgriffith$elm_ui$Element$Input$autofill_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$autofill_a1 = $elm$html$Html$Attributes$attribute("autocomplete"), $mdgriffith$elm_ui$Element$Input$autofill = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$autofill_a0, $mdgriffith$elm_ui$Element$Input$autofill_a1);
    var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
    var $mdgriffith$elm_ui$Element$behindContent = function (element) {
        return $mdgriffith$elm_ui$Element$createNearby_fn(5, element);
    };
    var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
        var gatherSpacing = F2(function (attr, found) {
            if ((attr.$ === 4) && (attr.b.$ === 5)) {
                var _v2 = attr.b;
                var x = _v2.b;
                var y = _v2.c;
                if (found.$ === 1) {
                    return $elm$core$Maybe$Just(y);
                }
                else {
                    return found;
                }
            }
            else {
                return found;
            }
        });
        var _v0 = $elm$core$List$foldr_fn(gatherSpacing, $elm$core$Maybe$Nothing, attrs);
        if (_v0.$ === 1) {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
        else {
            var vSpace = _v0.a;
            return $mdgriffith$elm_ui$Element$moveUp($elm$core$Basics$floor(vSpace / 2));
        }
    };
    var $mdgriffith$elm_ui$Element$clip = $mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.eP);
    var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
    var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$borderColor, $mdgriffith$elm_ui$Internal$Model$Colored_fn("bc-" + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr), "border-color", clr));
    };
    var $mdgriffith$elm_ui$Element$Input$darkGrey = $mdgriffith$elm_ui$Element$rgb_fn(186 / 255, 189 / 255, 182 / 255);
    var $mdgriffith$elm_ui$Element$paddingXY_fn = function (x, y) {
        if (_Utils_eq(x, y)) {
            var f = x;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + $elm$core$String$fromInt(x), f, f, f, f));
        }
        else {
            var yFloat = y;
            var xFloat = x;
            return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn("p-" + ($elm$core$String$fromInt(x) + ("-" + $elm$core$String$fromInt(y))), yFloat, xFloat, yFloat, xFloat));
        }
    }, $mdgriffith$elm_ui$Element$paddingXY = F2($mdgriffith$elm_ui$Element$paddingXY_fn);
    var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = $mdgriffith$elm_ui$Element$paddingXY_fn(12, 12);
    var $mdgriffith$elm_ui$Element$Input$white = $mdgriffith$elm_ui$Element$rgb_fn(1, 1, 1);
    var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray([
        $mdgriffith$elm_ui$Element$Input$defaultTextPadding,
        $mdgriffith$elm_ui$Element$Border$rounded(3),
        $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
        $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
        $mdgriffith$elm_ui$Element$Border$width(1),
        $mdgriffith$elm_ui$Element$spacing(5),
        $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
        $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
    ]);
    var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
        if (attr.$ === 8) {
            var h = attr.a;
            return $elm$core$Maybe$Just(h);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
        return { $: 5, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
        if (label.$ === 1) {
            var textLabel = label.a;
            return $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Label(textLabel));
        }
        else {
            return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
        isConstrained: while (true) {
            switch (len.$) {
                case 1:
                    return false;
                case 0:
                    return true;
                case 2:
                    return true;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isConstrained;
                default:
                    var l = len.b;
                    return true;
            }
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
        if (label.$ === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
        if (!label.$) {
            var loc = label.a;
            switch (loc) {
                case 0:
                    return false;
                case 1:
                    return false;
                case 2:
                    return true;
                default:
                    return true;
            }
        }
        else {
            return true;
        }
    };
    var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
        return { cS: -box.cS, dr: -box.dr, dO: -box.dO, d4: -box.d4 };
    };
    var $elm$html$Html$Events$alwaysStop = function (x) {
        return _Utils_Tuple2(x, true);
    };
    var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
        return { $: 1, a: a };
    };
    var $elm$html$Html$Events$stopPropagationOn_fn = function (event, decoder) {
        return _VirtualDom_on_fn(event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
    }, $elm$html$Html$Events$stopPropagationOn = F2($elm$html$Html$Events$stopPropagationOn_fn);
    var $elm$json$Json$Decode$at_fn = function (fields, decoder) {
        return $elm$core$List$foldr_fn($elm$json$Json$Decode$field, decoder, fields);
    }, $elm$json$Json$Decode$at = F2($elm$json$Json$Decode$at_fn);
    var $elm$html$Html$Events$targetValue = $elm$json$Json$Decode$at_fn(_List_fromArray(["target", "value"]), $elm$json$Json$Decode$string);
    var $elm$html$Html$Events$onInput = function (tagger) {
        return $elm$html$Html$Events$stopPropagationOn_fn("input", _Json_map1_fn($elm$html$Html$Events$alwaysStop, _Json_map1_fn(tagger, $elm$html$Html$Events$targetValue)));
    };
    var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
        isFill: while (true) {
            switch (len.$) {
                case 2:
                    return true;
                case 1:
                    return false;
                case 0:
                    return false;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isFill;
                default:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isFill;
            }
        }
    };
    var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
        isPixel: while (true) {
            switch (len.$) {
                case 1:
                    return false;
                case 0:
                    return true;
                case 2:
                    return false;
                case 3:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isPixel;
                default:
                    var l = len.b;
                    var $temp$len = l;
                    len = $temp$len;
                    continue isPixel;
            }
        }
    };
    var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn = function (top, right, bottom, left) {
        return "pad-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ("-" + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ("-" + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
    }, $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn);
    var $mdgriffith$elm_ui$Element$Input$redistributeOver_fn = function (isMultiline, stacked, attr, els) {
        switch (attr.$) {
            case 9:
                return _Utils_update(els, {
                    b: _List_Cons(attr, els.b)
                });
            case 7:
                var width = attr.a;
                return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(els, {
                    j: _List_Cons(attr, els.j),
                    r: _List_Cons(attr, els.r),
                    b: _List_Cons(attr, els.b)
                }) : (stacked ? _Utils_update(els, {
                    j: _List_Cons(attr, els.j)
                }) : _Utils_update(els, {
                    b: _List_Cons(attr, els.b)
                }));
            case 8:
                var height = attr.a;
                return (!stacked) ? _Utils_update(els, {
                    j: _List_Cons(attr, els.j),
                    b: _List_Cons(attr, els.b)
                }) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(els, {
                    j: _List_Cons(attr, els.j),
                    b: _List_Cons(attr, els.b)
                }) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(els, {
                    b: _List_Cons(attr, els.b)
                }) : _Utils_update(els, {
                    b: _List_Cons(attr, els.b)
                })));
            case 6:
                return _Utils_update(els, {
                    j: _List_Cons(attr, els.j)
                });
            case 5:
                return _Utils_update(els, {
                    j: _List_Cons(attr, els.j)
                });
            case 4:
                switch (attr.b.$) {
                    case 5:
                        var _v1 = attr.b;
                        return _Utils_update(els, {
                            j: _List_Cons(attr, els.j),
                            r: _List_Cons(attr, els.r),
                            b: _List_Cons(attr, els.b),
                            aM: _List_Cons(attr, els.aM)
                        });
                    case 7:
                        var cls = attr.a;
                        var _v2 = attr.b;
                        var pad = _v2.a;
                        var t = _v2.b;
                        var r = _v2.c;
                        var b = _v2.d;
                        var l = _v2.e;
                        if (isMultiline) {
                            return _Utils_update(els, {
                                F: _List_Cons(attr, els.F),
                                b: _List_Cons(attr, els.b)
                            });
                        }
                        else {
                            var newTop = t - $elm$core$Basics$min_fn(t, b);
                            var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(_VirtualDom_style_fn("line-height", "calc(1.0em + " + ($elm$core$String$fromFloat(2 * $elm$core$Basics$min_fn(t, b)) + "px)")));
                            var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(_VirtualDom_style_fn("height", "calc(1.0em + " + ($elm$core$String$fromFloat(2 * $elm$core$Basics$min_fn(t, b)) + "px)")));
                            var newBottom = b - $elm$core$Basics$min_fn(t, b);
                            var reducedVerticalPadding = $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$padding, $mdgriffith$elm_ui$Internal$Model$PaddingStyle_fn($mdgriffith$elm_ui$Internal$Model$paddingNameFloat_fn(newTop, r, newBottom, l), newTop, r, newBottom, l));
                            return _Utils_update(els, {
                                F: _List_Cons(attr, els.F),
                                r: _List_Cons(newHeight, _List_Cons(newLineHeight, els.r)),
                                b: _List_Cons(reducedVerticalPadding, els.b)
                            });
                        }
                    case 6:
                        var _v3 = attr.b;
                        return _Utils_update(els, {
                            F: _List_Cons(attr, els.F),
                            b: _List_Cons(attr, els.b)
                        });
                    case 10:
                        return _Utils_update(els, {
                            F: _List_Cons(attr, els.F),
                            b: _List_Cons(attr, els.b)
                        });
                    case 2:
                        return _Utils_update(els, {
                            j: _List_Cons(attr, els.j)
                        });
                    case 1:
                        var _v4 = attr.b;
                        return _Utils_update(els, {
                            j: _List_Cons(attr, els.j)
                        });
                    default:
                        var flag = attr.a;
                        var cls = attr.b;
                        return _Utils_update(els, {
                            b: _List_Cons(attr, els.b)
                        });
                }
            case 0:
                return els;
            case 1:
                var a = attr.a;
                return _Utils_update(els, {
                    r: _List_Cons(attr, els.r)
                });
            case 2:
                return _Utils_update(els, {
                    r: _List_Cons(attr, els.r)
                });
            case 3:
                return _Utils_update(els, {
                    b: _List_Cons(attr, els.b)
                });
            default:
                return _Utils_update(els, {
                    r: _List_Cons(attr, els.r)
                });
        }
    }, $mdgriffith$elm_ui$Element$Input$redistributeOver = F4($mdgriffith$elm_ui$Element$Input$redistributeOver_fn);
    var $mdgriffith$elm_ui$Element$Input$redistribute_fn = function (isMultiline, stacked, attrs) {
        return function (redist) {
            return {
                F: $elm$core$List$reverse(redist.F),
                j: $elm$core$List$reverse(redist.j),
                r: $elm$core$List$reverse(redist.r),
                b: $elm$core$List$reverse(redist.b),
                aM: $elm$core$List$reverse(redist.aM)
            };
        }($elm$core$List$foldl_fn(A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked), { F: _List_Nil, j: _List_Nil, r: _List_Nil, b: _List_Nil, aM: _List_Nil }, attrs));
    }, $mdgriffith$elm_ui$Element$Input$redistribute = F3($mdgriffith$elm_ui$Element$Input$redistribute_fn);
    var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
        var top = _v0.d4;
        var right = _v0.dO;
        var bottom = _v0.cS;
        var left = _v0.dr;
        return $elm$core$String$fromInt(top) + ("px " + ($elm$core$String$fromInt(right) + ("px " + ($elm$core$String$fromInt(bottom) + ("px " + ($elm$core$String$fromInt(left) + "px"))))));
    };
    var $mdgriffith$elm_ui$Internal$Model$Transparency_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Transparency = F2($mdgriffith$elm_ui$Internal$Model$Transparency_fn);
    var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
    var $mdgriffith$elm_ui$Element$alpha = function (o) {
        var transparency = function (x) {
            return 1 - x;
        }($elm$core$Basics$min_fn(1, $elm$core$Basics$max_fn(0, o)));
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$transparency, $mdgriffith$elm_ui$Internal$Model$Transparency_fn("transparency-" + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency), transparency));
    };
    var $mdgriffith$elm_ui$Element$Input$charcoal = $mdgriffith$elm_ui$Element$rgb_fn(136 / 255, 138 / 255, 133 / 255);
    var $mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn = function (_v0, forPlaceholder, on) {
        var placeholderAttrs = _v0.a;
        var placeholderEl = _v0.b;
        return $mdgriffith$elm_ui$Element$el_fn(_Utils_ap(forPlaceholder, _Utils_ap(_List_fromArray([
            $mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
            $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dx + (" " + $mdgriffith$elm_ui$Internal$Style$classes.fT)),
            $mdgriffith$elm_ui$Element$clip,
            $mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
            $mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0)),
            $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
            $mdgriffith$elm_ui$Element$alpha(on ? 1 : 0)
        ]), placeholderAttrs)), placeholderEl);
    }, $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3($mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn);
    var $elm$html$Html$span = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "span"), $elm$html$Html$span_fn = $elm$html$Html$span.f;
    var $elm$html$Html$Attributes$spellcheck_a0 = "spellcheck", $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$spellcheck_a0);
    var $mdgriffith$elm_ui$Element$Input$spellcheck_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$spellcheck_a1 = $elm$html$Html$Attributes$spellcheck, $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$spellcheck_a0, $mdgriffith$elm_ui$Element$Input$spellcheck_a1);
    var $elm$html$Html$Attributes$type__a0 = "type", $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$type__a0);
    var $elm$html$Html$Attributes$value_a0 = "value", $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$value_a0);
    var $mdgriffith$elm_ui$Element$Input$value_a0 = $mdgriffith$elm_ui$Internal$Model$Attr, $mdgriffith$elm_ui$Element$Input$value_a1 = $elm$html$Html$Attributes$value, $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Element$Input$value_a0, $mdgriffith$elm_ui$Element$Input$value_a1);
    var $mdgriffith$elm_ui$Element$Input$textHelper_fn = function (textInput, attrs, textOptions) {
        var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
        var redistributed = $mdgriffith$elm_ui$Element$Input$redistribute_fn(_Utils_eq(textInput.k, $mdgriffith$elm_ui$Element$Input$TextArea), $mdgriffith$elm_ui$Element$Input$isStacked(textOptions.R), withDefaults);
        var onlySpacing = function (attr) {
            if ((attr.$ === 4) && (attr.b.$ === 5)) {
                var _v9 = attr.b;
                return true;
            }
            else {
                return false;
            }
        };
        var heightConstrained = function () {
            var _v7 = textInput.k;
            if (!_v7.$) {
                var inputType = _v7.a;
                return false;
            }
            else {
                return $elm$core$Maybe$withDefault_fn(false, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Input$isConstrained, $elm$core$List$head($elm$core$List$reverse($elm$core$List$filterMap_fn($mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
            }
        }();
        var getPadding = function (attr) {
            if ((attr.$ === 4) && (attr.b.$ === 7)) {
                var cls = attr.a;
                var _v6 = attr.b;
                var pad = _v6.a;
                var t = _v6.b;
                var r = _v6.c;
                var b = _v6.d;
                var l = _v6.e;
                return $elm$core$Maybe$Just({
                    cS: $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(b - 3)),
                    dr: $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(l - 3)),
                    dO: $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(r - 3)),
                    d4: $elm$core$Basics$max_fn(0, $elm$core$Basics$floor(t - 3))
                });
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        };
        var parentPadding = $elm$core$Maybe$withDefault_fn({ cS: 0, dr: 0, dO: 0, d4: 0 }, $elm$core$List$head($elm$core$List$reverse($elm$core$List$filterMap_fn(getPadding, withDefaults))));
        var inputElement = $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, function () {
            var _v3 = textInput.k;
            if (!_v3.$) {
                var inputType = _v3.a;
                return $mdgriffith$elm_ui$Internal$Model$NodeName("input");
            }
            else {
                return $mdgriffith$elm_ui$Internal$Model$NodeName("textarea");
            }
        }(), _Utils_ap(function () {
            var _v4 = textInput.k;
            if (!_v4.$) {
                var inputType = _v4.a;
                return _List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, inputType)),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fq)
                ]);
            }
            else {
                return _List_fromArray([
                    $mdgriffith$elm_ui$Element$clip,
                    $mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fm),
                    $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
                    $mdgriffith$elm_ui$Element$paddingEach(parentPadding),
                    $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("margin", $mdgriffith$elm_ui$Element$Input$renderBox($mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
                    $mdgriffith$elm_ui$Internal$Model$Attr(_VirtualDom_style_fn("box-sizing", "content-box"))
                ]);
            }
        }(), _Utils_ap(_List_fromArray([
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Input$value_a0, $mdgriffith$elm_ui$Element$Input$value_a1, textOptions.gk),
            $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Events$onInput(textOptions.fL)),
            $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.R),
            $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Element$Input$spellcheck_a0, $mdgriffith$elm_ui$Element$Input$spellcheck_a1, textInput._),
            $elm$core$Maybe$withDefault_fn($mdgriffith$elm_ui$Internal$Model$NoAttribute, $elm$core$Maybe$map_fn($mdgriffith$elm_ui$Element$Input$autofill, textInput.U))
        ]), redistributed.r)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
        var wrappedInput = function () {
            var _v0 = textInput.k;
            if (_v0.$ === 1) {
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _Utils_ap((heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(_List_fromArray([
                    $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
                    $elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.c6),
                    $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fp)
                ])), redistributed.b), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([
                    $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asParagraph, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill), _List_Cons($mdgriffith$elm_ui$Element$inFront(inputElement), _List_Cons($mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fo), redistributed.aM)))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(function () {
                        if (textOptions.gk === "") {
                            var _v1 = textOptions.fU;
                            if (_v1.$ === 1) {
                                return _List_fromArray([
                                    $mdgriffith$elm_ui$Element$text("\u00A0")
                                ]);
                            }
                            else {
                                var place = _v1.a;
                                return _List_fromArray([
                                    $mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn(place, _List_Nil, textOptions.gk === "")
                                ]);
                            }
                        }
                        else {
                            return _List_fromArray([
                                $elm$core$Basics$composeL_fn($mdgriffith$elm_ui$Internal$Model$unstyled_a0, $mdgriffith$elm_ui$Internal$Model$unstyled_a1, $elm$html$Html$span_fn(_List_fromArray([
                                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, $mdgriffith$elm_ui$Internal$Style$classes.fn)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(textOptions.gk + "\u00A0")
                                ])))
                            ]);
                        }
                    }()))
                ])));
            }
            else {
                var inputType = _v0.a;
                return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons($elm$core$List$any_fn($mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.c6), $elm$core$List$concat(_List_fromArray([
                    redistributed.b,
                    function () {
                        var _v2 = textOptions.fU;
                        if (_v2.$ === 1) {
                            return _List_Nil;
                        }
                        else {
                            var place = _v2.a;
                            return _List_fromArray([
                                $mdgriffith$elm_ui$Element$behindContent($mdgriffith$elm_ui$Element$Input$renderPlaceholder_fn(place, redistributed.F, textOptions.gk === ""))
                            ]);
                        }
                    }()
                ])))), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([inputElement])));
            }
        }();
        return $mdgriffith$elm_ui$Element$Input$applyLabel_fn(_List_Cons($mdgriffith$elm_ui$Internal$Model$Class_fn($mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.eW), _List_Cons($mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.R) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5), _List_Cons($mdgriffith$elm_ui$Element$Region$announce, redistributed.j))), textOptions.R, wrappedInput);
    }, $mdgriffith$elm_ui$Element$Input$textHelper = F3($mdgriffith$elm_ui$Element$Input$textHelper_fn);
    var $mdgriffith$elm_ui$Element$Input$multiline_fn = function (attrs, multi) {
        return $mdgriffith$elm_ui$Element$Input$textHelper_fn({ U: $elm$core$Maybe$Nothing, _: multi.gb, k: $mdgriffith$elm_ui$Element$Input$TextArea }, attrs, { R: multi.R, fL: multi.fL, fU: multi.fU, gk: multi.gk });
    }, $mdgriffith$elm_ui$Element$Input$multiline = F2($mdgriffith$elm_ui$Element$Input$multiline_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$runLabel_fn = function (context, _v0) {
        var f = _v0;
        return f(context);
    }, $miniBill$elm_ui_with_context$Element$WithContext$Input$runLabel = F2($miniBill$elm_ui_with_context$Element$WithContext$Input$runLabel_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$runPlaceholder_fn = function (context, _v0) {
        var f = _v0;
        return f(context);
    }, $miniBill$elm_ui_with_context$Element$WithContext$Input$runPlaceholder = F2($miniBill$elm_ui_with_context$Element$WithContext$Input$runPlaceholder_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a0 = $mdgriffith$elm_ui$Element$Input$multiline, $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a1 = F2(function (context, config) {
        return {
            R: $miniBill$elm_ui_with_context$Element$WithContext$Input$runLabel_fn(context, config.R),
            fL: config.fL,
            fU: $elm$core$Maybe$map_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context), config.fU),
            gb: config.gb,
            gk: config.gk
        };
    }), $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline = A2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a1);
    var $elm$core$Tuple$pair_fn = function (a, b) {
        return _Utils_Tuple2(a, b);
    }, $elm$core$Tuple$pair = F2($elm$core$Tuple$pair_fn);
    var $author$project$UI$Theme$onCtrlEnter = function (msg) {
        return $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Events$on_fn("keyup", _Json_andThen_fn(function (_v0) {
            var s = _v0.a;
            var ctrl = _v0.b;
            return ((s === "Enter") && ctrl) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail("ignored");
        }, _Json_map2_fn($elm$core$Tuple$pair, _Json_decodeField_fn("key", $elm$json$Json$Decode$string), _Json_decodeField_fn("ctrlKey", $elm$json$Json$Decode$bool)))));
    };
    var $author$project$UI$RowView$inputBox_fn = function (maxWidth, input) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$multiline_a1, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$width($mdgriffith$elm_ui$Element$maximum_fn(maxWidth, $miniBill$elm_ui_with_context$Element$WithContext$fill)),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$virtual_dom$VirtualDom$attribute_fn("autocorrect", "off")),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$virtual_dom$VirtualDom$attribute_fn("autocapitalize", "none")),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$spellcheck_a0, false)),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "input")),
            $author$project$UI$Theme$onCtrlEnter($author$project$UI$Model$Calculate)
        ]), {
            R: $miniBill$elm_ui_with_context$Element$WithContext$Input$labelHidden("Input"),
            fL: $author$project$UI$Model$Input,
            fU: $elm$core$Maybe$Nothing,
            gb: false,
            gk: input
        });
    }, $author$project$UI$RowView$inputBox = F2($author$project$UI$RowView$inputBox_fn);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$SwapOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$swapOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$SwapOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$swapOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$swapOutlined);
    };
    var $author$project$UI$RowView$codeInputLine_fn = function (size, index, input) {
        var label = $author$project$UI$L10N$text($author$project$UI$L10N$invariant("In [" + ($elm$core$String$fromInt(index) + "]")));
        var buttons = _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                $author$project$UI$L10N$title({ e0: "Press Ctrl+Enter to calculate", fs: "Premere Ctrl+Invio per calcolare" })
            ]), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$playSquareOutlined($author$project$UI$Theme$darkIconAttrs)),
                W: $elm$core$Maybe$Just($author$project$UI$Model$Calculate)
            }),
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                $author$project$UI$L10N$title({ e0: "Convert to Markdown cell", fs: "Converti in cella con Markdown" })
            ]), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$swapOutlined($author$project$UI$Theme$darkIconAttrs)),
                W: $elm$core$Maybe$Just($author$project$UI$Model$ToMarkdown)
            }),
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                $author$project$UI$L10N$title({ e0: "Clear result", fs: "Pulisci risultato" })
            ]), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$stopOutlined($author$project$UI$Theme$darkIconAttrs)),
                W: $elm$core$Maybe$Just($author$project$UI$Model$Clear)
            })
        ]);
        return $miniBill$elm_ui_with_context$Element$WithContext$with_fn(function ($) {
            return $.c$;
        }, function (deviceClass) {
            if (!deviceClass) {
                return A2($author$project$UI$Theme$column, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                ]), _List_fromArray([
                    A2($author$project$UI$Theme$row, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                    ]), _List_Cons(label, buttons)),
                    $author$project$UI$RowView$inputBox_fn(size.bE - (2 * $author$project$UI$Theme$spacing), input)
                ]));
            }
            else {
                return A2($author$project$UI$Theme$row, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                ]), _List_Cons(label, _List_Cons($author$project$UI$RowView$inputBox_fn(size.bE - 180, input), buttons)));
            }
        });
    }, $author$project$UI$RowView$codeInputLine = F3($author$project$UI$RowView$codeInputLine_fn);
    var $elm$html$Html$a = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "a"), $elm$html$Html$a_fn = $elm$html$Html$a.f;
    var $elm$html$Html$Attributes$align_a0 = "align", $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$align_a0);
    var $elm$html$Html$Attributes$alt_a0 = "alt", $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$alt_a0);
    var $elm$html$Html$blockquote = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "blockquote"), $elm$html$Html$blockquote_fn = $elm$html$Html$blockquote.f;
    var $elm$html$Html$br = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "br"), $elm$html$Html$br_fn = $elm$html$Html$br.f;
    var $elm$html$Html$Attributes$checked_a0 = "checked", $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$checked_a0);
    var $elm$html$Html$code = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "code"), $elm$html$Html$code_fn = $elm$html$Html$code.f;
    var $elm$html$Html$em = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "em"), $elm$html$Html$em_fn = $elm$html$Html$em.f;
    var $elm$html$Html$h1 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h1"), $elm$html$Html$h1_fn = $elm$html$Html$h1.f;
    var $elm$html$Html$h2 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h2"), $elm$html$Html$h2_fn = $elm$html$Html$h2.f;
    var $elm$html$Html$h3 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h3"), $elm$html$Html$h3_fn = $elm$html$Html$h3.f;
    var $elm$html$Html$h4 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h4"), $elm$html$Html$h4_fn = $elm$html$Html$h4.f;
    var $elm$html$Html$h5 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h5"), $elm$html$Html$h5_fn = $elm$html$Html$h5.f;
    var $elm$html$Html$h6 = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "h6"), $elm$html$Html$h6_fn = $elm$html$Html$h6.f;
    var $elm$html$Html$hr = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "hr"), $elm$html$Html$hr_fn = $elm$html$Html$hr.f;
    var $elm$html$Html$Attributes$href = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("href", _VirtualDom_noJavaScriptUri(url));
    };
    var $elm$html$Html$img = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "img"), $elm$html$Html$img_fn = $elm$html$Html$img.f;
    var $elm$html$Html$input = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "input"), $elm$html$Html$input_fn = $elm$html$Html$input.f;
    var $elm$html$Html$li = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "li"), $elm$html$Html$li_fn = $elm$html$Html$li.f;
    var $elm$html$Html$ol = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "ol"), $elm$html$Html$ol_fn = $elm$html$Html$ol.f;
    var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$Html$resultOr_fn = function (ra, rb) {
        if (ra.$ === 1) {
            var singleError = ra.a;
            if (!rb.$) {
                var okValue = rb.a;
                return $elm$core$Result$Ok(okValue);
            }
            else {
                var errorsSoFar = rb.a;
                return $elm$core$Result$Err(_List_Cons(singleError, errorsSoFar));
            }
        }
        else {
            var okValue = ra.a;
            return $elm$core$Result$Ok(okValue);
        }
    }, $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2($dillonkearns$elm_markdown$Markdown$Html$resultOr_fn);
    var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
        return $elm$core$String$join_fn(" ", $elm$core$List$map_fn(function (_v0) {
            var name = _v0.dw;
            var value = _v0.S;
            return name + ("=\"" + (value + "\""));
        }, attributes));
    };
    var $dillonkearns$elm_markdown$Markdown$Html$tagToString_fn = function (tagName, attributes) {
        return $elm$core$List$isEmpty(attributes) ? ("<" + (tagName + ">")) : ("<" + (tagName + (" " + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + ">"))));
    }, $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn);
    var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
        var unwrappedDecoders = $elm$core$List$map_fn(function (_v1) {
            var rawDecoder = _v1;
            return rawDecoder;
        }, decoders);
        return function (rawDecoder) {
            return F3(function (tagName, attributes, innerBlocks) {
                return $elm$core$Result$mapError_fn(function (errors) {
                    if (!errors.b) {
                        return "Ran into a oneOf with no possibilities!";
                    }
                    else {
                        if (!errors.b.b) {
                            var singleError = errors.a;
                            return "Problem with the given value:\n\n" + ($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn(tagName, attributes) + ("\n\n" + (singleError + "\n")));
                        }
                        else {
                            return "oneOf failed parsing this value:\n    " + ($dillonkearns$elm_markdown$Markdown$Html$tagToString_fn(tagName, attributes) + ("\n\nParsing failed in the following 2 ways:\n\n\n" + ($elm$core$String$join_fn("\n\n", $elm$core$List$indexedMap_fn(F2(function (index, error) {
                                return "(" + ($elm$core$String$fromInt(index + 1) + (") " + error));
                            }), errors)) + "\n")));
                        }
                    }
                }, A3(rawDecoder, tagName, attributes, innerBlocks));
            });
        }($elm$core$List$foldl_fn_unwrapped(function (decoder, soFar) {
            return F3(function (tagName, attributes, children) {
                return $dillonkearns$elm_markdown$Markdown$Html$resultOr_fn(A3(decoder, tagName, attributes, children), A3(soFar, tagName, attributes, children));
            });
        }, F3(function (tagName, attributes, children) {
            return $elm$core$Result$Err(_List_Nil);
        }), unwrappedDecoders));
    };
    var $elm$html$Html$pre = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "pre"), $elm$html$Html$pre_fn = $elm$html$Html$pre.f;
    var $elm$html$Html$Attributes$src = function (url) {
        return $elm$html$Html$Attributes$stringProperty_fn("src", _VirtualDom_noJavaScriptOrHtmlUri(url));
    };
    var $elm$html$Html$Attributes$start = function (n) {
        return $elm$html$Html$Attributes$stringProperty_fn("start", $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$strong = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "strong"), $elm$html$Html$strong_fn = $elm$html$Html$strong.f;
    var $elm$html$Html$table = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "table"), $elm$html$Html$table_fn = $elm$html$Html$table.f;
    var $elm$html$Html$tbody = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "tbody"), $elm$html$Html$tbody_fn = $elm$html$Html$tbody.f;
    var $elm$html$Html$td = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "td"), $elm$html$Html$td_fn = $elm$html$Html$td.f;
    var $elm$html$Html$th = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "th"), $elm$html$Html$th_fn = $elm$html$Html$th.f;
    var $elm$html$Html$thead = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "thead"), $elm$html$Html$thead_fn = $elm$html$Html$thead.f;
    var $elm$html$Html$tr = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "tr"), $elm$html$Html$tr_fn = $elm$html$Html$tr.f;
    var $elm$html$Html$ul = _VirtualDom_nodeNS_fn(_VirtualDom_node_a0, "ul"), $elm$html$Html$ul_fn = $elm$html$Html$ul.f;
    var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
        bK: $elm$html$Html$blockquote(_List_Nil),
        bP: function (_v0) {
            var body = _v0.bM;
            var language = _v0.dp;
            var classes = function () {
                var _v1 = $elm$core$Maybe$map_fn($elm$core$String$words, language);
                if ((!_v1.$) && _v1.a.b) {
                    var _v2 = _v1.a;
                    var actualLanguage = _v2.a;
                    return _List_fromArray([
                        $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "language-" + actualLanguage)
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }();
            return $elm$html$Html$pre_fn(_List_Nil, _List_fromArray([
                $elm$html$Html$code_fn(classes, _List_fromArray([
                    $elm$html$Html$text(body)
                ]))
            ]));
        },
        bQ: function (content) {
            return $elm$html$Html$code_fn(_List_Nil, _List_fromArray([
                $elm$html$Html$text(content)
            ]));
        },
        bT: function (children) {
            return $elm$html$Html$em_fn(_List_Nil, children);
        },
        bX: $elm$html$Html$br_fn(_List_Nil, _List_Nil),
        b0: function (_v3) {
            var level = _v3.ds;
            var children = _v3.P;
            switch (level) {
                case 0:
                    return $elm$html$Html$h1_fn(_List_Nil, children);
                case 1:
                    return $elm$html$Html$h2_fn(_List_Nil, children);
                case 2:
                    return $elm$html$Html$h3_fn(_List_Nil, children);
                case 3:
                    return $elm$html$Html$h4_fn(_List_Nil, children);
                case 4:
                    return $elm$html$Html$h5_fn(_List_Nil, children);
                default:
                    return $elm$html$Html$h6_fn(_List_Nil, children);
            }
        },
        b3: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
        b5: function (imageInfo) {
            var _v5 = imageInfo.bB;
            if (!_v5.$) {
                var title = _v5.a;
                return $elm$html$Html$img_fn(_List_fromArray([
                    $elm$html$Html$Attributes$src(imageInfo.cr),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$alt_a0, imageInfo.bI),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, title)
                ]), _List_Nil);
            }
            else {
                return $elm$html$Html$img_fn(_List_fromArray([
                    $elm$html$Html$Attributes$src(imageInfo.cr),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$alt_a0, imageInfo.bI)
                ]), _List_Nil);
            }
        },
        ca: F2(function (link, content) {
            var _v6 = link.bB;
            if (!_v6.$) {
                var title = _v6.a;
                return $elm$html$Html$a_fn(_List_fromArray([
                    $elm$html$Html$Attributes$href(link.eZ),
                    $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, title)
                ]), content);
            }
            else {
                return $elm$html$Html$a_fn(_List_fromArray([
                    $elm$html$Html$Attributes$href(link.eZ)
                ]), content);
            }
        }),
        cg: F2(function (startingIndex, items) {
            return $elm$html$Html$ol_fn(function () {
                if (startingIndex === 1) {
                    return _List_fromArray([
                        $elm$html$Html$Attributes$start(startingIndex)
                    ]);
                }
                else {
                    return _List_Nil;
                }
            }(), $elm$core$List$map_fn(function (itemBlocks) {
                return $elm$html$Html$li_fn(_List_Nil, itemBlocks);
            }, items));
        }),
        ch: $elm$html$Html$p(_List_Nil),
        ct: function (children) {
            return $elm$html$Html$strong_fn(_List_Nil, children);
        },
        cw: $elm$html$Html$table(_List_Nil),
        cx: $elm$html$Html$tbody(_List_Nil),
        cy: function (maybeAlignment) {
            var attrs = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($elm$html$Html$Attributes$align, $elm$core$Maybe$map_fn(function (alignment) {
                switch (alignment) {
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, maybeAlignment))));
            return $elm$html$Html$td(attrs);
        },
        cz: $elm$html$Html$thead(_List_Nil),
        cA: function (maybeAlignment) {
            var attrs = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$Maybe$map_fn($elm$core$List$singleton, $elm$core$Maybe$map_fn($elm$html$Html$Attributes$align, $elm$core$Maybe$map_fn(function (alignment) {
                switch (alignment) {
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, maybeAlignment))));
            return $elm$html$Html$th(attrs);
        },
        bz: $elm$html$Html$tr(_List_Nil),
        gk: $elm$html$Html$text,
        cD: $elm$html$Html$hr_fn(_List_Nil, _List_Nil),
        cG: function (items) {
            return $elm$html$Html$ul_fn(_List_Nil, $elm$core$List$map_fn(function (item) {
                var task = item.a;
                var children = item.b;
                var checkbox = function () {
                    switch (task) {
                        case 0:
                            return $elm$html$Html$text("");
                        case 1:
                            return $elm$html$Html$input_fn(_List_fromArray([
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true),
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, false),
                                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "checkbox")
                            ]), _List_Nil);
                        default:
                            return $elm$html$Html$input_fn(_List_fromArray([
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$disabled_a0, true),
                                $elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$checked_a0, true),
                                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$type__a0, "checkbox")
                            ]), _List_Nil);
                    }
                }();
                return $elm$html$Html$li_fn(_List_Nil, _List_Cons(checkbox, children));
            }, items));
        }
    };
    var $author$project$UI$Model$StartEditing = { $: 4 };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$EditOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$editOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$EditOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$editOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$editOutlined);
    };
    var $author$project$UI$RowView$editButton = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
        $author$project$UI$L10N$title({ e0: "Edit", fs: "Modifica" })
    ]), {
        R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$editOutlined($author$project$UI$Theme$darkIconAttrs)),
        W: $elm$core$Maybe$Just($author$project$UI$Model$StartEditing)
    });
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$EnterOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$enterOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$EnterOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$enterOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$enterOutlined);
    };
    var $author$project$UI$Model$CanvasId = $elm$core$Basics$identity;
    var $author$project$Expression$Value$complexToSymbolic = function (_v0) {
        var r = _v0.a;
        var i = _v0.b;
        return (!i) ? $author$project$Expression$Float(r) : ((!r) ? ((i === 1) ? $author$project$Expression$Variable("i") : $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
            $author$project$Expression$Float(i),
            $author$project$Expression$Variable("i")
        ]))) : $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
            $author$project$Expression$Float(r),
            $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                $author$project$Expression$Float(i),
                $author$project$Expression$Variable("i")
            ]))
        ])));
    };
    var $author$project$UI$Model$CopyCanvas = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$UI$Model$ExitFullscreenCanvas = function (a) {
        return { $: 10, a: a };
    };
    var $author$project$UI$Model$FullscreenCanvas = function (a) {
        return { $: 9, a: a };
    };
    var $author$project$UI$Model$ResetZoom = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$UI$Model$SaveCanvas = function (a) {
        return { $: 8, a: a };
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$AimOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z")
            ]), _List_Nil),
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$aimOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$AimOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$aimOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$aimOutlined);
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$behindContent_a0 = $mdgriffith$elm_ui$Element$behindContent, $miniBill$elm_ui_with_context$Element$WithContext$behindContent = $miniBill$elm_ui_with_context$Element$WithContext$createNearby($miniBill$elm_ui_with_context$Element$WithContext$behindContent_a0);
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$CopyOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$copyOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$CopyOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$copyOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$copyOutlined);
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$FullscreenExitOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$fullscreenExitOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$FullscreenExitOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$fullscreenExitOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$fullscreenExitOutlined);
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$FullscreenOutlined$viewWithAttributes = function (attributes) {
        return $elm$svg$Svg$svg_fn(_Utils_ap(_List_fromArray([
            _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$viewBox_a0, "64 64 896 896")
        ]), attributes), _List_fromArray([
            $elm$svg$Svg$path_fn(_List_fromArray([
                _VirtualDom_attribute_fn($elm$svg$Svg$Attributes$d_a0, "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z")
            ]), _List_Nil)
        ]));
    };
    var $lemol$ant_design_icons_elm$Ant$Icons$Svg$fullscreenOutlined = $lemol$ant_design_icons_elm$Ant$Icons$Svg$FullscreenOutlined$viewWithAttributes;
    var $lemol$ant_design_icons_elm_ui$Ant$Icons$fullscreenOutlined = function (attrs) {
        return $lemol$ant_design_icons_elm_ui$Ant$Icon$iconBase_fn($lemol$ant_design_icons_elm_ui$Ant$Icon$icon_a0, attrs, $lemol$ant_design_icons_elm$Ant$Icons$Svg$fullscreenOutlined);
    };
    var $author$project$UI$Glsl$IntervalAndStraight = 2;
    var $author$project$UI$Glsl$IntervalOnly = 0;
    var $author$project$UI$Glsl$StraightOnly = 1;
    var $author$project$UI$Glsl$Code$deindent = function (i) {
        var s = $elm$core$String$repeat_fn(i, " ");
        return A2($elm$core$Basics$composeR, $elm$core$String$split("\n"), A2($elm$core$Basics$composeR, $elm$core$List$map(function (l) {
            return _String_startsWith_fn(s, l) ? $elm$core$String$dropLeft_fn(i, l) : l;
        }), $elm$core$String$join("\n")));
    };
    var $author$project$UI$Glsl$Model$GlslAddition = 0;
    var $author$project$UI$Glsl$Model$GlslDivision = 3;
    var $author$project$UI$Glsl$Model$GlslMultiplication = 1;
    var $author$project$UI$Glsl$Model$GlslNegation = 2;
    var $author$project$UI$Glsl$Model$GlslPower = 4;
    var $author$project$UI$Glsl$Model$GlslRelations = 5;
    var $author$project$UI$Glsl$RequireFunction = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$UI$Glsl$RequireOperation = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$UI$Glsl$Model$Square22 = 28;
    var $author$project$UI$Glsl$Model$Abs22 = 0;
    var $author$project$UI$Glsl$Model$Acos22 = 1;
    var $author$project$UI$Glsl$Model$Arg22 = 2;
    var $author$project$UI$Glsl$Model$Asin22 = 3;
    var $author$project$UI$Glsl$Model$Atan22 = 4;
    var $author$project$UI$Glsl$Model$Atan222 = 5;
    var $author$project$UI$Glsl$Model$Cbrt22 = 27;
    var $author$project$UI$Glsl$Model$Ceiling22 = 6;
    var $author$project$UI$Glsl$Model$Cos22 = 7;
    var $author$project$UI$Glsl$Model$Cosh22 = 9;
    var $author$project$UI$Glsl$Model$Exp22 = 10;
    var $author$project$UI$Glsl$Model$Floor22 = 11;
    var $author$project$UI$Glsl$Model$Im22 = 12;
    var $author$project$UI$Glsl$Model$Ln22 = 13;
    var $author$project$UI$Glsl$Model$Log1022 = 14;
    var $author$project$UI$Glsl$Model$Max222 = 15;
    var $author$project$UI$Glsl$Model$Mbrot22 = 18;
    var $author$project$UI$Glsl$Model$Min222 = 16;
    var $author$project$UI$Glsl$Model$Mod22 = 17;
    var $author$project$UI$Glsl$Model$Pw22 = 19;
    var $author$project$UI$Glsl$Model$Re22 = 20;
    var $author$project$UI$Glsl$Model$Round22 = 21;
    var $author$project$UI$Glsl$Model$Sign22 = 22;
    var $author$project$UI$Glsl$Model$Sin22 = 23;
    var $author$project$UI$Glsl$Model$Sinh22 = 25;
    var $author$project$UI$Glsl$Model$Sqrt22 = 26;
    var $author$project$UI$Glsl$Model$Tan22 = 29;
    var $author$project$UI$Glsl$Model$Tanh22 = 31;
    var $author$project$UI$Glsl$toGlslFunction = function (name) {
        switch (name.$) {
            case 0:
                return $elm$core$Maybe$Just(23);
            case 1:
                return $elm$core$Maybe$Just(7);
            case 2:
                return $elm$core$Maybe$Just(29);
            case 3:
                return $elm$core$Maybe$Just(3);
            case 4:
                return $elm$core$Maybe$Just(1);
            case 5:
                return $elm$core$Maybe$Just(4);
            case 6:
                return $elm$core$Maybe$Just(5);
            case 7:
                return $elm$core$Maybe$Just(25);
            case 8:
                return $elm$core$Maybe$Just(9);
            case 9:
                return $elm$core$Maybe$Just(31);
            case 10:
                return $elm$core$Maybe$Just(0);
            case 15:
                return $elm$core$Maybe$Just(22);
            case 11:
                switch (name.a) {
                    case 2:
                        return $elm$core$Maybe$Just(26);
                    case 3:
                        return $elm$core$Maybe$Just(27);
                    default:
                        return $elm$core$Maybe$Nothing;
                }
            case 12:
                return $elm$core$Maybe$Just(13);
            case 13:
                return $elm$core$Maybe$Just(14);
            case 14:
                return $elm$core$Maybe$Just(10);
            case 16:
                return $elm$core$Maybe$Just(20);
            case 17:
                return $elm$core$Maybe$Just(12);
            case 18:
                return $elm$core$Maybe$Just(2);
            case 19:
                return $elm$core$Maybe$Nothing;
            case 28:
                return $elm$core$Maybe$Just(19);
            case 26:
                return $elm$core$Maybe$Just(11);
            case 27:
                return $elm$core$Maybe$Just(6);
            case 25:
                return $elm$core$Maybe$Just(21);
            case 23:
                return $elm$core$Maybe$Just(16);
            case 24:
                return $elm$core$Maybe$Just(15);
            case 34:
                return $elm$core$Maybe$Just(17);
            case 20:
                return $elm$core$Maybe$Nothing;
            case 21:
                return $elm$core$Maybe$Nothing;
            case 22:
                return $elm$core$Maybe$Nothing;
            case 29:
                return $elm$core$Maybe$Nothing;
            case 30:
                return $elm$core$Maybe$Nothing;
            case 31:
                return $elm$core$Maybe$Nothing;
            case 32:
                return $elm$core$Maybe$Nothing;
            case 33:
                return $elm$core$Maybe$Nothing;
            case 35:
                return $elm$core$Maybe$Just(18);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$core$Dict$values = function (dict) {
        return $elm$core$Dict$foldr_fn_unwrapped(function (key, value, valueList) {
            return _List_Cons(value, valueList);
        }, _List_Nil, dict);
    };
    var $author$project$UI$Glsl$expressionToRequirements = function (e) {
        expressionToRequirements: while (true) {
            _v0$9: while (true) {
                switch (e.$) {
                    case 8:
                        if (!e.a.$) {
                            var n = e.a.a;
                            var args = e.b;
                            var _v1 = $author$project$UI$Glsl$toGlslFunction(n);
                            if (!_v1.$) {
                                var gf = _v1.a;
                                return _List_Cons($author$project$UI$Glsl$RequireFunction(gf), $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, args));
                            }
                            else {
                                return $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, args);
                            }
                        }
                        else {
                            var args = e.b;
                            return $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, args);
                        }
                    case 0:
                        return _List_Nil;
                    case 1:
                        return _List_Nil;
                    case 2:
                        return _List_Nil;
                    case 4:
                        var c = e.b;
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(2), $author$project$UI$Glsl$expressionToRequirements(c));
                    case 5:
                        if (e.a === 1) {
                            switch (e.c.$) {
                                case 0:
                                    if (e.b.$ === 2) {
                                        var _v2 = e.a;
                                        var v = e.b.a;
                                        return (v === "i") ? _List_fromArray([
                                            $author$project$UI$Glsl$RequireOperation(4)
                                        ]) : _List_fromArray([
                                            $author$project$UI$Glsl$RequireOperation(4),
                                            $author$project$UI$Glsl$RequireOperation(1),
                                            $author$project$UI$Glsl$RequireFunction(28)
                                        ]);
                                    }
                                    else {
                                        var _v3 = e.a;
                                        var b = e.b;
                                        return _Utils_ap(_List_fromArray([
                                            $author$project$UI$Glsl$RequireOperation(4),
                                            $author$project$UI$Glsl$RequireOperation(1),
                                            $author$project$UI$Glsl$RequireFunction(28)
                                        ]), $author$project$UI$Glsl$expressionToRequirements(b));
                                    }
                                case 1:
                                    var _v4 = e.a;
                                    var b = e.b;
                                    return _Utils_ap(_List_fromArray([
                                        $author$project$UI$Glsl$RequireOperation(4),
                                        $author$project$UI$Glsl$RequireOperation(1),
                                        $author$project$UI$Glsl$RequireFunction(28)
                                    ]), $author$project$UI$Glsl$expressionToRequirements(b));
                                default:
                                    break _v0$9;
                            }
                        }
                        else {
                            break _v0$9;
                        }
                    case 6:
                        var l = e.b;
                        var r = e.c;
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(5), $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, _List_fromArray([l, r])));
                    case 7:
                        var op = e.a;
                        var l = e.b;
                        var m = e.c;
                        var r = e.d;
                        var op_ = function () {
                            if (!op) {
                                return 0;
                            }
                            else {
                                return 1;
                            }
                        }();
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(op_), $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, _List_Cons(l, _List_Cons(m, r))));
                    case 9:
                        var ctx = e.a;
                        var c = e.b;
                        return $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, _List_Cons(c, $elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$Dict$values(ctx))));
                    case 10:
                        var args = e.a;
                        return $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, args);
                    default:
                        var f = e.b;
                        var $temp$e = f;
                        e = $temp$e;
                        continue expressionToRequirements;
                }
            }
            var op = e.a;
            var l = e.b;
            var r = e.c;
            var op_ = function () {
                if (op === 1) {
                    return 4;
                }
                else {
                    return 3;
                }
            }();
            return _List_Cons($author$project$UI$Glsl$RequireOperation(op_), $elm$core$List$concatMap_fn($author$project$UI$Glsl$expressionToRequirements, _List_fromArray([l, r])));
        }
    };
    var $author$project$UI$Glsl$Plane$Plane = $elm$core$Basics$identity;
    var $author$project$Expression$Utils$isOne = function (expr) {
        switch (expr.$) {
            case 0:
                var _int = expr.a;
                return _int === 1;
            case 1:
                var _float = expr.a;
                return _float === 1;
            default:
                return false;
        }
    };
    var $author$project$Expression$Utils$isZero = function (expr) {
        switch (expr.$) {
            case 0:
                var _int = expr.a;
                return !_int;
            case 1:
                var _float = expr.a;
                return !_float;
            default:
                return false;
        }
    };
    var $author$project$Expression$Utils$byShort = function (exprs) {
        return $elm$core$List$any_fn($author$project$Expression$Utils$isZero, exprs) ? $author$project$Expression$Utils$zero : $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, $elm_community$list_extra$List$Extra$filterNot_fn($author$project$Expression$Utils$isOne, exprs));
    };
    var $elm_community$list_extra$List$Extra$andThen = $elm$core$List$concatMap;
    var $elm_community$list_extra$List$Extra$lift2_fn = function (f, la, lb) {
        return $elm$core$List$concatMap_fn(function (a) {
            return $elm$core$List$concatMap_fn(function (b) {
                return _List_fromArray([
                    A2(f, a, b)
                ]);
            }, lb);
        }, la);
    }, $elm_community$list_extra$List$Extra$lift2_fn_unwrapped = function (f, la, lb) {
        return $elm$core$List$concatMap_fn(function (a) {
            return $elm$core$List$concatMap_fn(function (b) {
                return _List_fromArray([
                    f(a, b)
                ]);
            }, lb);
        }, la);
    }, $elm_community$list_extra$List$Extra$lift2 = F3($elm_community$list_extra$List$Extra$lift2_fn);
    var $elm_community$list_extra$List$Extra$cartesianProduct = function (ll) {
        if (!ll.b) {
            return _List_fromArray([_List_Nil]);
        }
        else {
            var xs = ll.a;
            var xss = ll.b;
            return $elm_community$list_extra$List$Extra$lift2_fn($elm$core$List$cons, xs, $elm_community$list_extra$List$Extra$cartesianProduct(xss));
        }
    };
    var $author$project$Expression$Utils$plusShort = function (exprs) {
        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm_community$list_extra$List$Extra$filterNot_fn($author$project$Expression$Utils$isZero, exprs));
    };
    var $elm$core$List$sortBy = _List_sortBy;
    var $elm$core$List$sort = function (xs) {
        return _List_sortBy_fn($elm$core$Basics$identity, xs);
    };
    var $author$project$Expression$Polynomial$by_fn = function (l, r) {
        return $elm$core$List$foldr_fn(function (_v7) {
            var k = _v7.a;
            var v = _v7.b;
            return A2($elm$core$Dict$update, k, A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault($author$project$Expression$Integer(0)), A2($elm$core$Basics$composeR, function (w) {
                return $author$project$Expression$Utils$plusShort(_List_fromArray([v, w]));
            }, $elm$core$Maybe$Just)));
        }, $elm$core$Dict$empty, $elm$core$List$map_fn(function (_v2) {
            var _v3 = _v2.a;
            var les = _v3.a;
            var lc = _v3.b;
            var _v4 = _v2.b;
            var res = _v4.a;
            var rc = _v4.b;
            return _Utils_Tuple2($author$project$List$MyExtra$groupOneWith_fn_unwrapped(function (_v5, _v6) {
                var ln = _v5.a;
                var le = _v5.b;
                var rn = _v6.a;
                var re = _v6.b;
                return _Utils_eq(ln, rn) ? $elm$core$Maybe$Just(_Utils_Tuple2(ln, le + re)) : $elm$core$Maybe$Nothing;
            }, $elm$core$List$sort(_Utils_ap(les, res))), $author$project$Expression$Utils$byShort(_List_fromArray([lc, rc])));
        }, $elm$core$List$filterMap_fn(function (p) {
            if ((p.b && p.b.b) && (!p.b.b.b)) {
                var v = p.a;
                var _v1 = p.b;
                var w = _v1.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2(v, w));
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }, $elm_community$list_extra$List$Extra$cartesianProduct(_List_fromArray([
            $elm$core$Dict$toList(l),
            $elm$core$Dict$toList(r)
        ])))));
    }, $author$project$Expression$Polynomial$by = F2($author$project$Expression$Polynomial$by_fn);
    var $elm$core$List$member_fn = function (x, xs) {
        return $elm$core$List$any_fn(function (a) {
            return _Utils_eq(a, x);
        }, xs);
    }, $elm$core$List$member = F2($elm$core$List$member_fn);
    var $author$project$Expression$Utils$negateShort = function (expr) {
        switch (expr.$) {
            case 0:
                var _int = expr.a;
                return $author$project$Expression$Integer(-_int);
            case 1:
                var _float = expr.a;
                return $author$project$Expression$Float(-_float);
            case 4:
                var _v1 = expr.a;
                var child = expr.b;
                return child;
            default:
                return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, expr);
        }
    };
    var $author$project$Expression$Polynomial$negate__a0 = $elm$core$Basics$always($author$project$Expression$Utils$negateShort), $author$project$Expression$Polynomial$negate_ = $elm$core$Dict$map($author$project$Expression$Polynomial$negate__a0);
    var $elm$core$Dict$singleton_fn = function (key, value) {
        return $elm$core$Dict$RBNode_elm_builtin_fn(1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    }, $elm$core$Dict$singleton = F2($elm$core$Dict$singleton_fn);
    var $author$project$Expression$Polynomial$pow_fn = function (e, p) {
        return (e < 0) ? $elm$core$Maybe$Nothing : ((!e) ? $elm$core$Maybe$Just($elm$core$Dict$singleton_fn(_List_Nil, $author$project$Expression$Integer(1))) : ((e === 1) ? $elm$core$Maybe$Just(p) : $elm$core$Maybe$map_fn($author$project$Expression$Polynomial$by(p), $author$project$Expression$Polynomial$pow_fn(e - 1, p))));
    }, $author$project$Expression$Polynomial$pow = F2($author$project$Expression$Polynomial$pow_fn);
    var $author$project$Expression$Polynomial$sum_fn = function (l, r) {
        var go = F3(function (ll, rl, acc) {
            go: while (true) {
                var _v0 = _Utils_Tuple2(ll, rl);
                if (!_v0.a.b) {
                    return _Utils_ap(rl, acc);
                }
                else {
                    if (!_v0.b.b) {
                        return _Utils_ap(ll, acc);
                    }
                    else {
                        var _v1 = _v0.a;
                        var lh = _v1.a;
                        var ln = lh.a;
                        var lc = lh.b;
                        var lt = _v1.b;
                        var _v2 = _v0.b;
                        var rh = _v2.a;
                        var rn = rh.a;
                        var rc = rh.b;
                        var rt = _v2.b;
                        if (_Utils_eq(ln, rn)) {
                            var $temp$ll = lt, $temp$rl = rl, $temp$acc = _List_Cons(_Utils_Tuple2(ln, $author$project$Expression$Utils$plusShort(_List_fromArray([lc, rc]))), acc);
                            ll = $temp$ll;
                            rl = $temp$rl;
                            acc = $temp$acc;
                            continue go;
                        }
                        else {
                            if (_Utils_cmp(ln, rn) < 0) {
                                var $temp$ll = lt, $temp$rl = rl, $temp$acc = _List_Cons(lh, acc);
                                ll = $temp$ll;
                                rl = $temp$rl;
                                acc = $temp$acc;
                                continue go;
                            }
                            else {
                                var $temp$ll = ll, $temp$rl = rt, $temp$acc = _List_Cons(rh, acc);
                                ll = $temp$ll;
                                rl = $temp$rl;
                                acc = $temp$acc;
                                continue go;
                            }
                        }
                    }
                }
            }
        });
        return $elm$core$Dict$fromList(A3(go, $elm$core$Dict$toList(l), $elm$core$Dict$toList(r), _List_Nil));
    }, $author$project$Expression$Polynomial$sum = F2($author$project$Expression$Polynomial$sum_fn);
    var $elm$core$Maybe$map2_fn = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(A2(func, a, b));
            }
        }
    }, $elm$core$Maybe$map2_fn_unwrapped = function (func, ma, mb) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(func(a, b));
            }
        }
    }, $elm$core$Maybe$map2 = F3($elm$core$Maybe$map2_fn);
    var $elm_community$maybe_extra$Maybe$Extra$traverse = function (f) {
        return A2($elm$core$List$foldr, function (x) {
            return A2($elm$core$Maybe$map2, $elm$core$List$cons, f(x));
        }, $elm$core$Maybe$Just(_List_Nil));
    };
    var $author$project$Expression$Polynomial$asPolynomial_fn = function (vars, e) {
        var res = function () {
            _v0$8: while (true) {
                switch (e.$) {
                    case 0:
                        return $elm$core$Maybe$Just($elm$core$Dict$singleton_fn(_List_Nil, e));
                    case 1:
                        return $elm$core$Maybe$Just($elm$core$Dict$singleton_fn(_List_Nil, e));
                    case 2:
                        var v = e.a;
                        return $elm$core$List$member_fn(v, vars) ? $elm$core$Maybe$Just($elm$core$Dict$singleton_fn(_List_fromArray([
                            _Utils_Tuple2(v, 1)
                        ]), $author$project$Expression$Utils$one)) : $elm$core$Maybe$Just($elm$core$Dict$singleton_fn(_List_Nil, e));
                    case 4:
                        var _v1 = e.a;
                        var c = e.b;
                        return $elm$core$Maybe$map_fn($author$project$Expression$Polynomial$negate_, $author$project$Expression$Polynomial$asPolynomial_fn(vars, c));
                    case 7:
                        if (!e.a) {
                            var _v2 = e.a;
                            var l = e.b;
                            var m = e.c;
                            var r = e.d;
                            return $elm$core$Maybe$map_fn(A2($elm$core$List$foldr, $author$project$Expression$Polynomial$sum, $elm$core$Dict$empty), A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$Expression$Polynomial$asPolynomial(vars), _List_Cons(l, _List_Cons(m, r))));
                        }
                        else {
                            var _v3 = e.a;
                            var l = e.b;
                            var m = e.c;
                            var r = e.d;
                            return $elm$core$Maybe$map_fn(A2($elm$core$List$foldr, $author$project$Expression$Polynomial$by, $elm$core$Dict$singleton_fn(_List_Nil, $author$project$Expression$Integer(1))), A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$Expression$Polynomial$asPolynomial(vars), _List_Cons(l, _List_Cons(m, r))));
                        }
                    case 5:
                        if (e.a === 1) {
                            if (!e.c.$) {
                                var _v4 = e.a;
                                var b = e.b;
                                var i = e.c.a;
                                return $elm$core$Maybe$andThen_fn($author$project$Expression$Polynomial$pow(i), $author$project$Expression$Polynomial$asPolynomial_fn(vars, b));
                            }
                            else {
                                break _v0$8;
                            }
                        }
                        else {
                            var _v5 = e.a;
                            var n = e.b;
                            var d = e.c;
                            var polyD = $elm$core$Maybe$map_fn($elm$core$Dict$toList, $author$project$Expression$Polynomial$asPolynomial_fn(vars, d));
                            if ((((!polyD.$) && polyD.a.b) && (!polyD.a.a.a.b)) && (!polyD.a.b.b)) {
                                var _v7 = polyD.a;
                                var _v8 = _v7.a;
                                var z = _v8.b;
                                return $elm$core$Maybe$map_fn($elm$core$Dict$map(F2(function (_v9, k) {
                                    return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, k, z);
                                })), $author$project$Expression$Polynomial$asPolynomial_fn(vars, n));
                            }
                            else {
                                return $elm$core$Maybe$Nothing;
                            }
                        }
                    default:
                        break _v0$8;
                }
            }
            return $elm$core$Maybe$Nothing;
        }();
        return res;
    }, $author$project$Expression$Polynomial$asPolynomial = F2($author$project$Expression$Polynomial$asPolynomial_fn);
    var $elm$core$Basics$pow = _Basics_pow;
    var $elm$core$List$product = function (numbers) {
        return $elm$core$List$foldl_fn($elm$core$Basics$mul, 1, numbers);
    };
    var $elm$core$List$sum = function (numbers) {
        return $elm$core$List$foldl_fn($elm$core$Basics$add, 0, numbers);
    };
    var $author$project$UI$Glsl$Polynomial$toFloat = function (e) {
        switch (e.$) {
            case 0:
                var i = e.a;
                return $elm$core$Maybe$Just(i);
            case 1:
                var f = e.a;
                return $elm$core$Maybe$Just(f);
            case 7:
                if (!e.a) {
                    var _v1 = e.a;
                    var l = e.b;
                    var m = e.c;
                    var r = e.d;
                    return $elm$core$Maybe$map_fn($elm$core$List$sum, A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$UI$Glsl$Polynomial$toFloat, _List_Cons(l, _List_Cons(m, r))));
                }
                else {
                    var _v2 = e.a;
                    var l = e.b;
                    var m = e.c;
                    var r = e.d;
                    return $elm$core$Maybe$map_fn($elm$core$List$product, A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$UI$Glsl$Polynomial$toFloat, _List_Cons(l, _List_Cons(m, r))));
                }
            case 4:
                var _v3 = e.a;
                var c = e.b;
                return $elm$core$Maybe$map_fn($elm$core$Basics$negate, $author$project$UI$Glsl$Polynomial$toFloat(c));
            case 5:
                if (!e.a) {
                    var _v4 = e.a;
                    var n = e.b;
                    var d = e.c;
                    return $elm$core$Maybe$map2_fn($elm$core$Basics$fdiv, $author$project$UI$Glsl$Polynomial$toFloat(n), $author$project$UI$Glsl$Polynomial$toFloat(d));
                }
                else {
                    var _v5 = e.a;
                    var b = e.b;
                    var ex = e.c;
                    return $elm$core$Maybe$map2_fn($elm$core$Basics$pow, $author$project$UI$Glsl$Polynomial$toFloat(b), $author$project$UI$Glsl$Polynomial$toFloat(ex));
                }
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$UI$Glsl$Polynomial$asPolynomial_fn = function (vars, e) {
        asPolynomial: while (true) {
            if ((e.$ === 6) && (e.a === 2)) {
                var _v1 = e.a;
                var l = e.b;
                var r = e.c;
                var $temp$vars = vars, $temp$e = $author$project$Expression$Utils$minus_fn(l, r);
                vars = $temp$vars;
                e = $temp$e;
                continue asPolynomial;
            }
            else {
                return $elm$core$Maybe$map_fn($elm$core$Dict$fromList, $elm$core$Maybe$andThen_fn($elm_community$maybe_extra$Maybe$Extra$traverse(function (_v2) {
                    var k = _v2.a;
                    var v = _v2.b;
                    return $elm$core$Maybe$map_fn($elm$core$Tuple$pair(k), $author$project$UI$Glsl$Polynomial$toFloat(v));
                }), $elm$core$Maybe$map_fn($elm$core$Dict$toList, $author$project$Expression$Polynomial$asPolynomial_fn(vars, e))));
            }
        }
    }, $author$project$UI$Glsl$Polynomial$asPolynomial = F2($author$project$UI$Glsl$Polynomial$asPolynomial_fn);
    var $author$project$UI$Glsl$Polynomial$getDegree = function (poly) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$List$maximum($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$Tuple$second), $elm$core$List$sum)), $elm$core$Dict$toList(poly))));
    };
    var $author$project$UI$Glsl$Plane$asPlane = function (e) {
        return $elm$core$Maybe$andThen_fn(function (poly) {
            if ($author$project$UI$Glsl$Polynomial$getDegree(poly) !== 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var get = function (k) {
                    return $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(k, poly));
                };
                return $elm$core$Maybe$Just({
                    dn: get(_List_Nil),
                    ef: get(_List_fromArray([
                        _Utils_Tuple2("x", 1)
                    ])),
                    eg: get(_List_fromArray([
                        _Utils_Tuple2("y", 1)
                    ])),
                    ei: get(_List_fromArray([
                        _Utils_Tuple2("z", 1)
                    ]))
                });
            }
        }, $author$project$UI$Glsl$Polynomial$asPolynomial_fn(_List_fromArray(["x", "y", "z"]), e));
    };
    var $author$project$UI$Glsl$Sphere$Sphere = $elm$core$Basics$identity;
    var $elm$core$Maybe$map3_fn = function (func, ma, mb, mc) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                if (mc.$ === 1) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var c = mc.a;
                    return $elm$core$Maybe$Just(A3(func, a, b, c));
                }
            }
        }
    }, $elm$core$Maybe$map3_fn_unwrapped = function (func, ma, mb, mc) {
        if (ma.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var a = ma.a;
            if (mb.$ === 1) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var b = mb.a;
                if (mc.$ === 1) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var c = mc.a;
                    return $elm$core$Maybe$Just(func(a, b, c));
                }
            }
        }
    }, $elm$core$Maybe$map3 = F4($elm$core$Maybe$map3_fn);
    var $author$project$UI$Glsl$Sphere$reduce = function (poly) {
        return $elm$core$Maybe$andThen_fn(function (c) {
            return (!c) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$Dict$map_fn_unwrapped(function (_v0, v) {
                return v / c;
            }, poly));
        }, $elm$core$Dict$get_fn(_List_fromArray([
            _Utils_Tuple2("x", 2)
        ]), poly));
    };
    var $elm$core$Basics$sqrt = _Basics_sqrt;
    var $author$project$UI$Glsl$Sphere$asSphere = function (e) {
        return $elm$core$Maybe$andThen_fn(function (poly) {
            if ($author$project$UI$Glsl$Polynomial$getDegree(poly) !== 2) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var getCenter = function (v) {
                    var _v0 = _Utils_Tuple2($elm$core$Dict$get_fn(_List_fromArray([
                        _Utils_Tuple2(v, 2)
                    ]), poly), $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(_List_fromArray([
                        _Utils_Tuple2(v, 1)
                    ]), poly)));
                    if (!_v0.a.$) {
                        var s = _v0.a.a;
                        var l = _v0.b;
                        return (s !== 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just((-l) / 2);
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                };
                return $elm$core$Maybe$map3_fn_unwrapped(function (x, y, z) {
                    return {
                        cU: { ef: x, eg: y, ei: z },
                        dI: $elm$core$Basics$sqrt($elm$core$Basics$max_fn(0, (((x * x) + (y * y)) + (z * z)) - $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(_List_Nil, poly))))
                    };
                }, getCenter("x"), getCenter("y"), getCenter("z"));
            }
        }, $elm$core$Maybe$andThen_fn($author$project$UI$Glsl$Sphere$reduce, $author$project$UI$Glsl$Polynomial$asPolynomial_fn(_List_fromArray(["x", "y", "z"]), e)));
    };
    var $author$project$UI$Glsl$Code$threshold = "0.000001 * max_distance";
    var $author$project$UI$Glsl$Code$suffixToBisect = function (suffix) {
        return "\n            bool bisect" + (suffix + ("(vec3 o, mat3 d, float max_distance, out vec3 found) {\n                mat3 from = mat3(o, o, vec3(0));\n                mat3 to = from + max_distance * d;\n                float ithreshold = " + ($author$project$UI$Glsl$Code$threshold + (";\n                int depth = 0;\n                int choices = 0;\n                for(int it = 0; it < MAX_ITERATIONS; it++) {\n                    mat3 midpoint = 0.5 * (from + to);\n                    vec2 front = interval" + (suffix + ("(from, midpoint);\n                    vec2 back = interval" + (suffix + ("(midpoint, to);\n                    if(depth >= MAX_DEPTH\n                        || (front.y - front.x < ithreshold && front.x <= 0.0 && front.y >= 0.0)\n                        || (back.y - back.x < ithreshold && back.x <= 0.0 && back.y >= 0.0)\n                        ) {\n                            found = mix(midpoint[0], midpoint[1], 0.5);\n                            return true;\n                        }\n                    if(front.x <= 0.0 && front.y >= 0.0) {\n                        to = midpoint;\n                        depth++;\n                        choices = left_shift(choices);\n                    } else if(back.x <= 0.0 && back.y >= 0.0) {\n                        from = midpoint;\n                        depth++;\n                        choices = left_shift_increment(choices);\n                    } else {\n                        // This could be possibly helped by https://graphics.stanford.edu/~seander/bithacks.html#ZerosOnRightBinSearch\n                        for(int j = MAX_DEPTH - 1; j > 0; j--) {\n                            if(j > depth)\n                                continue;\n                            depth--;\n                            choices = right_shift(choices);\n                            if(is_even(choices)) {\n                                midpoint = to;\n                                to = to + (to - from);\n                                vec2 back = interval" + (suffix + "(midpoint, to);\n                                if(back.x <= 0.0 && back.y >= 0.0) {\n                                    from = midpoint;\n                                    depth++;\n                                    choices = left_shift_increment(choices);\n                                    break;\n                                }\n                            } else {\n                                from = from - (to - from);\n                            }\n                        }\n                        if(depth == 0)\n                            return false;\n                    }\n                }\n                return false;\n            }\n    ")))))))));
    };
    var $author$project$UI$Glsl$Generator$indent_fn = function (i, line) {
        return _Utils_ap($elm$core$String$repeat_fn(4 * i, " "), line);
    }, $author$project$UI$Glsl$Generator$indent = F2($author$project$UI$Glsl$Generator$indent_fn);
    var $author$project$UI$Glsl$Generator$toGlsl = function () {
        var go = F2(function (i, c) {
            if (!c.$) {
                var h = c.a;
                var b = c.b;
                return $author$project$UI$Glsl$Generator$indent_fn(i, h) + ("{\n" + ($elm$core$String$join_fn("\n", $elm$core$List$map_fn(go(i + 1), b)) + "\n}"));
            }
            else {
                var l = c.a;
                return $author$project$UI$Glsl$Generator$indent_fn(i, l) + ";";
            }
        });
        return go(0);
    }();
    var $author$project$UI$Glsl$Code$floatToGlsl = function (f) {
        var s = $elm$core$String$fromFloat(f);
        return (_String_contains_fn(".", s) || _String_contains_fn("e", s)) ? s : (s + ".0");
    };
    var $author$project$UI$Glsl$Plane$toGlsl_fn = function (suffix, _v0) {
        var x = _v0.ef;
        var y = _v0.eg;
        var z = _v0.ei;
        var known = _v0.dn;
        return "\n    bool bisect" + (suffix + ("(vec3 o, mat3 d, float max_distance, out vec3 found) {\n        vec3 coeffs = vec3(" + ($author$project$UI$Glsl$Code$floatToGlsl(x) + ("," + ($author$project$UI$Glsl$Code$floatToGlsl(y) + ("," + ($author$project$UI$Glsl$Code$floatToGlsl(z) + (");\n        float t = -(" + ($author$project$UI$Glsl$Code$floatToGlsl(known) + (" + dot(coeffs, o)) / dot(coeffs, 0.5 * (d[0] + d[1]));\n        found = o + t * 0.5 * (d[0] + d[1]);\n        return t > " + ($author$project$UI$Glsl$Code$threshold + ";\n    }\n    ")))))))))));
    }, $author$project$UI$Glsl$Plane$toGlsl = F2($author$project$UI$Glsl$Plane$toGlsl_fn);
    var $author$project$UI$Glsl$Sphere$toGlsl_fn = function (suffix, _v0) {
        var center = _v0.cU;
        var radius = _v0.dI;
        return "\n    bool bisect" + (suffix + ("(vec3 o, mat3 d, float max_distance, out vec3 found) {\n        vec3 center = vec3(" + ($author$project$UI$Glsl$Code$floatToGlsl(center.ef) + ("," + ($author$project$UI$Glsl$Code$floatToGlsl(center.eg) + ("," + ($author$project$UI$Glsl$Code$floatToGlsl(center.ei) + (");\n\n        vec3 to_center = o - center;\n        float b = dot(to_center, mix(d[0], d[1], 0.5));\n        float c = dot(to_center, to_center) - " + ($author$project$UI$Glsl$Code$floatToGlsl(radius * radius) + (";\n        float delta = b*b - c;\n        if(delta < 0.0)\n            return false;\n        float x = -b - sqrt(delta);\n        if(x < " + ($author$project$UI$Glsl$Code$threshold + ")\n            return false;\n        found = o + x * mix(d[0], d[1], 0.5);\n        return true;\n    }\n    ")))))))))));
    }, $author$project$UI$Glsl$Sphere$toGlsl = F2($author$project$UI$Glsl$Sphere$toGlsl_fn);
    var $author$project$UI$Glsl$Generator$call_fn = function (fname, args) {
        return fname + ("(" + ($elm$core$String$join_fn(", ", args) + ")"));
    }, $author$project$UI$Glsl$Generator$call = F2($author$project$UI$Glsl$Generator$call_fn);
    var $author$project$UI$Glsl$Generator$Line = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$UI$Glsl$Generator$decl_fn = function (_v0, name, value) {
        var type_ = _v0;
        return $author$project$UI$Glsl$Generator$Line(type_ + (" " + (name + (" = " + value))));
    }, $author$project$UI$Glsl$Generator$decl = F3($author$project$UI$Glsl$Generator$decl_fn);
    var $author$project$Expression$PFloat = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$functionNameToString = function (name) {
        if (!name.$) {
            switch (name.a.$) {
                case 0:
                    var _v1 = name.a;
                    return "sin";
                case 1:
                    var _v2 = name.a;
                    return "cos";
                case 2:
                    var _v3 = name.a;
                    return "tan";
                case 3:
                    var _v4 = name.a;
                    return "asin";
                case 4:
                    var _v5 = name.a;
                    return "acos";
                case 5:
                    var _v6 = name.a;
                    return "atan";
                case 6:
                    var _v7 = name.a;
                    return "atan2";
                case 7:
                    var _v8 = name.a;
                    return "sinh";
                case 8:
                    var _v9 = name.a;
                    return "cosh";
                case 9:
                    var _v10 = name.a;
                    return "tanh";
                case 10:
                    var _v11 = name.a;
                    return "abs";
                case 15:
                    var _v12 = name.a;
                    return "sign";
                case 11:
                    switch (name.a.a) {
                        case 2:
                            return "sqrt";
                        case 3:
                            return "cbrt";
                        default:
                            var n = name.a.a;
                            return "root" + $elm$core$String$fromInt(n);
                    }
                case 12:
                    var _v13 = name.a;
                    return "ln";
                case 13:
                    var _v14 = name.a;
                    return "log10";
                case 20:
                    var _v15 = name.a;
                    return "det";
                case 14:
                    var _v16 = name.a;
                    return "exp";
                case 16:
                    var _v17 = name.a;
                    return "re";
                case 17:
                    var _v18 = name.a;
                    return "im";
                case 18:
                    var _v19 = name.a;
                    return "arg";
                case 19:
                    var _v20 = name.a;
                    return "gra";
                case 21:
                    var _v21 = name.a;
                    return "dd";
                case 22:
                    var _v22 = name.a;
                    return "ii";
                case 28:
                    var _v23 = name.a;
                    return "pw";
                case 29:
                    var _v24 = name.a;
                    return "plot";
                case 30:
                    var _v25 = name.a;
                    return "aplot";
                case 31:
                    var _v26 = name.a;
                    return "simplify";
                case 32:
                    var _v27 = name.a;
                    return "stepsimplify";
                case 33:
                    var _v28 = name.a;
                    return "solve";
                case 26:
                    var _v29 = name.a;
                    return "floor";
                case 27:
                    var _v30 = name.a;
                    return "ceiling";
                case 25:
                    var _v31 = name.a;
                    return "round";
                case 23:
                    var _v32 = name.a;
                    return "min";
                case 24:
                    var _v33 = name.a;
                    return "max";
                case 34:
                    var _v34 = name.a;
                    return "mod";
                case 35:
                    var _v35 = name.a;
                    return "mbrot";
                default:
                    var _v36 = name.a;
                    return "for";
            }
        }
        else {
            var u = name.a;
            return u;
        }
    };
    var $author$project$UI$Glsl$Code$paren_fn = function (b, c) {
        return b ? ("(" + (c + ")")) : c;
    }, $author$project$UI$Glsl$Code$paren = F2($author$project$UI$Glsl$Code$paren_fn);
    var $author$project$Expression$PReplace_fn = function (a, b) {
        return { $: 10, a: a, b: b };
    }, $author$project$Expression$PReplace = F2($author$project$Expression$PReplace_fn);
    var $elm$core$Dict$filter_fn = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return A2(isGood, k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter_fn_unwrapped = function (isGood, dict) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, d) {
            return isGood(k, v) ? $elm$core$Dict$insert_fn(k, v, d) : d;
        }, $elm$core$Dict$empty, dict);
    }, $elm$core$Dict$filter = F2($elm$core$Dict$filter_fn);
    var $elm$core$Dict$isEmpty = function (dict) {
        if (dict.$ === -2) {
            return true;
        }
        else {
            return false;
        }
    };
    var $author$project$Expression$PAdd_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Expression$PAdd = F2($author$project$Expression$PAdd_fn);
    var $author$project$Expression$PApply_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $author$project$Expression$PApply = F2($author$project$Expression$PApply_fn);
    var $author$project$Expression$PBy_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $author$project$Expression$PBy = F2($author$project$Expression$PBy_fn);
    var $author$project$Expression$PDiv_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $author$project$Expression$PDiv = F2($author$project$Expression$PDiv_fn);
    var $author$project$Expression$PInteger = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$PLambda_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $author$project$Expression$PLambda = F2($author$project$Expression$PLambda_fn);
    var $author$project$Expression$PList = function (a) {
        return { $: 11, a: a };
    };
    var $author$project$Expression$PNegate = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Expression$PPower_fn = function (a, b) {
        return { $: 9, a: a, b: b };
    }, $author$project$Expression$PPower = F2($author$project$Expression$PPower_fn);
    var $author$project$Expression$PRel_fn = function (a, b, c) {
        return { $: 8, a: a, b: b, c: c };
    }, $author$project$Expression$PRel = F3($author$project$Expression$PRel_fn);
    var $author$project$Expression$PVariable = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Expression$pvisit_fn = function (f, expr) {
        var _v0 = f(expr);
        if (!_v0.$) {
            var r = _v0.a;
            return r;
        }
        else {
            switch (expr.$) {
                case 2:
                    var s = expr.a;
                    return $author$project$Expression$PVariable(s);
                case 0:
                    var i = expr.a;
                    return $author$project$Expression$PInteger(i);
                case 1:
                    var f_ = expr.a;
                    return $author$project$Expression$PFloat(f_);
                case 5:
                    var l = expr.a;
                    return $author$project$Expression$PNegate($author$project$Expression$pvisit_fn(f, l));
                case 3:
                    var x = expr.a;
                    var e = expr.b;
                    return $author$project$Expression$PLambda_fn(x, $author$project$Expression$pvisit_fn(f, e));
                case 4:
                    var l = expr.a;
                    var r = expr.b;
                    return $author$project$Expression$PAdd_fn($author$project$Expression$pvisit_fn(f, l), $author$project$Expression$pvisit_fn(f, r));
                case 6:
                    var l = expr.a;
                    var r = expr.b;
                    return $author$project$Expression$PBy_fn($author$project$Expression$pvisit_fn(f, l), $author$project$Expression$pvisit_fn(f, r));
                case 7:
                    var l = expr.a;
                    var r = expr.b;
                    return $author$project$Expression$PDiv_fn($author$project$Expression$pvisit_fn(f, l), $author$project$Expression$pvisit_fn(f, r));
                case 9:
                    var l = expr.a;
                    var r = expr.b;
                    return $author$project$Expression$PPower_fn($author$project$Expression$pvisit_fn(f, l), $author$project$Expression$pvisit_fn(f, r));
                case 8:
                    var o = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return $author$project$Expression$PRel_fn(o, $author$project$Expression$pvisit_fn(f, l), $author$project$Expression$pvisit_fn(f, r));
                case 12:
                    var func = expr.a;
                    var e = expr.b;
                    return $author$project$Expression$PApply_fn(func, $elm$core$List$map_fn($author$project$Expression$pvisit(f), e));
                case 10:
                    var vars = expr.a;
                    var e = expr.b;
                    return $author$project$Expression$PReplace_fn($elm$core$Dict$map_fn(function (_v2) {
                        return $elm$core$Maybe$map($author$project$Expression$pvisit(f));
                    }, vars), $author$project$Expression$pvisit_fn(f, e));
                default:
                    var es = expr.a;
                    return $author$project$Expression$PList($elm$core$List$map_fn($author$project$Expression$pvisit(f), es));
            }
        }
    }, $author$project$Expression$pvisit = F2($author$project$Expression$pvisit_fn);
    var $author$project$Expression$pfullSubstitute = function (dict) {
        return $author$project$Expression$pvisit(function (expr) {
            switch (expr.$) {
                case 10:
                    var vars = expr.a;
                    var e = expr.b;
                    return $elm$core$Maybe$Just($author$project$Expression$PReplace_fn($elm$core$Dict$map_fn(function (_v1) {
                        return $elm$core$Maybe$map($author$project$Expression$pfullSubstitute(dict));
                    }, vars), function () {
                        var reduced = $elm$core$Dict$filter_fn_unwrapped(function (k, _v2) {
                            return !$elm$core$Dict$member_fn(k, vars);
                        }, dict);
                        return $elm$core$Dict$isEmpty(reduced) ? e : A2($author$project$Expression$pfullSubstitute, dict, e);
                    }()));
                case 2:
                    var string = expr.a;
                    return $elm$core$Maybe$Just($elm$core$Maybe$withDefault_fn(expr, $elm$core$Maybe$andThen_fn($elm$core$Basics$identity, $elm$core$Dict$get_fn(string, dict))));
                default:
                    return $elm$core$Maybe$Nothing;
            }
        });
    };
    var $author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn = function (expandIntervals, p, expr) {
        expressionToIntervalGlslPrec: while (true) {
            var infixl_ = F4(function (n, op, l, r) {
                return $author$project$UI$Glsl$Code$paren_fn(_Utils_cmp(p, n) > 0, _Utils_ap($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, n, l), _Utils_ap(op, $author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, n + 1, r))));
            });
            var expand = function (e) {
                return expandIntervals ? ("iexpand(" + (e + ")")) : e;
            };
            var apply = F2(function (name, ex) {
                return $author$project$UI$Glsl$Code$paren_fn(p > 10, name + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn(A2($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec, expandIntervals, 0), ex)) + ")")));
            });
            switch (expr.$) {
                case 2:
                    switch (expr.a) {
                        case "pi":
                            return "dup(radians(180.0))";
                        case "e":
                            return "dup(exp(1.0))";
                        default:
                            var v = expr.a;
                            return v;
                    }
                case 0:
                    var v = expr.a;
                    return "dup(" + ($elm$core$String$fromInt(v) + ".0)");
                case 1:
                    var f = expr.a;
                    return "dup(" + ($author$project$UI$Glsl$Code$floatToGlsl(f) + ")");
                case 5:
                    var expression = expr.a;
                    return "ineg(" + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 10, expression) + ")");
                case 4:
                    var l = expr.a;
                    var r = expr.b;
                    return expand(A4(infixl_, 6, " + ", l, r));
                case 8:
                    var op = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var name = function () {
                        switch (op) {
                            case "<":
                                return "ilt";
                            case "<=":
                                return "ileq";
                            case "=":
                                return "ieq";
                            case ">=":
                                return "igeq";
                            case ">":
                                return "igt";
                            default:
                                return "iuknownrelop";
                        }
                    }();
                    return expand(name + ("(" + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 10, l) + (", " + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 10, r) + ")")))));
                case 6:
                    var l = expr.a;
                    var r = expr.b;
                    return expand(A2(apply, "iby", _List_fromArray([l, r])));
                case 7:
                    var l = expr.a;
                    var r = expr.b;
                    return expand(A2(apply, "idiv", _List_fromArray([l, r])));
                case 9:
                    switch (expr.b.$) {
                        case 1:
                            var l = expr.a;
                            var f = expr.b.a;
                            return (f === 2) ? expand("isquare(" + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 0, l) + ")")) : expand(A2(apply, "ipow", _List_fromArray([
                                l,
                                $author$project$Expression$PFloat(f)
                            ])));
                        case 0:
                            if (expr.b.a === 2) {
                                if ((expr.a.$ === 2) && (expr.a.a === "i")) {
                                    return "dup(-1.0)";
                                }
                                else {
                                    var l = expr.a;
                                    return expand("isquare(" + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 0, l) + ")"));
                                }
                            }
                            else {
                                var l = expr.a;
                                var ri = expr.b.a;
                                var ris = $elm$core$String$fromInt(ri);
                                return expand("ipow(" + ($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn(expandIntervals, 0, l) + (", " + (ris + ")"))));
                            }
                        default:
                            var l = expr.a;
                            var r = expr.b;
                            return expand(A2(apply, "ipow", _List_fromArray([l, r])));
                    }
                case 12:
                    var name = expr.a;
                    var ex = expr.b;
                    if ($elm$core$List$any_fn(function (_v2) {
                        var v = _v2.b;
                        return _Utils_eq(name, $author$project$Expression$KnownFunction(v));
                    }, $author$project$Expression$variadicFunctions)) {
                        var _v3 = $elm$core$List$map_fn(A2($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec, expandIntervals, 0), ex);
                        if (!_v3.b) {
                            return "vec2(0)";
                        }
                        else {
                            var head = _v3.a;
                            var tail = _v3.b;
                            return expand($elm$core$List$foldl_fn_unwrapped(function (e, a) {
                                return "i" + ($author$project$Expression$functionNameToString(name) + ("(" + (a + ("," + (e + ")")))));
                            }, head, tail));
                        }
                    }
                    else {
                        if (_Utils_eq(name, $author$project$Expression$KnownFunction($author$project$Expression$Sin)) || _Utils_eq(name, $author$project$Expression$KnownFunction($author$project$Expression$Cos))) {
                            return A2(apply, "i" + $author$project$Expression$functionNameToString(name), ex);
                        }
                        else {
                            return expand(A2(apply, "i" + $author$project$Expression$functionNameToString(name), ex));
                        }
                    }
                case 11:
                    var es = expr.a;
                    return "vec" + ($elm$core$String$fromInt($elm$core$List$length(es)) + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn(A2($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec, expandIntervals, 0), es)) + ")")));
                case 10:
                    var _var = expr.a;
                    var e = expr.b;
                    var $temp$expandIntervals = expandIntervals, $temp$p = p, $temp$expr = A2($author$project$Expression$pfullSubstitute, _var, e);
                    expandIntervals = $temp$expandIntervals;
                    p = $temp$p;
                    expr = $temp$expr;
                    continue expressionToIntervalGlslPrec;
                default:
                    return "vec2(0)";
            }
        }
    }, $author$project$UI$Glsl$Code$expressionToIntervalGlslPrec = F3($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec_fn);
    var $author$project$Expression$relationToString = function (rop) {
        switch (rop) {
            case 0:
                return "<";
            case 1:
                return "\u2A7D";
            case 2:
                return "=";
            case 3:
                return "\u2A7E";
            default:
                return ">";
        }
    };
    var $author$project$Expression$toPrintExpression = function (e) {
        switch (e.$) {
            case 2:
                var v = e.a;
                return $author$project$Expression$PVariable(v);
            case 3:
                var x = e.a;
                var f = e.b;
                return $author$project$Expression$PLambda_fn(x, $author$project$Expression$toPrintExpression(f));
            case 0:
                var i = e.a;
                return $author$project$Expression$PInteger(i);
            case 1:
                var f = e.a;
                return $author$project$Expression$PFloat(f);
            case 4:
                var _v1 = e.a;
                var expression = e.b;
                return $author$project$Expression$PNegate($author$project$Expression$toPrintExpression(expression));
            case 5:
                if (e.a === 1) {
                    var _v2 = e.a;
                    var l = e.b;
                    var r = e.c;
                    return $author$project$Expression$PPower_fn($author$project$Expression$toPrintExpression(l), $author$project$Expression$toPrintExpression(r));
                }
                else {
                    var _v3 = e.a;
                    var l = e.b;
                    var r = e.c;
                    return $author$project$Expression$PDiv_fn($author$project$Expression$toPrintExpression(l), $author$project$Expression$toPrintExpression(r));
                }
            case 6:
                var op = e.a;
                var l = e.b;
                var r = e.c;
                return $author$project$Expression$PRel_fn($author$project$Expression$relationToString(op), $author$project$Expression$toPrintExpression(l), $author$project$Expression$toPrintExpression(r));
            case 7:
                if (!e.a) {
                    var _v4 = e.a;
                    var l = e.b;
                    var r = e.c;
                    var o = e.d;
                    return $elm$core$List$foldl_fn_unwrapped(function (el, a) {
                        return $author$project$Expression$PAdd_fn(a, el);
                    }, $author$project$Expression$PAdd_fn($author$project$Expression$toPrintExpression(l), $author$project$Expression$toPrintExpression(r)), $elm$core$List$map_fn($author$project$Expression$toPrintExpression, o));
                }
                else {
                    var _v5 = e.a;
                    var l = e.b;
                    var r = e.c;
                    var o = e.d;
                    return $elm$core$List$foldl_fn_unwrapped(function (el, a) {
                        return $author$project$Expression$PBy_fn(a, el);
                    }, $author$project$Expression$PBy_fn($author$project$Expression$toPrintExpression(l), $author$project$Expression$toPrintExpression(r)), $elm$core$List$map_fn($author$project$Expression$toPrintExpression, o));
                }
            case 9:
                var vars = e.a;
                var expr = e.b;
                return $author$project$Expression$PReplace_fn($elm$core$Dict$map_fn(function (_v6) {
                    return $elm$core$Maybe$map($author$project$Expression$toPrintExpression);
                }, vars), $author$project$Expression$toPrintExpression(expr));
            case 10:
                var es = e.a;
                return $author$project$Expression$PList($elm$core$List$map_fn($author$project$Expression$toPrintExpression, es));
            default:
                var f = e.a;
                var es = e.b;
                return $author$project$Expression$PApply_fn(f, $elm$core$List$map_fn($author$project$Expression$toPrintExpression, es));
        }
    };
    var $author$project$UI$Glsl$Code$wordWrap = function () {
        var step = F2(function (e, _v1) {
            var l = _v1.a;
            var acc = _v1.b;
            return (($elm$core$String$length(e) + $elm$core$String$length(l)) > 40) ? _Utils_Tuple2(e, _List_Cons(l, acc)) : _Utils_Tuple2(_Utils_ap(l, e), acc);
        });
        return A2($elm$core$Basics$composeR, $elm$core$String$split(" "), A2($elm$core$Basics$composeR, A2($elm$core$List$foldl, step, _Utils_Tuple2("", _List_Nil)), A2($elm$core$Basics$composeR, function (_v0) {
            var l = _v0.a;
            var a = _v0.b;
            return $elm$core$String$isEmpty(l) ? a : _List_Cons(l, a);
        }, A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$String$join("\n            ")))));
    }();
    var $author$project$UI$Glsl$Code$expressionToIntervalGlsl = function (expandIntervals) {
        return A2($elm$core$Basics$composeR, $author$project$Expression$toPrintExpression, A2($elm$core$Basics$composeR, A2($author$project$UI$Glsl$Code$expressionToIntervalGlslPrec, expandIntervals, 0), $author$project$UI$Glsl$Code$wordWrap));
    };
    var $author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn = function (p, expr) {
        expressionToNormalGlslPrec: while (true) {
            var infixl_ = F4(function (n, op, l, r) {
                return $author$project$UI$Glsl$Code$paren_fn(_Utils_cmp(p, n) > 0, _Utils_ap($author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn(n, l), _Utils_ap(op, $author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn(n + 1, r))));
            });
            var apply = F2(function (name, ex) {
                return $author$project$UI$Glsl$Code$paren_fn(p > 10, name + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToNormalGlslPrec(0), ex)) + ")")));
            });
            switch (expr.$) {
                case 2:
                    switch (expr.a) {
                        case "pi":
                            return "gnum(radians(180.0))";
                        case "e":
                            return "gnum(exp(1.0))";
                        case "x":
                            return "vec4(x,1,0,0)";
                        case "y":
                            return "vec4(y,0,1,0)";
                        case "z":
                            return "vec4(z,0,0,1)";
                        default:
                            var v = expr.a;
                            return v;
                    }
                case 0:
                    var v = expr.a;
                    return "gnum(" + ($elm$core$String$fromInt(v) + ".0)");
                case 1:
                    var f = expr.a;
                    return "gnum(" + ($author$project$UI$Glsl$Code$floatToGlsl(f) + ")");
                case 5:
                    var expression = expr.a;
                    return "gneg(" + ($author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn(10, expression) + ")");
                case 4:
                    var l = expr.a;
                    var r = expr.b;
                    return A4(infixl_, 6, " + ", l, r);
                case 8:
                    var op = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return ((op === "<=") || (op === "<")) ? A4(infixl_, 6, " - ", r, l) : ((op === "=") ? ("(abs(" + (A4(infixl_, 6, " - ", r, l) + "))")) : A4(infixl_, 6, " - ", l, r));
                case 6:
                    var l = expr.a;
                    var r = expr.b;
                    return A2(apply, "gby", _List_fromArray([l, r]));
                case 7:
                    var l = expr.a;
                    var r = expr.b;
                    return A2(apply, "gdiv", _List_fromArray([l, r]));
                case 9:
                    if (!expr.b.$) {
                        if (expr.b.a === 2) {
                            var l = expr.a;
                            return A2(apply, "gsquare", _List_fromArray([l]));
                        }
                        else {
                            var l = expr.a;
                            var ri = expr.b.a;
                            return "gpow(" + ($author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn(0, l) + (", " + ($elm$core$String$fromInt(ri) + ")")));
                        }
                    }
                    else {
                        var l = expr.a;
                        var r = expr.b;
                        return A2(apply, "gpow", _List_fromArray([l, r]));
                    }
                case 12:
                    var name = expr.a;
                    var ex = expr.b;
                    if ($elm$core$List$any_fn(function (_v1) {
                        var v = _v1.b;
                        return _Utils_eq(name, $author$project$Expression$KnownFunction(v));
                    }, $author$project$Expression$variadicFunctions)) {
                        var _v2 = $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToNormalGlslPrec(0), ex);
                        if (!_v2.b) {
                            return "vec2(0)";
                        }
                        else {
                            var head = _v2.a;
                            var tail = _v2.b;
                            return $elm$core$List$foldl_fn_unwrapped(function (e, a) {
                                return "g" + ($author$project$Expression$functionNameToString(name) + ("(" + (a + ("," + (e + ")")))));
                            }, head, tail);
                        }
                    }
                    else {
                        return A2(apply, "g" + $author$project$Expression$functionNameToString(name), ex);
                    }
                case 11:
                    var es = expr.a;
                    return "vec" + ($elm$core$String$fromInt($elm$core$List$length(es)) + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToNormalGlslPrec(0), es)) + ")")));
                case 10:
                    var _var = expr.a;
                    var e = expr.b;
                    var $temp$p = p, $temp$expr = A2($author$project$Expression$pfullSubstitute, _var, e);
                    p = $temp$p;
                    expr = $temp$expr;
                    continue expressionToNormalGlslPrec;
                default:
                    return "vec4(0)";
            }
        }
    }, $author$project$UI$Glsl$Code$expressionToNormalGlslPrec = F2($author$project$UI$Glsl$Code$expressionToNormalGlslPrec_fn);
    var $author$project$UI$Glsl$Code$expressionToNormalGlsl_a0 = $author$project$Expression$toPrintExpression, $author$project$UI$Glsl$Code$expressionToNormalGlsl_a1 = A2($elm$core$Basics$composeR, $author$project$UI$Glsl$Code$expressionToNormalGlslPrec(0), $author$project$UI$Glsl$Code$wordWrap), $author$project$UI$Glsl$Code$expressionToNormalGlsl = A2($elm$core$Basics$composeR, $author$project$UI$Glsl$Code$expressionToNormalGlsl_a0, $author$project$UI$Glsl$Code$expressionToNormalGlsl_a1);
    var $author$project$UI$Glsl$Generator$Type = $elm$core$Basics$identity;
    var $author$project$UI$Glsl$Generator$floatT = "float";
    var $author$project$UI$Glsl$Generator$Block_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$UI$Glsl$Generator$Block = F2($author$project$UI$Glsl$Generator$Block_fn);
    var $author$project$UI$Glsl$Generator$fun_fn = function (_v0, name, args, body) {
        var type_ = _v0;
        return $author$project$UI$Glsl$Generator$Block_fn(type_ + (" " + (name + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn(function (_v1) {
            var t = _v1.a;
            var n = _v1.b;
            return t + (" " + n);
        }, args)) + ")")))), body);
    }, $author$project$UI$Glsl$Generator$fun = F4($author$project$UI$Glsl$Generator$fun_fn);
    var $author$project$UI$Glsl$Generator$mat3T = "mat3";
    var $author$project$UI$Glsl$Generator$return = function (v) {
        return $author$project$UI$Glsl$Generator$Line("return " + v);
    };
    var $author$project$UI$Glsl$Generator$vec2_fn = function (x, y) {
        return $author$project$UI$Glsl$Generator$call_fn("vec2", _List_fromArray([x, y]));
    }, $author$project$UI$Glsl$Generator$vec2 = F2($author$project$UI$Glsl$Generator$vec2_fn);
    var $author$project$UI$Glsl$Generator$vec2T = "vec2";
    var $author$project$UI$Glsl$Generator$vec3T = "vec3";
    var $author$project$UI$Glsl$Generator$vec4T = "vec4";
    var $author$project$UI$Glsl$Code$toSrc3D_fn = function (expandIntervals, suffix, e) {
        return _List_fromArray([
            $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec3T, "normal" + suffix, _List_fromArray([
                _Utils_Tuple2($author$project$UI$Glsl$Generator$vec3T, "p")
            ]), _List_fromArray([
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "x", "p.x"),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "y", "p.y"),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "z", "p.z"),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec4T, "gradient", $elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToNormalGlsl_a0, $author$project$UI$Glsl$Code$expressionToNormalGlsl_a1, e)),
                $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$call_fn("normalize", _List_fromArray(["gradient.yzw"])))
            ])),
            $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "interval" + suffix, _List_fromArray([
                _Utils_Tuple2($author$project$UI$Glsl$Generator$mat3T, "f"),
                _Utils_Tuple2($author$project$UI$Glsl$Generator$mat3T, "t")
            ]), _List_fromArray([
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec3T, "mn", $author$project$UI$Glsl$Generator$call_fn("min", _List_fromArray(["f[0]", "t[0]"]))),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec3T, "mx", $author$project$UI$Glsl$Generator$call_fn("max", _List_fromArray(["f[1]", "t[1]"]))),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec2T, "x", $author$project$UI$Glsl$Generator$vec2_fn("mn.x", "mx.x")),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec2T, "y", $author$project$UI$Glsl$Generator$vec2_fn("mn.y", "mx.y")),
                $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$vec2T, "z", $author$project$UI$Glsl$Generator$vec2_fn("mn.z", "mx.z")),
                $author$project$UI$Glsl$Generator$return(A2($author$project$UI$Glsl$Code$expressionToIntervalGlsl, expandIntervals, e))
            ]))
        ]);
    }, $author$project$UI$Glsl$Code$toSrc3D = F3($author$project$UI$Glsl$Code$toSrc3D_fn);
    var $author$project$Expression$Utils$unaryFunc_fn = function (name, arg) {
        return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction(name), _List_fromArray([arg]));
    }, $author$project$Expression$Utils$unaryFunc = F2($author$project$Expression$Utils$unaryFunc_fn);
    var $author$project$Expression$Utils$cbrt_a0 = $author$project$Expression$Root(3), $author$project$Expression$Utils$cbrt = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$cbrt_a0);
    var $author$project$Expression$fullSubstitute = function (dict) {
        return $author$project$Expression$visit(function (expr) {
            switch (expr.$) {
                case 9:
                    var vars = expr.a;
                    var e = expr.b;
                    return $elm$core$Maybe$Just($author$project$Expression$Replace_fn($elm$core$Dict$map_fn(function (_v1) {
                        return $elm$core$Maybe$map($author$project$Expression$fullSubstitute(dict));
                    }, vars), function () {
                        var reduced = $elm$core$Dict$filter_fn_unwrapped(function (k, _v2) {
                            return !$elm$core$Dict$member_fn(k, vars);
                        }, dict);
                        return $elm$core$Dict$isEmpty(reduced) ? e : A2($author$project$Expression$fullSubstitute, dict, e);
                    }()));
                case 2:
                    var string = expr.a;
                    return $elm$core$Maybe$Just($elm$core$Maybe$withDefault_fn(expr, $elm$core$Dict$get_fn(string, dict)));
                default:
                    return $elm$core$Maybe$Nothing;
            }
        });
    };
    var $author$project$UI$Glsl$Code$expressionToGlslPrec_fn = function (p, expr) {
        expressionToGlslPrec: while (true) {
            var noninfix = F2(function (op, c) {
                return $author$project$UI$Glsl$Code$paren_fn(p > 10, _Utils_ap(op, $author$project$UI$Glsl$Code$expressionToGlslPrec_fn(11, c)));
            });
            var infixl_ = F4(function (n, op, l, r) {
                return $author$project$UI$Glsl$Code$paren_fn(_Utils_cmp(p, n) > 0, _Utils_ap($author$project$UI$Glsl$Code$expressionToGlslPrec_fn(n, l), _Utils_ap(op, $author$project$UI$Glsl$Code$expressionToGlslPrec_fn(n + 1, r))));
            });
            var apply = F2(function (name, ex) {
                return $author$project$UI$Glsl$Code$paren_fn(p > 10, name + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToGlslPrec(0), ex)) + ")")));
            });
            _v0$14: while (true) {
                switch (expr.$) {
                    case 2:
                        switch (expr.a) {
                            case "i":
                                return "vec2(0,1)";
                            case "pi":
                                return "vec2(radians(180.0),0.0)";
                            case "e":
                                return "vec2(exp(1.0),0)";
                            default:
                                var v = expr.a;
                                return "vec2(" + (v + ",0)");
                        }
                    case 0:
                        var v = expr.a;
                        return "vec2(" + ($elm$core$String$fromInt(v) + ",0)");
                    case 1:
                        var f = expr.a;
                        return "vec2(" + ($author$project$UI$Glsl$Code$floatToGlsl(f) + ",0)");
                    case 5:
                        var expression = expr.a;
                        return "(" + (A2(noninfix, "-", expression) + ")");
                    case 4:
                        if (expr.b.$ === 5) {
                            var l = expr.a;
                            var r = expr.b.a;
                            return A4(infixl_, 6, " - ", l, r);
                        }
                        else {
                            var l = expr.a;
                            var r = expr.b;
                            return A4(infixl_, 6, " + ", l, r);
                        }
                    case 8:
                        var op = expr.a;
                        var l = expr.b;
                        var r = expr.c;
                        return ((op === "<=") || (op === "<")) ? A4(infixl_, 6, " - ", r, l) : ((op === "=") ? ("(abs(" + (A4(infixl_, 6, " - ", r, l) + "))")) : A4(infixl_, 6, " - ", l, r));
                    case 6:
                        var l = expr.a;
                        var r = expr.b;
                        return A2(apply, "by", _List_fromArray([l, r]));
                    case 7:
                        var l = expr.a;
                        var r = expr.b;
                        return A2(apply, "div", _List_fromArray([l, r]));
                    case 9:
                        if (expr.a.$ === 2) {
                            if (expr.a.a === "i") {
                                var r = expr.b;
                                return A2(apply, "cpow", _List_fromArray([
                                    $author$project$Expression$PVariable("i"),
                                    r
                                ]));
                            }
                            else {
                                if ((!expr.b.$) && (expr.b.a === 2)) {
                                    var v = expr.a.a;
                                    return "vec2(" + (v + ("*" + (v + ",0)")));
                                }
                                else {
                                    break _v0$14;
                                }
                            }
                        }
                        else {
                            break _v0$14;
                        }
                    case 12:
                        if ((((!expr.a.$) && (expr.a.a.$ === 31)) && expr.b.b) && (!expr.b.b.b)) {
                            var _v1 = expr.a.a;
                            var _v2 = expr.b;
                            var e = _v2.a;
                            var $temp$p = p, $temp$expr = e;
                            p = $temp$p;
                            expr = $temp$expr;
                            continue expressionToGlslPrec;
                        }
                        else {
                            var name = expr.a;
                            var ex = expr.b;
                            if ($elm$core$List$any_fn(function (_v3) {
                                var v = _v3.b;
                                return _Utils_eq(name, $author$project$Expression$KnownFunction(v));
                            }, $author$project$Expression$variadicFunctions)) {
                                var _v4 = $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToGlslPrec(0), ex);
                                if (!_v4.b) {
                                    return "vec2(0)";
                                }
                                else {
                                    var head = _v4.a;
                                    var tail = _v4.b;
                                    return $elm$core$List$foldl_fn_unwrapped(function (e, a) {
                                        return "c" + ($author$project$Expression$functionNameToString(name) + ("(" + (a + ("," + (e + ")")))));
                                    }, head, tail);
                                }
                            }
                            else {
                                return A2(apply, "c" + $author$project$Expression$functionNameToString(name), ex);
                            }
                        }
                    case 11:
                        var es = expr.a;
                        return "vec" + ($elm$core$String$fromInt($elm$core$List$length(es)) + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$UI$Glsl$Code$expressionToGlslPrec(0), es)) + ")")));
                    case 10:
                        var _var = expr.a;
                        var e = expr.b;
                        var $temp$p = p, $temp$expr = A2($author$project$Expression$pfullSubstitute, _var, e);
                        p = $temp$p;
                        expr = $temp$expr;
                        continue expressionToGlslPrec;
                    default:
                        return "vec2(0)";
                }
            }
            var l = expr.a;
            var r = expr.b;
            return A2(apply, "cpow", _List_fromArray([l, r]));
        }
    }, $author$project$UI$Glsl$Code$expressionToGlslPrec = F2($author$project$UI$Glsl$Code$expressionToGlslPrec_fn);
    var $author$project$UI$Glsl$Code$expressionToGlsl_a0 = $author$project$Expression$toPrintExpression, $author$project$UI$Glsl$Code$expressionToGlsl_a1 = A2($elm$core$Basics$composeR, $author$project$UI$Glsl$Code$expressionToGlslPrec(0), $author$project$UI$Glsl$Code$wordWrap), $author$project$UI$Glsl$Code$expressionToGlsl = A2($elm$core$Basics$composeR, $author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1);
    var $author$project$UI$Glsl$Polynomial$getSolutions = function (poly) {
        var tFrom = function (v) {
            return _Utils_Tuple2("t", v + (".x < 0.0 || abs(" + (v + (".y) > " + ($author$project$UI$Glsl$Code$threshold + (" ? t : min(" + (v + ".x, t)")))))));
        };
        var get = function (d) {
            return $elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$zero, $elm$core$Dict$get_fn(d, poly)));
        };
        var deg = $elm$core$Maybe$withDefault_fn(0, $elm$core$List$maximum($elm$core$Dict$keys(poly)));
        var sols = function () {
            switch (deg) {
                case 1:
                    return _List_fromArray([
                        _Utils_Tuple2("!dx", "mix(d[0].x, d[1].x, 0.5)"),
                        _Utils_Tuple2("!dy", "mix(d[0].y, d[1].y, 0.5)"),
                        _Utils_Tuple2("!dz", "mix(d[0].z, d[1].z, 0.5)"),
                        _Utils_Tuple2("a", get(1)),
                        _Utils_Tuple2("b", get(0)),
                        _Utils_Tuple2("x", "div(-b, a)"),
                        tFrom("x")
                    ]);
                case 2:
                    return _List_fromArray([
                        _Utils_Tuple2("!dx", "mix(d[0].x, d[1].x, 0.5)"),
                        _Utils_Tuple2("!dy", "mix(d[0].y, d[1].y, 0.5)"),
                        _Utils_Tuple2("!dz", "mix(d[0].z, d[1].z, 0.5)"),
                        _Utils_Tuple2("a", get(2)),
                        _Utils_Tuple2("b", get(1)),
                        _Utils_Tuple2("c", get(0)),
                        _Utils_Tuple2("delta", "by(b,b) - 4.0 * by(a,c)"),
                        _Utils_Tuple2("sqdelta", "csqrt(delta)"),
                        _Utils_Tuple2("den", "2.0 * a"),
                        _Utils_Tuple2("pos", "div(- b + sqdelta, den)"),
                        tFrom("pos"),
                        _Utils_Tuple2("neg", "div(- b - sqdelta, den)"),
                        tFrom("neg")
                    ]);
                default:
                    return _List_Nil;
            }
        }();
        return $elm$core$List$isEmpty(sols) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_Utils_Tuple2(deg, sols));
    };
    var $author$project$Expression$Utils$ipow_fn = function (base, exponent) {
        return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, base, $author$project$Expression$Integer(exponent));
    }, $author$project$Expression$Utils$ipow = F2($author$project$Expression$Utils$ipow_fn);
    var $author$project$Expression$Utils$sqrt__a0 = $author$project$Expression$Root(2), $author$project$Expression$Utils$sqrt_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$sqrt__a0);
    var $author$project$UI$Glsl$tryGlslFromPolynomial_fn = function (prefix, e) {
        var t = $author$project$Expression$Variable("t");
        var _var = function (v) {
            return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                $author$project$Expression$Variable("o." + v),
                $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                    t,
                    $author$project$Expression$Variable("d" + v)
                ]))
            ]));
        };
        var repls = $elm$core$Dict$fromList($elm$core$List$map_fn(function (c) {
            return _Utils_Tuple2(c, _var(c));
        }, _List_fromArray(["x", "y", "z"])));
        var replaced = A2($author$project$Expression$fullSubstitute, repls, e);
        var poly = $elm$core$Maybe$withDefault_fn($elm$core$Dict$empty, $elm$core$Maybe$map_fn($elm$core$Dict$fromList, $elm$core$Maybe$andThen_fn($elm_community$maybe_extra$Maybe$Extra$traverse(function (p) {
            if (!p.a.b) {
                var k = p.b;
                return $elm$core$Maybe$Just(_Utils_Tuple2(0, k));
            }
            else {
                if (!p.a.b.b) {
                    var _v7 = p.a;
                    var _v8 = _v7.a;
                    var v = _v8.a;
                    var d = _v8.b;
                    var k = p.b;
                    return (v === "t") ? $elm$core$Maybe$Just(_Utils_Tuple2(d, k)) : $elm$core$Maybe$Nothing;
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }), $elm$core$Maybe$map_fn($elm$core$Dict$toList, $author$project$Expression$Polynomial$asPolynomial_fn(_List_fromArray(["t"]), function () {
            if ((replaced.$ === 6) && (replaced.a === 2)) {
                var _v5 = replaced.a;
                var l = replaced.b;
                var r = replaced.c;
                return $author$project$Expression$Utils$minus_fn(l, r);
            }
            else {
                return replaced;
            }
        }())))));
        var fromSols = function (sols) {
            var checks = $elm$core$String$join_fn("\n                        ", $elm$core$List$reverse($elm$core$List$foldl_fn_unwrapped(function (_v1, _v2) {
                var k = _v1.a;
                var v = _v1.b;
                var known = _v2.a;
                var lines = _v2.b;
                var _v3 = $elm$core$List$member_fn(k, known) ? _Utils_Tuple2("", 0) : (_String_startsWith_fn("!", k) ? _Utils_Tuple2("float ", 1) : _Utils_Tuple2("vec2 ", 0));
                var decl = _v3.a;
                var drop = _v3.b;
                var newLine = decl + ($elm$core$String$dropLeft_fn(drop, k) + (" = " + (v + ";")));
                return _Utils_Tuple2(_List_Cons(k, known), _List_Cons(newLine, lines));
            }, _Utils_Tuple2(_List_fromArray(["t"]), _List_Nil), sols).b));
            var srcExpr = "\n                    bool bisect" + (prefix + ("(vec3 o, mat3 d, float max_distance, out vec3 found) {\n                        float t = max_distance * 2.0;\n                        " + (checks + "\n                        found = o + t * mix(d[0], d[1], 0.5);\n                        return t < max_distance && t > 0.0;\n                    }\n                    ")));
            return {
                z: $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, $author$project$Expression$Utils$ipow_fn(e, 3)))),
                C: A2($author$project$UI$Glsl$Code$deindent, 16, srcExpr)
            };
        };
        return $elm$core$Maybe$map_fn(function (_v0) {
            var sols = _v0.b;
            return fromSols(sols);
        }, $author$project$UI$Glsl$Polynomial$getSolutions(poly));
    }, $author$project$UI$Glsl$tryGlslFromPolynomial = F2($author$project$UI$Glsl$tryGlslFromPolynomial_fn);
    var $author$project$UI$Glsl$get3DSource_fn = function (expandIntervals, prefix, e) {
        var _v0 = $elm$core$Maybe$map_fn($author$project$UI$Glsl$Sphere$toGlsl(prefix), $author$project$UI$Glsl$Sphere$asSphere(e));
        if (!_v0.$) {
            var glsl = _v0.a;
            return { z: e, C: glsl };
        }
        else {
            var _v1 = $elm$core$Maybe$map_fn($author$project$UI$Glsl$Plane$toGlsl(prefix), $author$project$UI$Glsl$Plane$asPlane(e));
            if (!_v1.$) {
                var glsl = _v1.a;
                return { z: e, C: glsl };
            }
            else {
                var _v2 = $author$project$UI$Glsl$tryGlslFromPolynomial_fn(prefix, e);
                if (!_v2.$) {
                    var o = _v2.a;
                    return o;
                }
                else {
                    var glsl = $elm$core$String$join_fn("\n\n", $elm$core$List$map_fn($author$project$UI$Glsl$Generator$toGlsl, $author$project$UI$Glsl$Code$toSrc3D_fn(expandIntervals, prefix, e)));
                    return {
                        z: e,
                        C: _Utils_ap(glsl, $author$project$UI$Glsl$Code$suffixToBisect(prefix))
                    };
                }
            }
        }
    }, $author$project$UI$Glsl$get3DSource = F3($author$project$UI$Glsl$get3DSource_fn);
    var $elm$core$Basics$pi = _Basics_pi;
    var $author$project$UI$Glsl$Code$main2D = function (pixels) {
        var addPixel = F2(function (i, _v0) {
            var name = _v0.dw;
            var color = _v0.bc;
            var h = $author$project$UI$Glsl$Code$floatToGlsl((i + 2) / $elm$core$Basics$pi);
            var k = color ? ("hl2rgb(" + (h + (", 0.5)" + (" * " + name)))) : name;
            return "\n            curr = " + (k + "(deltaX, deltaY, x, y);\n            px = curr == vec3(0,0,0) ? px : curr;");
        });
        var inner = $elm$core$String$concat($elm$core$List$indexedMap_fn(addPixel, pixels));
        return A2($author$project$UI$Glsl$Code$deindent, 8, "\n        float log10(float x) {\n            return log(x) / log(10.0);\n        }\n\n        float axis(float coord, float otherCoord, float maxDelta) {\n            float across = 1.0 - abs(coord/maxDelta);\n            if(across < -12.0)\n                return 0.0;\n            float smallUnit = pow(10.0, ceil(log10(maxDelta)));\n            if(across < 0.0 && abs(otherCoord) < maxDelta * 2.0)\n                return 0.0;\n            float unit = across < -6.0 ? smallUnit * 100.0 : across < -0.1 ? smallUnit * 10.0 : smallUnit * 5.0;\n            float parallel = mod(abs(otherCoord), unit) < maxDelta ? 1.0 : 0.0;\n            return max(0.0, max(across, parallel));\n        }\n\n        vec4 pixel2 () {\n            vec2 canvasSize = vec2(u_canvasWidth, u_canvasHeight);\n            vec2 uv_centered = gl_FragCoord.xy - 0.5 * canvasSize;\n\n            vec2 viewportSize = (u_viewportWidth / u_canvasWidth) * canvasSize;\n            vec2 uv = uv_centered / canvasSize * viewportSize;\n            vec2 c = u_zoomCenter + uv;\n            float x = c.x;\n            float y = c.y;\n\n            float deltaX = u_viewportWidth / u_canvasWidth;\n            float deltaY = u_viewportWidth / u_canvasHeight;\n            vec3 px = vec3(0,0,0);\n            vec3 curr;" + (inner + "\n            float maxDelta = max(deltaX, deltaY);\n            vec3 yax = u_drawAxes == 1.0 ? axis(x, y, maxDelta) * vec3(0,1,0) : vec3(0);\n            vec3 xax = u_drawAxes == 1.0 ? axis(y, x, maxDelta) * vec3(1,0,0) : vec3(0);\n            return vec4(max(px, max(xax, yax)), 1.0);\n        }\n        "));
    };
    var $author$project$UI$Glsl$Code$raytrace = function (suffixes) {
        var suffixToRayLight = function (suffix) {
            return "\n                    else if(bisect" + (suffix + "(offseted, light_direction, light_distance, f)) {\n                        light_coeff = 0.2;\n                    }\n            ");
        };
        var suffixToRay = F2(function (i, suffix) {
            return "\n                if(bisect" + (suffix + ("(o, d, max_distance, f) && length(f - o) < curr_distance) {\n                    found_index = " + ($elm$core$String$fromInt(i) + ";\n                    found = f;\n                    curr_distance = length(found - o);\n                }\n            ")));
        });
        var innerTrace = $elm$core$String$join_fn("\n", $elm$core$List$indexedMap_fn(suffixToRay, suffixes));
        var innerLightTrace = $elm$core$String$join_fn("\n", $elm$core$List$map_fn(suffixToRayLight, suffixes));
        var colorCoeff = $author$project$UI$Glsl$Code$floatToGlsl(1.19 - (0.2 * $elm$core$List$length(suffixes)));
        return "\n            vec4 raytrace(vec3 o, mat3 d, float max_distance) {\n                vec3 found = vec3(0);\n                float curr_distance = max_distance;\n                int found_index = -1;\n                vec3 f = vec3(0);\n                vec3 n = vec3(0);\n                " + (innerTrace + ("\n                if(found_index >= 0) {\n                    float hue_based_on_index = (float(found_index))*radians(360.0 / 1.1);\n\n                    vec3 ld = normalize(vec3(-0.3, 0.0, 1.0));\n                    vec3 diffs = d[1] - d[0];\n                    mat3 light_direction = mat3(ld - 0.5 * diffs, ld + 0.5 * diffs, vec3(0));\n                    float light_distance = max_distance;\n                    float light_coeff = 0.45;\n                    vec3 offseted = found + 0.0001 * max_distance * normalize(o - found);\n                    if(0 == 1) { }\n                    " + (innerLightTrace + ("\n\n                    vec3 px = mix(\n                        hl2rgb(hue_based_on_index, light_coeff),\n                        hl2rgb(found.z * 0.5, light_coeff),\n                        max(0.2, " + (colorCoeff + ")\n                    );\n                    return vec4(px, 1.0);\n                } else {\n                    return vec4(0.0, 0.0, 0.0, 1.0);\n                }\n            }\n    ")))));
    };
    var $author$project$UI$Glsl$Code$main3D_fn = function (rayDifferentials, suffixes) {
        var iif = F3(function (b, t, f) {
            return b ? t : f;
        });
        var block = "\n            vec4 pixel3 () {\n                float eye_dist = 2.0 * u_viewportWidth;\n                vec2 canvasSize = vec2(u_canvasWidth, u_canvasHeight);\n                vec2 uv_centered = gl_FragCoord.xy - 0.5 * canvasSize;\n                vec2 uv_normalized = 1.0 / u_canvasHeight * uv_centered;\n\n                float t = u_theta + 0.58;\n                float p = -2.0 * u_phi;\n                vec3 eye = eye_dist * normalize(vec3(\n                    cos(t) * sin(p),\n                    cos(t) * -cos(p),\n                    sin(t)\n                ));\n\n                vec3 target = vec3(0);\n                vec3 to_target = normalize(target-eye);\n                vec3 across = normalize(cross(to_target, vec3(0,0,1)));\n                vec3 up = normalize(cross(across, to_target));\n\n                vec3 canvas_center = eye + to_target;\n                vec3 canvas_point = canvas_center + uv_normalized.x * across + uv_normalized.y * up;\n\n                vec3 ray_direction = normalize(canvas_point - eye);\n\n                vec3 diffs = abs(fwidth(ray_direction));\n                float k = " + (A3(iif, rayDifferentials, "0.001", "0.0") + ";\n                mat3 d = mat3(ray_direction - k * diffs, ray_direction + k * diffs, vec3(0));\n\n                float max_distance = 100.0 * eye_dist;\n                return raytrace(canvas_point, d, max_distance);\n            }\n        ");
        return A2($author$project$UI$Glsl$Code$deindent, 12, _Utils_ap($author$project$UI$Glsl$Code$raytrace(suffixes), block));
    }, $author$project$UI$Glsl$Code$main3D = F2($author$project$UI$Glsl$Code$main3D_fn);
    var $author$project$UI$Glsl$Code$mainGlsl_fn = function (rayDifferentials, pixel2, pixel3) {
        var _v0 = _Utils_Tuple2(pixel2, pixel3);
        if (!_v0.b.b) {
            return $author$project$UI$Glsl$Code$main2D(pixel2) + "\n\nvoid main () { gl_FragColor = pixel2(); }";
        }
        else {
            if (!_v0.a.b) {
                return $author$project$UI$Glsl$Code$main3D_fn(rayDifferentials, pixel3) + "\n\nvoid main () { gl_FragColor = pixel3(); }";
            }
            else {
                return $author$project$UI$Glsl$Code$main2D(pixel2) + ("\n\n" + ($author$project$UI$Glsl$Code$main3D_fn(rayDifferentials, pixel3) + "\n\nvoid main () { gl_FragColor = max(pixel2(), pixel3()); }"));
            }
        }
    }, $author$project$UI$Glsl$Code$mainGlsl = F3($author$project$UI$Glsl$Code$mainGlsl_fn);
    var $author$project$UI$Glsl$Model$Cosh11 = 8;
    var $author$project$UI$Glsl$Model$I = 2;
    var $author$project$UI$Glsl$Model$Pi = 1;
    var $author$project$UI$Glsl$RequireConstant = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$UI$Glsl$Model$Sinh11 = 24;
    var $author$project$UI$Glsl$Model$Tanh11 = 30;
    var $author$project$UI$Glsl$dependenciesOf = function (req) {
        switch (req.$) {
            case 0:
                switch (req.a) {
                    case 23:
                        var _v1 = req.a;
                        return $elm$core$List$map_fn($author$project$UI$Glsl$RequireFunction, _List_fromArray([24, 8]));
                    case 7:
                        var _v2 = req.a;
                        return $elm$core$List$map_fn($author$project$UI$Glsl$RequireFunction, _List_fromArray([23, 24, 8]));
                    case 29:
                        var _v3 = req.a;
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(3), $elm$core$List$map_fn($author$project$UI$Glsl$RequireFunction, _List_fromArray([23, 7])));
                    case 3:
                        var _v4 = req.a;
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(1), $elm$core$List$map_fn($author$project$UI$Glsl$RequireFunction, _List_fromArray([26, 13])));
                    case 1:
                        var _v5 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireConstant(1),
                            $author$project$UI$Glsl$RequireFunction(3)
                        ]);
                    case 4:
                        var _v6 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireConstant(2),
                            $author$project$UI$Glsl$RequireOperation(1),
                            $author$project$UI$Glsl$RequireOperation(3),
                            $author$project$UI$Glsl$RequireFunction(13)
                        ]);
                    case 5:
                        var _v7 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireFunction(4),
                            $author$project$UI$Glsl$RequireOperation(1),
                            $author$project$UI$Glsl$RequireFunction(22)
                        ]);
                    case 25:
                        var _v8 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireFunction(10),
                            $author$project$UI$Glsl$RequireFunction(24)
                        ]);
                    case 9:
                        var _v9 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireFunction(10)
                        ]);
                    case 31:
                        var _v10 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireFunction(8),
                            $author$project$UI$Glsl$RequireFunction(30),
                            $author$project$UI$Glsl$RequireFunction(10),
                            $author$project$UI$Glsl$RequireOperation(3)
                        ]);
                    case 0:
                        var _v11 = req.a;
                        return _List_Nil;
                    case 22:
                        var _v12 = req.a;
                        return _List_Nil;
                    case 26:
                        var _v13 = req.a;
                        return _List_Nil;
                    case 27:
                        var _v14 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireOperation(4)
                        ]);
                    case 28:
                        var _v15 = req.a;
                        return _List_Nil;
                    case 16:
                        var _v16 = req.a;
                        return _List_Nil;
                    case 15:
                        var _v17 = req.a;
                        return _List_Nil;
                    case 17:
                        var _v18 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireOperation(3),
                            $author$project$UI$Glsl$RequireOperation(1),
                            $author$project$UI$Glsl$RequireFunction(11),
                            $author$project$UI$Glsl$RequireOperation(2)
                        ]);
                    case 13:
                        var _v19 = req.a;
                        return _List_Nil;
                    case 14:
                        var _v20 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireFunction(13),
                            $author$project$UI$Glsl$RequireOperation(3)
                        ]);
                    case 10:
                        var _v21 = req.a;
                        return _List_Nil;
                    case 20:
                        var _v22 = req.a;
                        return _List_Nil;
                    case 12:
                        var _v23 = req.a;
                        return _List_Nil;
                    case 2:
                        var _v24 = req.a;
                        return _List_Nil;
                    case 19:
                        var _v25 = req.a;
                        return _List_Nil;
                    case 24:
                        var _v26 = req.a;
                        return _List_Nil;
                    case 8:
                        var _v27 = req.a;
                        return _List_Nil;
                    case 30:
                        var _v28 = req.a;
                        return _List_Nil;
                    case 6:
                        var _v29 = req.a;
                        return _List_Nil;
                    case 11:
                        var _v30 = req.a;
                        return _List_Nil;
                    case 21:
                        var _v31 = req.a;
                        return _List_Nil;
                    default:
                        var _v32 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireOperation(1)
                        ]);
                }
            case 2:
                switch (req.a) {
                    case 4:
                        var _v33 = req.a;
                        return _List_Cons($author$project$UI$Glsl$RequireOperation(1), $elm$core$List$map_fn($author$project$UI$Glsl$RequireFunction, _List_fromArray([10, 13])));
                    case 0:
                        var _v34 = req.a;
                        return _List_Nil;
                    case 1:
                        var _v35 = req.a;
                        return _List_Nil;
                    case 3:
                        var _v36 = req.a;
                        return _List_fromArray([
                            $author$project$UI$Glsl$RequireOperation(1)
                        ]);
                    case 2:
                        var _v37 = req.a;
                        return _List_Nil;
                    default:
                        var _v38 = req.a;
                        return _List_Nil;
                }
            default:
                return _List_Nil;
        }
    };
    var $author$project$UI$Glsl$dependsOn_fn = function (r, l) {
        var d = $author$project$UI$Glsl$dependenciesOf(l);
        return $elm$core$List$member_fn(r, d) || $elm$core$List$any_fn($author$project$UI$Glsl$dependsOn(r), d);
    }, $author$project$UI$Glsl$dependsOn = F2($author$project$UI$Glsl$dependsOn_fn);
    var $author$project$UI$Glsl$requirementSort_fn = function (l, r) {
        return $author$project$UI$Glsl$dependsOn_fn(r, l) ? 2 : ($author$project$UI$Glsl$dependsOn_fn(l, r) ? 0 : 1);
    }, $author$project$UI$Glsl$requirementSort = F2($author$project$UI$Glsl$requirementSort_fn);
    var $author$project$UI$Glsl$Code$constantToGlsl = function (c) {
        switch (c) {
            case 2:
                return $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "i", _List_Nil, _List_fromArray([
                    $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$vec2_fn("0", "1"))
                ]));
            case 1:
                return $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "pi", _List_Nil, _List_fromArray([
                    $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$vec2_fn("radians(180.0)", "0.0"))
                ]));
            default:
                return $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "e", _List_Nil, _List_fromArray([
                    $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$vec2_fn("exp(1.0)", "0.0"))
                ]));
        }
    };
    var $author$project$UI$Glsl$Code$intervalFunctionToGlsl = function (name) {
        switch (name) {
            case 0:
                return "\n            vec2 iabs(vec2 z) {\n                if(z.x <= 0.0 && z.y >= 0.0)\n                    return vec2(0.0, max(z.y, abs(z.x)));\n                if(z.x <= 0.0)\n                    return vec2(-z.y, -z.x);\n                return z;\n            }\n\n            vec4 gabs(vec4 v) {\n                return vec4(abs(v.x), sign(v.x) * v.yzw);\n            }\n            ";
            case 1:
                return "\n            vec2 iacos(vec2 z) {\n                // Don't use clamp so if z is fully outside range the result is empty\n                vec2 clamped = vec2(\n                    max(z.x, -1.0),\n                    min(z.y, 1.0)\n                );\n                return acos(clamped).yx;\n            }\n\n            vec4 gacos(vec4 v) {\n                return vec4(acos(v.x), -v.yzw / sqrt(1.0 - v.x * v.x));\n            }\n            ";
            case 2:
                return "\n            vec2 iarg(vec2 z) {\n                if(z.y < 0.0)\n                    return dup(radians(180.0));\n                if(z.x >= 0.0)\n                    return vec2(0);\n                return vec2(0.0, radians(180.0));\n            }\n\n            vec4 garg(vec4 z) {\n                return gnum(z.x >= 0.0 ? 0.0 : radians(180.0));\n            }\n            ";
            case 22:
                return "\n            vec2 isign(vec2 z) {\n                return sign(z);\n            }\n\n            vec4 gsign(vec4 v) {\n                return gnum(sign(v.x));\n            }\n            ";
            case 3:
                return "\n            vec2 iasin(vec2 z) {\n                // Don't use clamp so if z is fully outside range the result is empty\n                vec2 clamped = vec2(\n                    max(z.x, -1.0),\n                    min(z.y, 1.0)\n                );\n                return asin(clamped);\n            }\n\n            vec4 gasin(vec4 v) {\n                return vec4(asin(v.x), v.yzw / sqrt(1.0 - v.x * v.x));\n            }\n            ";
            case 4:
                return "\n            vec2 iatan(vec2 z) {\n                return atan(z);\n            }\n\n            vec4 gatan(vec4 v) {\n                return vec4(atan(v.x), v.yzw / (1.0 + v.x * v.x));\n            }\n            ";
            case 5:
                return "\n            vec2 iatan2(vec2 y, vec2 x) {\n                // TODO: improve this\n                vec2 r = vec2(atan(y.x, x.x), atan(y.y, x.x));\n                vec2 q = vec2(atan(y.x, x.y), atan(y.y, x.y));\n                vec2 rs = vec2(min(r.x, r.y), max(r.x, r.y));\n                vec2 qs = vec2(min(q.x, q.y), max(q.x, q.y));\n                return vec2(min(rs.x,qs.x),max(rs.y,qs.y));\n            }\n\n            vec4 gatan2(vec4 y, vec4 x) {\n                return vec4(atan(y.x, x.x), y.yzw / x.yzw / (1.0 + y.x * y.x / x.x / x.x));\n            }\n            ";
            case 6:
                return "\n            vec2 iceiling(vec2 z) {\n                return ceil(z);\n            }\n\n            vec4 gceiling(vec4 z) {\n                return gnum(ceil(z.x));\n            }\n            ";
            case 7:
                return "\n            vec2 icos(vec2 v) {\n                vec2 shift = radians(90.0) * vec2(1,1);\n                return isin(v + shift);\n            }\n\n            vec4 gcos(vec4 v) {\n                return vec4(cos(v.x), -sin(v.x) * v.yzw);\n            }\n            ";
            case 8:
                return "";
            case 9:
                return "\n            vec2 icosh(vec2 z) {\n                if(z.x <= 0.0 && z.y >= 0.0)\n                    return vec2(cosh(0.0), max(z.y, abs(z.x)));\n                if(z.x <= 0.0)\n                    return vec2(cosh(-z.y), cosh(-z.x));\n                return vec2(cosh(z.x), cosh(z.y));\n            }\n\n            vec4 gcosh(vec4 v) {\n                return vec4(cosh(v.x), sinh(v.x) * v.yzw);\n            }\n            ";
            case 10:
                return "\n            vec2 iexp(vec2 z) {\n                return vec2(exp(z.x), exp(z.y));\n            }\n\n            vec4 gexp(vec4 z) {\n                return vec4(\n                    exp(z.x),\n                    exp(z.x) * z.yzw\n                );\n            }\n            ";
            case 11:
                return "\n            vec2 ifloor(vec2 z) {\n                return floor(z);\n            }\n\n            vec4 gfloor(vec4 z) {\n                return gnum(floor(z.x));\n            }\n            ";
            case 13:
                return "\n            vec2 iln(vec2 z) {\n                return vec2(log(z.x), log(z.y));\n            }\n\n            vec4 gln(vec4 z) {\n                return vec4(log(z.x), z.yzw / z.x);\n            }\n            ";
            case 14:
                return "\n            vec2 ilog10(vec2 z) {\n                return log(z) / log(10.0);\n            }\n\n            vec4 glog10(vec4 z) {\n                return vec4(log(z.x), z.yzw / z.x) / log(10.0);\n            }\n            ";
            case 19:
                return "\n            vec2 ipw(vec2 c, vec2 t, vec2 f) {\n                if(c.y <= 0.0)\n                    return f;\n                if(c.x > 0.0)\n                    return t;\n                return vec2(min(t.x, f.x), max(t.y, f.y));\n            }\n\n            vec4 gpw(vec4 c, vec4 t, vec4 f) {\n                return c.x > 0.0 ? t : f;\n            }\n            ";
            case 20:
                return "\n            vec2 ire(vec2 v) {\n                return v;\n            }\n\n            vec4 gre(vec4 v) {\n                return v;\n            }\n            ";
            case 12:
                return "\n            vec2 iim(vec2 v) {\n                return vec2(0);\n            }\n\n            vec4 gim(vec4 v) {\n                return vec4(0, 0, 0, 1.0);\n            }\n            ";
            case 21:
                return "\n            vec2 iround(vec2 z) {\n                return round(z);\n            }\n\n            vec4 ground(vec4 z) {\n                return gnum(round(z.x));\n            }\n            ";
            case 23:
                return "\n            bool between(float x, float low, float high) {\n                return low <= x && x <= high;\n            }\n\n            vec2 isin(vec2 v) {\n                if(v.y - v.x > radians(360.0)) {\n                    return vec2(-1.0, 1.0);\n                }\n                float from = mod(v.x, radians(360.0)); // [0, 360\u00B0]\n                float to = from + v.y - v.x; // [0, 720\u00B0]\n                vec2 s = sin(vec2(from, to));\n                vec2 res = vec2(min(s.x, s.y), max(s.x, s.y));\n                if(between(radians(90.0), from, to) || between(radians(90.0 + 360.0), from, to))\n                    res.y = 1.0;\n                if(between(radians(270.0), from, to) || between(radians(270.0 + 360.0), from, to))\n                    res.x = -1.0;\n                return res;\n            }\n\n            vec4 gsin(vec4 v) {\n                return vec4(sin(v.x), cos(v.x) * v.yzw);\n            }\n            ";
            case 24:
                return "";
            case 25:
                return "\n            vec2 isinh(vec2 v) {\n                return vec2(sinh(v.x), sinh(v.y));\n            }\n\n            vec4 gsinh(vec4 v) {\n                return vec4(sinh(v.x), cosh(v.x) * v.yzw);\n            }\n            ";
            case 26:
                return "\n            vec2 isqrt(vec2 v) {\n                return vec2(sqrt(max(0.0, v.x)), sqrt(max(0.0, v.y)));\n            }\n\n            vec4 gsqrt(vec4 v) {\n                return vec4(sqrt(v.x), 0.5 * pow(v.x, -0.5) * v.yzw);\n            }\n            ";
            case 27:
                return "\n            float cbrt(float v) {\n                return sign(v) * pow(abs(v), 1.0 / 3.0);\n            }\n\n            vec2 icbrt(vec2 v) {\n                return vec2(cbrt(v.x), cbrt(v.y));\n            }\n\n            vec4 gcbrt(vec4 v) {\n                return vec4(cbrt(v.x), pow(v.x, -2.0 / 3.0) / 3.0 * v.yzw);\n            }\n            ";
            case 28:
                return "\n            vec2 isquare(vec2 z) {\n                vec2 s = z * z;\n                float mx = max(s.x, s.y);\n                if(z.x <= 0.0 && z.y >= 0.0)\n                    return vec2(0.0, mx);\n                float mn = min(s.x, s.y);\n                return vec2(mn, mx);\n            }\n\n            vec4 gsquare(vec4 z) {\n                return vec4(z.x*z.x, 2.0 * z.x * z.yzw);\n            }\n            ";
            case 29:
                return "\n            vec2 itan(vec2 z) {\n                return idiv(isin(z), icos(z));\n            }\n\n            vec4 gtan(vec4 z) {\n                float c = cos(z.x);\n                return vec4(tan(z.x), 1.0 / (c * c) * z.yzw);\n            }\n            ";
            case 30:
                return "\n            ";
            case 31:
                return "\n            vec2 itanh(vec2 z) {\n                return vec2(tanh(z.x), tanh(z.y));\n            }\n\n            vec4 gtanh(vec4 z) {\n                float c = 1.0 / cosh(z.x);\n                return vec4(tanh(z.x), c * c * z.yzw);\n            }\n            ";
            case 16:
                return "\n            vec2 imin(vec2 l, vec2 r) {\n                return vec2(min(l.x, r.x), min(l.y, r.y));\n            }\n\n            vec4 gmin(vec4 l, vec4 r) {\n                return l.x < r.x ? l : r;\n            }\n            ";
            case 15:
                return "\n            vec2 imax(vec2 l, vec2 r) {\n                return vec2(max(l.x, r.x), max(l.y, r.y));\n            }\n\n            vec4 gmax(vec4 l, vec4 r) {\n                return l.x > r.x ? l : r;\n            }\n            ";
            case 17:
                return "\n            vec2 imod(vec2 x, vec2 y) {\n                return x + ineg(iby(y, ifloor(idiv(x, y))));\n            }\n\n            vec4 gmod(vec4 l, vec4 r) {\n                return vec4(mod(l.x, r.x), l.yzw);\n            }\n            ";
            default:
                return "TODO";
        }
    };
    var $author$project$UI$Glsl$Code$straightFunctionToGlsl = function (name) {
        switch (name) {
            case 24:
                return "\n            float sinh(float x) {\n                return 0.5 * (exp(x) - exp(-x));\n            }\n            ";
            case 8:
                return "\n            float cosh(float x) {\n                return 0.5 * (exp(x) + exp(-x));\n            }\n            ";
            case 30:
                return "\n            float tanh(float x) {\n                if(abs(x) > 10.0)\n                    return sign(x);\n                float p = exp(x);\n                float m = exp(-x);\n                return (p - m) / (p + m);\n            }\n            ";
            case 23:
                return "\n            vec2 csin(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(sin(z.x), 0);\n                }\n                return vec2(sin(z.x) * cosh(z.y), cos(z.x) * sinh(z.y));\n            }\n            ";
            case 7:
                return "\n            vec2 ccos(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(cos(z.x), 0);\n                }\n                return vec2(cos(z.x) * cosh(z.y), sin(z.x) * sinh(z.y));\n            }\n            ";
            case 29:
                return "\n            vec2 ctan(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(tan(z.x), 0);\n                }\n                return div(csin(z), ccos(z));\n            }\n            ";
            case 3:
                return "\n            vec2 casin(vec2 z) {\n                vec2 s = csqrt(vec2(1, 0) - by(z, z));\n                vec2 arg = s - by(vec2(0, 1), z);\n                return by(vec2(0, 1), cln(arg));\n            }\n            ";
            case 1:
                return "\n            vec2 cacos(vec2 z) {\n                return pi() * 0.5 - casin(z);\n            }\n            ";
            case 4:
                return "\n            vec2 catan(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(atan(z.x), 0);\n                }\n                vec2 o = vec2(1, 0);\n                vec2 iz = by(vec2(0, 1), z);\n                vec2 l = div(o + iz, o - iz);\n                return -0.5 * by(vec2(0, 1), cln(l));\n            }\n            ";
            case 5:
                return "\n            vec2 catan2(vec2 y, vec2 x) {\n                vec2 z = vec2(x.x - y.y, x.y + y.x);\n                return vec2(atan(z.y, z.x), 0.0);\n            }\n            ";
            case 25:
                return "\n            vec2 csinh(vec2 z) {\n                return 0.5 * (cexp(z) - cexp(-z));\n            }\n            ";
            case 9:
                return "\n            vec2 ccosh(vec2 z) {\n                return 0.5 * (cexp(z) + cexp(-z));\n            }\n            ";
            case 31:
                return "\n            vec2 ctanh(vec2 z) {\n                vec2 p = cexp(z);\n                vec2 m = cexp(-z);\n                return div(p - m, p + m);\n            }\n            ";
            case 0:
                return "\n            vec2 cabs(vec2 z) {\n                return vec2(length(z), 0.0);\n            }\n            ";
            case 22:
                return "\n            vec2 csign(vec2 z) {\n                return vec2(sign(z.x), sign(z.y));\n            }\n            ";
            case 26:
                return "\n            vec2 csqrt(vec2 z) {\n                if(z.y == 0.0 && z.x >= 0.0) {\n                    return vec2(sqrt(z.x), 0);\n                }\n                float r = pow(dot(z, z), 0.25);\n                float t = atan(z.y, z.x) * 0.5;\n                return r * vec2(cos(t), sin(t));\n            }\n            ";
            case 27:
                return "\n            vec2 ccbrt(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(sign(z.x) * pow(z.x, 1.0 / 3.0), 0);\n                }\n                float r = pow(dot(z, z), 1.0 / 6.0);\n                float t = atan(z.y, z.x) / 3.0 + (z.x > 0.0 ? 0.0 : radians(120.0));\n                return r * vec2(cos(t), sin(t));\n            }\n            ";
            case 28:
                return "\n            vec2 csquare(vec2 z) {\n                return by(z, z);\n            }\n            ";
            case 13:
                return "\n            vec2 cln(vec2 z) {\n                if(z.y == 0.0 && z.x >= 0.0) {\n                    return vec2(log(z.x), 0);\n                }\n                float px = length(z);\n                float py = atan(z.y, z.x);\n                return vec2(log(px), py);\n            }\n            ";
            case 14:
                return "\n            vec2 clog10(vec2 z) {\n                return div(cln(z), vec2(log(10.0), 0));\n            }\n            ";
            case 10:
                return "\n            vec2 cexp(vec2 z) {\n                if(z.y == 0.0) {\n                    return vec2(exp(z.x), 0);\n                }\n                return vec2(cos(z.y) * exp(z.x), sin(z.y) * exp(z.x));\n            }\n            ";
            case 20:
                return "\n            vec2 cre(vec2 z) {\n                return vec2(z.x, 0.0);\n            }\n            ";
            case 12:
                return "\n            vec2 cim(vec2 z) {\n                return vec2(z.y, 0.0);\n            }\n            ";
            case 2:
                return "\n            float arg(vec2 v) {\n                return atan(v.y, v.x);\n            }\n\n            vec2 carg(vec2 v) {\n                return vec2(atan(v.y, v.x), 0);\n            }\n            ";
            case 19:
                return "\n            vec2 cpw(vec2 c, vec2 t, vec2 f) {\n                return c.x > 0.0 ? t : f;\n            }\n            ";
            case 6:
                return "\n            vec2 cceiling(vec2 z) {\n                return ceil(z);\n            }\n            ";
            case 11:
                return "\n            vec2 cfloor(vec2 z) {\n                return floor(z);\n            }\n            ";
            case 21:
                return "\n            vec2 cround(vec2 z) {\n                return floor(z + vec2(0.5, 0.5));\n            }\n            ";
            case 16:
                return "\n            vec2 cmin(vec2 l, vec2 r) {\n                return l.x < r.x ? l : r;\n            }\n            ";
            case 15:
                return "\n            vec2 cmax(vec2 l, vec2 r) {\n                return l.x > r.x ? l : r;\n            }\n            ";
            case 17:
                return "\n            vec2 cmod(vec2 l, vec2 r) {\n                return vec2(mod(l.x, r.x), 0);\n            }\n            ";
            default:
                return "\n            vec2 cmbrot(vec2 x, vec2 y) {\n                vec2 c = x + vec2(-y.y, y.x);\n\n                float p = length(c - vec2(0.25, 0));\n                if(c.x <= p - 2.0*p*p + 0.25 || length(c + vec2(1,0)) <= 0.25)\n                    return vec2(0,0);\n\n                vec2 z = c;\n                for(int i = 0; i < 4000; i++) {\n                    z = vec2(z.x * z.x - z.y * z.y, 2.0 * z.x * z.y) + c;\n                    if(length(z) > 1000000.0) {\n                        float logLength = log(length(z));\n                        float nu = log(logLength / log(2.0)) / log(2.0);\n                        float fi = float(i) - nu;\n                        return vec2(sin(fi),cos(fi));\n                    }\n                }\n                return vec2(0,0);\n            }\n            ";
        }
    };
    var $author$project$UI$Glsl$functionToGlsl_fn = function (interval, name) {
        switch (interval) {
            case 1:
                return A2($author$project$UI$Glsl$Code$deindent, 12, $author$project$UI$Glsl$Code$straightFunctionToGlsl(name));
            case 0:
                return A2($author$project$UI$Glsl$Code$deindent, 12, $author$project$UI$Glsl$Code$intervalFunctionToGlsl(name));
            default:
                return A2($author$project$UI$Glsl$Code$deindent, 12, $author$project$UI$Glsl$Code$straightFunctionToGlsl(name) + ("\n" + $author$project$UI$Glsl$Code$intervalFunctionToGlsl(name)));
        }
    }, $author$project$UI$Glsl$functionToGlsl = F2($author$project$UI$Glsl$functionToGlsl_fn);
    var $author$project$UI$Glsl$Code$intervalOperationToGlsl = function (op) {
        switch (op) {
            case 0:
                return "";
            case 2:
                return "\n            vec2 ineg(vec2 v) {\n                return vec2(-v.y, -v.x);\n            }\n\n            vec4 gneg(vec4 v) {\n                return -v;\n            }\n            ";
            case 1:
                return "\n            vec2 iby(vec2 l, vec2 r) {\n                float a = l.x * r.x;\n                float b = l.x * r.y;\n                float c = l.y * r.x;\n                float d = l.y * r.y;\n                float mn = min(min(a,b),min(c,d));\n                float mx = max(max(a,b),max(c,d));\n                return vec2(mn, mx);\n            }\n\n            vec4 gby(vec4 l, vec4 r) {\n                return vec4(\n                    l.x * r.x,\n                    l.x * r.yzw + r.x * l.yzw);\n            }\n            ";
            case 3:
                return "\n            vec2 iinverse(vec2 y) {\n                if(y.x <= 0.0 && y.y >= 0.0)\n                    return vec2(-1.0 / 0.0, 1.0 / 0.0);\n                if(y.y == 0.0)\n                    return vec2(-1.0 / 0.0, 1.0 / y.x);\n                if(y.x == 0.0)\n                    return vec2(1.0 / y.y, 1.0 / 0.0);\n                return vec2(1.0 / y.y, 1.0 / y.x);\n            }\n\n            vec2 idiv(vec2 l, vec2 r) {\n                return iby(l, iinverse(r));\n            }\n\n            vec4 gdiv(vec4 l, vec4 r) {\n                return vec4(\n                    l.x / r.x,\n                    (r.x * l.yzw - l.x * r.yzw) / pow(r.x, 2.0)\n                );\n            }\n            ";
            case 4:
                return "\n            float ipow(float b, int e) {\n                float fe = float(e);\n                if(mod(fe, 2.0) == 0.0)\n                    return pow(abs(b), fe);\n                else\n                    return b * pow(abs(b), fe - 1.0);\n            }\n\n            vec2 ipow(vec2 b, int e) {\n                if(e == 0)\n                    return vec2(1,1);\n                if(e == 1)\n                    return b;\n                float xe = ipow(b.x, e);\n                float ye = ipow(b.y, e);\n                float mn = min(xe, ye);\n                float mx = max(xe, ye);\n                if(mod(float(e), 2.0) == 0.0 && b.x <= 0.0 && b.y >= 0.0) {\n                    return vec2(\n                        min(0.0, mn),\n                        max(0.0, mx)\n                    );\n                }\n                return vec2(mn, mx);\n            }\n\n            vec2 ipow(vec2 b, vec2 e) {\n                if(e.y - e.x < 0.000001 && abs(e.x - round(e.x)) < 0.000001)\n                    return ipow(b, int(e.x));\n                return iexp(iby(iln(b), e));\n            }\n\n            vec4 gpow(vec4 b, int e) {\n                return vec4(pow(b.x, float(e)), float(e) * pow(b.x, float(e - 1)) * b.yzw);\n            }\n\n            vec4 gpow(vec4 b, vec4 e) {\n                int ie = int(e.x);\n                if(float(ie) == e.x && e.y == 0.0 && e.z == 0.0 && e.w == 0.0) {\n                    return gpow(b, ie);\n                }\n                return gexp(gby(gln(b), e));\n            }\n            ";
            default:
                return "\n            vec2 ilt(vec2 l, vec2 r) {\n                return vec2(r.x - l.y, r.y - l.x);\n            }\n\n            vec2 ileq(vec2 l, vec2 r) {\n                return vec2(r.x - l.y, r.y - l.x);\n            }\n\n            vec2 ieq(vec2 l, vec2 r) {\n                return vec2(l.x - r.y, l.y - r.x);\n            }\n\n            vec2 igeq(vec2 l, vec2 r) {\n                return vec2(l.x - r.y, l.y - r.x);\n            }\n\n            vec2 igt(vec2 l, vec2 r) {\n                return vec2(l.x - r.y, l.y - r.x);\n            }\n            ";
        }
    };
    var $author$project$UI$Glsl$Generator$ands_a0 = " && ", $author$project$UI$Glsl$Generator$ands = $elm$core$String$join($author$project$UI$Glsl$Generator$ands_a0);
    var $author$project$UI$Glsl$Generator$ternary_fn = function (c, t, f) {
        return c + (" ? " + (t + (" : " + f)));
    }, $author$project$UI$Glsl$Generator$ternary = F3($author$project$UI$Glsl$Generator$ternary_fn);
    var $author$project$UI$Glsl$Code$straightOperationToGlsl = function (op) {
        switch (op) {
            case 0:
                return _List_Nil;
            case 1:
                return _List_fromArray([
                    $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "by", _List_fromArray([
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "a"),
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "b")
                    ]), _List_fromArray([
                        $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$vec2_fn("a.x*b.x-a.y*b.y", "a.x*b.y+a.y*b.x"))
                    ])),
                    $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "by", _List_fromArray([
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "a"),
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "b"),
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "c")
                    ]), _List_fromArray([
                        $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$call_fn("by", _List_fromArray([
                            $author$project$UI$Glsl$Generator$call_fn("by", _List_fromArray(["a", "b"])),
                            "c"
                        ])))
                    ]))
                ]);
            case 2:
                return _List_Nil;
            case 3:
                return _List_fromArray([
                    $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "div", _List_fromArray([
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "a"),
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "b")
                    ]), _List_fromArray([
                        $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "k", "1.0 / dot(b, b)"),
                        $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "r", "k * dot(a, b)"),
                        $author$project$UI$Glsl$Generator$decl_fn($author$project$UI$Glsl$Generator$floatT, "i", "k * (a.y*b.x - a.x*b.y)"),
                        $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$vec2_fn("r", "i"))
                    ]))
                ]);
            case 4:
                return _List_fromArray([
                    $author$project$UI$Glsl$Generator$fun_fn($author$project$UI$Glsl$Generator$vec2T, "cpow", _List_fromArray([
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "w"),
                        _Utils_Tuple2($author$project$UI$Glsl$Generator$vec2T, "z")
                    ]), _List_fromArray([
                        $author$project$UI$Glsl$Generator$return($author$project$UI$Glsl$Generator$ternary_fn($elm$core$String$join_fn($author$project$UI$Glsl$Generator$ands_a0, _List_fromArray(["w.x >= 0.0", "w.y == 0.0", "z.y == 0.0"])), $author$project$UI$Glsl$Generator$vec2_fn("pow(w.x, z.x)", "0"), "cexp(by(cln(w), z))"))
                    ]))
                ]);
            default:
                return _List_Nil;
        }
    };
    var $author$project$UI$Glsl$operationToGlsl_fn = function (interval, op) {
        switch (interval) {
            case 1:
                return $elm$core$String$join_fn("\n\n", $elm$core$List$map_fn($author$project$UI$Glsl$Generator$toGlsl, $author$project$UI$Glsl$Code$straightOperationToGlsl(op)));
            case 0:
                return A2($author$project$UI$Glsl$Code$deindent, 12, $author$project$UI$Glsl$Code$intervalOperationToGlsl(op));
            default:
                return A2($author$project$UI$Glsl$Code$deindent, 12, $elm$core$String$join_fn("\n\n", $elm$core$List$map_fn($author$project$UI$Glsl$Generator$toGlsl, $author$project$UI$Glsl$Code$straightOperationToGlsl(op))) + ("\n" + $author$project$UI$Glsl$Code$intervalOperationToGlsl(op)));
        }
    }, $author$project$UI$Glsl$operationToGlsl = F2($author$project$UI$Glsl$operationToGlsl_fn);
    var $author$project$UI$Glsl$requirementToGlsl_fn = function (i, r) {
        switch (r.$) {
            case 0:
                var f = r.a;
                return $author$project$UI$Glsl$functionToGlsl_fn(i, f);
            case 1:
                var c = r.a;
                return $author$project$UI$Glsl$Generator$toGlsl($author$project$UI$Glsl$Code$constantToGlsl(c));
            default:
                var o = r.a;
                return $author$project$UI$Glsl$operationToGlsl_fn(i, o);
        }
    }, $author$project$UI$Glsl$requirementToGlsl = F2($author$project$UI$Glsl$requirementToGlsl_fn);
    var $elm$core$List$sortWith = _List_sortWith;
    var $author$project$Expression$Utils$square = function (base) {
        return $author$project$Expression$Utils$ipow_fn(base, 2);
    };
    var $author$project$UI$Glsl$Code$thetaDelta = "\n    float thetaDelta(float theta) {\n        if(u_whiteLines < 1.0)\n            return 100.0;\n        float thetaSix = theta * u_whiteLines + 0.5;\n        float thetaNeigh = 0.05;\n        return abs(fract(thetaSix) - 0.5) / thetaNeigh;\n    }\n    ";
    var $author$project$UI$Glsl$Code$toSrcContour_fn = function (suffix, e) {
        return "\n    vec3 pixel" + (suffix + ("_o(float deltaX, float deltaY, float x, float y) {\n        vec2 z = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, e) + (";\n\n        float theta = atan(z.y, z.x) / radians(360.0);\n\n        float logRadius = log2(length(z));\n        float powerRemainder = fract(logRadius);\n        float squished = 0.7 - powerRemainder * 0.4;\n\n        if(u_completelyReal > 0.0) {\n            float haf = fract(logRadius) / 6.0;\n            if(z.x > 0.0)\n                return hl2rgb(haf + 0.3, squished);\n            else\n                return hl2rgb(haf - 0.1, 1.0 - squished);\n        }\n\n        float td = thetaDelta(theta);\n        float l = mix(1.0, squished, smoothstep(0.0, 1.0, td));\n        return hl2rgb(theta, l);\n    }\n\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        // Antialiasing\n\n        float dist = 1.0 / 3.0;\n        vec3 a = pixel" + (suffix + ("_o(deltaX, deltaY, x + dist * deltaX, y + dist * deltaY);\n        vec3 b = pixel" + (suffix + ("_o(deltaX, deltaY, x - dist * deltaX, y - dist * deltaY);\n        vec3 c = pixel" + (suffix + ("_o(deltaX, deltaY, x + dist * deltaX, y - dist * deltaY);\n        vec3 d = pixel" + (suffix + ("_o(deltaX, deltaY, x - dist * deltaX, y + dist * deltaY);\n\n        vec3 diff = abs(max(a, max(b, max(c, d))) - min(a, min(b, min(c, d))));\n        if (diff.x < dist && diff.y < dist && diff.z < dist)\n            return (a + b + c + d) / 4.0;\n\n        vec3 e = pixel" + (suffix + ("_o(deltaX, deltaY, x + 2.0 * dist * deltaX, y);\n        vec3 f = pixel" + (suffix + ("_o(deltaX, deltaY, x - 2.0 * dist * deltaX, y);\n        vec3 g = pixel" + (suffix + ("_o(deltaX, deltaY, x, y - 2.0 * dist * deltaY);\n        vec3 h = pixel" + (suffix + "_o(deltaX, deltaY, x, y + 2.0 * dist * deltaY);\n\n        return (a + b + c + d + e + f + g + h) / 8.0;\n    }\n    ")))))))))))))))))))));
    }, $author$project$UI$Glsl$Code$toSrcContour = F2($author$project$UI$Glsl$Code$toSrcContour_fn);
    var $author$project$UI$Glsl$Code$epsilon = 0.00001;
    var $author$project$UI$Glsl$Code$toSrcImplicit_fn = function (suffix, e) {
        var antialiasingSamples = 7;
        return "\n    float f" + (suffix + ("(float x, float y) {\n        vec2 complex = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, e) + (";\n        if(abs(complex.y) > " + ($author$project$UI$Glsl$Code$floatToGlsl($author$project$UI$Glsl$Code$epsilon) + (") {\n            return 0.0;\n        }\n        return complex.x > 0.0 ? 1.0 : -1.0;\n    }\n\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        float sum = 0.0;\n        float samples = " + ($author$project$UI$Glsl$Code$floatToGlsl(antialiasingSamples) + (" * 2.0 + 1.0;\n        samples *= samples;\n        float coeff = 0.0875;\n        for(int w = -" + ($elm$core$String$fromInt(antialiasingSamples) + ("; w <= " + ($elm$core$String$fromInt(antialiasingSamples) + ("; w++)\n            for(int h = -" + ($elm$core$String$fromInt(antialiasingSamples) + ("; h <= " + ($elm$core$String$fromInt(antialiasingSamples) + ("; h++) {\n                float piece = f" + (suffix + "(x + deltaX * coeff * float(w), y + deltaX * coeff * float(h));\n                if(piece == 0.0)\n                    return vec3(0);\n                sum += piece;\n            }\n\n        float perc = (samples - abs(sum)) / samples;\n        perc = pow(perc, 0.2);\n        return perc * vec3(1,1,1);\n    }\n    ")))))))))))))))))));
    }, $author$project$UI$Glsl$Code$toSrcImplicit = F2($author$project$UI$Glsl$Code$toSrcImplicit_fn);
    var $author$project$UI$Glsl$Code$toSrcParametric_fn = function (expandIntervals, suffix, e) {
        return "\n    vec2 interval" + (suffix + ("(vec2 p, float from, float to) {\n        vec2 x = vec2(p.x,p.x);\n        vec2 y = vec2(p.y,p.y);\n        vec2 t = from < to ? vec2(from, to) : vec2(to, from);\n        return " + (A2($author$project$UI$Glsl$Code$expressionToIntervalGlsl, expandIntervals, e) + (";\n    }\n\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        float max_distance = pow(2.0, 10.0);\n        float from = -max_distance / 2.0;\n        float to = max_distance / 2.0;\n        vec2 p = vec2(x, y);\n        int depth = 0;\n        int choices = 0;\n        float ithreshold = 10.0 * deltaX * deltaX;\n        for(int it = 0; it < MAX_ITERATIONS; it++) {\n            float midpoint = mix(from, to, 0.5);\n            vec2 front = interval" + (suffix + ("(p, from, midpoint);\n            vec2 back = interval" + (suffix + ("(p, midpoint, to);\n            if(depth >= MAX_DEPTH\n                || (front.y - front.x < ithreshold && front.x <= 0.0 && front.y >= 0.0)\n                || (back.y - back.x < ithreshold && back.x <= 0.0 && back.y >= 0.0)\n                )\n                    return vec3(1,1,1);\n            if(front.x <= 0.0 && front.y >= 0.0) {\n                to = midpoint;\n                depth++;\n                choices *= 2;\n            } else if(back.x <= 0.0 && back.y >= 0.0) {\n                from = midpoint;\n                depth++;\n                choices = choices * 2 + 1;\n            } else {\n                // This could be possibly helped by https://graphics.stanford.edu/~seander/bithacks.html#ZerosOnRightBinSearch\n                for(int j = MAX_DEPTH - 1; j > 0; j--) {\n                    if(j > depth)\n                        continue;\n                    depth--;\n                    choices /= 2;\n                    if(choices / 2 * 2 == choices) {\n                        midpoint = to;\n                        to = to + (to - from);\n                        vec2 back = interval" + (suffix + "(p, midpoint, to);\n                        if(back.x <= 0.0 && back.y >= 0.0) {\n                            from = midpoint;\n                            depth++;\n                            choices = choices * 2 + 1;\n                            break;\n                        }\n                    } else {\n                        from = from - (to - from);\n                    }\n                }\n                if(depth == 0)\n                    return vec3(0,0,0);\n            }\n        }\n        return vec3(0,0,0);\n    }\n    ")))))))))));
    }, $author$project$UI$Glsl$Code$toSrcParametric = F3($author$project$UI$Glsl$Code$toSrcParametric_fn);
    var $author$project$UI$Glsl$Code$toSrcPolar_fn = function (suffix, e) {
        return "\n    float f" + (suffix + ("(float x, float y, float deltaT, float ot) {\n        float r = sqrt(x*x + y*y);\n        float t = atanPlus(y, x) + deltaT;\n        // Avoid the branch cut at {x > 0, y = 0}\n        if(abs(t - ot) > radians(180.0)) {\n            if(t < ot) t += radians(360.0);\n            else t -= radians(360.0);\n        }\n        vec2 complex = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, e) + (";\n        if(abs(complex.y) > " + ($author$project$UI$Glsl$Code$floatToGlsl($author$project$UI$Glsl$Code$epsilon) + (") {\n            return -1.0;\n        }\n        return complex.x > 0.0 ? 1.0 : 0.0;\n    }\n\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        float t = 0.0;\n        x += deltaX / 2.0;\n        y += deltaY / 2.0;\n        float ot = atanPlus(y, x);\n\n        for(int i = 0; i < MAX_ITERATIONS / 10; i++) {\n            float h = f" + (suffix + ("(x, y, t, ot);\n            float l = f" + (suffix + ("(x - deltaX, y, t, ot);\n            float u = f" + (suffix + ("(x, y - deltaY, t, ot);\n            float ul = f" + (suffix + "(x - deltaX, y - deltaY, t, ot);\n            if(h < 0.0 || l < 0.0 || u < 0.0 || ul < 0.0)\n                break;\n            if(h != l || h != u || h != ul)\n                return vec3(1,1,1);\n            t += radians(360.0);\n            ot += radians(360.0);\n        }\n        return vec3(0,0,0);\n    }\n    ")))))))))))))));
    }, $author$project$UI$Glsl$Code$toSrcPolar = F2($author$project$UI$Glsl$Code$toSrcPolar_fn);
    var $author$project$UI$Glsl$Code$toSrcRelation_fn = function (suffix, e) {
        return "\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        vec2 complex = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, e) + (";\n        return complex.x > 0.0 && abs(complex.y) < " + ($author$project$UI$Glsl$Code$floatToGlsl($author$project$UI$Glsl$Code$epsilon) + " ? vec3(0.8,0.5,0.5) : vec3(0,0,0);\n    }\n    ")))));
    }, $author$project$UI$Glsl$Code$toSrcRelation = F2($author$project$UI$Glsl$Code$toSrcRelation_fn);
    var $author$project$UI$Glsl$Code$toSrcVectorField2D_fn = function (suffix, x, y) {
        return "\n    vec2 vector" + (suffix + ("(float x, float y) {\n        vec2 xv = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, x) + (";\n        vec2 yv = " + ($elm$core$Basics$composeR_fn($author$project$UI$Glsl$Code$expressionToGlsl_a0, $author$project$UI$Glsl$Code$expressionToGlsl_a1, y) + (";\n        return abs(xv.y) + abs(yv.y) < " + ($author$project$UI$Glsl$Code$floatToGlsl($author$project$UI$Glsl$Code$epsilon) + (" ? vec2(xv.x, yv.x) : vec2(0,0);\n    }\n\n    bool near(vec2 o, vec2 corner, vec2 vector, float deltaX, float mx) {\n        float angleCorner = arg(o - corner);\n        float angleVector = arg(vector);\n        float delta = mod(angleCorner - angleVector, radians(360.0));\n        float l = length(vector) / mx;\n        float maxLength = deltaX * VECTOR_SPACING * (l < " + ($author$project$UI$Glsl$Code$floatToGlsl($author$project$UI$Glsl$Code$epsilon) + (" ? 0.0 : l / 2.0 + 0.5);\n        float wantedLength = length(o - corner);\n        float angularDistance = mix(180.0, 0.0, pow(wantedLength / maxLength, 0.3));\n        return (delta < radians(angularDistance) || delta > radians(360.0 - angularDistance)) && wantedLength < maxLength;\n    }\n\n    vec3 pixel" + (suffix + ("(float deltaX, float deltaY, float x, float y) {\n        vec2 o = vec2(x, y);\n\n        float mx = 0.0;\n        for(int xi = -X_POINTS; xi <= X_POINTS; xi++) {\n            for(int yi = -Y_POINTS; yi <= Y_POINTS; yi++) {\n                vec2 p = u_zoomCenter + vec2(deltaX * VECTOR_SPACING * float(xi), deltaX * VECTOR_SPACING * float(yi));\n                vec2 v = vector" + (suffix + ("(p.x, p.y);\n                mx = max(mx, length(v));\n            }\n        }\n\n        vec3 colorA = vec3(0.0, 1.0, 0.0);\n        vec3 colorB = vec3(0.0, 0.0, 1.0);\n\n        x = o.x - mod(o.x, deltaX * VECTOR_SPACING);\n        y = o.y - mod(o.y, deltaX * VECTOR_SPACING);\n\n        vec2 bl = vector" + (suffix + ("(x, y);\n        vec2 br = vector" + (suffix + ("(x + deltaX * VECTOR_SPACING, y);\n        vec2 ul = vector" + (suffix + ("(x, y + deltaX * VECTOR_SPACING);\n        vec2 ur = vector" + (suffix + "(x + deltaX * VECTOR_SPACING, y + deltaX * VECTOR_SPACING);\n\n        float angleO;\n        vec2 corner;\n        float l;\n\n        corner = vec2(x, y);\n        l = length(bl) / mx;\n        if(near(o, corner, bl, deltaX, mx))\n            return mix(colorA, colorB, l);\n\n        corner = vec2(x + deltaX * VECTOR_SPACING, y);\n        l = length(br) / mx;\n        if(near(o, corner, br, deltaX, mx))\n            return mix(colorA, colorB, l);\n\n        corner = vec2(x, y + deltaX * VECTOR_SPACING);\n        l = length(ul) / mx;\n        if(near(o, corner, ul, deltaX, mx))\n            return mix(colorA, colorB, l);\n\n        corner = vec2(x + deltaX * VECTOR_SPACING, y + deltaX * VECTOR_SPACING);\n        l = length(ur) / mx;\n        if(near(o, corner, ur, deltaX, mx))\n            return mix(colorA, colorB, l);\n\n        return vec3(0,0,0);\n    }\n    ")))))))))))))))))))));
    }, $author$project$UI$Glsl$Code$toSrcVectorField2D = F3($author$project$UI$Glsl$Code$toSrcVectorField2D_fn);
    var $author$project$SortedAnySet$SortedAnySet = $elm$core$Basics$identity;
    var $author$project$SortedAnySet$empty = _List_Nil;
    var $author$project$SortedAnySet$insert_fn = function (x, o) {
        var list = o;
        return $elm$core$List$member_fn(x, list) ? o : _List_Cons(x, list);
    }, $author$project$SortedAnySet$insert = F2($author$project$SortedAnySet$insert_fn);
    var $author$project$SortedAnySet$member_fn = function (x, _v0) {
        var list = _v0;
        return $elm$core$List$member_fn(x, list);
    }, $author$project$SortedAnySet$member = F2($author$project$SortedAnySet$member_fn);
    var $author$project$SortedAnySet$toList = function (_v0) {
        var list = _v0;
        return $elm$core$List$reverse(list);
    };
    var $author$project$UI$Glsl$transitiveClosure = function () {
        var go = F2(function (set, ls) {
            go: while (true) {
                if (!ls.b) {
                    return $author$project$SortedAnySet$toList(set);
                }
                else {
                    var x = ls.a;
                    var xs = ls.b;
                    if ($author$project$SortedAnySet$member_fn(x, set)) {
                        var $temp$set = set, $temp$ls = xs;
                        set = $temp$set;
                        ls = $temp$ls;
                        continue go;
                    }
                    else {
                        var deps = $author$project$UI$Glsl$dependenciesOf(x);
                        if ($elm$core$List$all_fn(function (d) {
                            return $author$project$SortedAnySet$member_fn(d, set);
                        }, deps)) {
                            var $temp$set = $author$project$SortedAnySet$insert_fn(x, set), $temp$ls = xs;
                            set = $temp$set;
                            ls = $temp$ls;
                            continue go;
                        }
                        else {
                            var $temp$set = set, $temp$ls = _Utils_ap(deps, ls);
                            set = $temp$set;
                            ls = $temp$ls;
                            continue go;
                        }
                    }
                }
            }
        });
        return go($author$project$SortedAnySet$empty);
    }();
    var $author$project$Expression$Utils$y = $author$project$Expression$Variable("y");
    var $author$project$UI$Glsl$getGlsl_fn = function (expandIntervals, rayDifferentials, graph) {
        var build2d = F3(function (toSrc, prefix, e) {
            return {
                z: e,
                am: 1,
                ao: _List_fromArray([
                    { bc: true, dw: "pixel" + prefix }
                ]),
                ap: _List_Nil,
                C: A2(toSrc, prefix, e),
                at: false
            };
        });
        var extract = F2(function (prefix, g) {
            switch (g.$) {
                case 0:
                    var c = g.a;
                    return A3(build2d, $author$project$UI$Glsl$Code$toSrcImplicit, prefix, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$y, c));
                case 2:
                    var l = g.a;
                    var r = g.b;
                    return A3(build2d, $author$project$UI$Glsl$Code$toSrcImplicit, prefix, $author$project$Expression$Utils$minus_fn(l, r));
                case 3:
                    var e = g.a;
                    return A3(build2d, $author$project$UI$Glsl$Code$toSrcPolar, prefix, e);
                case 5:
                    var x = g.a;
                    var y = g.b;
                    var e = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                        $author$project$Expression$Utils$square($author$project$Expression$Utils$minus_fn($author$project$Expression$Variable("x"), x)),
                        $author$project$Expression$Utils$square($author$project$Expression$Utils$minus_fn($author$project$Expression$Variable("y"), y))
                    ]));
                    return {
                        z: e,
                        am: 0,
                        ao: _List_fromArray([
                            { bc: true, dw: "pixel" + prefix }
                        ]),
                        ap: _List_Nil,
                        C: $author$project$UI$Glsl$Code$toSrcParametric_fn(expandIntervals, prefix, e),
                        at: false
                    };
                case 1:
                    var e = g.a;
                    return A3(build2d, $author$project$UI$Glsl$Code$toSrcRelation, prefix, e);
                case 7:
                    var e = g.a;
                    return {
                        z: e,
                        am: 1,
                        ao: _List_fromArray([
                            { bc: false, dw: "pixel" + prefix }
                        ]),
                        ap: _List_Nil,
                        C: $author$project$UI$Glsl$Code$toSrcContour_fn(prefix, e),
                        at: true
                    };
                case 6:
                    var e = g.a;
                    var f = $author$project$UI$Glsl$get3DSource_fn(expandIntervals, prefix, e);
                    return {
                        z: f.z,
                        am: 2,
                        ao: _List_Nil,
                        ap: _List_fromArray([prefix]),
                        C: f.C,
                        at: true
                    };
                case 8:
                    var children = g.a;
                    var prefix_ = function (i) {
                        return prefix + ("_" + $elm$core$String$fromInt(i));
                    };
                    var extracted = $elm$core$List$indexedMap_fn(A2($elm$core$Basics$composeL, extract, prefix_), children);
                    return {
                        z: $author$project$Expression$List($elm$core$List$map_fn(function ($) {
                            return $.z;
                        }, extracted)),
                        am: $elm$core$List$any_fn(function (c) {
                            return c.am !== 1;
                        }, extracted) ? 2 : 1,
                        ao: $elm$core$List$concatMap_fn(function ($) {
                            return $.ao;
                        }, extracted),
                        ap: $elm$core$List$concatMap_fn(function ($) {
                            return $.ap;
                        }, extracted),
                        C: $elm$core$String$join_fn("\n", $elm$core$List$map_fn(function ($) {
                            return $.C;
                        }, extracted)),
                        at: $elm$core$List$any_fn(function ($) {
                            return $.at;
                        }, extracted)
                    };
                default:
                    var x = g.a;
                    var y = g.b;
                    return {
                        z: $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Arg), _List_fromArray([x, y])),
                        am: 1,
                        ao: _List_fromArray([
                            { bc: false, dw: "pixel" + prefix }
                        ]),
                        ap: _List_Nil,
                        C: $author$project$UI$Glsl$Code$toSrcVectorField2D_fn(prefix, x, y),
                        at: true
                    };
            }
        });
        var _v1 = A2(extract, "", graph);
        var expr = _v1.z;
        var srcExpr = _v1.C;
        var interval = _v1.am;
        var usesThetaDelta = _v1.at;
        var pixel2D = _v1.ao;
        var pixel3D = _v1.ap;
        var reqs = $elm$core$String$join_fn("\n", $elm$core$List$map_fn($author$project$UI$Glsl$requirementToGlsl(interval), _List_sortWith_fn($author$project$UI$Glsl$requirementSort, $author$project$UI$Glsl$transitiveClosure($author$project$UI$Glsl$expressionToRequirements(expr)))));
        var thetaDeltaCode = usesThetaDelta ? A2($author$project$UI$Glsl$Code$deindent, 4, $author$project$UI$Glsl$Code$thetaDelta) : "";
        return thetaDeltaCode + (reqs + ("\n/* Expression */\n" + (A2($author$project$UI$Glsl$Code$deindent, 4, srcExpr) + $author$project$UI$Glsl$Code$mainGlsl_fn(rayDifferentials, pixel2D, pixel3D))));
    }, $author$project$UI$Glsl$getGlsl = F3($author$project$UI$Glsl$getGlsl_fn);
    var $elm$html$Html$Attributes$id_a0 = "id", $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty($elm$html$Html$Attributes$id_a0);
    var $author$project$Expression$NumericRange$Complex = 6;
    var $author$project$Expression$NumericRange$Positive = 0;
    var $author$project$Expression$NumericRange$Nonnegative = 1;
    var $author$project$Expression$NumericRange$Real = 5;
    var $author$project$Expression$NumericRange$Zero = 2;
    var $elm$core$Basics$abs = function (n) {
        return (n < 0) ? (-n) : n;
    };
    var $author$project$Expression$NumericRange$Negative = 4;
    var $author$project$Expression$NumericRange$addRange_fn = function (arg1, arg2) {
        if (_Utils_eq(arg1, arg2)) {
            return arg1;
        }
        else {
            var _v0 = _Utils_Tuple2(arg1, arg2);
            _v0$1: while (true) {
                _v0$2: while (true) {
                    _v0$3: while (true) {
                        _v0$8: while (true) {
                            switch (_v0.a) {
                                case 2:
                                    var _v1 = _v0.a;
                                    return arg2;
                                case 6:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$2;
                                        default:
                                            break _v0$2;
                                    }
                                case 0:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$3;
                                        case 1:
                                            var _v5 = _v0.a;
                                            var _v6 = _v0.b;
                                            return 0;
                                        default:
                                            break _v0$8;
                                    }
                                case 1:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$3;
                                        case 0:
                                            var _v7 = _v0.a;
                                            var _v8 = _v0.b;
                                            return 0;
                                        default:
                                            break _v0$8;
                                    }
                                case 3:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$3;
                                        case 4:
                                            var _v9 = _v0.a;
                                            var _v10 = _v0.b;
                                            return 4;
                                        default:
                                            break _v0$8;
                                    }
                                case 4:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$3;
                                        case 3:
                                            var _v11 = _v0.a;
                                            var _v12 = _v0.b;
                                            return 4;
                                        default:
                                            break _v0$8;
                                    }
                                default:
                                    switch (_v0.b) {
                                        case 2:
                                            break _v0$1;
                                        case 6:
                                            break _v0$3;
                                        default:
                                            break _v0$8;
                                    }
                            }
                        }
                        return 5;
                    }
                    var _v4 = _v0.b;
                    return 6;
                }
                var _v3 = _v0.a;
                return 6;
            }
            var _v2 = _v0.b;
            return arg1;
        }
    }, $author$project$Expression$NumericRange$addRange = F2($author$project$Expression$NumericRange$addRange_fn);
    var $author$project$Expression$filterContext_a0 = $elm$core$Dict$toList, $author$project$Expression$filterContext_a1 = A2($elm$core$Basics$composeR, $elm$core$List$filterMap(function (_v0) {
        var k = _v0.a;
        var mv = _v0.b;
        return $elm$core$Maybe$map_fn($elm$core$Tuple$pair(k), mv);
    }), $elm$core$Dict$fromList), $author$project$Expression$filterContext = A2($elm$core$Basics$composeR, $author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1);
    var $author$project$Expression$NumericRange$Nonpositive = 3;
    var $author$project$Expression$NumericRange$negateRange = function (range) {
        switch (range) {
            case 0:
                return 4;
            case 1:
                return 3;
            case 2:
                return 2;
            case 3:
                return 1;
            case 4:
                return 0;
            case 5:
                return 5;
            default:
                return 6;
        }
    };
    var $author$project$Expression$NumericRange$union_fn = function (arg1, arg2) {
        if (_Utils_eq(arg1, arg2)) {
            return arg1;
        }
        else {
            var _v0 = _Utils_Tuple2(arg1, arg2);
            _v0$1: while (true) {
                _v0$10: while (true) {
                    switch (_v0.a) {
                        case 6:
                            var _v1 = _v0.a;
                            return 6;
                        case 2:
                            switch (_v0.b) {
                                case 6:
                                    break _v0$1;
                                case 0:
                                    var _v5 = _v0.a;
                                    var _v6 = _v0.b;
                                    return 1;
                                case 4:
                                    var _v9 = _v0.a;
                                    var _v10 = _v0.b;
                                    return 3;
                                default:
                                    break _v0$10;
                            }
                        case 1:
                            switch (_v0.b) {
                                case 6:
                                    break _v0$1;
                                case 0:
                                    var _v11 = _v0.a;
                                    var _v12 = _v0.b;
                                    return 1;
                                default:
                                    break _v0$10;
                            }
                        case 0:
                            switch (_v0.b) {
                                case 6:
                                    break _v0$1;
                                case 2:
                                    var _v3 = _v0.a;
                                    var _v4 = _v0.b;
                                    return 1;
                                case 1:
                                    var _v13 = _v0.a;
                                    var _v14 = _v0.b;
                                    return 1;
                                default:
                                    break _v0$10;
                            }
                        case 3:
                            switch (_v0.b) {
                                case 6:
                                    break _v0$1;
                                case 4:
                                    var _v15 = _v0.a;
                                    var _v16 = _v0.b;
                                    return 3;
                                default:
                                    break _v0$10;
                            }
                        case 4:
                            switch (_v0.b) {
                                case 6:
                                    break _v0$1;
                                case 2:
                                    var _v7 = _v0.a;
                                    var _v8 = _v0.b;
                                    return 3;
                                case 3:
                                    var _v17 = _v0.a;
                                    var _v18 = _v0.b;
                                    return 3;
                                default:
                                    break _v0$10;
                            }
                        default:
                            if (_v0.b === 6) {
                                break _v0$1;
                            }
                            else {
                                break _v0$10;
                            }
                    }
                }
                return 5;
            }
            var _v2 = _v0.b;
            return 6;
        }
    }, $author$project$Expression$NumericRange$union = F2($author$project$Expression$NumericRange$union_fn);
    var $author$project$Expression$NumericRange$multiplyRange_fn = function (arg1, arg2) {
        var _v0 = _Utils_Tuple2(arg1, arg2);
        _v0$1: while (true) {
            _v0$2: while (true) {
                _v0$3: while (true) {
                    _v0$4: while (true) {
                        _v0$5: while (true) {
                            _v0$6: while (true) {
                                _v0$7: while (true) {
                                    _v0$8: while (true) {
                                        _v0$9: while (true) {
                                            _v0$10: while (true) {
                                                switch (_v0.a) {
                                                    case 2:
                                                        var _v1 = _v0.a;
                                                        return 2;
                                                    case 6:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$2;
                                                            case 5:
                                                                break _v0$2;
                                                            case 0:
                                                                break _v0$2;
                                                            case 4:
                                                                break _v0$2;
                                                            case 1:
                                                                break _v0$2;
                                                            default:
                                                                break _v0$2;
                                                        }
                                                    case 5:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$3;
                                                            case 5:
                                                                break _v0$4;
                                                            case 0:
                                                                break _v0$4;
                                                            case 4:
                                                                break _v0$4;
                                                            case 1:
                                                                break _v0$4;
                                                            default:
                                                                break _v0$4;
                                                        }
                                                    case 0:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$3;
                                                            case 5:
                                                                break _v0$5;
                                                            case 0:
                                                                break _v0$6;
                                                            case 4:
                                                                break _v0$6;
                                                            case 1:
                                                                break _v0$6;
                                                            default:
                                                                break _v0$6;
                                                        }
                                                    case 4:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$3;
                                                            case 5:
                                                                break _v0$5;
                                                            case 0:
                                                                break _v0$7;
                                                            case 4:
                                                                break _v0$8;
                                                            case 1:
                                                                break _v0$8;
                                                            default:
                                                                break _v0$8;
                                                        }
                                                    case 1:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$3;
                                                            case 5:
                                                                break _v0$5;
                                                            case 0:
                                                                break _v0$7;
                                                            case 4:
                                                                break _v0$9;
                                                            case 1:
                                                                break _v0$10;
                                                            default:
                                                                break _v0$10;
                                                        }
                                                    default:
                                                        switch (_v0.b) {
                                                            case 2:
                                                                break _v0$1;
                                                            case 6:
                                                                break _v0$3;
                                                            case 5:
                                                                break _v0$5;
                                                            case 0:
                                                                break _v0$7;
                                                            case 4:
                                                                break _v0$9;
                                                            case 1:
                                                                var _v12 = _v0.b;
                                                                return $author$project$Expression$NumericRange$union_fn(arg1, 2);
                                                            default:
                                                                var _v13 = _v0.a;
                                                                return $author$project$Expression$NumericRange$union_fn($author$project$Expression$NumericRange$negateRange(arg2), 2);
                                                        }
                                                }
                                            }
                                            var _v11 = _v0.a;
                                            return $author$project$Expression$NumericRange$union_fn(arg2, 2);
                                        }
                                        var _v10 = _v0.b;
                                        return $author$project$Expression$NumericRange$negateRange(arg1);
                                    }
                                    var _v9 = _v0.a;
                                    return $author$project$Expression$NumericRange$negateRange(arg2);
                                }
                                var _v8 = _v0.b;
                                return arg1;
                            }
                            var _v7 = _v0.a;
                            return arg2;
                        }
                        var _v6 = _v0.b;
                        return 5;
                    }
                    var _v5 = _v0.a;
                    return 5;
                }
                var _v4 = _v0.b;
                return 6;
            }
            var _v3 = _v0.a;
            return 6;
        }
        var _v2 = _v0.b;
        return 2;
    }, $author$project$Expression$NumericRange$multiplyRange = F2($author$project$Expression$NumericRange$multiplyRange_fn);
    var $author$project$Expression$NumericRange$sign = function (j) {
        return (!j) ? 2 : ((j > 0) ? 0 : 4);
    };
    var $author$project$Expression$NumericRange$sqrtRange = function (v) {
        switch (v) {
            case 1:
                return 1;
            case 0:
                return 0;
            case 2:
                return 2;
            default:
                return 6;
        }
    };
    var $author$project$Expression$NumericRange$squareRange = function (v) {
        switch (v) {
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 1;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 6;
        }
    };
    var $author$project$Expression$NumericRange$getRange_fn = function (ctx, e) {
        var result = function () {
            _v13$19: while (true) {
                switch (e.$) {
                    case 2:
                        var v = e.a;
                        return $elm$core$Maybe$withDefault_fn(5, $elm$core$Dict$get_fn(v, ctx));
                    case 0:
                        var j = e.a;
                        return $author$project$Expression$NumericRange$sign(j);
                    case 1:
                        var j = e.a;
                        return $author$project$Expression$NumericRange$sign(j);
                    case 4:
                        var _v14 = e.a;
                        var c = e.b;
                        return $author$project$Expression$NumericRange$negateRange($author$project$Expression$NumericRange$getRange_fn(ctx, c));
                    case 5:
                        if (e.a === 1) {
                            var _v15 = e.a;
                            var b = e.b;
                            var ex = e.c;
                            return $author$project$Expression$NumericRange$powerRange_fn(ctx, $author$project$Expression$NumericRange$getRange_fn(ctx, b), ex);
                        }
                        else {
                            var _v16 = e.a;
                            var n = e.b;
                            var d = e.c;
                            return $author$project$Expression$NumericRange$multiplyRange_fn($author$project$Expression$NumericRange$getRange_fn(ctx, n), $author$project$Expression$NumericRange$getRange_fn(ctx, d));
                        }
                    case 6:
                        return 1;
                    case 7:
                        if (!e.a) {
                            var _v17 = e.a;
                            var l = e.b;
                            var m = e.c;
                            var o = e.d;
                            return $elm$core$List$foldl_fn($author$project$Expression$NumericRange$addRange, $author$project$Expression$NumericRange$getRange_fn(ctx, l), $elm$core$List$map_fn($author$project$Expression$NumericRange$getRange(ctx), _List_Cons(m, o)));
                        }
                        else {
                            var _v18 = e.a;
                            var l = e.b;
                            var m = e.c;
                            var o = e.d;
                            return $elm$core$List$foldl_fn($author$project$Expression$NumericRange$multiplyRange, $author$project$Expression$NumericRange$getRange_fn(ctx, l), $elm$core$List$map_fn($author$project$Expression$NumericRange$getRange(ctx), _List_Cons(m, o)));
                        }
                    case 10:
                        var es = e.a;
                        if (!es.b) {
                            return 2;
                        }
                        else {
                            var h = es.a;
                            var t = es.b;
                            return $elm$core$List$foldl_fn($author$project$Expression$NumericRange$union, $author$project$Expression$NumericRange$getRange_fn(ctx, h), $elm$core$List$map_fn($author$project$Expression$NumericRange$getRange(ctx), t));
                        }
                    case 8:
                        if (!e.a.$) {
                            switch (e.a.a.$) {
                                case 10:
                                    if (e.b.b && (!e.b.b.b)) {
                                        var _v20 = e.a.a;
                                        var _v21 = e.b;
                                        var c = _v21.a;
                                        var _v22 = $author$project$Expression$NumericRange$getRange_fn(ctx, c);
                                        switch (_v22) {
                                            case 0:
                                                return 0;
                                            case 4:
                                                return 0;
                                            case 2:
                                                return 2;
                                            default:
                                                return 1;
                                        }
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 18:
                                    if (e.b.b && (!e.b.b.b)) {
                                        var _v23 = e.a.a;
                                        var _v24 = e.b;
                                        var c = _v24.a;
                                        var _v25 = $author$project$Expression$NumericRange$getRange_fn(ctx, c);
                                        if (_v25 === 6) {
                                            return 5;
                                        }
                                        else {
                                            var o = _v25;
                                            return o;
                                        }
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 11:
                                    if (e.b.b && (!e.b.b.b)) {
                                        switch (e.a.a.a) {
                                            case 2:
                                                var _v26 = e.b;
                                                var c = _v26.a;
                                                return $author$project$Expression$NumericRange$sqrtRange($author$project$Expression$NumericRange$getRange_fn(ctx, c));
                                            case 3:
                                                var _v27 = e.b;
                                                var c = _v27.a;
                                                return $author$project$Expression$NumericRange$getRange_fn(ctx, c);
                                            default:
                                                break _v13$19;
                                        }
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 16:
                                    if (e.b.b && (!e.b.b.b)) {
                                        var _v28 = e.a.a;
                                        var _v29 = e.b;
                                        return 5;
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 17:
                                    if (e.b.b && (!e.b.b.b)) {
                                        var _v30 = e.a.a;
                                        var _v31 = e.b;
                                        return 5;
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 6:
                                    if ((e.b.b && e.b.b.b) && (!e.b.b.b.b)) {
                                        var _v32 = e.a.a;
                                        var _v33 = e.b;
                                        var y = _v33.a;
                                        var _v34 = _v33.b;
                                        var x = _v34.a;
                                        return (($author$project$Expression$NumericRange$getRange_fn(ctx, y) !== 6) && ($author$project$Expression$NumericRange$getRange_fn(ctx, x) !== 6)) ? 5 : 6;
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 28:
                                    if (((e.b.b && e.b.b.b) && e.b.b.b.b) && (!e.b.b.b.b.b)) {
                                        var _v35 = e.a.a;
                                        var _v36 = e.b;
                                        var _v37 = _v36.b;
                                        var t = _v37.a;
                                        var _v38 = _v37.b;
                                        var f = _v38.a;
                                        return $author$project$Expression$NumericRange$union_fn($author$project$Expression$NumericRange$getRange_fn(ctx, t), $author$project$Expression$NumericRange$getRange_fn(ctx, f));
                                    }
                                    else {
                                        break _v13$19;
                                    }
                                case 35:
                                    var _v39 = e.a.a;
                                    return 6;
                                default:
                                    break _v13$19;
                            }
                        }
                        else {
                            return 6;
                        }
                    case 9:
                        var variables = e.a;
                        var c = e.b;
                        return $author$project$Expression$NumericRange$getRange_fn($elm$core$List$foldl_fn(function (_v40) {
                            var k = _v40.a;
                            var v = _v40.b;
                            return A2($elm$core$Dict$insert, k, $author$project$Expression$NumericRange$getRange_fn(ctx, v));
                        }, ctx, $elm$core$Dict$toList($elm$core$Basics$composeR_fn($author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1, variables))), c);
                    default:
                        var x = e.a;
                        var f = e.b;
                        return $author$project$Expression$NumericRange$getRange_fn($elm$core$Dict$remove_fn(x, ctx), f);
                }
            }
            var args = e.b;
            return $elm$core$List$any_fn(function (c) {
                return $author$project$Expression$NumericRange$getRange_fn(ctx, c) === 6;
            }, args) ? 6 : 5;
        }();
        return result;
    }, $author$project$Expression$NumericRange$getRange = F2($author$project$Expression$NumericRange$getRange_fn);
    var $author$project$Expression$NumericRange$powerRange_fn = function (ctx, brange, ex) {
        var _default = function (_v12) {
            var _v2 = _Utils_Tuple2(brange, $author$project$Expression$NumericRange$getRange_fn(ctx, ex));
            _v2$0: while (true) {
                switch (_v2.a) {
                    case 2:
                        switch (_v2.b) {
                            case 2:
                                break _v2$0;
                            case 0:
                                var _v4 = _v2.a;
                                var _v5 = _v2.b;
                                return 2;
                            case 4:
                                var _v6 = _v2.a;
                                var _v7 = _v2.b;
                                return 2;
                            default:
                                var _v8 = _v2.a;
                                return 1;
                        }
                    case 0:
                        if (_v2.b === 2) {
                            break _v2$0;
                        }
                        else {
                            var _v9 = _v2.a;
                            var ek = _v2.b;
                            switch (ek) {
                                case 6:
                                    return 6;
                                case 2:
                                    return 0;
                                default:
                                    return 1;
                            }
                        }
                    case 1:
                        if (_v2.b === 2) {
                            break _v2$0;
                        }
                        else {
                            var _v11 = _v2.a;
                            var ek = _v2.b;
                            return (ek === 6) ? 6 : 1;
                        }
                    default:
                        if (_v2.b === 2) {
                            break _v2$0;
                        }
                        else {
                            return 6;
                        }
                }
            }
            var _v3 = _v2.b;
            return 0;
        };
        var asInteger = function (n) {
            switch (n.$) {
                case 0:
                    var i = n.a;
                    return $elm$core$Maybe$Just(i);
                case 1:
                    var f = n.a;
                    var rounded = $elm$core$Basics$round(f);
                    return _Utils_eq(rounded, f) ? $elm$core$Maybe$Just(rounded) : $elm$core$Maybe$Nothing;
                default:
                    return $elm$core$Maybe$Nothing;
            }
        };
        var _v0 = asInteger(ex);
        if (!_v0.$) {
            var j = _v0.a;
            return ($elm$core$Basics$abs(j) > 10) ? _default(0) : ((_Basics_modBy_fn(2, j) === 1) ? brange : ((!j) ? _default(0) : $author$project$Expression$NumericRange$squareRange(brange)));
        }
        else {
            return _default(0);
        }
    }, $author$project$Expression$NumericRange$powerRange = F3($author$project$Expression$NumericRange$powerRange_fn);
    var $author$project$Expression$NumericRange$get_a0 = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("i", 6),
        _Utils_Tuple2("e", 0),
        _Utils_Tuple2("pi", 0)
    ])), $author$project$Expression$NumericRange$get = $author$project$Expression$NumericRange$getRange($author$project$Expression$NumericRange$get_a0);
    var $author$project$Expression$NumericRange$isCompletelyReal_a0 = $author$project$Expression$NumericRange$get, $author$project$Expression$NumericRange$isCompletelyReal_a1 = $elm$core$Basics$neq(6), $author$project$Expression$NumericRange$isCompletelyReal = A2($elm$core$Basics$composeR, $author$project$Expression$NumericRange$isCompletelyReal_a0, $author$project$Expression$NumericRange$isCompletelyReal_a1);
    var $author$project$UI$Theme$lightIconAttrs = _List_fromArray([
        $lemol$ant_design_icons_elm_ui$Ant$Icon$width($author$project$UI$Theme$iconSize.dZ),
        $lemol$ant_design_icons_elm_ui$Ant$Icon$fill($author$project$UI$Theme$colors.dh)
    ]);
    var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
    var $author$project$Expression$Graph$toExpression = function (g) {
        toExpression: while (true) {
            switch (g.$) {
                case 0:
                    var e = g.a;
                    return e;
                case 1:
                    var e = g.a;
                    return e;
                case 2:
                    var l = g.a;
                    var r = g.b;
                    return $author$project$Expression$RelationOperation_fn(2, l, r);
                case 6:
                    var e = g.a;
                    return e;
                case 7:
                    var e = g.a;
                    return e;
                case 3:
                    var e = g.a;
                    return e;
                case 4:
                    var x = g.a;
                    var y = g.b;
                    return $author$project$Expression$List(_List_fromArray([x, y]));
                case 5:
                    var x = g.a;
                    var y = g.b;
                    return $author$project$Expression$List(_List_fromArray([x, y]));
                default:
                    if (g.a.b && (!g.a.b.b)) {
                        var _v1 = g.a;
                        var c = _v1.a;
                        var $temp$g = c;
                        g = $temp$g;
                        continue toExpression;
                    }
                    else {
                        var gs = g.a;
                        return $author$project$Expression$List($elm$core$List$map_fn($author$project$Expression$Graph$toExpression, gs));
                    }
            }
        }
    };
    var $author$project$Expression$toStringPrec_fn = function (p, e) {
        var paren = F2(function (b, c) {
            return b ? ("(" + (c + ")")) : c;
        });
        var noninfix = F2(function (op, c) {
            return A2(paren, p > 10, _Utils_ap(op, $author$project$Expression$toStringPrec_fn(11, c)));
        });
        var infixr_ = F4(function (n, op, l, r) {
            return A2(paren, _Utils_cmp(p, n) > 0, _Utils_ap($author$project$Expression$toStringPrec_fn(n + 1, l), _Utils_ap(op, $author$project$Expression$toStringPrec_fn(n, r))));
        });
        var infixl_ = F4(function (n, op, l, r) {
            return A2(paren, _Utils_cmp(p, n) > 0, _Utils_ap($author$project$Expression$toStringPrec_fn(n, l), _Utils_ap(op, $author$project$Expression$toStringPrec_fn(n + 1, r))));
        });
        var asVector = function (l) {
            var opened = $elm$core$List$filterMap_fn(function (el) {
                if (((el.$ === 11) && el.a.b) && (!el.a.b.b)) {
                    var _v8 = el.a;
                    var x = _v8.a;
                    return $elm$core$Maybe$Just(x);
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }, l);
            return _Utils_eq($elm$core$List$length(opened), $elm$core$List$length(l)) ? $elm$core$Maybe$Just(opened) : $elm$core$Maybe$Nothing;
        };
        _v0$14: while (true) {
            switch (e.$) {
                case 2:
                    var v = e.a;
                    return v;
                case 1:
                    var f = e.a;
                    return $elm$core$String$fromFloat(f);
                case 0:
                    var v = e.a;
                    return $elm$core$String$fromInt(v);
                case 5:
                    var expression = e.a;
                    return A2(noninfix, "-", expression);
                case 4:
                    switch (e.b.$) {
                        case 5:
                            var l = e.a;
                            var r = e.b.a;
                            return A4(infixl_, 6, " - ", l, r);
                        case 1:
                            var l = e.a;
                            var pf = e.b.a;
                            return (pf < 0) ? A4(infixl_, 6, " - ", l, $author$project$Expression$PFloat(-pf)) : A4(infixl_, 6, " + ", l, $author$project$Expression$PFloat(pf));
                        case 0:
                            var l = e.a;
                            var pi = e.b.a;
                            return (pi < 0) ? A4(infixl_, 6, " - ", l, $author$project$Expression$PInteger(-pi)) : A4(infixl_, 6, " + ", l, $author$project$Expression$PInteger(pi));
                        default:
                            var l = e.a;
                            var r = e.b;
                            return A4(infixl_, 6, " + ", l, r);
                    }
                case 8:
                    var rel = e.a;
                    var l = e.b;
                    var r = e.c;
                    return A4(infixl_, 5, " " + (rel + " "), l, r);
                case 6:
                    if (!e.a.$) {
                        var l = e.a;
                        var r = e.b;
                        switch (r.$) {
                            case 9:
                                return A4(infixl_, 7, "", l, r);
                            case 2:
                                return A4(infixl_, 7, "", l, r);
                            case 12:
                                return A4(infixl_, 7, "", l, r);
                            default:
                                return A4(infixl_, 7, "*", l, r);
                        }
                    }
                    else {
                        var l = e.a;
                        var r = e.b;
                        return A4(infixl_, 7, "*", l, r);
                    }
                case 7:
                    var l = e.a;
                    var r = e.b;
                    return A4(infixl_, 7, "/", l, r);
                case 9:
                    if (!e.b.$) {
                        switch (e.b.a) {
                            case 2:
                                var l = e.a;
                                return A2(paren, p > 8, $author$project$Expression$toStringPrec_fn(9, l) + "\u00B2");
                            case 3:
                                var l = e.a;
                                return A2(paren, p > 8, $author$project$Expression$toStringPrec_fn(9, l) + "\u00B3");
                            default:
                                break _v0$14;
                        }
                    }
                    else {
                        break _v0$14;
                    }
                case 3:
                    if ((((e.b.$ === 12) && e.b.b.b) && (e.b.b.a.$ === 2)) && (!e.b.b.b.b)) {
                        var x = e.a;
                        var f = e.b;
                        var fn = f.a;
                        var _v2 = f.b;
                        var v = _v2.a.a;
                        return _Utils_eq(v, x) ? $author$project$Expression$functionNameToString(fn) : A2(paren, p > 0, x + (" => " + $author$project$Expression$toStringPrec_fn(0, f)));
                    }
                    else {
                        var x = e.a;
                        var f = e.b;
                        return A2(paren, p > 0, x + (" => " + $author$project$Expression$toStringPrec_fn(0, f)));
                    }
                case 12:
                    if ((e.b.b && (e.b.a.$ === 11)) && (!e.b.b.b)) {
                        var name = e.a;
                        var _v3 = e.b;
                        var ex = _v3.a;
                        return A2(paren, p > 10, _Utils_ap($author$project$Expression$functionNameToString(name), $author$project$Expression$toStringPrec_fn(0, ex)));
                    }
                    else {
                        var name = e.a;
                        var ex = e.b;
                        return A2(paren, p > 10, $author$project$Expression$functionNameToString(name) + ("(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toStringPrec(0), ex)) + ")")));
                    }
                case 11:
                    var es = e.a;
                    var _v4 = asVector(es);
                    if (_v4.$ === 1) {
                        return "{" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toStringPrec(0), es)) + "}");
                    }
                    else {
                        var rs = _v4.a;
                        return "(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toStringPrec(0), rs)) + ")");
                    }
                default:
                    var _var = e.a;
                    var expr = e.b;
                    return "[" + ($elm$core$String$join_fn("; ", $elm$core$List$map_fn(function (_v5) {
                        var k = _v5.a;
                        var mv = _v5.b;
                        if (mv.$ === 1) {
                            return "!" + k;
                        }
                        else {
                            var v = mv.a;
                            var r = $author$project$Expression$toStringPrec_fn(0, v);
                            return $elm$core$String$join_fn(_String_contains_fn(" ", r) ? " " : "", _List_fromArray([k, "=", r]));
                        }
                    }, $elm$core$Dict$toList(_var))) + ("] " + $author$project$Expression$toStringPrec_fn(0, expr)));
            }
        }
        var l = e.a;
        var r = e.b;
        return A4(infixr_, 8, "^", l, r);
    }, $author$project$Expression$toStringPrec = F2($author$project$Expression$toStringPrec_fn);
    var $author$project$Expression$toString_a0 = $author$project$Expression$toPrintExpression, $author$project$Expression$toString_a1 = $author$project$Expression$toStringPrec(0), $author$project$Expression$toString = A2($elm$core$Basics$composeR, $author$project$Expression$toString_a0, $author$project$Expression$toString_a1);
    var $author$project$UI$Theme$whiteLines = 6;
    var $author$project$UI$RowView$draw_fn = function (_v0, id, _v1, _v2) {
        var width = _v0.bE;
        var height = _v0.bj;
        var wdiv = _v1.aL;
        var hdiv = _v1.bi;
        var graph = _v2.aw;
        var axes = _v2.aP;
        var rawImageWidth = $elm$core$Basics$min_fn(1920, width - ((8 + wdiv) * $author$project$UI$Theme$spacing));
        var rawImageHeight = $elm$core$Basics$min_fn(1080, height - ((14 + hdiv) * $author$project$UI$Theme$spacing));
        var noRound = { eI: 0, eJ: 0, gz: 0, gA: 0 };
        var isCompletelyReal = function (g) {
            switch (g.$) {
                case 8:
                    var gs = g.a;
                    return $elm$core$List$all_fn(isCompletelyReal, gs);
                case 7:
                    var e = g.a;
                    return $elm$core$Basics$composeR_fn($author$project$Expression$NumericRange$isCompletelyReal_a0, $author$project$Expression$NumericRange$isCompletelyReal_a1, e);
                default:
                    return false;
            }
        };
        var is3D = function (g) {
            switch (g.$) {
                case 8:
                    var gs = g.a;
                    return $elm$core$List$any_fn(is3D, gs);
                case 6:
                    return true;
                default:
                    return false;
            }
        };
        var imageWidth = $elm$core$Basics$min_fn(rawImageWidth, ((rawImageHeight * 4) / 3) | 0);
        var imageHeight = $elm$core$Basics$min_fn(rawImageHeight, ((rawImageWidth * 4) / 3) | 0);
        var iconButton = F3(function (msg, rounds, icon) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$behindContent_a0, $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                    $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
                    $miniBill$elm_ui_with_context$Element$WithContext$Background$color($mdgriffith$elm_ui$Internal$Model$Rgba_fn(0, 0, 0, 0.2)),
                    $miniBill$elm_ui_with_context$Element$WithContext$Border$roundEach(rounds)
                ]), $miniBill$elm_ui_with_context$Element$WithContext$none)),
                $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing),
                $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "on-parent-hover"))
            ]), {
                R: $miniBill$elm_ui_with_context$Element$WithContext$element(icon($author$project$UI$Theme$lightIconAttrs)),
                W: $elm$core$Maybe$Just(msg(id))
            });
        });
        var urButtonsRow = $miniBill$elm_ui_with_context$Element$WithContext$with_fn(function ($) {
            return $.bZ;
        }, function (hasClipboard) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$alignRight, $miniBill$elm_ui_with_context$Element$WithContext$alignTop]), hasClipboard ? _List_fromArray([
                A3(iconButton, $author$project$UI$Model$CopyCanvas, _Utils_update(noRound, { eI: $author$project$UI$Theme$spacing }), $lemol$ant_design_icons_elm_ui$Ant$Icons$copyOutlined),
                A3(iconButton, $author$project$UI$Model$SaveCanvas, noRound, $lemol$ant_design_icons_elm_ui$Ant$Icons$saveOutlined)
            ]) : _List_fromArray([
                A3(iconButton, $author$project$UI$Model$SaveCanvas, _Utils_update(noRound, { eI: $author$project$UI$Theme$spacing }), $lemol$ant_design_icons_elm_ui$Ant$Icons$saveOutlined)
            ]));
        });
        var brButtonsRow = $miniBill$elm_ui_with_context$Element$WithContext$with_fn($elm$core$Basics$identity, function (_v7) {
            var isFullscreen = _v7.dl;
            var hasFullscreen = _v7.b_;
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$alignRight, $miniBill$elm_ui_with_context$Element$WithContext$alignBottom]), isFullscreen ? _List_fromArray([
                A3(iconButton, $author$project$UI$Model$ResetZoom, _Utils_update(noRound, { gz: $author$project$UI$Theme$spacing }), $lemol$ant_design_icons_elm_ui$Ant$Icons$aimOutlined),
                A3(iconButton, $author$project$UI$Model$ExitFullscreenCanvas, noRound, $lemol$ant_design_icons_elm_ui$Ant$Icons$fullscreenExitOutlined)
            ]) : (hasFullscreen ? _List_fromArray([
                A3(iconButton, $author$project$UI$Model$ResetZoom, _Utils_update(noRound, { gz: $author$project$UI$Theme$spacing }), $lemol$ant_design_icons_elm_ui$Ant$Icons$aimOutlined),
                A3(iconButton, $author$project$UI$Model$FullscreenCanvas, noRound, $lemol$ant_design_icons_elm_ui$Ant$Icons$fullscreenOutlined)
            ]) : _List_fromArray([
                A3(iconButton, $author$project$UI$Model$ResetZoom, _Utils_update(noRound, { gz: $author$project$UI$Theme$spacing }), $lemol$ant_design_icons_elm_ui$Ant$Icons$aimOutlined)
            ])));
        });
        var boolToIntString = function (b) {
            return b ? "1" : "0";
        };
        var _v5 = id;
        var cid = _v5;
        var attrs = _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$inFront_a0, urButtonsRow),
            $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$inFront_a0, brButtonsRow),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$id_a0, cid + "-parent")),
            $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "hover-parent"))
        ]);
        return $miniBill$elm_ui_with_context$Element$WithContext$with_fn($elm$core$Basics$identity, function (_v6) {
            var rayDifferentials = _v6.ck;
            var expandIntervals = _v6.bU;
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, attrs, $miniBill$elm_ui_with_context$Element$WithContext$html(A3($elm$html$Html$node, "nu-plot", _List_fromArray([
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$id_a0, cid),
                $elm$virtual_dom$VirtualDom$property_fn("exprSrc", $elm$json$Json$Encode$string($author$project$UI$Glsl$getGlsl_fn(expandIntervals, rayDifferentials, graph))),
                $elm$virtual_dom$VirtualDom$attribute_fn("canvas-width", $elm$core$String$fromInt((imageWidth / wdiv) | 0)),
                $elm$virtual_dom$VirtualDom$attribute_fn("canvas-height", $elm$core$String$fromInt((imageHeight / hdiv) | 0)),
                $elm$virtual_dom$VirtualDom$attribute_fn("white-lines", $elm$core$String$fromInt($author$project$UI$Theme$whiteLines)),
                $elm$virtual_dom$VirtualDom$attribute_fn("completely-real", boolToIntString(isCompletelyReal(graph))),
                $elm$virtual_dom$VirtualDom$attribute_fn("draw-axes", boolToIntString(axes)),
                $elm$virtual_dom$VirtualDom$attribute_fn("is-3d", boolToIntString(is3D(graph))),
                $elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$title_a0, $elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, $author$project$Expression$Graph$toExpression(graph)))
            ]), _List_Nil)));
        });
    }, $author$project$UI$RowView$draw = F4($author$project$UI$RowView$draw_fn);
    var $author$project$Expression$genericAsMatrix_fn = function (asList, mx) {
        return $elm$core$Maybe$andThen_fn(function (ls) {
            var childLists = $elm$core$List$filterMap_fn(asList, ls);
            var lens = $elm$core$List$map_fn($elm$core$List$length, childLists);
            return (_Utils_eq($elm$core$List$length(ls), $elm$core$List$length(childLists)) && _Utils_eq($elm$core$List$minimum(lens), $elm$core$List$maximum(lens))) ? $elm$core$Maybe$Just(childLists) : $elm$core$Maybe$Nothing;
        }, asList(mx));
    }, $author$project$Expression$genericAsMatrix = F2($author$project$Expression$genericAsMatrix_fn);
    var $author$project$UI$Theme$bracketBorderWidth = 2;
    var $author$project$UI$Theme$bracketWidth = 8;
    var $mdgriffith$elm_ui$Element$InternalColumn = function (a) {
        return { $: 1, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$GridPosition = function (a) {
        return { $: 9, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$GridTemplateStyle = function (a) {
        return { $: 8, a: a };
    };
    var $mdgriffith$elm_ui$Internal$Model$AsGrid = 3;
    var $mdgriffith$elm_ui$Internal$Model$asGrid = 3;
    var $mdgriffith$elm_ui$Internal$Model$getSpacing_fn = function (attrs, _default) {
        return $elm$core$Maybe$withDefault_fn(_default, $elm$core$List$foldr_fn(F2(function (attr, acc) {
            if (!acc.$) {
                var x = acc.a;
                return $elm$core$Maybe$Just(x);
            }
            else {
                if ((attr.$ === 4) && (attr.b.$ === 5)) {
                    var _v2 = attr.b;
                    var x = _v2.b;
                    var y = _v2.c;
                    return $elm$core$Maybe$Just(_Utils_Tuple2(x, y));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
        }), $elm$core$Maybe$Nothing, attrs));
    }, $mdgriffith$elm_ui$Internal$Model$getSpacing = F2($mdgriffith$elm_ui$Internal$Model$getSpacing_fn);
    var $mdgriffith$elm_ui$Internal$Flag$gridPosition = $mdgriffith$elm_ui$Internal$Flag$flag(35);
    var $mdgriffith$elm_ui$Internal$Flag$gridTemplate = $mdgriffith$elm_ui$Internal$Flag$flag(34);
    var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
    var $elm$core$List$repeatHelp_fn = function (result, n, value) {
        repeatHelp: while (true) {
            if (n <= 0) {
                return result;
            }
            else {
                var $temp$result = _List_Cons(value, result), $temp$n = n - 1, $temp$value = value;
                result = $temp$result;
                n = $temp$n;
                value = $temp$value;
                continue repeatHelp;
            }
        }
    }, $elm$core$List$repeatHelp = F3($elm$core$List$repeatHelp_fn);
    var $elm$core$List$repeat_fn = function (n, value) {
        return $elm$core$List$repeatHelp_fn(_List_Nil, n, value);
    }, $elm$core$List$repeat = F2($elm$core$List$repeat_fn);
    var $mdgriffith$elm_ui$Element$tableHelper_fn = function (attrs, config) {
        var onGrid = F3(function (rowLevel, columnLevel, elem) {
            return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asEl, $mdgriffith$elm_ui$Internal$Model$div, _List_fromArray([
                $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$gridPosition, $mdgriffith$elm_ui$Internal$Model$GridPosition({ aG: columnLevel, bj: 1, f$: rowLevel, bE: 1 }))
            ]), $mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_fromArray([elem])));
        });
        var columnWidth = function (col) {
            if (!col.$) {
                var colConfig = col.a;
                return colConfig.bE;
            }
            else {
                var colConfig = col.a;
                return colConfig.bE;
            }
        };
        var columnHeader = function (col) {
            if (!col.$) {
                var colConfig = col.a;
                return colConfig.fb;
            }
            else {
                var colConfig = col.a;
                return colConfig.fb;
            }
        };
        var maybeHeaders = function (headers) {
            return $elm$core$List$all_fn($elm$core$Basics$eq($mdgriffith$elm_ui$Internal$Model$Empty), headers) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$List$indexedMap_fn(F2(function (col, header) {
                return A3(onGrid, 1, col + 1, header);
            }), headers));
        }($elm$core$List$map_fn(columnHeader, config.eS));
        var add = F3(function (cell, columnConfig, cursor) {
            if (!columnConfig.$) {
                var col = columnConfig.a;
                return _Utils_update(cursor, {
                    aj: cursor.aj + 1,
                    ab: _List_Cons(A3(onGrid, cursor.f$, cursor.aj, A2(col.gD, _Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? (cursor.f$ - 1) : (cursor.f$ - 2), cell)), cursor.ab)
                });
            }
            else {
                var col = columnConfig.a;
                return {
                    aj: cursor.aj + 1,
                    ab: _List_Cons(A3(onGrid, cursor.f$, cursor.aj, col.gD(cell)), cursor.ab),
                    f$: cursor.f$
                };
            }
        });
        var build = F3(function (columns, rowData, cursor) {
            var newCursor = $elm$core$List$foldl_fn(add(rowData), cursor, columns);
            return { aj: 1, ab: newCursor.ab, f$: cursor.f$ + 1 };
        });
        var children = $elm$core$List$foldl_fn(build(config.eS), {
            aj: 1,
            ab: _List_Nil,
            f$: _Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? 1 : 2
        }, config.G);
        var _v0 = $mdgriffith$elm_ui$Internal$Model$getSpacing_fn(attrs, _Utils_Tuple2(0, 0));
        var sX = _v0.a;
        var sY = _v0.b;
        var template = $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$gridTemplate, $mdgriffith$elm_ui$Internal$Model$GridTemplateStyle({
            eS: $elm$core$List$map_fn(columnWidth, config.eS),
            M: $elm$core$List$repeat_fn($elm$core$List$length(config.G), $mdgriffith$elm_ui$Internal$Model$Content),
            ga: _Utils_Tuple2($mdgriffith$elm_ui$Element$px(sX), $mdgriffith$elm_ui$Element$px(sY))
        }));
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asGrid, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill), _List_Cons(template, attrs)), $mdgriffith$elm_ui$Internal$Model$Unkeyed(function () {
            if (maybeHeaders.$ === 1) {
                return children.ab;
            }
            else {
                var renderedHeaders = maybeHeaders.a;
                return _Utils_ap(renderedHeaders, $elm$core$List$reverse(children.ab));
            }
        }()));
    }, $mdgriffith$elm_ui$Element$tableHelper = F2($mdgriffith$elm_ui$Element$tableHelper_fn);
    var $mdgriffith$elm_ui$Element$table_fn = function (attrs, config) {
        return $mdgriffith$elm_ui$Element$tableHelper_fn(attrs, {
            eS: $elm$core$List$map_fn($mdgriffith$elm_ui$Element$InternalColumn, config.eS),
            G: config.G
        });
    }, $mdgriffith$elm_ui$Element$table = F2($mdgriffith$elm_ui$Element$table_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$table_a0 = $mdgriffith$elm_ui$Element$table, $miniBill$elm_ui_with_context$Element$WithContext$table_a1 = F2(function (context, config) {
        return {
            eS: $elm$core$List$map_fn(function (col) {
                return {
                    fb: $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, col.fb),
                    gD: A2($elm$core$Basics$composeL, $miniBill$elm_ui_with_context$Element$WithContext$Internal$run(context), col.gD),
                    bE: col.bE
                };
            }, config.eS),
            G: config.G
        };
    }), $miniBill$elm_ui_with_context$Element$WithContext$table = A2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $miniBill$elm_ui_with_context$Element$WithContext$table_a0, $miniBill$elm_ui_with_context$Element$WithContext$table_a1);
    var $author$project$UI$Theme$grid_fn = function (attrs, rows) {
        if ($elm$core$List$isEmpty(rows)) {
            return $miniBill$elm_ui_with_context$Element$WithContext$none;
        }
        else {
            var w = $elm$core$Maybe$withDefault_fn(0, $elm$core$List$maximum($elm$core$List$map_fn($elm$core$List$length, rows)));
            var toColumn = function (i) {
                return {
                    fb: $miniBill$elm_ui_with_context$Element$WithContext$none,
                    gD: function (x) {
                        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$alignBottom]), $elm$core$Maybe$withDefault_fn($miniBill$elm_ui_with_context$Element$WithContext$none, $elm$core$List$head($elm$core$List$drop_fn(i, x))));
                    },
                    bE: $miniBill$elm_ui_with_context$Element$WithContext$shrink
                };
            };
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$table_a0, $miniBill$elm_ui_with_context$Element$WithContext$table_a1, _List_Cons($miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing), attrs), {
                eS: $elm$core$List$map_fn(toColumn, $elm$core$List$range_fn(0, w - 1)),
                G: rows
            });
        }
    }, $author$project$UI$Theme$grid = F2($author$project$UI$Theme$grid_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$paddingXY_fn = function (x, y) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$paddingXY_fn(x, y));
    }, $miniBill$elm_ui_with_context$Element$WithContext$paddingXY = F2($miniBill$elm_ui_with_context$Element$WithContext$paddingXY_fn);
    var $author$project$UI$RowView$bracketed_fn = function (l, r, blocks) {
        var grid = $author$project$UI$Theme$grid_fn(_List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$alignBottom]), blocks);
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$spacing(1),
            $miniBill$elm_ui_with_context$Element$WithContext$paddingXY_fn(2, 0)
        ]), _List_fromArray([l, grid, r]));
    }, $author$project$UI$RowView$bracketed = F3($author$project$UI$RowView$bracketed_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$px = $mdgriffith$elm_ui$Element$px;
    var $author$project$UI$RowView$simplyBracketed_fn = function (lw, lr, rw, rr, blocks) {
        var bracket = F2(function (we, re) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$px($author$project$UI$Theme$bracketWidth)),
                $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
                $miniBill$elm_ui_with_context$Element$WithContext$Border$widthEach(we),
                $miniBill$elm_ui_with_context$Element$WithContext$Border$roundEach(re)
            ]), $miniBill$elm_ui_with_context$Element$WithContext$none);
        });
        return $author$project$UI$RowView$bracketed_fn(A2(bracket, lw, lr), A2(bracket, rw, rr), blocks);
    }, $author$project$UI$RowView$simplyBracketed = F5($author$project$UI$RowView$simplyBracketed_fn);
    var $author$project$UI$RowView$roundBracketed_a0 = { cS: 0, dr: $author$project$UI$Theme$bracketBorderWidth, dO: 0, d4: 0 }, $author$project$UI$RowView$roundBracketed_a1 = { eI: 999, eJ: 0, gz: 999, gA: 0 }, $author$project$UI$RowView$roundBracketed_a2 = { cS: 0, dr: 0, dO: $author$project$UI$Theme$bracketBorderWidth, d4: 0 }, $author$project$UI$RowView$roundBracketed_a3 = { eI: 0, eJ: 999, gz: 0, gA: 999 }, $author$project$UI$RowView$roundBracketed = A4($author$project$UI$RowView$simplyBracketed, $author$project$UI$RowView$roundBracketed_a0, $author$project$UI$RowView$roundBracketed_a1, $author$project$UI$RowView$roundBracketed_a2, $author$project$UI$RowView$roundBracketed_a3);
    var $author$project$Complex$toString = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return (!y) ? $elm$core$String$fromFloat(x) : ((!x) ? ($elm$core$String$fromFloat(y) + "i") : ((y === 1) ? ($elm$core$String$fromFloat(x) + " + i") : (y === -1 ? ($elm$core$String$fromFloat(x) + " - i") : ((y > 0) ? ($elm$core$String$fromFloat(x) + (" + " + ($elm$core$String$fromFloat(y) + "i"))) : ($elm$core$String$fromFloat(x) + (" - " + ($elm$core$String$fromFloat(-y) + "i")))))));
    };
    var $elm$core$List$unzip = function (pairs) {
        var step = F2(function (_v0, _v1) {
            var x = _v0.a;
            var y = _v0.b;
            var xs = _v1.a;
            var ys = _v1.b;
            return _Utils_Tuple2(_List_Cons(x, xs), _List_Cons(y, ys));
        });
        return $elm$core$List$foldr_fn(step, _Utils_Tuple2(_List_Nil, _List_Nil), pairs);
    };
    var $author$project$Expression$Value$ComplexValue = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Expression$Value$ErrorValue = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Value$GraphValue = function (a) {
        return { $: 4, a: a };
    };
    var $author$project$Expression$Value$LambdaValue_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Expression$Value$LambdaValue = F2($author$project$Expression$Value$LambdaValue_fn);
    var $author$project$Expression$Value$ListValue = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Expression$Value$SolutionTreeValue = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$Value$SymbolicValue = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Complex$abs = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $elm$core$Basics$sqrt((x * x) + (y * y));
    };
    var $author$project$Complex$Complex_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Complex$Complex = F2($author$project$Complex$Complex_fn);
    var $author$project$Complex$by_fn = function (_v0, _v1) {
        var lr = _v0.a;
        var li = _v0.b;
        var rr = _v1.a;
        var ri = _v1.b;
        return $author$project$Complex$Complex_fn((lr * rr) - (li * ri), (li * rr) + (lr * ri));
    }, $author$project$Complex$by = F2($author$project$Complex$by_fn);
    var $author$project$Complex$i = $author$project$Complex$Complex_fn(0, 1);
    var $elm$core$Basics$e = _Basics_e;
    var $elm$core$Basics$atan2 = _Basics_atan2;
    var $author$project$Complex$arg = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Basics_atan2_fn(y, x);
    };
    var $author$project$Complex$toPolar = function (c) {
        return _Utils_Tuple2($author$project$Complex$abs(c), $author$project$Complex$arg(c));
    };
    var $author$project$Complex$ln = function (c) {
        var _v0 = $author$project$Complex$toPolar(c);
        var a = _v0.a;
        var t = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$logBase_fn($elm$core$Basics$e, a), t);
    };
    var $author$project$Complex$negate = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn(-x, -y);
    };
    var $author$project$Complex$plus_fn = function (_v0, _v1) {
        var lr = _v0.a;
        var li = _v0.b;
        var rr = _v1.a;
        var ri = _v1.b;
        return $author$project$Complex$Complex_fn(lr + rr, li + ri);
    }, $author$project$Complex$plus = F2($author$project$Complex$plus_fn);
    var $author$project$Complex$minus_fn = function (l, r) {
        return $author$project$Complex$plus_fn(l, $author$project$Complex$negate(r));
    }, $author$project$Complex$minus = F2($author$project$Complex$minus_fn);
    var $author$project$Complex$one = $author$project$Complex$Complex_fn(1, 0);
    var $author$project$Complex$sqrt = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        var a = $elm$core$Basics$sqrt((x * x) + (y * y));
        var mi = $elm$core$Basics$sqrt((a - x) / 2);
        var si = (y >= 0) ? mi : (-mi);
        var r = $elm$core$Basics$sqrt((a + x) / 2);
        return $author$project$Complex$Complex_fn(r, si);
    };
    var $author$project$Complex$acos = function (x) {
        return $author$project$Complex$negate($author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$ln($author$project$Complex$plus_fn(x, $author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$sqrt($author$project$Complex$minus_fn($author$project$Complex$one, $author$project$Complex$by_fn(x, x))))))));
    };
    var $author$project$Expression$Value$asList = function (v) {
        if (v.$ === 6) {
            var ls = v.a;
            return $elm$core$Maybe$Just(ls);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Expression$genericAsSquareMatrix = function (asList) {
        return A2($elm$core$Basics$composeR, $author$project$Expression$genericAsMatrix(asList), $elm$core$Maybe$andThen(function (rows) {
            return _Utils_eq($elm$core$Maybe$Just($elm$core$List$length(rows)), $elm$core$Maybe$map_fn($elm$core$List$length, $elm$core$List$head(rows))) ? $elm$core$Maybe$Just(rows) : $elm$core$Maybe$Nothing;
        }));
    };
    var $author$project$Expression$Value$asSquareMatrix = $author$project$Expression$genericAsSquareMatrix($author$project$Expression$Value$asList);
    var $author$project$Complex$asin = function (x) {
        return $author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$ln($author$project$Complex$minus_fn($author$project$Complex$sqrt($author$project$Complex$minus_fn($author$project$Complex$one, $author$project$Complex$by_fn(x, x))), $author$project$Complex$by_fn($author$project$Complex$i, x))));
    };
    var $author$project$Expression$Value$assocToList_fn = function (_default, f, xs) {
        if (!xs.b) {
            return _default;
        }
        else {
            var h = xs.a;
            var t = xs.b;
            return $elm$core$List$foldl_fn_unwrapped(function (e, a) {
                return A2(f, a, e);
            }, h, t);
        }
    }, $author$project$Expression$Value$assocToList_fn_unwrapped = function (_default, f, xs) {
        if (!xs.b) {
            return _default;
        }
        else {
            var h = xs.a;
            var t = xs.b;
            return $elm$core$List$foldl_fn_unwrapped(function (e, a) {
                return f(a, e);
            }, h, t);
        }
    }, $author$project$Expression$Value$assocToList = F3($author$project$Expression$Value$assocToList_fn);
    var $elm$core$Basics$cos = _Basics_cos;
    var $author$project$Complex$cosh_ = function (x) {
        return (_Basics_pow_fn($elm$core$Basics$e, x) + _Basics_pow_fn($elm$core$Basics$e, -x)) / 2;
    };
    var $elm$core$Basics$sin = _Basics_sin;
    var $author$project$Complex$sinh_ = function (x) {
        return (_Basics_pow_fn($elm$core$Basics$e, x) - _Basics_pow_fn($elm$core$Basics$e, -x)) / 2;
    };
    var $author$project$Complex$cos = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$cos(x) * $author$project$Complex$cosh_(y), $elm$core$Basics$sin(x) * $author$project$Complex$sinh_(y));
    };
    var $author$project$Complex$invert = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        var l = (x * x) + (y * y);
        return $author$project$Complex$Complex_fn(x / l, (-y) / l);
    };
    var $author$project$Complex$div_fn = function (l, r) {
        return $author$project$Complex$by_fn(l, $author$project$Complex$invert(r));
    }, $author$project$Complex$div = F2($author$project$Complex$div_fn);
    var $author$project$Complex$sin = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$sin(x) * $author$project$Complex$cosh_(y), $elm$core$Basics$cos(x) * $author$project$Complex$sinh_(y));
    };
    var $author$project$Complex$tan = function (c) {
        return $author$project$Complex$div_fn($author$project$Complex$sin(c), $author$project$Complex$cos(c));
    };
    var $author$project$Complex$atan = function (x) {
        return $author$project$Complex$negate($author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$tan($author$project$Complex$by_fn($author$project$Complex$i, x))));
    };
    var $author$project$Complex$fromReal = function (r) {
        return $author$project$Complex$Complex_fn(r, 0);
    };
    var $author$project$Complex$atan2_fn = function (y, x) {
        return $author$project$Complex$fromReal($author$project$Complex$arg($author$project$Complex$plus_fn(x, $author$project$Complex$by_fn($author$project$Complex$i, y))));
    }, $author$project$Complex$atan2 = F2($author$project$Complex$atan2_fn);
    var $author$project$Complex$ceiling = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$ceiling(x), $elm$core$Basics$ceiling(y));
    };
    var $author$project$Expression$Value$strings = {
        bN: { e0: "Cannot apply functions to ", fs: "Impossibile applicare funzioni a " },
        a6: { e0: "Cannot calculate the determinant of ", fs: "Impossibile calcolare il determinante di " },
        aR: { e0: "Cannot perform calculations on ", fs: "Impossibile effettuare operazioni su " },
        aT: { e0: "graphs", fs: "grafici" },
        aZ: { e0: "solution trees", fs: "alberi di soluzioni" }
    };
    var $author$project$Expression$Value$complexMap_fn = function (fs, v) {
        var lambda = fs.ad;
        var symbolic = fs.ah;
        var complex = fs.aa;
        var list = fs.ae;
        switch (v.$) {
            case 0:
                return v;
            case 5:
                var x = v.a;
                var f = v.b;
                if (!lambda.$) {
                    var l = lambda.a;
                    return A2(l, x, f);
                }
                else {
                    return $author$project$Expression$Value$LambdaValue_fn(x, $author$project$Expression$Value$complexMap_fn(fs, f));
                }
            case 6:
                var ls = v.a;
                if (!list.$) {
                    var lf = list.a;
                    return lf(ls);
                }
                else {
                    return $author$project$Expression$Value$ListValue($elm$core$List$map_fn($author$project$Expression$Value$complexMap(fs), ls));
                }
            case 3:
                var c = v.a;
                return $author$project$Expression$Value$ComplexValue(complex(c));
            case 4:
                return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.bN, $author$project$Expression$Value$strings.aT])));
            case 1:
                return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.bN, $author$project$Expression$Value$strings.aZ])));
            default:
                var w = v.a;
                return $author$project$Expression$Value$SymbolicValue(symbolic(w));
        }
    }, $author$project$Expression$Value$complexMap = F2($author$project$Expression$Value$complexMap_fn);
    var $author$project$Complex$cosh = function (x) {
        return $author$project$Complex$cos($author$project$Complex$by_fn($author$project$Complex$i, x));
    };
    var $author$project$Expression$Value$defaultValueContext = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("e", $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal($elm$core$Basics$e))),
        _Utils_Tuple2("pi", $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal($elm$core$Basics$pi))),
        _Utils_Tuple2("\u03C0", $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal($elm$core$Basics$pi)))
    ]));
    var $author$project$Expression$Utils$asList = function (ex) {
        if (ex.$ === 10) {
            var ls = ex.a;
            return $elm$core$Maybe$Just(ls);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Expression$Utils$asSquareMatrix = $author$project$Expression$genericAsSquareMatrix($author$project$Expression$Utils$asList);
    var $author$project$Expression$genericDeterminant_fn = function (_v0, mat) {
        var plus = _v0.ci;
        var negate = _v0.fC;
        var by = _v0.cT;
        _v1$5: while (true) {
            if (!mat.b) {
                return $elm$core$Maybe$Just(plus(_List_Nil));
            }
            else {
                if (mat.a.b) {
                    if (!mat.a.b.b) {
                        if (!mat.b.b) {
                            var _v2 = mat.a;
                            var single = _v2.a;
                            return $elm$core$Maybe$Just(single);
                        }
                        else {
                            break _v1$5;
                        }
                    }
                    else {
                        if (!mat.a.b.b.b) {
                            if ((((mat.b.b && mat.b.a.b) && mat.b.a.b.b) && (!mat.b.a.b.b.b)) && (!mat.b.b.b)) {
                                var _v3 = mat.a;
                                var a_ = _v3.a;
                                var _v4 = _v3.b;
                                var b_ = _v4.a;
                                var _v5 = mat.b;
                                var _v6 = _v5.a;
                                var c_ = _v6.a;
                                var _v7 = _v6.b;
                                var d_ = _v7.a;
                                return $elm$core$Maybe$Just(plus(_List_fromArray([
                                    by(_List_fromArray([a_, d_])),
                                    negate(by(_List_fromArray([b_, c_])))
                                ])));
                            }
                            else {
                                break _v1$5;
                            }
                        }
                        else {
                            if (!mat.a.b.b.b.b) {
                                if ((((((((((mat.b.b && mat.b.a.b) && mat.b.a.b.b) && mat.b.a.b.b.b) && (!mat.b.a.b.b.b.b)) && mat.b.b.b) && mat.b.b.a.b) && mat.b.b.a.b.b) && mat.b.b.a.b.b.b) && (!mat.b.b.a.b.b.b.b)) && (!mat.b.b.b.b)) {
                                    var _v8 = mat.a;
                                    var a_ = _v8.a;
                                    var _v9 = _v8.b;
                                    var b_ = _v9.a;
                                    var _v10 = _v9.b;
                                    var c_ = _v10.a;
                                    var _v11 = mat.b;
                                    var _v12 = _v11.a;
                                    var d_ = _v12.a;
                                    var _v13 = _v12.b;
                                    var e_ = _v13.a;
                                    var _v14 = _v13.b;
                                    var f_ = _v14.a;
                                    var _v15 = _v11.b;
                                    var _v16 = _v15.a;
                                    var g_ = _v16.a;
                                    var _v17 = _v16.b;
                                    var h_ = _v17.a;
                                    var _v18 = _v17.b;
                                    var i_ = _v18.a;
                                    return $elm$core$Maybe$Just(plus(_List_fromArray([
                                        by(_List_fromArray([a_, e_, i_])),
                                        negate(by(_List_fromArray([a_, f_, h_]))),
                                        negate(by(_List_fromArray([b_, d_, i_]))),
                                        by(_List_fromArray([b_, f_, g_])),
                                        by(_List_fromArray([c_, d_, h_])),
                                        negate(by(_List_fromArray([c_, e_, g_])))
                                    ])));
                                }
                                else {
                                    break _v1$5;
                                }
                            }
                            else {
                                if ((((((((((((((((((((!mat.a.b.b.b.b.b) && mat.b.b) && mat.b.a.b) && mat.b.a.b.b) && mat.b.a.b.b.b) && mat.b.a.b.b.b.b) && (!mat.b.a.b.b.b.b.b)) && mat.b.b.b) && mat.b.b.a.b) && mat.b.b.a.b.b) && mat.b.b.a.b.b.b) && mat.b.b.a.b.b.b.b) && (!mat.b.b.a.b.b.b.b.b)) && mat.b.b.b.b) && mat.b.b.b.a.b) && mat.b.b.b.a.b.b) && mat.b.b.b.a.b.b.b) && mat.b.b.b.a.b.b.b.b) && (!mat.b.b.b.a.b.b.b.b.b)) && (!mat.b.b.b.b.b)) {
                                    var _v19 = mat.a;
                                    var a_ = _v19.a;
                                    var _v20 = _v19.b;
                                    var b_ = _v20.a;
                                    var _v21 = _v20.b;
                                    var c_ = _v21.a;
                                    var _v22 = _v21.b;
                                    var d_ = _v22.a;
                                    var _v23 = mat.b;
                                    var _v24 = _v23.a;
                                    var e_ = _v24.a;
                                    var _v25 = _v24.b;
                                    var f_ = _v25.a;
                                    var _v26 = _v25.b;
                                    var g_ = _v26.a;
                                    var _v27 = _v26.b;
                                    var h_ = _v27.a;
                                    var _v28 = _v23.b;
                                    var _v29 = _v28.a;
                                    var i_ = _v29.a;
                                    var _v30 = _v29.b;
                                    var j_ = _v30.a;
                                    var _v31 = _v30.b;
                                    var k_ = _v31.a;
                                    var _v32 = _v31.b;
                                    var l_ = _v32.a;
                                    var _v33 = _v28.b;
                                    var _v34 = _v33.a;
                                    var m_ = _v34.a;
                                    var _v35 = _v34.b;
                                    var n_ = _v35.a;
                                    var _v36 = _v35.b;
                                    var o_ = _v36.a;
                                    var _v37 = _v36.b;
                                    var p_ = _v37.a;
                                    return $elm$core$Maybe$Just(plus(_List_fromArray([
                                        by(_List_fromArray([a_, f_, k_, p_])),
                                        negate(by(_List_fromArray([a_, f_, l_, o_]))),
                                        negate(by(_List_fromArray([a_, g_, j_, p_]))),
                                        by(_List_fromArray([a_, g_, l_, n_])),
                                        by(_List_fromArray([a_, h_, j_, o_])),
                                        negate(by(_List_fromArray([a_, h_, k_, n_]))),
                                        negate(by(_List_fromArray([b_, e_, k_, p_]))),
                                        by(_List_fromArray([b_, e_, l_, o_])),
                                        by(_List_fromArray([b_, g_, i_, p_])),
                                        negate(by(_List_fromArray([b_, g_, l_, m_]))),
                                        negate(by(_List_fromArray([b_, h_, i_, o_]))),
                                        by(_List_fromArray([b_, h_, k_, m_])),
                                        by(_List_fromArray([c_, e_, j_, p_])),
                                        negate(by(_List_fromArray([c_, e_, l_, n_]))),
                                        negate(by(_List_fromArray([c_, f_, i_, p_]))),
                                        by(_List_fromArray([c_, f_, l_, m_])),
                                        by(_List_fromArray([c_, h_, i_, n_])),
                                        negate(by(_List_fromArray([c_, h_, j_, m_]))),
                                        negate(by(_List_fromArray([d_, e_, j_, o_]))),
                                        by(_List_fromArray([d_, e_, k_, n_])),
                                        by(_List_fromArray([d_, f_, i_, o_])),
                                        negate(by(_List_fromArray([d_, f_, k_, m_]))),
                                        negate(by(_List_fromArray([d_, g_, i_, n_]))),
                                        by(_List_fromArray([d_, g_, j_, m_]))
                                    ])));
                                }
                                else {
                                    break _v1$5;
                                }
                            }
                        }
                    }
                }
                else {
                    break _v1$5;
                }
            }
        }
        return $elm$core$Maybe$Nothing;
    }, $author$project$Expression$genericDeterminant = F2($author$project$Expression$genericDeterminant_fn);
    var $author$project$Expression$Utils$determinant = function (expr) {
        var _v0 = $author$project$Expression$Utils$asSquareMatrix(expr);
        if (!_v0.$) {
            var rows = _v0.a;
            return $elm$core$Maybe$withDefault_fn($author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Det), _List_fromArray([expr])), $author$project$Expression$genericDeterminant_fn({ cT: $author$project$Expression$Utils$by, fC: $author$project$Expression$Utils$negate_, ci: $author$project$Expression$Utils$plus }, rows));
        }
        else {
            return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Det), _List_fromArray([expr]));
        }
    };
    var $author$project$Complex$exp = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn(_Basics_pow_fn($elm$core$Basics$e, x) * $elm$core$Basics$cos(y), _Basics_pow_fn($elm$core$Basics$e, x) * $elm$core$Basics$sin(y));
    };
    var $author$project$Complex$floor = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$floor(x), $elm$core$Basics$floor(y));
    };
    var $author$project$Expression$Graph$Contour = function (a) {
        return { $: 7, a: a };
    };
    var $author$project$Expression$Graph$Explicit2D = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$Graph$GraphList = function (a) {
        return { $: 8, a: a };
    };
    var $author$project$Expression$Graph$Implicit2D_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $author$project$Expression$Graph$Implicit2D = F2($author$project$Expression$Graph$Implicit2D_fn);
    var $author$project$Expression$Graph$Implicit3D = function (a) {
        return { $: 6, a: a };
    };
    var $author$project$Expression$Graph$Parametric2D_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $author$project$Expression$Graph$Parametric2D = F2($author$project$Expression$Graph$Parametric2D_fn);
    var $author$project$Expression$Graph$Polar2D = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Expression$Graph$Relation2D = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$Graph$VectorField2D_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Expression$Graph$VectorField2D = F2($author$project$Expression$Graph$VectorField2D_fn);
    var $elm$core$Dict$diff_fn = function (t1, t2) {
        return $elm$core$Dict$foldl_fn_unwrapped(function (k, v, t) {
            return $elm$core$Dict$remove_fn(k, t);
        }, t1, t2);
    }, $elm$core$Dict$diff = F2($elm$core$Dict$diff_fn);
    var $elm$core$Set$diff_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$diff_fn(dict1, dict2);
    }, $elm$core$Set$diff = F2($elm$core$Set$diff_fn);
    var $elm$core$Set$singleton = function (key) {
        return $elm$core$Dict$singleton_fn(key, 0);
    };
    var $elm$core$Set$union_fn = function (_v0, _v1) {
        var dict1 = _v0;
        var dict2 = _v1;
        return $elm$core$Dict$union_fn(dict1, dict2);
    }, $elm$core$Set$union = F2($elm$core$Set$union_fn);
    var $author$project$Expression$getFreeVariables = function (expr) {
        getFreeVariables: while (true) {
            var concatMap = A2($elm$core$List$foldl, A2($elm$core$Basics$composeL, $elm$core$Set$union, $author$project$Expression$getFreeVariables), $elm$core$Set$empty);
            switch (expr.$) {
                case 2:
                    var v = expr.a;
                    return $elm$core$Set$singleton(v);
                case 4:
                    var e = expr.b;
                    var $temp$expr = e;
                    expr = $temp$expr;
                    continue getFreeVariables;
                case 5:
                    var l = expr.b;
                    var r = expr.c;
                    return $elm$core$Set$union_fn($author$project$Expression$getFreeVariables(l), $author$project$Expression$getFreeVariables(r));
                case 6:
                    var l = expr.b;
                    var r = expr.c;
                    return $elm$core$Set$union_fn($author$project$Expression$getFreeVariables(l), $author$project$Expression$getFreeVariables(r));
                case 7:
                    var l = expr.b;
                    var r = expr.c;
                    var o = expr.d;
                    return $elm$core$Set$union_fn(concatMap(o), $elm$core$Set$union_fn($author$project$Expression$getFreeVariables(l), $author$project$Expression$getFreeVariables(r)));
                case 8:
                    var args = expr.b;
                    return concatMap(args);
                case 0:
                    return $elm$core$Set$empty;
                case 1:
                    return $elm$core$Set$empty;
                case 3:
                    var x = expr.a;
                    var f = expr.b;
                    return $elm$core$Set$diff_fn($author$project$Expression$getFreeVariables(f), $elm$core$Set$singleton(x));
                case 9:
                    var vars = expr.a;
                    var e = expr.b;
                    return $author$project$Expression$getFreeVariables(A2($author$project$Expression$fullSubstitute, $elm$core$Basics$composeR_fn($author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1, vars), e));
                default:
                    var es = expr.a;
                    return concatMap(es);
            }
        }
    };
    var $author$project$Expression$partialSubstitute_fn = function (_var, val) {
        return $author$project$Expression$fullSubstitute($elm$core$Dict$singleton_fn(_var, val));
    }, $author$project$Expression$partialSubstitute = F2($author$project$Expression$partialSubstitute_fn);
    var $author$project$Expression$Simplify$innerHoistLabmda = function (expr) {
        _v0$4: while (true) {
            switch (expr.$) {
                case 3:
                    var x = expr.a;
                    var f = expr.b;
                    return $elm$core$Maybe$Just($author$project$Expression$Lambda_fn(x, $author$project$Expression$Simplify$cyclic$hoistLambda()(f)));
                case 5:
                    if (expr.a === 1) {
                        var _v1 = expr.a;
                        var b = expr.b;
                        var e = expr.c;
                        var _v2 = _Utils_Tuple2($author$project$Expression$Simplify$cyclic$hoistLambda()(b), $author$project$Expression$Simplify$cyclic$hoistLambda()(e));
                        if (_v2.a.$ === 3) {
                            var _v3 = _v2.a;
                            var x = _v3.a;
                            var f = _v3.b;
                            var he = _v2.b;
                            return $elm$core$Maybe$Just($author$project$Expression$Lambda_fn(x, $author$project$Expression$Simplify$cyclic$hoistLambda()($author$project$Expression$BinaryOperation_fn(1, f, he))));
                        }
                        else {
                            return $elm$core$Maybe$Nothing;
                        }
                    }
                    else {
                        break _v0$4;
                    }
                case 7:
                    if (expr.a === 1) {
                        var _v4 = expr.a;
                        var l = expr.b;
                        var m = expr.c;
                        var r = expr.d;
                        var step = F2(function (curr, last) {
                            if (curr.$ === 3) {
                                var x = curr.a;
                                var f = curr.b;
                                return $elm$core$Maybe$Just($author$project$Expression$Simplify$cyclic$hoistLambda()(A3($author$project$Expression$partialSubstitute, x, last, f)));
                            }
                            else {
                                return $elm$core$Maybe$Nothing;
                            }
                        });
                        var grouped = $author$project$List$MyExtra$groupOneWith_fn(step, _List_Cons($author$project$Expression$Simplify$cyclic$hoistLambda()(l), _List_Cons($author$project$Expression$Simplify$cyclic$hoistLambda()(m), $elm$core$List$map_fn($author$project$Expression$Simplify$cyclic$hoistLambda(), r))));
                        return $elm$core$Maybe$Just(function () {
                            if (!grouped.b) {
                                return $author$project$Expression$Integer(1);
                            }
                            else {
                                if (!grouped.b.b) {
                                    var x = grouped.a;
                                    return x;
                                }
                                else {
                                    var x = grouped.a;
                                    var _v6 = grouped.b;
                                    var y = _v6.a;
                                    var zs = _v6.b;
                                    return $author$project$Expression$AssociativeOperation_fn(1, x, y, zs);
                                }
                            }
                        }());
                    }
                    else {
                        break _v0$4;
                    }
                case 8:
                    var fn = expr.a;
                    var args = expr.b;
                    var _v8 = _Utils_Tuple2(fn, $elm$core$List$map_fn($author$project$Expression$Simplify$cyclic$hoistLambda(), args));
                    _v8$2: while (true) {
                        _v8$3: while (true) {
                            if (!_v8.a.$) {
                                switch (_v8.a.a.$) {
                                    case 29:
                                        var _v9 = _v8.a.a;
                                        return $elm$core$Maybe$Nothing;
                                    case 30:
                                        var _v10 = _v8.a.a;
                                        return $elm$core$Maybe$Nothing;
                                    default:
                                        if ((_v8.b.b && (_v8.b.a.$ === 3)) && (!_v8.b.b.b)) {
                                            break _v8$2;
                                        }
                                        else {
                                            break _v8$3;
                                        }
                                }
                            }
                            else {
                                if ((_v8.b.b && (_v8.b.a.$ === 3)) && (!_v8.b.b.b)) {
                                    break _v8$2;
                                }
                                else {
                                    break _v8$3;
                                }
                            }
                        }
                        return $elm$core$Maybe$Nothing;
                    }
                    var _v11 = _v8.b;
                    var _v12 = _v11.a;
                    var x = _v12.a;
                    var f = _v12.b;
                    return $elm$core$Maybe$Just($author$project$Expression$Lambda_fn(x, $author$project$Expression$Simplify$cyclic$hoistLambda()($author$project$Expression$Apply_fn(fn, _List_fromArray([f])))));
                default:
                    break _v0$4;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    function $author$project$Expression$Simplify$cyclic$hoistLambda() {
        return $author$project$Expression$visit($author$project$Expression$Simplify$innerHoistLabmda);
    }
    var $author$project$Expression$Simplify$hoistLambda = $author$project$Expression$Simplify$cyclic$hoistLambda();
    $author$project$Expression$Simplify$cyclic$hoistLambda = function () {
        return $author$project$Expression$Simplify$hoistLambda;
    };
    var $elm$core$Dict$sizeHelp_fn = function (n, dict) {
        sizeHelp: while (true) {
            if (dict.$ === -2) {
                return n;
            }
            else {
                var left = dict.d;
                var right = dict.e;
                var $temp$n = $elm$core$Dict$sizeHelp_fn(n + 1, right), $temp$dict = left;
                n = $temp$n;
                dict = $temp$dict;
                continue sizeHelp;
            }
        }
    }, $elm$core$Dict$sizeHelp = F2($elm$core$Dict$sizeHelp_fn);
    var $elm$core$Dict$size = function (dict) {
        return $elm$core$Dict$sizeHelp_fn(0, dict);
    };
    var $author$project$Expression$equals_fn = function (l, r) {
        var _v0 = _Utils_Tuple2(l, r);
        switch (_v0.a.$) {
            case 4:
                if (_v0.b.$ === 4) {
                    var _v1 = _v0.a;
                    var lop = _v1.a;
                    var le = _v1.b;
                    var _v2 = _v0.b;
                    var rop = _v2.a;
                    var re = _v2.b;
                    return _Utils_eq(lop, rop) && $author$project$Expression$equals_fn(le, re);
                }
                else {
                    var _v3 = _v0.a;
                    return false;
                }
            case 5:
                if (_v0.b.$ === 5) {
                    var _v4 = _v0.a;
                    var lop = _v4.a;
                    var ll = _v4.b;
                    var lr = _v4.c;
                    var _v5 = _v0.b;
                    var rop = _v5.a;
                    var rl = _v5.b;
                    var rr = _v5.c;
                    return _Utils_eq(lop, rop) && ($author$project$Expression$equals_fn(ll, rl) && $author$project$Expression$equals_fn(lr, rr));
                }
                else {
                    var _v6 = _v0.a;
                    return false;
                }
            case 7:
                if (_v0.b.$ === 7) {
                    var _v7 = _v0.a;
                    var lop = _v7.a;
                    var ll = _v7.b;
                    var lr = _v7.c;
                    var lo = _v7.d;
                    var _v8 = _v0.b;
                    var rop = _v8.a;
                    var rl = _v8.b;
                    var rr = _v8.c;
                    var ro = _v8.d;
                    return _Utils_eq(lop, rop) && ($author$project$Expression$equals_fn(ll, rl) && ($author$project$Expression$equals_fn(lr, rr) && $author$project$Expression$listEquals_fn(lo, ro)));
                }
                else {
                    var _v9 = _v0.a;
                    return false;
                }
            case 8:
                if (_v0.b.$ === 8) {
                    var _v10 = _v0.a;
                    var lname = _v10.a;
                    var largs = _v10.b;
                    var _v11 = _v0.b;
                    var rname = _v11.a;
                    var rargs = _v11.b;
                    return _Utils_eq(lname, rname) && $author$project$Expression$listEquals_fn(largs, rargs);
                }
                else {
                    var _v12 = _v0.a;
                    return false;
                }
            case 2:
                if (_v0.b.$ === 2) {
                    var lv = _v0.a.a;
                    var rv = _v0.b.a;
                    return _Utils_eq(lv, rv);
                }
                else {
                    return false;
                }
            case 0:
                if (!_v0.b.$) {
                    var li = _v0.a.a;
                    var ri = _v0.b.a;
                    return _Utils_eq(li, ri);
                }
                else {
                    return false;
                }
            case 1:
                if (_v0.b.$ === 1) {
                    var lf = _v0.a.a;
                    var rf = _v0.b.a;
                    return _Utils_eq(lf, rf);
                }
                else {
                    return false;
                }
            case 9:
                if (_v0.b.$ === 9) {
                    var _v13 = _v0.a;
                    var ls = _v13.a;
                    var le = _v13.b;
                    var _v14 = _v0.b;
                    var rs = _v14.a;
                    var re = _v14.b;
                    var maybeEquals = F2(function (ln, rn) {
                        var _v17 = _Utils_Tuple2(ln, rn);
                        _v17$2: while (true) {
                            if (!_v17.a.$) {
                                if (!_v17.b.$) {
                                    var lne = _v17.a.a;
                                    var rne = _v17.b.a;
                                    return $author$project$Expression$equals_fn(lne, rne);
                                }
                                else {
                                    break _v17$2;
                                }
                            }
                            else {
                                if (_v17.b.$ === 1) {
                                    var _v18 = _v17.a;
                                    var _v19 = _v17.b;
                                    return true;
                                }
                                else {
                                    break _v17$2;
                                }
                            }
                        }
                        return false;
                    });
                    return _Utils_eq($elm$core$Dict$size(ls), $elm$core$Dict$size(rs)) && ($author$project$Expression$equals_fn(le, re) && $elm$core$List$all_fn($elm$core$Basics$identity, _List_map2_fn_unwrapped(function (_v15, _v16) {
                        var lc = _v15.a;
                        var ln = _v15.b;
                        var rc = _v16.a;
                        var rn = _v16.b;
                        return _Utils_eq(lc, rc) && A2(maybeEquals, ln, rn);
                    }, $elm$core$Dict$toList(ls), $elm$core$Dict$toList(rs))));
                }
                else {
                    var _v20 = _v0.a;
                    return false;
                }
            case 10:
                if (_v0.b.$ === 10) {
                    var ls = _v0.a.a;
                    var rs = _v0.b.a;
                    return $author$project$Expression$listEquals_fn(ls, rs);
                }
                else {
                    return false;
                }
            case 6:
                if (_v0.b.$ === 6) {
                    var _v21 = _v0.a;
                    var lop = _v21.a;
                    var ll = _v21.b;
                    var lr = _v21.c;
                    var _v22 = _v0.b;
                    var rop = _v22.a;
                    var rl = _v22.b;
                    var rr = _v22.c;
                    return _Utils_eq(lop, rop) && ($author$project$Expression$equals_fn(ll, rl) && $author$project$Expression$equals_fn(lr, rr));
                }
                else {
                    var _v23 = _v0.a;
                    return false;
                }
            default:
                if (_v0.b.$ === 3) {
                    var _v24 = _v0.a;
                    var x = _v24.a;
                    var f = _v24.b;
                    var _v25 = _v0.b;
                    var y = _v25.a;
                    var g = _v25.b;
                    var goat = $author$project$Expression$Variable("GOATFINDER");
                    var res = $author$project$Expression$equals_fn(A3($author$project$Expression$partialSubstitute, x, goat, f), A3($author$project$Expression$partialSubstitute, y, goat, g));
                    return res;
                }
                else {
                    var _v26 = _v0.a;
                    return false;
                }
        }
    }, $author$project$Expression$equals = F2($author$project$Expression$equals_fn);
    var $author$project$Expression$listEquals_fn = function (ls, rs) {
        return _Utils_eq($elm$core$List$length(ls), $elm$core$List$length(rs)) && $elm$core$List$all_fn($elm$core$Basics$identity, _List_map2_fn($author$project$Expression$equals, ls, rs));
    }, $author$project$Expression$listEquals = F2($author$project$Expression$listEquals_fn);
    var $author$project$Expression$Simplify$findNegate = function (expr) {
        if (expr.$ === 4) {
            var _v1 = expr.a;
            var e = expr.b;
            return $elm$core$Maybe$Just(e);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Expression$Simplify$polyDegree_fn = function (_var, expr) {
        var res = function () {
            switch (expr.$) {
                case 0:
                    return $elm$core$Maybe$Just(0);
                case 4:
                    var _v1 = expr.a;
                    var e = expr.b;
                    return $author$project$Expression$Simplify$polyDegree_fn(_var, e);
                case 5:
                    if (!expr.a) {
                        var _v2 = expr.a;
                        var l = expr.b;
                        var r = expr.c;
                        return $elm$core$Maybe$map2_fn($elm$core$Basics$sub, $author$project$Expression$Simplify$polyDegree_fn(_var, l), $author$project$Expression$Simplify$polyDegree_fn(_var, r));
                    }
                    else {
                        if (!expr.c.$) {
                            var _v3 = expr.a;
                            var base = expr.b;
                            var i = expr.c.a;
                            return $elm$core$Maybe$map_fn($elm$core$Basics$mul(i), $author$project$Expression$Simplify$polyDegree_fn(_var, base));
                        }
                        else {
                            var _v4 = expr.a;
                            return $elm$core$Maybe$Nothing;
                        }
                    }
                case 6:
                    switch (expr.a) {
                        case 0:
                            var _v5 = expr.a;
                            return $elm$core$Maybe$Nothing;
                        case 1:
                            var _v6 = expr.a;
                            return $elm$core$Maybe$Nothing;
                        case 2:
                            var _v7 = expr.a;
                            return $elm$core$Maybe$Nothing;
                        case 4:
                            var _v8 = expr.a;
                            return $elm$core$Maybe$Nothing;
                        default:
                            var _v9 = expr.a;
                            return $elm$core$Maybe$Nothing;
                    }
                case 7:
                    if (!expr.a) {
                        var _v10 = expr.a;
                        var l = expr.b;
                        var r = expr.c;
                        var o = expr.d;
                        return $elm$core$Maybe$andThen_fn($elm$core$List$maximum, A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$Expression$Simplify$polyDegree(_var), _List_Cons(l, _List_Cons(r, o))));
                    }
                    else {
                        var _v11 = expr.a;
                        var l = expr.b;
                        var r = expr.c;
                        var o = expr.d;
                        return $elm$core$Maybe$map_fn($elm$core$List$sum, A2($elm_community$maybe_extra$Maybe$Extra$traverse, $author$project$Expression$Simplify$polyDegree(_var), _List_Cons(l, _List_Cons(r, o))));
                    }
                case 2:
                    var v = expr.a;
                    return _Utils_eq(v, _var) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Just(0);
                case 1:
                    return $elm$core$Maybe$Just(0);
                case 8:
                    return $elm$core$Maybe$Nothing;
                case 9:
                    return $elm$core$Maybe$Nothing;
                case 10:
                    return $elm$core$Maybe$Nothing;
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }();
        return res;
    }, $author$project$Expression$Simplify$polyDegree = F2($author$project$Expression$Simplify$polyDegree_fn);
    var $elm_community$list_extra$List$Extra$stableSortWith_fn = function (pred, list) {
        var predWithIndex = F2(function (_v1, _v2) {
            var a1 = _v1.a;
            var i1 = _v1.b;
            var a2 = _v2.a;
            var i2 = _v2.b;
            var result = A2(pred, a1, a2);
            if (result === 1) {
                return _Utils_compare_fn(i1, i2);
            }
            else {
                return result;
            }
        });
        var listWithIndex = $elm$core$List$indexedMap_fn(F2(function (i, a) {
            return _Utils_Tuple2(a, i);
        }), list);
        return $elm$core$List$map_fn($elm$core$Tuple$first, _List_sortWith_fn(predWithIndex, listWithIndex));
    }, $elm_community$list_extra$List$Extra$stableSortWith_fn_unwrapped = function (pred, list) {
        var predWithIndex = F2(function (_v1, _v2) {
            var a1 = _v1.a;
            var i1 = _v1.b;
            var a2 = _v2.a;
            var i2 = _v2.b;
            var result = pred(a1, a2);
            if (result === 1) {
                return _Utils_compare_fn(i1, i2);
            }
            else {
                return result;
            }
        });
        var listWithIndex = $elm$core$List$indexedMap_fn(F2(function (i, a) {
            return _Utils_Tuple2(a, i);
        }), list);
        return $elm$core$List$map_fn($elm$core$Tuple$first, _List_sortWith_fn(predWithIndex, listWithIndex));
    }, $elm_community$list_extra$List$Extra$stableSortWith = F2($elm_community$list_extra$List$Extra$stableSortWith_fn);
    var $author$project$Expression$Simplify$sortByDegree_fn = function (aop, ee) {
        var letters = function (l) {
            return (!aop) ? $elm$core$List$reverse(l) : l;
        }(_List_sortBy_fn(function (s) {
            return _Utils_Tuple2($elm$core$String$length(s), s);
        }, $elm$core$Set$toList($author$project$Expression$getFreeVariables($author$project$Expression$List(ee)))));
        var by = F3(function (f, x, y) {
            return (!aop) ? _Utils_compare_fn(-f(x), -f(y)) : _Utils_compare_fn(f(x), f(y));
        });
        return $elm$core$List$foldl_fn(function (_var) {
            return $elm_community$list_extra$List$Extra$stableSortWith(by(function (e) {
                return ((_var === "i") && (!aop)) ? (-$elm$core$Maybe$withDefault_fn(-1, $author$project$Expression$Simplify$polyDegree_fn(_var, e))) : $elm$core$Maybe$withDefault_fn(-1, $author$project$Expression$Simplify$polyDegree_fn(_var, e));
            }));
        }, ee, letters);
    }, $author$project$Expression$Simplify$sortByDegree = F2($author$project$Expression$Simplify$sortByDegree_fn);
    var $author$project$Expression$Simplify$asList = function (l) {
        if (l.$ === 10) {
            var u = l.a;
            return $elm$core$Maybe$Just(u);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Expression$matrixSize = function (m) {
        return _Utils_Tuple2($elm$core$List$length(m), $elm$core$List$length($elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$head(m))));
    };
    var $author$project$Expression$genericMatrixAddition_fn = function (_v0, l, r) {
        var plus = _v0.ci;
        var asList = _v0.cO;
        var toList = _v0.d3;
        var _v1 = $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, $author$project$Expression$genericAsMatrix_fn(asList, l), $author$project$Expression$genericAsMatrix_fn(asList, r));
        if (!_v1.$) {
            var _v2 = _v1.a;
            var lm = _v2.a;
            var rm = _v2.b;
            return (!_Utils_eq($author$project$Expression$matrixSize(lm), $author$project$Expression$matrixSize(rm))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(toList(_List_map2_fn_unwrapped(function (le, re) {
                return toList(_List_map2_fn_unwrapped(function (lc, rc) {
                    return plus(_List_fromArray([lc, rc]));
                }, le, re));
            }, lm, rm)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Expression$genericMatrixAddition = F3($author$project$Expression$genericMatrixAddition_fn);
    var $author$project$Expression$Simplify$addMatrices_a0 = { cO: $author$project$Expression$Simplify$asList, ci: $author$project$Expression$Utils$plus, d3: $author$project$Expression$List }, $author$project$Expression$Simplify$addMatrices = $author$project$Expression$genericMatrixAddition($author$project$Expression$Simplify$addMatrices_a0);
    var $author$project$Expression$Utils$ipowShort_fn = function (base, exponent) {
        switch (exponent) {
            case 0:
                return $author$project$Expression$Utils$one;
            case 1:
                return base;
            default:
                return $author$project$Expression$Utils$ipow_fn(base, exponent);
        }
    }, $author$project$Expression$Utils$ipowShort = F2($author$project$Expression$Utils$ipowShort_fn);
    var $author$project$Expression$Utils$two = $author$project$Expression$Integer(2);
    var $author$project$Expression$Simplify$stepSimplifyAddition_fn = function (left, right) {
        var standard = function (_v35) {
            var _v6 = _Utils_Tuple2(left, right);
            _v6$0: while (true) {
                _v6$1: while (true) {
                    _v6$3: while (true) {
                        _v6$6: while (true) {
                            _v6$7: while (true) {
                                _v6$9: while (true) {
                                    _v6$10: while (true) {
                                        _v6$12: while (true) {
                                            switch (_v6.b.$) {
                                                case 0:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.b.a) {
                                                                break _v6$0;
                                                            }
                                                            else {
                                                                if (!_v6.a.a) {
                                                                    break _v6$1;
                                                                }
                                                                else {
                                                                    var il = _v6.a.a;
                                                                    var ir = _v6.b.a;
                                                                    return $elm$core$Maybe$Just($author$project$Expression$Integer(il + ir));
                                                                }
                                                            }
                                                        case 4:
                                                            if (!_v6.b.a) {
                                                                break _v6$0;
                                                            }
                                                            else {
                                                                break _v6$6;
                                                            }
                                                        case 5:
                                                            if (!_v6.b.a) {
                                                                break _v6$0;
                                                            }
                                                            else {
                                                                if (!_v6.a.a) {
                                                                    break _v6$9;
                                                                }
                                                                else {
                                                                    break _v6$12;
                                                                }
                                                            }
                                                        default:
                                                            if (!_v6.b.a) {
                                                                break _v6$0;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                    }
                                                case 7:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.a.a) {
                                                                break _v6$1;
                                                            }
                                                            else {
                                                                if (((_v6.b.a === 1) && (!_v6.b.b.$)) && (!_v6.b.d.b)) {
                                                                    break _v6$3;
                                                                }
                                                                else {
                                                                    break _v6$12;
                                                                }
                                                            }
                                                        case 4:
                                                            if (((_v6.b.a === 1) && (!_v6.b.b.$)) && (!_v6.b.d.b)) {
                                                                break _v6$3;
                                                            }
                                                            else {
                                                                break _v6$6;
                                                            }
                                                        case 5:
                                                            if (((_v6.b.a === 1) && (!_v6.b.b.$)) && (!_v6.b.d.b)) {
                                                                break _v6$3;
                                                            }
                                                            else {
                                                                if (!_v6.a.a) {
                                                                    break _v6$9;
                                                                }
                                                                else {
                                                                    break _v6$12;
                                                                }
                                                            }
                                                        default:
                                                            if (((_v6.b.a === 1) && (!_v6.b.b.$)) && (!_v6.b.d.b)) {
                                                                break _v6$3;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                    }
                                                case 4:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.a.a) {
                                                                break _v6$1;
                                                            }
                                                            else {
                                                                break _v6$7;
                                                            }
                                                        case 4:
                                                            break _v6$6;
                                                        case 5:
                                                            if (((!_v6.a.a) && (_v6.b.b.$ === 5)) && (!_v6.b.b.a)) {
                                                                var _v9 = _v6.a;
                                                                var _v10 = _v9.a;
                                                                var ln = _v9.b;
                                                                var ld = _v9.c;
                                                                var _v11 = _v6.b;
                                                                var _v12 = _v11.a;
                                                                var _v13 = _v11.b;
                                                                var _v14 = _v13.a;
                                                                var rn = _v13.b;
                                                                var rd = _v13.c;
                                                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ln, rd])), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([rn, ld]))), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ld, rd]))));
                                                            }
                                                            else {
                                                                break _v6$7;
                                                            }
                                                        default:
                                                            break _v6$7;
                                                    }
                                                case 5:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.a.a) {
                                                                break _v6$1;
                                                            }
                                                            else {
                                                                if (!_v6.b.a) {
                                                                    break _v6$10;
                                                                }
                                                                else {
                                                                    break _v6$12;
                                                                }
                                                            }
                                                        case 4:
                                                            if (((!_v6.b.a) && (_v6.a.b.$ === 5)) && (!_v6.a.b.a)) {
                                                                var _v15 = _v6.a;
                                                                var _v16 = _v15.a;
                                                                var _v17 = _v15.b;
                                                                var _v18 = _v17.a;
                                                                var ln = _v17.b;
                                                                var ld = _v17.c;
                                                                var _v19 = _v6.b;
                                                                var _v20 = _v19.a;
                                                                var rn = _v19.b;
                                                                var rd = _v19.c;
                                                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                                                        $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, ln),
                                                                        rd
                                                                    ])),
                                                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([rn, ld]))
                                                                ])), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ld, rd]))));
                                                            }
                                                            else {
                                                                break _v6$6;
                                                            }
                                                        case 5:
                                                            if (!_v6.a.a) {
                                                                if (!_v6.b.a) {
                                                                    var _v27 = _v6.a;
                                                                    var _v28 = _v27.a;
                                                                    var ln = _v27.b;
                                                                    var ld = _v27.c;
                                                                    var _v29 = _v6.b;
                                                                    var _v30 = _v29.a;
                                                                    var rn = _v29.b;
                                                                    var rd = _v29.c;
                                                                    return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                                                        $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ln, rd])),
                                                                        $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([rn, ld]))
                                                                    ])), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ld, rd]))));
                                                                }
                                                                else {
                                                                    break _v6$9;
                                                                }
                                                            }
                                                            else {
                                                                if (!_v6.b.a) {
                                                                    break _v6$10;
                                                                }
                                                                else {
                                                                    break _v6$12;
                                                                }
                                                            }
                                                        default:
                                                            if (!_v6.b.a) {
                                                                break _v6$10;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                    }
                                                case 10:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.a.a) {
                                                                break _v6$1;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                        case 4:
                                                            break _v6$6;
                                                        case 5:
                                                            if (!_v6.a.a) {
                                                                break _v6$9;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                        case 10:
                                                            return $author$project$Expression$genericMatrixAddition_fn($author$project$Expression$Simplify$addMatrices_a0, left, right);
                                                        default:
                                                            break _v6$12;
                                                    }
                                                default:
                                                    switch (_v6.a.$) {
                                                        case 0:
                                                            if (!_v6.a.a) {
                                                                break _v6$1;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                        case 4:
                                                            break _v6$6;
                                                        case 5:
                                                            if (!_v6.a.a) {
                                                                break _v6$9;
                                                            }
                                                            else {
                                                                break _v6$12;
                                                            }
                                                        default:
                                                            break _v6$12;
                                                    }
                                            }
                                        }
                                        return $author$project$Expression$equals_fn(left, right) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([$author$project$Expression$Utils$two, right]))) : $elm$core$Maybe$Nothing;
                                    }
                                    var l = _v6.a;
                                    var _v33 = _v6.b;
                                    var _v34 = _v33.a;
                                    var rn = _v33.b;
                                    var rd = _v33.c;
                                    return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                        $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, rd])),
                                        rn
                                    ])), rd));
                                }
                                var _v31 = _v6.a;
                                var _v32 = _v31.a;
                                var ln = _v31.b;
                                var ld = _v31.c;
                                var r = _v6.b;
                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                    ln,
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ld, r]))
                                ])), ld));
                            }
                            var _v23 = _v6.b;
                            var _v24 = _v23.a;
                            var nr = _v23.b;
                            if ($author$project$Expression$equals_fn(nr, left)) {
                                return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                            }
                            else {
                                if ($author$project$Expression$equals_fn(left, right)) {
                                    return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([$author$project$Expression$Utils$two, right])));
                                }
                                else {
                                    if ((nr.$ === 5) && (!nr.a)) {
                                        var _v26 = nr.a;
                                        var rn = nr.b;
                                        var rd = nr.c;
                                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([left, rd])), rn), rd));
                                    }
                                    else {
                                        return $elm$core$Maybe$Nothing;
                                    }
                                }
                            }
                        }
                        var _v21 = _v6.a;
                        var _v22 = _v21.a;
                        var nl = _v21.b;
                        return $author$project$Expression$equals_fn(nl, right) ? $elm$core$Maybe$Just($author$project$Expression$Utils$zero) : ($author$project$Expression$equals_fn(left, right) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([$author$project$Expression$Utils$two, right]))) : $elm$core$Maybe$Nothing);
                    }
                    var _v7 = _v6.b;
                    var _v8 = _v7.a;
                    var c = _v7.b.a;
                    var mon = _v7.c;
                    return $author$project$Expression$equals_fn(left, mon) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                        $author$project$Expression$Integer(c + 1),
                        mon
                    ]))) : $elm$core$Maybe$Nothing;
                }
                return $elm$core$Maybe$Just(right);
            }
            return $elm$core$Maybe$Just(left);
        };
        var leftVars = $elm$core$Set$toList($author$project$Expression$getFreeVariables(left));
        var _v0 = _Utils_Tuple2($elm$core$Maybe$map_fn($elm$core$Dict$toList, $author$project$Expression$Polynomial$asPolynomial_fn(leftVars, left)), $elm$core$Maybe$map_fn($elm$core$Dict$toList, $author$project$Expression$Polynomial$asPolynomial_fn(leftVars, right)));
        if ((((((!_v0.a.$) && _v0.a.a.b) && (!_v0.a.a.b.b)) && (!_v0.b.$)) && _v0.b.a.b) && (!_v0.b.a.b.b)) {
            var _v1 = _v0.a.a;
            var _v2 = _v1.a;
            var dl = _v2.a;
            var cl = _v2.b;
            var _v3 = _v0.b.a;
            var _v4 = _v3.a;
            var dr = _v4.a;
            var cr = _v4.b;
            if (_Utils_eq(dl, dr) && (!$elm$core$List$isEmpty(dl))) {
                var pows = $elm$core$List$map_fn(function (_v5) {
                    var v = _v5.a;
                    var e = _v5.b;
                    return $author$project$Expression$Utils$ipowShort_fn($author$project$Expression$Variable(v), e);
                }, dl);
                return $elm$core$Maybe$Just($author$project$Expression$Utils$byShort(_List_Cons($author$project$Expression$Utils$plusShort(_List_fromArray([cl, cr])), pows)));
            }
            else {
                return standard(0);
            }
        }
        else {
            return standard(0);
        }
    }, $author$project$Expression$Simplify$stepSimplifyAddition = F2($author$project$Expression$Simplify$stepSimplifyAddition_fn);
    var $author$project$Expression$Utils$abs__a0 = $author$project$Expression$Abs, $author$project$Expression$Utils$abs_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$abs__a0);
    var $author$project$Expression$Utils$cos__a0 = $author$project$Expression$Cos, $author$project$Expression$Utils$cos_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$cos__a0);
    var $author$project$Expression$Utils$cosh__a0 = $author$project$Expression$Cosh, $author$project$Expression$Utils$cosh_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$cosh__a0);
    var $author$project$Expression$Utils$exp__a0 = $author$project$Expression$Exp, $author$project$Expression$Utils$exp_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$exp__a0);
    var $author$project$Expression$Utils$log10__a0 = $author$project$Expression$Log10, $author$project$Expression$Utils$log10_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$log10__a0);
    var $author$project$Expression$Utils$sign_a0 = $author$project$Expression$Sign, $author$project$Expression$Utils$sign = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$sign_a0);
    var $author$project$Expression$Utils$sin__a0 = $author$project$Expression$Sin, $author$project$Expression$Utils$sin_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$sin__a0);
    var $author$project$Expression$Utils$sinh__a0 = $author$project$Expression$Sinh, $author$project$Expression$Utils$sinh_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$sinh__a0);
    var $author$project$Expression$Utils$tan__a0 = $author$project$Expression$Tan, $author$project$Expression$Utils$tan_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$tan__a0);
    var $author$project$Expression$Derivative$knownDerivative_fn = function (name, x) {
        switch (name.$) {
            case 0:
                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, x);
            case 1:
                return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, x));
            case 2:
                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                    $author$project$Expression$Utils$one,
                    $author$project$Expression$Utils$square($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$tan__a0, x))
                ]));
            case 3:
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$one, $author$project$Expression$Utils$square(x))));
            case 4:
                return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$one, $author$project$Expression$Utils$square(x)))));
            case 5:
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                    $author$project$Expression$Utils$one,
                    $author$project$Expression$Utils$square(x)
                ])));
            case 6:
                return $author$project$Expression$Variable("TODO");
            case 7:
                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cosh__a0, x);
            case 8:
                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sinh__a0, x);
            case 9:
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$square($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cosh__a0, x)));
            case 10:
                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sign_a0, x);
            case 11:
                var n = name.a;
                var ni = $author$project$Expression$Integer(n);
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, x, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(1 - n), ni)), ni);
            case 12:
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, x);
            case 13:
                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                    $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, x),
                    $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$log10__a0, $author$project$Expression$Variable("e"))
                ]));
            case 14:
                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$exp__a0, x);
            case 15:
                return $author$project$Expression$Utils$zero;
            case 16:
                return $author$project$Expression$Variable("TODO");
            case 17:
                return $author$project$Expression$Variable("TODO");
            case 18:
                return $author$project$Expression$Variable("TODO");
            case 19:
                return $author$project$Expression$Variable("TODO");
            case 20:
                return $author$project$Expression$Variable("TODO");
            case 21:
                return $author$project$Expression$Variable("TODO");
            case 22:
                return $author$project$Expression$Variable("TODO");
            case 23:
                return $author$project$Expression$Variable("TODO");
            case 24:
                return $author$project$Expression$Variable("TODO");
            case 25:
                return $author$project$Expression$Utils$zero;
            case 26:
                return $author$project$Expression$Utils$zero;
            case 27:
                return $author$project$Expression$Utils$zero;
            case 28:
                return $author$project$Expression$Variable("TODO");
            case 29:
                return $author$project$Expression$Variable("TODO");
            case 30:
                return $author$project$Expression$Variable("TODO");
            case 31:
                return $author$project$Expression$Variable("TODO");
            case 32:
                return $author$project$Expression$Variable("TODO");
            case 33:
                return $author$project$Expression$Variable("TODO");
            case 34:
                return $author$project$Expression$Variable("TODO");
            case 35:
                return $author$project$Expression$Variable("TODO");
            default:
                return $author$project$Expression$Variable("TODO");
        }
    }, $author$project$Expression$Derivative$knownDerivative = F2($author$project$Expression$Derivative$knownDerivative_fn);
    var $author$project$Expression$Utils$ln__a0 = $author$project$Expression$Ln, $author$project$Expression$Utils$ln_ = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$ln__a0);
    var $author$project$Expression$Utils$runForLoop = function (args) {
        var run = F2(function (expression, values) {
            return $elm$core$List$map_fn(function (value) {
                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([expression, value]));
            }, values);
        });
        _v0$3: while (true) {
            if (args.b && args.b.b) {
                if (args.b.b.b) {
                    if (((!args.b.a.$) && (!args.b.b.a.$)) && (!args.b.b.b.b)) {
                        var expression = args.a;
                        var _v1 = args.b;
                        var from = _v1.a.a;
                        var _v2 = _v1.b;
                        var to = _v2.a.a;
                        return $elm$core$Maybe$Just(A2(run, expression, $elm$core$List$map_fn($author$project$Expression$Integer, $elm$core$List$range_fn(from, to - 1))));
                    }
                    else {
                        break _v0$3;
                    }
                }
                else {
                    switch (args.b.a.$) {
                        case 10:
                            var expression = args.a;
                            var _v3 = args.b;
                            var values = _v3.a.a;
                            return $elm$core$Maybe$Just(A2(run, expression, values));
                        case 0:
                            var expression = args.a;
                            var _v4 = args.b;
                            var to = _v4.a.a;
                            return $elm$core$Maybe$Just(A2(run, expression, $elm$core$List$map_fn($author$project$Expression$Integer, $elm$core$List$range_fn(0, to - 1))));
                        default:
                            break _v0$3;
                    }
                }
            }
            else {
                break _v0$3;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Derivative$derivative_fn = function (_var, expr) {
        derivative: while (true) {
            _v0$16: while (true) {
                switch (expr.$) {
                    case 0:
                        return $author$project$Expression$Utils$zero;
                    case 1:
                        return $author$project$Expression$Utils$zero;
                    case 2:
                        var v = expr.a;
                        return _Utils_eq(v, _var) ? $author$project$Expression$Utils$one : $author$project$Expression$Utils$zero;
                    case 3:
                        var x = expr.a;
                        var f = expr.b;
                        return $author$project$Expression$Lambda_fn(x, f);
                    case 10:
                        var ls = expr.a;
                        return $author$project$Expression$List($elm$core$List$map_fn($author$project$Expression$Derivative$derivative(_var), ls));
                    case 7:
                        if (!expr.a) {
                            var _v1 = expr.a;
                            var l = expr.b;
                            var m = expr.c;
                            var rs = expr.d;
                            return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn($author$project$Expression$Derivative$derivative(_var), _List_Cons(l, _List_Cons(m, rs))));
                        }
                        else {
                            if (!expr.d.b) {
                                var _v2 = expr.a;
                                var l = expr.b;
                                var r = expr.c;
                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                        $author$project$Expression$Derivative$derivative_fn(_var, l),
                                        r
                                    ])),
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                        l,
                                        $author$project$Expression$Derivative$derivative_fn(_var, r)
                                    ]))
                                ]));
                            }
                            else {
                                var _v3 = expr.a;
                                var l = expr.b;
                                var r = expr.c;
                                var rs = expr.d;
                                var $temp$var = _var, $temp$expr = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, r])),
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, rs)
                                ]));
                                _var = $temp$var;
                                expr = $temp$expr;
                                continue derivative;
                            }
                        }
                    case 4:
                        var _v4 = expr.a;
                        var e = expr.b;
                        return $author$project$Expression$UnaryOperation_fn(0, $author$project$Expression$Derivative$derivative_fn(_var, e));
                    case 5:
                        if (!expr.a) {
                            var _v5 = expr.a;
                            var f = expr.b;
                            var g = expr.c;
                            var fpg = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                $author$project$Expression$Derivative$derivative_fn(_var, f),
                                g
                            ]));
                            var fgp = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                f,
                                $author$project$Expression$Derivative$derivative_fn(_var, g)
                            ]));
                            return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$minus_fn(fpg, fgp), $author$project$Expression$Utils$square(g));
                        }
                        else {
                            if ((expr.b.$ === 2) && (!expr.c.$)) {
                                var _v6 = expr.a;
                                var v = expr.b.a;
                                var ex = expr.c;
                                var i = ex.a;
                                return (!_Utils_eq(v, _var)) ? $author$project$Expression$Utils$zero : $author$project$Expression$Utils$byShort(_List_fromArray([
                                    ex,
                                    $author$project$Expression$Utils$ipowShort_fn($author$project$Expression$Variable(v), i - 1)
                                ]));
                            }
                            else {
                                var _v7 = expr.a;
                                var f = expr.b;
                                var g = expr.c;
                                var gp = $author$project$Expression$Derivative$derivative_fn(_var, g);
                                var fp = $author$project$Expression$Derivative$derivative_fn(_var, f);
                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                    $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, f, g),
                                    $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                        $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                            fp,
                                            $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, g, f)
                                        ])),
                                        $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                            gp,
                                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$ln__a0, f)
                                        ]))
                                    ]))
                                ]));
                            }
                        }
                    case 6:
                        return $author$project$Expression$Utils$zero;
                    case 9:
                        var ctx = expr.a;
                        var e = expr.b;
                        return $author$project$Expression$Derivative$derivative_fn(_var, A2($author$project$Expression$fullSubstitute, $elm$core$Basics$composeR_fn($author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1, ctx), e));
                    default:
                        if (!expr.a.$) {
                            if (expr.b.b && (!expr.b.b.b)) {
                                var f = expr.a.a;
                                var _v8 = expr.b;
                                var x = _v8.a;
                                if (x.$ === 2) {
                                    var xv = x.a;
                                    return _Utils_eq(xv, _var) ? $author$project$Expression$Derivative$knownDerivative_fn(f, x) : $author$project$Expression$Utils$zero;
                                }
                                else {
                                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                        $author$project$Expression$Derivative$knownDerivative_fn(f, x),
                                        $author$project$Expression$Derivative$derivative_fn(_var, x)
                                    ]));
                                }
                            }
                            else {
                                if (expr.a.a.$ === 36) {
                                    var _v10 = expr.a.a;
                                    var args = expr.b;
                                    var _v11 = $author$project$Expression$Utils$runForLoop(args);
                                    if (!_v11.$) {
                                        var result = _v11.a;
                                        return $author$project$Expression$Derivative$derivative_fn(_var, $author$project$Expression$List(result));
                                    }
                                    else {
                                        return $author$project$Expression$Variable("TODO");
                                    }
                                }
                                else {
                                    break _v0$16;
                                }
                            }
                        }
                        else {
                            break _v0$16;
                        }
                }
            }
            return $author$project$Expression$Variable("TODO");
        }
    }, $author$project$Expression$Derivative$derivative = F2($author$project$Expression$Derivative$derivative_fn);
    var $author$project$Expression$Simplify$extract_fn = function (filter, ls) {
        var go = F2(function (old, incoming) {
            go: while (true) {
                if (!incoming.b) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    var h = incoming.a;
                    var t = incoming.b;
                    var _v1 = filter(h);
                    if (_v1.$ === 1) {
                        var $temp$old = _List_Cons(h, old), $temp$incoming = t;
                        old = $temp$old;
                        incoming = $temp$incoming;
                        continue go;
                    }
                    else {
                        var e = _v1.a;
                        return $elm$core$Maybe$Just(_Utils_Tuple2(e, _Utils_ap($elm$core$List$reverse(old), t)));
                    }
                }
            }
        });
        return A2(go, _List_Nil, ls);
    }, $author$project$Expression$Simplify$extract = F2($author$project$Expression$Simplify$extract_fn);
    var $author$project$Expression$Simplify$findSpecificVariable_fn = function (j, expr) {
        if (expr.$ === 2) {
            var i = expr.a;
            return _Utils_eq(i, j) ? $elm$core$Maybe$Just(i) : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Expression$Simplify$findSpecificVariable = F2($author$project$Expression$Simplify$findSpecificVariable_fn);
    var $author$project$Expression$Utils$i = $author$project$Expression$Variable("i");
    var $author$project$Expression$Utils$im_a0 = $author$project$Expression$Im, $author$project$Expression$Utils$im = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$im_a0);
    var $author$project$Expression$Utils$re_a0 = $author$project$Expression$Re, $author$project$Expression$Utils$re = $author$project$Expression$Utils$unaryFunc($author$project$Expression$Utils$re_a0);
    var $author$project$Expression$Simplify$stepSimplifyAbs = function (sarg) {
        _v0$4: while (true) {
            switch (sarg.$) {
                case 0:
                    var i = sarg.a;
                    return $elm$core$Maybe$Just($author$project$Expression$Integer($elm$core$Basics$abs(i)));
                case 1:
                    var f = sarg.a;
                    return $elm$core$Maybe$Just($author$project$Expression$Float($elm$core$Basics$abs(f)));
                case 2:
                    var v = sarg.a;
                    switch (v) {
                        case "e":
                            return $elm$core$Maybe$Just(sarg);
                        case "pi":
                            return $elm$core$Maybe$Just(sarg);
                        default:
                            return $elm$core$Maybe$Nothing;
                    }
                case 8:
                    if ((!sarg.a.$) && (sarg.a.a.$ === 10)) {
                        var _v2 = sarg.a.a;
                        return $elm$core$Maybe$Just(sarg);
                    }
                    else {
                        break _v0$4;
                    }
                default:
                    break _v0$4;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Utils$smallPrimes = _List_fromArray([2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997]);
    var $author$project$Expression$Utils$factor = function () {
        var plusOne = F2(function (key, dict) {
            return $elm$core$Dict$insert_fn(key, 1 + $elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(key, dict)), dict);
        });
        var naive = F2(function (prime, num) {
            naive: while (true) {
                if (!_Basics_modBy_fn(prime, num)) {
                    return prime;
                }
                else {
                    if (_Utils_cmp(prime * prime, num) > -1) {
                        return num;
                    }
                    else {
                        var $temp$prime = prime + 2, $temp$num = num;
                        prime = $temp$prime;
                        num = $temp$num;
                        continue naive;
                    }
                }
            }
        });
        var go = F2(function (acc, num) {
            go: while (true) {
                if (num <= 1) {
                    return acc;
                }
                else {
                    var _v0 = $elm_community$list_extra$List$Extra$find_fn(function (prime) {
                        return !_Basics_modBy_fn(prime, num);
                    }, $author$project$Expression$Utils$smallPrimes);
                    if (!_v0.$) {
                        var prime = _v0.a;
                        var $temp$acc = A2(plusOne, prime, acc), $temp$num = (num / prime) | 0;
                        acc = $temp$acc;
                        num = $temp$num;
                        continue go;
                    }
                    else {
                        var prime = A2(naive, 1009, num);
                        var $temp$acc = A2(plusOne, prime, acc), $temp$num = (num / prime) | 0;
                        acc = $temp$acc;
                        num = $temp$num;
                        continue go;
                    }
                }
            }
        });
        return A2($elm$core$Basics$composeR, go($elm$core$Dict$empty), $elm$core$Dict$toList);
    }();
    var $elm$core$Basics$truncate = _Basics_truncate;
    var $author$project$Expression$Simplify$cbrtInteger = function (j) {
        var a = $elm$core$Basics$abs(j);
        var r = _Basics_pow_fn(a, 1 / 3) | 0;
        var s = function () {
            var _v0 = $elm$core$List$foldl_fn_unwrapped(function (_v1, _v2) {
                var f = _v1.a;
                var e = _v1.b;
                var o = _v2.a;
                var i = _v2.b;
                return _Utils_Tuple2(o * _Basics_pow_fn(f, (e / 3) | 0), i * _Basics_pow_fn(f, _Basics_modBy_fn(3, e)));
            }, _Utils_Tuple2(1, 1), $author$project$Expression$Utils$factor(a));
            var outer = _v0.a;
            var inner = _v0.b;
            var _v3 = _Utils_Tuple2(outer, inner);
            if (_v3.b === 1) {
                return $elm$core$Maybe$Just($author$project$Expression$Integer(outer));
            }
            else {
                if (_v3.a === 1) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                        $author$project$Expression$Integer(outer),
                        $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, $author$project$Expression$Integer(inner))
                    ])));
                }
            }
        }();
        return _Utils_eq((r * r) * r, j) ? $elm$core$Maybe$Just($author$project$Expression$Integer(r)) : ((j < 0) ? $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, $author$project$Expression$Integer(a)), s))) : s);
    };
    var $author$project$Expression$Simplify$stepSimplifyCbrt = function (sarg) {
        _v0$4: while (true) {
            switch (sarg.$) {
                case 0:
                    var j = sarg.a;
                    return $author$project$Expression$Simplify$cbrtInteger(j);
                case 7:
                    if (sarg.a === 1) {
                        var _v2 = sarg.a;
                        var l = sarg.b;
                        var m = sarg.c;
                        var r = sarg.d;
                        var cbrts = $elm$core$List$map_fn($author$project$Expression$Simplify$stepSimplifyCbrt, _List_Cons(l, _List_Cons(m, r)));
                        return $elm$core$List$any_fn($elm$core$Basics$neq($elm$core$Maybe$Nothing), cbrts) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_map2_fn(A2($elm$core$Basics$composeL, $elm$core$Maybe$withDefault, $author$project$Expression$Utils$cbrt), _List_Cons(l, _List_Cons(m, r)), cbrts))) : $elm$core$Maybe$Nothing;
                    }
                    else {
                        break _v0$4;
                    }
                case 5:
                    if (!sarg.a) {
                        var _v1 = sarg.a;
                        var n = sarg.b;
                        var d = sarg.c;
                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, n), $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, d)));
                    }
                    else {
                        if (!sarg.c.$) {
                            var _v3 = sarg.a;
                            var b = sarg.b;
                            var e = sarg.c.a;
                            if (e < 0) {
                                return $elm$core$Maybe$Nothing;
                            }
                            else {
                                var outer = $author$project$Expression$Utils$ipowShort_fn(b, (e / 3) | 0);
                                var _v4 = _Basics_modBy_fn(3, e);
                                switch (_v4) {
                                    case 0:
                                        return $elm$core$Maybe$Just(outer);
                                    case 1:
                                        return $elm$core$Maybe$Just($author$project$Expression$Utils$byShort(_List_fromArray([
                                            outer,
                                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, b)
                                        ])));
                                    default:
                                        return $elm$core$Maybe$Just($author$project$Expression$Utils$byShort(_List_fromArray([
                                            outer,
                                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, $author$project$Expression$Utils$square(b))
                                        ])));
                                }
                            }
                        }
                        else {
                            break _v0$4;
                        }
                    }
                default:
                    break _v0$4;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Simplify$asPiFraction_fn = function (n, d) {
        var _v0 = _Utils_Tuple2(n, d);
        _v0$2: while (true) {
            if (!_v0.b.$) {
                switch (_v0.a.$) {
                    case 2:
                        if (_v0.a.a === "pi") {
                            var di = _v0.b.a;
                            return $elm$core$Maybe$Just(_Utils_Tuple2(1, di));
                        }
                        else {
                            break _v0$2;
                        }
                    case 7:
                        if (((((_v0.a.a === 1) && (!_v0.a.b.$)) && (_v0.a.c.$ === 2)) && (_v0.a.c.a === "pi")) && (!_v0.a.d.b)) {
                            var _v1 = _v0.a;
                            var _v2 = _v1.a;
                            var ni = _v1.b.a;
                            var di = _v0.b.a;
                            return $elm$core$Maybe$Just(_Utils_Tuple2(ni, di));
                        }
                        else {
                            break _v0$2;
                        }
                    default:
                        break _v0$2;
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    }, $author$project$Expression$Simplify$asPiFraction = F2($author$project$Expression$Simplify$asPiFraction_fn);
    var $author$project$Expression$Utils$divShort_fn = function (num, den) {
        return $author$project$Expression$Utils$isZero(num) ? $author$project$Expression$Utils$zero : ($author$project$Expression$Utils$isOne(den) ? num : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, num, den));
    }, $author$project$Expression$Utils$divShort = F2($author$project$Expression$Utils$divShort_fn);
    var $author$project$Fraction$gcd_fn = function (ll, rr) {
        gcd: while (true) {
            if (ll < 0) {
                var $temp$ll = -ll, $temp$rr = rr;
                ll = $temp$ll;
                rr = $temp$rr;
                continue gcd;
            }
            else {
                if (_Utils_cmp(ll, rr) < 0) {
                    var $temp$ll = rr, $temp$rr = ll;
                    ll = $temp$ll;
                    rr = $temp$rr;
                    continue gcd;
                }
                else {
                    if (!rr) {
                        return ll;
                    }
                    else {
                        var $temp$ll = rr, $temp$rr = _Basics_modBy_fn(rr, ll);
                        ll = $temp$ll;
                        rr = $temp$rr;
                        continue gcd;
                    }
                }
            }
        }
    }, $author$project$Fraction$gcd = F2($author$project$Fraction$gcd_fn);
    var $author$project$Expression$Simplify$getSinValueForPiFraction_fn = function (pn, pd) {
        getSinValueForPiFraction: while (true) {
            if (pd < 0) {
                var $temp$pn = -pn, $temp$pd = -pd;
                pn = $temp$pn;
                pd = $temp$pd;
                continue getSinValueForPiFraction;
            }
            else {
                if (!pd) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    if (!pn) {
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                    }
                    else {
                        var _v0 = $author$project$Fraction$gcd_fn(pn, pd);
                        if (_v0 === 1) {
                            var _v1 = _Basics_modBy_fn(pd, 4);
                            if (!_v1) {
                                var _v2 = _Basics_modBy_fn(8, ((pn * 4) / pd) | 0);
                                switch (_v2) {
                                    case 0:
                                        return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                                    case 1:
                                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(2)), $author$project$Expression$Utils$two));
                                    case 2:
                                        return $elm$core$Maybe$Just($author$project$Expression$Utils$one);
                                    case 3:
                                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(2)), $author$project$Expression$Utils$two));
                                    case 4:
                                        return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                                    case 5:
                                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(2))), $author$project$Expression$Utils$two));
                                    case 6:
                                        return $elm$core$Maybe$Just($author$project$Expression$Integer(-1));
                                    default:
                                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(2))), $author$project$Expression$Utils$two));
                                }
                            }
                            else {
                                var _v3 = _Basics_modBy_fn(pd, 6);
                                if (!_v3) {
                                    var _v4 = _Basics_modBy_fn(12, ((pn * 6) / pd) | 0);
                                    switch (_v4) {
                                        case 0:
                                            return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                                        case 1:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$two));
                                        case 2:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(3)), $author$project$Expression$Utils$two));
                                        case 3:
                                            return $elm$core$Maybe$Just($author$project$Expression$Utils$one);
                                        case 4:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(3)), $author$project$Expression$Utils$two));
                                        case 5:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$two));
                                        case 6:
                                            return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                                        case 7:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(-1), $author$project$Expression$Utils$two));
                                        case 8:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(3))), $author$project$Expression$Utils$two));
                                        case 9:
                                            return $elm$core$Maybe$Just($author$project$Expression$Integer(-1));
                                        case 10:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(3))), $author$project$Expression$Utils$two));
                                        default:
                                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(-1), $author$project$Expression$Utils$two));
                                    }
                                }
                                else {
                                    return $elm$core$Maybe$Nothing;
                                }
                            }
                        }
                        else {
                            var g = _v0;
                            var $temp$pn = (pn / g) | 0, $temp$pd = (pd / g) | 0;
                            pn = $temp$pn;
                            pd = $temp$pd;
                            continue getSinValueForPiFraction;
                        }
                    }
                }
            }
        }
    }, $author$project$Expression$Simplify$getSinValueForPiFraction = F2($author$project$Expression$Simplify$getSinValueForPiFraction_fn);
    var $author$project$Expression$Simplify$stepSimplifyCos = function (sarg) {
        _v0$6: while (true) {
            switch (sarg.$) {
                case 1:
                    var j = sarg.a;
                    return $elm$core$Maybe$Just($author$project$Expression$Float($elm$core$Basics$cos(j)));
                case 2:
                    if (sarg.a === "pi") {
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$one);
                    }
                    else {
                        break _v0$6;
                    }
                case 4:
                    var _v1 = sarg.a;
                    var c = sarg.b;
                    return $elm$core$Maybe$Just($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, c));
                case 7:
                    if (!sarg.a) {
                        var _v5 = sarg.a;
                        var l = sarg.b;
                        var m = sarg.c;
                        var r = sarg.d;
                        var rr = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_Cons(m, r));
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, l),
                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, rr)
                        ])), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, l),
                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, rr)
                        ]))));
                    }
                    else {
                        break _v0$6;
                    }
                case 5:
                    if (!sarg.a) {
                        if ((sarg.b.$ === 7) && (!sarg.b.a)) {
                            var _v2 = sarg.a;
                            var _v3 = sarg.b;
                            var _v4 = _v3.a;
                            var l = _v3.b;
                            var m = _v3.c;
                            var r = _v3.d;
                            var d = sarg.c;
                            return $author$project$Expression$Simplify$stepSimplifyCos($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn(function (n) {
                                return $author$project$Expression$Utils$divShort_fn(n, d);
                            }, _List_Cons(l, _List_Cons(m, r)))));
                        }
                        else {
                            var _v6 = sarg.a;
                            var n = sarg.b;
                            var d = sarg.c;
                            return $elm$core$Maybe$andThen_fn(function (_v7) {
                                var pn = _v7.a;
                                var pd = _v7.b;
                                return $author$project$Expression$Simplify$getSinValueForPiFraction_fn((pn * 2) + pd, pd * 2);
                            }, $author$project$Expression$Simplify$asPiFraction_fn(n, d));
                        }
                    }
                    else {
                        break _v0$6;
                    }
                default:
                    break _v0$6;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Simplify$stepSimplifyIntegral_fn = function (expr, _var, from, to) {
        var _default = function (_v4) {
            return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Ii), _List_fromArray([
                expr,
                $author$project$Expression$Variable(_var),
                from,
                to
            ]));
        };
        var _v0 = $author$project$Expression$Polynomial$asPolynomial_fn(_List_fromArray([_var]), expr);
        if (!_v0.$) {
            var poly = _v0.a;
            var integrateOne = function (_v3) {
                var v = _v3.a;
                var exp = _v3.b;
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$ipow_fn($author$project$Expression$Variable(v), exp + 1), $author$project$Expression$Integer(exp + 1));
            };
            var integrateMonomial = function (_v2) {
                var vars = _v2.a;
                var coeff = _v2.b;
                if (!vars.b) {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                        coeff,
                        $author$project$Expression$Variable(_var)
                    ]));
                }
                else {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_Cons(coeff, $elm$core$List$map_fn(integrateOne, vars)));
                }
            };
            var primitive = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn(integrateMonomial, $elm$core$Dict$toList(poly)));
            return $author$project$Expression$Utils$minus_fn(A3($author$project$Expression$partialSubstitute, _var, to, primitive), A3($author$project$Expression$partialSubstitute, _var, from, primitive));
        }
        else {
            return _default(0);
        }
    }, $author$project$Expression$Simplify$stepSimplifyIntegral = F4($author$project$Expression$Simplify$stepSimplifyIntegral_fn);
    var $author$project$Expression$Simplify$stepSimplifyRe = function (sargs) {
        _v0$8: while (true) {
            if (sargs.b && (!sargs.b.b)) {
                switch (sargs.a.$) {
                    case 5:
                        if (!sargs.a.a) {
                            if ((sargs.a.b.$ === 7) && (!sargs.a.b.a)) {
                                var _v1 = sargs.a;
                                var _v2 = _v1.a;
                                var _v3 = _v1.b;
                                var _v4 = _v3.a;
                                var l = _v3.b;
                                var m = _v3.c;
                                var r = _v3.d;
                                var d = _v1.c;
                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn(function (c) {
                                    return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, c, d));
                                }, _List_Cons(l, _List_Cons(m, r))));
                            }
                            else {
                                if (!sargs.a.c.$) {
                                    var _v5 = sargs.a;
                                    var _v6 = _v5.a;
                                    var n = _v5.b;
                                    var d = _v5.c.a;
                                    return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, n), $author$project$Expression$Integer(d));
                                }
                                else {
                                    break _v0$8;
                                }
                            }
                        }
                        else {
                            break _v0$8;
                        }
                    case 4:
                        var _v7 = sargs.a;
                        var _v8 = _v7.a;
                        var c = _v7.b;
                        return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, c));
                    case 2:
                        var v = sargs.a.a;
                        return (v === "i") ? $author$project$Expression$Utils$zero : $author$project$Expression$Variable(v);
                    case 0:
                        var i = sargs.a.a;
                        return $author$project$Expression$Integer(i);
                    case 1:
                        var i = sargs.a.a;
                        return $author$project$Expression$Float(i);
                    case 7:
                        if (!sargs.a.a) {
                            var _v9 = sargs.a;
                            var _v10 = _v9.a;
                            var l = _v9.b;
                            var m = _v9.c;
                            var r = _v9.d;
                            return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn($author$project$Expression$Utils$re, _List_Cons(l, _List_Cons(m, r))));
                        }
                        else {
                            var _v11 = sargs.a;
                            var _v12 = _v11.a;
                            var l = _v11.b;
                            var m = _v11.c;
                            var r = _v11.d;
                            var rest = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_Cons(m, r));
                            return $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, l),
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, rest)
                            ])), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$im_a0, l),
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$im_a0, rest)
                            ])));
                        }
                    default:
                        break _v0$8;
                }
            }
            else {
                break _v0$8;
            }
        }
        return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Re), sargs);
    };
    var $author$project$Expression$Simplify$stepSimplifySin = function (sarg) {
        _v0$6: while (true) {
            switch (sarg.$) {
                case 1:
                    var j = sarg.a;
                    return $elm$core$Maybe$Just($author$project$Expression$Float($elm$core$Basics$sin(j)));
                case 2:
                    if (sarg.a === "pi") {
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$zero);
                    }
                    else {
                        break _v0$6;
                    }
                case 4:
                    var _v1 = sarg.a;
                    var c = sarg.b;
                    return $elm$core$Maybe$Just($author$project$Expression$Utils$negateShort($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, c)));
                case 7:
                    if (!sarg.a) {
                        var _v5 = sarg.a;
                        var l = sarg.b;
                        var m = sarg.c;
                        var r = sarg.d;
                        var rr = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_Cons(m, r));
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                            $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, l),
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, rr)
                            ])),
                            $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, l),
                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, rr)
                            ]))
                        ])));
                    }
                    else {
                        break _v0$6;
                    }
                case 5:
                    if (!sarg.a) {
                        if ((sarg.b.$ === 7) && (!sarg.b.a)) {
                            var _v2 = sarg.a;
                            var _v3 = sarg.b;
                            var _v4 = _v3.a;
                            var l = _v3.b;
                            var m = _v3.c;
                            var r = _v3.d;
                            var d = sarg.c;
                            return $author$project$Expression$Simplify$stepSimplifySin($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn(function (n) {
                                return $author$project$Expression$Utils$divShort_fn(n, d);
                            }, _List_Cons(l, _List_Cons(m, r)))));
                        }
                        else {
                            var _v6 = sarg.a;
                            var n = sarg.b;
                            var d = sarg.c;
                            return $elm$core$Maybe$andThen_fn(function (_v7) {
                                var pn = _v7.a;
                                var pd = _v7.b;
                                return $author$project$Expression$Simplify$getSinValueForPiFraction_fn(pn, pd);
                            }, $author$project$Expression$Simplify$asPiFraction_fn(n, d));
                        }
                    }
                    else {
                        break _v0$6;
                    }
                default:
                    break _v0$6;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Simplify$sqrtInteger = function (j) {
        var a = $elm$core$Basics$abs(j);
        var r = $elm$core$Basics$sqrt(a) | 0;
        var s = function () {
            if (_Utils_eq(r * r, a)) {
                return $elm$core$Maybe$Just($author$project$Expression$Integer(r));
            }
            else {
                var _v0 = $elm$core$List$foldl_fn_unwrapped(function (_v1, _v2) {
                    var f = _v1.a;
                    var e = _v1.b;
                    var o = _v2.a;
                    var i = _v2.b;
                    return _Utils_Tuple2(o * _Basics_pow_fn(f, (e / 2) | 0), i * _Basics_pow_fn(f, _Basics_modBy_fn(2, e)));
                }, _Utils_Tuple2(1, 1), $author$project$Expression$Utils$factor(a));
                var outer = _v0.a;
                var inner = _v0.b;
                var _v3 = _Utils_Tuple2(outer, inner);
                if (_v3.b === 1) {
                    return $elm$core$Maybe$Just($author$project$Expression$Integer(outer));
                }
                else {
                    if (_v3.a === 1) {
                        return $elm$core$Maybe$Nothing;
                    }
                    else {
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                            $author$project$Expression$Integer(outer),
                            $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(inner))
                        ])));
                    }
                }
            }
        }();
        return (j < 0) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
            $author$project$Expression$Variable("i"),
            $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Integer(a)), s)
        ]))) : s;
    };
    var $author$project$Expression$Simplify$stepSimplifySqrt = function (sarg) {
        _v0$4: while (true) {
            switch (sarg.$) {
                case 0:
                    var j = sarg.a;
                    return $author$project$Expression$Simplify$sqrtInteger(j);
                case 7:
                    if (sarg.a === 1) {
                        var _v2 = sarg.a;
                        var l = sarg.b;
                        var m = sarg.c;
                        var r = sarg.d;
                        var sqrts = $elm$core$List$map_fn($author$project$Expression$Simplify$stepSimplifySqrt, _List_Cons(l, _List_Cons(m, r)));
                        return $elm$core$List$any_fn($elm$core$Basics$neq($elm$core$Maybe$Nothing), sqrts) ? $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_map2_fn(A2($elm$core$Basics$composeL, $elm$core$Maybe$withDefault, $author$project$Expression$Utils$sqrt_), _List_Cons(l, _List_Cons(m, r)), sqrts))) : $elm$core$Maybe$Nothing;
                    }
                    else {
                        break _v0$4;
                    }
                case 5:
                    if (!sarg.a) {
                        var _v1 = sarg.a;
                        var n = sarg.b;
                        var d = sarg.c;
                        return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, n), $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, d)));
                    }
                    else {
                        if (!sarg.c.$) {
                            var _v3 = sarg.a;
                            var b = sarg.b;
                            var e = sarg.c.a;
                            if (e < 0) {
                                return $elm$core$Maybe$Nothing;
                            }
                            else {
                                var outer = $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$abs__a0, $author$project$Expression$Utils$ipowShort_fn(b, (e / 2) | 0));
                                return (!_Basics_modBy_fn(2, e)) ? $elm$core$Maybe$Just(outer) : $elm$core$Maybe$Just($author$project$Expression$Utils$byShort(_List_fromArray([
                                    outer,
                                    $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, b)
                                ])));
                            }
                        }
                        else {
                            break _v0$4;
                        }
                    }
                default:
                    break _v0$4;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Simplify$stepSimplifyApply_fn = function (fname, sargs) {
        if (fname.$ === 1) {
            return $author$project$Expression$Apply_fn(fname, sargs);
        }
        else {
            var name = fname.a;
            var _v1 = _Utils_Tuple2(name, sargs);
            _v1$16: while (true) {
                switch (_v1.a.$) {
                    case 11:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            switch (_v1.a.a) {
                                case 2:
                                    var _v2 = _v1.b;
                                    var arg = _v2.a;
                                    return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, arg), $author$project$Expression$Simplify$stepSimplifySqrt(arg));
                                case 3:
                                    var _v3 = _v1.b;
                                    var arg = _v3.a;
                                    return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cbrt_a0, arg), $author$project$Expression$Simplify$stepSimplifyCbrt(arg));
                                default:
                                    break _v1$16;
                            }
                        }
                        else {
                            break _v1$16;
                        }
                    case 0:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            var _v4 = _v1.a;
                            var _v5 = _v1.b;
                            var arg = _v5.a;
                            return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, arg), $author$project$Expression$Simplify$stepSimplifySin(arg));
                        }
                        else {
                            break _v1$16;
                        }
                    case 10:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            var _v6 = _v1.a;
                            var _v7 = _v1.b;
                            var arg = _v7.a;
                            return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$abs__a0, arg), $author$project$Expression$Simplify$stepSimplifyAbs(arg));
                        }
                        else {
                            break _v1$16;
                        }
                    case 1:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            var _v8 = _v1.a;
                            var _v9 = _v1.b;
                            var arg = _v9.a;
                            return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, arg), $author$project$Expression$Simplify$stepSimplifyCos(arg));
                        }
                        else {
                            break _v1$16;
                        }
                    case 7:
                        if (((_v1.b.b && (_v1.b.a.$ === 7)) && (_v1.b.a.a === 1)) && (!_v1.b.b.b)) {
                            var _v10 = _v1.a;
                            var _v11 = _v1.b;
                            var _v12 = _v11.a;
                            var _v13 = _v12.a;
                            var l = _v12.b;
                            var r = _v12.c;
                            var o = _v12.d;
                            var _v14 = $author$project$Expression$Simplify$extract_fn($author$project$Expression$Simplify$findSpecificVariable("i"), _List_Cons(l, _List_Cons(r, o)));
                            if (!_v14.$) {
                                var _v15 = _v14.a;
                                var rest = _v15.b;
                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                    $author$project$Expression$Utils$i,
                                    $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sin__a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, rest))
                                ]));
                            }
                            else {
                                return $author$project$Expression$Apply_fn(fname, sargs);
                            }
                        }
                        else {
                            break _v1$16;
                        }
                    case 8:
                        if (((_v1.b.b && (_v1.b.a.$ === 7)) && (_v1.b.a.a === 1)) && (!_v1.b.b.b)) {
                            var _v16 = _v1.a;
                            var _v17 = _v1.b;
                            var _v18 = _v17.a;
                            var _v19 = _v18.a;
                            var l = _v18.b;
                            var r = _v18.c;
                            var o = _v18.d;
                            var _v20 = $author$project$Expression$Simplify$extract_fn($author$project$Expression$Simplify$findSpecificVariable("i"), _List_Cons(l, _List_Cons(r, o)));
                            if (!_v20.$) {
                                var _v21 = _v20.a;
                                var rest = _v21.b;
                                return $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$cos__a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, rest));
                            }
                            else {
                                return $author$project$Expression$Apply_fn(fname, sargs);
                            }
                        }
                        else {
                            break _v1$16;
                        }
                    case 21:
                        if (((_v1.b.b && _v1.b.b.b) && (_v1.b.b.a.$ === 2)) && (!_v1.b.b.b.b)) {
                            var _v22 = _v1.a;
                            var _v23 = _v1.b;
                            var expr = _v23.a;
                            var _v24 = _v23.b;
                            var _var = _v24.a.a;
                            return $author$project$Expression$Derivative$derivative_fn(_var, expr);
                        }
                        else {
                            break _v1$16;
                        }
                    case 20:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            var _v25 = _v1.a;
                            var _v26 = _v1.b;
                            var expr = _v26.a;
                            return $author$project$Expression$Utils$determinant(expr);
                        }
                        else {
                            break _v1$16;
                        }
                    case 16:
                        var _v27 = _v1.a;
                        return $author$project$Expression$Simplify$stepSimplifyRe(sargs);
                    case 17:
                        if (_v1.b.b && (!_v1.b.b.b)) {
                            switch (_v1.b.a.$) {
                                case 2:
                                    var _v32 = _v1.a;
                                    var _v33 = _v1.b;
                                    var v = _v33.a.a;
                                    return (v === "i") ? $author$project$Expression$Utils$one : $author$project$Expression$Utils$zero;
                                case 0:
                                    var _v34 = _v1.a;
                                    var _v35 = _v1.b;
                                    return $author$project$Expression$Utils$zero;
                                case 1:
                                    var _v36 = _v1.a;
                                    var _v37 = _v1.b;
                                    return $author$project$Expression$Utils$zero;
                                case 7:
                                    if (!_v1.b.a.a) {
                                        var _v28 = _v1.a;
                                        var _v29 = _v1.b;
                                        var _v30 = _v29.a;
                                        var _v31 = _v30.a;
                                        var l = _v30.b;
                                        var m = _v30.c;
                                        var r = _v30.d;
                                        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn($author$project$Expression$Utils$im, _List_Cons(l, _List_Cons(m, r))));
                                    }
                                    else {
                                        var _v38 = _v1.a;
                                        var _v39 = _v1.b;
                                        var _v40 = _v39.a;
                                        var _v41 = _v40.a;
                                        var l = _v40.b;
                                        var m = _v40.c;
                                        var r = _v40.d;
                                        var rest = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_Cons(m, r));
                                        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                                            $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, l),
                                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$im_a0, rest)
                                            ])),
                                            $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$im_a0, l),
                                                $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$re_a0, rest)
                                            ]))
                                        ]));
                                    }
                                default:
                                    break _v1$16;
                            }
                        }
                        else {
                            break _v1$16;
                        }
                    case 22:
                        if (((((_v1.b.b && _v1.b.b.b) && (_v1.b.b.a.$ === 2)) && _v1.b.b.b.b) && _v1.b.b.b.b.b) && (!_v1.b.b.b.b.b.b)) {
                            var _v42 = _v1.a;
                            var _v43 = _v1.b;
                            var expr = _v43.a;
                            var _v44 = _v43.b;
                            var _var = _v44.a.a;
                            var _v45 = _v44.b;
                            var from = _v45.a;
                            var _v46 = _v45.b;
                            var to = _v46.a;
                            return $author$project$Expression$Simplify$stepSimplifyIntegral_fn(expr, _var, from, to);
                        }
                        else {
                            break _v1$16;
                        }
                    default:
                        break _v1$16;
                }
            }
            return $author$project$Expression$Apply_fn(fname, sargs);
        }
    }, $author$project$Expression$Simplify$stepSimplifyApply = F2($author$project$Expression$Simplify$stepSimplifyApply_fn);
    var $author$project$Zipper$canGoRight = function (_v0) {
        var after = _v0.d;
        return !$elm$core$List$isEmpty(after);
    };
    var $author$project$Zipper$fromNonemptyList_fn = function (h, t) {
        return { d: t, e: _List_Nil, h: h };
    }, $author$project$Zipper$fromNonemptyList = F2($author$project$Zipper$fromNonemptyList_fn);
    var $author$project$Zipper$getLeft = function (_v0) {
        var before = _v0.e;
        return $elm$core$List$reverse(before);
    };
    var $author$project$Zipper$getRight = function (_v0) {
        var after = _v0.d;
        return after;
    };
    var $author$project$Expression$Simplify$isImmaginary = function (e) {
        _v0$3: while (true) {
            switch (e.$) {
                case 2:
                    if (e.a === "i") {
                        return $elm$core$Maybe$Just($author$project$Expression$Utils$one);
                    }
                    else {
                        break _v0$3;
                    }
                case 4:
                    var _v1 = e.a;
                    var c = e.b;
                    return $elm$core$Maybe$map_fn($author$project$Expression$Utils$negate_, $author$project$Expression$Simplify$isImmaginary(c));
                case 7:
                    if (e.a === 1) {
                        var _v2 = e.a;
                        var ll = e.b;
                        var mm = e.c;
                        var rr = e.d;
                        var nonIs = $elm_community$list_extra$List$Extra$filterNot_fn($elm$core$Basics$eq($author$project$Expression$Variable("i")), _List_Cons(ll, _List_Cons(mm, rr)));
                        var _v3 = _Basics_modBy_fn(4, ($elm$core$List$length(rr) + 2) - $elm$core$List$length(nonIs));
                        switch (_v3) {
                            case 0:
                                return $elm$core$Maybe$Nothing;
                            case 1:
                                return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, nonIs));
                            case 2:
                                return $elm$core$Maybe$Nothing;
                            default:
                                return $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, nonIs)));
                        }
                    }
                    else {
                        break _v0$3;
                    }
                default:
                    break _v0$3;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Expression$Simplify$stepSimplifyDivision_fn = function (ls, rs) {
        var trySimplifyFactors = F3(function (nz, dz, dzip) {
            trySimplifyFactors: while (true) {
                var _v0 = $author$project$Expression$Simplify$stepSimplifyDivision_fn($author$project$Zipper$selected(nz), $author$project$Zipper$selected(dz));
                _v0$2: while (true) {
                    switch (_v0.$) {
                        case 5:
                            if (!_v0.a) {
                                var _v1 = _v0.a;
                                if ($author$project$Zipper$canGoRight(dz)) {
                                    var $temp$nz = nz, $temp$dz = $author$project$Zipper$right_fn(1, dz), $temp$dzip = dzip;
                                    nz = $temp$nz;
                                    dz = $temp$dz;
                                    dzip = $temp$dzip;
                                    continue trySimplifyFactors;
                                }
                                else {
                                    if ($author$project$Zipper$canGoRight(nz)) {
                                        var $temp$nz = $author$project$Zipper$right_fn(1, nz), $temp$dz = dzip, $temp$dzip = dzip;
                                        nz = $temp$nz;
                                        dz = $temp$dz;
                                        dzip = $temp$dzip;
                                        continue trySimplifyFactors;
                                    }
                                    else {
                                        return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                                    }
                                }
                            }
                            else {
                                break _v0$2;
                            }
                        case 0:
                            if (_v0.a === 1) {
                                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _Utils_ap($author$project$Zipper$getLeft(nz), $author$project$Zipper$getRight(nz))), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _Utils_ap($author$project$Zipper$getLeft(dz), $author$project$Zipper$getRight(dz))));
                            }
                            else {
                                break _v0$2;
                            }
                        default:
                            break _v0$2;
                    }
                }
                var reduced = _v0;
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _Utils_ap($author$project$Zipper$getLeft(nz), _List_Cons(reduced, $author$project$Zipper$getRight(nz)))), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _Utils_ap($author$project$Zipper$getLeft(dz), $author$project$Zipper$getRight(dz))));
            }
        });
        var _v2 = _Utils_Tuple2(ls, rs);
        _v2$0: while (true) {
            _v2$1: while (true) {
                _v2$2: while (true) {
                    _v2$3: while (true) {
                        _v2$5: while (true) {
                            _v2$7: while (true) {
                                _v2$8: while (true) {
                                    _v2$10: while (true) {
                                        _v2$11: while (true) {
                                            _v2$12: while (true) {
                                                switch (_v2.b.$) {
                                                    case 2:
                                                        switch (_v2.a.$) {
                                                            case 0:
                                                                if (_v2.b.a === "i") {
                                                                    break _v2$1;
                                                                }
                                                                else {
                                                                    if (!_v2.a.a) {
                                                                        break _v2$3;
                                                                    }
                                                                    else {
                                                                        break _v2$12;
                                                                    }
                                                                }
                                                            case 7:
                                                                if (_v2.b.a === "i") {
                                                                    break _v2$1;
                                                                }
                                                                else {
                                                                    if (_v2.a.a === 1) {
                                                                        break _v2$8;
                                                                    }
                                                                    else {
                                                                        break _v2$12;
                                                                    }
                                                                }
                                                            case 5:
                                                                if (!_v2.a.a) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    if (_v2.b.a === "i") {
                                                                        break _v2$1;
                                                                    }
                                                                    else {
                                                                        break _v2$11;
                                                                    }
                                                                }
                                                            default:
                                                                if (_v2.b.a === "i") {
                                                                    break _v2$1;
                                                                }
                                                                else {
                                                                    break _v2$12;
                                                                }
                                                        }
                                                    case 0:
                                                        switch (_v2.a.$) {
                                                            case 0:
                                                                if (_v2.b.a === 1) {
                                                                    break _v2$2;
                                                                }
                                                                else {
                                                                    if (!_v2.a.a) {
                                                                        break _v2$3;
                                                                    }
                                                                    else {
                                                                        var li = _v2.a.a;
                                                                        var ri = _v2.b.a;
                                                                        var _v5 = $elm$core$Basics$abs($author$project$Fraction$gcd_fn(li, ri));
                                                                        if (_v5 === 1) {
                                                                            return (ri < 0) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(-li), $author$project$Expression$Integer(-ri)) : ((li < 0) ? $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(-li), rs)) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs));
                                                                        }
                                                                        else {
                                                                            var g = _v5;
                                                                            return _Utils_eq(g, ri) ? $author$project$Expression$Integer((li / g) | 0) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer((li / g) | 0), $author$project$Expression$Integer((ri / g) | 0));
                                                                        }
                                                                    }
                                                                }
                                                            case 7:
                                                                if (_v2.b.a === 1) {
                                                                    break _v2$2;
                                                                }
                                                                else {
                                                                    if (_v2.a.a === 1) {
                                                                        break _v2$8;
                                                                    }
                                                                    else {
                                                                        break _v2$12;
                                                                    }
                                                                }
                                                            case 5:
                                                                if (!_v2.a.a) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    if (_v2.b.a === 1) {
                                                                        break _v2$2;
                                                                    }
                                                                    else {
                                                                        break _v2$11;
                                                                    }
                                                                }
                                                            default:
                                                                if (_v2.b.a === 1) {
                                                                    break _v2$2;
                                                                }
                                                                else {
                                                                    break _v2$12;
                                                                }
                                                        }
                                                    case 7:
                                                        switch (_v2.a.$) {
                                                            case 0:
                                                                if (!_v2.b.a) {
                                                                    if (!_v2.a.a) {
                                                                        break _v2$3;
                                                                    }
                                                                    else {
                                                                        break _v2$5;
                                                                    }
                                                                }
                                                                else {
                                                                    if (!_v2.a.a) {
                                                                        break _v2$3;
                                                                    }
                                                                    else {
                                                                        break _v2$7;
                                                                    }
                                                                }
                                                            case 7:
                                                                if (!_v2.b.a) {
                                                                    break _v2$5;
                                                                }
                                                                else {
                                                                    if (_v2.a.a === 1) {
                                                                        var _v12 = _v2.a;
                                                                        var _v13 = _v12.a;
                                                                        var nl = _v12.b;
                                                                        var nm = _v12.c;
                                                                        var nr = _v12.d;
                                                                        var _v14 = _v2.b;
                                                                        var _v15 = _v14.a;
                                                                        var dl = _v14.b;
                                                                        var dm = _v14.c;
                                                                        var dr = _v14.d;
                                                                        var nzip = $author$project$Zipper$fromNonemptyList_fn(nl, _List_Cons(nm, nr));
                                                                        var dzip = $author$project$Zipper$fromNonemptyList_fn(dl, _List_Cons(dm, dr));
                                                                        return A3(trySimplifyFactors, nzip, dzip, dzip);
                                                                    }
                                                                    else {
                                                                        break _v2$7;
                                                                    }
                                                                }
                                                            case 5:
                                                                if (!_v2.a.a) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    if (!_v2.b.a) {
                                                                        break _v2$5;
                                                                    }
                                                                    else {
                                                                        break _v2$7;
                                                                    }
                                                                }
                                                            default:
                                                                if (!_v2.b.a) {
                                                                    break _v2$5;
                                                                }
                                                                else {
                                                                    break _v2$7;
                                                                }
                                                        }
                                                    case 5:
                                                        switch (_v2.a.$) {
                                                            case 0:
                                                                if (!_v2.a.a) {
                                                                    break _v2$3;
                                                                }
                                                                else {
                                                                    if (_v2.b.a === 1) {
                                                                        break _v2$10;
                                                                    }
                                                                    else {
                                                                        break _v2$12;
                                                                    }
                                                                }
                                                            case 7:
                                                                if (_v2.a.a === 1) {
                                                                    break _v2$8;
                                                                }
                                                                else {
                                                                    if (_v2.b.a === 1) {
                                                                        break _v2$10;
                                                                    }
                                                                    else {
                                                                        break _v2$12;
                                                                    }
                                                                }
                                                            case 5:
                                                                if (!_v2.a.a) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    if (_v2.b.a === 1) {
                                                                        var _v20 = _v2.a;
                                                                        var _v21 = _v20.a;
                                                                        var lb = _v20.b;
                                                                        var le = _v20.c;
                                                                        var _v22 = _v2.b;
                                                                        var _v23 = _v22.a;
                                                                        var rb = _v22.b;
                                                                        var re = _v22.c;
                                                                        return $author$project$Expression$equals_fn(lb, rb) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, lb, $author$project$Expression$Utils$minus_fn(le, re)) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                                                                    }
                                                                    else {
                                                                        break _v2$11;
                                                                    }
                                                                }
                                                            default:
                                                                if (_v2.b.a === 1) {
                                                                    break _v2$10;
                                                                }
                                                                else {
                                                                    break _v2$12;
                                                                }
                                                        }
                                                    default:
                                                        switch (_v2.a.$) {
                                                            case 0:
                                                                if (!_v2.a.a) {
                                                                    break _v2$3;
                                                                }
                                                                else {
                                                                    break _v2$12;
                                                                }
                                                            case 7:
                                                                if (_v2.a.a === 1) {
                                                                    break _v2$8;
                                                                }
                                                                else {
                                                                    break _v2$12;
                                                                }
                                                            case 5:
                                                                if (!_v2.a.a) {
                                                                    break _v2$0;
                                                                }
                                                                else {
                                                                    break _v2$11;
                                                                }
                                                            default:
                                                                break _v2$12;
                                                        }
                                                }
                                            }
                                            return $author$project$Expression$equals_fn(ls, rs) ? $author$project$Expression$Utils$one : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                                        }
                                        var _v26 = _v2.a;
                                        var _v27 = _v26.a;
                                        var lb = _v26.b;
                                        var le = _v26.c;
                                        return $author$project$Expression$equals_fn(lb, rs) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, lb, $author$project$Expression$Utils$minus_fn(le, $author$project$Expression$Utils$one)) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                                    }
                                    var _v24 = _v2.b;
                                    var _v25 = _v24.a;
                                    var rb = _v24.b;
                                    var re = _v24.c;
                                    return $author$project$Expression$equals_fn(ls, rb) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, ls, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$one, re)) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                                }
                                var _v18 = _v2.a;
                                var _v19 = _v18.a;
                                var nl = _v18.b;
                                var nm = _v18.c;
                                var nr = _v18.d;
                                var d = _v2.b;
                                var nzip = $author$project$Zipper$fromNonemptyList_fn(nl, _List_Cons(nm, nr));
                                var dzip = $author$project$Zipper$fromNonemptyList_fn(d, _List_Nil);
                                return A3(trySimplifyFactors, nzip, dzip, dzip);
                            }
                            var n = _v2.a;
                            var _v16 = _v2.b;
                            var _v17 = _v16.a;
                            var dl = _v16.b;
                            var dm = _v16.c;
                            var dr = _v16.d;
                            var nzip = $author$project$Zipper$fromNonemptyList_fn(n, _List_Nil);
                            var dzip = $author$project$Zipper$fromNonemptyList_fn(dl, _List_Cons(dm, dr));
                            return A3(trySimplifyFactors, nzip, dzip, dzip);
                        }
                        var _v6 = _v2.b;
                        var _v7 = _v6.a;
                        var l = _v6.b;
                        var m = _v6.c;
                        var r = _v6.d;
                        var _v8 = $elm$core$List$foldl_fn_unwrapped(function (e, _v9) {
                            var ar = _v9.a;
                            var ai = _v9.b;
                            var _v10 = $author$project$Expression$Simplify$isImmaginary(e);
                            if (!_v10.$) {
                                var k = _v10.a;
                                return _Utils_Tuple2(ar, _List_Cons(k, ai));
                            }
                            else {
                                return _Utils_Tuple2(_List_Cons(e, ar), ai);
                            }
                        }, _Utils_Tuple2(_List_Nil, _List_Nil), _List_Cons(l, _List_Cons(m, r)));
                        var reals = _v8.a;
                        var immaginaries = _v8.b;
                        var plusImmaginaries = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, immaginaries);
                        var plusReals = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, reals);
                        var inverted = $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$minus_fn(plusReals, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                            $author$project$Expression$Variable("i"),
                            plusImmaginaries
                        ]))), $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                            $author$project$Expression$Utils$square(plusReals),
                            $author$project$Expression$Utils$square(plusImmaginaries)
                        ])));
                        var _v11 = _Utils_Tuple2(immaginaries, ls);
                        if (!_v11.a.b) {
                            return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, ls, rs);
                        }
                        else {
                            if ((!_v11.b.$) && (_v11.b.a === 1)) {
                                return inverted;
                            }
                            else {
                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ls, inverted]));
                            }
                        }
                    }
                    return ls;
                }
                return ls;
            }
            return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                ls,
                $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$i)
            ]));
        }
        var _v3 = _v2.a;
        var _v4 = _v3.a;
        var lsn = _v3.b;
        var lsd = _v3.c;
        return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, lsn, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([lsd, rs])));
    }, $author$project$Expression$Simplify$stepSimplifyDivision = F2($author$project$Expression$Simplify$stepSimplifyDivision_fn);
    var $author$project$Expression$genericMatrixMultiplication_fn = function (_v0, l, r) {
        var by = _v0.cT;
        var plus = _v0.ci;
        var asList = _v0.cO;
        var toList = _v0.d3;
        var _v1 = $elm$core$Maybe$map2_fn($elm$core$Tuple$pair, $author$project$Expression$genericAsMatrix_fn(asList, l), $author$project$Expression$genericAsMatrix_fn(asList, r));
        if (!_v1.$) {
            var _v2 = _v1.a;
            var lm = _v2.a;
            var rm = _v2.b;
            var getRow = F2(function (j, m) {
                return $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$head($elm$core$List$drop_fn(j, m)));
            });
            var getCol = F2(function (j, m) {
                return $elm$core$List$filterMap_fn(A2($elm$core$Basics$composeR, $elm$core$List$drop(j), $elm$core$List$head), m);
            });
            var dot = F2(function (x, y) {
                return plus(_List_map2_fn_unwrapped(function (xe, ye) {
                    return by(_List_fromArray([xe, ye]));
                }, x, y));
            });
            var _v3 = $author$project$Expression$matrixSize(rm);
            var rr = _v3.a;
            var rc = _v3.b;
            var _v4 = $author$project$Expression$matrixSize(lm);
            var lr = _v4.a;
            var lc = _v4.b;
            return (!_Utils_eq(lc, rr)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(toList($elm$core$List$map_fn(function (row) {
                return toList($elm$core$List$map_fn(function (col) {
                    return A2(dot, A2(getRow, row, lm), A2(getCol, col, rm));
                }, $elm$core$List$range_fn(0, rc - 1)));
            }, $elm$core$List$range_fn(0, lr - 1))));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Expression$genericMatrixMultiplication = F3($author$project$Expression$genericMatrixMultiplication_fn);
    var $author$project$Expression$Simplify$multiplyMatrices_a0 = { cO: $author$project$Expression$Simplify$asList, cT: $author$project$Expression$Utils$by, ci: $author$project$Expression$Utils$plus, d3: $author$project$Expression$List }, $author$project$Expression$Simplify$multiplyMatrices = $author$project$Expression$genericMatrixMultiplication($author$project$Expression$Simplify$multiplyMatrices_a0);
    var $author$project$Expression$Simplify$stepSimplifyMultiplication_fn = function (left, right) {
        var go3 = function (_v26) {
            return $author$project$Expression$equals_fn(left, right) ? $elm$core$Maybe$Just($author$project$Expression$Utils$ipow_fn(right, 2)) : $elm$core$Maybe$Nothing;
        };
        var go2 = function (_v25) {
            var _v18 = _Utils_Tuple2(left, right);
            _v18$1: while (true) {
                _v18$4: while (true) {
                    switch (_v18.a.$) {
                        case 5:
                            if (!_v18.a.a) {
                                var _v19 = _v18.a;
                                var _v20 = _v19.a;
                                var ln = _v19.b;
                                var ld = _v19.c;
                                var r = _v18.b;
                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([ln, r])), ld));
                            }
                            else {
                                if ((_v18.b.$ === 5) && (!_v18.b.a)) {
                                    break _v18$1;
                                }
                                else {
                                    break _v18$4;
                                }
                            }
                        case 10:
                            switch (_v18.b.$) {
                                case 5:
                                    if (!_v18.b.a) {
                                        break _v18$1;
                                    }
                                    else {
                                        break _v18$4;
                                    }
                                case 10:
                                    var _v23 = $author$project$Expression$genericMatrixMultiplication_fn($author$project$Expression$Simplify$multiplyMatrices_a0, left, right);
                                    if (!_v23.$) {
                                        var r = _v23.a;
                                        return $elm$core$Maybe$Just(r);
                                    }
                                    else {
                                        return go3(0);
                                    }
                                default:
                                    break _v18$4;
                            }
                        case 3:
                            if ((_v18.b.$ === 5) && (!_v18.b.a)) {
                                break _v18$1;
                            }
                            else {
                                var _v24 = _v18.a;
                                var x = _v24.a;
                                var f = _v24.b;
                                var c = _v18.b;
                                return $elm$core$Maybe$Just(A3($author$project$Expression$partialSubstitute, x, c, f));
                            }
                        default:
                            if ((_v18.b.$ === 5) && (!_v18.b.a)) {
                                break _v18$1;
                            }
                            else {
                                break _v18$4;
                            }
                    }
                }
                return go3(0);
            }
            var l = _v18.a;
            var _v21 = _v18.b;
            var _v22 = _v21.a;
            var rn = _v21.b;
            var rd = _v21.c;
            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, rn])), rd));
        };
        var go1 = function (_v17) {
            var _v1 = _Utils_Tuple2(left, right);
            _v1$0: while (true) {
                _v1$1: while (true) {
                    _v1$3: while (true) {
                        _v1$4: while (true) {
                            _v1$5: while (true) {
                                switch (_v1.a.$) {
                                    case 7:
                                        switch (_v1.b.$) {
                                            case 7:
                                                if (!_v1.a.a) {
                                                    break _v1$0;
                                                }
                                                else {
                                                    if (!_v1.b.a) {
                                                        break _v1$1;
                                                    }
                                                    else {
                                                        break _v1$5;
                                                    }
                                                }
                                            case 5:
                                                if (!_v1.a.a) {
                                                    break _v1$0;
                                                }
                                                else {
                                                    if (_v1.b.a === 1) {
                                                        break _v1$4;
                                                    }
                                                    else {
                                                        break _v1$5;
                                                    }
                                                }
                                            default:
                                                if (!_v1.a.a) {
                                                    break _v1$0;
                                                }
                                                else {
                                                    break _v1$5;
                                                }
                                        }
                                    case 5:
                                        switch (_v1.b.$) {
                                            case 7:
                                                if (!_v1.b.a) {
                                                    break _v1$1;
                                                }
                                                else {
                                                    if (_v1.a.a === 1) {
                                                        break _v1$3;
                                                    }
                                                    else {
                                                        break _v1$5;
                                                    }
                                                }
                                            case 5:
                                                if (_v1.a.a === 1) {
                                                    if (_v1.b.a === 1) {
                                                        var _v6 = _v1.a;
                                                        var _v7 = _v6.a;
                                                        var lb = _v6.b;
                                                        var le = _v6.c;
                                                        var _v8 = _v1.b;
                                                        var _v9 = _v8.a;
                                                        var rb = _v8.b;
                                                        var re = _v8.c;
                                                        if ($author$project$Expression$equals_fn(lb, rb)) {
                                                            var _v10 = _Utils_Tuple2(le, re);
                                                            if ((!_v10.a.$) && (!_v10.b.$)) {
                                                                var lei = _v10.a.a;
                                                                var rei = _v10.b.a;
                                                                return $elm$core$Maybe$Just($author$project$Expression$Utils$ipow_fn(lb, lei + rei));
                                                            }
                                                            else {
                                                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, lb, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([le, re]))));
                                                            }
                                                        }
                                                        else {
                                                            return go2(0);
                                                        }
                                                    }
                                                    else {
                                                        break _v1$3;
                                                    }
                                                }
                                                else {
                                                    if (_v1.b.a === 1) {
                                                        break _v1$4;
                                                    }
                                                    else {
                                                        break _v1$5;
                                                    }
                                                }
                                            default:
                                                if (_v1.a.a === 1) {
                                                    break _v1$3;
                                                }
                                                else {
                                                    break _v1$5;
                                                }
                                        }
                                    default:
                                        switch (_v1.b.$) {
                                            case 7:
                                                if (!_v1.b.a) {
                                                    break _v1$1;
                                                }
                                                else {
                                                    break _v1$5;
                                                }
                                            case 5:
                                                if (_v1.b.a === 1) {
                                                    break _v1$4;
                                                }
                                                else {
                                                    break _v1$5;
                                                }
                                            default:
                                                break _v1$5;
                                        }
                                }
                            }
                            return go2(0);
                        }
                        var _v14 = _v1.b;
                        var _v15 = _v14.a;
                        var pb = _v14.b;
                        var pe = _v14.c;
                        if ($author$project$Expression$equals_fn(left, pb)) {
                            if (!pe.$) {
                                var pei = pe.a;
                                return $elm$core$Maybe$Just($author$project$Expression$Utils$ipow_fn(pb, pei + 1));
                            }
                            else {
                                return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn(1, pb, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([$author$project$Expression$Utils$one, pe]))));
                            }
                        }
                        else {
                            return go2(0);
                        }
                    }
                    var _v11 = _v1.a;
                    var _v12 = _v11.a;
                    var pb = _v11.b;
                    var pe = _v11.c;
                    var l = _v1.b;
                    if ($author$project$Expression$equals_fn(l, pb)) {
                        if (!pe.$) {
                            var pei = pe.a;
                            return $elm$core$Maybe$Just($author$project$Expression$Utils$ipow_fn(pb, pei + 1));
                        }
                        else {
                            return $elm$core$Maybe$Just($author$project$Expression$BinaryOperation_fn(1, pb, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([$author$project$Expression$Utils$one, pe]))));
                        }
                    }
                    else {
                        return go2(0);
                    }
                }
                var _v4 = _v1.b;
                var _v5 = _v4.a;
                var l = _v4.b;
                var m = _v4.c;
                var r = _v4.d;
                return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_Cons($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([left, l])), _List_Cons($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([left, m])), $elm$core$List$map_fn(function (o) {
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([left, o]));
                }, r)))));
            }
            var _v2 = _v1.a;
            var _v3 = _v2.a;
            var l = _v2.b;
            var m = _v2.c;
            var r = _v2.d;
            return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_Cons($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, right])), _List_Cons($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([m, right])), $elm$core$List$map_fn(function (o) {
                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([o, right]));
            }, r)))));
        };
        var go = function () {
            var _v0 = _Utils_Tuple2(left, right);
            _v0$0: while (true) {
                _v0$1: while (true) {
                    _v0$2: while (true) {
                        _v0$3: while (true) {
                            if (!_v0.a.$) {
                                if (!_v0.b.$) {
                                    switch (_v0.a.a) {
                                        case 1:
                                            break _v0$0;
                                        case 0:
                                            switch (_v0.b.a) {
                                                case 1:
                                                    break _v0$1;
                                                case 0:
                                                    break _v0$2;
                                                default:
                                                    break _v0$3;
                                            }
                                        default:
                                            switch (_v0.b.a) {
                                                case 1:
                                                    break _v0$1;
                                                case 0:
                                                    break _v0$2;
                                                default:
                                                    var il = _v0.a.a;
                                                    var ir = _v0.b.a;
                                                    return $elm$core$Maybe$Just($author$project$Expression$Integer(il * ir));
                                            }
                                    }
                                }
                                else {
                                    switch (_v0.a.a) {
                                        case 1:
                                            break _v0$0;
                                        case 0:
                                            break _v0$3;
                                        default:
                                            var j = _v0.a.a;
                                            return j === -1 ? $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, right)) : go1(0);
                                    }
                                }
                            }
                            else {
                                if (!_v0.b.$) {
                                    switch (_v0.b.a) {
                                        case 1:
                                            break _v0$1;
                                        case 0:
                                            break _v0$2;
                                        default:
                                            var k = _v0.b.a;
                                            return k === -1 ? $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, left)) : go1(0);
                                    }
                                }
                                else {
                                    return go1(0);
                                }
                            }
                        }
                        return $elm$core$Maybe$Just($author$project$Expression$Integer(0));
                    }
                    return $elm$core$Maybe$Just($author$project$Expression$Integer(0));
                }
                var c = _v0.a;
                return $elm$core$Maybe$Just(c);
            }
            var l = _v0.b;
            return $elm$core$Maybe$Just(l);
        }();
        return go;
    }, $author$project$Expression$Simplify$stepSimplifyMultiplication = F2($author$project$Expression$Simplify$stepSimplifyMultiplication_fn);
    var $author$project$Expression$Simplify$stepSimplifyPower_fn = function (ls, rs) {
        var _v0 = _Utils_Tuple2(ls, rs);
        _v0$0: while (true) {
            _v0$6: while (true) {
                _v0$8: while (true) {
                    _v0$10: while (true) {
                        _v0$11: while (true) {
                            switch (_v0.b.$) {
                                case 5:
                                    switch (_v0.a.$) {
                                        case 0:
                                            if (((!_v0.b.a) && (!_v0.b.b.$)) && (!_v0.b.c.$)) {
                                                var b = _v0.a.a;
                                                var _v6 = _v0.b;
                                                var _v7 = _v6.a;
                                                var en = _v6.b.a;
                                                var ed = _v6.c.a;
                                                if (!b) {
                                                    return $author$project$Expression$Integer(0);
                                                }
                                                else {
                                                    if (b === 1) {
                                                        return $author$project$Expression$Integer(1);
                                                    }
                                                    else {
                                                        var appr = $elm$core$Basics$floor(_Basics_pow_fn(b, en / ed));
                                                        return _Utils_eq(_Basics_pow_fn(appr, ed), _Basics_pow_fn(b, en)) ? $author$project$Expression$Integer(appr) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, $author$project$Expression$Integer(_Basics_pow_fn(b, en)), $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Integer(ed)));
                                                    }
                                                }
                                            }
                                            else {
                                                break _v0$11;
                                            }
                                        case 5:
                                            if (!_v0.a.a) {
                                                break _v0$6;
                                            }
                                            else {
                                                break _v0$8;
                                            }
                                        default:
                                            break _v0$11;
                                    }
                                case 4:
                                    if (_v0.a.$ === 5) {
                                        if (!_v0.a.a) {
                                            break _v0$6;
                                        }
                                        else {
                                            break _v0$8;
                                        }
                                    }
                                    else {
                                        var _v15 = _v0.b;
                                        var _v16 = _v15.a;
                                        var n = _v15.b;
                                        return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, ls, n));
                                    }
                                case 0:
                                    switch (_v0.a.$) {
                                        case 7:
                                            if (_v0.a.a === 1) {
                                                if (_v0.b.a === 1) {
                                                    break _v0$0;
                                                }
                                                else {
                                                    var _v1 = _v0.a;
                                                    var _v2 = _v1.a;
                                                    var lm = _v1.b;
                                                    var rm = _v1.c;
                                                    var om = _v1.d;
                                                    var rsi = _v0.b.a;
                                                    return $author$project$Expression$AssociativeOperation_fn(1, $author$project$Expression$Utils$ipow_fn(lm, rsi), $author$project$Expression$Utils$ipow_fn(rm, rsi), $elm$core$List$map_fn(function (b) {
                                                        return $author$project$Expression$Utils$ipow_fn(b, rsi);
                                                    }, om));
                                                }
                                            }
                                            else {
                                                if (_v0.b.a === 1) {
                                                    break _v0$0;
                                                }
                                                else {
                                                    var _v3 = _v0.a;
                                                    var _v4 = _v3.a;
                                                    var rsi = _v0.b.a;
                                                    if (rsi < 0) {
                                                        return $author$project$Expression$BinaryOperation_fn(0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$ipow_fn(ls, -rsi));
                                                    }
                                                    else {
                                                        switch (rsi) {
                                                            case 0:
                                                                return $author$project$Expression$Integer(1);
                                                            case 1:
                                                                return ls;
                                                            default:
                                                                return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                                                    ls,
                                                                    $author$project$Expression$Utils$ipow_fn(ls, rsi - 1)
                                                                ]));
                                                        }
                                                    }
                                                }
                                            }
                                        case 0:
                                            if (_v0.b.a === 1) {
                                                break _v0$0;
                                            }
                                            else {
                                                var il = _v0.a.a;
                                                var ir = _v0.b.a;
                                                return (ir < 0) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Integer(_Basics_pow_fn(il, -ir))) : $author$project$Expression$Integer(_Basics_pow_fn(il, ir));
                                            }
                                        case 2:
                                            if (_v0.b.a === 1) {
                                                break _v0$0;
                                            }
                                            else {
                                                if (_v0.a.a === "i") {
                                                    var ir = _v0.b.a;
                                                    var _v8 = _Basics_modBy_fn(4, ir);
                                                    switch (_v8) {
                                                        case 0:
                                                            return $author$project$Expression$Utils$one;
                                                        case 1:
                                                            return $author$project$Expression$Utils$i;
                                                        case 2:
                                                            return $author$project$Expression$Integer(-1);
                                                        default:
                                                            return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$Utils$i);
                                                    }
                                                }
                                                else {
                                                    break _v0$10;
                                                }
                                            }
                                        case 4:
                                            if (_v0.b.a === 1) {
                                                break _v0$0;
                                            }
                                            else {
                                                var _v11 = _v0.a;
                                                var _v12 = _v11.a;
                                                var nl = _v11.b;
                                                var ir = _v0.b.a;
                                                return (ir <= 0) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, ls, rs) : ((!_Basics_modBy_fn(2, ir)) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, nl, rs) : $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, nl, rs)));
                                            }
                                        case 5:
                                            if (!_v0.a.a) {
                                                if (_v0.b.a === 1) {
                                                    break _v0$0;
                                                }
                                                else {
                                                    break _v0$6;
                                                }
                                            }
                                            else {
                                                if (_v0.b.a === 1) {
                                                    break _v0$0;
                                                }
                                                else {
                                                    break _v0$8;
                                                }
                                            }
                                        default:
                                            if (_v0.b.a === 1) {
                                                break _v0$0;
                                            }
                                            else {
                                                break _v0$10;
                                            }
                                    }
                                default:
                                    if (_v0.a.$ === 5) {
                                        if (!_v0.a.a) {
                                            break _v0$6;
                                        }
                                        else {
                                            break _v0$8;
                                        }
                                    }
                                    else {
                                        break _v0$11;
                                    }
                            }
                        }
                        return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, ls, rs);
                    }
                    var n = _v0.b.a;
                    return (n < 0) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Utils$ipow_fn(ls, -n)) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, ls, rs);
                }
                var _v13 = _v0.a;
                var _v14 = _v13.a;
                var bb = _v13.b;
                var be = _v13.c;
                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, bb, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([be, rs])));
            }
            var _v9 = _v0.a;
            var _v10 = _v9.a;
            var nl = _v9.b;
            var dl = _v9.c;
            return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, nl, rs), $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, dl, rs));
        }
        return ls;
    }, $author$project$Expression$Simplify$stepSimplifyPower = F2($author$project$Expression$Simplify$stepSimplifyPower_fn);
    var $author$project$Expression$Simplify$tryExtract_fn = function (f, g, es) {
        return $elm$core$Maybe$withDefault_fn(es, $elm$core$Maybe$map_fn(g, $author$project$Expression$Simplify$extract_fn(f, es)));
    }, $author$project$Expression$Simplify$tryExtract = F3($author$project$Expression$Simplify$tryExtract_fn);
    var $author$project$Expression$Simplify$step1_fn = function (context, _v24, arg) {
        var andThen = _v24.E;
        var ifChanged = _v24.K;
        var sarg = $author$project$Expression$Simplify$stepSimplify_fn(context, arg);
        return $author$project$Expression$equals_fn(arg, sarg) ? andThen(sarg) : ifChanged(sarg);
    }, $author$project$Expression$Simplify$step1 = F3($author$project$Expression$Simplify$step1_fn);
    var $author$project$Expression$Simplify$step2_fn = function (context, _v23, arg1, arg2) {
        var andThen = _v23.E;
        var ifChanged = _v23.K;
        var sarg2 = $author$project$Expression$Simplify$stepSimplify_fn(context, arg2);
        var sarg1 = $author$project$Expression$Simplify$stepSimplify_fn(context, arg1);
        return ($author$project$Expression$equals_fn(arg1, sarg1) && $author$project$Expression$equals_fn(arg2, sarg2)) ? A2(andThen, sarg1, sarg2) : A2(ifChanged, sarg1, sarg2);
    }, $author$project$Expression$Simplify$step2 = F4($author$project$Expression$Simplify$step2_fn);
    var $author$project$Expression$Simplify$stepList_fn = function (context, _v22, args) {
        var andThen = _v22.E;
        var ifChanged = _v22.K;
        var sargs = $elm$core$List$map_fn($author$project$Expression$Simplify$stepSimplify(context), args);
        return $elm$core$List$all_fn($elm$core$Basics$identity, _List_map2_fn($author$project$Expression$equals, args, sargs)) ? andThen(sargs) : ifChanged(sargs);
    }, $author$project$Expression$Simplify$stepList = F3($author$project$Expression$Simplify$stepList_fn);
    var $author$project$Expression$Simplify$stepSimplify_fn = function (context, expr) {
        switch (expr.$) {
            case 2:
                var v = expr.a;
                return $elm$core$Maybe$withDefault_fn(expr, $elm$core$Dict$get_fn(v, context));
            case 9:
                var vars = expr.a;
                var e = expr.b;
                return $author$project$Expression$Simplify$step1_fn(context, {
                    E: $author$project$Expression$fullSubstitute($elm$core$Basics$composeR_fn($author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1, vars)),
                    K: $author$project$Expression$Replace(vars)
                }, e);
            case 3:
                var x = expr.a;
                var f = expr.b;
                return $author$project$Expression$Lambda_fn(x, $author$project$Expression$Simplify$stepSimplify_fn(context, f));
            case 4:
                var _v16 = expr.a;
                var e = expr.b;
                return $author$project$Expression$Simplify$step1_fn(context, {
                    E: $author$project$Expression$Simplify$stepSimplifyNegate(context),
                    K: $author$project$Expression$Utils$negate_
                }, e);
            case 5:
                var bop = expr.a;
                var l = expr.b;
                var r = expr.c;
                return $author$project$Expression$Simplify$step2_fn(context, {
                    E: function () {
                        if (!bop) {
                            return $author$project$Expression$Simplify$stepSimplifyDivision;
                        }
                        else {
                            return $author$project$Expression$Simplify$stepSimplifyPower;
                        }
                    }(),
                    K: $author$project$Expression$BinaryOperation(bop)
                }, l, r);
            case 6:
                var rop = expr.a;
                var l = expr.b;
                var r = expr.c;
                return $author$project$Expression$Simplify$step2_fn(context, {
                    E: $author$project$Expression$RelationOperation(rop),
                    K: $author$project$Expression$RelationOperation(rop)
                }, l, r);
            case 7:
                if (((((expr.a === 1) && expr.d.b) && (expr.d.a.$ === 7)) && (!expr.d.a.a)) && (!expr.d.b.b)) {
                    var _v18 = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var _v19 = expr.d;
                    var _v20 = _v19.a;
                    var _v21 = _v20.a;
                    var al = _v20.b;
                    var ar = _v20.c;
                    var ao = _v20.d;
                    return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn(function (o) {
                        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, r, o]));
                    }, _List_Cons(al, _List_Cons(ar, ao))));
                }
                else {
                    var aop = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var o = expr.d;
                    return $author$project$Expression$Simplify$stepList_fn(context, {
                        E: A2($author$project$Expression$Simplify$stepSimplifyAssociative, context, aop),
                        K: (!aop) ? $author$project$Expression$Utils$plus : $author$project$Expression$Utils$by
                    }, _List_Cons(l, _List_Cons(r, o)));
                }
            case 8:
                var name = expr.a;
                var args = expr.b;
                return $author$project$Expression$Simplify$stepList_fn(context, {
                    E: $author$project$Expression$Simplify$stepSimplifyApply(name),
                    K: $author$project$Expression$Apply(name)
                }, args);
            case 10:
                var es = expr.a;
                return $author$project$Expression$Simplify$stepList_fn(context, { E: $author$project$Expression$List, K: $author$project$Expression$List }, es);
            case 0:
                return expr;
            default:
                return expr;
        }
    }, $author$project$Expression$Simplify$stepSimplify = F2($author$project$Expression$Simplify$stepSimplify_fn);
    var $author$project$Expression$Simplify$stepSimplifyAssociative_fn = function (context, aop, args) {
        var groupStep = function () {
            if (!aop) {
                return $author$project$Expression$Simplify$stepSimplifyAddition;
            }
            else {
                return $author$project$Expression$Simplify$stepSimplifyMultiplication;
            }
        }();
        var extractop = function (e) {
            _v11$2: while (true) {
                switch (e.$) {
                    case 4:
                        if (e.b.$ === 7) {
                            var _v12 = e.a;
                            var _v13 = e.b;
                            var iaop = _v13.a;
                            var il = _v13.b;
                            var ir = _v13.c;
                            var io = _v13.d;
                            return _Utils_eq(iaop, aop) ? ((!aop) ? $elm$core$List$map_fn($author$project$Expression$UnaryOperation(0), _List_Cons(il, _List_Cons(ir, io))) : _List_Cons($author$project$Expression$UnaryOperation_fn(0, il), _List_Cons(ir, io))) : _List_fromArray([e]);
                        }
                        else {
                            break _v11$2;
                        }
                    case 7:
                        var iaop = e.a;
                        var il = e.b;
                        var ir = e.c;
                        var io = e.d;
                        return _Utils_eq(iaop, aop) ? _List_Cons(il, _List_Cons(ir, io)) : _List_fromArray([e]);
                    default:
                        break _v11$2;
                }
            }
            return _List_fromArray([e]);
        };
        var build = function () {
            if (!aop) {
                return $author$project$Expression$Utils$plus;
            }
            else {
                return $author$project$Expression$Utils$by;
            }
        }();
        var andThen = function (ls) {
            return build($author$project$Expression$Simplify$sortByDegree_fn(aop, function () {
                if (!aop) {
                    return $elm$core$Basics$identity;
                }
                else {
                    return A2($author$project$Expression$Simplify$tryExtract, $author$project$Expression$Simplify$findNegate, function (_v9) {
                        var negated = _v9.a;
                        var rest = _v9.b;
                        return _List_fromArray([
                            $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, build(_List_Cons(negated, rest)))
                        ]);
                    });
                }
            }()($author$project$List$MyExtra$groupOneWith_fn(groupStep, ls))));
        };
        return $author$project$Expression$Simplify$stepList_fn(context, { E: andThen, K: build }, $author$project$Expression$Simplify$sortByDegree_fn(aop, $elm$core$List$concatMap_fn(extractop, args)));
    }, $author$project$Expression$Simplify$stepSimplifyAssociative = F3($author$project$Expression$Simplify$stepSimplifyAssociative_fn);
    var $author$project$Expression$Simplify$stepSimplifyNegate_fn = function (context, expr) {
        _v0$7: while (true) {
            switch (expr.$) {
                case 4:
                    var _v1 = expr.a;
                    var e = expr.b;
                    return e;
                case 0:
                    var ni = expr.a;
                    return $author$project$Expression$Integer(-ni);
                case 10:
                    var ls = expr.a;
                    return $author$project$Expression$Simplify$stepList_fn(context, {
                        E: function (ss) {
                            return $author$project$Expression$List($elm$core$List$map_fn($author$project$Expression$Utils$negate_, ss));
                        },
                        K: function (ss) {
                            return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, $author$project$Expression$List(ss));
                        }
                    }, ls);
                case 5:
                    if (!expr.a) {
                        switch (expr.b.$) {
                            case 4:
                                var _v2 = expr.a;
                                var _v3 = expr.b;
                                var _v4 = _v3.a;
                                var n = _v3.b;
                                var d = expr.c;
                                return $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, n, d);
                            case 0:
                                var _v5 = expr.a;
                                var i = expr.b.a;
                                var d = expr.c;
                                return (i < 0) ? $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(-i), d) : $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, expr);
                            default:
                                break _v0$7;
                        }
                    }
                    else {
                        break _v0$7;
                    }
                case 7:
                    if (expr.a === 1) {
                        if (!expr.b.$) {
                            var _v6 = expr.a;
                            var i = expr.b.a;
                            var m = expr.c;
                            var r = expr.d;
                            return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _Utils_ap(_List_fromArray([
                                $author$project$Expression$Integer(-i),
                                m
                            ]), r));
                        }
                        else {
                            break _v0$7;
                        }
                    }
                    else {
                        var _v7 = expr.a;
                        var l = expr.b;
                        var m = expr.c;
                        var r = expr.d;
                        return $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$map_fn($author$project$Expression$Utils$negate_, _List_Cons(l, _List_Cons(m, r))));
                    }
                default:
                    break _v0$7;
            }
        }
        return $author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, expr);
    }, $author$project$Expression$Simplify$stepSimplifyNegate = F2($author$project$Expression$Simplify$stepSimplifyNegate_fn);
    var $author$project$Expression$Simplify$simplify = function () {
        var go = F2(function (n, e) {
            go: while (true) {
                if (n <= 0) {
                    return e;
                }
                else {
                    var res = $author$project$Expression$Simplify$stepSimplify_fn($elm$core$Dict$empty, e);
                    if ($author$project$Expression$equals_fn(e, res)) {
                        return e;
                    }
                    else {
                        var $temp$n = n - 1, $temp$e = res;
                        n = $temp$n;
                        e = $temp$e;
                        continue go;
                    }
                }
            }
        });
        return go(100);
    }();
    function $author$project$Expression$Graph$cyclic$fromExpression() {
        var go = function (expr) {
            var free = $author$project$Expression$getFreeVariables(expr);
            _v0$5: while (true) {
                switch (expr.$) {
                    case 3:
                        var x = expr.a;
                        var f = expr.b;
                        return $author$project$Expression$Graph$cyclic$fromExpression()(A3($author$project$Expression$partialSubstitute, x, $author$project$Expression$Variable("x"), f));
                    case 9:
                        if (expr.b.$ === 6) {
                            var ctx = expr.a;
                            var _v1 = expr.b;
                            var rop = _v1.a;
                            var l = _v1.b;
                            var r = _v1.c;
                            return $author$project$Expression$Graph$cyclic$fromExpression()($author$project$Expression$RelationOperation_fn(rop, $author$project$Expression$Replace_fn(ctx, l), $author$project$Expression$Replace_fn(ctx, r)));
                        }
                        else {
                            break _v0$5;
                        }
                    case 6:
                        var rop = expr.a;
                        var l = expr.b;
                        var r = expr.c;
                        if ($elm$core$Set$member_fn("z", free)) {
                            return $author$project$Expression$Graph$Implicit3D(expr);
                        }
                        else {
                            if ($elm$core$Set$member_fn("r", free)) {
                                return $author$project$Expression$Graph$Polar2D($author$project$Expression$Utils$minus_fn(l, r));
                            }
                            else {
                                var _v2 = _Utils_Tuple3(l, rop, $elm$core$Set$member_fn("y", $author$project$Expression$getFreeVariables(r)));
                                if (_v2.b === 2) {
                                    if (((_v2.a.$ === 2) && (_v2.a.a === "y")) && (!_v2.c)) {
                                        var _v3 = _v2.b;
                                        return $author$project$Expression$Graph$Explicit2D(r);
                                    }
                                    else {
                                        var _v4 = _v2.b;
                                        return $author$project$Expression$Graph$Implicit2D_fn(l, r);
                                    }
                                }
                                else {
                                    return $author$project$Expression$Graph$Relation2D(expr);
                                }
                            }
                        }
                    case 10:
                        var ls = expr.a;
                        if ($elm$core$Set$member_fn("r", free)) {
                            return $author$project$Expression$Graph$GraphList($elm$core$List$map_fn($author$project$Expression$Graph$cyclic$fromExpression(), ls));
                        }
                        else {
                            if ($elm$core$Set$member_fn("t", free)) {
                                if ((ls.b && ls.b.b) && (!ls.b.b.b)) {
                                    var x = ls.a;
                                    var _v6 = ls.b;
                                    var y = _v6.a;
                                    return $author$project$Expression$Graph$Parametric2D_fn(x, y);
                                }
                                else {
                                    return $author$project$Expression$Graph$GraphList($elm$core$List$map_fn($author$project$Expression$Graph$cyclic$fromExpression(), ls));
                                }
                            }
                            else {
                                if ((((((((ls.b && (ls.a.$ === 10)) && ls.a.a.b) && (!ls.a.a.b.b)) && ls.b.b) && (ls.b.a.$ === 10)) && ls.b.a.a.b) && (!ls.b.a.a.b.b)) && (!ls.b.b.b)) {
                                    var _v8 = ls.a.a;
                                    var x = _v8.a;
                                    var _v9 = ls.b;
                                    var _v10 = _v9.a.a;
                                    var y = _v10.a;
                                    return $author$project$Expression$Graph$VectorField2D_fn(x, y);
                                }
                                else {
                                    return $author$project$Expression$Graph$GraphList($elm$core$List$map_fn($author$project$Expression$Graph$cyclic$fromExpression(), ls));
                                }
                            }
                        }
                    case 8:
                        if ((((!expr.a.$) && (expr.a.a.$ === 31)) && expr.b.b) && (!expr.b.b.b)) {
                            var _v11 = expr.a.a;
                            var _v12 = expr.b;
                            var e = _v12.a;
                            return go($author$project$Expression$Simplify$simplify(e));
                        }
                        else {
                            break _v0$5;
                        }
                    default:
                        break _v0$5;
                }
            }
            return $elm$core$Set$member_fn("z", free) ? $author$project$Expression$Graph$Implicit3D(expr) : ($elm$core$Set$member_fn("r", free) ? $author$project$Expression$Graph$Polar2D(expr) : ($elm$core$Set$member_fn("y", free) ? $author$project$Expression$Graph$Contour(expr) : $author$project$Expression$Graph$Explicit2D(expr)));
        };
        return A2($elm$core$Basics$composeL, go, $author$project$Expression$Simplify$hoistLambda);
    }
    var $author$project$Expression$Graph$fromExpression = $author$project$Expression$Graph$cyclic$fromExpression();
    $author$project$Expression$Graph$cyclic$fromExpression = function () {
        return $author$project$Expression$Graph$fromExpression;
    };
    var $author$project$Complex$im = function (_v0) {
        var y = _v0.b;
        return $author$project$Complex$fromReal(y);
    };
    var $author$project$Complex$max_fn = function (l, r) {
        var lr = l.a;
        var rr = r.a;
        return (_Utils_cmp(lr, rr) > 0) ? l : r;
    }, $author$project$Complex$max = F2($author$project$Complex$max_fn);
    var $author$project$Complex$min_fn = function (l, r) {
        var lr = l.a;
        var rr = r.a;
        return (_Utils_cmp(lr, rr) < 0) ? l : r;
    }, $author$project$Complex$min = F2($author$project$Complex$min_fn);
    var $author$project$Expression$Value$negateValue_a0 = {
        aa: $author$project$Complex$negate,
        ad: $elm$core$Maybe$Nothing,
        ae: $elm$core$Maybe$Nothing,
        ah: $author$project$Expression$UnaryOperation(0)
    }, $author$project$Expression$Value$negateValue = $author$project$Expression$Value$complexMap($author$project$Expression$Value$negateValue_a0);
    var $author$project$Expression$Value$toExpression = function (v) {
        switch (v.$) {
            case 5:
                var x = v.a;
                var f = v.b;
                return $author$project$Expression$Lambda_fn(x, $author$project$Expression$Value$toExpression(f));
            case 2:
                var s = v.a;
                return s;
            case 3:
                var c = v.a;
                return $author$project$Expression$Value$complexToSymbolic(c);
            case 6:
                var l = v.a;
                return $author$project$Expression$List($elm$core$List$map_fn($author$project$Expression$Value$toExpression, l));
            case 4:
                var graph = v.a.aw;
                var axes = v.a.aP;
                return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction(axes ? $author$project$Expression$Plot : $author$project$Expression$APlot), _List_fromArray([
                    $author$project$Expression$Graph$toExpression(graph)
                ]));
            case 0:
                return $author$project$Expression$Integer(0);
            default:
                return $author$project$Expression$Integer(0);
        }
    };
    var $author$project$Expression$Value$partialSubstitute_fn = function (_var, val, expr) {
        switch (expr.$) {
            case 2:
                var s = expr.a;
                return $author$project$Expression$Value$SymbolicValue(A3($author$project$Expression$partialSubstitute, _var, $author$project$Expression$Value$toExpression(val), s));
            case 5:
                var x = expr.a;
                var f = expr.b;
                return _Utils_eq(x, _var) ? expr : $author$project$Expression$Value$LambdaValue_fn(x, $author$project$Expression$Value$partialSubstitute_fn(_var, val, f));
            case 6:
                var ls = expr.a;
                return $author$project$Expression$Value$ListValue($elm$core$List$map_fn(A2($author$project$Expression$Value$partialSubstitute, _var, val), ls));
            case 4:
                return expr;
            case 3:
                return expr;
            case 0:
                return expr;
            default:
                return expr;
        }
    }, $author$project$Expression$Value$partialSubstitute = F3($author$project$Expression$Value$partialSubstitute_fn);
    var $author$project$Complex$power_fn = function (b, z) {
        var br = b.a;
        var bi = b.b;
        var zr = z.a;
        var zi = z.b;
        if ((!bi) && (!zi)) {
            return $author$project$Complex$fromReal(_Basics_pow_fn(br, zr));
        }
        else {
            var _v0 = $author$project$Complex$toPolar(b);
            var r = _v0.a;
            var t = _v0.b;
            return $author$project$Complex$exp($author$project$Complex$by_fn(z, $author$project$Complex$Complex_fn($elm$core$Basics$logBase_fn($elm$core$Basics$e, r), t)));
        }
    }, $author$project$Complex$power = F2($author$project$Complex$power_fn);
    var $author$project$Complex$re = function (_v0) {
        var x = _v0.a;
        return $author$project$Complex$fromReal(x);
    };
    var $author$project$Complex$zero = $author$project$Complex$Complex_fn(0, 0);
    var $author$project$Expression$Value$relationValue_fn = function (o, lc, rc) {
        var lv = lc.a;
        var rv = rc.a;
        var toComplex = function (check) {
            return check ? $author$project$Complex$one : $author$project$Complex$zero;
        };
        switch (o) {
            case 0:
                return toComplex(_Utils_cmp(lv, rv) < 0);
            case 1:
                return toComplex(_Utils_cmp(lv, rv) < 1);
            case 2:
                return $author$project$Complex$minus_fn(lc, rc);
            case 3:
                return toComplex(_Utils_cmp(lv, rv) > -1);
            default:
                return toComplex(_Utils_cmp(lv, rv) > 0);
        }
    }, $author$project$Expression$Value$relationValue = F3($author$project$Expression$Value$relationValue_fn);
    var $author$project$Complex$round = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        return $author$project$Complex$Complex_fn($elm$core$Basics$round(x), $elm$core$Basics$round(y));
    };
    var $author$project$Complex$sign = function (_v0) {
        var x = _v0.a;
        var y = _v0.b;
        var sgn = function (q) {
            return (q > 0) ? 1 : ((q < 0) ? (-1) : 0);
        };
        return $author$project$Complex$Complex_fn(sgn(x), sgn(y));
    };
    var $author$project$Complex$sinh = function (x) {
        return $author$project$Complex$negate($author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$sin($author$project$Complex$by_fn($author$project$Complex$i, x))));
    };
    var $author$project$Expression$SolutionBranch = function (a) {
        return { $: 5, a: a };
    };
    var $author$project$Expression$SolutionError = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$Expression$SolutionStep_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $author$project$Expression$SolutionStep = F2($author$project$Expression$SolutionStep_fn);
    var $author$project$Expression$Solver$Shortcut_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Expression$Solver$Shortcut = F2($author$project$Expression$Solver$Shortcut_fn);
    function $author$project$Expression$Solver$cyclic$cut() {
        var go = function (tree) {
            switch (tree.$) {
                case 1:
                    return _Utils_Tuple2($elm$core$Dict$empty, tree);
                case 2:
                    return _Utils_Tuple2($elm$core$Dict$empty, tree);
                case 0:
                    return _Utils_Tuple2($elm$core$Dict$empty, tree);
                case 3:
                    var e = tree.a;
                    return _Utils_Tuple2($elm$core$Dict$singleton_fn($elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, e), $author$project$Expression$Solver$Shortcut_fn(tree, $elm$core$Dict$empty)), tree);
                case 4:
                    var e = tree.a;
                    var n = tree.b;
                    var key = $elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, e);
                    var _v1 = go(n);
                    var shortcuts = _v1.a;
                    var ncut = _v1.b;
                    var _v2 = $elm$core$Dict$get_fn(key, shortcuts);
                    if (_v2.$ === 1) {
                        var res = $author$project$Expression$SolutionStep_fn(e, ncut);
                        return _Utils_Tuple2($elm$core$Dict$insert_fn(key, $author$project$Expression$Solver$Shortcut_fn(res, shortcuts), shortcuts), res);
                    }
                    else {
                        var _v3 = _v2.a;
                        var shortTree = _v3.a;
                        var lessShortcuts = _v3.b;
                        return _Utils_Tuple2($elm$core$Dict$insert_fn(key, $author$project$Expression$Solver$Shortcut_fn(shortTree, shortcuts), lessShortcuts), shortTree);
                    }
                default:
                    var ls = tree.a;
                    return _Utils_Tuple2($elm$core$Dict$empty, $author$project$Expression$SolutionBranch($elm$core$List$map_fn($author$project$Expression$Solver$cyclic$cut(), ls)));
            }
        };
        return A2($elm$core$Basics$composeR, go, $elm$core$Tuple$second);
    }
    var $author$project$Expression$Solver$cut = $author$project$Expression$Solver$cyclic$cut();
    $author$project$Expression$Solver$cyclic$cut = function () {
        return $author$project$Expression$Solver$cut;
    };
    var $author$project$Expression$Solver$coeffsToEq = function (coeffs) {
        return function (l) {
            return $author$project$Expression$RelationOperation_fn(2, l, $author$project$Expression$Utils$zero);
        }($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$filterMap_fn(function (_v0) {
            var exps = _v0.a;
            var c = _v0.b;
            if ($elm$core$List$isEmpty(exps)) {
                return $author$project$Expression$Utils$isZero(c) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(c);
            }
            else {
                var pows = $author$project$Expression$Utils$byShort($elm$core$List$map_fn(function (_v2) {
                    var v = _v2.a;
                    var e = _v2.b;
                    return $author$project$Expression$Utils$ipowShort_fn($author$project$Expression$Variable(v), e);
                }, exps));
                if ($author$project$Expression$Utils$isZero(c)) {
                    return $elm$core$Maybe$Nothing;
                }
                else {
                    switch (c.$) {
                        case 0:
                            var i = c.a;
                            return (i === 1) ? $elm$core$Maybe$Just(pows) : (i === -1 ? $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, pows)) : $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([c, pows]))));
                        case 1:
                            var f = c.a;
                            return (f === 1) ? $elm$core$Maybe$Just(pows) : (f === -1 ? $elm$core$Maybe$Just($author$project$Expression$UnaryOperation_fn($author$project$Expression$Utils$negate__a0, pows)) : $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([c, pows]))));
                        default:
                            return $elm$core$Maybe$Just($author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([c, pows])));
                    }
                }
            }
        }, $elm$core$List$reverse($elm$core$Dict$toList(coeffs)))));
    };
    var $elm$core$Result$andThen_fn = function (callback, result) {
        if (!result.$) {
            var value = result.a;
            return callback(value);
        }
        else {
            var msg = result.a;
            return $elm$core$Result$Err(msg);
        }
    }, $elm$core$Result$andThen = F2($elm$core$Result$andThen_fn);
    var $author$project$Fraction$Fraction_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $author$project$Fraction$Fraction = F2($author$project$Fraction$Fraction_fn);
    var $author$project$Fraction$build_fn = function (n, d) {
        build: while (true) {
            if (d < 0) {
                var $temp$n = -n, $temp$d = -d;
                n = $temp$n;
                d = $temp$d;
                continue build;
            }
            else {
                var g = $author$project$Fraction$gcd_fn(n, d);
                return $author$project$Fraction$Fraction_fn((n / g) | 0, (d / g) | 0);
            }
        }
    }, $author$project$Fraction$build = F2($author$project$Fraction$build_fn);
    var $author$project$Fraction$by_fn = function (_v0, _v1) {
        var ln = _v0.a;
        var ld = _v0.b;
        var rn = _v1.a;
        var rd = _v1.b;
        return $author$project$Fraction$build_fn(ln * rn, ld * rd);
    }, $author$project$Fraction$by = F2($author$project$Fraction$by_fn);
    var $author$project$Fraction$div_fn = function (_v0, _v1) {
        var ln = _v0.a;
        var ld = _v0.b;
        var rn = _v1.a;
        var rd = _v1.b;
        return $author$project$Fraction$build_fn(ln * rd, ld * rn);
    }, $author$project$Fraction$div = F2($author$project$Fraction$div_fn);
    var $author$project$Fraction$fromInt = function (i) {
        return $author$project$Fraction$Fraction_fn(i, 1);
    };
    var $elm$core$Result$map2_fn = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(A2(func, a, b));
            }
        }
    }, $elm$core$Result$map2_fn_unwrapped = function (func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        }
        else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            }
            else {
                var b = rb.a;
                return $elm$core$Result$Ok(func(a, b));
            }
        }
    }, $elm$core$Result$map2 = F3($elm$core$Result$map2_fn);
    var $author$project$Fraction$negate = function (_v0) {
        var n = _v0.a;
        var d = _v0.b;
        return $author$project$Fraction$Fraction_fn(-n, d);
    };
    var $author$project$Fraction$plus_fn = function (_v0, _v1) {
        var ln = _v0.a;
        var ld = _v0.b;
        var rn = _v1.a;
        var rd = _v1.b;
        return $author$project$Fraction$build_fn((ln * rd) + (rn * ld), ld * rd);
    }, $author$project$Fraction$plus = F2($author$project$Fraction$plus_fn);
    var $author$project$Expression$Solver$asFraction = function (e) {
        _v0$5: while (true) {
            switch (e.$) {
                case 0:
                    var i = e.a;
                    return $elm$core$Result$Ok($author$project$Fraction$fromInt(i));
                case 5:
                    if (!e.a) {
                        var _v1 = e.a;
                        var n = e.b;
                        var d = e.c;
                        return $elm$core$Result$map2_fn($author$project$Fraction$div, $author$project$Expression$Solver$asFraction(n), $author$project$Expression$Solver$asFraction(d));
                    }
                    else {
                        break _v0$5;
                    }
                case 7:
                    if (!e.a) {
                        var _v2 = e.a;
                        var l = e.b;
                        var m = e.c;
                        var r = e.d;
                        return $elm$core$List$foldr_fn($elm$core$Result$map2($author$project$Fraction$plus), $author$project$Expression$Solver$asFraction(l), $elm$core$List$map_fn($author$project$Expression$Solver$asFraction, _List_Cons(m, r)));
                    }
                    else {
                        var _v3 = e.a;
                        var l = e.b;
                        var m = e.c;
                        var r = e.d;
                        return $elm$core$List$foldr_fn($elm$core$Result$map2($author$project$Fraction$by), $author$project$Expression$Solver$asFraction(l), $elm$core$List$map_fn($author$project$Expression$Solver$asFraction, _List_Cons(m, r)));
                    }
                case 4:
                    var _v4 = e.a;
                    var inner = e.b;
                    return $elm$core$Result$map_fn($author$project$Fraction$negate, $author$project$Expression$Solver$asFraction(inner));
                default:
                    break _v0$5;
            }
        }
        return $elm$core$Result$Err($elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, e) + " is not a fraction");
    };
    var $elm_community$result_extra$Result$Extra$combine_a0 = $elm$core$Result$map2($elm$core$List$cons), $elm_community$result_extra$Result$Extra$combine_a1 = $elm$core$Result$Ok(_List_Nil), $elm_community$result_extra$Result$Extra$combine = A2($elm$core$List$foldr, $elm_community$result_extra$Result$Extra$combine_a0, $elm_community$result_extra$Result$Extra$combine_a1);
    var $author$project$Fraction$divisor = function (_v0) {
        var d = _v0.b;
        return d;
    };
    var $elm$core$Result$fromMaybe_fn = function (err, maybe) {
        if (!maybe.$) {
            var v = maybe.a;
            return $elm$core$Result$Ok(v);
        }
        else {
            return $elm$core$Result$Err(err);
        }
    }, $elm$core$Result$fromMaybe = F2($elm$core$Result$fromMaybe_fn);
    var $elm_community$list_extra$List$Extra$initialize_fn = function (n, f) {
        var step = F2(function (i, acc) {
            step: while (true) {
                if (i < 0) {
                    return acc;
                }
                else {
                    var $temp$i = i - 1, $temp$acc = _List_Cons(f(i), acc);
                    i = $temp$i;
                    acc = $temp$acc;
                    continue step;
                }
            }
        });
        return A2(step, n - 1, _List_Nil);
    }, $elm_community$list_extra$List$Extra$initialize = F2($elm_community$list_extra$List$Extra$initialize_fn);
    var $author$project$Fraction$isZero = function (_v0) {
        var n = _v0.a;
        return !n;
    };
    var $author$project$Fraction$toFloat = function (_v0) {
        var n = _v0.a;
        var d = _v0.b;
        return n / d;
    };
    var $author$project$Fraction$toPair = function (_v0) {
        var n = _v0.a;
        var d = _v0.b;
        return _Utils_Tuple2(n, d);
    };
    var $elm_community$list_extra$List$Extra$uniqueHelp_fn = function (f, existing, remaining, accumulator) {
        uniqueHelp: while (true) {
            if (!remaining.b) {
                return $elm$core$List$reverse(accumulator);
            }
            else {
                var first = remaining.a;
                var rest = remaining.b;
                var computedFirst = f(first);
                if ($elm$core$Set$member_fn(computedFirst, existing)) {
                    var $temp$f = f, $temp$existing = existing, $temp$remaining = rest, $temp$accumulator = accumulator;
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
                else {
                    var $temp$f = f, $temp$existing = $elm$core$Set$insert_fn(computedFirst, existing), $temp$remaining = rest, $temp$accumulator = _List_Cons(first, accumulator);
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
            }
        }
    }, $elm_community$list_extra$List$Extra$uniqueHelp = F4($elm_community$list_extra$List$Extra$uniqueHelp_fn);
    var $elm_community$list_extra$List$Extra$uniqueBy_fn = function (f, list) {
        return $elm_community$list_extra$List$Extra$uniqueHelp_fn(f, $elm$core$Set$empty, list, _List_Nil);
    }, $elm_community$list_extra$List$Extra$uniqueBy = F2($elm_community$list_extra$List$Extra$uniqueBy_fn);
    var $author$project$Expression$Solver$findRationalRoot_fn = function (v, coeffs) {
        var rootAndRest = F2(function (potential, c) {
            var toExpr = function (f) {
                var _v8 = $author$project$Fraction$toPair(f);
                var n = _v8.a;
                var d = _v8.b;
                return (d === 1) ? $author$project$Expression$Integer(n) : ((!n) ? $author$project$Expression$Integer(0) : $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Integer(n), $author$project$Expression$Integer(d)));
            };
            var rest = $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, $elm$core$List$reverse($elm$core$List$filterMap_fn($elm$core$Basics$identity, $elm$core$List$indexedMap_fn(F2(function (exponent, k) {
                var ke = toExpr(k);
                return $author$project$Fraction$isZero(k) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(function () {
                    switch (exponent) {
                        case 0:
                            return toExpr(k);
                        case 1:
                            return _Utils_eq(ke, $author$project$Expression$Integer(1)) ? $author$project$Expression$Variable(v) : $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                toExpr(k),
                                $author$project$Expression$Variable(v)
                            ]));
                        default:
                            return _Utils_eq(ke, $author$project$Expression$Integer(1)) ? $author$project$Expression$Utils$ipow_fn($author$project$Expression$Variable(v), exponent) : $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([
                                toExpr(k),
                                $author$project$Expression$Utils$ipow_fn($author$project$Expression$Variable(v), exponent)
                            ]));
                    }
                }());
            }), c))));
            return {
                dN: rest,
                dP: toExpr(potential)
            };
        });
        var findRoot = function (rats) {
            var commonMultiple = $elm$core$List$foldl_fn_unwrapped(function (f, a) {
                return $elm$core$Basics$abs((($author$project$Fraction$divisor(f) * a) / $author$project$Fraction$gcd_fn($author$project$Fraction$divisor(f), a)) | 0);
            }, 1, $elm$core$List$map_fn($elm$core$Tuple$second, rats));
            var reduced = $elm$core$List$map_fn($elm$core$Tuple$mapSecond(A2($elm$core$Basics$composeR, $author$project$Fraction$toPair, function (_v6) {
                var n = _v6.a;
                var d = _v6.b;
                return ((n * commonMultiple) / d) | 0;
            })), rats);
            var head = $elm$core$Maybe$withDefault_fn(1, $elm$core$Maybe$map_fn($elm$core$Tuple$second, $elm$core$List$head(_List_sortBy_fn(function (_v5) {
                var d = _v5.a;
                return -$elm$core$List$sum($elm$core$List$map_fn($elm$core$Tuple$second, d));
            }, reduced))));
            var known = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$Tuple$second, $elm_community$list_extra$List$Extra$find_fn(function (_v4) {
                var d = _v4.a;
                return $elm$core$List$isEmpty(d);
            }, reduced)));
            var reducedDict = $elm$core$Dict$fromList(reduced);
            var getCoeff = function (d) {
                return $author$project$Fraction$fromInt($elm$core$Maybe$withDefault_fn(0, $elm$core$Dict$get_fn(_List_fromArray([
                    _Utils_Tuple2(v, d)
                ]), reducedDict)));
            };
            var maximumDegree = $elm$core$Maybe$withDefault_fn(0, $elm$core$List$maximum($elm$core$List$map_fn(A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$Tuple$second), $elm$core$List$sum), $elm$core$Dict$keys(reducedDict))));
            var tryDivision = function (potential) {
                return function (_v3) {
                    var r = _v3.a;
                    var c = _v3.b;
                    return $author$project$Fraction$isZero(r) ? $elm$core$Maybe$Just(A2(rootAndRest, potential, c)) : $elm$core$Maybe$Nothing;
                }($elm$core$List$foldr_fn(F2(function (degree, _v2) {
                    var r = _v2.a;
                    var a = _v2.b;
                    var k = getCoeff(degree);
                    var r_ = $author$project$Fraction$plus_fn(k, $author$project$Fraction$by_fn(r, potential));
                    return _Utils_Tuple2(r_, _List_Cons(r, a));
                }), _Utils_Tuple2(getCoeff(maximumDegree), _List_Nil), $elm$core$List$range_fn(0, maximumDegree - 1)));
            };
            var allDivisors = function (n) {
                return $elm$core$List$map_fn($elm$core$List$product, $elm_community$list_extra$List$Extra$cartesianProduct($elm$core$List$map_fn(function (_v1) {
                    var f = _v1.a;
                    var m = _v1.b;
                    return $elm_community$list_extra$List$Extra$initialize_fn(m + 1, function (exp) {
                        return _Basics_pow_fn(f, exp);
                    });
                }, _List_Cons(_Utils_Tuple2(1, 0), $author$project$Expression$Utils$factor($elm$core$Basics$abs(n))))));
            };
            var potentialsD = allDivisors(head);
            var potentialsN = allDivisors(known);
            var potentials = _List_sortBy_fn($author$project$Fraction$toFloat, $elm_community$list_extra$List$Extra$uniqueBy_fn($author$project$Fraction$toPair, $elm$core$List$concatMap_fn(function (f) {
                return _List_fromArray([
                    f,
                    $author$project$Fraction$negate(f)
                ]);
            }, $elm$core$List$concatMap_fn(function (n) {
                return $elm$core$List$map_fn($author$project$Fraction$build(n), potentialsD);
            }, potentialsN))));
            var res = $elm$core$List$head($elm$core$List$filterMap_fn(tryDivision, potentials));
            return $elm$core$Result$fromMaybe_fn("no rational root found, and no simple formula is usable", res);
        };
        return $elm$core$Result$andThen_fn(findRoot, $elm$core$List$foldr_fn($elm_community$result_extra$Result$Extra$combine_a0, $elm_community$result_extra$Result$Extra$combine_a1, $elm$core$List$map_fn(function (_v0) {
            var d = _v0.a;
            var e = _v0.b;
            return $elm$core$Result$map_fn($elm$core$Tuple$pair(d), $author$project$Expression$Solver$asFraction(e));
        }, $elm$core$Dict$toList(coeffs))));
    }, $author$project$Expression$Solver$findRationalRoot = F2($author$project$Expression$Solver$findRationalRoot_fn);
    var $author$project$Expression$Solver$onLeaves_fn = function (f, tree) {
        switch (tree.$) {
            case 5:
                var cs = tree.a;
                return $author$project$Expression$SolutionBranch($elm$core$List$map_fn($author$project$Expression$Solver$onLeaves(f), cs));
            case 3:
                var e = tree.a;
                return f(e);
            case 4:
                var s = tree.a;
                var c = tree.b;
                return $author$project$Expression$SolutionStep_fn(s, $author$project$Expression$Solver$onLeaves_fn(f, c));
            default:
                return tree;
        }
    }, $author$project$Expression$Solver$onLeaves = F2($author$project$Expression$Solver$onLeaves_fn);
    var $author$project$Expression$SolutionForall = function (a) {
        return { $: 0, a: a };
    };
    var $author$project$Expression$SolutionNone = function (a) {
        return { $: 2, a: a };
    };
    var $author$project$Expression$Solver$solve0_fn = function (v, k) {
        return $author$project$Expression$Utils$isZero(k) ? $author$project$Expression$SolutionForall(v) : $author$project$Expression$SolutionNone(v);
    }, $author$project$Expression$Solver$solve0 = F2($author$project$Expression$Solver$solve0_fn);
    var $author$project$Expression$Solver$solIs_a0 = $author$project$Expression$RelationOperation(2), $author$project$Expression$Solver$solIs_a1 = $author$project$Expression$Variable, $author$project$Expression$Solver$solIs = A2($elm$core$Basics$composeL, $author$project$Expression$Solver$solIs_a0, $author$project$Expression$Solver$solIs_a1);
    var $author$project$Expression$SolutionDone = function (a) {
        return { $: 3, a: a };
    };
    var $author$project$Expression$Solver$stepSimplify = function () {
        var go = F2(function (i, e) {
            if (i <= 0) {
                return $author$project$Expression$SolutionDone(e);
            }
            else {
                var next = $author$project$Expression$Simplify$stepSimplify_fn($elm$core$Dict$empty, e);
                return $author$project$Expression$equals_fn(next, e) ? $author$project$Expression$SolutionDone(e) : $author$project$Expression$SolutionStep_fn(e, A2(go, i - 1, next));
            }
        });
        return go(50);
    }();
    var $author$project$Expression$Solver$solutionBranch_fn = function (v, sol) {
        return $author$project$Expression$Solver$stepSimplify(A2($author$project$Expression$Solver$solIs, v, sol));
    }, $author$project$Expression$Solver$solutionBranch = F2($author$project$Expression$Solver$solutionBranch_fn);
    var $author$project$Expression$Solver$solve1_fn = function (v, a, b) {
        return $author$project$Expression$Utils$isZero(a) ? $author$project$Expression$Solver$solve0_fn(v, b) : $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$divShort_fn($author$project$Expression$Utils$negateShort(b), a));
    }, $author$project$Expression$Solver$solve1 = F3($author$project$Expression$Solver$solve1_fn);
    var $author$project$Expression$Solver$solve2_fn = function (v, a, b, c) {
        if ($author$project$Expression$Utils$isZero(a)) {
            return $author$project$Expression$Solver$solve1_fn(v, b, c);
        }
        else {
            if ($author$project$Expression$Utils$isZero(b)) {
                var solPlus = $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$Utils$divShort_fn($author$project$Expression$Utils$negateShort(c), a));
                return $author$project$Expression$SolutionBranch(_List_fromArray([
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$negateShort(solPlus)),
                    $author$project$Expression$Solver$solutionBranch_fn(v, solPlus)
                ]));
            }
            else {
                var delta = $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$square(b), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(4),
                    a,
                    c
                ])));
                var solMinus = $author$project$Expression$Utils$divShort_fn($author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$negateShort(b), $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, delta)), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(2),
                    a
                ])));
                var solPlus = $author$project$Expression$Utils$divShort_fn($author$project$Expression$Utils$plusShort(_List_fromArray([
                    $author$project$Expression$Utils$negateShort(b),
                    $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, delta)
                ])), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(2),
                    a
                ])));
                return $author$project$Expression$SolutionBranch(_List_fromArray([
                    $author$project$Expression$Solver$solutionBranch_fn(v, solMinus),
                    $author$project$Expression$Solver$solutionBranch_fn(v, solPlus)
                ]));
            }
        }
    }, $author$project$Expression$Solver$solve2 = F4($author$project$Expression$Solver$solve2_fn);
    var $author$project$Expression$Solver$solve4Biquad_fn = function (v, a, c, e) {
        if ($author$project$Expression$Utils$isZero(a)) {
            return $author$project$Expression$Solver$solve2_fn(v, c, $author$project$Expression$Utils$zero, e);
        }
        else {
            if ($author$project$Expression$Utils$isZero(c)) {
                var solPlus = $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$pow_a0, $author$project$Expression$Utils$divShort_fn($author$project$Expression$Utils$negateShort(e), a), $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$one, $author$project$Expression$Integer(4)));
                return $author$project$Expression$SolutionBranch(_List_fromArray([
                    $author$project$Expression$Solver$solutionBranch_fn(v, solPlus),
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$negateShort(solPlus)),
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$byShort(_List_fromArray([$author$project$Expression$Utils$i, solPlus]))),
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$byShort(_List_fromArray([
                        $author$project$Expression$Utils$negateShort($author$project$Expression$Utils$i),
                        solPlus
                    ])))
                ]));
            }
            else {
                var delta = $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$square(c), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(4),
                    a,
                    e
                ])));
                var solMinus = $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$minus_fn($author$project$Expression$Utils$negateShort(c), $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, delta)), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(2),
                    a
                ]))));
                var solPlus = $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, $author$project$Expression$BinaryOperation_fn($author$project$Expression$Utils$div_a0, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$plus_a0, $author$project$Expression$Utils$plus_a1, _List_fromArray([
                    $author$project$Expression$Utils$negateShort(c),
                    $author$project$Expression$Utils$unaryFunc_fn($author$project$Expression$Utils$sqrt__a0, delta)
                ])), $author$project$Expression$Utils$byShort(_List_fromArray([
                    $author$project$Expression$Integer(2),
                    a
                ]))));
                return $author$project$Expression$SolutionBranch(_List_fromArray([
                    $author$project$Expression$Solver$solutionBranch_fn(v, solPlus),
                    $author$project$Expression$Solver$solutionBranch_fn(v, solMinus),
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$negateShort(solPlus)),
                    $author$project$Expression$Solver$solutionBranch_fn(v, $author$project$Expression$Utils$negateShort(solMinus))
                ]));
            }
        }
    }, $author$project$Expression$Solver$solve4Biquad = F4($author$project$Expression$Solver$solve4Biquad_fn);
    var $author$project$Expression$Solver$innerSolve_fn = function (v, expr) {
        if (expr.$ === 6) {
            if (expr.a === 2) {
                var _v20 = expr.a;
                var l = expr.b;
                var r = expr.c;
                return $author$project$Expression$SolutionStep_fn(expr, $author$project$Expression$Solver$solveEquation_fn(v, l, r));
            }
            else {
                return $author$project$Expression$SolutionError({ e0: "Cannot solve disequations [yet!]", fs: "Non \u00E8 [per ora!] possibile risolvere le disequazioni" });
            }
        }
        else {
            if ((expr.$ === 5) && (!expr.a)) {
                var _v22 = expr.a;
                var n = expr.b;
                return $author$project$Expression$Solver$onLeaves_fn($author$project$Expression$Solver$innerSolve(v), $author$project$Expression$Solver$stepSimplify($author$project$Expression$RelationOperation_fn(2, n, $author$project$Expression$Utils$zero)));
            }
            else {
                return $author$project$Expression$SolutionStep_fn($author$project$Expression$RelationOperation_fn(2, expr, $author$project$Expression$Utils$zero), $author$project$Expression$Solver$solveEquation_fn(v, expr, $author$project$Expression$Utils$zero));
            }
        }
    }, $author$project$Expression$Solver$innerSolve = F2($author$project$Expression$Solver$innerSolve_fn);
    var $author$project$Expression$Solver$solveEquation_fn = function (v, l, r) {
        var go = function (expr) {
            var _v1 = $elm$core$Maybe$map_fn($elm$core$Dict$map($elm$core$Basics$always($author$project$Expression$Simplify$simplify)), $author$project$Expression$Polynomial$asPolynomial_fn(_List_fromArray([v]), expr));
            if (_v1.$ === 1) {
                return $author$project$Expression$SolutionError({
                    e0: "Cannot solve " + $elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, expr),
                    fs: "Impossibile risolvere " + $elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, expr)
                });
            }
            else {
                var coeffs = _v1.a;
                var rebuilt = $author$project$Expression$Solver$coeffsToEq(coeffs);
                var cleanCoeffs = $elm_community$list_extra$List$Extra$filterNot_fn(A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Expression$Utils$isZero), $elm$core$List$reverse($elm$core$Dict$toList(coeffs)));
                var _default = function (_v18) {
                    var _v17 = $author$project$Expression$Solver$findRationalRoot_fn(v, $elm$core$Dict$fromList(cleanCoeffs));
                    if (!_v17.$) {
                        var root = _v17.a.dP;
                        var rest = _v17.a.dN;
                        return $author$project$Expression$SolutionBranch(_List_fromArray([
                            $author$project$Expression$Solver$innerSolve_fn(v, $author$project$Expression$RelationOperation_fn(2, $author$project$Expression$Variable(v), root)),
                            $author$project$Expression$Solver$innerSolve_fn(v, $author$project$Expression$RelationOperation_fn(2, rest, $author$project$Expression$Utils$zero))
                        ]));
                    }
                    else {
                        var e = _v17.a;
                        return $author$project$Expression$SolutionError({
                            e0: "Cannot solve " + ($elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, rebuilt) + (", " + e)),
                            fs: "Impossibile risolvere " + ($elm$core$Basics$composeR_fn($author$project$Expression$toString_a0, $author$project$Expression$toString_a1, rebuilt) + (", " + e))
                        });
                    }
                };
                var get = function (k) {
                    return $elm$core$Maybe$withDefault_fn($author$project$Expression$Utils$zero, $elm$core$Maybe$map_fn($elm$core$Tuple$second, $elm_community$list_extra$List$Extra$find_fn(function (_v16) {
                        var d = _v16.a;
                        return (!k) ? _Utils_eq(d, _List_Nil) : _Utils_eq(d, _List_fromArray([
                            _Utils_Tuple2(v, k)
                        ]));
                    }, cleanCoeffs)));
                };
                var last = function () {
                    var _v2 = $elm$core$List$head(cleanCoeffs);
                    _v2$6: while (true) {
                        if (_v2.$ === 1) {
                            return $author$project$Expression$Solver$solve0_fn(v, $author$project$Expression$Utils$zero);
                        }
                        else {
                            if (!_v2.a.a.b) {
                                var _v3 = _v2.a;
                                var k = _v3.b;
                                return $author$project$Expression$Solver$solve0_fn(v, k);
                            }
                            else {
                                if (!_v2.a.a.b.b) {
                                    switch (_v2.a.a.a.b) {
                                        case 1:
                                            var _v4 = _v2.a;
                                            var _v5 = _v4.a;
                                            var _v6 = _v5.a;
                                            var a = _v4.b;
                                            return $author$project$Expression$Solver$solve1_fn(v, a, get(0));
                                        case 2:
                                            var _v7 = _v2.a;
                                            var _v8 = _v7.a;
                                            var _v9 = _v8.a;
                                            var a = _v7.b;
                                            return $author$project$Expression$Solver$solve2_fn(v, a, get(1), get(0));
                                        case 3:
                                            var _v10 = _v2.a;
                                            var _v11 = _v10.a;
                                            var _v12 = _v11.a;
                                            return _default(0);
                                        case 4:
                                            var _v13 = _v2.a;
                                            var _v14 = _v13.a;
                                            var _v15 = _v14.a;
                                            var a = _v13.b;
                                            return ($author$project$Expression$Utils$isZero(get(1)) && $author$project$Expression$Utils$isZero(get(3))) ? $author$project$Expression$Solver$solve4Biquad_fn(v, a, get(2), get(0)) : _default(0);
                                        default:
                                            break _v2$6;
                                    }
                                }
                                else {
                                    break _v2$6;
                                }
                            }
                        }
                    }
                    return _default(0);
                }();
                return $author$project$Expression$SolutionStep_fn($author$project$Expression$RelationOperation_fn(2, expr, $author$project$Expression$Utils$zero), $author$project$Expression$SolutionStep_fn(rebuilt, last));
            }
        };
        var _v0 = _Utils_Tuple2(l, r);
        if ((!_v0.a.$) && (!_v0.a.a)) {
            return go(r);
        }
        else {
            if ((!_v0.b.$) && (!_v0.b.a)) {
                return go(l);
            }
            else {
                return go($author$project$Expression$Utils$minus_fn(l, r));
            }
        }
    }, $author$project$Expression$Solver$solveEquation = F3($author$project$Expression$Solver$solveEquation_fn);
    var $author$project$Expression$Solver$solve_fn = function (e, x) {
        if (x.$ === 2) {
            var v = x.a;
            var go = function (m) {
                return $author$project$Expression$Solver$onLeaves_fn(function (s) {
                    _v6$2: while (true) {
                        if ((s.$ === 6) && (s.a === 2)) {
                            if ((s.c.$ === 5) && (!s.c.a)) {
                                var _v7 = s.a;
                                var l = s.b;
                                var _v8 = s.c;
                                var _v9 = _v8.a;
                                var n = _v8.b;
                                var d = _v8.c;
                                return $author$project$Expression$Solver$onLeaves_fn($author$project$Expression$Solver$innerSolve(v), $author$project$Expression$Solver$stepSimplify($author$project$Expression$RelationOperation_fn(2, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([l, d])), n)));
                            }
                            else {
                                if ((s.b.$ === 5) && (!s.b.a)) {
                                    var _v10 = s.a;
                                    var _v11 = s.b;
                                    var _v12 = _v11.a;
                                    var n = _v11.b;
                                    var d = _v11.c;
                                    var r = s.c;
                                    return $author$project$Expression$Solver$onLeaves_fn($author$project$Expression$Solver$innerSolve(v), $author$project$Expression$Solver$stepSimplify($author$project$Expression$RelationOperation_fn(2, n, $author$project$Expression$Utils$associativeOperation_fn($author$project$Expression$Utils$by_a0, $author$project$Expression$Utils$by_a1, _List_fromArray([r, d])))));
                                }
                                else {
                                    break _v6$2;
                                }
                            }
                        }
                        else {
                            break _v6$2;
                        }
                    }
                    return $author$project$Expression$Solver$innerSolve_fn(v, s);
                }, $author$project$Expression$Solver$stepSimplify(m));
            };
            return $author$project$Expression$Solver$cut(function () {
                _v1$3: while (true) {
                    switch (e.$) {
                        case 7:
                            if (e.a === 1) {
                                var _v5 = e.a;
                                var ml = e.b;
                                var mm = e.c;
                                var mr = e.d;
                                return $author$project$Expression$SolutionStep_fn(e, $author$project$Expression$SolutionStep_fn($author$project$Expression$RelationOperation_fn(2, e, $author$project$Expression$Utils$zero), $author$project$Expression$SolutionBranch($elm$core$List$map_fn(function (mc) {
                                    return go($author$project$Expression$RelationOperation_fn(2, mc, $author$project$Expression$Utils$zero));
                                }, _List_Cons(ml, _List_Cons(mm, mr))))));
                            }
                            else {
                                break _v1$3;
                            }
                        case 6:
                            if (e.a === 2) {
                                var _v2 = e.a;
                                var l = e.b;
                                var r = e.c;
                                if ($author$project$Expression$Utils$isZero(l)) {
                                    return $author$project$Expression$Utils$isZero(r) ? go(e) : $author$project$Expression$SolutionStep_fn(e, go($author$project$Expression$RelationOperation_fn(2, r, l)));
                                }
                                else {
                                    if ($author$project$Expression$Utils$isZero(r)) {
                                        if ((l.$ === 7) && (l.a === 1)) {
                                            var _v4 = l.a;
                                            var ml = l.b;
                                            var mm = l.c;
                                            var mr = l.d;
                                            return $author$project$Expression$SolutionStep_fn(e, $author$project$Expression$SolutionBranch($elm$core$List$map_fn(function (mc) {
                                                return go($author$project$Expression$RelationOperation_fn(2, mc, $author$project$Expression$Utils$zero));
                                            }, _List_Cons(ml, _List_Cons(mm, mr)))));
                                        }
                                        else {
                                            return go(e);
                                        }
                                    }
                                    else {
                                        return go(e);
                                    }
                                }
                            }
                            else {
                                return go(e);
                            }
                        default:
                            break _v1$3;
                    }
                }
                return $author$project$Expression$SolutionStep_fn(e, go($author$project$Expression$RelationOperation_fn(2, e, $author$project$Expression$Utils$zero)));
            }());
        }
        else {
            return $author$project$Expression$SolutionError({ e0: "The second argument of `solve` must be the variable you want to solve for", fs: "Il secondo argomento di `solve` deve essere la variabile per cui risolvere l'equazione" });
        }
    }, $author$project$Expression$Solver$solve = F2($author$project$Expression$Solver$solve_fn);
    var $author$project$Complex$tanh = function (x) {
        return $author$project$Complex$negate($author$project$Complex$by_fn($author$project$Complex$i, $author$project$Complex$tan($author$project$Complex$by_fn($author$project$Complex$i, x))));
    };
    var $author$project$Expression$Value$unexpectedArgCount_fn = function (maybeName, count) {
        if (!maybeName.$) {
            var name = maybeName.a;
            return $author$project$Expression$Value$ErrorValue({
                e0: "Unexpected number of args to " + (name + (", expected " + $elm$core$String$join_fn(" or ", $elm$core$List$map_fn($elm$core$String$fromInt, count)))),
                fs: "Numero di argomenti inatteso per " + (name + (", " + ((_Utils_eq(count, _List_fromArray([1])) ? "atteso " : "attesi ") + $elm$core$String$join_fn(" o ", $elm$core$List$map_fn($elm$core$String$fromInt, count)))))
            });
        }
        else {
            return $author$project$Expression$Value$ErrorValue({
                e0: "Unexpected number of args, expected " + $elm$core$String$join_fn(" or ", $elm$core$List$map_fn($elm$core$String$fromInt, count)),
                fs: "Numero di argomenti inatteso, " + ((_Utils_eq(count, _List_fromArray([1])) ? "atteso " : "attesi ") + $elm$core$String$join_fn(" o ", $elm$core$List$map_fn($elm$core$String$fromInt, count)))
            });
        }
    }, $author$project$Expression$Value$unexpectedArgCount = F2($author$project$Expression$Value$unexpectedArgCount_fn);
    var $author$project$Expression$Value$applyValue_fn = function (context, name, args) {
        if (!name.$) {
            switch (name.a.$) {
                case 0:
                    var _v23 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Sin, $author$project$Complex$sin);
                case 1:
                    var _v24 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Cos, $author$project$Complex$cos);
                case 2:
                    var _v25 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Tan, $author$project$Complex$tan);
                case 7:
                    var _v26 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Sinh, $author$project$Complex$sinh);
                case 8:
                    var _v27 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Cosh, $author$project$Complex$cosh);
                case 9:
                    var _v28 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Tanh, $author$project$Complex$tanh);
                case 3:
                    var _v29 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Asin, $author$project$Complex$asin);
                case 4:
                    var _v30 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Acos, $author$project$Complex$acos);
                case 5:
                    var _v31 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Atan, $author$project$Complex$atan);
                case 26:
                    var _v32 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Floor, $author$project$Complex$floor);
                case 27:
                    var _v33 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Ceiling, $author$project$Complex$ceiling);
                case 25:
                    var _v34 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Round, $author$project$Complex$round);
                case 23:
                    var _v35 = name.a;
                    return $author$project$Expression$Value$arbitraryFunctionValue_fn(context, args, $author$project$Expression$Min, $author$project$Complex$min);
                case 24:
                    var _v36 = name.a;
                    return $author$project$Expression$Value$arbitraryFunctionValue_fn(context, args, $author$project$Expression$Max, $author$project$Complex$max);
                case 6:
                    var _v37 = name.a;
                    return $author$project$Expression$Value$binaryFunctionValue_fn(context, args, $author$project$Expression$Atan2, $author$project$Complex$atan2);
                case 11:
                    if (name.a.a === 2) {
                        return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Root(2), $author$project$Complex$sqrt);
                    }
                    else {
                        var n = name.a.a;
                        return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Root(n), function (v) {
                            return $author$project$Complex$power_fn(v, $author$project$Complex$fromReal(1 / n));
                        });
                    }
                case 12:
                    var _v38 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Ln, $author$project$Complex$ln);
                case 18:
                    var _v39 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Arg, A2($elm$core$Basics$composeL, $author$project$Complex$fromReal, $author$project$Complex$arg));
                case 16:
                    var _v40 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Re, $author$project$Complex$re);
                case 17:
                    var _v41 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Im, $author$project$Complex$im);
                case 10:
                    var _v42 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Abs, A2($elm$core$Basics$composeL, $author$project$Complex$fromReal, $author$project$Complex$abs));
                case 15:
                    var _v43 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Sign, $author$project$Complex$sign);
                case 13:
                    var _v44 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Log10, function (v) {
                        return $author$project$Complex$div_fn(v, $author$project$Complex$ln($author$project$Complex$fromReal(10)));
                    });
                case 35:
                    var _v45 = name.a;
                    return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
                case 20:
                    var _v46 = name.a;
                    if (args.b && (!args.b.b)) {
                        var c = args.a;
                        return $author$project$Expression$Value$determinant_fn(context, $author$project$Expression$Value$innerValue_fn(context, c));
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("det"), _List_fromArray([1]));
                    }
                case 14:
                    var _v48 = name.a;
                    return $author$project$Expression$Value$unaryFunctionValue_fn(context, args, $author$project$Expression$Exp, $author$project$Complex$exp);
                case 28:
                    var _v49 = name.a;
                    if (((args.b && args.b.b) && args.b.b.b) && (!args.b.b.b.b)) {
                        var c = args.a;
                        var _v51 = args.b;
                        var t = _v51.a;
                        var _v52 = _v51.b;
                        var f = _v52.a;
                        var _v53 = $author$project$Expression$Value$innerValue_fn(context, c);
                        switch (_v53.$) {
                            case 3:
                                var cv = _v53.a;
                                return $author$project$Expression$Value$innerValue_fn(context, _Utils_eq(cv, $author$project$Complex$zero) ? f : t);
                            case 0:
                                var e = _v53.a;
                                return $author$project$Expression$Value$ErrorValue(e);
                            case 2:
                                var s = _v53.a;
                                return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Pw), _List_fromArray([s, t, f])));
                            default:
                                return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn($author$project$Expression$KnownFunction($author$project$Expression$Pw), args));
                        }
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("pw"), _List_fromArray([3]));
                    }
                case 33:
                    var _v54 = name.a;
                    if ((args.b && args.b.b) && (!args.b.b.b)) {
                        var e = args.a;
                        var _v56 = args.b;
                        var x = _v56.a;
                        return $author$project$Expression$Value$SolutionTreeValue($author$project$Expression$Solver$solve_fn(e, x));
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("solve"), _List_fromArray([2]));
                    }
                case 31:
                    var _v57 = name.a;
                    if (args.b && (!args.b.b)) {
                        var e = args.a;
                        return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Simplify$simplify(e));
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("simplify"), _List_fromArray([1]));
                    }
                case 32:
                    var _v59 = name.a;
                    if (args.b && (!args.b.b)) {
                        var e = args.a;
                        return $author$project$Expression$Value$SolutionTreeValue($author$project$Expression$Solver$stepSimplify(e));
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("stepsimplify"), _List_fromArray([1]));
                    }
                case 29:
                    var _v61 = name.a;
                    if (args.b && (!args.b.b)) {
                        var e = args.a;
                        return $author$project$Expression$Value$GraphValue({
                            aP: true,
                            aw: $author$project$Expression$Graph$fromExpression($author$project$Expression$Value$toExpression(A2($author$project$Expression$Value$value, $elm$core$Dict$empty, e)))
                        });
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("plot"), _List_fromArray([1]));
                    }
                case 30:
                    var _v63 = name.a;
                    if (args.b && (!args.b.b)) {
                        var e = args.a;
                        return $author$project$Expression$Value$GraphValue({
                            aP: false,
                            aw: $author$project$Expression$Graph$fromExpression($author$project$Expression$Value$toExpression(A2($author$project$Expression$Value$value, $elm$core$Dict$empty, e)))
                        });
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("aplot"), _List_fromArray([1]));
                    }
                case 36:
                    var _v65 = name.a;
                    var _v66 = $author$project$Expression$Utils$runForLoop(args);
                    if (!_v66.$) {
                        var values = _v66.a;
                        return A2($author$project$Expression$Value$value, context, $author$project$Expression$List(values));
                    }
                    else {
                        return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Just("for"), _List_fromArray([2, 3]));
                    }
                case 19:
                    var _v67 = name.a;
                    return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
                case 21:
                    var _v68 = name.a;
                    return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
                case 22:
                    var _v69 = name.a;
                    return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
                default:
                    var _v70 = name.a;
                    return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
            }
        }
        else {
            return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Apply_fn(name, args));
        }
    }, $author$project$Expression$Value$applyValue = F3($author$project$Expression$Value$applyValue_fn);
    var $author$project$Expression$Value$arbitraryFunctionValue_fn = function (context, args, s, f) {
        if (args.b) {
            var h = args.a;
            var t = args.b;
            return $elm$core$List$foldr_fn(function (e) {
                return A2($author$project$Expression$Value$complexMap2, {
                    aa: f,
                    eU: context,
                    ad: $elm$core$Maybe$Nothing,
                    ae: $elm$core$Maybe$Nothing,
                    ah: F2(function (lv, rv) {
                        return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction(s), _List_fromArray([lv, rv]));
                    })
                }, $author$project$Expression$Value$innerValue_fn(context, e));
            }, $author$project$Expression$Value$innerValue_fn(context, h), t);
        }
        else {
            return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Nothing, _List_fromArray([1]));
        }
    }, $author$project$Expression$Value$arbitraryFunctionValue = F4($author$project$Expression$Value$arbitraryFunctionValue_fn);
    var $author$project$Expression$Value$binaryFunctionValue_fn = function (context, args, s, f) {
        if ((args.b && args.b.b) && (!args.b.b.b)) {
            var l = args.a;
            var _v20 = args.b;
            var r = _v20.a;
            return $author$project$Expression$Value$complexMap2_fn({
                aa: f,
                eU: context,
                ad: $elm$core$Maybe$Nothing,
                ae: $elm$core$Maybe$Nothing,
                ah: F2(function (lv, rv) {
                    return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction(s), _List_fromArray([lv, rv]));
                })
            }, $author$project$Expression$Value$innerValue_fn(context, l), $author$project$Expression$Value$innerValue_fn(context, r));
        }
        else {
            return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Nothing, _List_fromArray([2]));
        }
    }, $author$project$Expression$Value$binaryFunctionValue = F4($author$project$Expression$Value$binaryFunctionValue_fn);
    var $author$project$Expression$Value$by = function (context) {
        return A2($author$project$Expression$Value$assocToList, $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal(1)), $author$project$Expression$Value$byTwo(context));
    };
    var $author$project$Expression$Value$byTwo = function (context) {
        var inner = F2(function (u, v) {
            var _v18 = _Utils_Tuple2(u, v);
            if (_v18.a.$ === 1) {
                var f = _v18.a.a;
                return (!f) ? $author$project$Expression$Float(0) : ((f === 1) ? v : $author$project$Expression$AssociativeOperation_fn(1, u, v, _List_Nil));
            }
            else {
                if (_v18.b.$ === 1) {
                    var f = _v18.b.a;
                    return (!f) ? $author$project$Expression$Float(0) : ((f === 1) ? u : $author$project$Expression$AssociativeOperation_fn(1, u, v, _List_Nil));
                }
                else {
                    return $author$project$Expression$AssociativeOperation_fn(1, u, v, _List_Nil);
                }
            }
        });
        return $author$project$Expression$Value$complexMap2({
            aa: $author$project$Complex$by,
            eU: context,
            ad: $elm$core$Maybe$Just(_Utils_Tuple2(F3(function (x, f, r) {
                return $author$project$Expression$Value$partialSubstitute_fn(x, r, f);
            }), F3(function (l, x, f) {
                return $author$project$Expression$Value$LambdaValue_fn(x, A3($author$project$Expression$Value$byTwo, context, l, f));
            }))),
            ae: $elm$core$Maybe$Just($author$project$Expression$Value$matrixMultiplication(context)),
            ah: inner
        });
    };
    var $author$project$Expression$Value$complexMap2_fn = function (fs, v, w) {
        var symbolic = fs.ah;
        var complex = fs.aa;
        var list = fs.ae;
        var lambda = fs.ad;
        var context = fs.eU;
        var _v10 = _Utils_Tuple2(v, w);
        _v10$1: while (true) {
            _v10$2: while (true) {
                _v10$3: while (true) {
                    _v10$4: while (true) {
                        _v10$5: while (true) {
                            _v10$8: while (true) {
                                _v10$9: while (true) {
                                    _v10$12: while (true) {
                                        _v10$13: while (true) {
                                            switch (_v10.a.$) {
                                                case 0:
                                                    return v;
                                                case 1:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$2;
                                                        case 5:
                                                            break _v10$2;
                                                        case 2:
                                                            break _v10$2;
                                                        case 4:
                                                            break _v10$2;
                                                        default:
                                                            break _v10$2;
                                                    }
                                                case 5:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$3;
                                                        case 5:
                                                            break _v10$4;
                                                        case 2:
                                                            break _v10$4;
                                                        case 4:
                                                            break _v10$4;
                                                        default:
                                                            break _v10$4;
                                                    }
                                                case 2:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$3;
                                                        case 5:
                                                            break _v10$5;
                                                        case 2:
                                                            break _v10$8;
                                                        case 4:
                                                            break _v10$8;
                                                        default:
                                                            break _v10$8;
                                                    }
                                                case 6:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$3;
                                                        case 5:
                                                            break _v10$5;
                                                        case 6:
                                                            var ls = _v10.a.a;
                                                            var rs = _v10.b.a;
                                                            if (!list.$) {
                                                                var lf = list.a;
                                                                return A2(lf, ls, rs);
                                                            }
                                                            else {
                                                                return $author$project$Expression$Value$ListValue(_List_map2_fn($author$project$Expression$Value$complexMap2(fs), ls, rs));
                                                            }
                                                        case 2:
                                                            break _v10$9;
                                                        case 3:
                                                            var l = _v10.a.a;
                                                            return $author$project$Expression$Value$ListValue($elm$core$List$map_fn(function (le) {
                                                                return $author$project$Expression$Value$complexMap2_fn(fs, le, w);
                                                            }, l));
                                                        default:
                                                            break _v10$13;
                                                    }
                                                case 3:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$3;
                                                        case 5:
                                                            break _v10$5;
                                                        case 3:
                                                            var l = _v10.a.a;
                                                            var r = _v10.b.a;
                                                            return $author$project$Expression$Value$ComplexValue(A2(complex, l, r));
                                                        case 2:
                                                            break _v10$9;
                                                        case 6:
                                                            var r = _v10.b.a;
                                                            return $author$project$Expression$Value$ListValue($elm$core$List$map_fn(function (re) {
                                                                return $author$project$Expression$Value$complexMap2_fn(fs, v, re);
                                                            }, r));
                                                        default:
                                                            break _v10$13;
                                                    }
                                                default:
                                                    switch (_v10.b.$) {
                                                        case 0:
                                                            break _v10$1;
                                                        case 1:
                                                            break _v10$3;
                                                        case 5:
                                                            break _v10$5;
                                                        case 2:
                                                            break _v10$9;
                                                        case 4:
                                                            break _v10$12;
                                                        default:
                                                            break _v10$12;
                                                    }
                                            }
                                        }
                                        return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.aR, $author$project$Expression$Value$strings.aT])));
                                    }
                                    return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.aR, $author$project$Expression$Value$strings.aT])));
                                }
                                var r = _v10.b.a;
                                return $author$project$Expression$Value$SymbolicValue(A2(symbolic, $author$project$Expression$Value$toExpression(v), r));
                            }
                            var l = _v10.a.a;
                            return $author$project$Expression$Value$SymbolicValue(A2(symbolic, l, $author$project$Expression$Value$toExpression(w)));
                        }
                        var _v14 = _v10.b;
                        var x = _v14.a;
                        var f = _v14.b;
                        if (!lambda.$) {
                            var _v16 = lambda.a;
                            var r = _v16.b;
                            return A3(r, v, x, f);
                        }
                        else {
                            return $author$project$Expression$Value$LambdaValue_fn(x, $author$project$Expression$Value$innerValue_fn($elm$core$Dict$remove_fn(x, context), A2(symbolic, $author$project$Expression$Value$toExpression(v), $author$project$Expression$Value$toExpression(f))));
                        }
                    }
                    var _v11 = _v10.a;
                    var x = _v11.a;
                    var f = _v11.b;
                    if (!lambda.$) {
                        var _v13 = lambda.a;
                        var l = _v13.a;
                        return A3(l, x, f, w);
                    }
                    else {
                        return $author$project$Expression$Value$LambdaValue_fn(x, $author$project$Expression$Value$innerValue_fn($elm$core$Dict$remove_fn(x, context), A2(symbolic, $author$project$Expression$Value$toExpression(f), $author$project$Expression$Value$toExpression(w))));
                    }
                }
                return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.aR, $author$project$Expression$Value$strings.aZ])));
            }
            return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.aR, $author$project$Expression$Value$strings.aZ])));
        }
        return w;
    }, $author$project$Expression$Value$complexMap2 = F3($author$project$Expression$Value$complexMap2_fn);
    var $author$project$Expression$Value$determinant_fn = function (context, val) {
        switch (val.$) {
            case 6:
                var _v9 = $author$project$Expression$Value$asSquareMatrix(val);
                if (!_v9.$) {
                    var rows = _v9.a;
                    return $elm$core$Maybe$withDefault_fn($author$project$Expression$Value$ErrorValue({ e0: "Error in calculating the determinant", fs: "Errore nel calcolo del determinante" }), $author$project$Expression$genericDeterminant_fn({
                        cT: $author$project$Expression$Value$by(context),
                        fC: $author$project$Expression$Value$negateValue,
                        ci: $author$project$Expression$Value$plus(context)
                    }, rows));
                }
                else {
                    return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([
                        $author$project$Expression$Value$strings.a6,
                        { e0: "a nonquare matrix", fs: "una matrice non quadrata" }
                    ])));
                }
            case 2:
                var s = val.a;
                return $author$project$Expression$Value$SymbolicValue($author$project$Expression$Utils$determinant(s));
            case 4:
                return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.a6, $author$project$Expression$Value$strings.aT])));
            case 3:
                return val;
            case 0:
                return val;
            case 5:
                return val;
            default:
                return $author$project$Expression$Value$ErrorValue($elm$core$Basics$composeR_fn($author$project$UI$L10N$concat_a0, $author$project$UI$L10N$concat_a1, _List_fromArray([$author$project$Expression$Value$strings.a6, $author$project$Expression$Value$strings.aZ])));
        }
    }, $author$project$Expression$Value$determinant = F2($author$project$Expression$Value$determinant_fn);
    var $author$project$Expression$Value$innerValue_fn = function (context, expr) {
        switch (expr.$) {
            case 2:
                if (expr.a === "i") {
                    return $author$project$Expression$Value$ComplexValue($author$project$Complex$i);
                }
                else {
                    var v = expr.a;
                    return $elm$core$Maybe$withDefault_fn($author$project$Expression$Value$SymbolicValue(expr), $elm$core$Dict$get_fn(v, context));
                }
            case 4:
                var _v3 = expr.a;
                var e = expr.b;
                return $author$project$Expression$Value$complexMap_fn($author$project$Expression$Value$negateValue_a0, $author$project$Expression$Value$innerValue_fn(context, e));
            case 5:
                if (!expr.a) {
                    var _v4 = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return $author$project$Expression$Value$simpleComplexMap2_fn($author$project$Expression$BinaryOperation(0), $author$project$Complex$div, context, l, r);
                }
                else {
                    var _v5 = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    return $author$project$Expression$Value$simpleComplexMap2_fn($author$project$Expression$BinaryOperation(1), $author$project$Complex$power, context, l, r);
                }
            case 6:
                var o = expr.a;
                var l = expr.b;
                var r = expr.c;
                return $author$project$Expression$Value$simpleComplexMap2_fn($author$project$Expression$RelationOperation(o), $author$project$Expression$Value$relationValue(o), context, l, r);
            case 7:
                if (!expr.a) {
                    var _v6 = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var o = expr.d;
                    return A2($author$project$Expression$Value$plus, context, $elm$core$List$map_fn($author$project$Expression$Value$innerValue(context), _List_Cons(l, _List_Cons(r, o))));
                }
                else {
                    var _v7 = expr.a;
                    var l = expr.b;
                    var r = expr.c;
                    var o = expr.d;
                    return A2($author$project$Expression$Value$by, context, $elm$core$List$map_fn($author$project$Expression$Value$innerValue(context), _List_Cons(l, _List_Cons(r, o))));
                }
            case 8:
                var name = expr.a;
                var args = expr.b;
                return $author$project$Expression$Value$applyValue_fn(context, name, args);
            case 3:
                var x = expr.a;
                var f = expr.b;
                return $author$project$Expression$Value$LambdaValue_fn(x, $author$project$Expression$Value$innerValue_fn($elm$core$Dict$insert_fn(x, $author$project$Expression$Value$SymbolicValue($author$project$Expression$Variable(x)), context), f));
            case 0:
                var i = expr.a;
                return $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal(i));
            case 1:
                var f = expr.a;
                return $author$project$Expression$Value$ComplexValue($author$project$Complex$fromReal(f));
            case 10:
                var ls = expr.a;
                return $author$project$Expression$Value$ListValue($elm$core$List$map_fn($author$project$Expression$Value$innerValue(context), ls));
            default:
                var ctx = expr.a;
                var e = expr.b;
                return $author$project$Expression$Value$innerValue_fn(context, A2($author$project$Expression$fullSubstitute, $elm$core$Basics$composeR_fn($author$project$Expression$filterContext_a0, $author$project$Expression$filterContext_a1, ctx), e));
        }
    }, $author$project$Expression$Value$innerValue = F2($author$project$Expression$Value$innerValue_fn);
    var $author$project$Expression$Value$matrixMultiplication_fn = function (context, l, r) {
        return $elm$core$Maybe$withDefault_fn($author$project$Expression$Value$ErrorValue({ e0: "Cannot multiply the matrices", fs: "Impossibile moltiplicare let matrici" }), $author$project$Expression$genericMatrixMultiplication_fn({
            cO: $author$project$Expression$Value$asList,
            cT: $author$project$Expression$Value$by(context),
            ci: $author$project$Expression$Value$plus(context),
            d3: $author$project$Expression$Value$ListValue
        }, $author$project$Expression$Value$ListValue(l), $author$project$Expression$Value$ListValue(r)));
    }, $author$project$Expression$Value$matrixMultiplication = F3($author$project$Expression$Value$matrixMultiplication_fn);
    var $author$project$Expression$Value$plus = function (context) {
        return A2($author$project$Expression$Value$assocToList, $author$project$Expression$Value$ComplexValue($author$project$Complex$zero), $author$project$Expression$Value$plusTwo(context));
    };
    var $author$project$Expression$Value$plusTwo = function (context) {
        var inner = F2(function (u, v) {
            var _v1 = _Utils_Tuple2(u, v);
            if (_v1.a.$ === 1) {
                var f = _v1.a.a;
                return (!f) ? v : $author$project$Expression$AssociativeOperation_fn(0, u, v, _List_Nil);
            }
            else {
                if (_v1.b.$ === 1) {
                    var f = _v1.b.a;
                    return (!f) ? u : $author$project$Expression$AssociativeOperation_fn(0, u, v, _List_Nil);
                }
                else {
                    return $author$project$Expression$AssociativeOperation_fn(0, u, v, _List_Nil);
                }
            }
        });
        return $author$project$Expression$Value$complexMap2({ aa: $author$project$Complex$plus, eU: context, ad: $elm$core$Maybe$Nothing, ae: $elm$core$Maybe$Nothing, ah: inner });
    };
    var $author$project$Expression$Value$simpleComplexMap2_fn = function (symbolic, complex, context, l, r) {
        return $author$project$Expression$Value$complexMap2_fn({ aa: complex, eU: context, ad: $elm$core$Maybe$Nothing, ae: $elm$core$Maybe$Nothing, ah: symbolic }, $author$project$Expression$Value$innerValue_fn(context, l), $author$project$Expression$Value$innerValue_fn(context, r));
    }, $author$project$Expression$Value$simpleComplexMap2 = F5($author$project$Expression$Value$simpleComplexMap2_fn);
    var $author$project$Expression$Value$unaryFunctionValue_fn = function (context, args, s, f) {
        if (args.b && (!args.b.b)) {
            var e = args.a;
            return $author$project$Expression$Value$complexMap_fn({
                aa: f,
                ad: $elm$core$Maybe$Nothing,
                ae: $elm$core$Maybe$Nothing,
                ah: function (sv) {
                    return $author$project$Expression$Apply_fn($author$project$Expression$KnownFunction(s), _List_fromArray([sv]));
                }
            }, $author$project$Expression$Value$innerValue_fn(context, e));
        }
        else {
            return $author$project$Expression$Value$unexpectedArgCount_fn($elm$core$Maybe$Nothing, _List_fromArray([1]));
        }
    }, $author$project$Expression$Value$unaryFunctionValue = F4($author$project$Expression$Value$unaryFunctionValue_fn);
    var $author$project$Expression$Value$value = function (context) {
        return A2($elm$core$Basics$composeR, $author$project$Expression$Simplify$hoistLambda, $author$project$Expression$Value$innerValue($elm$core$Dict$union_fn(context, $author$project$Expression$Value$defaultValueContext)));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Font$color = function (fontColor) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attr($mdgriffith$elm_ui$Element$Font$color(fontColor));
    };
    var $mdgriffith$elm_ui$Element$Font$family = function (families) {
        return $mdgriffith$elm_ui$Internal$Model$StyleClass_fn($mdgriffith$elm_ui$Internal$Flag$fontFamily, $mdgriffith$elm_ui$Internal$Model$FontFamily_fn($elm$core$List$foldl_fn($mdgriffith$elm_ui$Internal$Model$renderFontClassName, "ff-", families), families));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Font$family = function (families) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$family(families));
    };
    var $mdgriffith$elm_ui$Internal$Model$Monospace = { $: 2 };
    var $mdgriffith$elm_ui$Element$Font$monospace = $mdgriffith$elm_ui$Internal$Model$Monospace;
    var $miniBill$elm_ui_with_context$Element$WithContext$Font$monospace = $mdgriffith$elm_ui$Element$Font$monospace;
    var $mdgriffith$elm_ui$Internal$Model$AsTextColumn = 5;
    var $mdgriffith$elm_ui$Internal$Model$asTextColumn = 5;
    var $mdgriffith$elm_ui$Internal$Model$Min_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $mdgriffith$elm_ui$Internal$Model$Min = F2($mdgriffith$elm_ui$Internal$Model$Min_fn);
    var $mdgriffith$elm_ui$Element$minimum_fn = function (i, l) {
        return $mdgriffith$elm_ui$Internal$Model$Min_fn(i, l);
    }, $mdgriffith$elm_ui$Element$minimum = F2($mdgriffith$elm_ui$Element$minimum_fn);
    var $mdgriffith$elm_ui$Element$textColumn_fn = function (attrs, children) {
        return $mdgriffith$elm_ui$Internal$Model$element_fn($mdgriffith$elm_ui$Internal$Model$asTextColumn, $mdgriffith$elm_ui$Internal$Model$div, _List_Cons($mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$maximum_fn(750, $mdgriffith$elm_ui$Element$minimum_fn(500, $mdgriffith$elm_ui$Element$fill))), attrs), $mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
    }, $mdgriffith$elm_ui$Element$textColumn = F2($mdgriffith$elm_ui$Element$textColumn_fn);
    var $miniBill$elm_ui_with_context$Element$WithContext$textColumn_a0 = $mdgriffith$elm_ui$Element$textColumn, $miniBill$elm_ui_with_context$Element$WithContext$textColumn = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($miniBill$elm_ui_with_context$Element$WithContext$textColumn_a0);
    var $author$project$UI$RowView$viewError = function (e) {
        var viewErrorLine = function (l) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$paragraph_a0, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Attributes$stringProperty_fn($elm$html$Html$Attributes$class_a0, "pre"))
            ]), _List_fromArray([
                $author$project$UI$L10N$text(l)
            ]));
        };
        var tuples = _List_map2_fn_unwrapped(function (en, it) {
            return { e0: en, fs: it };
        }, $elm$core$String$split_fn("\n", e.e0), $elm$core$String$split_fn("\n", e.fs));
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$textColumn_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$alignTop,
            $miniBill$elm_ui_with_context$Element$WithContext$Font$family(_List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$Font$monospace])),
            $miniBill$elm_ui_with_context$Element$WithContext$Font$color($author$project$UI$Theme$colors.e1),
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
        ]), $elm$core$List$map_fn(viewErrorLine, tuples));
    };
    var $author$project$Expression$asMatrixPrint_a0 = function (l) {
        if (l.$ === 11) {
            var u = l.a;
            return $elm$core$Maybe$Just(u);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $author$project$Expression$asMatrixPrint = $author$project$Expression$genericAsMatrix($author$project$Expression$asMatrixPrint_a0);
    var $author$project$Expression$toTeXStringPrec_fn = function (p, e) {
        var wrp = function (x) {
            return (p > 0) ? ("{" + (x + "}")) : x;
        };
        var paren = F2(function (b, c) {
            return b ? ("(" + (c + ")")) : c;
        });
        var noninfix = F2(function (op, c) {
            return A2(paren, p > 10, _Utils_ap(op, $author$project$Expression$toTeXStringPrec_fn(11, c)));
        });
        var infixl_ = F4(function (n, op, l, r) {
            return A2(paren, _Utils_cmp(p, n) > 0, _Utils_ap($author$project$Expression$toTeXStringPrec_fn(n, l), _Utils_ap(op, $author$project$Expression$toTeXStringPrec_fn(n + 1, r))));
        });
        return wrp(function () {
            _v0$8: while (true) {
                _v0$19: while (true) {
                    _v0$23: while (true) {
                        _v0$24: while (true) {
                            switch (e.$) {
                                case 2:
                                    var v = e.a;
                                    return $elm$core$Dict$member_fn(v, $author$project$Expression$greeks) ? ("\\" + v) : v;
                                case 1:
                                    var f = e.a;
                                    return $elm$core$String$fromFloat(f);
                                case 0:
                                    var v = e.a;
                                    return $elm$core$String$fromInt(v);
                                case 5:
                                    var expression = e.a;
                                    return A2(noninfix, "-", expression);
                                case 4:
                                    switch (e.b.$) {
                                        case 5:
                                            var l = e.a;
                                            var r = e.b.a;
                                            return A4(infixl_, 6, " - ", l, r);
                                        case 6:
                                            if (!e.b.a.$) {
                                                var l = e.a;
                                                var _v1 = e.b;
                                                var m = _v1.a.a;
                                                var r = _v1.b;
                                                return (m < 0) ? A4(infixl_, 6, " - ", l, $author$project$Expression$PBy_fn($author$project$Expression$PInteger(-m), r)) : A4(infixl_, 6, " + ", l, $author$project$Expression$PBy_fn($author$project$Expression$PInteger(m), r));
                                            }
                                            else {
                                                break _v0$8;
                                            }
                                        case 1:
                                            var l = e.a;
                                            var pf = e.b.a;
                                            return (pf < 0) ? A4(infixl_, 6, " - ", l, $author$project$Expression$PFloat(-pf)) : A4(infixl_, 6, " + ", l, $author$project$Expression$PFloat(pf));
                                        case 0:
                                            var l = e.a;
                                            var pi = e.b.a;
                                            return (pi < 0) ? A4(infixl_, 6, " - ", l, $author$project$Expression$PInteger(-pi)) : A4(infixl_, 6, " + ", l, $author$project$Expression$PInteger(pi));
                                        default:
                                            break _v0$8;
                                    }
                                case 8:
                                    var rel = e.a;
                                    var l = e.b;
                                    var r = e.c;
                                    return A4(infixl_, 5, " " + (rel + " "), l, r);
                                case 3:
                                    if ((((e.b.$ === 12) && e.b.b.b) && (e.b.b.a.$ === 2)) && (!e.b.b.b.b)) {
                                        var x = e.a;
                                        var f = e.b;
                                        var fn = f.a;
                                        var _v2 = f.b;
                                        var v = _v2.a.a;
                                        return _Utils_eq(v, x) ? $author$project$Expression$functionNameToString(fn) : A2(paren, p > 0, x + (" \\RightArrow " + $author$project$Expression$toTeXStringPrec_fn(0, f)));
                                    }
                                    else {
                                        var x = e.a;
                                        var f = e.b;
                                        return A2(paren, p > 0, x + (" \\RightArrow " + $author$project$Expression$toTeXStringPrec_fn(0, f)));
                                    }
                                case 6:
                                    if (!e.a.$) {
                                        var l = e.a;
                                        var r = e.b;
                                        switch (r.$) {
                                            case 9:
                                                return A4(infixl_, 7, "", l, r);
                                            case 2:
                                                return A4(infixl_, 7, "", l, r);
                                            case 12:
                                                if ((!r.a.$) && (r.a.a.$ === 10)) {
                                                    var _v4 = r.a.a;
                                                    return A4(infixl_, 7, "\\cdot", l, r);
                                                }
                                                else {
                                                    return A4(infixl_, 7, "", l, r);
                                                }
                                            default:
                                                return A4(infixl_, 7, "\\cdot", l, r);
                                        }
                                    }
                                    else {
                                        var l = e.a;
                                        var r = e.b;
                                        return A4(infixl_, 7, "\\cdot", l, r);
                                    }
                                case 7:
                                    var l = e.a;
                                    var r = e.b;
                                    return A2(paren, p > 7, "\\frac" + ($author$project$Expression$toTeXStringPrec_fn(7, l) + $author$project$Expression$toTeXStringPrec_fn(8, r)));
                                case 9:
                                    switch (e.b.$) {
                                        case 7:
                                            if ((!e.b.a.$) && (e.b.a.a === 1)) {
                                                if ((!e.b.b.$) && (e.b.b.a === 2)) {
                                                    var l = e.a;
                                                    var _v5 = e.b;
                                                    return A2(paren, p > 8, "\\sqrt{" + ($author$project$Expression$toTeXStringPrec_fn(0, l) + "}"));
                                                }
                                                else {
                                                    var l = e.a;
                                                    var _v6 = e.b;
                                                    var s = _v6.b;
                                                    return A2(paren, p > 8, "\\sqrt[" + ($author$project$Expression$toTeXStringPrec_fn(0, s) + ("]{" + ($author$project$Expression$toTeXStringPrec_fn(0, l) + "}"))));
                                                }
                                            }
                                            else {
                                                break _v0$19;
                                            }
                                        case 1:
                                            if (e.a.$ === 12) {
                                                var _v7 = e.a;
                                                var name = _v7.a;
                                                var args = _v7.b;
                                                var i = e.b.a;
                                                return A2(paren, p > 10, "\\mathrm{" + ($author$project$Expression$functionNameToString(name) + ("}^{" + ($elm$core$String$fromFloat(i) + ("}\\left(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toTeXStringPrec(0), args)) + "\\right)"))))));
                                            }
                                            else {
                                                break _v0$19;
                                            }
                                        case 0:
                                            if (e.a.$ === 12) {
                                                var _v8 = e.a;
                                                var name = _v8.a;
                                                var args = _v8.b;
                                                var i = e.b.a;
                                                return A2(paren, p > 10, "\\mathrm{" + ($author$project$Expression$functionNameToString(name) + ("}^{" + ($elm$core$String$fromInt(i) + ("}\\left(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toTeXStringPrec(0), args)) + "\\right)"))))));
                                            }
                                            else {
                                                break _v0$19;
                                            }
                                        default:
                                            break _v0$19;
                                    }
                                case 12:
                                    if (e.b.b && (!e.b.b.b)) {
                                        if (!e.a.$) {
                                            switch (e.a.a.$) {
                                                case 10:
                                                    var _v9 = e.a.a;
                                                    var _v10 = e.b;
                                                    var ex = _v10.a;
                                                    return A2(paren, p > 10, "\\left|" + ($author$project$Expression$toTeXStringPrec_fn(0, ex) + "\\right|"));
                                                case 11:
                                                    if (e.a.a.a === 2) {
                                                        var _v11 = e.b;
                                                        var ex = _v11.a;
                                                        return A2(paren, p > 10, "\\sqrt{" + ($author$project$Expression$toTeXStringPrec_fn(0, ex) + "}"));
                                                    }
                                                    else {
                                                        var n = e.a.a.a;
                                                        var _v12 = e.b;
                                                        var ex = _v12.a;
                                                        return A2(paren, p > 10, "\\sqrt[" + ($elm$core$String$fromInt(n) + ("]{" + ($author$project$Expression$toTeXStringPrec_fn(0, ex) + "}"))));
                                                    }
                                                default:
                                                    if (e.b.a.$ === 11) {
                                                        break _v0$23;
                                                    }
                                                    else {
                                                        break _v0$24;
                                                    }
                                            }
                                        }
                                        else {
                                            if (e.b.a.$ === 11) {
                                                break _v0$23;
                                            }
                                            else {
                                                break _v0$24;
                                            }
                                        }
                                    }
                                    else {
                                        break _v0$24;
                                    }
                                case 11:
                                    var es = e.a;
                                    var _v14 = $author$project$Expression$genericAsMatrix_fn($author$project$Expression$asMatrixPrint_a0, e);
                                    if (!_v14.$) {
                                        var childLists = _v14.a;
                                        var viewRow = A2($elm$core$Basics$composeL, $elm$core$String$join(" & "), $elm$core$List$map(function (cell) {
                                            return "{" + ($author$project$Expression$toTeXStringPrec_fn(0, cell) + "}");
                                        }));
                                        return "\\begin{pmatrix}" + ($elm$core$String$join_fn(" \\\\ ", $elm$core$List$map_fn(viewRow, childLists)) + "\\end{pmatrix}");
                                    }
                                    else {
                                        return "\\begin{Bmatrix}" + ($elm$core$String$join_fn(", & ", $elm$core$List$map_fn(function (cell) {
                                            return "{" + ($author$project$Expression$toTeXStringPrec_fn(0, cell) + "}");
                                        }, es)) + " \\end{Bmatrix}");
                                    }
                                default:
                                    var _var = e.a;
                                    var expr = e.b;
                                    return "\\begin{bmatrix}" + ($elm$core$String$join_fn(" \\\\ ", $elm$core$List$map_fn(function (_v15) {
                                        var k = _v15.a;
                                        var mv = _v15.b;
                                        if (mv.$ === 1) {
                                            return "!" + k;
                                        }
                                        else {
                                            var v = mv.a;
                                            var r = $author$project$Expression$toTeXStringPrec_fn(0, v);
                                            return $elm$core$String$join_fn(_String_contains_fn(" ", r) ? " " : "", _List_fromArray([k, "=", r]));
                                        }
                                    }, $elm$core$Dict$toList(_var))) + ("\\end{bmatrix} " + $author$project$Expression$toTeXStringPrec_fn(0, expr)));
                            }
                        }
                        var name = e.a;
                        var ex = e.b;
                        return A2(paren, p > 10, "\\mathrm{" + ($author$project$Expression$functionNameToString(name) + ("}\\left(" + ($elm$core$String$join_fn(", ", $elm$core$List$map_fn($author$project$Expression$toTeXStringPrec(0), ex)) + "\\right)"))));
                    }
                    var name = e.a;
                    var _v13 = e.b;
                    var ex = _v13.a;
                    return A2(paren, p > 10, "\\mathrm{" + ($author$project$Expression$functionNameToString(name) + ("}" + $author$project$Expression$toTeXStringPrec_fn(0, ex))));
                }
                var l = e.a;
                var r = e.b;
                return A2(paren, p > 8, $author$project$Expression$toTeXStringPrec_fn(9, l) + ("^{" + ($author$project$Expression$toTeXStringPrec_fn(0, r) + "}")));
            }
            var l = e.a;
            var r = e.b;
            return A4(infixl_, 6, " + ", l, r);
        }());
    }, $author$project$Expression$toTeXStringPrec = F2($author$project$Expression$toTeXStringPrec_fn);
    var $author$project$Expression$toTeXString_a0 = $author$project$Expression$toPrintExpression, $author$project$Expression$toTeXString_a1 = $author$project$Expression$toTeXStringPrec(0), $author$project$Expression$toTeXString = A2($elm$core$Basics$composeR, $author$project$Expression$toTeXString_a0, $author$project$Expression$toTeXString_a1);
    var $author$project$UI$RowView$viewLaTeX_fn = function (pageWidth, tex) {
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$shrink),
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$shrink)
        ]), $miniBill$elm_ui_with_context$Element$WithContext$html(A3($elm$html$Html$node, "ka-tex", _List_fromArray([
            $elm$virtual_dom$VirtualDom$attribute_fn("tex-src", tex),
            $elm$virtual_dom$VirtualDom$attribute_fn("container-width", $elm$core$String$fromInt(pageWidth - (2 * $author$project$UI$Theme$spacing)))
        ]), _List_Nil)));
    }, $author$project$UI$RowView$viewLaTeX = F2($author$project$UI$RowView$viewLaTeX_fn);
    var $author$project$UI$RowView$viewExpression_fn = function (pageWidth, expr) {
        return $author$project$UI$RowView$viewLaTeX_fn(pageWidth, $elm$core$Basics$composeR_fn($author$project$Expression$toTeXString_a0, $author$project$Expression$toTeXString_a1, expr));
    }, $author$project$UI$RowView$viewExpression = F2($author$project$UI$RowView$viewExpression_fn);
    var $author$project$UI$RowView$viewSolutionTree_fn = function (pageWidth, tree) {
        switch (tree.$) {
            case 4:
                var e = tree.a;
                var c = tree.b;
                return _List_Cons($author$project$UI$RowView$viewLaTeX_fn(pageWidth, $elm$core$Basics$composeR_fn($author$project$Expression$toTeXString_a0, $author$project$Expression$toTeXString_a1, e)), $author$project$UI$RowView$viewSolutionTree_fn(pageWidth, c));
            case 0:
                var v = tree.a;
                return _List_fromArray([
                    $author$project$UI$RowView$viewLaTeX_fn(pageWidth, "\\forall " + (v + " \\in \\mathbb{R}"))
                ]);
            case 1:
                var e = tree.a;
                return _List_fromArray([
                    $author$project$UI$L10N$text({ e0: "Error: " + e.e0, fs: "Errore: " + e.fs })
                ]);
            case 2:
                var v = tree.a;
                return _List_fromArray([
                    $author$project$UI$RowView$viewLaTeX_fn(pageWidth, "\\not \\exists " + (v + " \\in \\mathbb{R}"))
                ]);
            case 3:
                var e = tree.a;
                return _List_fromArray([
                    $author$project$UI$RowView$viewLaTeX_fn(pageWidth, $elm$core$Basics$composeR_fn($author$project$Expression$toTeXString_a0, $author$project$Expression$toTeXString_a1, e))
                ]);
            default:
                var children = tree.a;
                var br = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$px(1)),
                    $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
                    $miniBill$elm_ui_with_context$Element$WithContext$Border$width(1)
                ]), $miniBill$elm_ui_with_context$Element$WithContext$none);
                return _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing)
                    ]), $elm$core$List$intersperse_fn(br, $elm$core$List$map_fn(function (c) {
                        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
                            $miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing),
                            $miniBill$elm_ui_with_context$Element$WithContext$alignTop
                        ]), $author$project$UI$RowView$viewSolutionTree_fn(pageWidth, c));
                    }, children)))
                ]);
        }
    }, $author$project$UI$RowView$viewSolutionTree = F2($author$project$UI$RowView$viewSolutionTree_fn);
    var $author$project$UI$RowView$outputBlock_fn = function (blockId, size, output) {
        var width = size.bE;
        var asExpression = function (v) {
            switch (v.$) {
                case 2:
                    var s = v.a;
                    return $elm$core$Maybe$Just(s);
                case 3:
                    var c = v.a;
                    return $elm$core$Maybe$Just($author$project$Expression$Value$complexToSymbolic(c));
                case 6:
                    var ls = v.a;
                    return $elm$core$Maybe$map_fn($author$project$Expression$List, $elm$core$List$foldr_fn($elm$core$Maybe$map2($elm$core$List$cons), $elm$core$Maybe$Just(_List_Nil), $elm$core$List$map_fn(asExpression, ls)));
                case 0:
                    return $elm$core$Maybe$Nothing;
                case 4:
                    return $elm$core$Maybe$Nothing;
                case 1:
                    return $elm$core$Maybe$Nothing;
                default:
                    var x = v.a;
                    var f = v.b;
                    return $elm$core$Maybe$map_fn($author$project$Expression$Lambda(x), asExpression(f));
            }
        };
        var viewValue = F3(function (id, coeffs, v) {
            var _v1 = asExpression(v);
            if (!_v1.$) {
                var ex = _v1.a;
                return _Utils_Tuple2($author$project$UI$RowView$viewExpression_fn(width, ex), false);
            }
            else {
                switch (v.$) {
                    case 2:
                        var s = v.a;
                        return _Utils_Tuple2($author$project$UI$RowView$viewExpression_fn(width, s), false);
                    case 1:
                        var t = v.a;
                        return _Utils_Tuple2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
                            $miniBill$elm_ui_with_context$Element$WithContext$spacing($author$project$UI$Theme$spacing),
                            $miniBill$elm_ui_with_context$Element$WithContext$scrollbarX,
                            $miniBill$elm_ui_with_context$Element$WithContext$width($mdgriffith$elm_ui$Element$maximum_fn(width - (2 * $author$project$UI$Theme$spacing), $miniBill$elm_ui_with_context$Element$WithContext$fill))
                        ]), $author$project$UI$RowView$viewSolutionTree_fn(width - (2 * $author$project$UI$Theme$spacing), t)), false);
                    case 4:
                        var g = v.a;
                        return _Utils_Tuple2($author$project$UI$RowView$draw_fn(size, id, coeffs, g), true);
                    case 3:
                        var c = v.a;
                        return _Utils_Tuple2($author$project$UI$L10N$text($author$project$UI$L10N$invariant($author$project$Complex$toString(c))), false);
                    case 0:
                        var err = v.a;
                        return _Utils_Tuple2($author$project$UI$RowView$viewError(err), false);
                    case 5:
                        var x = v.a;
                        var f = v.b;
                        var _v3 = asExpression(f);
                        if (!_v3.$) {
                            var e = _v3.a;
                            return _Utils_Tuple2($author$project$UI$RowView$viewExpression_fn(width, $author$project$Expression$Lambda_fn(x, e)), false);
                        }
                        else {
                            return _Utils_Tuple2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$row_a0, _List_Nil, _List_fromArray([
                                $author$project$UI$L10N$text($author$project$UI$L10N$invariant(x + " => ")),
                                A3(viewValue, id, coeffs, f).a
                            ])), false);
                        }
                    default:
                        var ls = v.a;
                        var valueAsList = function (w) {
                            if (w.$ === 6) {
                                var us = w.a;
                                return $elm$core$Maybe$Just(us);
                            }
                            else {
                                return $elm$core$Maybe$Nothing;
                            }
                        };
                        var unpack = A2($elm$core$Basics$composeR, $elm$core$List$unzip, function (_v5) {
                            var es = _v5.a;
                            var gs = _v5.b;
                            return _Utils_Tuple2(es, $elm$core$List$any_fn($elm$core$Basics$identity, gs));
                        });
                        var _v4 = $author$project$Expression$genericAsMatrix_fn(valueAsList, v);
                        if (!_v4.$) {
                            var m = _v4.a;
                            return $elm$core$Tuple$mapFirst_fn($author$project$UI$RowView$roundBracketed, unpack($elm$core$List$indexedMap_fn(function (y) {
                                return A2($elm$core$Basics$composeR, $elm$core$List$indexedMap(function (x) {
                                    return A2(viewValue, id + ("_" + ($elm$core$String$fromInt(y) + ("_" + $elm$core$String$fromInt(x)))), {
                                        bi: coeffs.bi * $elm$core$List$length(m),
                                        aL: coeffs.aL * $elm$core$Maybe$withDefault_fn(1, $elm$core$Maybe$map_fn($elm$core$List$length, $elm$core$List$head(m)))
                                    });
                                }), unpack);
                            }, m)));
                        }
                        else {
                            return $elm$core$Tuple$mapFirst_fn(function (e) {
                                return $author$project$UI$RowView$simplyBracketed_fn($author$project$UI$RowView$roundBracketed_a0, $author$project$UI$RowView$roundBracketed_a1, $author$project$UI$RowView$roundBracketed_a2, $author$project$UI$RowView$roundBracketed_a3, _List_fromArray([e]));
                            }, unpack($elm$core$List$indexedMap_fn(function (i) {
                                return A2(viewValue, id + ("_" + $elm$core$String$fromInt(i)), _Utils_update(coeffs, {
                                    aL: coeffs.aL * $elm$core$List$length(ls)
                                }));
                            }, ls)));
                        }
                }
            }
        });
        var showExpr = function (e) {
            return $elm$core$Tuple$mapFirst_fn(function (vv) {
                return vv;
            }, A3(viewValue, blockId, { bi: 1, aL: 1 }, A2($author$project$Expression$Value$value, $elm$core$Dict$empty, e)));
        };
        if (!output.$) {
            return $miniBill$elm_ui_with_context$Element$WithContext$none;
        }
        else {
            var e = output.a;
            var _v8 = showExpr(e);
            var child = _v8.a;
            var isPlot = _v8.b;
            return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                isPlot ? $miniBill$elm_ui_with_context$Element$WithContext$centerX : $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
            ]), child);
        }
    }, $author$project$UI$RowView$outputBlock = F3($author$project$UI$RowView$outputBlock_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = { $: 0 };
    var $elm$parser$Parser$Expecting = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = { $: 7 };
    var $dillonkearns$elm_markdown$Markdown$Block$Heading_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$Heading = F2($dillonkearns$elm_markdown$Markdown$Block$Heading_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn = function (a, b) {
        return { $: 3, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Image_fn = function (a, b, c) {
        return { $: 2, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$Image = F3($dillonkearns$elm_markdown$Markdown$Block$Image_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
    var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Link_fn = function (a, b, c) {
        return { $: 1, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Block$Link = F3($dillonkearns$elm_markdown$Markdown$Block$Link_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2($dillonkearns$elm_markdown$Markdown$Block$ListItem_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn = function (a, b) {
        return { $: 2, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F2($dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
        return { $: 1, a: a };
    };
    var $elm$parser$Parser$Problem = function (a) {
        return { $: 12, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$Table_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Block$Table = F2($dillonkearns$elm_markdown$Markdown$Block$Table_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = { $: 8 };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = { $: 7 };
    var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$Parser$addReference_fn = function (state, linkRef) {
        return {
            az: _List_Cons(linkRef, state.az),
            ag: state.ag
        };
    }, $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2($dillonkearns$elm_markdown$Markdown$Parser$addReference_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = { $: 10 };
    var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
        switch (_char) {
            case " ":
                return true;
            case "\t":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = $elm$parser$Parser$Advanced$Token_fn("\r", $elm$parser$Parser$Expecting("a carriage return"));
    var $dillonkearns$elm_markdown$Parser$Token$newline = $elm$parser$Parser$Advanced$Token_fn("\n", $elm$parser$Parser$Expecting("a newline"));
    var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
            $elm$parser$Parser$Advanced$succeed(0)
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = $elm$parser$Parser$Advanced$map_fn(function (_v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $dillonkearns$elm_markdown$Whitespace$lineEnd));
    var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
        return { $: 11, a: a };
    };
    var $dillonkearns$elm_markdown$Parser$Token$space = $elm$parser$Parser$Advanced$Token_fn(" ", $elm$parser$Parser$Expecting("a space"));
    var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray([
        $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(">"))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(" >"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(" >", $elm$parser$Parser$Expecting("  >"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("  >", $elm$parser$Parser$Expecting("   >")))
        ])))
    ]);
    var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
        switch (_char) {
            case "\n":
                return true;
            case "\r":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
    var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("the end of the input"));
    var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
    var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote), $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
        return { $: 8, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Table$Table_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Table$Table = F2($dillonkearns$elm_markdown$Markdown$Table$Table_fn);
    var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn = function (joinWith, string1, string2) {
        var _v0 = _Utils_Tuple2(string1, string2);
        if (_v0.a === "") {
            return string2;
        }
        else {
            if (_v0.b === "") {
                return string1;
            }
            else {
                return _Utils_ap(string1, _Utils_ap(joinWith, string2));
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn = function (string1, string2) {
        return string1 + ("\n" + string2);
    }, $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn);
    var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$Expecting(str)));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
        var curr = _v0.a;
        var acc = _v0.b;
        var _return = $elm$core$Maybe$withDefault_fn($elm$parser$Parser$Advanced$Done(acc), $elm$core$Maybe$map_fn(function (cell) {
            return $elm$parser$Parser$Advanced$Done(_List_Cons(cell, acc));
        }, curr));
        var finishCell = $elm$core$Maybe$withDefault_fn($elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Nothing, acc)), $elm$core$Maybe$map_fn(function (cell) {
            return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Cons(cell, acc)));
        }, curr));
        var addToCurrent = function (c) {
            return _Utils_ap($elm$core$Maybe$withDefault_fn("", curr), c);
        };
        var continueCell = function (c) {
            return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2($elm$core$Maybe$Just(addToCurrent(c)), acc));
        };
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                return _return;
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("|\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return _return;
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v3) {
                return _return;
            }, $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end"))),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("|"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\\\|")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("\\"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\\\")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(continueCell("|"))), $dillonkearns$elm_markdown$Parser$Token$parseString("\\|")),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$succeed(finishCell)), $dillonkearns$elm_markdown$Parser$Token$parseString("|")),
            $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (_char, _v4) {
                return continueCell(_char);
            }, $elm$parser$Parser$Advanced$chompIf_fn($elm$core$Basics$always(true), $elm$parser$Parser$Problem("No character found")))
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = $elm$parser$Parser$Advanced$map_fn(A2($elm$core$List$foldl, F2(function (cell, acc) {
        return _List_Cons($elm$core$String$trim(cell), acc);
    }), _List_Nil), $elm$parser$Parser$Advanced$loop_fn(_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil), $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
    var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Parser$Token$parseString("|"),
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
    var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn = function (_v0, headersRow) {
        var columnAlignments = _v0.b;
        var headersWithAlignment = function (headers) {
            return _List_map2_fn_unwrapped(function (headerCell, alignment) {
                return { a3: alignment, R: headerCell };
            }, headers, columnAlignments);
        };
        var combineHeaderAndDelimiter = function (headers) {
            return _Utils_eq($elm$core$List$length(headers), $elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(headersWithAlignment(headers)) : $elm$core$Result$Err("Tables must have the same number of header columns (" + ($elm$core$String$fromInt($elm$core$List$length(headers)) + (") as delimiter columns (" + ($elm$core$String$fromInt($elm$core$List$length(columnAlignments)) + ")"))));
        };
        var _v1 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
        if (!_v1.$) {
            var headers = _v1.a;
            return combineHeaderAndDelimiter(headers);
        }
        else {
            return $elm$core$Result$Err("Unable to parse previous line as a table header");
        }
    }, $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2($dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn = function (state, newRawBlock) {
        return {
            az: state.az,
            ag: function () {
                var _v0 = _Utils_Tuple2(newRawBlock, state.ag);
                _v0$9: while (true) {
                    if (_v0.b.b) {
                        switch (_v0.b.a.$) {
                            case 5:
                                if (_v0.a.$ === 5) {
                                    var block1 = _v0.a.a;
                                    var _v1 = _v0.b;
                                    var block2 = _v1.a.a;
                                    var rest = _v1.b;
                                    return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock({
                                        bM: $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(block2.bM, block1.bM),
                                        dp: $elm$core$Maybe$Nothing
                                    }), rest);
                                }
                                else {
                                    break _v0$9;
                                }
                            case 6:
                                if (_v0.a.$ === 6) {
                                    var block1 = _v0.a.a;
                                    var _v2 = _v0.b;
                                    var block2 = _v2.a.a;
                                    var rest = _v2.b;
                                    return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(block2, block1)), rest);
                                }
                                else {
                                    break _v0$9;
                                }
                            case 11:
                                switch (_v0.a.$) {
                                    case 1:
                                        var body1 = _v0.a.a;
                                        var _v3 = _v0.b;
                                        var body2 = _v3.a.a;
                                        var rest = _v3.b;
                                        return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", body2, body1)), rest);
                                    case 11:
                                        var body1 = _v0.a.a;
                                        var _v4 = _v0.b;
                                        var body2 = _v4.a.a;
                                        var rest = _v4.b;
                                        return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll_fn(body2, body1)), rest);
                                    default:
                                        break _v0$9;
                                }
                            case 1:
                                switch (_v0.a.$) {
                                    case 1:
                                        var body1 = _v0.a.a;
                                        var _v5 = _v0.b;
                                        var body2 = _v5.a.a;
                                        var rest = _v5.b;
                                        return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", body2, body1)), rest);
                                    case 12:
                                        if (!_v0.a.a) {
                                            var _v6 = _v0.a;
                                            var _v7 = _v6.a;
                                            var _v8 = _v0.b;
                                            var unparsedInlines = _v8.a.a;
                                            var rest = _v8.b;
                                            return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn(1, unparsedInlines), rest);
                                        }
                                        else {
                                            var _v9 = _v0.a;
                                            var _v10 = _v9.a;
                                            var _v11 = _v0.b;
                                            var unparsedInlines = _v11.a.a;
                                            var rest = _v11.b;
                                            return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Heading_fn(2, unparsedInlines), rest);
                                        }
                                    case 9:
                                        var _v12 = _v0.a.a;
                                        var text = _v12.a;
                                        var alignments = _v12.b;
                                        var _v13 = _v0.b;
                                        var rawHeaders = _v13.a.a;
                                        var rest = _v13.b;
                                        var _v14 = $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader_fn($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn(text, alignments), rawHeaders);
                                        if (!_v14.$) {
                                            var headers = _v14.a;
                                            return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Table($dillonkearns$elm_markdown$Markdown$Table$Table_fn(headers, _List_Nil)), rest);
                                        }
                                        else {
                                            return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith_fn("\n", rawHeaders, text.dJ)), rest);
                                        }
                                    default:
                                        break _v0$9;
                                }
                            case 8:
                                if (_v0.a.$ === 8) {
                                    var updatedTable = _v0.a.a;
                                    var _v15 = _v0.b;
                                    var rest = _v15.b;
                                    return _List_Cons($dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable), rest);
                                }
                                else {
                                    break _v0$9;
                                }
                            default:
                                break _v0$9;
                        }
                    }
                    else {
                        break _v0$9;
                    }
                }
                return _List_Cons(newRawBlock, state.ag);
            }()
        };
    }, $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
        switch (problem.$) {
            case 0:
                var string = problem.a;
                return "Expecting " + string;
            case 1:
                return "Expecting int";
            case 2:
                return "Expecting hex";
            case 3:
                return "Expecting octal";
            case 4:
                return "Expecting binary";
            case 5:
                return "Expecting float";
            case 6:
                return "Expecting number";
            case 7:
                return "Expecting variable";
            case 8:
                var string = problem.a;
                return "Expecting symbol " + string;
            case 9:
                var string = problem.a;
                return "Expecting keyword " + string;
            case 10:
                return "Expecting keyword end";
            case 11:
                return "Unexpected char";
            case 12:
                var problemDescription = problem.a;
                return problemDescription;
            default:
                return "Bad repeat";
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
        return "Problem at row " + ($elm$core$String$fromInt(deadEnd.f$) + ("\n" + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.dE)));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
        return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
    };
    var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$Element_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$HtmlParser$Element = F3($dillonkearns$elm_markdown$HtmlParser$Element_fn);
    var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting("at least 1 tag name character");
    var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
        switch (c) {
            case " ":
                return false;
            case "\r":
                return false;
            case "\n":
                return false;
            case "\t":
                return false;
            case "/":
                return false;
            case "<":
                return false;
            case ">":
                return false;
            case "\"":
                return false;
            case "'":
                return false;
            case "=":
                return false;
            default:
                return true;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$tagName = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (name, _v0) {
        return $elm$core$String$toLower(name);
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
    var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
    var $elm$parser$Parser$ExpectingSymbol = function (a) {
        return { $: 8, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$ExpectingSymbol(str)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("amp", "&"),
        _Utils_Tuple2("lt", "<"),
        _Utils_Tuple2("gt", ">"),
        _Utils_Tuple2("apos", "'"),
        _Utils_Tuple2("quot", "\"")
    ]));
    var $rtfeldman$elm_hex$Hex$fromStringHelp_fn = function (position, chars, accumulated) {
        fromStringHelp: while (true) {
            if (!chars.b) {
                return $elm$core$Result$Ok(accumulated);
            }
            else {
                var _char = chars.a;
                var rest = chars.b;
                switch (_char) {
                    case "0":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated;
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "1":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + _Basics_pow_fn(16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "2":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (2 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "3":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (3 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "4":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (4 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "5":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (5 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "6":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (6 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "7":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (7 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "8":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (8 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "9":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (9 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "a":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (10 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "b":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (11 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "c":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (12 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "d":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (13 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "e":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (14 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case "f":
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + (15 * _Basics_pow_fn(16, position));
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    default:
                        var nonHex = _char;
                        return $elm$core$Result$Err($elm$core$String$fromChar(nonHex) + " is not a valid hexadecimal character.");
                }
            }
        }
    }, $rtfeldman$elm_hex$Hex$fromStringHelp = F3($rtfeldman$elm_hex$Hex$fromStringHelp_fn);
    var $elm$core$List$tail = function (list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(xs);
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $rtfeldman$elm_hex$Hex$fromString = function (str) {
        if ($elm$core$String$isEmpty(str)) {
            return $elm$core$Result$Err("Empty strings are not valid hexadecimal strings.");
        }
        else {
            var result = function () {
                if (_String_startsWith_fn("-", str)) {
                    var list = $elm$core$Maybe$withDefault_fn(_List_Nil, $elm$core$List$tail($elm$core$String$toList(str)));
                    return $elm$core$Result$map_fn($elm$core$Basics$negate, $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$List$length(list) - 1, list, 0));
                }
                else {
                    return $rtfeldman$elm_hex$Hex$fromStringHelp_fn($elm$core$String$length(str) - 1, $elm$core$String$toList(str), 0);
                }
            }();
            var formatError = function (err) {
                return $elm$core$String$join_fn(" ", _List_fromArray(["\"" + (str + "\""), "is not a valid hexadecimal string because", err]));
            };
            return $elm$core$Result$mapError_fn(formatError, result);
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
        return _String_startsWith_fn("#x", s) ? $elm$core$Result$mapError_fn($elm$parser$Parser$Problem, $elm$core$Result$map_fn($elm$core$Char$fromCode, $rtfeldman$elm_hex$Hex$fromString($elm$core$String$dropLeft_fn(2, s)))) : (_String_startsWith_fn("#", s) ? $elm$core$Result$fromMaybe_fn($elm$parser$Parser$Problem("Invalid escaped character: " + s), $elm$core$Maybe$map_fn($elm$core$Char$fromCode, $elm$core$String$toInt($elm$core$String$dropLeft_fn(1, s)))) : $elm$core$Result$fromMaybe_fn($elm$parser$Parser$Problem("No entity named \"&" + (s + ";\" found.")), $elm$core$Dict$get_fn(s, $dillonkearns$elm_markdown$HtmlParser$entities)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
        var process = function (entityStr) {
            var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
            if (!_v0.$) {
                var c = _v0.a;
                return $elm$parser$Parser$Advanced$succeed(c);
            }
            else {
                var e = _v0.a;
                return $elm$parser$Parser$Advanced$problem(e);
            }
        };
        var isEntityChar = function (c) {
            return (!_Utils_eq(c, end_)) && (c !== ";");
        };
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("&")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn(process, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn(isEntityChar, $elm$parser$Parser$Expecting("an entity character")), $elm$parser$Parser$Advanced$chompWhile(isEntityChar)))), $dillonkearns$elm_markdown$HtmlParser$symbol(";")));
    };
    var $dillonkearns$elm_markdown$HtmlParser$textStringStep_fn = function (closingChar, predicate, accum) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (soFar) {
            return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                $elm$parser$Parser$Advanced$map_fn(function (escaped) {
                    return $elm$parser$Parser$Advanced$Loop(_Utils_ap(accum, _Utils_ap(soFar, $elm$core$String$fromChar(escaped))));
                }, $dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
                $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(_Utils_ap(accum, soFar)))
            ]));
        }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile(predicate)));
    }, $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3($dillonkearns$elm_markdown$HtmlParser$textStringStep_fn);
    var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
        var predicate = function (c) {
            return (!_Utils_eq(c, closingChar)) && (c !== "&");
        };
        return $elm$parser$Parser$Advanced$loop_fn("", A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
    };
    var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("\"")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$textString("\""), $dillonkearns$elm_markdown$HtmlParser$symbol("\""))),
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("'")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$textString("'"), $dillonkearns$elm_markdown$HtmlParser$symbol("'")))
    ]));
    var $dillonkearns$elm_markdown$HtmlParser$keepOldest_fn = function (_new, mValue) {
        if (!mValue.$) {
            var v = mValue.a;
            return $elm$core$Maybe$Just(v);
        }
        else {
            return $elm$core$Maybe$Just(_new);
        }
    }, $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2($dillonkearns$elm_markdown$HtmlParser$keepOldest_fn);
    var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
        switch (c) {
            case " ":
                return true;
            case "\r":
                return true;
            case "\n":
                return true;
            case "\t":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
    var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
        var process = F2(function (name, value) {
            return $elm$parser$Parser$Advanced$Loop($elm$core$Dict$update_fn($elm$core$String$toLower(name), $dillonkearns$elm_markdown$HtmlParser$keepOldest(value), attrs));
        });
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(process), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $dillonkearns$elm_markdown$HtmlParser$symbol("=")), $dillonkearns$elm_markdown$HtmlParser$whiteSpace)), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(attrs))
        ]));
    };
    var $dillonkearns$elm_markdown$HtmlParser$attributes = $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Dict$foldl, F3(function (key, value, accum) {
        return _List_Cons({ dw: key, S: value }, accum);
    }), _List_Nil), $elm$parser$Parser$Advanced$loop_fn($elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
    var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
        return function (s) {
            var _v0 = _Parser_findSubString_fn(str, s.a, s.f$, s.aG, s.cr);
            var newOffset = _v0.a;
            var newRow = _v0.b;
            var newCol = _v0.c;
            var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.cr) : newOffset;
            return $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.a, adjustedOffset) < 0, 0, { aG: newCol, eU: s.eU, f: s.f, a: adjustedOffset, f$: newRow, cr: s.cr });
        };
    };
    var $dillonkearns$elm_markdown$HtmlParser$cdata = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("<![CDATA[")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("]]>")), $dillonkearns$elm_markdown$HtmlParser$symbol("]]>")));
    var $dillonkearns$elm_markdown$HtmlParser$childrenStep_fn = function (options, accum) {
        return $elm$parser$Parser$Advanced$map_fn(function (f) {
            return f(accum);
        }, $elm$parser$Parser$Advanced$oneOf(options));
    }, $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2($dillonkearns$elm_markdown$HtmlParser$childrenStep_fn);
    var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(str));
    };
    var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
        var closingTagName = $elm$parser$Parser$Advanced$andThen_fn(function (endTagName) {
            return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail("tag name mismatch: " + (startTagName + (" and " + endTagName)));
        }, $dillonkearns$elm_markdown$HtmlParser$tagName);
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$symbol("</"), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), closingTagName), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $dillonkearns$elm_markdown$HtmlParser$symbol(">"));
    };
    var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
        return $elm$parser$Parser$Advanced$Token_fn(str, $elm$parser$Parser$Expecting(str));
    };
    var $dillonkearns$elm_markdown$HtmlParser$comment = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment), $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$HtmlParser$toToken("<!--"))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("-->")), $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$HtmlParser$toToken("-->"))));
    var $dillonkearns$elm_markdown$HtmlParser$Declaration_fn = function (a, b) {
        return { $: 5, a: a, b: b };
    }, $dillonkearns$elm_markdown$HtmlParser$Declaration = F2($dillonkearns$elm_markdown$HtmlParser$Declaration_fn);
    var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting("at least 1 uppercase character");
    var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter), $elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
    var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$isWhitespace, $elm$parser$Parser$Expecting("at least one whitespace")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
    var $dillonkearns$elm_markdown$HtmlParser$docType = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration), $dillonkearns$elm_markdown$HtmlParser$symbol("<!")), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr(">")), $dillonkearns$elm_markdown$HtmlParser$symbol(">")));
    var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction), $dillonkearns$elm_markdown$HtmlParser$symbol("<?")), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntilEndOr("?>")), $dillonkearns$elm_markdown$HtmlParser$symbol("?>")));
    var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
        switch (c) {
            case "<":
                return false;
            case "&":
                return false;
            default:
                return true;
        }
    };
    var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray([
        $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            return $elm$parser$Parser$Advanced$Loop(0);
        }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar, $elm$parser$Parser$Expecting("is not & or <")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
        $elm$parser$Parser$Advanced$map_fn(function (_v1) {
            return $elm$parser$Parser$Advanced$Loop(0);
        }, $dillonkearns$elm_markdown$HtmlParser$escapedChar("<")),
        $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(0))
    ]);
    var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
        return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
    };
    var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$loop_fn(0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
    var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
        return $elm$parser$Parser$Advanced$loop_fn(_List_Nil, $dillonkearns$elm_markdown$HtmlParser$childrenStep($dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
    };
    var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
        return _List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(F2(function (_v1, accum) {
                return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(accum));
            }), $dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
            $elm$parser$Parser$Advanced$andThen_fn(function (text) {
                return $elm$core$String$isEmpty(text) ? $elm$parser$Parser$Advanced$map_fn(F2(function (_v2, accum) {
                    return $elm$parser$Parser$Advanced$Done($elm$core$List$reverse(accum));
                }), $dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(function (accum) {
                    return $elm$parser$Parser$Advanced$Loop(_List_Cons($dillonkearns$elm_markdown$HtmlParser$Text(text), accum));
                });
            }, $dillonkearns$elm_markdown$HtmlParser$textNodeString),
            $elm$parser$Parser$Advanced$map_fn(F2(function (_new, accum) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(_new, accum));
            }), $dillonkearns$elm_markdown$HtmlParser$cyclic$html())
        ]);
    };
    var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Element(startTagName)), $dillonkearns$elm_markdown$HtmlParser$whiteSpace), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return _List_Nil;
            }, $dillonkearns$elm_markdown$HtmlParser$symbol("/>")),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol(">")), $dillonkearns$elm_markdown$HtmlParser$children(startTagName))
        ])));
    };
    function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
            $dillonkearns$elm_markdown$HtmlParser$processingInstruction,
            $dillonkearns$elm_markdown$HtmlParser$comment,
            $dillonkearns$elm_markdown$HtmlParser$docType,
            $dillonkearns$elm_markdown$HtmlParser$cyclic$element()
        ]));
    }
    function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$HtmlParser$symbol("<")), $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
    }
    var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
    $dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
        return $dillonkearns$elm_markdown$HtmlParser$html;
    };
    var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
    $dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
        return $dillonkearns$elm_markdown$HtmlParser$element;
    };
    var $dillonkearns$elm_markdown$Parser$Token$tab = $elm$parser$Parser$Advanced$Token_fn("\t", $elm$parser$Parser$Expecting("a tab"));
    var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("   ", $elm$parser$Parser$ExpectingSymbol("Indentation"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn(" \t", $elm$parser$Parser$ExpectingSymbol("Indentation"))),
            $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("  \t", $elm$parser$Parser$ExpectingSymbol("Indentation")))
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock), $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (rawLine, _v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
    }, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
    var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn = function (a, b) {
        return { $: 4, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F2($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn);
    var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn(condition, $elm$parser$Parser$Problem("Expected one or more character")), $elm$parser$Parser$Advanced$chompWhile(condition));
    };
    var $dillonkearns$elm_markdown$Parser$Token$closingParen = $elm$parser$Parser$Advanced$Token_fn(")", $elm$parser$Parser$Expecting("a `)`"));
    var $dillonkearns$elm_markdown$Parser$Token$dot = $elm$parser$Parser$Advanced$Token_fn(".", $elm$parser$Parser$Expecting("a `.`"));
    var $dillonkearns$elm_markdown$Markdown$OrderedList$itemBody = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(""), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)
    ]));
    var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
        return $elm$core$Maybe$withDefault_fn(0, $elm$core$String$toInt(str));
    }, $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
    var $dillonkearns$elm_markdown$Markdown$OrderedList$singleItemParser = function (listMarker) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Parser$Extra$positiveInteger, $elm$parser$Parser$Advanced$symbol(listMarker)))), $dillonkearns$elm_markdown$Markdown$OrderedList$itemBody);
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp_fn = function (itemParser, revStmts) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (stmt) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(stmt, revStmts));
            }, itemParser),
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done($elm$core$List$reverse(revStmts)))
        ]));
    }, $dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp = F2($dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$OrderedList$parseSubsequentItems_fn = function (startingIndex, listMarker, firstItem) {
        return $elm$parser$Parser$Advanced$map_fn(function (items) {
            return _Utils_Tuple2(startingIndex, _List_Cons(firstItem, items));
        }, $elm$parser$Parser$Advanced$loop_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp($dillonkearns$elm_markdown$Markdown$OrderedList$singleItemParser(listMarker))));
    }, $dillonkearns$elm_markdown$Markdown$OrderedList$parseSubsequentItems = F3($dillonkearns$elm_markdown$Markdown$OrderedList$parseSubsequentItems_fn);
    var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = $elm$parser$Parser$Advanced$andThen_fn(function (parsed) {
        return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Starting numbers must be nine digits or less."));
    }, $dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
    var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
        if (parsed === 1) {
            return $elm$parser$Parser$Advanced$succeed(parsed);
        }
        else {
            return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
        return $elm$parser$Parser$Advanced$andThen_fn($elm$core$Basics$identity, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$OrderedList$parseSubsequentItems), $elm$parser$Parser$Advanced$backtrackable(previousWasBody ? $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1, $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits) : $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Parser$Token$dot), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Parser$Token$closingParen), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
        ]))), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
        return $elm$parser$Parser$Advanced$map_fn(function (_v0) {
            var startingIndex = _v0.a;
            var unparsedLines = _v0.b;
            return $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock_fn(startingIndex, $elm$core$List$map_fn($elm$core$Basics$identity, unparsedLines));
        }, $dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
        return { $: 2, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn);
    var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = { $: 1 };
    var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$Inline$Image_fn = function (a, b, c) {
        return { $: 4, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Image = F3($dillonkearns$elm_markdown$Markdown$Inline$Image_fn);
    var $dillonkearns$elm_markdown$Markdown$Inline$Link_fn = function (a, b, c) {
        return { $: 3, a: a, b: b, c: c };
    }, $dillonkearns$elm_markdown$Markdown$Inline$Link = F3($dillonkearns$elm_markdown$Markdown$Inline$Link_fn);
    var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
        var match = _v0;
        var _v1 = match.k;
        switch (_v1.$) {
            case 0:
                return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.gk);
            case 1:
                return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
            case 2:
                return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.gk);
            case 3:
                var _v2 = _v1.a;
                var text = _v2.a;
                var url = _v2.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Link_fn(url, $elm$core$Maybe$Nothing, _List_fromArray([
                    $dillonkearns$elm_markdown$Markdown$Inline$Text(text)
                ]));
            case 4:
                var _v3 = _v1.a;
                var url = _v3.a;
                var maybeTitle = _v3.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Link_fn(url, maybeTitle, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.v));
            case 5:
                var _v4 = _v1.a;
                var url = _v4.a;
                var maybeTitle = _v4.b;
                return $dillonkearns$elm_markdown$Markdown$Inline$Image_fn(url, maybeTitle, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.v));
            case 6:
                var model = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
            default:
                var length = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Inline$Emphasis_fn(length, $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.v));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
        return $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn = function (parentMatch, childMatch) {
        return { c2: childMatch.c2 - parentMatch.t, v: childMatch.v, d_: childMatch.d_ - parentMatch.t, gk: childMatch.gk, D: childMatch.D - parentMatch.t, t: childMatch.t - parentMatch.t, k: childMatch.k };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn = function (parentMatch, childMatch) {
        return {
            c2: parentMatch.c2,
            v: _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn(parentMatch, childMatch), parentMatch.v),
            d_: parentMatch.d_,
            gk: parentMatch.gk,
            D: parentMatch.D,
            t: parentMatch.t,
            k: parentMatch.k
        };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
        var match = _v4;
        return {
            c2: match.c2,
            v: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.v),
            d_: match.d_,
            gk: match.gk,
            D: match.D,
            t: match.t,
            k: match.k
        };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
        var _v2 = _List_sortBy_fn(function (_v3) {
            var match = _v3;
            return match.d_;
        }, matches);
        if (!_v2.b) {
            return _List_Nil;
        }
        else {
            var first = _v2.a;
            var rest = _v2.b;
            return $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn(rest, first, _List_Nil);
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn = function (remaining, _v0, matchesTail) {
        organizeMatchesHelp: while (true) {
            var prevMatch = _v0;
            if (!remaining.b) {
                return _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch), matchesTail);
            }
            else {
                var match = remaining.a;
                var rest = remaining.b;
                if (_Utils_cmp(prevMatch.c2, match.d_) < 1) {
                    var $temp$remaining = rest, $temp$_v0 = match, $temp$matchesTail = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch), matchesTail);
                    remaining = $temp$remaining;
                    _v0 = $temp$_v0;
                    matchesTail = $temp$matchesTail;
                    continue organizeMatchesHelp;
                }
                else {
                    if ((_Utils_cmp(prevMatch.d_, match.d_) < 0) && (_Utils_cmp(prevMatch.c2, match.c2) > 0)) {
                        var $temp$remaining = rest, $temp$_v0 = $dillonkearns$elm_markdown$Markdown$InlineParser$addChild_fn(prevMatch, match), $temp$matchesTail = matchesTail;
                        remaining = $temp$remaining;
                        _v0 = $temp$_v0;
                        matchesTail = $temp$matchesTail;
                        continue organizeMatchesHelp;
                    }
                    else {
                        var $temp$remaining = rest, $temp$_v0 = prevMatch, $temp$matchesTail = matchesTail;
                        remaining = $temp$remaining;
                        _v0 = $temp$_v0;
                        matchesTail = $temp$matchesTail;
                        continue organizeMatchesHelp;
                    }
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = { $: 0 };
    var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
        return _String_contains_fn("&", string);
    };
    var $elm$regex$Regex$Match_fn = function (match, index, number, submatches) {
        return { b7: index, aV: match, fK: number, cv: submatches };
    }, $elm$regex$Regex$Match = F4($elm$regex$Regex$Match_fn);
    var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
    var $elm$regex$Regex$fromString = function (string) {
        return _Regex_fromStringWith_fn({ eM: false, fA: false }, string);
    };
    var $elm$regex$Regex$never = _Regex_never;
    var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&#([0-9]{1,8});"));
    var $elm$regex$Regex$replace_a0 = _Regex_infinity, $elm$regex$Regex$replace = _Regex_replaceAtMost($elm$regex$Regex$replace_a0);
    var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
        var remain_ = _Basics_modBy_fn(16, _int);
        var remain = _Basics_modBy_fn(131070, _int);
        return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
        return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
        return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar($elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar($elm$core$Char$fromCode(65533));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
        var _v0 = match.cv;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            var _v1 = $elm$core$String$toInt(first);
            if (!_v1.$) {
                var v = _v1.a;
                return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
            }
            else {
                return match.aV;
            }
        }
        else {
            return match.aV;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
    var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&([0-9a-zA-Z]+);"));
    var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2("quot", 34),
        _Utils_Tuple2("amp", 38),
        _Utils_Tuple2("apos", 39),
        _Utils_Tuple2("lt", 60),
        _Utils_Tuple2("gt", 62),
        _Utils_Tuple2("nbsp", 160),
        _Utils_Tuple2("iexcl", 161),
        _Utils_Tuple2("cent", 162),
        _Utils_Tuple2("pound", 163),
        _Utils_Tuple2("curren", 164),
        _Utils_Tuple2("yen", 165),
        _Utils_Tuple2("brvbar", 166),
        _Utils_Tuple2("sect", 167),
        _Utils_Tuple2("uml", 168),
        _Utils_Tuple2("copy", 169),
        _Utils_Tuple2("ordf", 170),
        _Utils_Tuple2("laquo", 171),
        _Utils_Tuple2("not", 172),
        _Utils_Tuple2("shy", 173),
        _Utils_Tuple2("reg", 174),
        _Utils_Tuple2("macr", 175),
        _Utils_Tuple2("deg", 176),
        _Utils_Tuple2("plusmn", 177),
        _Utils_Tuple2("sup2", 178),
        _Utils_Tuple2("sup3", 179),
        _Utils_Tuple2("acute", 180),
        _Utils_Tuple2("micro", 181),
        _Utils_Tuple2("para", 182),
        _Utils_Tuple2("middot", 183),
        _Utils_Tuple2("cedil", 184),
        _Utils_Tuple2("sup1", 185),
        _Utils_Tuple2("ordm", 186),
        _Utils_Tuple2("raquo", 187),
        _Utils_Tuple2("frac14", 188),
        _Utils_Tuple2("frac12", 189),
        _Utils_Tuple2("frac34", 190),
        _Utils_Tuple2("iquest", 191),
        _Utils_Tuple2("Agrave", 192),
        _Utils_Tuple2("Aacute", 193),
        _Utils_Tuple2("Acirc", 194),
        _Utils_Tuple2("Atilde", 195),
        _Utils_Tuple2("Auml", 196),
        _Utils_Tuple2("Aring", 197),
        _Utils_Tuple2("AElig", 198),
        _Utils_Tuple2("Ccedil", 199),
        _Utils_Tuple2("Egrave", 200),
        _Utils_Tuple2("Eacute", 201),
        _Utils_Tuple2("Ecirc", 202),
        _Utils_Tuple2("Euml", 203),
        _Utils_Tuple2("Igrave", 204),
        _Utils_Tuple2("Iacute", 205),
        _Utils_Tuple2("Icirc", 206),
        _Utils_Tuple2("Iuml", 207),
        _Utils_Tuple2("ETH", 208),
        _Utils_Tuple2("Ntilde", 209),
        _Utils_Tuple2("Ograve", 210),
        _Utils_Tuple2("Oacute", 211),
        _Utils_Tuple2("Ocirc", 212),
        _Utils_Tuple2("Otilde", 213),
        _Utils_Tuple2("Ouml", 214),
        _Utils_Tuple2("times", 215),
        _Utils_Tuple2("Oslash", 216),
        _Utils_Tuple2("Ugrave", 217),
        _Utils_Tuple2("Uacute", 218),
        _Utils_Tuple2("Ucirc", 219),
        _Utils_Tuple2("Uuml", 220),
        _Utils_Tuple2("Yacute", 221),
        _Utils_Tuple2("THORN", 222),
        _Utils_Tuple2("szlig", 223),
        _Utils_Tuple2("agrave", 224),
        _Utils_Tuple2("aacute", 225),
        _Utils_Tuple2("acirc", 226),
        _Utils_Tuple2("atilde", 227),
        _Utils_Tuple2("auml", 228),
        _Utils_Tuple2("aring", 229),
        _Utils_Tuple2("aelig", 230),
        _Utils_Tuple2("ccedil", 231),
        _Utils_Tuple2("egrave", 232),
        _Utils_Tuple2("eacute", 233),
        _Utils_Tuple2("ecirc", 234),
        _Utils_Tuple2("euml", 235),
        _Utils_Tuple2("igrave", 236),
        _Utils_Tuple2("iacute", 237),
        _Utils_Tuple2("icirc", 238),
        _Utils_Tuple2("iuml", 239),
        _Utils_Tuple2("eth", 240),
        _Utils_Tuple2("ntilde", 241),
        _Utils_Tuple2("ograve", 242),
        _Utils_Tuple2("oacute", 243),
        _Utils_Tuple2("ocirc", 244),
        _Utils_Tuple2("otilde", 245),
        _Utils_Tuple2("ouml", 246),
        _Utils_Tuple2("divide", 247),
        _Utils_Tuple2("oslash", 248),
        _Utils_Tuple2("ugrave", 249),
        _Utils_Tuple2("uacute", 250),
        _Utils_Tuple2("ucirc", 251),
        _Utils_Tuple2("uuml", 252),
        _Utils_Tuple2("yacute", 253),
        _Utils_Tuple2("thorn", 254),
        _Utils_Tuple2("yuml", 255),
        _Utils_Tuple2("OElig", 338),
        _Utils_Tuple2("oelig", 339),
        _Utils_Tuple2("Scaron", 352),
        _Utils_Tuple2("scaron", 353),
        _Utils_Tuple2("Yuml", 376),
        _Utils_Tuple2("fnof", 402),
        _Utils_Tuple2("circ", 710),
        _Utils_Tuple2("tilde", 732),
        _Utils_Tuple2("Alpha", 913),
        _Utils_Tuple2("Beta", 914),
        _Utils_Tuple2("Gamma", 915),
        _Utils_Tuple2("Delta", 916),
        _Utils_Tuple2("Epsilon", 917),
        _Utils_Tuple2("Zeta", 918),
        _Utils_Tuple2("Eta", 919),
        _Utils_Tuple2("Theta", 920),
        _Utils_Tuple2("Iota", 921),
        _Utils_Tuple2("Kappa", 922),
        _Utils_Tuple2("Lambda", 923),
        _Utils_Tuple2("Mu", 924),
        _Utils_Tuple2("Nu", 925),
        _Utils_Tuple2("Xi", 926),
        _Utils_Tuple2("Omicron", 927),
        _Utils_Tuple2("Pi", 928),
        _Utils_Tuple2("Rho", 929),
        _Utils_Tuple2("Sigma", 931),
        _Utils_Tuple2("Tau", 932),
        _Utils_Tuple2("Upsilon", 933),
        _Utils_Tuple2("Phi", 934),
        _Utils_Tuple2("Chi", 935),
        _Utils_Tuple2("Psi", 936),
        _Utils_Tuple2("Omega", 937),
        _Utils_Tuple2("alpha", 945),
        _Utils_Tuple2("beta", 946),
        _Utils_Tuple2("gamma", 947),
        _Utils_Tuple2("delta", 948),
        _Utils_Tuple2("epsilon", 949),
        _Utils_Tuple2("zeta", 950),
        _Utils_Tuple2("eta", 951),
        _Utils_Tuple2("theta", 952),
        _Utils_Tuple2("iota", 953),
        _Utils_Tuple2("kappa", 954),
        _Utils_Tuple2("lambda", 955),
        _Utils_Tuple2("mu", 956),
        _Utils_Tuple2("nu", 957),
        _Utils_Tuple2("xi", 958),
        _Utils_Tuple2("omicron", 959),
        _Utils_Tuple2("pi", 960),
        _Utils_Tuple2("rho", 961),
        _Utils_Tuple2("sigmaf", 962),
        _Utils_Tuple2("sigma", 963),
        _Utils_Tuple2("tau", 964),
        _Utils_Tuple2("upsilon", 965),
        _Utils_Tuple2("phi", 966),
        _Utils_Tuple2("chi", 967),
        _Utils_Tuple2("psi", 968),
        _Utils_Tuple2("omega", 969),
        _Utils_Tuple2("thetasym", 977),
        _Utils_Tuple2("upsih", 978),
        _Utils_Tuple2("piv", 982),
        _Utils_Tuple2("ensp", 8194),
        _Utils_Tuple2("emsp", 8195),
        _Utils_Tuple2("thinsp", 8201),
        _Utils_Tuple2("zwnj", 8204),
        _Utils_Tuple2("zwj", 8205),
        _Utils_Tuple2("lrm", 8206),
        _Utils_Tuple2("rlm", 8207),
        _Utils_Tuple2("ndash", 8211),
        _Utils_Tuple2("mdash", 8212),
        _Utils_Tuple2("lsquo", 8216),
        _Utils_Tuple2("rsquo", 8217),
        _Utils_Tuple2("sbquo", 8218),
        _Utils_Tuple2("ldquo", 8220),
        _Utils_Tuple2("rdquo", 8221),
        _Utils_Tuple2("bdquo", 8222),
        _Utils_Tuple2("dagger", 8224),
        _Utils_Tuple2("Dagger", 8225),
        _Utils_Tuple2("bull", 8226),
        _Utils_Tuple2("hellip", 8230),
        _Utils_Tuple2("permil", 8240),
        _Utils_Tuple2("prime", 8242),
        _Utils_Tuple2("Prime", 8243),
        _Utils_Tuple2("lsaquo", 8249),
        _Utils_Tuple2("rsaquo", 8250),
        _Utils_Tuple2("oline", 8254),
        _Utils_Tuple2("frasl", 8260),
        _Utils_Tuple2("euro", 8364),
        _Utils_Tuple2("image", 8465),
        _Utils_Tuple2("weierp", 8472),
        _Utils_Tuple2("real", 8476),
        _Utils_Tuple2("trade", 8482),
        _Utils_Tuple2("alefsym", 8501),
        _Utils_Tuple2("larr", 8592),
        _Utils_Tuple2("uarr", 8593),
        _Utils_Tuple2("rarr", 8594),
        _Utils_Tuple2("darr", 8595),
        _Utils_Tuple2("harr", 8596),
        _Utils_Tuple2("crarr", 8629),
        _Utils_Tuple2("lArr", 8656),
        _Utils_Tuple2("uArr", 8657),
        _Utils_Tuple2("rArr", 8658),
        _Utils_Tuple2("dArr", 8659),
        _Utils_Tuple2("hArr", 8660),
        _Utils_Tuple2("forall", 8704),
        _Utils_Tuple2("part", 8706),
        _Utils_Tuple2("exist", 8707),
        _Utils_Tuple2("empty", 8709),
        _Utils_Tuple2("nabla", 8711),
        _Utils_Tuple2("isin", 8712),
        _Utils_Tuple2("notin", 8713),
        _Utils_Tuple2("ni", 8715),
        _Utils_Tuple2("prod", 8719),
        _Utils_Tuple2("sum", 8721),
        _Utils_Tuple2("minus", 8722),
        _Utils_Tuple2("lowast", 8727),
        _Utils_Tuple2("radic", 8730),
        _Utils_Tuple2("prop", 8733),
        _Utils_Tuple2("infin", 8734),
        _Utils_Tuple2("ang", 8736),
        _Utils_Tuple2("and", 8743),
        _Utils_Tuple2("or", 8744),
        _Utils_Tuple2("cap", 8745),
        _Utils_Tuple2("cup", 8746),
        _Utils_Tuple2("int", 8747),
        _Utils_Tuple2("there4", 8756),
        _Utils_Tuple2("sim", 8764),
        _Utils_Tuple2("cong", 8773),
        _Utils_Tuple2("asymp", 8776),
        _Utils_Tuple2("ne", 8800),
        _Utils_Tuple2("equiv", 8801),
        _Utils_Tuple2("le", 8804),
        _Utils_Tuple2("ge", 8805),
        _Utils_Tuple2("sub", 8834),
        _Utils_Tuple2("sup", 8835),
        _Utils_Tuple2("nsub", 8836),
        _Utils_Tuple2("sube", 8838),
        _Utils_Tuple2("supe", 8839),
        _Utils_Tuple2("oplus", 8853),
        _Utils_Tuple2("otimes", 8855),
        _Utils_Tuple2("perp", 8869),
        _Utils_Tuple2("sdot", 8901),
        _Utils_Tuple2("lceil", 8968),
        _Utils_Tuple2("rceil", 8969),
        _Utils_Tuple2("lfloor", 8970),
        _Utils_Tuple2("rfloor", 8971),
        _Utils_Tuple2("lang", 9001),
        _Utils_Tuple2("rang", 9002),
        _Utils_Tuple2("loz", 9674),
        _Utils_Tuple2("spades", 9824),
        _Utils_Tuple2("clubs", 9827),
        _Utils_Tuple2("hearts", 9829),
        _Utils_Tuple2("diams", 9830)
    ]));
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
        var _v0 = match.cv;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            var _v1 = $elm$core$Dict$get_fn(first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
            if (!_v1.$) {
                var code = _v1.a;
                return $elm$core$String$fromChar($elm$core$Char$fromCode(code));
            }
            else {
                return match.aV;
            }
        }
        else {
            return match.aV;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
    var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])"));
    var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex, function (regexMatch) {
        var _v0 = regexMatch.cv;
        if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
            var backslashes = _v0.a.a;
            var _v1 = _v0.b;
            var escapedStr = _v1.a.a;
            return _Utils_ap($elm$core$String$repeat_fn(($elm$core$String$length(backslashes) / 2) | 0, "\\"), escapedStr);
        }
        else {
            return regexMatch.aV;
        }
    });
    var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("&#[Xx]([0-9a-fA-F]{1,8});"));
    var $elm$core$String$foldl = _String_foldl;
    var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
        var folder = F2(function (hexDigit, _int) {
            return ((_int * 16) + _Basics_modBy_fn(39, $elm$core$Char$toCode(hexDigit))) - 9;
        });
        return _String_foldl_fn(folder, 0, $elm$core$String$toLower(string));
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
        var _v0 = match.cv;
        if (_v0.b && (!_v0.a.$)) {
            var first = _v0.a.a;
            return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode($dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
        }
        else {
            return match.aV;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
    var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
        var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
        return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals($dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals($dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
        return {
            c2: 0,
            v: _List_Nil,
            d_: 0,
            gk: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
            D: 0,
            t: 0,
            k: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
        };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn = function (rawText, _v2, parsedMatches) {
        var matchModel = _v2;
        var updtMatch = {
            c2: matchModel.c2,
            v: $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn(matchModel.gk, _List_Nil, matchModel.v),
            d_: matchModel.d_,
            gk: matchModel.gk,
            D: matchModel.D,
            t: matchModel.t,
            k: matchModel.k
        };
        if (!parsedMatches.b) {
            var finalStr = $elm$core$String$dropLeft_fn(matchModel.c2, rawText);
            return $elm$core$String$isEmpty(finalStr) ? _List_fromArray([updtMatch]) : _List_fromArray([
                updtMatch,
                $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
            ]);
        }
        else {
            var matchHead = parsedMatches.a;
            var matchesTail = parsedMatches.b;
            var _v4 = matchHead.k;
            if (!_v4.$) {
                return _List_Cons(updtMatch, parsedMatches);
            }
            else {
                return _Utils_eq(matchModel.c2, matchHead.d_) ? _List_Cons(updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.c2, matchHead.d_) < 0) ? _List_Cons(updtMatch, _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(_String_slice_fn(matchModel.c2, matchHead.d_, rawText)), parsedMatches)) : parsedMatches);
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn = function (rawText, parsedMatches, matches) {
        parseTextMatches: while (true) {
            if (!matches.b) {
                if (!parsedMatches.b) {
                    return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray([
                        $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
                    ]);
                }
                else {
                    var matchModel = parsedMatches.a;
                    return (matchModel.d_ > 0) ? _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch($elm$core$String$left_fn(matchModel.d_, rawText)), parsedMatches) : parsedMatches;
                }
            }
            else {
                var match = matches.a;
                var matchesTail = matches.b;
                var $temp$rawText = rawText, $temp$parsedMatches = $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch_fn(rawText, match, parsedMatches), $temp$matches = matchesTail;
                rawText = $temp$rawText;
                parsedMatches = $temp$parsedMatches;
                matches = $temp$matches;
                continue parseTextMatches;
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\<)"));
    var $elm$regex$Regex$find_a0 = _Regex_infinity, $elm$regex$Regex$find = _Regex_findAtMost($elm$regex$Regex$find_a0);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = { $: 4 };
    var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
        return !_Basics_modBy_fn(2, _int);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
        var _v0 = regMatch.cv;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var delimiter = _v1.a.a;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ b7: regMatch.b7 + backslashesLength, b8: 1, c: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen }) : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\>)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
        var _v0 = regMatch.cv;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $elm$core$Maybe$Just({
                b7: regMatch.b7 + backslashesLength,
                b8: 1,
                c: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
            });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)([^*])?(\\*+)([^*])?"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn = function (a, b) {
        return { $: 7, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
        switch (c) {
            case "!":
                return true;
            case "\"":
                return true;
            case "#":
                return true;
            case "%":
                return true;
            case "&":
                return true;
            case "'":
                return true;
            case "(":
                return true;
            case ")":
                return true;
            case "*":
                return true;
            case ",":
                return true;
            case "-":
                return true;
            case ".":
                return true;
            case "/":
                return true;
            case ":":
                return true;
            case ";":
                return true;
            case "?":
                return true;
            case "@":
                return true;
            case "[":
                return true;
            case "]":
                return true;
            case "_":
                return true;
            case "{":
                return true;
            case "}":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0 = F2(function (c, accum) {
        return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1 = false, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2($elm$core$String$foldl, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
        switch (c) {
            case " ":
                return true;
            case "\f":
                return true;
            case "\n":
                return true;
            case "\r":
                return true;
            case "\t":
                return true;
            case "\v":
                return true;
            case "\u00A0":
                return true;
            case "\u2028":
                return true;
            case "\u2029":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0 = F2(function (c, accum) {
        return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1 = false, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2($elm$core$String$foldl, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
        if (!mstring.$) {
            var string = mstring.a;
            return ($elm$core$String$isEmpty(string) || _String_foldl_fn($dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace_a1, string)) ? 0 : (_String_foldl_fn($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation_a1, string) ? 1 : 2);
        }
        else {
            return 0;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken_fn = function (_char, rawText, regMatch) {
        var _v0 = regMatch.cv;
        if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var maybeLeftFringe = _v1.a;
            var _v2 = _v1.b;
            var delimiter = _v2.a.a;
            var _v3 = _v2.b;
            var maybeRightFringe = _v3.a;
            var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
            var leftFringeLength = function () {
                if (!maybeLeftFringe.$) {
                    var left = maybeLeftFringe.a;
                    return $elm$core$String$length(left);
                }
                else {
                    return 0;
                }
            }();
            var mLeftFringe = ((!(!regMatch.b7)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(_String_slice_fn(regMatch.b7 - 1, regMatch.b7, rawText)) : maybeLeftFringe;
            var backslashesLength = function () {
                if (!maybeBackslashes.$) {
                    var backslashes = maybeBackslashes.a;
                    return $elm$core$String$length(backslashes);
                }
                else {
                    return 0;
                }
            }();
            var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
                if ((!mLeftFringe.$) && (mLeftFringe.a === "\\")) {
                    return true;
                }
                else {
                    return false;
                }
            }();
            var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
            var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
            if ((delimiterLength <= 0) || ((_char === "_") && ((lFringeRank === 2) && (rFringeRank === 2)))) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var index = ((regMatch.b7 + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
                return $elm$core$Maybe$Just({
                    b7: index,
                    b8: delimiterLength,
                    c: $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken_fn(_char, { bm: lFringeRank, bs: rFringeRank })
                });
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
        return $elm$core$List$filterMap_fn(A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, "*", str), _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\`+)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
        return { $: 0, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
        var _v0 = regMatch.cv;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backtick = _v1.a.a;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $elm$core$Maybe$Just({
                b7: regMatch.b7 + backslashesLength,
                b8: $elm$core$String$length(backtick),
                c: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
            });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(\\\\+)|( {2,}))\\n"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = { $: 9 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
        var _v0 = regMatch.cv;
        _v0$2: while (true) {
            if (_v0.b) {
                if (!_v0.a.$) {
                    var backslashes = _v0.a.a;
                    var backslashesLength = $elm$core$String$length(backslashes);
                    return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just({ b7: (regMatch.b7 + backslashesLength) - 1, b8: 2, c: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken }) : $elm$core$Maybe$Nothing;
                }
                else {
                    if (_v0.b.b && (!_v0.b.a.$)) {
                        var _v1 = _v0.b;
                        return $elm$core$Maybe$Just({
                            b7: regMatch.b7,
                            b8: $elm$core$String$length(regMatch.aV),
                            c: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
                        });
                    }
                    else {
                        break _v0$2;
                    }
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
        var _v0 = regMatch.cv;
        _v0$2: while (true) {
            if (_v0.b) {
                if (!_v0.a.$) {
                    var backslashes = _v0.a.a;
                    var backslashesLength = $elm$core$String$length(backslashes);
                    return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ b7: regMatch.b7 + backslashesLength, b8: 1, c: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken }) : $elm$core$Maybe$Just({ b7: (regMatch.b7 + backslashesLength) - 1, b8: 2, c: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken });
                }
                else {
                    if (_v0.b.b) {
                        var _v1 = _v0.b;
                        var maybeSpaces = _v1.a;
                        return $elm$core$Maybe$Just({
                            b7: regMatch.b7,
                            b8: $elm$core$String$length(regMatch.aV),
                            c: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
                        });
                    }
                    else {
                        break _v0$2;
                    }
                }
            }
            else {
                break _v0$2;
            }
        }
        return $elm$core$Maybe$Nothing;
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(?:(\\\\+)|( *))\\n"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\])"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = { $: 3 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
        var _v0 = regMatch.cv;
        if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just({ b7: regMatch.b7 + backslashesLength, b8: 1, c: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose }) : $elm$core$Maybe$Nothing;
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)(\\!)?(\\[)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = { $: 2 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
        var _v0 = regMatch.cv;
        if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
            var maybeBackslashes = _v0.a;
            var _v1 = _v0.b;
            var maybeImageOpen = _v1.a;
            var _v2 = _v1.b;
            var backslashesLength = $elm$core$Maybe$withDefault_fn(0, $elm$core$Maybe$map_fn($elm$core$String$length, maybeBackslashes));
            var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
            var index = isEscaped ? ((regMatch.b7 + backslashesLength) + 1) : (regMatch.b7 + backslashesLength);
            if (isEscaped) {
                if (!maybeImageOpen.$) {
                    return $elm$core$Maybe$Just({
                        b7: index,
                        b8: 1,
                        c: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
                    });
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                if (!maybeImageOpen.$) {
                    return $elm$core$Maybe$Just({ b7: index, b8: 2, c: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken });
                }
                else {
                    return $elm$core$Maybe$Just({
                        b7: index,
                        b8: 1,
                        c: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
                    });
                }
            }
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken, _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("(\\\\*)([^_])?(\\_+)([^_])?"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
        return $elm$core$List$filterMap_fn(A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, "_", str), _Regex_findAtMost_fn($elm$regex$Regex$find_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn = function (left, right) {
        if (left.b) {
            var lfirst = left.a;
            var lrest = left.b;
            if (right.b) {
                var rfirst = right.a;
                var rrest = right.b;
                return (_Utils_cmp(lfirst.b7, rfirst.b7) < 0) ? _List_Cons(lfirst, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn(lrest, right)) : _List_Cons(rfirst, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn(left, rrest));
            }
            else {
                return left;
            }
        }
        else {
            return right;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex_fn($dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText), $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText))))))));
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = { $: 2 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
        return { $: 7, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
        return { $: 6, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
        return { $: 5, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
        return { $: 4, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
        return { $: 3, a: a };
    };
    var $elm$regex$Regex$contains = _Regex_contains;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0 = $elm$url$Url$percentEncode, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1 = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex, function (match) {
        return $elm$core$Maybe$withDefault_fn(match.aV, $elm$url$Url$percentDecode(match.aV));
    }), $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
        var match = _v0;
        return _Regex_contains_fn($dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.gk) ? $elm$core$Result$Ok(_Utils_update(match, {
            k: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(_Utils_Tuple2(match.gk, $elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, match.gk)))
        })) : $elm$core$Result$Err(match);
    };
    var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
    var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = "[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*";
    var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\[\\s*(" + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ")\\s*\\]")));
    var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
        return original;
    };
    var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0 = $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1 = $elm$core$String$toLower, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn = function (rawUrl, maybeTitle) {
        return _Utils_Tuple2($elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)), $elm$core$Maybe$map_fn($dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn = function (matchModel, references, maybeRegexMatch) {
        var refLabel = function (str) {
            return $elm$core$String$isEmpty(str) ? matchModel.gk : str;
        }($elm$core$Maybe$withDefault_fn(matchModel.gk, $elm$core$Maybe$withDefault_fn($elm$core$Maybe$Nothing, $elm$core$Maybe$andThen_fn(A2($elm$core$Basics$composeR, function ($) {
            return $.cv;
        }, $elm$core$List$head), maybeRegexMatch))));
        var _v0 = $elm$core$Dict$get_fn($elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a0, $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel_a1, refLabel), references);
        if (_v0.$ === 1) {
            return $elm$core$Maybe$Nothing;
        }
        else {
            var _v1 = _v0.a;
            var rawUrl = _v1.a;
            var maybeTitle = _v1.b;
            var type_ = function () {
                var _v3 = matchModel.k;
                if (_v3.$ === 5) {
                    return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle));
                }
                else {
                    return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle));
                }
            }();
            var regexMatchLength = function () {
                if (!maybeRegexMatch.$) {
                    var match = maybeRegexMatch.a.aV;
                    return $elm$core$String$length(match);
                }
                else {
                    return 0;
                }
            }();
            return $elm$core$Maybe$Just(_Utils_update(matchModel, { c2: matchModel.c2 + regexMatchLength, k: type_ }));
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3($dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn = function (remainText, _v0, references) {
        var tempMatch = _v0;
        var matches = _Regex_findAtMost_fn(1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
        return $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch_fn(tempMatch, references, $elm$core$List$head(matches));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn);
    var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = "\\f\\v\\r\\n";
    var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = " \\t\\f\\v\\r\\n";
    var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = "(?:<([^<>" + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + ("]*)>|([^" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ("\\(\\)\\\\]*(?:\\\\.[^" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + "\\(\\)\\\\]*)*))")))));
    var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = "(?:[" + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ("]+" + ("(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|" + ("\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|" + "\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?"))));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^\\(\\s*" + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + "\\s*\\)"))));
    var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
        var process = F2(function (a, maybeFound) {
            if (!maybeFound.$) {
                var found = maybeFound.a;
                return $elm$core$Maybe$Just(found);
            }
            else {
                return a;
            }
        });
        return $elm$core$List$foldl_fn(process, $elm$core$Maybe$Nothing, maybes);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn = function (matchModel, regexMatch) {
        var _v0 = regexMatch.cv;
        if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
            var maybeRawUrlAngleBrackets = _v0.a;
            var _v1 = _v0.b;
            var maybeRawUrlWithoutBrackets = _v1.a;
            var _v2 = _v1.b;
            var maybeTitleSingleQuotes = _v2.a;
            var _v3 = _v2.b;
            var maybeTitleDoubleQuotes = _v3.a;
            var _v4 = _v3.b;
            var maybeTitleParenthesis = _v4.a;
            var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(_List_fromArray([maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
            var toMatch = function (rawUrl) {
                return _Utils_update(matchModel, {
                    c2: matchModel.c2 + $elm$core$String$length(regexMatch.aV),
                    k: function () {
                        var _v5 = matchModel.k;
                        if (_v5.$ === 5) {
                            return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
                        }
                        else {
                            return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
                        }
                    }()($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle_fn(rawUrl, maybeTitle))
                });
            };
            var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(_List_fromArray([maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
            return $elm$core$Maybe$Just(toMatch($elm$core$Maybe$withDefault_fn("", maybeRawUrl)));
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn = function (remainText, _v0, refs) {
        var tempMatch = _v0;
        var _v1 = _Regex_findAtMost_fn(1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
        if (_v1.b) {
            var first = _v1.a;
            var _v2 = $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch_fn(tempMatch, first);
            if (!_v2.$) {
                var match = _v2.a;
                return $elm$core$Maybe$Just(match);
            }
            else {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn(remainText, tempMatch, refs);
            }
        }
        else {
            return $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences_fn(remainText, tempMatch, refs);
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn = function (_v0, remainMatches) {
        var match = _v0;
        var overlappingMatches = $elm$core$List$filter(function (_v1) {
            var testMatch = _v1;
            return (_Utils_cmp(match.c2, testMatch.d_) > 0) && (_Utils_cmp(match.c2, testMatch.c2) < 0);
        });
        return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(_List_Cons(match, remainMatches)) : $elm$core$Maybe$Nothing;
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = $elm$core$Maybe$withDefault_fn($elm$regex$Regex$never, $elm$regex$Regex$fromString("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$"));
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
        var match = _v0;
        return _Regex_contains_fn($dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.gk) ? $elm$core$Result$Ok(_Utils_update(match, {
            k: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(_Utils_Tuple2(match.gk, "mailto:" + $elm$core$Basics$composeR_fn($dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a0, $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl_a1, match.gk)))
        })) : $elm$core$Result$Err(match);
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn = function (innerTokens, isToken, tokens) {
        findTokenHelp: while (true) {
            if (!tokens.b) {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var nextToken = tokens.a;
                var remainingTokens = tokens.b;
                if (isToken(nextToken)) {
                    return $elm$core$Maybe$Just(_Utils_Tuple3(nextToken, $elm$core$List$reverse(innerTokens), remainingTokens));
                }
                else {
                    var $temp$innerTokens = _List_Cons(nextToken, innerTokens), $temp$isToken = isToken, $temp$tokens = remainingTokens;
                    innerTokens = $temp$innerTokens;
                    isToken = $temp$isToken;
                    tokens = $temp$tokens;
                    continue findTokenHelp;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn = function (isToken, tokens) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp_fn(_List_Nil, isToken, tokens);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn = function (a, b) {
        return { $: 6, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 1;
    var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn = function (rawText, _v0) {
        var match = _v0;
        var consumedCharacters = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F3(function (startOffset, htmlTag, endOffset) {
            return { df: htmlTag, b8: endOffset - startOffset };
        })), $elm$parser$Parser$Advanced$getOffset), $dillonkearns$elm_markdown$HtmlParser$html), $elm$parser$Parser$Advanced$getOffset);
        var parsed = $elm$parser$Parser$Advanced$run_fn(consumedCharacters, $elm$core$String$dropLeft_fn(match.d_, rawText));
        if (!parsed.$) {
            var htmlTag = parsed.a.df;
            var length = parsed.a.b8;
            var htmlToken = $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken_fn(1, htmlTag);
            return $elm$core$Maybe$Just({ b7: match.d_, b8: length, c: htmlToken });
        }
        else {
            return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn);
    var $dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn = function (_function, result) {
        if (!result.$) {
            return result;
        }
        else {
            var err = result.a;
            return _function(err);
        }
    }, $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2($dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken_fn = function (htmlModel, token) {
        return false;
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair_fn = function (closeToken, openToken) {
        var _v0 = openToken.c;
        if (!_v0.$) {
            if (!_v0.a) {
                var _v1 = _v0.a;
                return openToken.b8 - 1 === closeToken.b8;
            }
            else {
                var _v2 = _v0.a;
                return _Utils_eq(openToken.b8, closeToken.b8);
            }
        }
        else {
            return false;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
        var _v0 = token.c;
        switch (_v0.$) {
            case 1:
                return true;
            case 2:
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken_fn = function (closeToken, openToken) {
        var _v0 = openToken.c;
        if (_v0.$ === 7) {
            var openChar = _v0.a;
            var open = _v0.b;
            var _v1 = closeToken.c;
            if (_v1.$ === 7) {
                var closeChar = _v1.a;
                var close = _v1.b;
                return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.bm, open.bs) || _Utils_eq(close.bm, close.bs)) ? (!(!_Basics_modBy_fn(3, closeToken.b8 + openToken.b8))) : true) : false;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = { $: 1 };
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn = function (token, type_) {
        return { c2: token.b7 + token.b8, v: _List_Nil, d_: token.b7, gk: "", D: 0, t: 0, k: type_ };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn = function (remaining, tokens, matches, refs, rawText) {
        lineBreakTTM: while (true) {
            if (!remaining.b) {
                return matches;
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v1 = token.c;
                if (_v1.$ === 9) {
                    var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn(token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType), matches), $temp$refs = refs, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    refs = $temp$refs;
                    rawText = $temp$rawText;
                    continue lineBreakTTM;
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$refs = refs, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    refs = $temp$refs;
                    rawText = $temp$rawText;
                    continue lineBreakTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn = function (_v0, tokensTail) {
        var match = _v0;
        return $elm$core$List$filter_fn(function (token) {
            return _Utils_cmp(token.b7, match.c2) > -1;
        }, tokensTail);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn = function (closeToken, escaped, matches, references, rawText, _v39) {
        var openToken = _v39.a;
        var remainTokens = _v39.c;
        var result = $dillonkearns$elm_markdown$Markdown$Helpers$ifError_fn($dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch, $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
            return s;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, openToken, closeToken, _List_Nil)));
        if (result.$ === 1) {
            var tempMatch = result.a;
            if (escaped === 1) {
                var _v42 = $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken_fn(rawText, tempMatch);
                if (!_v42.$) {
                    var newToken = _v42.a;
                    return $elm$core$Maybe$Just(_Utils_Tuple2(_List_Cons(newToken, remainTokens), matches));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
        else {
            var newMatch = result.a;
            return $elm$core$Maybe$Just(_Utils_Tuple2(remainTokens, _List_Cons(newMatch, matches)));
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn = function (remaining, tokens, matches, references, rawText) {
        codeAutolinkTypeHtmlTagTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v31 = token.c;
                switch (_v31.$) {
                    case 0:
                        var isEscaped = _v31.a;
                        var _v32 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token), tokens);
                        if (!_v32.$) {
                            var code = _v32.a;
                            var _v33 = $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn(token, matches, references, rawText, code);
                            var newTokens = _v33.a;
                            var newMatches = _v33.b;
                            var $temp$remaining = tokensTail, $temp$tokens = newTokens, $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                    case 5:
                        var isEscaped = _v31.a;
                        var isAngleBracketOpen = function (_v38) {
                            var meaning = _v38.c;
                            if (meaning.$ === 4) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        var _v34 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn(isAngleBracketOpen, tokens);
                        if (!_v34.$) {
                            var found = _v34.a;
                            var _v35 = $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch_fn(token, isEscaped, matches, references, rawText, found);
                            if (!_v35.$) {
                                var _v36 = _v35.a;
                                var newTokens = _v36.a;
                                var newMatches = _v36.b;
                                var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), newTokens), $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue codeAutolinkTypeHtmlTagTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue codeAutolinkTypeHtmlTagTTM;
                            }
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = $elm$core$List$filter_fn(A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen), tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue codeAutolinkTypeHtmlTagTTM;
                        }
                    default:
                        var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue codeAutolinkTypeHtmlTagTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn = function (closeToken, matches, references, rawText, _v27) {
        var openToken = _v27.a;
        var remainTokens = _v27.c;
        var updatedOpenToken = function () {
            var _v28 = openToken.c;
            if ((!_v28.$) && (!_v28.a)) {
                var _v29 = _v28.a;
                return _Utils_update(openToken, { b7: openToken.b7 + 1, b8: openToken.b8 - 1 });
            }
            else {
                return openToken;
            }
        }();
        var match = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
        return _Utils_Tuple2(remainTokens, _List_Cons(match, matches));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn = function (remaining, tokens, matches, references, rawText) {
        emphasisTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v22 = token.c;
                if (_v22.$ === 7) {
                    var _char = _v22.a;
                    var leftFringeRank = _v22.b.bm;
                    var rightFringeRank = _v22.b.bs;
                    if (_Utils_eq(leftFringeRank, rightFringeRank)) {
                        if ((!(!rightFringeRank)) && ((_char !== "_") || (rightFringeRank === 1))) {
                            var _v23 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token), tokens);
                            if (!_v23.$) {
                                var found = _v23.a;
                                var _v24 = $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn(references, rawText, token, tokensTail, found);
                                var newRemaining = _v24.a;
                                var match = _v24.b;
                                var newTokens = _v24.c;
                                var $temp$remaining = newRemaining, $temp$tokens = newTokens, $temp$matches = _List_Cons(match, matches), $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue emphasisTTM;
                        }
                    }
                    else {
                        if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
                            var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue emphasisTTM;
                        }
                        else {
                            var _v25 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token), tokens);
                            if (!_v25.$) {
                                var found = _v25.a;
                                var _v26 = $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn(references, rawText, token, tokensTail, found);
                                var newRemaining = _v26.a;
                                var match = _v26.b;
                                var newTokens = _v26.c;
                                var $temp$remaining = newRemaining, $temp$tokens = newTokens, $temp$matches = _List_Cons(match, matches), $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                            else {
                                var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                                remaining = $temp$remaining;
                                tokens = $temp$tokens;
                                matches = $temp$matches;
                                references = $temp$references;
                                rawText = $temp$rawText;
                                continue emphasisTTM;
                            }
                        }
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue emphasisTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn = function (references, rawText, closeToken, tokensTail, _v20) {
        var openToken = _v20.a;
        var innerTokens = _v20.b;
        var remainTokens = _v20.c;
        var remainLength = openToken.b8 - closeToken.b8;
        var updt = (!remainLength) ? { ba: closeToken, aW: openToken, br: remainTokens, bD: tokensTail } : ((remainLength > 0) ? {
            ba: closeToken,
            aW: _Utils_update(openToken, { b7: openToken.b7 + remainLength, b8: closeToken.b8 }),
            br: _List_Cons(_Utils_update(openToken, { b8: remainLength }), remainTokens),
            bD: tokensTail
        } : {
            ba: _Utils_update(closeToken, { b8: openToken.b8 }),
            aW: openToken,
            br: remainTokens,
            bD: _List_Cons(_Utils_update(closeToken, { b7: closeToken.b7 + openToken.b8, b8: -remainLength }), tokensTail)
        });
        var match = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
            return s;
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.aW.b8), updt.aW, updt.ba, $elm$core$List$reverse(innerTokens));
        return _Utils_Tuple3(updt.bD, match, updt.br);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn = function (remaining, tokens, matches, references, rawText) {
        htmlElementTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v16 = token.c;
                if (_v16.$ === 6) {
                    var isOpen = _v16.a;
                    var htmlModel = _v16.b;
                    if (isOpen === 1) {
                        var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn(token, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)), matches), $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue htmlElementTTM;
                    }
                    else {
                        var _v18 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel), tokensTail);
                        if (_v18.$ === 1) {
                            var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = _List_Cons($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch_fn(token, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)), matches), $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue htmlElementTTM;
                        }
                        else {
                            var _v19 = _v18.a;
                            var closeToken = _v19.a;
                            var innerTokens = _v19.b;
                            var newTail = _v19.c;
                            var newMatch = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
                                return s;
                            }, $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel), token, closeToken, innerTokens);
                            var $temp$remaining = newTail, $temp$tokens = tokens, $temp$matches = _List_Cons(newMatch, matches), $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue htmlElementTTM;
                        }
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue htmlElementTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn = function (remaining, tokens, matches, references, rawText) {
        linkImageTypeTTM: while (true) {
            if (!remaining.b) {
                return $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM_fn($elm$core$List$reverse(tokens), _List_Nil, matches, references, rawText);
            }
            else {
                var token = remaining.a;
                var tokensTail = remaining.b;
                var _v11 = token.c;
                if (_v11.$ === 3) {
                    var _v12 = $dillonkearns$elm_markdown$Markdown$InlineParser$findToken_fn($dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
                    if (!_v12.$) {
                        var found = _v12.a;
                        var _v13 = $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn(token, tokensTail, matches, references, rawText, found);
                        if (!_v13.$) {
                            var _v14 = _v13.a;
                            var x = _v14.a;
                            var newMatches = _v14.b;
                            var newTokens = _v14.c;
                            var $temp$remaining = x, $temp$tokens = newTokens, $temp$matches = newMatches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue linkImageTypeTTM;
                        }
                        else {
                            var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                            remaining = $temp$remaining;
                            tokens = $temp$tokens;
                            matches = $temp$matches;
                            references = $temp$references;
                            rawText = $temp$rawText;
                            continue linkImageTypeTTM;
                        }
                    }
                    else {
                        var $temp$remaining = tokensTail, $temp$tokens = tokens, $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                        remaining = $temp$remaining;
                        tokens = $temp$tokens;
                        matches = $temp$matches;
                        references = $temp$references;
                        rawText = $temp$rawText;
                        continue linkImageTypeTTM;
                    }
                }
                else {
                    var $temp$remaining = tokensTail, $temp$tokens = _List_Cons(token, tokens), $temp$matches = matches, $temp$references = references, $temp$rawText = rawText;
                    remaining = $temp$remaining;
                    tokens = $temp$tokens;
                    matches = $temp$matches;
                    references = $temp$references;
                    rawText = $temp$rawText;
                    continue linkImageTypeTTM;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5($dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn = function (closeToken, tokensTail, oldMatches, references, rawText, _v1) {
        var openToken = _v1.a;
        var innerTokens = _v1.b;
        var remainTokens = _v1.c;
        var removeOpenToken = _Utils_Tuple3(tokensTail, oldMatches, _Utils_ap(innerTokens, remainTokens));
        var remainText = $elm$core$String$dropLeft_fn(closeToken.b7 + 1, rawText);
        var inactivateLinkOpenToken = function (token) {
            var _v9 = token.c;
            if (_v9.$ === 1) {
                return _Utils_update(token, {
                    c: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
                });
            }
            else {
                return token;
            }
        };
        var findTempMatch = function (isLinkType) {
            return $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn(references, rawText, function (s) {
                return s;
            }, isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(_Utils_Tuple2("", $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(_Utils_Tuple2("", $elm$core$Maybe$Nothing)), openToken, closeToken, $elm$core$List$reverse(innerTokens));
        };
        var _v2 = openToken.c;
        switch (_v2.$) {
            case 2:
                var tempMatch = findTempMatch(false);
                var _v3 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn(remainText, tempMatch, references);
                if (_v3.$ === 1) {
                    return $elm$core$Maybe$Just(removeOpenToken);
                }
                else {
                    var match = _v3.a;
                    var _v4 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn(match, oldMatches);
                    if (!_v4.$) {
                        var matches = _v4.a;
                        return $elm$core$Maybe$Just(_Utils_Tuple3($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn(match, tokensTail), matches, remainTokens));
                    }
                    else {
                        return $elm$core$Maybe$Just(removeOpenToken);
                    }
                }
            case 1:
                if (!_v2.a) {
                    var _v5 = _v2.a;
                    var tempMatch = findTempMatch(true);
                    var _v6 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType_fn(remainText, tempMatch, references);
                    if (_v6.$ === 1) {
                        return $elm$core$Maybe$Just(removeOpenToken);
                    }
                    else {
                        var match = _v6.a;
                        var _v7 = $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping_fn(match, oldMatches);
                        if (!_v7.$) {
                            var matches = _v7.a;
                            return $elm$core$Maybe$Just(_Utils_Tuple3($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens_fn(match, tokensTail), matches, $elm$core$List$map_fn(inactivateLinkOpenToken, remainTokens)));
                        }
                        else {
                            return $elm$core$Maybe$Just(removeOpenToken);
                        }
                    }
                }
                else {
                    var _v8 = _v2.a;
                    return $elm$core$Maybe$Just(removeOpenToken);
                }
            default:
                return $elm$core$Maybe$Nothing;
        }
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn = function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
        var textStart = openToken.b7 + openToken.b8;
        var textEnd = closeToken.b7;
        var text = processText(_String_slice_fn(textStart, textEnd, rawText));
        var start = openToken.b7;
        var end = closeToken.b7 + closeToken.b8;
        var match = { c2: end, v: _List_Nil, d_: start, gk: text, D: textEnd, t: textStart, k: type_ };
        var matches = $elm$core$List$map_fn(function (_v0) {
            var matchModel = _v0;
            return $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch_fn(match, matchModel);
        }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn(innerTokens, _List_Nil, references, rawText));
        return { c2: end, v: matches, d_: start, gk: text, D: textEnd, t: textStart, k: type_ };
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn = function (tokens, matches, references, rawText) {
        return $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM_fn(tokens, _List_Nil, matches, references, rawText);
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn);
    var $dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn = function (refs, rawText_) {
        var rawText = $elm$core$String$trim(rawText_);
        var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
        return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches_fn(rawText, _List_Nil, $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches_fn(tokens, _List_Nil, refs, rawText))));
    }, $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2($dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(" ", $elm$parser$Parser$Expecting(" "))),
        $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting(">"))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($elm$core$Char$isAlpha, $elm$parser$Parser$Expecting("Alpha")), $elm$parser$Parser$Advanced$chompWhile(function (c) {
            return $elm$core$Char$isAlphaNum(c) || (c === "-");
        })), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(":", $elm$parser$Parser$Expecting(":"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("@", $elm$parser$Parser$Expecting("@"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("\\", $elm$parser$Parser$Expecting("\\"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("+", $elm$parser$Parser$Expecting("+"))),
            $elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn(".", $elm$parser$Parser$Expecting(".")))
        ])))
    ]));
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (rawLine, _v0) {
        return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
    }, $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$token($elm$parser$Parser$Advanced$Token_fn("<", $elm$parser$Parser$Expecting("<"))), $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag), $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock_fn = function (language, body) {
        return { bM: body, dp: language };
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
        var toInfoString = F2(function (str, _v2) {
            var _v1 = $elm$core$String$trim(str);
            if (_v1 === "") {
                return $elm$core$Maybe$Nothing;
            }
            else {
                var trimmed = _v1;
                return $elm$core$Maybe$Just(trimmed);
            }
        });
        var _v0 = fenceCharacter.bl;
        if (!_v0) {
            return $elm$parser$Parser$Advanced$mapChompedString_fn(toInfoString, $elm$parser$Parser$Advanced$chompWhile(function (c) {
                return (c !== "`") && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
            }));
        }
        else {
            return $elm$parser$Parser$Advanced$mapChompedString_fn(toInfoString, $elm$parser$Parser$Advanced$chompWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
    var $dillonkearns$elm_markdown$Parser$Token$backtick = $elm$parser$Parser$Advanced$Token_fn("`", $elm$parser$Parser$Expecting("a '`'"));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = { a8: "`", bl: 0, bC: $dillonkearns$elm_markdown$Parser$Token$backtick };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
        switch (_int) {
            case 1:
                return $elm$parser$Parser$Advanced$succeed(0);
            case 2:
                return $elm$parser$Parser$Advanced$succeed(1);
            case 3:
                return $elm$parser$Parser$Advanced$succeed(2);
            case 4:
                return $elm$parser$Parser$Advanced$succeed(3);
            default:
                return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("Fenced code blocks should be indented no more than 3 spaces"));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn = function (minLength, fenceCharacter) {
        var builtTokens = $elm$core$List$foldl_fn_unwrapped(function (t, p) {
            return $elm$parser$Parser$Advanced$ignorer_fn(p, t);
        }, $elm$parser$Parser$Advanced$succeed(0), $elm$core$List$repeat_fn(minLength, $elm$parser$Parser$Advanced$token(fenceCharacter.bC)));
        return $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (str, _v0) {
            return _Utils_Tuple2(fenceCharacter, $elm$core$String$length(str));
        }, $elm$parser$Parser$Advanced$ignorer_fn(builtTokens, $elm$parser$Parser$Advanced$chompWhile($elm$core$Basics$eq(fenceCharacter.a8))));
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn);
    var $elm$parser$Parser$Advanced$getCol = function (s) {
        return $elm$parser$Parser$Advanced$Good_fn(false, s.aG, s);
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
    var $dillonkearns$elm_markdown$Parser$Token$tilde = $elm$parser$Parser$Advanced$Token_fn("~", $elm$parser$Parser$Expecting("a `~`"));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = { a8: "~", bl: 1, bC: $dillonkearns$elm_markdown$Parser$Token$tilde };
    var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
    var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Whitespace$space, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))),
        $elm$parser$Parser$Advanced$succeed(0)
    ]));
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F2(function (indent, _v0) {
        var character = _v0.a;
        var length = _v0.b;
        return { a9: character, b6: indent, b8: length };
    })), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
        $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
    ])));
    var $elm$parser$Parser$ExpectingEnd = { $: 10 };
    var $dillonkearns$elm_markdown$Whitespace$isSpace_a0 = " ", $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq($dillonkearns$elm_markdown$Whitespace$isSpace_a0);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn = function (minLength, fenceCharacter) {
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast_fn(minLength, fenceCharacter)), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn);
    var $dillonkearns$elm_markdown$Parser$Extra$upTo_fn = function (n, parser) {
        var _v0 = $elm$core$List$repeat_fn(n, parser);
        if (!_v0.b) {
            return $elm$parser$Parser$Advanced$succeed(0);
        }
        else {
            var firstParser = _v0.a;
            var remainingParsers = _v0.b;
            return $elm$core$List$foldl_fn_unwrapped(function (p, parsers) {
                return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                    $elm$parser$Parser$Advanced$ignorer_fn(p, parsers),
                    $elm$parser$Parser$Advanced$succeed(0)
                ]));
            }, $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                firstParser,
                $elm$parser$Parser$Advanced$succeed(0)
            ])), remainingParsers);
        }
    }, $dillonkearns$elm_markdown$Parser$Extra$upTo = F2($dillonkearns$elm_markdown$Parser$Extra$upTo_fn);
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Parser$Extra$upTo_fn(indented, $dillonkearns$elm_markdown$Whitespace$space)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
        var fence = _v0.a;
        var body = _v0.b;
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(body)), $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
            $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (lineEnd, _v1) {
                return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2(fence, _Utils_ap(body, lineEnd)));
            }, $dillonkearns$elm_markdown$Whitespace$lineEnd),
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(body)), $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence_fn(fence.b8, fence.a9))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(F3(function (start, end, source) {
                return $elm$parser$Parser$Advanced$Loop(_Utils_Tuple2(fence, _Utils_ap(body, _String_slice_fn(start, end, source))));
            })), $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.b6)), $elm$parser$Parser$Advanced$getOffset), $elm$parser$Parser$Advanced$getSource)
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
        return $elm$parser$Parser$Advanced$loop_fn(_Utils_Tuple2(fence, ""), $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
    };
    var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = $elm$parser$Parser$Advanced$andThen_fn(function (fence) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.a9), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)), $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
    }, $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
    var $elm$core$String$trimRight = _String_trimRight;
    var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
        return _String_endsWith_fn("#", headingString) ? $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes($elm$core$String$trimRight($elm$core$String$dropRight_fn(1, headingString))) : headingString;
    };
    var $dillonkearns$elm_markdown$Parser$Token$hash = $elm$parser$Parser$Advanced$Token_fn("#", $elm$parser$Parser$Expecting("a `#`"));
    var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
        if ("#" === c) {
            return true;
        }
        else {
            return false;
        }
    };
    var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(function (c) {
        return (c === " ") || ((c === "\n") || (c === "\r"));
    });
    var $elm$core$String$trimLeft = _String_trimLeft;
    var $dillonkearns$elm_markdown$Markdown$Heading$parser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading), $elm$parser$Parser$Advanced$andThen_fn(function (startingSpaces) {
        var startSpace = $elm$core$String$length(startingSpaces);
        return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("heading with < 4 spaces in front")) : $elm$parser$Parser$Advanced$succeed(startSpace);
    }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)), $elm$parser$Parser$Advanced$andThen_fn(function (additionalHashes) {
        var level = $elm$core$String$length(additionalHashes) + 1;
        return (level >= 7) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("heading with < 7 #'s")) : $elm$parser$Parser$Advanced$succeed(level);
    }, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))), $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (headingText, _v0) {
        return $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes($elm$core$String$trimLeft(headingText));
    }, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd));
    var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
    var $elm$parser$Parser$Advanced$fromInfo_fn = function (row, col, x, context) {
        return $elm$parser$Parser$Advanced$AddRight_fn($elm$parser$Parser$Advanced$Empty, $elm$parser$Parser$Advanced$DeadEnd_fn(row, col, x, context));
    }, $elm$parser$Parser$Advanced$fromInfo = F4($elm$parser$Parser$Advanced$fromInfo_fn);
    var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        return function (s) {
            var _v1 = _Parser_findSubString_fn(str, s.a, s.f$, s.aG, s.cr);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return newOffset === -1 ? $elm$parser$Parser$Advanced$Bad_fn(false, $elm$parser$Parser$Advanced$fromInfo_fn(newRow, newCol, expecting, s.eU)) : $elm$parser$Parser$Advanced$Good_fn(_Utils_cmp(s.a, newOffset) < 0, 0, { aG: newCol, eU: s.eU, f: s.f, a: newOffset, f$: newRow, cr: s.cr });
        };
    };
    var $dillonkearns$elm_markdown$Parser$Token$greaterThan = $elm$parser$Parser$Advanced$Token_fn(">", $elm$parser$Parser$Expecting("a `>`"));
    var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
        switch (_char) {
            case " ":
                return true;
            case "\n":
                return true;
            case "\t":
                return true;
            case "\v":
                return true;
            case "\f":
                return true;
            case "\r":
                return true;
            default:
                return false;
        }
    };
    var $dillonkearns$elm_markdown$Parser$Token$lessThan = $elm$parser$Parser$Advanced$Token_fn("<", $elm$parser$Parser$Expecting("a `<`"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = $elm$parser$Parser$Advanced$inContext_fn("link destination", $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
        $elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
    ])));
    var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = $elm$parser$Parser$Advanced$Token_fn("]", $elm$parser$Parser$Expecting("a `]`"));
    var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = $elm$parser$Parser$Advanced$Token_fn("[", $elm$parser$Parser$Expecting("a `[`"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("]:", $elm$parser$Parser$Expecting("]:")))));
    var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = $elm$parser$Parser$Advanced$Token_fn("\"", $elm$parser$Parser$Expecting("a double quote"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
        return _String_contains_fn("\n\n", str) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("no blank line")) : $elm$parser$Parser$Advanced$succeed(str);
    };
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompWhile(function (c) {
        return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
    }), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$chompIf_fn($dillonkearns$elm_markdown$Whitespace$isWhitespace, $elm$parser$Parser$Expecting("Required whitespace")), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
    var $dillonkearns$elm_markdown$Parser$Token$singleQuote = $elm$parser$Parser$Advanced$Token_fn("'", $elm$parser$Parser$Expecting("a single quote"));
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
        var inSingleQuotes = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
        var inDoubleQuotes = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine, $elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
        return $elm$parser$Parser$Advanced$inContext_fn("title", $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$requiredWhitespace), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                inDoubleQuotes,
                inSingleQuotes,
                $elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
            ])))),
            $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
        ])));
    }();
    var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = $elm$parser$Parser$Advanced$inContext_fn("link reference definition", $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(F3(function (label, destination, title) {
        return _Utils_Tuple2(label, { eZ: destination, bB: title });
    })), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser, $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$Whitespace$lineEnd,
        $elm$parser$Parser$Advanced$succeed(0)
    ]))), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser), $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
    var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
    var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
    var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
        var token = $dillonkearns$elm_markdown$Parser$Token$parseString($elm$core$String$fromChar(tchar));
        return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), token), $dillonkearns$elm_markdown$ThematicBreak$whitespace), token), $dillonkearns$elm_markdown$ThematicBreak$whitespace), token), $elm$parser$Parser$Advanced$chompWhile(function (c) {
            return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
        })), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
    };
    var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $dillonkearns$elm_markdown$ThematicBreak$withChar("-"),
        $dillonkearns$elm_markdown$ThematicBreak$withChar("*"),
        $dillonkearns$elm_markdown$ThematicBreak$withChar("_")
    ]));
    var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$space), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Whitespace$space,
            $elm$parser$Parser$Advanced$succeed(0)
        ]))), $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
        $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
    ]));
    var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
    var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn = function (a, b) {
        return { $: 12, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn);
    var $dillonkearns$elm_markdown$Parser$Token$equals = $elm$parser$Parser$Advanced$Token_fn("=", $elm$parser$Parser$Expecting("a `=`"));
    var $dillonkearns$elm_markdown$Parser$Token$minus = $elm$parser$Parser$Advanced$Token_fn("-", $elm$parser$Parser$Expecting("a `-`"));
    var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
        var setextLevel = F3(function (level, levelToken, levelChar) {
            return $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(level), $elm$parser$Parser$Advanced$token(levelToken)), $elm$parser$Parser$Advanced$chompWhile($elm$core$Basics$eq(levelChar)));
        });
        return $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (raw, level) {
            return $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine_fn(level, raw);
        }, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, "="),
            A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, "-")
        ])), $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
    }();
    var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
        return { $: 9, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
    var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$chompIf_fn(condition, $elm$parser$Parser$Problem("Character not found")),
            $elm$parser$Parser$Advanced$succeed(0)
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
        return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Parser$Token$parseString("|"),
            $elm$parser$Parser$Advanced$succeed(0)
        ])) : $dillonkearns$elm_markdown$Parser$Token$parseString("|");
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$map_fn(function (_v0) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("|\n"))),
            $elm$parser$Parser$Advanced$map_fn(function (_v1) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $dillonkearns$elm_markdown$Parser$Token$parseString("\n")),
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
            }, $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end"))),
            $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(revDelimiterColumns)), $dillonkearns$elm_markdown$Parser$Token$parseString("|")), $elm$parser$Parser$Advanced$end($elm$parser$Parser$Expecting("end")))),
            $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(function (column) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(column, revDelimiterColumns));
            }), $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)), $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $dillonkearns$elm_markdown$Parser$Extra$maybeChomp(function (c) {
                return c === ":";
            })), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(function (c) {
                return c === "-";
            })), $dillonkearns$elm_markdown$Parser$Extra$maybeChomp(function (c) {
                return c === ":";
            }))), $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
    var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
        var _v0 = _Utils_Tuple2(_String_startsWith_fn(":", cell), _String_endsWith_fn(":", cell));
        if (_v0.a) {
            if (_v0.b) {
                return $elm$core$Maybe$Just(2);
            }
            else {
                return $elm$core$Maybe$Just(0);
            }
        }
        else {
            if (_v0.b) {
                return $elm$core$Maybe$Just(1);
            }
            else {
                return $elm$core$Maybe$Nothing;
            }
        }
    };
    var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = $elm$parser$Parser$Advanced$andThen_fn(function (delimiterRow) {
        var trimmed = delimiterRow.a.d8;
        var headers = delimiterRow.b;
        return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Expecting("Must have at least one column in delimiter row.")) : ((($elm$core$List$length(headers) === 1) && (!(_String_startsWith_fn("|", trimmed) && _String_endsWith_fn("|", trimmed)))) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.")) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
    }, $elm$parser$Parser$Advanced$mapChompedString_fn_unwrapped(function (delimiterText, revDelimiterColumns) {
        return $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow_fn({
            dJ: delimiterText,
            d8: $elm$core$String$trim(delimiterText)
        }, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment, $elm$core$List$reverse(revDelimiterColumns)));
    }, $elm$parser$Parser$Advanced$loop_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
    var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
    var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn = function (expectedLength, row) {
        var rowLength = $elm$core$List$length(row);
        var _v0 = _Utils_compare_fn(expectedLength, rowLength);
        switch (_v0) {
            case 0:
                return $elm$core$List$take_fn(expectedLength, row);
            case 1:
                return row;
            default:
                return _Utils_ap(row, $elm$core$List$repeat_fn(expectedLength - rowLength, ""));
        }
    }, $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn);
    var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
        return $elm$parser$Parser$Advanced$andThen_fn(function (row) {
            return ($elm$core$List$isEmpty(row) || $elm$core$List$all_fn($elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem("A line must have at least one column")) : $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength_fn(expectedRowLength, row));
        }, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
        var headers = _v0.a;
        var body = _v0.b;
        return $elm$parser$Parser$Advanced$map_fn(function (row) {
            return $dillonkearns$elm_markdown$Markdown$RawBlock$Table($dillonkearns$elm_markdown$Markdown$Table$Table_fn(headers, _Utils_ap(body, _List_fromArray([row]))));
        }, $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser($elm$core$List$length(headers)));
    };
    var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
    var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
    var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
    var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
    var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
    var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
    var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
        switch (level) {
            case 1:
                return $elm$core$Result$Ok(0);
            case 2:
                return $elm$core$Result$Ok(1);
            case 3:
                return $elm$core$Result$Ok(2);
            case 4:
                return $elm$core$Result$Ok(3);
            case 5:
                return $elm$core$Result$Ok(4);
            case 6:
                return $elm$core$Result$Ok(5);
            default:
                return $elm$core$Result$Err($elm$parser$Parser$Expecting("A heading with 1 to 6 #'s, but found " + $elm$core$String$fromInt(level)));
        }
    };
    var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = function (a) {
        return { $: 3, a: a };
    };
    var $dillonkearns$elm_markdown$Parser$Token$asterisk = $elm$parser$Parser$Advanced$Token_fn("*", $elm$parser$Parser$Expecting("a `*`"));
    var $dillonkearns$elm_markdown$Parser$Token$plus = $elm$parser$Parser$Advanced$Token_fn("+", $elm$parser$Parser$Expecting("a `+`"));
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$listMarkerParser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Parser$Token$minus), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$minus)),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Parser$Token$plus), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$plus)),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Parser$Token$asterisk), $elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$asterisk))
    ]));
    var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
        return { $: 1, a: a };
    };
    var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem_fn = function (a, b) {
        return { $: 0, a: a, b: b };
    }, $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem_fn);
    var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
    var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
    var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[x] ", $elm$parser$Parser$ExpectingSymbol("[x] ")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(1), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[X] ", $elm$parser$Parser$ExpectingSymbol("[X] ")))),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed(0), $elm$parser$Parser$Advanced$symbol($elm$parser$Parser$Advanced$Token_fn("[ ] ", $elm$parser$Parser$ExpectingSymbol("[ ] "))))
    ]));
    var $dillonkearns$elm_markdown$Markdown$ListItem$parser = $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem), $elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser, $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
        $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
    ])), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd), $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$itemBody = $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
        $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))), $dillonkearns$elm_markdown$Markdown$ListItem$parser),
        $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem("")), $dillonkearns$elm_markdown$Whitespace$lineEnd)
    ]));
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$singleItemParser = function (listMarker) {
        return $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity), $elm$parser$Parser$Advanced$backtrackable($elm$parser$Parser$Advanced$symbol(listMarker))), $dillonkearns$elm_markdown$Markdown$UnorderedList$itemBody);
    };
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp_fn = function (itemParser, firstItem, revStmts) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (stmt) {
                return $elm$parser$Parser$Advanced$Loop(_List_Cons(stmt, revStmts));
            }, itemParser),
            $elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$Done(_List_Cons(firstItem, $elm$core$List$reverse(revStmts))))
        ]));
    }, $dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp = F3($dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function () {
        var parseSubsequentItems = F2(function (listMarker, firstItem) {
            return $elm$parser$Parser$Advanced$loop_fn(_List_Nil, A2($dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp, $dillonkearns$elm_markdown$Markdown$UnorderedList$singleItemParser(listMarker), firstItem));
        });
        return $elm$parser$Parser$Advanced$andThen_fn($elm$core$Basics$identity, $elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$keeper_fn($elm$parser$Parser$Advanced$succeed(parseSubsequentItems), $elm$parser$Parser$Advanced$ignorer_fn($elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$listMarkerParser), $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))), $dillonkearns$elm_markdown$Markdown$ListItem$parser));
    }();
    var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function () {
        var parseListItem = function (unparsedListItem) {
            if (!unparsedListItem.$) {
                var completion = unparsedListItem.a;
                var body = unparsedListItem.b;
                return {
                    bM: body,
                    cC: $elm$core$Maybe$Just(function () {
                        if (completion === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }())
                };
            }
            else {
                var body = unparsedListItem.a;
                return { bM: body, cC: $elm$core$Maybe$Nothing };
            }
        };
        return $elm$parser$Parser$Advanced$map_fn(A2($elm$core$Basics$composeR, $elm$core$List$map(parseListItem), $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock), $dillonkearns$elm_markdown$Markdown$UnorderedList$parser);
    }();
    var $elm$core$Result$withDefault_fn = function (def, result) {
        if (!result.$) {
            var a = result.a;
            return a;
        }
        else {
            return def;
        }
    }, $elm$core$Result$withDefault = F2($elm$core$Result$withDefault_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn = function (node, blocks) {
        switch (node.$) {
            case 0:
                var tag = node.a;
                var attributes = node.b;
                var children = node.c;
                var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
                if (!_v28.$) {
                    var childrenAsBlocks = _v28.a;
                    var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, childrenAsBlocks));
                    return $elm$core$Result$Ok(_List_Cons(block, blocks));
                }
                else {
                    var err = _v28.a;
                    return $elm$core$Result$Err(err);
                }
            case 1:
                var innerText = node.a;
                var _v29 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
                if (!_v29.$) {
                    var value = _v29.a;
                    return $elm$core$Result$Ok(_Utils_ap($elm$core$List$reverse(value), blocks));
                }
                else {
                    var error = _v29.a;
                    return $elm$core$Result$Err($elm$parser$Parser$Expecting($elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
                }
            case 2:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)), blocks));
            case 3:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$Cdata(string)), blocks));
            case 4:
                var string = node.a;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)), blocks));
            default:
                var declarationType = node.a;
                var content = node.b;
                return $elm$core$Result$Ok(_List_Cons($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content)), blocks));
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn = function (referencesDict, _v23) {
        var unparsedInlines = _v23;
        var mappedReferencesDict = $elm$core$Dict$fromList($elm$core$List$map_fn($elm$core$Tuple$mapSecond(function (_v24) {
            var destination = _v24.eZ;
            var title = _v24.bB;
            return _Utils_Tuple2(destination, title);
        }), referencesDict));
        return $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, $dillonkearns$elm_markdown$Markdown$InlineParser$parse_fn(mappedReferencesDict, unparsedInlines));
    }, $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
        switch (inline.$) {
            case 0:
                var string = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
            case 1:
                return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
            case 2:
                var string = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
            case 3:
                var string = inline.a;
                var maybeString = inline.b;
                var inlines = inline.c;
                return $dillonkearns$elm_markdown$Markdown$Block$Link_fn(string, maybeString, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
            case 4:
                var string = inline.a;
                var maybeString = inline.b;
                var inlines = inline.c;
                return $dillonkearns$elm_markdown$Markdown$Block$Image_fn(string, maybeString, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
            case 5:
                var node = inline.a;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline($dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
            default:
                var level = inline.a;
                var inlines = inline.b;
                switch (level) {
                    case 1:
                        return $dillonkearns$elm_markdown$Markdown$Block$Emphasis($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
                    case 2:
                        return $dillonkearns$elm_markdown$Markdown$Block$Strong($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
                    default:
                        return $dillonkearns$elm_markdown$Markdown$Block$Strong($elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
                }
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
        switch (node.$) {
            case 1:
                var innerText = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment("TODO this never happens, but use types to drop this case.");
            case 0:
                var tag = node.a;
                var attributes = node.b;
                var children = node.c;
                var parseChild = function (child) {
                    if (child.$ === 1) {
                        var text = child.a;
                        return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
                    }
                    else {
                        return _List_fromArray([
                            $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock($dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
                        ]);
                    }
                };
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, $elm$core$List$concatMap_fn(parseChild, children));
            case 2:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
            case 3:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
            case 4:
                var string = node.a;
                return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
            default:
                var declarationType = node.a;
                var content = node.b;
                return $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content);
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
        return $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn(children, _List_Nil);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn = function (remaining, soFar) {
        nodesToBlocksHelp: while (true) {
            if (remaining.b) {
                var node = remaining.a;
                var rest = remaining.b;
                var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks_fn(node, soFar);
                if (!_v18.$) {
                    var newSoFar = _v18.a;
                    var $temp$remaining = rest, $temp$soFar = newSoFar;
                    remaining = $temp$remaining;
                    soFar = $temp$soFar;
                    continue nodesToBlocksHelp;
                }
                else {
                    var e = _v18.a;
                    return $elm$core$Result$Err(e);
                }
            }
            else {
                return $elm$core$Result$Ok($elm$core$List$reverse(soFar));
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
        var _v14 = $elm$parser$Parser$Advanced$run_fn($elm$parser$Parser$Advanced$ignorer_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), $dillonkearns$elm_markdown$Helpers$endOfFile), input);
        if (_v14.$ === 1) {
            var e = _v14.a;
            return $elm$core$Result$Err(e);
        }
        else {
            var v = _v14.a;
            var _v15 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
            if (_v15.$ === 1) {
                var e = _v15.a;
                return $elm$parser$Parser$Advanced$run_fn($elm$parser$Parser$Advanced$problem(e), "");
            }
            else {
                var blocks = _v15.a;
                var isNotEmptyParagraph = function (block) {
                    if ((block.$ === 5) && (!block.a.b)) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };
                return $elm$core$Result$Ok($elm$core$List$filter_fn(isNotEmptyParagraph, blocks));
            }
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
        return $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn(state, state.ag, _List_Nil);
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn = function (state, rawBlocks, parsedBlocks) {
        parseAllInlinesHelp: while (true) {
            if (rawBlocks.b) {
                var rawBlock = rawBlocks.a;
                var rest = rawBlocks.b;
                var _v13 = $dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn(state.az, rawBlock);
                switch (_v13.$) {
                    case 1:
                        var newParsedBlock = _v13.a;
                        var $temp$state = state, $temp$rawBlocks = rest, $temp$parsedBlocks = _List_Cons(newParsedBlock, parsedBlocks);
                        state = $temp$state;
                        rawBlocks = $temp$rawBlocks;
                        parsedBlocks = $temp$parsedBlocks;
                        continue parseAllInlinesHelp;
                    case 0:
                        var $temp$state = state, $temp$rawBlocks = rest, $temp$parsedBlocks = parsedBlocks;
                        state = $temp$state;
                        rawBlocks = $temp$rawBlocks;
                        parsedBlocks = $temp$parsedBlocks;
                        continue parseAllInlinesHelp;
                    default:
                        var e = _v13.a;
                        return $elm$core$Result$Err(e);
                }
            }
            else {
                return $elm$core$Result$Ok(parsedBlocks);
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn = function (linkReferences, header) {
        return $elm$core$List$map_fn(function (_v11) {
            var label = _v11.R;
            var alignment = _v11.a3;
            return $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn(linkReferences, function (parsedHeaderLabel) {
                return { a3: alignment, R: parsedHeaderLabel };
            }, label);
        }, header);
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn = function (linkReferences, rawBlock) {
        switch (rawBlock.$) {
            case 0:
                var level = rawBlock.a;
                var unparsedInlines = rawBlock.b;
                var _v5 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
                if (!_v5.$) {
                    var parsedLevel = _v5.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Heading_fn(parsedLevel, $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines)));
                }
                else {
                    var e = _v5.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
                }
            case 1:
                var unparsedInlines = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines)));
            case 2:
                var html = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
            case 3:
                var unparsedItems = rawBlock.a;
                var parseItem = function (unparsed) {
                    var task = function () {
                        var _v6 = unparsed.cC;
                        if (!_v6.$) {
                            if (!_v6.a) {
                                return 1;
                            }
                            else {
                                return 2;
                            }
                        }
                        else {
                            return 0;
                        }
                    }();
                    var parsedInlines = $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn(linkReferences, $elm$core$Basics$identity, unparsed.bM);
                    return $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn(task, parsedInlines);
                };
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$UnorderedList($elm$core$List$map_fn(parseItem, unparsedItems)));
            case 4:
                var startingIndex = rawBlock.a;
                var unparsedInlines = rawBlock.b;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$OrderedList_fn(startingIndex, $elm$core$List$map_fn(A2($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity), unparsedInlines)));
            case 5:
                var codeBlock = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
            case 7:
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
            case 10:
                return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
            case 11:
                var rawBlocks = rawBlock.a;
                var _v7 = $elm$parser$Parser$Advanced$run_fn($dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(), rawBlocks);
                if (!_v7.$) {
                    var value = _v7.a;
                    var _v8 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(value);
                    if (!_v8.$) {
                        var parsedBlocks = _v8.a;
                        return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
                    }
                    else {
                        var e = _v8.a;
                        return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
                    }
                }
                else {
                    var error = _v7.a;
                    return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem($elm$parser$Parser$Problem($dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
                }
            case 6:
                var codeBlockBody = rawBlock.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$CodeBlock({ bM: codeBlockBody, dp: $elm$core$Maybe$Nothing }));
            case 8:
                var _v9 = rawBlock.a;
                var header = _v9.a;
                var rows = _v9.b;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Table_fn($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines_fn(linkReferences, header), $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn(linkReferences, rows)));
            case 9:
                var _v10 = rawBlock.a;
                var text = _v10.a;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, text.dJ)));
            default:
                var raw = rawBlock.b;
                return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$Paragraph($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, raw)));
        }
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn = function (linkReferences, wrap, unparsedInlines) {
        return wrap($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper_fn(linkReferences, unparsedInlines));
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn = function (linkReferences, rows) {
        return $elm$core$List$map_fn(function (row) {
            return $elm$core$List$map_fn(function (column) {
                return $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline_fn(linkReferences, $elm$core$Basics$identity, column);
            }, row);
        }, rows);
    }, $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines_fn);
    var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $elm$parser$Parser$Advanced$map_fn(function (_v2) {
                return $elm$parser$Parser$Advanced$Done(revStmts);
            }, $dillonkearns$elm_markdown$Helpers$endOfFile),
            $elm$parser$Parser$Advanced$map_fn(function (reference) {
                return $elm$parser$Parser$Advanced$Loop($dillonkearns$elm_markdown$Markdown$Parser$addReference_fn(revStmts, reference));
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
            $elm$parser$Parser$Advanced$map_fn(function (block) {
                return $elm$parser$Parser$Advanced$Loop($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn(revStmts, block));
            }, function () {
                var _v3 = revStmts.ag;
                _v3$2: while (true) {
                    if (_v3.b) {
                        switch (_v3.a.$) {
                            case 1:
                                return $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
                            case 8:
                                var table = _v3.a.a;
                                return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
                                    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
                                    $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
                                ]));
                            default:
                                break _v3$2;
                        }
                    }
                    else {
                        break _v3$2;
                    }
                }
                return $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
            }()),
            $elm$parser$Parser$Advanced$map_fn(function (block) {
                return $elm$parser$Parser$Advanced$Loop($dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks_fn(revStmts, block));
            }, $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser)
        ]));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
        return $elm$core$Result$withDefault_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
        switch (xmlNode.$) {
            case 1:
                var innerText = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
            case 0:
                var tag = xmlNode.a;
                var attributes = xmlNode.b;
                var children = xmlNode.c;
                var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
                if (!_v1.$) {
                    var parsedChildren = _v1.a;
                    return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlElement_fn(tag, attributes, parsedChildren)));
                }
                else {
                    var err = _v1.a;
                    return $elm$parser$Parser$Advanced$problem(err);
                }
            case 2:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
            case 3:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
            case 4:
                var string = xmlNode.a;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
            default:
                var declarationType = xmlNode.a;
                var content = xmlNode.b;
                return $elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Html($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration_fn(declarationType, content)));
        }
    };
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$blankLine,
            $dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
            $elm$parser$Parser$Advanced$map_fn(function (_v26) {
                return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
            $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
        ]));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
        return $elm$parser$Parser$Advanced$oneOf(_List_fromArray([
            $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$blankLine,
            $dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
            $elm$parser$Parser$Advanced$map_fn($dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
            $elm$parser$Parser$Advanced$map_fn(function (_v25) {
                return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
            }, $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
            $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock,
            $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
            $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
            $elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
        ]));
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
        return $elm$parser$Parser$Advanced$andThen_fn($dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
    }
    function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
        return $elm$parser$Parser$Advanced$loop_fn({ az: _List_Nil, ag: _List_Nil }, $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock);
    }
    var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
    $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
        return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
    };
    var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0 = $elm$core$Result$map2($elm$core$List$cons), $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1 = $elm$core$Result$Ok(_List_Nil), $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2($elm$core$List$foldr, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1);
    var $dillonkearns$elm_markdown$Markdown$Block$foldl_fn = function (_function, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var block = list.a;
                var remainingBlocks = list.b;
                switch (block.$) {
                    case 0:
                        var html = block.a;
                        if (!html.$) {
                            var children = html.c;
                            var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap(children, remainingBlocks);
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                        else {
                            var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                    case 1:
                        var listItems = block.a;
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 2:
                        var _int = block.a;
                        var lists = block.b;
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 3:
                        var blocks = block.a;
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = _Utils_ap(blocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 4:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 5:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 6:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 7:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    default:
                        var $temp$function = _function, $temp$acc = A2(_function, block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped = function (_function, acc, list) {
        foldl: while (true) {
            if (!list.b) {
                return acc;
            }
            else {
                var block = list.a;
                var remainingBlocks = list.b;
                switch (block.$) {
                    case 0:
                        var html = block.a;
                        if (!html.$) {
                            var children = html.c;
                            var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap(children, remainingBlocks);
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                        else {
                            var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                            _function = $temp$function;
                            acc = $temp$acc;
                            list = $temp$list;
                            continue foldl;
                        }
                    case 1:
                        var listItems = block.a;
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 2:
                        var _int = block.a;
                        var lists = block.b;
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 3:
                        var blocks = block.a;
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = _Utils_ap(blocks, remainingBlocks);
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 4:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 5:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 6:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    case 7:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                    default:
                        var $temp$function = _function, $temp$acc = _function(block, acc), $temp$list = remainingBlocks;
                        _function = $temp$function;
                        acc = $temp$acc;
                        list = $temp$list;
                        continue foldl;
                }
            }
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$foldl = F3($dillonkearns$elm_markdown$Markdown$Block$foldl_fn);
    var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
        switch (block.$) {
            case 5:
                var inlines = block.a;
                return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
            case 0:
                var html = block.a;
                if (!html.$) {
                    var blocks = html.c;
                    return $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped(function (nestedBlock, soFar) {
                        return _Utils_ap(soFar, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
                    }, "", blocks);
                }
                else {
                    return "";
                }
            case 1:
                var items = block.a;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn(function (_v4) {
                    var task = _v4.a;
                    var inlines = _v4.b;
                    return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
                }, items));
            case 2:
                var _int = block.a;
                var items = block.b;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineText, items));
            case 3:
                var blocks = block.a;
                return $elm$core$String$join_fn("\n", $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
            case 4:
                var headingLevel = block.a;
                var inlines = block.b;
                return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
            case 6:
                var header = block.a;
                var rows = block.b;
                return $elm$core$String$join_fn("\n", $elm$core$List$concat(_List_fromArray([
                    $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Block$extractInlineText, $elm$core$List$map_fn(function ($) {
                        return $.R;
                    }, header)),
                    $elm$core$List$concat($elm$core$List$map_fn($elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText), rows))
                ])));
            case 7:
                var body = block.a.bM;
                return body;
            default:
                return "";
        }
    };
    var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
        return $elm$core$List$foldl_fn($dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, "", inlines);
    };
    var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp_fn = function (inline, text) {
        switch (inline.$) {
            case 6:
                var str = inline.a;
                return _Utils_ap(text, str);
            case 7:
                return text + " ";
            case 5:
                var str = inline.a;
                return _Utils_ap(text, str);
            case 1:
                var inlines = inline.c;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            case 2:
                var inlines = inline.c;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            case 0:
                var html = inline.a;
                if (!html.$) {
                    var blocks = html.c;
                    return $dillonkearns$elm_markdown$Markdown$Block$foldl_fn_unwrapped(function (block, soFar) {
                        return _Utils_ap(soFar, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
                    }, text, blocks);
                }
                else {
                    return text;
                }
            case 4:
                var inlines = inline.a;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
            default:
                var inlines = inline.a;
                return _Utils_ap(text, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
        }
    }, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2($dillonkearns$elm_markdown$Markdown$Block$extractTextHelp_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn = function (tagName, attributes, children, _v0, renderedChildren) {
        var htmlRenderer = _v0;
        return $elm$core$Result$andThen_fn(function (okChildren) {
            return $elm$core$Result$map_fn(function (myRenderer) {
                return myRenderer(okChildren);
            }, A3(htmlRenderer, tagName, attributes, children));
        }, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, renderedChildren));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5($dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing_fn = function (renderer, topLevelInline, soFar) {
        var _v7 = $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn(renderer, topLevelInline);
        if (!_v7.$) {
            var inline = _v7.a;
            return _List_Cons(inline, soFar);
        }
        else {
            return soFar;
        }
    }, $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3($dillonkearns$elm_markdown$Markdown$Renderer$foldThing_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn = function (renderer, blocks) {
        return $elm$core$List$filterMap_fn($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer), blocks);
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
        return function (block) {
            switch (block.$) {
                case 4:
                    var level = block.a;
                    var content = block.b;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(function (children) {
                        return renderer.b0({
                            P: children,
                            ds: level,
                            fX: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
                        });
                    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content)));
                case 5:
                    var content = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.ch, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, content)));
                case 0:
                    var html = block.a;
                    if (!html.$) {
                        var tag = html.a;
                        var attributes = html.b;
                        var children = html.c;
                        return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn(renderer, tag, attributes, children));
                    }
                    else {
                        return $elm$core$Maybe$Nothing;
                    }
                case 1:
                    var items = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.cG, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(function (_v4) {
                        var task = _v4.a;
                        var children = _v4.b;
                        return $elm$core$Result$map_fn(function (renderedBody) {
                            return $dillonkearns$elm_markdown$Markdown$Block$ListItem_fn(task, renderedBody);
                        }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, children));
                    }, items))));
                case 2:
                    var startingIndex = block.a;
                    var items = block.b;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.cg(startingIndex), $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer), items))));
                case 7:
                    var codeBlock = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.bP(codeBlock)));
                case 8:
                    return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.cD));
                case 3:
                    var nestedBlocks = block.a;
                    return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.bK, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, nestedBlocks))));
                default:
                    var header = block.a;
                    var rows = block.b;
                    var renderedHeaderCells = $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(function (_v6) {
                        var label = _v6.R;
                        var alignment = _v6.a3;
                        return $elm$core$Result$map_fn($elm$core$Tuple$pair(alignment), $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, label));
                    }, header));
                    var renderedHeader = $elm$core$Result$map_fn(function (listListView) {
                        return renderer.cz($elm$core$List$singleton(renderer.bz($elm$core$List$map_fn(function (_v5) {
                            var maybeAlignment = _v5.a;
                            var item = _v5.b;
                            return A2(renderer.cA, maybeAlignment, item);
                        }, listListView))));
                    }, renderedHeaderCells);
                    var renderedBody = function (r) {
                        return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray([
                            renderer.cx(r)
                        ]);
                    };
                    var alignmentForColumn = function (columnIndex) {
                        return $elm$core$Maybe$andThen_fn(function ($) {
                            return $.a3;
                        }, $elm$core$List$head($elm$core$List$drop_fn(columnIndex, header)));
                    };
                    var renderRow = function (cells) {
                        return $elm$core$Result$map_fn(renderer.bz, $elm$core$Result$map_fn($elm$core$List$indexedMap(F2(function (index, cell) {
                            return A2(renderer.cy, alignmentForColumn(index), cell);
                        })), $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer), cells))));
                    };
                    var renderedRows = $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$map_fn(renderRow, rows));
                    return $elm$core$Maybe$Just($elm$core$Result$map2_fn_unwrapped(function (h, r) {
                        return renderer.cw(_List_Cons(h, renderedBody(r)));
                    }, renderedHeader, renderedRows));
            }
        };
    };
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn = function (renderer, tag, attributes, children) {
        return $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml_fn(tag, attributes, children, renderer.b3, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, children));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn = function (renderer, inline) {
        switch (inline.$) {
            case 4:
                var innerInlines = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.ct, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, innerInlines)));
            case 3:
                var innerInlines = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$map_fn(renderer.bT, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, innerInlines)));
            case 2:
                var src = inline.a;
                var title = inline.b;
                var children = inline.c;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.b5({
                    bI: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
                    cr: src,
                    bB: title
                })));
            case 6:
                var string = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.gk(string)));
            case 5:
                var string = inline.a;
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.bQ(string)));
            case 1:
                var destination = inline.a;
                var title = inline.b;
                var inlines = inline.c;
                return $elm$core$Maybe$Just($elm$core$Result$andThen_fn(function (children) {
                    return $elm$core$Result$Ok(A2(renderer.ca, { eZ: destination, bB: title }, children));
                }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn(renderer, inlines)));
            case 7:
                return $elm$core$Maybe$Just($elm$core$Result$Ok(renderer.bX));
            default:
                var html = inline.a;
                if (!html.$) {
                    var tag = html.a;
                    var attributes = html.b;
                    var children = html.c;
                    return $elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode_fn(renderer, tag, attributes, children));
                }
                else {
                    return $elm$core$Maybe$Nothing;
                }
        }
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn = function (renderer, styledStrings) {
        return $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer), _List_Nil, styledStrings));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled_fn);
    var $dillonkearns$elm_markdown$Markdown$Renderer$render_fn = function (renderer, ast) {
        return $elm$core$List$foldr_fn($dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a0, $dillonkearns$elm_markdown$Markdown$Renderer$combineResults_a1, $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper_fn(renderer, ast));
    }, $dillonkearns$elm_markdown$Markdown$Renderer$render = F2($dillonkearns$elm_markdown$Markdown$Renderer$render_fn);
    var $author$project$UI$RowView$statusLine_fn = function (pageWidth, output) {
        if (!output.$) {
            var e = output.a;
            return $author$project$UI$RowView$viewError(e);
        }
        else {
            var e = output.a;
            return false ? A2($author$project$UI$Theme$column, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$alignTop,
                $miniBill$elm_ui_with_context$Element$WithContext$width($mdgriffith$elm_ui$Element$maximum_fn(200, $miniBill$elm_ui_with_context$Element$WithContext$fill))
            ]), _List_fromArray([
                $author$project$UI$L10N$text({ e0: "Interpreted as: ", fs: "Interpretato come: " }),
                $author$project$UI$RowView$viewExpression_fn(pageWidth, e)
            ])) : $miniBill$elm_ui_with_context$Element$WithContext$none;
        }
    }, $author$project$UI$RowView$statusLine = F2($author$project$UI$RowView$statusLine_fn);
    var $author$project$UI$RowView$view_fn = function (size, index, _v0) {
        var input = _v0.r;
        var editing = _v0.al;
        var data = _v0.G;
        return $miniBill$elm_ui_with_context$Element$WithContext$map_fn(function (msg) {
            return $author$project$UI$Model$DocumentCellMsg({ b7: index, fz: msg });
        }, function () {
            if (!data.$) {
                var output = data.a;
                var outputRows = $elm$core$List$concatMap_fn(function (o) {
                    return _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$Lazy$lazy3_fn($author$project$UI$RowView$outputBlock, "canvas" + $elm$core$String$fromInt(index), size, o),
                        $author$project$UI$RowView$statusLine_fn(size.bE, o)
                    ]);
                }, output);
                return A2($author$project$UI$Theme$column, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                    $miniBill$elm_ui_with_context$Element$WithContext$alignTop
                ]), _List_Cons($author$project$UI$RowView$codeInputLine_fn(size, index, input), outputRows));
            }
            else {
                var toCodeCellButton = $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$alignRight,
                    $author$project$UI$L10N$title({ e0: "Convert to Code cell", fs: "Converti in cella con Codice" })
                ]), {
                    R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$swapOutlined($author$project$UI$Theme$darkIconAttrs)),
                    W: $elm$core$Maybe$Just($author$project$UI$Model$ToCode)
                });
                return editing ? A2($author$project$UI$Theme$row, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                ]), _List_fromArray([
                    $author$project$UI$RowView$inputBox_fn(size.bE - 100, input),
                    $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                        $author$project$UI$L10N$title({ e0: "End editing", fs: "Fine modifica" })
                    ]), {
                        R: $miniBill$elm_ui_with_context$Element$WithContext$element($lemol$ant_design_icons_elm_ui$Ant$Icons$enterOutlined($author$project$UI$Theme$darkIconAttrs)),
                        W: $elm$core$Maybe$Just($author$project$UI$Model$EndEditing)
                    }),
                    toCodeCellButton
                ])) : function (e) {
                    return A2($author$project$UI$Theme$row, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill)
                    ]), _List_fromArray([e, $author$project$UI$RowView$editButton, toCodeCellButton]));
                }($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$textColumn_a0, _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                    $miniBill$elm_ui_with_context$Element$WithContext$alignTop
                ]), $elm$core$List$map_fn(function (e) {
                    return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$paragraph_a0, _List_Nil, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$html(e)
                    ]));
                }, $elm$core$Result$withDefault_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$Renderer$render_fn($dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, $elm$core$Result$withDefault_fn(_List_Nil, $dillonkearns$elm_markdown$Markdown$Parser$parse(input)))))));
            }
        }());
    }, $author$project$UI$RowView$view = F3($author$project$UI$RowView$view_fn);
    var $author$project$UI$viewDocument_fn = function (size, _v0) {
        var id = _v0.fh;
        var rows = _v0.M;
        var rowsViews = $elm$core$List$indexedMap_fn(F2(function (index, row) {
            return $miniBill$elm_ui_with_context$Element$WithContext$Lazy$lazy3_fn($author$project$UI$RowView$view, size, index, row);
        }), rows);
        return $miniBill$elm_ui_with_context$Element$WithContext$map_fn($author$project$UI$Model$DocumentMsg(id), $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$spacing(2 * $author$project$UI$Theme$spacing),
            $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing),
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$scrollbarY
        ]), _Utils_ap(rowsViews, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill)
            ]), $miniBill$elm_ui_with_context$Element$WithContext$none)
        ]))));
    }, $author$project$UI$viewDocument = F2($author$project$UI$viewDocument_fn);
    var $author$project$UI$Model$DocumentPopModal = { $: 10 };
    var $author$project$UI$Model$DocumentRename = function (a) {
        return { $: 1, a: a };
    };
    var $author$project$UI$Model$DocumentReplaceModal = function (a) {
        return { $: 9, a: a };
    };
    var $elm$html$Html$Attributes$autofocus_a0 = "autofocus", $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty($elm$html$Html$Attributes$autofocus_a0);
    var $mdgriffith$elm_ui$Element$Input$focusedOnLoad = $mdgriffith$elm_ui$Internal$Model$Attr($elm$html$Html$Attributes$boolProperty_fn($elm$html$Html$Attributes$autofocus_a0, true));
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$focusedOnLoad = $miniBill$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Input$focusedOnLoad);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel_fn = function (f, attrs, child) {
        return function (context) {
            return A2(f, $miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, child));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel_fn_unwrapped = function (f, attrs, child) {
        return function (context) {
            return f($miniBill$elm_ui_with_context$Element$WithContext$Internal$attributes_fn(context, attrs), $miniBill$elm_ui_with_context$Element$WithContext$Internal$run_fn(context, child));
        };
    }, $miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel = F3($miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel_fn);
    var $mdgriffith$elm_ui$Element$Input$Above = 2;
    var $mdgriffith$elm_ui$Element$Input$Label_fn = function (a, b, c) {
        return { $: 0, a: a, b: b, c: c };
    }, $mdgriffith$elm_ui$Element$Input$Label = F3($mdgriffith$elm_ui$Element$Input$Label_fn);
    var $mdgriffith$elm_ui$Element$Input$labelAbove_a0 = 2, $mdgriffith$elm_ui$Element$Input$labelAbove = $mdgriffith$elm_ui$Element$Input$Label($mdgriffith$elm_ui$Element$Input$labelAbove_a0);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$labelAbove_a0 = $mdgriffith$elm_ui$Element$Input$labelAbove, $miniBill$elm_ui_with_context$Element$WithContext$Input$labelAbove = $miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel($miniBill$elm_ui_with_context$Element$WithContext$Input$labelAbove_a0);
    var $author$project$UI$Theme$onKey = function (msg) {
        return $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute($elm$html$Html$Events$on_fn("keyup", _Json_andThen_fn(function (s) {
            var _v0 = msg(s);
            if (!_v0.$) {
                var m = _v0.a;
                return $elm$json$Json$Decode$succeed(m);
            }
            else {
                return $elm$json$Json$Decode$fail("ignored");
            }
        }, _Json_decodeField_fn("key", $elm$json$Json$Decode$string))));
    };
    var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
        return { $: 0, a: a };
    };
    var $mdgriffith$elm_ui$Element$Input$text_a0 = {
        U: $elm$core$Maybe$Nothing,
        _: false,
        k: $mdgriffith$elm_ui$Element$Input$TextInputNode("text")
    }, $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper($mdgriffith$elm_ui$Element$Input$text_a0);
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$textHelper = function (f) {
        return A2($miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, f, F2(function (context, config) {
            return {
                R: $miniBill$elm_ui_with_context$Element$WithContext$Input$runLabel_fn(context, config.R),
                fL: config.fL,
                fU: $elm$core$Maybe$map_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context), config.fU),
                gk: config.gk
            };
        }));
    };
    var $miniBill$elm_ui_with_context$Element$WithContext$Input$text = $miniBill$elm_ui_with_context$Element$WithContext$Input$textHelper($mdgriffith$elm_ui$Element$Input$text);
    var $author$project$UI$viewDocumentModal = function (document) {
        var wrap = F2(function (onOk, e) {
            return $miniBill$elm_ui_with_context$Element$WithContext$map_fn($author$project$UI$Model$DocumentMsg(document.fh), $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
                $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing * 8),
                $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.fx),
                $miniBill$elm_ui_with_context$Element$WithContext$htmlAttribute(_VirtualDom_style_fn("backdrop-filter", "blur(2px)"))
            ]), $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$centerX,
                $miniBill$elm_ui_with_context$Element$WithContext$centerY,
                $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.aQ),
                $miniBill$elm_ui_with_context$Element$WithContext$Border$rounded($author$project$UI$Theme$roundness)
            ]), $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$el_a0, $miniBill$elm_ui_with_context$Element$WithContext$el_a1, _List_fromArray([
                $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing)
            ]), A2($author$project$UI$Theme$column, _List_Nil, _Utils_ap(e, _List_fromArray([
                A2($author$project$UI$Theme$row, _List_fromArray([$miniBill$elm_ui_with_context$Element$WithContext$alignRight]), _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing)
                    ]), {
                        R: $author$project$UI$L10N$text({ e0: "Ok", fs: "Ok" }),
                        W: $elm$core$Maybe$Just(onOk)
                    }),
                    $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$button_a0, $miniBill$elm_ui_with_context$Element$WithContext$Input$button_a1, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$padding($author$project$UI$Theme$spacing)
                    ]), {
                        R: $author$project$UI$L10N$text({ e0: "Cancel", fs: "Annulla" }),
                        W: $elm$core$Maybe$Just($author$project$UI$Model$DocumentPopModal)
                    })
                ]))
            ])))))));
        });
        var _v0 = document.du;
        if (!_v0.b) {
            return $miniBill$elm_ui_with_context$Element$WithContext$none;
        }
        else {
            if (!_v0.a.$) {
                var _v1 = _v0.a;
                return A2(wrap, $author$project$UI$Model$DocumentClose({ bJ: false }), _List_fromArray([
                    $author$project$UI$L10N$text(function () {
                        var _v2 = document.dw;
                        if (!_v2.$) {
                            var name = _v2.a;
                            return { e0: "Close document \"" + (name + "\"?"), fs: "Chiudi il documento \"" + (name + "\"?") };
                        }
                        else {
                            return { e0: "Close the document?", fs: "Chiudere il documento?" };
                        }
                    }())
                ]));
            }
            else {
                var name = _v0.a.a;
                return A2(wrap, $author$project$UI$Model$DocumentRename(name), _List_fromArray([
                    A2($miniBill$elm_ui_with_context$Element$WithContext$Input$text, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$Input$focusedOnLoad,
                        $author$project$UI$Theme$onKey(function (key) {
                            switch (key) {
                                case "Enter":
                                    return $elm$core$Maybe$Just($author$project$UI$Model$DocumentRename(name));
                                case "Escape":
                                    return $elm$core$Maybe$Just($author$project$UI$Model$DocumentPopModal);
                                default:
                                    return $elm$core$Maybe$Nothing;
                            }
                        })
                    ]), {
                        R: $miniBill$elm_ui_with_context$Element$WithContext$Input$buildLabel_fn($miniBill$elm_ui_with_context$Element$WithContext$Input$labelAbove_a0, _List_Nil, $author$project$UI$L10N$text(function () {
                            var _v4 = document.dw;
                            if (!_v4.$) {
                                var n = _v4.a;
                                return { e0: "Rename document \"" + (n + "\" to"), fs: "Rinomina il documento \"" + (n + "\" in") };
                            }
                            else {
                                return { e0: "Rename the document to", fs: "Rinomina il documento in" };
                            }
                        }())),
                        fL: A2($elm$core$Basics$composeL, $author$project$UI$Model$DocumentReplaceModal, $author$project$Document$ModalRename),
                        fU: $elm$core$Maybe$Nothing,
                        gk: name
                    })
                ]));
            }
        }
    };
    var $author$project$UI$view = function (model) {
        var documentView = $elm$core$Maybe$withDefault_fn($author$project$UI$L10N$text({ e0: "Select a document", fs: "Seleziona un documento" }), $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Zipper$selected, $author$project$UI$viewDocument(model.cq)), model.l));
        return $miniBill$elm_ui_with_context$Element$WithContext$Internal$wrapContainer_fn($miniBill$elm_ui_with_context$Element$WithContext$column_a0, _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$height($miniBill$elm_ui_with_context$Element$WithContext$fill),
            $miniBill$elm_ui_with_context$Element$WithContext$createNearby_fn($miniBill$elm_ui_with_context$Element$WithContext$inFront_a0, $elm$core$Maybe$withDefault_fn($miniBill$elm_ui_with_context$Element$WithContext$none, $elm$core$Maybe$map_fn(A2($elm$core$Basics$composeR, $author$project$Zipper$selected, $author$project$UI$viewDocumentModal), model.l)))
        ]), _List_fromArray([
            $miniBill$elm_ui_with_context$Element$WithContext$html(A3($elm$html$Html$node, "style", _List_Nil, _List_fromArray([
                $elm$html$Html$text("\n                        div.pre > div {\n                            white-space: pre-wrap !important;\n                        }\n\n                        textarea.input {\n                            word-break: break-word !important;\n                        }\n\n                        @media (hover: hover) {\n                            div.hover-parent div.on-parent-hover {\n                                visibility: hidden;\n                            }\n\n                            div.hover-parent:hover div.on-parent-hover {\n                                visibility: visible;\n                            }\n                        }\n                    ")
            ]))),
            $author$project$UI$documentPicker(model),
            documentView
        ]));
    };
    var $author$project$UI$main = $elm$browser$Browser$application({
        fl: $author$project$UI$init,
        fO: $elm$core$Basics$always($author$project$UI$Model$Nop("onUrlChange")),
        fP: $elm$core$Basics$always($author$project$UI$Model$Nop("onUrlRequest")),
        gh: $author$project$UI$subscriptions,
        gC: $author$project$UI$update,
        gD: function (model) {
            return {
                bM: _List_fromArray([
                    $miniBill$elm_ui_with_context$Element$WithContext$layout_fn(model.eU, _List_fromArray([
                        $miniBill$elm_ui_with_context$Element$WithContext$width($miniBill$elm_ui_with_context$Element$WithContext$fill),
                        $miniBill$elm_ui_with_context$Element$WithContext$Font$size($author$project$UI$Theme$fontSize),
                        $miniBill$elm_ui_with_context$Element$WithContext$Background$color($author$project$UI$Theme$colors.aQ)
                    ]), $author$project$UI$view(model))
                ]),
                bB: "nuPlot"
            };
        }
    });
    _Platform_export({ "UI": { "init": $author$project$UI$main(_Json_andThen_fn(function (saved) {
                return _Json_andThen_fn(function (rootUrl) {
                    return _Json_andThen_fn(function (languages) {
                        return _Json_andThen_fn(function (hasFullscreen) {
                            return _Json_andThen_fn(function (hasClipboard) {
                                return _Json_andThen_fn(function (googleAccessToken) {
                                    return $elm$json$Json$Decode$succeed({ dc: googleAccessToken, bZ: hasClipboard, b_: hasFullscreen, dq: languages, cn: rootUrl, dS: saved });
                                }, _Json_decodeField_fn("googleAccessToken", $elm$json$Json$Decode$string));
                            }, _Json_decodeField_fn("hasClipboard", $elm$json$Json$Decode$bool));
                        }, _Json_decodeField_fn("hasFullscreen", $elm$json$Json$Decode$bool));
                    }, _Json_decodeField_fn("languages", $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
                }, _Json_decodeField_fn("rootUrl", $elm$json$Json$Decode$string));
            }, _Json_decodeField_fn("saved", $elm$json$Json$Decode$value)))(0) } });
}(this));
